export interface ImCodes{
    [key: string]: string[];
}

export const IM_CODES:ImCodes={
  "0": ["GJ9","Dc9","Dc8"],
  "1": ["GKL","Dbs","E5X","Dbo"],
  "2": ["GKN","Dc6","E5Z","Dc4"],
  "3": ["GKP","Dcn","E5a","Dcl"],
  "4": ["GKR","DbS","E5b","DbQ"],
  "5": ["GKT","DbC","E5c","DbA"],
  "6": ["GKV","DcE","E5d","DcC"],
  "7": ["GKW","Dbw","E5e","Dbu"],
  "8": ["GKX","Daf","E5f","Dab"],
  "9": ["GKZ","DbY","E5g","DbW"],
  "10": ["GKA","DcV","DcU"],
  "11": ["GKC","Dau","E5Q","Dat"],
  "12": ["GKD","Dcr","E5R","Dcp"],
  "13": ["GKE","DcY","E5S","DcX"],
  "14": ["GKF","DbU","E5T","DbT"],
  "15": ["GKG","Daw","E5U","Dav"],
  "16": ["GKH","DcG","E5V","DcF"],
  "17": ["GKI","Dby","E5W","Dbx"],
  "18": ["GKJ","Dad","Dac"],
  "19": ["GKK","Dba","DbZ"],
  "20": ["GKM","Dcy","E5Y","Dcs"],
  "21": ["FYl","Dcx"],
  "22": ["FYm","Dc3"],
  "23": ["FYn","Dc2"],
  "24": ["FYo","Dcv"],
  "25": ["FYp","Dcu"],
  "26": ["FYq","Dc0"],
  "27": ["FYr","Dcz"],
  "28": ["FYs","Dct"],
  "29": ["FYt","Dcw"],
  "30": ["GKO","Dcf","DcZ"],
  "31": ["Dce"],
  "32": ["Dck"],
  "33": ["Dcj"],
  "34": ["Dcc"],
  "35": ["Dcb"],
  "36": ["Dch"],
  "37": ["Dcg"],
  "38": ["FYv","Dca"],
  "39": ["FYw","Dcd"],
  "40": ["GKQ","DbK","DbE"],
  "41": ["DbJ"],
  "42": ["FYy","DbP"],
  "43": ["FYz","DbO"],
  "44": ["DbH"],
  "45": ["FY0","DbG"],
  "46": ["DbM"],
  "47": ["DbL"],
  "48": ["DbF"],
  "49": ["DbI"],
  "50": ["GKS","Da4","Day"],
  "51": ["Da3"],
  "52": ["Da9"],
  "53": ["Da8"],
  "54": ["Da1"],
  "55": ["FY2","Da0"],
  "56": ["Da6"],
  "57": ["Da5"],
  "58": ["Daz"],
  "59": ["Da2"],
  "60": ["FY4","DcO","DcI"],
  "61": ["DcN"],
  "62": ["DcT"],
  "63": ["DcS"],
  "64": ["DcL"],
  "65": ["DcK"],
  "66": ["DcQ"],
  "67": ["GKU","DcP"],
  "68": ["FY5","DcJ"],
  "69": ["DcM"],
  "70": ["FY7","Db6","Db0"],
  "71": ["Db5"],
  "72": ["FY8","DcB"],
  "73": ["DcA"],
  "74": ["Db3"],
  "75": ["Db2"],
  "76": ["Db8"],
  "77": ["Db7"],
  "78": ["Db1"],
  "79": ["Db4"],
  "80": ["FZA","Dan","Dah"],
  "81": ["Dam"],
  "82": ["Das"],
  "83": ["Dar"],
  "84": ["Dak"],
  "85": ["Daj"],
  "86": ["Dap"],
  "87": ["Dao"],
  "88": ["Dai"],
  "89": ["Dal"],
  "90": ["FZB","Dbi","Dbc"],
  "91": ["Dbh"],
  "92": ["Dbn"],
  "93": ["Dbm"],
  "94": ["Dbf"],
  "95": ["Dbe"],
  "96": ["Dbk"],
  "97": ["Dbj"],
  "98": ["Dbd"],
  "99": ["Dbg"],
  "100": ["FYj","Dbp"],
  "200": ["Dc5"],
  "300": ["Dcm"],
  "400": ["DbR"],
  "500": ["FY1","DbB"],
  "600": ["DcD"],
  "700": ["Dbv"],
  "800": ["Dae"],
  "900": ["DbX"],
  "1000": ["FYi","Dbt"],
  "1200": ["Dcq"],
  "2000": ["Dc7"],
  "3000": ["Dco"],
  "4000": ["DbV"],
  "5000": ["DbD"],
  "6000": ["DcH"],
  "7000": ["Dbz"],
  "8000": ["Dag"],
  "9000": ["Dbb"],
  "10000": ["DcW"],
  "15000": ["Dax"],
  "20000": ["Dc1"],
  "30000": ["Dci"],
  "40000": ["DbN"],
  "50000": ["Da7"],
  "60000": ["DcR"],
  "70000": ["Db9"],
  "80000": ["Daq"],
  "90000": ["Dbl"],
  "100000": ["Dbq"],
  "1000000": ["Dbr"],
  "10 o'clock": ["FYk","DeW"],
  "10 past 8": ["DeX"],
  "10 to 5": ["DeY"],
  "1000th": ["HA3"],
  "100th": ["HA4"],
  "10th": ["HA5","GKB"],
  "11 minutes past 5": ["Dd9"],
  "11th": ["HA6"],
  "12th": ["HA7"],
  "13th": ["HA8"],
  "14th": ["HA9"],
  "15th": ["HBA"],
  "16th": ["HBB"],
  "17th": ["HBC"],
  "18th": ["HBD"],
  "19th": ["HBE"],
  "1st": ["HBF"],
  "2 o'clock": ["FYu","Deg"],
  "20 past 2": ["Dee"],
  "20 to 4": ["Def"],
  "20th": ["HBG"],
  "21st": ["HBH"],
  "25 past 10": ["Dec"],
  "25 past 11": ["Dea"],
  "25 past 6": ["Deb"],
  "25 to 10": ["Ded"],
  "2nd": ["HBI"],
  "3 o'clock": ["FYx","DeZ"],
  "30th": ["HBJ"],
  "3rd": ["HBK"],
  "40th": ["HBL"],
  "4th": ["HBM"],
  "5 o'clock": ["FY3","DeA"],
  "5 past 12": ["DeC"],
  "5 past 6": ["DeB"],
  "5 to 12": ["DeD"],
  "50th": ["HBN"],
  "5th": ["HBO"],
  "6 o'clock": ["FY6","DeV"],
  "6th": ["HBP"],
  "7 o'clock": ["FY9","DeU"],
  "7th": ["HBQ"],
  "8'clock": ["Dd8"],
  "8th": ["HBR","GKY"],
  "9 o'clock": ["FZC","DeJ"],
  "9th": ["HBS","GKa"],
  "A": ["DZl","FbE","E6F","HBe"],
  "a": ["GLX","DZm","HBT"],
  "a baboon": ["Hnz"],
  "a baby": ["Hn1"],
  "a baby brother": ["Hn0"],
  "a baby sister": ["Hn2"],
  "a babysitter": ["Hn3"],
  "a backpack": ["Hn4"],
  "a bad apple": ["D8A","D8B","D8C"],
  "a badge": ["Hn5"],
  "a bag": ["FZD"],
  "a bag of chips": ["Hn6"],
  "a Bahraini": ["Knc","Knb"],
  "a baker": ["Hn7"],
  "a baker's": ["Hn8"],
  "a bakery": ["Hn9"],
  "a balcony": ["HoA"],
  "a ball": ["FZE"],
  "a ballerina": ["HoB"],
  "a ballet": ["HoC"],
  "a balloon": ["HoD"],
  "a banana": ["HoE"],
  "a band": ["HoH"],
  "a band aid": ["HoG"],
  "a bandage": ["HoF"],
  "a Bangladeshi": ["Kne","Knd"],
  "a bank": ["HoI"],
  "a banner": ["HoJ"],
  "a bar": ["HoP"],
  "a bar of": ["FZF"],
  "a barbecue": ["HoK"],
  "a barber": ["HoL"],
  "a barbershop": ["HoM"],
  "a bargain": ["HoN"],
  "a barn": ["HoO"],
  "a baseball cap": ["HoQ"],
  "a basement": ["HoR"],
  "a basket": ["HoS"],
  "a Basque": ["Knf"],
  "a bat": ["HoV"],
  "a bath": ["HoT"],
  "a bathroom": ["FZG"],
  "a bathtub": ["HoU"],
  "a battery": ["HoW"],
  "a battle": ["HoX"],
  "a bauble": ["HoY"],
  "a bay": ["HoZ"],
  "a beach": ["Hoc"],
  "a beach ball": ["Hoa"],
  "a beach chair": ["Hob"],
  "a beach umbrella": ["Hod"],
  "a bead": ["Hoe"],
  "a beak": ["Hof"],
  "a bean": ["Hoh"],
  "a beanie": ["Hog"],
  "a bear": ["Hoj"],
  "a beard": ["Hoi"],
  "a beaver": ["Hok"],
  "a bed": ["FZI"],
  "a Bedouin": ["Kng"],
  "a bedroom": ["Hol"],
  "a bedside table": ["Hom"],
  "a bee": ["Hon"],
  "a beer": ["Hoo"],
  "a beetle": ["Hop"],
  "a beetroot": ["Hoq"],
  "a Belarusian": ["Knh"],
  "a Belgian": ["Kni"],
  "a bell": ["Hor"],
  "a belly": ["Hot"],
  "a belly button": ["Hos"],
  "a belt": ["Hou"],
  "a bench": ["Hov"],
  "a Berber": ["Knj"],
  "a Berliner": ["Knk"],
  "a berry": ["How"],
  "a Bhutanese": ["Knl"],
  "a bicycle": ["Hox"],
  "a bike": ["Hoy"],
  "a bikini": ["Hoz"],
  "a bill": ["Ho0"],
  "a bin": ["Ho1"],
  "a biography": ["Ho2"],
  "a bird": ["FZK"],
  "a birthday": ["Ho7"],
  "a birthday cake": ["Ho3"],
  "a birthday card": ["Ho4"],
  "a birthday hat": ["Ho5"],
  "a birthday party": ["Ho6"],
  "a biscuit": ["Ho8"],
  "a bit": ["G6Y"],
  "a blackberry": ["Ho9"],
  "a blackboard": ["HpA"],
  "a blanket": ["HpB"],
  "a blazer": ["HpC"],
  "a blender": ["HpD"],
  "a blizzard": ["HpE"],
  "a block": ["HpG"],
  "a block of flats": ["HpF"],
  "a blossom": ["HpH"],
  "a blouse": ["HpI"],
  "a blueberry": ["HpJ"],
  "a board": ["HpL"],
  "a board game": ["HpK"],
  "a body": ["HpM"],
  "a Bolivian": ["Knm"],
  "a bone": ["HpN"],
  "a bonfire": ["HpO"],
  "a book": ["FZM"],
  "a book shelf": ["HpQ"],
  "a bookcase": ["HpP"],
  "a bookshelf": ["HpR"],
  "a bookshop": ["HpS"],
  "a bookstore": ["HpT"],
  "a bookworm": ["FZN","D8D","D8E","D8F"],
  "a boot": ["HpU"],
  "a Bosnian": ["Knn"],
  "a boss": ["HpV"],
  "a bottle": ["HpW"],
  "a bottle of": ["FZP"],
  "a bouquet": ["HpX"],
  "a bow": ["Hpa"],
  "a bow tie": ["Hpb"],
  "a bowl": ["HpZ"],
  "a bowl of soup": ["FZR"],
  "a bowling alley": ["HpY"],
  "a box": ["Hpc"],
  "a boy": ["Hpe"],
  "a boyfriend": ["Hpd"],
  "a bracelet": ["Hpf"],
  "a braid": ["Hpg"],
  "a brain": ["Hph"],
  "a branch": ["Hpi"],
  "a Brazilian": ["Kno"],
  "a breeze": ["Hpj"],
  "a brick": ["Hpk"],
  "a bride": ["Hpl"],
  "a bridge": ["Hpm"],
  "a briefcase": ["Hpn"],
  "a Brit": ["Knq"],
  "a Briton": ["Knp"],
  "a broom": ["Hpo"],
  "a broomstick": ["Hpp"],
  "a brother": ["Hpq"],
  "a bruise": ["Hpr"],
  "a Brummie": ["Knr"],
  "a Bruneian": ["Kns"],
  "a brush": ["Hps"],
  "a bubble": ["Hpt"],
  "a bucket": ["Hpv"],
  "a bucket and spade": ["Hpu"],
  "a budgie": ["Hpw"],
  "a buffalo": ["Hpx"],
  "a bug": ["Hpy"],
  "a builder": ["Hpz"],
  "a building": ["Hp0"],
  "a Bulgarian": ["Knt"],
  "a bull": ["Hp1"],
  "a bump": ["Hp3"],
  "a bumper car": ["Hp2"],
  "a bun": ["Hp5"],
  "a bunny": ["Hp4"],
  "a burger": ["Hp6"],
  "a Burmese": ["Knu"],
  "a bus": ["HqC"],
  "a bus driver": ["Hp7"],
  "a bus station": ["HqD"],
  "a bus stop": ["HqE"],
  "a bush": ["Hp8"],
  "a business": ["HqA"],
  "a businessman": ["Hp9"],
  "a businesswoman": ["HqB"],
  "a butcher": ["HqF"],
  "a butchers": ["HqG"],
  "a butterfly": ["HqH"],
  "a button": ["HqI"],
  "a cab": ["HqN"],
  "a cabin": ["HqK"],
  "a cabinet": ["HqJ"],
  "a cable": ["HqM"],
  "a cable car": ["HqL"],
  "a cactus": ["HqO"],
  "a cafe": ["HqP"],
  "a cafeteria": ["HqQ"],
  "a Cajun": ["Knv"],
  "a cake": ["HqR"],
  "a calculator": ["HqS"],
  "a calendar": ["HqT"],
  "a calf": ["HqU"],
  "a Californian": ["Knw"],
  "a Cambodian": ["Knx"],
  "a camel": ["HqV"],
  "a camera": ["HqW"],
  "a Cameroonian": ["Kny"],
  "a camp": ["HqY"],
  "a campfire": ["HqX"],
  "a campsite": ["HqZ"],
  "a can of": ["FZW"],
  "a Canadian": ["Knz"],
  "a canary": ["Hqa"],
  "a candle": ["Hqb"],
  "a candy": ["Hqe"],
  "a candy bar": ["Hqc"],
  "a candy cane": ["Hqd"],
  "a candy store": ["Hqf"],
  "a cane": ["Hqg"],
  "a canoe": ["Hqh"],
  "a canteen": ["Hqi"],
  "a Canuck": ["Kn0"],
  "a cap": ["Hql"],
  "a cape": ["Hqj"],
  "a capital": ["Hqk"],
  "a captain": ["Hqm"],
  "a car": ["FZX"],
  "a car crash": ["Hqo"],
  "a car park": ["Hqs"],
  "a caravan": ["Hqn"],
  "a card": ["Hqq"],
  "a cardigan": ["Hqp"],
  "a career": ["Hqr"],
  "a carpenter": ["Hqt"],
  "a carpet": ["Hqu"],
  "a carriage": ["Hqv"],
  "a carrot": ["FZY"],
  "a cart": ["Hqy"],
  "a carton": ["Hqw"],
  "a carton of": ["FZZ"],
  "a cartoon": ["Hqx"],
  "a case": ["Hqz"],
  "a cashier": ["Hq0"],
  "a castle": ["Hq1"],
  "a cat": ["Hq4"],
  "a caterpillar": ["Hq2"],
  "a cathedral": ["Hq3"],
  "a cattle": ["Hq5"],
  "a cauldron": ["Hq6"],
  "a cauliflower": ["Hq7"],
  "a cave": ["Hq8"],
  "a CD": ["HrA"],
  "a CD player": ["Hq9"],
  "a ceiling": ["HrB"],
  "a celebration": ["HrC"],
  "a cell": ["HrF"],
  "a cell phone": ["HrE"],
  "a cello": ["HrD"],
  "a Celt": ["Kn2","Kn1"],
  "a center": ["HrG"],
  "a ceremony": ["HrH"],
  "a chain": ["HrI"],
  "a chair": ["FZj"],
  "a challenge": ["HrJ"],
  "a chameleon": ["HrK"],
  "a chance": ["HrL"],
  "a charger": ["HrM"],
  "a charity": ["HrN"],
  "a cheese sandwich": ["HrP"],
  "a cheeseburger": ["HrO"],
  "a cheetah": ["HrQ"],
  "a chef": ["HrR"],
  "a chemist": ["HrS"],
  "a Cherokee": ["Kn3"],
  "a cherry": ["HrT"],
  "a chest": ["HrV"],
  "a chest of drawers": ["HrU"],
  "a chick": ["HrY"],
  "a chicken": ["HrX"],
  "a chicken nugget": ["HrW"],
  "a child": ["HrZ"],
  "a Chilean": ["Kn4"],
  "a chilli pepper": ["Hra"],
  "a chimney": ["Hrb"],
  "a chimp": ["Hrd"],
  "a chimpanzee": ["Hrc"],
  "a chin": ["Hre"],
  "a Chinese": ["Kn5"],
  "a chocolate": ["Hrh"],
  "a chocolate bar": ["Hrf"],
  "a chocolate cake": ["Hrg"],
  "a choir": ["Hri"],
  "a Christmas candle": ["Hrj"],
  "a Christmas dinner": ["Hrk"],
  "a Christmas stocking": ["Hrl"],
  "a Christmas tree": ["Hrm"],
  "a church": ["Hrn"],
  "a cinema": ["Hro"],
  "a circle": ["Hrp"],
  "a circus": ["Hrq"],
  "a city": ["Hrs"],
  "a city hall": ["Hrr"],
  "a clam": ["Hrt"],
  "a clarinet": ["Hru"],
  "a class": ["Hrw"],
  "a classmate": ["Hrv"],
  "a classroom": ["Hrx"],
  "a claw": ["Hry"],
  "a cleaner": ["Hrz"],
  "a clerk": ["Hr0"],
  "a cliff": ["Hr1"],
  "a clinic": ["Hr2"],
  "a clip": ["Hr3"],
  "a clock": ["Hr4"],
  "a closet": ["Hr5"],
  "a cloth": ["Hr8"],
  "a clothes shop": ["Hr6"],
  "a clothing store": ["Hr7"],
  "a cloud": ["Hr9"],
  "a clown": ["HsA"],
  "a club": ["HsB"],
  "a clue": ["HsC"],
  "a coat": ["HsD"],
  "a Cockney": ["Kn7","Kn6"],
  "a cockroach": ["HsE"],
  "a coconut": ["HsF"],
  "a coffee": ["HsH"],
  "a coffee machine": ["HsG"],
  "a coffee shop": ["HsI"],
  "a coffee table": ["HsJ"],
  "a coffin": ["HsK"],
  "a coin": ["HsL"],
  "a coke": ["HsM"],
  "a collection": ["HsN"],
  "a college": ["HsO"],
  "a Colombian": ["Kn8"],
  "a color": ["HsP"],
  "a comedian": ["HsQ"],
  "a comedy": ["HsR"],
  "a comet": ["HsS"],
  "a communication": ["HsT"],
  "a community": ["HsU"],
  "a company": ["HsV"],
  "a compass": ["HsW"],
  "a competition": ["HsX"],
  "a composer": ["HsY"],
  "a computer": ["FZl"],
  "a computer game": ["HsZ"],
  "a computer lab": ["Hsa"],
  "a computer programmer": ["Hsb"],
  "a computer room": ["Hsc"],
  "a computer technician": ["Hsd"],
  "a concert": ["Hsf"],
  "a concert hall": ["Hse"],
  "a cone": ["Hsg"],
  "a construction worker": ["Hsh"],
  "a container": ["Hsi"],
  "a contest": ["Hsj"],
  "a control": ["Hsl"],
  "a controller": ["Hsk"],
  "a convenience store": ["Hsm"],
  "a conversation": ["Hsn"],
  "a cook": ["Hsq"],
  "a cooker": ["Hso"],
  "a cookie": ["Hsp"],
  "a coral reef": ["Hsr"],
  "a corner": ["Hss"],
  "a corridor": ["Hst"],
  "a Costa Rican": ["Kn9"],
  "a costume": ["Hsu"],
  "a cosy": ["Hsv"],
  "a cot": ["Hsw"],
  "a cottage": ["Hsx"],
  "a couch": ["Hsy"],
  "a couch potato": ["D8I","D8J","D8K"],
  "a cough": ["FZm"],
  "a count": ["Hsz"],
  "a country": ["Hs0"],
  "a couple": ["Hs1"],
  "a couple of": ["ILu"],
  "a courthouse": ["Hs2"],
  "a cousin": ["Hs3"],
  "a cow": ["Hs5"],
  "a cowboy": ["Hs4"],
  "a crab": ["Hs6"],
  "a cracker": ["Hs7"],
  "a crane": ["Hs8"],
  "a crayon": ["Hs9"],
  "a creature": ["HtA"],
  "a credit card": ["HtB"],
  "a Creole": ["KoA"],
  "a crescent": ["HtC"],
  "a crew": ["HtD"],
  "a crib": ["HtE"],
  "a Croatian": ["KoB"],
  "a crocodile": ["HtF"],
  "a croissant": ["HtG"],
  "a crossroad": ["HtH"],
  "a crosswalk": ["HtI"],
  "a crow": ["HtL"],
  "a crowd": ["HtJ"],
  "a crown": ["HtK"],
  "a cub": ["HtN"],
  "a Cuban": ["KoC"],
  "a cube": ["HtM"],
  "a cucumber": ["HtO"],
  "a culture": ["HtP"],
  "a cup": ["HtS"],
  "a cup of tea": ["FZs"],
  "a cupboard": ["HtQ"],
  "a cupcake": ["HtR"],
  "a curry": ["HtT"],
  "a curtain": ["HtU"],
  "a cushion": ["HtV"],
  "a customer": ["HtW"],
  "a cylinder": ["HtX"],
  "a Cypriot": ["KoD"],
  "a Czech": ["KoE"],
  "a dad": ["HtZ"],
  "a daddy": ["HtY"],
  "a daisy": ["Hta"],
  "a dancer": ["Htb"],
  "a Dane": ["KoF"],
  "a date": ["Htc"],
  "a daughter": ["Htd"],
  "a deck": ["Hte"],
  "a deer": ["Htf"],
  "a delivery": ["Hth"],
  "a delivery man": ["Htg"],
  "a dentist": ["Hti"],
  "a department store": ["Htj"],
  "a desert": ["Htk"],
  "a designer": ["Htl"],
  "a desk": ["FZw"],
  "a desktop computer": ["Htm"],
  "a dessert": ["Htn"],
  "a detective": ["Hto"],
  "a diamond": ["Htp"],
  "a diary": ["Htq"],
  "a dictionary": ["Htr"],
  "a dinner": ["Hts"],
  "a dinosaur": ["Htt"],
  "a director": ["Htu"],
  "a discount": ["Htv"],
  "a dish": ["Htw"],
  "a dishwasher": ["Htx"],
  "a doctor": ["Hty"],
  "a document": ["Ht0"],
  "a documentary": ["Htz"],
  "a dog": ["Ht2"],
  "a dog house": ["Ht1"],
  "a doll": ["FZz"],
  "a doll house": ["Ht3"],
  "a dolphin": ["Ht4"],
  "a Dominican": ["KoG"],
  "a donkey": ["Ht5"],
  "a donut": ["Ht6"],
  "a door": ["FZ0"],
  "a doorbell": ["Ht7"],
  "a dot": ["Ht8"],
  "a doughnut": ["Ht9"],
  "a dragon": ["HuB"],
  "a dragonfly": ["HuA"],
  "a drain": ["HuC"],
  "a drawer": ["HuD"],
  "a dream": ["HuE"],
  "a dresser": ["HuF"],
  "a drill": ["HuG"],
  "a drink": ["HuH"],
  "a driver": ["HuI"],
  "a drone": ["HuJ"],
  "a drought": ["HuK"],
  "a drugstore": ["HuL"],
  "a dual citizen": ["KoH"],
  "a duck": ["HuM"],
  "a Dutchman": ["KoI"],
  "a DVD player": ["HuN"],
  "a dwarf": ["HuO"],
  "a European": ["KoJ"],
  "a face": ["HuP"],
  "a facility": ["HuQ"],
  "a factory": ["HuR"],
  "a fairy": ["HuS"],
  "a falcon": ["HuT"],
  "a family": ["HuU"],
  "a fan": ["HuV"],
  "a far cry from": ["IMq"],
  "a farm": ["HuX"],
  "a farmer": ["HuW"],
  "a fashion": ["HuZ"],
  "a fashion designer": ["HuY"],
  "a father": ["Hua"],
  "a faucet": ["Hub"],
  "a feast": ["Huc"],
  "a feather": ["Hud"],
  "a fence": ["Hue"],
  "a ferris wheel": ["Huf"],
  "a ferry": ["Hug"],
  "a festival": ["Huh"],
  "a fever": ["Hui"],
  "a few": ["G6a"],
  "a field": ["Huj"],
  "a Fijian": ["KoK"],
  "a file": ["Huk"],
  "a Filipina": ["KoL"],
  "a Filipino": ["KoM"],
  "a film": ["Hul"],
  "a fin": ["Hun"],
  "a finger": ["Hum"],
  "a Finn": ["KoN"],
  "a fire": ["Hut"],
  "a fire engine": ["Huo"],
  "a fire extinguisher": ["Hup"],
  "a fire station": ["Huu"],
  "a fire truck": ["Huv"],
  "a firefighter": ["Huq"],
  "a fireman": ["Hur"],
  "a fireplace": ["Hus"],
  "a first aid kit": ["Huw"],
  "a fish": ["Huz"],
  "a fish out of water": ["D8M","D8N","D8O"],
  "a fisherman": ["Hux"],
  "a fishmonger": ["Huy"],
  "a flag": ["Hu0"],
  "a flame": ["Hu1"],
  "a flamingo": ["Hu2"],
  "a flash drive": ["Hu3"],
  "a flashlight": ["Hu4"],
  "a flight": ["Hu6"],
  "a flight attendant": ["Hu5"],
  "a flood": ["Hu7"],
  "a floor": ["Hu8"],
  "a Florentine": ["KoO"],
  "a florist": ["Hu9"],
  "a flow": ["HvB"],
  "a flower": ["HvA"],
  "a flute": ["HvC"],
  "a foal": ["HvD"],
  "a folder": ["HvE"],
  "a fool": ["HvF"],
  "a foot": ["HvI"],
  "a football player": ["HvH"],
  "a footballer": ["HvG"],
  "a footprint": ["HvJ"],
  "a forehead": ["HvK"],
  "a foreign national": ["KoQ"],
  "a foreigner": ["KoP"],
  "a forest": ["HvM"],
  "a forest fire": ["HvL"],
  "a fossil": ["HvN"],
  "a fountain": ["HvO"],
  "a fox": ["HvP"],
  "a freckle": ["HvQ"],
  "a freezer": ["HvR"],
  "a Frenchman": ["KoR"],
  "a fridge": ["HvS"],
  "a friend": ["HvT"],
  "a frisbee": ["HvU"],
  "a frog": ["HvV"],
  "a front door": ["HvW"],
  "a fruit salad": ["HvX"],
  "a funfair": ["HvY"],
  "a galaxy": ["HvZ"],
  "a gallery": ["Hva"],
  "a game": ["Hvc"],
  "a game console": ["Hvb"],
  "a game show": ["Hvd"],
  "a garage": ["Hve"],
  "a gardener": ["Hvf"],
  "a gas station": ["Hvg"],
  "a gate": ["Hvh"],
  "a gazelle": ["Hvi"],
  "a gecko": ["Hvj"],
  "a geese": ["Hvk"],
  "a Geordie": ["KoS"],
  "a Georgian": ["KoT"],
  "a germ": ["Hvl"],
  "a German": ["KoU"],
  "a Ghanaian": ["KoV"],
  "a ghost": ["Hvm"],
  "a gift": ["Hvn"],
  "a gift shop": ["Hvo"],
  "a giraffe": ["Hvp"],
  "a girl": ["Hvq"],
  "a glacier": ["Hvr"],
  "a glass": ["Hvs"],
  "a glass of milk": ["FaG"],
  "a globe": ["Hvt"],
  "a glove": ["Hvu"],
  "a glue stick": ["Hvv"],
  "a goal": ["Hvw"],
  "a goat": ["Hvx"],
  "a god": ["Hvy"],
  "a goldfish": ["Hvz"],
  "a goose": ["Hv0"],
  "a gorilla": ["Hv1"],
  "a grand": ["G6c"],
  "a grandad": ["Hv2"],
  "a granddaughter": ["Hv3"],
  "a grandfather": ["Hv4"],
  "a grandma": ["Hv5"],
  "a grandmother": ["Hv6"],
  "a grandpa": ["Hv7"],
  "a grandparent": ["Hv8"],
  "a grandson": ["Hv9"],
  "a granny": ["HwA"],
  "a grape": ["HwC"],
  "a grapefruit": ["HwB"],
  "a graphic designer": ["HwD"],
  "a grasshopper": ["HwE"],
  "a grassland": ["HwF"],
  "a graveyard": ["HwG"],
  "a Greek": ["KoW"],
  "a greengrocer": ["HwH"],
  "a greengrocers": ["HwI"],
  "a grill": ["HwJ"],
  "a grin": ["HwK"],
  "a grocery": ["HwL"],
  "a grocery store": ["HwM"],
  "a groom": ["HwN"],
  "a group": ["HwO"],
  "a guard": ["HwP"],
  "a Guatemalan": ["KoX"],
  "a guest": ["HwQ"],
  "a guinea pig": ["HwR"],
  "a guitar": ["HwS"],
  "a gym": ["HwT"],
  "a gypsy": ["KoY"],
  "a habitat": ["HwU"],
  "a hair dryer": ["HwX"],
  "a hair salon": ["HwY"],
  "a hairbrush": ["HwV"],
  "a hairdresser": ["HwW"],
  "a Haitian": ["KoZ"],
  "a hall": ["HwZ"],
  "a hallway": ["Hwa"],
  "a ham": ["Hwe"],
  "a hamburger": ["Hwb"],
  "a hammer": ["Hwc"],
  "a hammock": ["Hwd"],
  "a hamster": ["Hwf"],
  "a hand": ["Hwh"],
  "a handbag": ["Hwg"],
  "a hanger": ["Hwi"],
  "a harbor": ["Hwj"],
  "a hare": ["Hwk"],
  "a harmonica": ["Hwl"],
  "a harp": ["Hwm"],
  "a hat": ["Hwn"],
  "a head": ["Hwp"],
  "a headache": ["Hwo"],
  "a heart": ["Hwr"],
  "a heart attack": ["Hwq"],
  "a heater": ["Hws"],
  "a hedgehog": ["Hwt"],
  "a heel": ["Hwu"],
  "a helicopter": ["Hwv"],
  "a helmet": ["Hww"],
  "a hen": ["Hwx"],
  "a hero": ["Hwy"],
  "a hexagon": ["Hwz"],
  "a highlighter": ["Hw0"],
  "a hill": ["Hw1"],
  "a hip": ["Hw2"],
  "a hippo": ["Hw3"],
  "a hippopotamus": ["Hw4"],
  "a Hispanic": ["Koa"],
  "a hive": ["Hw5"],
  "a hole": ["Hw6"],
  "a holiday": ["Hw7"],
  "a Hollander": ["Kob"],
  "a home": ["Hw8"],
  "a Honduran": ["Koc"],
  "a Hong Konger": ["Kod"],
  "a Hongkonger": ["Koe"],
  "a hoodie": ["Hw9"],
  "a hoof": ["HxA"],
  "a hook": ["HxB"],
  "a horn": ["HxC"],
  "a horse": ["HxD"],
  "a hose": ["HxE"],
  "a hospital": ["HxF"],
  "a hostel": ["HxG"],
  "a hotel": ["HxH"],
  "a house": ["FaI"],
  "a housewife": ["HxI"],
  "a hummingbird": ["HxJ"],
  "a hump": ["HxK"],
  "a hundred": ["FaJ"],
  "a Hungarian": ["Kof"],
  "a hunter": ["HxL"],
  "a hurricane": ["HxM"],
  "a husband": ["HxN"],
  "a hut": ["HxO"],
  "a hyena": ["HxP"],
  "a jack fruit": ["HxR"],
  "a jack o lantern": ["HxT"],
  "a jacket": ["HxQ"],
  "a jackfruit": ["HxS"],
  "a jaguar": ["HxU"],
  "a Jamaican": ["Kog"],
  "a janitor": ["HxV"],
  "a Japanese": ["Koh"],
  "a jar": ["HxW"],
  "a jar of": ["FaO"],
  "a jeep": ["HxX"],
  "a jelly": ["Hxa"],
  "a jellybean": ["HxY"],
  "a jellyfish": ["HxZ"],
  "a jewel": ["Hxb"],
  "a jewelry store": ["Hxc"],
  "a jigsaw": ["Hxd"],
  "a job": ["Hxe"],
  "a joke": ["Hxf"],
  "a journalist": ["Hxg"],
  "a journey": ["Hxh"],
  "a jug": ["Hxj"],
  "a juggler": ["Hxi"],
  "a jumper": ["Hxk"],
  "a jungle": ["Hxl"],
  "a kangaroo": ["Hxm"],
  "a kayak": ["Hxn"],
  "a Kazakhstani": ["Koi"],
  "a Kenyan": ["Koj"],
  "a kettle": ["Hxo"],
  "a key": ["Hxq"],
  "a keyboard": ["Hxp"],
  "a kid": ["Hxs"],
  "a kidney": ["Hxr"],
  "a killer whale": ["Hxt"],
  "a king": ["Hxu"],
  "a kitchen": ["Hxv"],
  "a kite": ["FaP"],
  "a kitten": ["Hxw"],
  "a kiwi": ["Hxy"],
  "a Kiwi": ["Kok"],
  "a kiwi fruit": ["Hxx"],
  "a knee": ["Hxz"],
  "a knife": ["Hx0"],
  "a knight": ["Hx1"],
  "a koala": ["Hx2"],
  "a Korean": ["Kol"],
  "a Kurd": ["Kom"],
  "a laboratory": ["Hx3"],
  "a ladder": ["Hx4"],
  "a ladle": ["Hx5"],
  "a lady": ["Hx8"],
  "a ladybird": ["Hx6"],
  "a ladybug": ["Hx7"],
  "a lake": ["Hx9"],
  "a lamb": ["HyA"],
  "a lamp": ["HyB"],
  "a landscape": ["HyC"],
  "a lane": ["HyD"],
  "a language": ["HyE"],
  "a lantern": ["HyF"],
  "a Laotian": ["Kon"],
  "a laptop": ["HyG"],
  "a Latin American": ["Koq","Kop"],
  "a Latina": ["Kor","Koo"],
  "a Latino": ["Kos"],
  "a Latvian": ["Kot"],
  "a laundromat": ["HyH"],
  "a laundry room": ["HyI"],
  "a lawn": ["HyJ"],
  "a lawyer": ["HyK"],
  "a leaf": ["HyL"],
  "a leek": ["HyM"],
  "a leg": ["HyN"],
  "a lemon": ["HyO"],
  "a leopard": ["HyP"],
  "a librarian": ["HyQ"],
  "a library": ["HyR"],
  "a Libyan": ["Kou"],
  "a lid": ["HyS"],
  "a lie": ["HyT"],
  "a life jacket": ["HyV"],
  "a lifeguard": ["HyU"],
  "a light bulb": ["HyW"],
  "a lighter": ["HyX"],
  "a lighthouse": ["HyY"],
  "a lily": ["HyZ"],
  "a lime": ["Hya"],
  "a Limey": ["Kov"],
  "a line": ["Hyb"],
  "a link": ["Hyc"],
  "a lion": ["Hyd"],
  "a list": ["Hye"],
  "a Lithuanian": ["Kow"],
  "a little": ["Exw"],
  "a little bit": ["G6d"],
  "a living room": ["Hyf"],
  "a lizard": ["Hyg"],
  "a loaf": ["Hyh"],
  "a loaf of": ["FaY"],
  "a lobster": ["Hyi"],
  "a Local": ["Koy","Kox"],
  "a lock": ["Hyk"],
  "a locker": ["Hyj"],
  "a log": ["Hyl"],
  "a lollipop": ["Hym"],
  "a Londoner": ["Ko1","Koz","Ko0"],
  "a long time ago": ["INz"],
  "a lorry": ["Hyn"],
  "a lot of": ["Exx"],
  "a lotus": ["Hyo"],
  "a lunch": ["Hyr"],
  "a lunch box": ["Hyp"],
  "a lunchbox": ["Hyq"],
  "a lung": ["Hys"],
  "a Luxembourger": ["Ko2"],
  "a lychee": ["Hyt"],
  "a Maasai": ["Ko3"],
  "a machine": ["Hyu"],
  "a magazine": ["Hyv"],
  "a magician": ["Hyw"],
  "a magnet": ["Hyx"],
  "a mailbox": ["Hyy"],
  "a mailman": ["Hyz"],
  "a Malagasy": ["Ko4"],
  "a Malaysian": ["Ko5"],
  "a Malian": ["Ko6"],
  "a mall": ["Hy0"],
  "a mammal": ["Hy1"],
  "a man": ["Hy6"],
  "a manager": ["Hy2"],
  "a mane": ["Hy3"],
  "a mango": ["Hy4"],
  "a mangosteen": ["Hy5"],
  "a Maori": ["Ko7"],
  "a map": ["Hy7"],
  "a marathon": ["Hy8"],
  "a marble": ["Hy9"],
  "a marker": ["HzA"],
  "a market": ["HzB"],
  "a marriage": ["HzC"],
  "a marshmallow": ["HzD"],
  "a mask": ["HzE"],
  "a mat": ["HzG"],
  "a match": ["HzF"],
  "a matter of taste": ["IOD"],
  "a Maya": ["Ko8"],
  "a mayor": ["HzH"],
  "a meal": ["HzI"],
  "a meatball": ["HzJ"],
  "a mechanic": ["HzK"],
  "a medal": ["HzL"],
  "a meerkat": ["HzM"],
  "a melon": ["HzN"],
  "a memory": ["HzO"],
  "a memory stick": ["HzP"],
  "a menu": ["HzQ"],
  "a mermaid": ["HzR"],
  "a mess": ["HzS"],
  "a meteor": ["HzT"],
  "a Mexican": ["Ko9"],
  "a microphone": ["HzU"],
  "a microscope": ["HzV"],
  "a microwave": ["HzW"],
  "a midwesterner": ["KpA"],
  "a migrant": ["KpB"],
  "a milkshake": ["HzX"],
  "a miner": ["HzY"],
  "a mirror": ["HzZ"],
  "a mistake": ["Hza"],
  "a mitten": ["Hzb"],
  "a mixer": ["Hzc"],
  "a model": ["Hzd"],
  "a Moldovan": ["KpC"],
  "a mole": ["Hze"],
  "a mom": ["Hzf"],
  "a Mongolian": ["KpD"],
  "a monitor": ["Hzg"],
  "a monkey": ["Hzh"],
  "a monster": ["Hzi"],
  "a Montenegrin": ["KpE"],
  "a monument": ["Hzj"],
  "a mooncake": ["Hzk"],
  "a moose": ["Hzl"],
  "a mop": ["Hzm"],
  "a Moroccan": ["KpF"],
  "a mosque": ["Hzn"],
  "a mosquito": ["Hzo"],
  "a moth": ["Hzq"],
  "a mother": ["Hzp"],
  "a motorbike": ["Hzr"],
  "a motorcycle": ["Hzs"],
  "a mountain": ["Hzt"],
  "a mouse": ["Hzu"],
  "a moustache": ["Hzv"],
  "a mouth": ["Hzw"],
  "a movie": ["Hzx"],
  "a movie theater": ["Hzy"],
  "a muffin": ["Hzz"],
  "a mug": ["Hz0"],
  "a mule": ["Hz1"],
  "a mum": ["Hz3"],
  "a mummy": ["Hz2"],
  "a muscle": ["Hz4"],
  "a Muscovite": ["KpH","KpG"],
  "a museum": ["Hz5"],
  "a mushroom": ["Hz6"],
  "a music room": ["Hz8"],
  "a musician": ["Hz7"],
  "a must have item": ["IOX"],
  "a mustache": ["Hz9"],
  "a Namibian": ["KpP"],
  "a nap": ["H0j"],
  "a napkin": ["H0f"],
  "a national": ["Kpc"],
  "a Native": ["Kpd"],
  "a Navajo": ["Kph"],
  "a neck": ["H1O"],
  "a necklace": ["H1N"],
  "a needle": ["H1Q"],
  "a neighbor": ["H1V"],
  "a neighborhood": ["H1U"],
  "a neighbour": ["H1W"],
  "a Nepalese": ["Kpr"],
  "a nephew": ["H1g"],
  "a nest": ["H1j"],
  "a net": ["H1k"],
  "a New Yorker": ["Kpw","Kpv"],
  "a New Zealander": ["Kpx"],
  "a newspaper": ["H1l"],
  "a Nicaraguan": ["Kp1"],
  "a niece": ["H11"],
  "a Nigerian": ["Kp3"],
  "a night owl": ["D8W","D8X","D8Y"],
  "a Norman": ["KqB"],
  "a North American": ["KqD","KqC"],
  "a North Korean": ["KqE"],
  "a Norwegian": ["KqF"],
  "a nose": ["H2S"],
  "a nose bleed": ["H2R"],
  "a note": ["H2W"],
  "a notebook": ["H2U"],
  "a notepad": ["H2V"],
  "a notice": ["H2X"],
  "a number": ["H2f"],
  "a nurse": ["H2j"],
  "a nut": ["H2k"],
  "a Pacific Islander": ["KqM","KqL"],
  "a package": ["H2l"],
  "a packet of": ["Fa5"],
  "a pad": ["H2n"],
  "a paddle": ["H2m"],
  "a page": ["H2o"],
  "a pagoda": ["H2p"],
  "a pail": ["H2q"],
  "a paintbrush": ["H2r"],
  "a painter": ["H2s"],
  "a pair of": ["IO9"],
  "a Pakistani": ["KqN"],
  "a palace": ["H2t"],
  "a palm tree": ["H2u"],
  "a pan": ["H2x"],
  "a Panamanian": ["KqO"],
  "a pancake": ["H2v"],
  "a panda": ["H2w"],
  "a paper": ["H2z"],
  "a paper clip": ["H2y"],
  "a Paraguayan": ["KqP"],
  "a parcel": ["H20"],
  "a parent": ["H21"],
  "a Parisian": ["KqR","KqQ"],
  "a park": ["H23"],
  "a parking lot": ["H22"],
  "a parrot": ["H24"],
  "a party": ["H26"],
  "a party hat": ["H25"],
  "a passenger": ["H27"],
  "a passing trend": ["IPC"],
  "a passion fruit": ["H28"],
  "a passport": ["H29"],
  "a password": ["H3A"],
  "a pastry": ["H3B"],
  "a path": ["H3C"],
  "a pattern": ["H3D"],
  "a pavement": ["H3E"],
  "a paw": ["H3F"],
  "a pea": ["H3J"],
  "a peach": ["H3G"],
  "a peacock": ["H3H"],
  "a peanut": ["H3I"],
  "a pear": ["H3K"],
  "a pedestrian": ["H3L"],
  "a peg": ["H3M"],
  "a pen": ["FbA"],
  "a pencil": ["Fa9"],
  "a pencil box": ["H3N"],
  "a pencil case": ["Fa8"],
  "a pencil sharpener": ["H3O"],
  "a penguin": ["H3P"],
  "a pentagon": ["H3Q"],
  "a permanent resident": ["KqT","KqS"],
  "a Peruvian": ["KqU"],
  "a pet": ["H3R"],
  "a pet store": ["H3T"],
  "a petrol station": ["H3S"],
  "a pharmacist": ["H3U"],
  "a pharmacy": ["H3V"],
  "a phone": ["H3W"],
  "a photo": ["H3Y"],
  "a photographer": ["H3X"],
  "a piano": ["H3Z"],
  "a picnic": ["H3a"],
  "a picture": ["H3b"],
  "a pie": ["H3d"],
  "a piece": ["H3c"],
  "a piece of cake": ["FbC"],
  "a pig": ["H3g"],
  "a pigeon": ["H3e"],
  "a piglet": ["H3f"],
  "a pill": ["H3i"],
  "a pillow": ["H3h"],
  "a pilot": ["H3j"],
  "a pin": ["H3m"],
  "a pine": ["H3l"],
  "a pineapple": ["H3k"],
  "a pipe": ["H3n"],
  "a pitch": ["H3o"],
  "a pizza": ["H3p"],
  "a plane": ["FbD"],
  "a planet": ["H3q"],
  "a plate": ["H3r"],
  "a platform": ["H3s"],
  "a platypus": ["H3t"],
  "a playground": ["H3u"],
  "a plug": ["H3w"],
  "a plug in": ["H3v"],
  "a plum": ["H3y"],
  "a plumber": ["H3x"],
  "a pocket": ["H3z"],
  "a poem": ["H30"],
  "a point": ["H31"],
  "a poison": ["H32"],
  "a Pole": ["KqV"],
  "a police man": ["H33"],
  "a police officer": ["H35"],
  "a policeman": ["H34"],
  "a policewoman": ["H36"],
  "a politician": ["H37"],
  "a polo shirt": ["H38"],
  "a Polynesian": ["KqX","KqW"],
  "a pom": ["KqY"],
  "a pond": ["H39"],
  "a pony": ["H4A"],
  "a ponytail": ["H4B"],
  "a pool": ["H4C"],
  "a pop star": ["H4E"],
  "a popsicle": ["H4D"],
  "a porch": ["H4F"],
  "a porcupine": ["H4G"],
  "a port": ["H4H"],
  "a portrait": ["H4I"],
  "a Portuguese": ["KqZ"],
  "a post office": ["H4M"],
  "a postcard": ["H4J"],
  "a poster": ["H4K"],
  "a postman": ["H4L"],
  "a pot": ["H4O"],
  "a potato": ["H4N"],
  "a prawn": ["H4P"],
  "a pretzel": ["H4Q"],
  "a prince": ["H4R"],
  "a princess": ["H4S"],
  "a printer": ["H4T"],
  "a prison": ["H4U"],
  "a process of trial and error": ["IPl"],
  "a professor": ["H4V"],
  "a program": ["H4X"],
  "a programmer": ["H4W"],
  "a projector": ["H4Y"],
  "a pub": ["H4Z"],
  "a pudding": ["H4a"],
  "a puddle": ["H4b"],
  "a pumpkin": ["H4d"],
  "a pumpkin pie": ["H4c"],
  "a punch": ["H4e"],
  "a pup": ["H4h"],
  "a pupil": ["H4f"],
  "a puppet": ["H4g"],
  "a puppy": ["H4i"],
  "a purse": ["H4j"],
  "a puzzle": ["FbM"],
  "a pyramid": ["H4k"],
  "a Qatari": ["Kqa"],
  "a quail": ["H4l"],
  "a queen": ["H4m"],
  "a question": ["H4n"],
  "a quilt": ["H4o"],
  "a quiz": ["H4p"],
  "a rabbit": ["H4q"],
  "a raccoon": ["H4r"],
  "a race": ["H4s"],
  "a rack": ["H4u"],
  "a racket": ["H4t"],
  "a radio": ["H4v"],
  "a rag": ["H4w"],
  "a railroad": ["H4x"],
  "a railway": ["H4y"],
  "a railway station": ["H4z"],
  "a rainbow": ["H40"],
  "a raincoat": ["H41"],
  "a rainforest": ["H42"],
  "a raisin": ["H43"],
  "a rake": ["H44"],
  "a ram": ["H45"],
  "a raspberry": ["H46"],
  "a rat": ["H47"],
  "a razor": ["H48"],
  "a receipt": ["H49"],
  "a reception": ["H5B"],
  "a receptionist": ["H5A"],
  "a record": ["H5D"],
  "a recorder": ["H5C"],
  "a rectangle": ["H5E"],
  "a recycling bin": ["H5F"],
  "a redneck": ["Kqc","Kqb"],
  "a referee": ["H5G"],
  "a refrigerator": ["H5H"],
  "a refugee": ["Kqe","Kqd"],
  "a reindeer": ["H5I"],
  "a reply": ["H5J"],
  "a report": ["H5L"],
  "a reporter": ["H5K"],
  "a reptile": ["H5M"],
  "a reservation": ["H5N"],
  "a resident": ["Kqg","Kqf"],
  "a restaurant": ["H5O"],
  "a restroom": ["H5P"],
  "a rhino": ["H5Q"],
  "a rib": ["H5S"],
  "a ribbon": ["H5R"],
  "a ride": ["H5T"],
  "a ring": ["H5U"],
  "a river": ["H5V"],
  "a road": ["H5W"],
  "a roast": ["H5X"],
  "a robe": ["H5Y"],
  "a robot": ["FbX"],
  "a rock": ["H5a"],
  "a rocket": ["H5Z"],
  "a rod": ["H5b"],
  "a roll": ["H5d"],
  "a roller coaster": ["H5c"],
  "a Roman": ["Kqj","Kqh"],
  "a Romanian": ["Kqi"],
  "a roof": ["H5e"],
  "a room": ["H5f"],
  "a rooster": ["H5g"],
  "a rope": ["H5h"],
  "a rose": ["H5i"],
  "a roundabout": ["H5j"],
  "a route": ["H5k"],
  "a row": ["H5l"],
  "a rucksack": ["H5m"],
  "a rug": ["H5n"],
  "a ruler": ["Fbl"],
  "a Russian": ["Kqk"],
  "a Rwandan": ["Kql"],
  "a sack": ["H5o"],
  "a saddle": ["H5p"],
  "a safari": ["H5q"],
  "a sail": ["H5t"],
  "a sailboat": ["H5r"],
  "a sailor": ["H5s"],
  "a salad": ["H5u"],
  "a sales clerk": ["H5v"],
  "a salesperson": ["H5w"],
  "a Salvadoran": ["Kqm"],
  "a Sami": ["Kqn"],
  "a sand castle": ["H5y"],
  "a sandal": ["H5x"],
  "a sandcastle": ["H5z"],
  "a sandpit": ["H50"],
  "a sandwich": ["H51"],
  "a satellite": ["H52"],
  "a saucepan": ["H53"],
  "a Saudi": ["Kqo"],
  "a sausage": ["H54"],
  "a savannah": ["H55"],
  "a Saxon": ["Kqp"],
  "a saxophone": ["H56"],
  "a scale": ["H57"],
  "a Scandinavian": ["Kqr","Kqq"],
  "a scanner": ["H58"],
  "a scar": ["H6B"],
  "a scarecrow": ["H59"],
  "a scarf": ["H6A"],
  "a schedule": ["H6C"],
  "a school": ["H6G"],
  "a school bag": ["H6D"],
  "a school bus": ["H6F"],
  "a school trip": ["H6H"],
  "a schoolbag": ["H6E"],
  "a science lab": ["H6I"],
  "a scientist": ["H6J"],
  "a scooter": ["H6K"],
  "a scorpion": ["H6L"],
  "a Scot": ["Kqs"],
  "a Scotsman": ["Kqt"],
  "a Scouser": ["Kqu"],
  "a screen": ["H6M"],
  "a screw": ["H6O"],
  "a screwdriver": ["H6N"],
  "a script": ["H6P"],
  "a sculpture": ["H6Q"],
  "a sea horse": ["H6S"],
  "a sea lion": ["H6U"],
  "a sea turtle": ["H6Y"],
  "a seagull": ["H6R"],
  "a seahorse": ["H6T"],
  "a seal": ["H6V"],
  "a seat": ["H6X"],
  "a seat belt": ["H6W"],
  "a secretary": ["H6Z"],
  "a security guard": ["H6a"],
  "a seed": ["H6b"],
  "a seesaw": ["H6c"],
  "a Senegalese": ["Kqv"],
  "a Serbian": ["Kqw"],
  "a shade": ["H6d"],
  "a shadow": ["H6e"],
  "a shark": ["H6f"],
  "a sharpener": ["H6g"],
  "a shed": ["H6h"],
  "a sheep": ["H6i"],
  "a sheet": ["H6j"],
  "a shelf": ["H6k"],
  "a shell": ["H6l"],
  "a shelter": ["H6m"],
  "a shield": ["H6n"],
  "a ship": ["H6o"],
  "a shirt": ["H6p"],
  "a shoe": ["H6q"],
  "a shoe shop": ["H6r"],
  "a shoe store": ["H6s"],
  "a shop": ["H6z"],
  "a shop assistant": ["H6t"],
  "a shopping cart": ["H6u"],
  "a shopping center": ["H6v"],
  "a shopping centre": ["H6w"],
  "a shopping list": ["H6x"],
  "a shopping mall": ["H6y"],
  "a shore": ["H60"],
  "a shoulder": ["H61"],
  "a shovel": ["H62"],
  "a shower": ["H63"],
  "a shrimp": ["H64"],
  "a sibling": ["H65"],
  "a sidewalk": ["H66"],
  "a sign": ["H67"],
  "a signpost": ["H68"],
  "a Sikh": ["Kqy","Kqx"],
  "a Singaporean": ["Kqz"],
  "a singer": ["H69"],
  "a sink": ["H7A"],
  "a sister": ["H7B"],
  "a skateboard": ["H7C"],
  "a skeleton": ["H7D"],
  "a sketch": ["H7E"],
  "a skirt": ["H7F"],
  "a skull": ["H7G"],
  "a skunk": ["H7H"],
  "a skyscraper": ["H7I"],
  "a sled": ["H7K"],
  "a sledge": ["H7J"],
  "a sleeping bag": ["H7L"],
  "a sleigh": ["H7M"],
  "a slice of": ["Fbr"],
  "a slice of pizza": ["Fbq"],
  "a slip": ["H7O"],
  "a slipper": ["H7N"],
  "a sloth": ["H7P"],
  "a Slovak": ["Kq0"],
  "a Slovene": ["Kq1"],
  "a smartphone": ["H7Q"],
  "a smoothie": ["H7R"],
  "a snack": ["H7S"],
  "a snail": ["H7T"],
  "a snake": ["H7U"],
  "a sneaker": ["H7V"],
  "a snow globe": ["H7Z"],
  "a snowball": ["H7X"],
  "a snowball fight": ["H7W"],
  "a snowflake": ["H7Y"],
  "a snowman": ["H7a"],
  "a snowstorm": ["H7b"],
  "a soccer ball": ["H7c"],
  "a soccer player": ["H7d"],
  "a sock": ["H7f"],
  "a socket": ["H7e"],
  "a soda": ["H7g"],
  "a sofa": ["Fbs"],
  "a soldier": ["H7h"],
  "a son": ["H7i"],
  "a South African": ["Kq2"],
  "a South American": ["Kq4","Kq3"],
  "a South Korean": ["Kq7"],
  "a Southerner": ["Kq6","Kq5"],
  "a souvenir": ["H7j"],
  "a space shuttle": ["H7m"],
  "a space station": ["H7n"],
  "a space suit": ["H7o"],
  "a spacecraft": ["H7k"],
  "a spaceship": ["H7l"],
  "a spade": ["H7p"],
  "a Spaniard": ["Kq8"],
  "a sparrow": ["H7q"],
  "a Spartan": ["Kq9"],
  "a spatula": ["H7r"],
  "a speaker": ["H7s"],
  "a spell": ["H7t"],
  "a sphere": ["H7u"],
  "a spider": ["H7v"],
  "a spider web": ["H7w"],
  "a spill": ["H7x"],
  "a splash": ["H7y"],
  "a sponge": ["H7z"],
  "a spoon": ["H70"],
  "a sport": ["H71"],
  "a sports center": ["H72"],
  "a sports centre": ["H73"],
  "a sports field": ["H74"],
  "a spray": ["H75"],
  "a spread": ["H76"],
  "a spring roll": ["H77"],
  "a spy": ["H78"],
  "a square": ["H79"],
  "a squash": ["H8A"],
  "a squirrel": ["H8B"],
  "a Sri Lankan": ["KrA"],
  "a stadium": ["H8C"],
  "a stage": ["H8D"],
  "a stair": ["H8E"],
  "a stamp": ["H8F"],
  "a stand": ["H8G"],
  "a stapler": ["H8H"],
  "a star": ["H8L"],
  "a star fish": ["H8I"],
  "a star fruit": ["H8K"],
  "a starfish": ["H8J"],
  "a station": ["H8M"],
  "a statue": ["H8N"],
  "a steak": ["H8O"],
  "a steal": ["IQw"],
  "a stew": ["H8P"],
  "a stick": ["H8R"],
  "a sticker": ["H8Q"],
  "a stingray": ["H8S"],
  "a stocking": ["H8T"],
  "a stomach": ["H8V"],
  "a stomach ache": ["H8U"],
  "a stone": ["H8W"],
  "a stool": ["H8X"],
  "a store": ["H8Y"],
  "a storm": ["H8Z"],
  "a storm in a teacup": ["IQy"],
  "a story": ["H8b"],
  "a storybook": ["H8a"],
  "a stove": ["H8c"],
  "a straw": ["H8e"],
  "a strawberry": ["H8d"],
  "a stream": ["H8f"],
  "a street": ["H8h"],
  "a street light": ["H8g"],
  "a stripe": ["H8i"],
  "a student": ["H8j"],
  "a studio": ["H8k"],
  "a submarine": ["H8l"],
  "a subway": ["H8m"],
  "a Sudanese": ["KrB"],
  "a suit": ["H8o"],
  "a suitcase": ["H8n"],
  "a sunflower": ["H8p"],
  "a sunrise": ["H8q"],
  "a sunset": ["H8r"],
  "a superhero": ["H8s"],
  "a supermarket": ["H8t"],
  "a surfboard": ["H8u"],
  "a surgeon": ["H8v"],
  "a surprise": ["H8w"],
  "a swamp": ["H8x"],
  "a swan": ["H8y"],
  "a sweater": ["H8z"],
  "a sweatshirt": ["H80"],
  "a Swede": ["KrC"],
  "a swimmer": ["H81"],
  "a swimming cap": ["H82"],
  "a swimming pool": ["H83"],
  "a swimsuit": ["H84"],
  "a swing": ["H85"],
  "a Swiss": ["KrD"],
  "a switch": ["H86"],
  "a sword": ["H88"],
  "a swordfish": ["H87"],
  "a t shirt": ["IAo"],
  "a table": ["Fb1"],
  "a tablecloth": ["H89"],
  "a tablespoon": ["H9A"],
  "a tablet": ["H9B"],
  "a taco": ["H9C"],
  "a tadpole": ["H9D"],
  "a tail": ["H9E"],
  "a Taiwanese": ["KrE"],
  "a tambourine": ["H9F"],
  "a tangerine": ["H9G"],
  "a tank": ["H9H"],
  "a tanktop": ["H9I"],
  "a Tanzanian": ["KrF"],
  "a tap": ["H9L"],
  "a tape": ["H9K"],
  "a tape measure": ["H9J"],
  "a taxi": ["H9N"],
  "a taxi driver": ["H9M"],
  "a tea set": ["H9S"],
  "a teacher": ["H9O"],
  "a team": ["H9P"],
  "a teapot": ["H9Q"],
  "a tear": ["H9R"],
  "a teaspoon": ["H9T"],
  "a technician": ["H9U"],
  "a teddy": ["H9V"],
  "a teddy bear": ["Fb2"],
  "a teenager": ["H9W"],
  "a telephone": ["H9X"],
  "a telescope": ["H9Y"],
  "a television": ["H9Z"],
  "a temple": ["H9a"],
  "a tennis ball": ["H9b"],
  "a tennis court": ["H9c"],
  "a tennis racket": ["H9d"],
  "a tent": ["H9e"],
  "a Texan": ["KrG"],
  "a text message": ["H9g"],
  "a textbook": ["H9f"],
  "a Thai": ["KrH"],
  "a theater": ["H9h"],
  "a theatre": ["H9i"],
  "a theme park": ["H9j"],
  "a thermometer": ["H9k"],
  "a thief": ["H9l"],
  "a thigh": ["H9m"],
  "a throne": ["H9n"],
  "a thumb": ["H9o"],
  "a thunderstorm": ["H9p"],
  "a tick": ["H9r"],
  "a ticket": ["H9q"],
  "a tie": ["H9s"],
  "a tiger": ["H9t"],
  "a timetable": ["H9u"],
  "a tin": ["H9v"],
  "a tin of": ["Fb4"],
  "a tire": ["H9w"],
  "a tissue": ["H9x"],
  "a toad": ["H9y"],
  "a toaster": ["H9z"],
  "a Tobagonian": ["KrI"],
  "a toe": ["H90"],
  "a toilet": ["H91"],
  "a tomato": ["H92"],
  "a tomb": ["H93"],
  "a tongue": ["H94"],
  "a tool": ["H96"],
  "a toolbox": ["H95"],
  "a tooth": ["H99"],
  "a toothache": ["H97"],
  "a toothbrush": ["H98"],
  "a torch": ["IAA"],
  "a tornado": ["IAB"],
  "a tortoise": ["IAC"],
  "a toucan": ["IAD"],
  "a tour": ["IAG"],
  "a tour guide": ["IAE"],
  "a tourist": ["IAF"],
  "a towel": ["IAH"],
  "a tower": ["IAI"],
  "a town": ["IAK"],
  "a town hall": ["IAJ"],
  "a town square": ["IAL"],
  "a toy": ["IAO"],
  "a toy box": ["IAM"],
  "a toy car": ["IAN"],
  "a toy shop": ["IAP"],
  "a toy soldier": ["IAQ"],
  "a toy store": ["IAR"],
  "a toy train": ["IAS"],
  "a track": ["IAT"],
  "a tracksuit": ["IAU"],
  "a tractor": ["IAV"],
  "a trail": ["IAW"],
  "a train": ["IAY"],
  "a train station": ["IAZ"],
  "a trainer": ["IAX"],
  "a tram": ["IAa"],
  "a trampoline": ["IAb"],
  "a trap": ["IAc"],
  "a trash can": ["IAd"],
  "a tray": ["IAe"],
  "a tree": ["Fb9"],
  "a tree house": ["IAf"],
  "a triangle": ["IAg"],
  "a Trinidadian": ["KrJ"],
  "a trip": ["IAh"],
  "a trolley": ["IAi"],
  "a trophy": ["IAj"],
  "a truck": ["IAl"],
  "a truck driver": ["IAk"],
  "a trumpet": ["IAm"],
  "a trunk": ["IAn"],
  "a tshirt": ["IAp"],
  "a tsunami": ["IAq"],
  "a tub": ["IAs"],
  "a tube": ["IAr"],
  "a tulip": ["IAt"],
  "a tunnel": ["IAu"],
  "a Turk": ["KrK"],
  "a turtle": ["IAv"],
  "a tutor": ["IAw"],
  "a TV": ["IAx"],
  "a twig": ["IAy"],
  "a typhoon": ["IAz"],
  "a Ukrainian": ["KrL"],
  "a unicorn": ["IA0"],
  "a uniform": ["IA1"],
  "a university": ["IA2"],
  "a USB stick": ["IA3"],
  "a vacation": ["IA4"],
  "a vacuum": ["IA5"],
  "a valley": ["IA6"],
  "a vampire": ["IA7"],
  "a van": ["IA8"],
  "a vase": ["IA9"],
  "a vegetable": ["IBA"],
  "a Venezuelan": ["KrM"],
  "a vest": ["IBB"],
  "a vet": ["IBD"],
  "a veterinarian": ["IBC"],
  "a Vietnamese": ["KrN"],
  "a Viking": ["KrO"],
  "a village": ["IBE"],
  "a violin": ["IBF"],
  "a volcano": ["IBG"],
  "a vulture": ["IBH"],
  "a wagon": ["IBI"],
  "a waiter": ["IBJ"],
  "a waitress": ["IBK"],
  "a wall": ["IBM"],
  "a wallet": ["IBL"],
  "a walrus": ["IBN"],
  "a wardrobe": ["IBO"],
  "a washbasin": ["IBP"],
  "a washing machine": ["IBQ"],
  "a wasp": ["IBR"],
  "a watch": ["IBS"],
  "a water bottle": ["IBT"],
  "a water park": ["IBX"],
  "a waterfall": ["IBU"],
  "a watering can": ["IBV"],
  "a watermelon": ["IBW"],
  "a wave": ["IBY"],
  "a web": ["IBa"],
  "a webcam": ["IBZ"],
  "a wedding": ["IBb"],
  "a weed": ["IBc"],
  "a Welshman": ["KrP"],
  "a werewolf": ["IBd"],
  "a westerner": ["KrQ"],
  "a whale": ["IBe"],
  "a wheel": ["IBg"],
  "a wheelchair": ["IBf"],
  "a whisk": ["IBi"],
  "a whisker": ["IBh"],
  "a whisper": ["IBj"],
  "a whistle": ["IBk"],
  "a whiteboard": ["IBl"],
  "a wife": ["IBm"],
  "a wig": ["IBn"],
  "a windmill": ["IBo"],
  "a window": ["FcS"],
  "a wing": ["IBp"],
  "a winner": ["IBq"],
  "a wire": ["IBr"],
  "a witch": ["IBs"],
  "a wizard": ["IBt"],
  "a wolf": ["IBu"],
  "a woman": ["IBv"],
  "a word": ["IBw"],
  "a worm": ["IBx"],
  "a wreath": ["IBy"],
  "a wrench": ["IBz"],
  "a wrist": ["IB0"],
  "a writer": ["IB1"],
  "a X ray": ["IB2"],
  "a xylophone": ["IB3"],
  "a yacht": ["IB4"],
  "a yak": ["IB5"],
  "a yam": ["IB6"],
  "a Yank": ["KrU","KrR"],
  "a Yankee": ["KrT","KrS"],
  "a yard": ["IB7"],
  "a yarn": ["IB8"],
  "a yo yo": ["ICA"],
  "a yogurt": ["IB9"],
  "a Zambian": ["KrV"],
  "a zebra": ["ICC"],
  "a zebra crossing": ["ICB"],
  "a Zimbabwean": ["KrW"],
  "a zip": ["ICE"],
  "a zipper": ["ICD"],
  "a zombie": ["ICF"],
  "a zoo": ["ICH"],
  "a zookeeper": ["ICG"],
  "a zucchini": ["ICI"],
  "a Zulu": ["KrX"],
  "a1": ["HFe"],
  "a2": ["HFf"],
  "aback": ["JnL"],
  "abandon": ["IKx"],
  "abandonment": ["JnM"],
  "abate": ["IKy"],
  "abbey": ["IKz"],
  "abbreviate": ["IK0"],
  "abbreviation": ["JnN"],
  "abdicate": ["FZH","AAA"],
  "abdomen": ["JnO"],
  "abdominal": ["JnP"],
  "abe": ["FZJ","AAB"],
  "aberrant": ["IK1"],
  "abhor": ["IK2"],
  "abide": ["IK4"],
  "abide by": ["IK3"],
  "abiding": ["IK5"],
  "ability": ["IK6"],
  "ablaze": ["IK7"],
  "able": ["IK8"],
  "abnormal": ["IK9"],
  "abnormality": ["JnQ"],
  "aboard": ["FZL","DRR"],
  "abolish": ["ILA"],
  "abolition": ["ILB"],
  "abominable": ["ILC"],
  "aboriginal": ["FZO","AAD","AAC"],
  "aborigine": ["ILD"],
  "Aborigine": ["KpI"],
  "abort": ["ILF"],
  "abortion": ["JnR"],
  "abortive": ["ILE"],
  "abound": ["ILG"],
  "about": ["FZQ","AAE"],
  "above": ["GKb","DdC","E5h","AAF"],
  "above all": ["ILH"],
  "above zero": ["HFg"],
  "Abraham Lincoln": ["JnS"],
  "abrasion": ["ILI"],
  "abreast": ["ILJ"],
  "abridge": ["ILK"],
  "abroad": ["GKc","Dob"],
  "abrupt": ["ILL"],
  "abruptly": ["JnT"],
  "absence": ["ILM"],
  "absent": ["ILO"],
  "absentee": ["JnU"],
  "absenteeism": ["ILN"],
  "absolute": ["ILP"],
  "absolutely": ["HFh"],
  "absolve": ["ILQ"],
  "absorb": ["ILR"],
  "absorption": ["ILS"],
  "abstract": ["FZS","AAI","AAG"],
  "abstraction": ["JnV"],
  "absurd": ["ILT"],
  "Abu Dhabi": ["AAJ","AAL"],
  "abundance": ["JnW"],
  "abundant": ["ILU"],
  "abuse": ["FZT","AAN","AAM"],
  "abusive": ["JnX"],
  "abut": ["ILV"],
  "abysmal": ["ILW"],
  "acacia tree": ["FZU","AAO","AAP"],
  "academic": ["ILX"],
  "academy": ["FZV","DRS","AAQ"],
  "accede": ["ILY"],
  "accelerate": ["FZa","DRT","AAS"],
  "acceleration": ["AAT"],
  "accelerator": ["JnY"],
  "accent": ["HFi"],
  "accentuate": ["JnZ"],
  "accept": ["FZb","DRU","AAX","AAU","AAV","AAW"],
  "accept the consequences of": ["ILZ"],
  "acceptable": ["Jna"],
  "acceptance": ["Jnb"],
  "access": ["ILc"],
  "accessibility": ["Jnc"],
  "accessible": ["ILa"],
  "accession": ["Jnd"],
  "accessory": ["ILb"],
  "accident": ["GKd","AAY","E5i","AAZ","DRV","AAa"],
  "accidental": ["Jnf"],
  "accidentally": ["Jne"],
  "acclaim": ["ILd"],
  "accommodate": ["ILe"],
  "accommodation": ["FZd","DRW","FZc","AAb","AAc"],
  "accompaniment": ["Jng"],
  "accompany": ["ILf"],
  "accomplish": ["FZe","AAh","AAg"],
  "accomplishment": ["ILg"],
  "accord": ["ILi"],
  "accordance": ["Jnh"],
  "according to": ["FZf","AAi"],
  "accordingly": ["ILh"],
  "accordion": ["FZg","AAj","AAk","AAl","C4b"],
  "account": ["FZh","AAr","AAm","AAn"],
  "account for": ["ILj"],
  "accountability": ["Jni"],
  "accountable": ["Jnj"],
  "accountancy": ["Jnk"],
  "accountant": ["GKe","C4d","E5j","C4c","AAq","AAo","AAp","D8G","D8H"],
  "accounting": ["ILk"],
  "accredit": ["ILl"],
  "accrue": ["Jnl"],
  "accumulate": ["DRX","AAt","AAs"],
  "accumulation": ["Jnm"],
  "accuracy": ["ILm"],
  "accurate": ["FZi","AAv","AAw"],
  "accurately": ["Jnn"],
  "accusation": ["Jno"],
  "accuse": ["DRZ"],
  "accuse someone of": ["ILn"],
  "accustom": ["ILp"],
  "accustomed": ["ILo"],
  "ace": ["Jnp"],
  "ache": ["ILr"],
  "ache for": ["ILq"],
  "achieve": ["GKf","AA2","AA5","AA0","AA1"],
  "achievement": ["FZk","AA4","AA3"],
  "Achilles": ["HFj"],
  "acid": ["HFk"],
  "acid rain": ["AA6"],
  "acidity": ["ILs"],
  "acknowledge": ["ILt"],
  "acknowledgement": ["Jnq"],
  "acknowledgment": ["Jnr"],
  "acorn": ["GKg","AA8","E5k"],
  "acorns": ["ABB"],
  "acoustic": ["ILv"],
  "acoustics": ["ABC"],
  "acquaint": ["ILw"],
  "acquaintance": ["Jns"],
  "acquiesce": ["ILx"],
  "acquire": ["ILz"],
  "acquire a taste for": ["ILy"],
  "acquisition": ["IL0"],
  "acquisitiveness": ["IL1"],
  "acquit": ["IL2"],
  "acre": ["Jnt"],
  "acrobat": ["FZo","ABK","DRb","ABE","ABH","ABF"],
  "acrobatics": ["FZn","ABJ"],
  "acronym": ["IL3"],
  "Acropolis": ["HFl"],
  "acrosome": ["Jnu"],
  "across": ["GKh","ABL"],
  "act": ["FZr","Exo"],
  "act as": ["IL4"],
  "act out": ["IL5"],
  "act up": ["IL7"],
  "acting": ["FZp","Exn"],
  "action": ["GKj","ABM","E5l","ABQ"],
  "action figure": ["GKi","ABN"],
  "action film": ["FZq","ABO","ABP"],
  "activate": ["ABR"],
  "activation": ["Jnv"],
  "active": ["GKk","ABT","E5m","ABS"],
  "actively": ["Jnw"],
  "activism": ["Jnx"],
  "activist": ["Jny"],
  "activity": ["Jnz"],
  "actor": ["GKl","ABX","ABW","ABU","ABV"],
  "actress": ["GKm","ABb","E5n","ABa","ABY","ABZ"],
  "actual": ["IL6"],
  "actually": ["G6Z"],
  "acumen": ["IL8"],
  "acute": ["DRc"],
  "acutely": ["Jn0"],
  "ad": ["JoI"],
  "adamant": ["IL9"],
  "adapt": ["HFm"],
  "adaptable": ["IMA"],
  "adaptation": ["Jn1"],
  "adapter": ["Jn2"],
  "adaptive": ["IMB"],
  "add": ["GKn","Dei","E5o","Eaa","Dej"],
  "add added": ["ESW","Dei","Dej"],
  "add on": ["IME"],
  "add sugar": ["FZv","Dej","Eaa"],
  "add the numbers": ["HFn"],
  "add to": ["IMF"],
  "add up": ["IMG"],
  "added": ["ESW"],
  "added sugar": ["ESW"],
  "addict": ["IMC"],
  "addiction": ["FZt","DRd","ABf"],
  "addictive": ["ABg"],
  "adding": ["Eaa","Dei","Dej"],
  "adding sugar": ["Eaa","Dej"],
  "addition": ["FZu","ABk","ABi","ABj"],
  "additional": ["Jn4"],
  "additionally": ["Jn3"],
  "additive": ["IMD"],
  "address": ["GKo","DRe","ABn","ABm"],
  "adept": ["IMH"],
  "adequacy": ["Jn5"],
  "adequate": ["IMI"],
  "adequately": ["Jn6"],
  "adhere": ["IMJ"],
  "adherence": ["Jn7"],
  "adhesion": ["Jn8"],
  "adhesive": ["IMK"],
  "adjacent": ["IML"],
  "adjective": ["Jn9"],
  "adjectives": ["FZx","ABo"],
  "adjoin": ["IMN"],
  "adjoining": ["IMM"],
  "adjourn": ["JoA"],
  "adjunct": ["IMO"],
  "adjust": ["IMP"],
  "adjustable": ["JoB"],
  "adjustment": ["JoC"],
  "administer": ["IMQ"],
  "administration": ["IMR"],
  "administrative": ["ABr","ABq"],
  "administrator": ["IMS"],
  "admirable": ["JoD"],
  "admiral": ["IMT"],
  "admiration": ["IMU"],
  "admire": ["FZy","ABt","ABs"],
  "admirer": ["JoE"],
  "admission": ["IMV"],
  "admit": ["IMW"],
  "admittedly": ["JoF"],
  "admonish": ["IMX"],
  "adobe": ["IMY"],
  "adolescence": ["IMZ"],
  "adolescent": ["HFo"],
  "adopt": ["FZ1","ABx","ABv","ABw"],
  "adoption": ["JoG"],
  "adore": ["JoH"],
  "adorn": ["IMa"],
  "Adriatic": ["JoJ"],
  "Adriatic Sea": ["JoK"],
  "adroit": ["IMb"],
  "adult": ["GKp","DRf","AB0","ABy","ABz"],
  "adultery": ["JoL"],
  "adulthood": ["JoM"],
  "advance": ["FZ2","AB2","AB1"],
  "advanced": ["HFp"],
  "advancement": ["JoN"],
  "advantage": ["IMd"],
  "advantageous": ["IMc"],
  "advent": ["IMf"],
  "adventitious": ["IMe"],
  "adventure": ["GKq","DRg","E5p","AB4","AB5","AB3"],
  "adventurer": ["JoO"],
  "adventurous": ["FZ3"],
  "adverb": ["JoP"],
  "adversary": ["IMg"],
  "adverse": ["IMh"],
  "adversely": ["JoQ"],
  "adversity": ["JoR"],
  "advert": ["FZ6","Exp"],
  "advertise": ["FZ5","Dek"],
  "advertise advertised": ["EUm","Dek"],
  "advertise burgers": ["Dek"],
  "advertised": ["EUm"],
  "advertised hamburgers": ["EUm"],
  "advertisement": ["FZ4","AB6","AB8"],
  "advertiser": ["JoS"],
  "advertising": ["Dek"],
  "advertising burgers": ["Dek"],
  "advice": ["FZ7"],
  "advisable": ["IMi"],
  "advise": ["IMk"],
  "advise against": ["IMj"],
  "adviser": ["JoT"],
  "advisor": ["JoU"],
  "advisory": ["IMl"],
  "advocacy": ["IMm"],
  "advocate": ["IMn"],
  "Aegean": ["JoV"],
  "Aegean Sea": ["JoW"],
  "aerial": ["IMo"],
  "aerobic": ["JoX"],
  "aerobics": ["FZ8","AB9"],
  "aeroplane": ["GKr","ACE","ACA","ACC","ACD","ACB"],
  "aerospace engineer": ["C4e","C4f"],
  "aesthetic": ["IMp"],
  "affable": ["IMr"],
  "affair": ["FZ9"],
  "affect": ["FaB","ACK","ACG"],
  "affection": ["IMs","FaA","DRh","ACH","ACI"],
  "affectionate": ["JoY"],
  "affective": ["JoZ"],
  "affidavit": ["Joa"],
  "affiliate": ["IMt"],
  "affiliation": ["Job"],
  "affinity": ["IMu"],
  "affirm": ["IMv"],
  "affirmative": ["Joc"],
  "affix": ["Jod"],
  "afflict": ["IMx"],
  "afflicted": ["IMw"],
  "affluent": ["IMy"],
  "afford": ["FaC","DRi","ACL"],
  "affordable": ["Joe"],
  "Afghan": ["HBU","KpJ","G6b"],
  "Afghanistan": ["FaD","ACM","D8L"],
  "afloat": ["IMz"],
  "aforementioned": ["Jof"],
  "afoul": ["IM0"],
  "afraid": ["GKs","ACR","E5q","ACQ","ACP"],
  "Africa": ["GKt","ACV","E5r","ACS","ACT","ACU"],
  "African": ["HBV","KpK"],
  "Africans": ["Krb"],
  "after": ["Exq"],
  "after all": ["IM1"],
  "after you": ["HFq"],
  "aftermath": ["IM2"],
  "afternoon": ["GKu","FaE","ACW","E5s"],
  "aftershock": ["IM3"],
  "afterward": ["Jog"],
  "afterwards": ["Exr"],
  "again": ["GKv","ACY","ACX"],
  "again and again": ["IM4"],
  "against": ["FaF","DRj","ACZ","ACa"],
  "age": ["GKw","DRk","ACb"],
  "ageism": ["IM5"],
  "agency": ["IM6"],
  "agenda": ["IM7"],
  "agent": ["Joh"],
  "aggravate": ["IM8"],
  "aggravated": ["DRl"],
  "aggregate": ["IM9"],
  "aggregation": ["Joi"],
  "aggression": ["INA"],
  "aggressive": ["INB"],
  "aggressively": ["Joj"],
  "agile": ["INC"],
  "agitate": ["IND"],
  "agitation": ["Jok"],
  "ago": ["INF"],
  "agonize": ["INE"],
  "agony": ["DRm","ACf","ACe"],
  "agree": ["GKx","ACg","DRo","ACi","ACm","ACh"],
  "agree on": ["INH"],
  "agree to": ["INI"],
  "agree with": ["INJ"],
  "agreeable": ["ING"],
  "agreement": ["FaH","ACk","ACl"],
  "agricultural": ["Jol"],
  "agriculture": ["INK"],
  "ahead": ["INL"],
  "AI": ["HFr"],
  "aid": ["INM"],
  "aide": ["Jom"],
  "ail": ["INO"],
  "ailment": ["INN"],
  "aim": ["FaK","DRp","ACo","ACp","ACq"],
  "aim at": ["INP"],
  "air": ["GK0","AC3","E5v","ACr","EdE","ACs"],
  "air conditioner": ["GKy","C4g","E5t","ACt","ACx","DwI","ACv","ACu","ACw"],
  "Air Force": ["HFs"],
  "air out": ["INR"],
  "air pollution": ["FaL","AC6","AC5","C4h","AC8","C4i"],
  "air quality": ["HFt"],
  "air resistance": ["HFu"],
  "airborne": ["Exs"],
  "aircraft": ["INQ"],
  "airfield": ["Jon"],
  "airline": ["Joo"],
  "airmail": ["Ext"],
  "airplane": ["GKz","AC2","E5u","AC1","ACy","AC0","ACz"],
  "airport": ["GK1","C4j","E5w","ADC","ADF","ADB","ADD","DwJ","ADE","AC9","ADA"],
  "airport terminal": ["FaM","ADG","ADH"],
  "airtight": ["Exu"],
  "airway": ["INS"],
  "airy": ["Jop"],
  "aisle": ["FaN","ADJ"],
  "akin": ["Joq"],
  "aladdin": ["FaQ","ADM","ADK"],
  "alarm": ["GK3","ADN","ADP","ADT"],
  "alarm clock": ["GK2","C4k","ADQ","DwK","ADS","ADR"],
  "alas": ["INT"],
  "Alaska": ["Jor"],
  "Albania": ["HBX","D8P"],
  "Albanian": ["HBW","KpL"],
  "albatross": ["ADV"],
  "albeit": ["Jos"],
  "Albert Einstein": ["Jou","ADX"],
  "Alberta": ["Jot"],
  "album": ["Exv"],
  "albumin": ["Jov"],
  "alchemist": ["INU"],
  "alcohol": ["FaR","ADb","ADc","ADZ","ADa","DRq"],
  "alcoholic": ["Jow"],
  "alcoholism": ["Jox"],
  "ale": ["Joy"],
  "alert": ["INV"],
  "Alexander the Great": ["Joz"],
  "Alexandria": ["HFv"],
  "alga": ["INW"],
  "algebra": ["INX"],
  "algebraic": ["Jo0"],
  "Algeria": ["HBZ","D8Q"],
  "Algerian": ["HBY","KpM"],
  "algorithm": ["Jo1"],
  "alien": ["GK4","ADg","E5x","DRr","ADd","ADe","ADf"],
  "alienable": ["INY"],
  "alienate": ["INZ"],
  "alienation": ["Jo2"],
  "aliens": ["FaS","DRs"],
  "alight": ["Jo3"],
  "align": ["INa"],
  "alignment": ["Jo4"],
  "alike": ["INb"],
  "alive": ["INc"],
  "alkali": ["HFw"],
  "all": ["GK6","ADx","ADh"],
  "all along": ["INd"],
  "all in all": ["INj"],
  "all of a sudden": ["INl"],
  "all over": ["HFx"],
  "all over the world": ["INn"],
  "all the best": ["HFy"],
  "all the rage": ["INq"],
  "all the time": ["INr"],
  "all the way": ["INs"],
  "allay": ["INe"],
  "allegation": ["Jo5"],
  "allege": ["INf"],
  "allegedly": ["Jo6"],
  "allegiance": ["INg"],
  "allele": ["Jo7"],
  "allergic": ["FaT","ADj","ADi","DRt"],
  "allergies": ["FaU","DRu","ADl"],
  "allergy": ["FaV","ADn","ADm"],
  "alleviate": ["INh"],
  "alley": ["FaW"],
  "alliance": ["INi"],
  "alligator": ["GK5","ADo","E5y","ADq","ADr","ADp"],
  "allocate": ["INk"],
  "allocation": ["Jo8"],
  "allot": ["INm"],
  "allotment": ["Jo9"],
  "allow": ["FaX","ADw","ADs","ADu"],
  "allow for": ["INo"],
  "allowance": ["JpA"],
  "alloy": ["INp"],
  "allude": ["INt"],
  "allure": ["INu"],
  "allusion": ["JpB"],
  "ally": ["INv"],
  "almighty": ["INw"],
  "almond": ["JpC"],
  "almost": ["JpD"],
  "almost ready": ["HFz"],
  "aloft": ["INx"],
  "alone": ["GK7","DRv","ADy","ADz"],
  "along": ["GK8","DRw"],
  "alongside": ["INy"],
  "aloof": ["IN0"],
  "aloud": ["FaZ","DRx","AD0"],
  "alpaca": ["Faa","AD4","AD2","AD3"],
  "alpha": ["Doc"],
  "alphabet": ["GK9","DRy","E5z","AD6","AD5"],
  "alpine": ["JpE"],
  "Alps": ["JpF"],
  "already": ["IN1"],
  "alright": ["JpG"],
  "also": ["JpH"],
  "altar": ["IN2"],
  "alter": ["IN5"],
  "alteration": ["JpI"],
  "alternate": ["IN3"],
  "alternative": ["IN4"],
  "alternative energy": ["AD8"],
  "alternatively": ["JpJ"],
  "although": ["G6e"],
  "altitude": ["Fab","DR0","AEB"],
  "alto": ["Fac"],
  "altogether": ["IN6"],
  "altruistic": ["IN7"],
  "aluminium": ["HF0"],
  "aluminum": ["HF1"],
  "alumnus": ["IN8"],
  "always": ["GLA","AEC"],
  "am": ["Exy"],
  "amalgamate": ["IN9"],
  "amalgamation": ["IOA"],
  "amass": ["IOB"],
  "Amaterasu": ["HF2"],
  "amateur": ["IOC"],
  "amaze": ["Fae","DR1","AED"],
  "amazed": ["Fad"],
  "amazement": ["JpK"],
  "amazing": ["GLB","DR2","E50","AEF","AEE"],
  "amazingly": ["JpL"],
  "amazon": ["Faf","AEJ","AEH"],
  "Amazon": ["JpM"],
  "Amazon Rainforest": ["HF3"],
  "Amazon River": ["JpN"],
  "ambassador": ["Fag","AEK"],
  "amber": ["Fah","AEN"],
  "ambience": ["IOE"],
  "ambient": ["IOF"],
  "ambiguity": ["IOG"],
  "ambiguous": ["IOH"],
  "ambition": ["JpO"],
  "ambitious": ["GLC","AEO"],
  "ambivalence": ["JpP"],
  "ambivalent": ["IOI"],
  "amble": ["IOJ"],
  "ambulance": ["GLD","C4m","E51","AEP","DwL","AES","AEQ"],
  "ambush": ["AEU"],
  "amenable": ["IOK"],
  "amend": ["IOL"],
  "amendment": ["JpQ"],
  "amenity": ["IOM"],
  "America": ["GLG","AEp","E53","C4p","AEY","AEZ","AEV","DwN","AEX","EPk"],
  "American": ["GLF","KpN","KpO","C4o","E52","EeD","AEo","AEb","AEa"],
  "American flag": ["Fai","AEc"],
  "American football": ["GLE","C4n","DwM","AEi","AEd","AEe","AEf","AEg","AEh"],
  "American Southwest": ["JpR"],
  "americano": ["EgS","AEn","AEj","AEk"],
  "americano iced": ["AEl"],
  "Americans": ["Krd","Krc"],
  "Americas": ["JpS"],
  "amiable": ["ION"],
  "amid": ["IOO"],
  "amidst": ["JpT"],
  "amino": ["IOP"],
  "ammonia": ["HF4"],
  "ammunition": ["HF5"],
  "amnesty": ["IOQ"],
  "among": ["Faj","AEq"],
  "among us": ["AEr"],
  "amongst": ["JpU"],
  "amount": ["IOR"],
  "amount to": ["IOS"],
  "amp": ["JpX"],
  "amphibian": ["GLH","C4q"],
  "amphibious": ["IOT"],
  "ample": ["IOU"],
  "amplification": ["JpV"],
  "amplifier": ["JpW"],
  "amplify": ["IOV"],
  "amplitude": ["AEs"],
  "Amsterdam": ["G6f","AEw"],
  "amuse": ["IOW"],
  "amusement": ["Fak","DR4","AEx","AEz","AEy"],
  "amusement park": ["GLI","AE1","E54","AE2","DR3","AE0"],
  "amusing": ["Fal","DR5","AE4"],
  "an Aborigine": ["KpI"],
  "an accident": ["H0A"],
  "an account": ["H0C"],
  "an accountant": ["H0B"],
  "an acorn": ["H0D"],
  "an acrobat": ["H0E"],
  "an action": ["H0H"],
  "an action figure": ["H0F"],
  "an action film": ["H0G"],
  "an actor": ["H0I"],
  "an actress": ["H0J"],
  "an advertisement": ["H0K"],
  "an aeroplane": ["H0L"],
  "an Afghan": ["KpJ"],
  "an African": ["KpK"],
  "an air conditioner": ["H0M"],
  "an airplane": ["H0N"],
  "an airport": ["H0O"],
  "an aisle": ["H0P"],
  "an alarm": ["H0R"],
  "an alarm clock": ["H0Q"],
  "an Albanian": ["KpL"],
  "an Algerian": ["KpM"],
  "an alien": ["H0S"],
  "an alligator": ["H0T"],
  "an ambulance": ["H0U"],
  "an American": ["KpO","KpN"],
  "an amphibian": ["H0V"],
  "an amusement park": ["H0W"],
  "an anchor": ["H0X"],
  "an Andorran": ["KpQ"],
  "an angel": ["H0Y"],
  "an Anglo": ["KpS","KpR"],
  "an Anglo Saxon": ["KpT"],
  "an Angolan": ["KpU"],
  "an ant": ["H0b"],
  "an antelope": ["H0Z"],
  "an antenna": ["H0a"],
  "an apartment": ["H0d"],
  "an apartment block": ["H0c"],
  "an ape": ["H0e"],
  "an app": ["H0k"],
  "an appetizer": ["H0g"],
  "an apple": ["Fan"],
  "an apple a day keeps the doctor away": ["D8R"],
  "an apple pie": ["H0h"],
  "an application": ["H0i"],
  "an apricot": ["H0l"],
  "an apron": ["H0m"],
  "an aquarium": ["H0n"],
  "an Arab": ["KpX","KpV","KpW"],
  "an archaeologist": ["H0o"],
  "an architect": ["H0p"],
  "an Argentine": ["KpY"],
  "an argument": ["H0q"],
  "an arm": ["H0v"],
  "an arm chair": ["H0s"],
  "an armband": ["H0r"],
  "an armchair": ["H0t"],
  "an Armenian": ["KpZ"],
  "an armpit": ["H0u"],
  "an army": ["H0w"],
  "an arrow": ["H0x"],
  "an art gallery": ["H0y"],
  "an art room": ["H01"],
  "an article": ["H0z"],
  "an artist": ["H00"],
  "an Asian": ["Kpa"],
  "an aspirin": ["H02"],
  "an assignment": ["H03"],
  "an assistant": ["H04"],
  "an asteroid": ["H05"],
  "an astronaut": ["H06"],
  "an astronomer": ["H07"],
  "an Athenian": ["Kpb"],
  "an athlete": ["H08"],
  "an ATM": ["H09"],
  "an attic": ["H1A"],
  "an audience": ["H1B"],
  "an aunt": ["H1C"],
  "an Aussie": ["Kpe"],
  "an Australian": ["Kpf"],
  "an Austrian": ["Kpg"],
  "an author": ["H1D"],
  "an avalanche": ["H1E"],
  "an avocado": ["H1F"],
  "an axe": ["H1G"],
  "an Azerbaijani": ["Kpi"],
  "an Aztec": ["Kpj"],
  "an eagle": ["H1H"],
  "an ear": ["H1J"],
  "an earache": ["Fap","Dod"],
  "an earmuff": ["H1I"],
  "an earthquake": ["H1K"],
  "an Easter bunny": ["H1L"],
  "an Easter egg": ["H1M"],
  "an ecosystem": ["H1P"],
  "an Ecuadorian": ["Kpk"],
  "an eel": ["H1R"],
  "an egg": ["H1T"],
  "an eggplant": ["H1S"],
  "an Egyptian": ["Kpl"],
  "an elbow": ["H1X"],
  "an electrician": ["H1Y"],
  "an elephant": ["H1Z"],
  "an elevator": ["H1a"],
  "an elf": ["H1b"],
  "an emergency": ["H1c"],
  "an emigrant": ["Kpm"],
  "an Emirati": ["Kpn"],
  "an engine": ["H1d"],
  "an Englishman": ["Kpq","Kpo","Kpp"],
  "an entrance": ["H1e"],
  "an envelope": ["H1f"],
  "an eraser": ["Faq"],
  "an eruption": ["H1h"],
  "an escalator": ["H1i"],
  "an Estonian": ["Kps"],
  "an Ethiopian": ["Kpt"],
  "an EU citizen": ["Kpu"],
  "an exam": ["H1m"],
  "an exhibition": ["H1n"],
  "an exile": ["Kpy"],
  "an expat": ["Kpz"],
  "an expatriate": ["Kp0"],
  "an explorer": ["H1o"],
  "an eye": ["H1r"],
  "an eyebrow": ["H1p"],
  "an eyelash": ["H1q"],
  "an hour": ["H1s"],
  "an ice cream": ["H1u"],
  "an ice lolly": ["H1v"],
  "an ice rink": ["H1w"],
  "an ice skate": ["H1x"],
  "an iceberg": ["H1t"],
  "an Icelander": ["Kp2"],
  "an icicle": ["H1y"],
  "an ID": ["H10"],
  "an ID card": ["H1z"],
  "an igloo": ["H12"],
  "an iguana": ["H13"],
  "an immigrant": ["Kp4"],
  "an increase": ["H14"],
  "an Indian": ["Kp5"],
  "an Indonesian": ["Kp6"],
  "an ingredient": ["H15"],
  "an injury": ["H16"],
  "an insect": ["H17"],
  "an Inuit": ["Kp7"],
  "an inventor": ["H18"],
  "an Iranian": ["Kp8"],
  "an Irishman": ["Kp9"],
  "an iron": ["H19"],
  "an island": ["H2A"],
  "an Italian": ["KqA"],
  "an oar": ["H2B"],
  "an oasis": ["H2C"],
  "an obstacle": ["H2D"],
  "an ocean": ["H2E"],
  "an octagon": ["H2F"],
  "an octopus": ["H2G"],
  "an office": ["H2H"],
  "an office worker": ["H2I"],
  "an olive": ["H2K"],
  "an olive oil": ["H2J"],
  "an omelette": ["H2L"],
  "an onion": ["H2M"],
  "an opera": ["H2N"],
  "an orange": ["Fax"],
  "an orchard": ["H2O"],
  "an orchid": ["H2P"],
  "an order": ["H2Q"],
  "an ostrich": ["H2T"],
  "an otter": ["H2Y"],
  "an outlet": ["H2Z"],
  "an oven": ["H2a"],
  "an owl": ["H2b"],
  "an owner": ["H2c"],
  "an ox": ["H2d"],
  "an oyster": ["H2e"],
  "an Ozzie": ["KqH","KqG"],
  "an Ugandan": ["KqI"],
  "an umbrella": ["H2g"],
  "an umpire": ["H2h"],
  "an uncle": ["H2i"],
  "an Uruguayan": ["KqJ"],
  "an Uzbek": ["KqK"],
  "anaconda": ["Fam","AE5","AE7","AE8"],
  "analog": ["JpY"],
  "analogous": ["IOY"],
  "analogy": ["AFA"],
  "analysis": ["IOZ"],
  "analyst": ["JpZ"],
  "analytic": ["IOb"],
  "analytical": ["IOa"],
  "analyze": ["IOc"],
  "anarchist": ["IOd"],
  "Anatolia": ["Jpb"],
  "Anatolian": ["Jpa"],
  "anatomy": ["IOe"],
  "ancestor": ["Fao","AFD","AFB"],
  "ancestral": ["Jpc"],
  "ancestry": ["IOf"],
  "anchor": ["GLJ","AFF","AFE","AFG"],
  "anchorage": ["HF6"],
  "ancient": ["GLK","AFH","E55","AFJ","AFI"],
  "Ancient Egypt": ["HF7"],
  "Ancient Greece": ["HF8"],
  "Ancient Rome": ["HF9"],
  "Ancient Wonders": ["HGA"],
  "and": ["Ex0","Exz"],
  "and so on": ["IOg"],
  "and you": ["HGD"],
  "and you too": ["HGE"],
  "andean": ["Jpd"],
  "Andes": ["Jpe"],
  "Andorra": ["HBb","AFL"],
  "Andorran": ["HBa","KpQ"],
  "Andromeda": ["HGC"],
  "Andromeda Galaxy": ["HGB"],
  "anecdotal": ["IOh"],
  "anecdote": ["IOi"],
  "anemia": ["IOj"],
  "anesthetic": ["Jpf"],
  "anew": ["IOk"],
  "angel": ["GLL","DR7","E56","DR6","AFP","AFM","AFQ","AFN"],
  "anger": ["Far","DR8","AFS"],
  "angiosperm": ["IOl"],
  "Angkor Wat": ["HGF"],
  "angle": ["HGG"],
  "angler": ["Jpg"],
  "Anglo": ["KpS","KpR"],
  "Anglo Saxon": ["KpT"],
  "Angola": ["HBd","D8U"],
  "Angolan": ["HBc","KpU"],
  "angrily": ["ERR"],
  "angry": ["GLM","Fas","C4r","E57","DR9","D8V","AFT","AFV","AFU","AFX"],
  "angry girl": ["AFW"],
  "anguish": ["IOm"],
  "angular": ["IOn"],
  "animal": ["GLN","AFa","E58"],
  "animal crossing": ["Fat","AFY","AFZ"],
  "animal shelter": ["AFd","AFe"],
  "animals": ["GLO","AFb","E59","AFf","AFc"],
  "animate": ["IOo"],
  "animation": ["GLP","AFh","AFg"],
  "anime": ["Fau","AFj","AFi"],
  "ankle": ["GLQ","C4s","E6A","AFk","DwO"],
  "anklet": ["AFl"],
  "annex": ["IOp"],
  "anniversary": ["IOq"],
  "annotation": ["IOr"],
  "announce": ["IOs"],
  "announcement": ["Jph"],
  "announcer": ["Fav","DSA","AFo","AFm","AFn"],
  "annoy": ["Faw","DSC","AFt"],
  "annoyance": ["Jpi"],
  "annoyed": ["GLR","AFr","D8Z","C4t","AFq","DSB","AFp","AFs"],
  "annoying": ["Ex1"],
  "annual": ["Jpl","Ex2"],
  "annualize": ["Jpj"],
  "annually": ["Jpk"],
  "annuity": ["Jpm"],
  "annul": ["IOt"],
  "annum": ["Jpn"],
  "anomalous": ["IOu"],
  "anomaly": ["IOv"],
  "anomie": ["IOw"],
  "anon": ["Jpo"],
  "anonymity": ["Jpp"],
  "anonymous": ["IOx"],
  "another": ["Fay","AFu"],
  "answer": ["HGI","GLS","AFv","E6B","AFx","AFz","AFw"],
  "answer a question": ["HGH"],
  "answer back": ["IOy"],
  "answer the phone": ["HGJ"],
  "ant": ["GLU","AGO","E6C","C4u","AF1","DwP","AF2","AF0","AF3"],
  "antagonist": ["Jpq"],
  "Antarctica": ["GLT","AF7","AF6","AF4","AF5"],
  "antecede": ["IO0"],
  "antecedent": ["IOz"],
  "antelope": ["Faz","AF8","AGA","AF9"],
  "antenna": ["Fa0","AGB","AGD","AGC"],
  "anterior": ["Jpr"],
  "anthem": ["Fa1","AGF","AGE"],
  "anthology": ["Jps"],
  "anthrax": ["Jpt"],
  "anthropologist": ["Jpu"],
  "anthropology": ["IO1"],
  "anti": ["Jpy"],
  "anti social": ["IO5"],
  "antibiotic": ["IO2"],
  "antibody": ["HGK"],
  "anticipate": ["IO3"],
  "anticipation": ["Jpv"],
  "antidepressant": ["Jpw"],
  "antigen": ["Jpx"],
  "antigravity": ["HGL"],
  "antimatter": ["HGM"],
  "antique": ["IO4"],
  "antique shop": ["Fa2","AGG","AGI","AGH"],
  "antiquity": ["Jpz"],
  "antisocial": ["AGJ"],
  "antitrust": ["Jp0"],
  "antlers": ["Fa3","AGN","AGK"],
  "antonym": ["IO6"],
  "ants": ["Fa4","AGR","AGP","AGQ"],
  "anxiety": ["HGN"],
  "anxious": ["GLV","AGT","E6D","AGS"],
  "anxiously": ["Jp1"],
  "any": ["Jp3"],
  "anybody": ["G6g"],
  "anyhow": ["Jp2"],
  "anymore": ["IO7"],
  "anyone": ["G6h"],
  "anything": ["G6i"],
  "anything but": ["IO8"],
  "anytime": ["Jp4"],
  "anyway": ["Jp5"],
  "anywhere": ["G6j"],
  "apart": ["IPB"],
  "apart from": ["IPA"],
  "apartheid": ["Jp6"],
  "apartment": ["GLW","AGU","E6E","AGV","AGW"],
  "apartment block": ["Fa6","C4v","DwQ"],
  "apartment tower": ["Fa7"],
  "ape": ["FbB","AGb","AGX","AGa"],
  "Aphrodite": ["HGO"],
  "Apollo": ["HGP"],
  "apologetic": ["IPD"],
  "apologize": ["IPE"],
  "apology": ["IPF"],
  "apoptosis": ["Jp7"],
  "apostrophe": ["G6k"],
  "app": ["GLc","AHC","AGc","AGd"],
  "appall": ["IPH"],
  "appalling": ["IPG"],
  "apparatus": ["IPI"],
  "apparel": ["Jp8"],
  "apparent": ["IPJ"],
  "apparently": ["Jp9"],
  "apparition": ["AGe"],
  "appeal": ["IPK"],
  "appeal to": ["IPL"],
  "appear": ["FbF","Doe"],
  "appearance": ["JqA"],
  "appease": ["IPM"],
  "append": ["IPN"],
  "appendix": ["FbG","AGg"],
  "appetite": ["IPO"],
  "appetizers": ["FbH","AGi","AGj","AGh"],
  "appetizing": ["IPP"],
  "applaud": ["IPQ"],
  "applause": ["IPR"],
  "apple": ["GLa","AGk","C4x","AGx","AGl","DwS","AGn","AGp","AGm","AGo"],
  "apple juice": ["GLY","AGr","E6G","C4w","DwR","AGq","AGs"],
  "apple pie": ["GLZ","AGw","AGu","AGt"],
  "apple tea": ["AG4"],
  "apple tree": ["Ex3"],
  "apples": ["GLb","C4y","E6H","AG0","EgT","AGz","AG3","AGy"],
  "applesauce": ["AG2"],
  "appliance": ["FbI","AG7","AG5"],
  "applicability": ["JqB"],
  "applicable": ["IPS"],
  "applicant": ["IPT"],
  "application": ["FbJ","AG9","AG8","AHA","AHB"],
  "apply": ["IPV"],
  "apply for": ["IPU"],
  "appoint": ["IPX"],
  "appointment": ["IPW"],
  "apportion": ["IPZ"],
  "apportionment": ["IPY"],
  "appraisal": ["JqC"],
  "appraise": ["IPa"],
  "appreciate": ["FbK","AHD","DSD"],
  "appreciation": ["IPb"],
  "apprehend": ["IPc"],
  "apprehension": ["JqD"],
  "apprehensive": ["IPd"],
  "apprentice": ["DSE","AHF"],
  "apprenticeship": ["IPe"],
  "apprise": ["IPf"],
  "approach": ["FbL","AHH"],
  "appropriate": ["IPg"],
  "appropriately": ["JqE"],
  "appropriation": ["JqF"],
  "approval": ["JqG"],
  "approve": ["IPi"],
  "approve of": ["IPh"],
  "approximate": ["IPj"],
  "approximately": ["JqH"],
  "approximation": ["IPk"],
  "apricot": ["GLd","AHI","E6I","AHK","AHJ"],
  "April": ["GLe","Dof","E6J"],
  "apron": ["GLf","C4z","E6K","AHM","DwT","AHL"],
  "apt": ["JqI"],
  "aptitude": ["IPm"],
  "aquamarine": ["FbN","AHN"],
  "aquarium": ["GLg","AHP","E6L","AHO"],
  "Aquarius": ["HGQ"],
  "aquatic": ["IPn"],
  "aquifer": ["IPo"],
  "Arab": ["KpW","KpV","KpX","AHQ","AHT"],
  "arabesque": ["AHR"],
  "Arabian": ["JqK"],
  "Arabian Peninsula": ["JqJ"],
  "Arabic": ["HGR"],
  "arable": ["IPp"],
  "Arabs": ["Kre"],
  "arbitrary": ["IPq"],
  "arbitration": ["JqL"],
  "arboreal": ["IPr"],
  "arc": ["IPz"],
  "arcade": ["JqM"],
  "arcade game": ["FbO","DSF"],
  "arch": ["IPy"],
  "archaeological": ["JqN"],
  "archaeologist": ["GLh","DSG","AHY","AHW","AHV","AHX"],
  "archaeology": ["IPs"],
  "archaic": ["IPt"],
  "archbishop": ["JqO"],
  "archeological": ["IPu"],
  "archeologist": ["FbP","DSH"],
  "archeology": ["IPv"],
  "archer": ["IPw"],
  "archery": ["GLi","C40","E6M","DSI","AHb","AHZ","DwU","AHa"],
  "Archimedes": ["JqP"],
  "architect": ["GLj","C41","E6N","C42","AHf","D8a","AHc","AHe","AHd","D8b"],
  "architectural": ["JqQ"],
  "architecture": ["HGS"],
  "archival": ["JqR"],
  "archive": ["IPx"],
  "arctic": ["FbR","AHk","AHh"],
  "Arctic": ["JqT"],
  "arctic fox": ["FbQ","AHj","AHi"],
  "Arctic Ocean": ["JqS"],
  "ardent": ["IP0"],
  "arduous": ["IP1"],
  "are you a student": ["D8d"],
  "are you alright": ["HGU"],
  "are you angry": ["D8c"],
  "are you bored": ["D8e"],
  "are you certain": ["HGV"],
  "are you cold": ["D8f"],
  "are you ok": ["HGX"],
  "are you okay": ["HGW"],
  "are you sure": ["HGY"],
  "are you tired": ["D8g"],
  "area": ["IP2"],
  "arena": ["IP3"],
  "Ares": ["HGT"],
  "Argentina": ["GLk","AHo","E6O","C44","DwV","AHn","AHl"],
  "Argentina flag": ["C43"],
  "Argentine": ["HBg","KpY"],
  "Argentinean": ["HBf","AHp"],
  "Argentinian": ["FbS","C45","EeE"],
  "argon": ["HGZ"],
  "arguably": ["JqU"],
  "argue": ["GLl","Del","E6P","Dem","EWW","EdK"],
  "argue argued": ["Del","EUu","Dem"],
  "argue in a courtroom": ["D8i"],
  "argue with someone": ["EWW"],
  "argued": ["EUu"],
  "arguing": ["FbT","EdK","Dem","Del"],
  "argument": ["FbU","AHq","AHs","AHt","AHr"],
  "aria": ["IP4"],
  "arid": ["IP5"],
  "Aries": ["HGa"],
  "arise": ["IP6"],
  "aristocracy": ["IP7"],
  "aristocrat": ["IP9"],
  "aristocratic": ["IP8"],
  "Aristotle": ["JqV"],
  "arithmetic": ["IQA"],
  "Arizona": ["JqW"],
  "arm": ["GLp","C48","E6R","AH4","DwY","AHv","AHu"],
  "arm chair": ["GLn","AHz","AHx","AHy"],
  "arm wrestling": ["HGb"],
  "armbands": ["GLm","AHw"],
  "armchair": ["GLo","C46","E6Q","DwW"],
  "armed": ["IQB"],
  "Armenia": ["HBi","AH3","AH0"],
  "Armenian": ["HBh","KpZ"],
  "armor": ["IQC"],
  "armpit": ["FbV","C47","DwX"],
  "arms": ["GLq","C49","E6S","C5A","AH5"],
  "army": ["FbW","AH9","AH6","AH8","AH7"],
  "aroma": ["DSJ"],
  "around": ["GLr","AIF","E6T","AIE"],
  "arousal": ["JqX"],
  "arouse": ["IQD"],
  "arrange": ["FbZ","Den","EWX","AIK","AIG","AIH"],
  "arrange arranged": ["Den"],
  "arrange flowers": ["D8j","Den"],
  "arrange some flowers": ["EWX"],
  "arrangement": ["FbY","AIJ"],
  "arranging": ["Den"],
  "arranging flowers": ["Den"],
  "array": ["IQE"],
  "arrears": ["JqY"],
  "arrest": ["Fba","Deo","AIO","EWY","AIL"],
  "arrest arrested": ["Deo"],
  "arrest criminals": ["D8k"],
  "arrest someone": ["EWY","Deo"],
  "arrest someone for": ["IQF"],
  "arrested": ["AIN"],
  "arresting": ["Deo"],
  "arresting someone": ["Deo"],
  "arrival": ["GLs","AIP"],
  "arrive": ["GLt","Deq","E6U","Dep","EWZ"],
  "arrive arrived": ["Fbb","Dep","Deq"],
  "arrive at": ["IQG"],
  "arrive at the station": ["Fbc","Dep","EWZ"],
  "arrive in": ["IQG"],
  "arrived": ["Fbd","DSK"],
  "arriving": ["Dep","Deq"],
  "arriving at the station": ["Dep"],
  "arrogance": ["DSL","AIR","AIQ"],
  "arrogant": ["Fbe","DSM","AIT","AIS"],
  "arrow": ["GLu","AIY","E6V","AIW","AIX","AIU","DSN"],
  "arse": ["Jqa"],
  "arsenal": ["JqZ"],
  "art": ["GLx","C5D","E6Y","AIZ","Dwa","AIb","AIu","AIa"],
  "art class": ["Fbf","Ex4"],
  "art gallery": ["GLv","AIg","E6W","AIe","AIf"],
  "art room": ["GLy","Dog","E6Z"],
  "Artemis": ["HGc"],
  "arterial": ["Jqb"],
  "artery": ["AId"],
  "artesian": ["IQH"],
  "arthritis": ["IQI"],
  "artichoke": ["Fbg","AIj","AIi","AIh"],
  "article": ["Fbh","AIm","AIk","AIl"],
  "articles": ["Fbi","AIn"],
  "articulate": ["IQJ"],
  "articulation": ["Jqc"],
  "artifact": ["IQK"],
  "artifice": ["IQL"],
  "artificial": ["IQM"],
  "artificially": ["Jqd"],
  "artillery": ["Jqe"],
  "artisan": ["IQN"],
  "artist": ["GLw","C5C","E6X","DSP","D8l","C5B","AIt","D8m","AIq","AIo","AIp"],
  "artistic": ["Fbj","DSO"],
  "artwork": ["Fbk","AIw","AIx"],
  "as": ["Jqh"],
  "as a matter of fact": ["IQO"],
  "as a result": ["IQP"],
  "as a rule": ["IQQ"],
  "as far as": ["IQU"],
  "as for": ["IQV"],
  "as hard as nails": ["D8n","D8o","D8p"],
  "as if": ["IQZ"],
  "as long as": ["G6l"],
  "as of yet": ["IQd"],
  "as old as the hills": ["D8q","D8r","D8s"],
  "as soon as": ["IQr"],
  "as to": ["IQx"],
  "as usual": ["AKK","AKL"],
  "as well as": ["G6n"],
  "as white as snow": ["D8w","D8x","D8y"],
  "ascend": ["IQR"],
  "ascent": ["Jqf"],
  "ascertain": ["IQS"],
  "ascribe": ["IQT"],
  "ash": ["IQX"],
  "ashamed": ["GLz","AI0","AI2","AIz"],
  "ashma": ["DSQ"],
  "ashore": ["IQW"],
  "Asia": ["GL0","AI8","AI9","AI3","AI4"],
  "Asian": ["HBj","Kpa"],
  "Asian Mythology": ["HGd"],
  "Asians": ["Krg","Krf"],
  "asiatic lion": ["AJA"],
  "aside": ["IQY"],
  "ask": ["GL1","Des","Der","Ebw","AJB","EWa","AJF"],
  "ask a question": ["Fbm","Der","Ebw","EWa"],
  "ask again": ["HGe"],
  "ask around": ["IQa"],
  "ask asked": ["Fbn","ETj","Der","Des"],
  "ask for": ["IQb"],
  "ask for directions": ["HGf"],
  "ask for help": ["Fbp","AJE"],
  "ask nicely": ["HGg"],
  "ask out": ["IQc"],
  "ask permission": ["HGh"],
  "ask the teacher": ["HGi"],
  "ask your mum": ["HGj"],
  "asked": ["Fbo","ETj","AJD"],
  "asked a question": ["ETj"],
  "asking": ["Ebw","Des","Der"],
  "asking a question": ["Ebw","Der"],
  "asleep": ["GL2","AJG","E6a","AJJ","AJI","AJH"],
  "asparagus": ["GL3","AJL","AJM","AJK"],
  "aspect": ["IQe"],
  "aspiration": ["Jqg"],
  "aspire": ["IQf"],
  "aspirin": ["Fbt","AJP","AJN","AJO"],
  "ass": ["Jqr"],
  "assail": ["IQg"],
  "assassin": ["Jqj"],
  "assassinate": ["IQh"],
  "assassination": ["Jqi"],
  "assault": ["Jqk"],
  "assay": ["Jql"],
  "assemblage": ["Jqm"],
  "assemble": ["AJQ","AJS","AJU","AJT"],
  "assembly": ["G6m"],
  "assembly line": ["HGk"],
  "assent": ["IQi"],
  "assert": ["IQk"],
  "assertion": ["Jqn"],
  "assertive": ["IQj"],
  "assess": ["IQl"],
  "assessment": ["Jqo"],
  "asset": ["IQm"],
  "assets": ["AJX","AJV","AJW"],
  "assign": ["AJa"],
  "assignment": ["Fbu","AJZ","AJY"],
  "assimilate": ["IQn"],
  "assimilation": ["IQo"],
  "assist": ["Fbx"],
  "assist the boss": ["D8t"],
  "assistance": ["Fbv","AJb","AJc"],
  "assistant": ["Fbw","AJf","AJh","AJi","AJg","AJe"],
  "associate": ["IQp"],
  "association": ["Jqp"],
  "associative": ["IQq"],
  "assort": ["Jqq"],
  "assortment": ["IQs"],
  "assume": ["IQt"],
  "assumption": ["IQu"],
  "assurance": ["Jqs"],
  "assure": ["IQv"],
  "asteroid": ["GL4","AJn","AJk","AJo","AJj","AJl","AJm"],
  "asteroid belt": ["HGl"],
  "asthma": ["Fby","AJs","DSR","AJp"],
  "astonish": ["DST"],
  "astonished": ["Fbz","AJz","DSS","AJx"],
  "astonishment": ["AJ1"],
  "astound": ["AJ4","AJ3"],
  "astounded": ["IQz"],
  "astrology": ["HGm"],
  "astronaut": ["GL5","C5F","E6b","AKC","AJ5","D8v","AJ7","D8u","AJ8","AKB","C5E","AJ6","AJ9","AKA"],
  "astronomer": ["GL6","AKE","AKD"],
  "astronomical": ["IQ0"],
  "astronomical unit": ["HGn"],
  "astronomy": ["Fb0","DSU"],
  "astute": ["IQ1"],
  "asylum": ["Jqt"],
  "asymmetrical": ["IQ2"],
  "asymmetry": ["Jqu"],
  "asymptotic": ["Jqv"],
  "at": ["Fb8","AKz","AKM"],
  "at a time": ["IQ4"],
  "at any time": ["IQ3"],
  "at first": ["IQ6"],
  "at first glance": ["IQ5"],
  "at hand": ["IQ7"],
  "at home": ["Fb3","AKa","AKb","AKc"],
  "at last": ["IQ8"],
  "at least": ["IQ9"],
  "at most": ["IRA"],
  "at night": ["Fb7","AKx","AKt","AKv","AKy"],
  "at once": ["IRC"],
  "at one's fingertips": ["IRD"],
  "at random": ["IRE"],
  "at risk": ["AK0","AK1"],
  "at school": ["FcA","AK4","AK2","AK6","AK3","AK5"],
  "at the back": ["FcG","DdD","Edp"],
  "at the back of the queue": ["Edp"],
  "at the beach": ["FcH","ALO"],
  "at the bus stop": ["HGs"],
  "at the desk": ["HGt"],
  "at the door": ["HGu"],
  "at the front": ["DdE","Edq"],
  "at the front of the plane": ["Edq"],
  "at the mall": ["ALR"],
  "at the most": ["IRK"],
  "at the museum": ["ALS"],
  "at the table": ["HGv"],
  "at the top of": ["IRL"],
  "at times": ["IRM"],
  "at work": ["HGw"],
  "at your wits end": ["D82","D83","D84"],
  "ate": ["GL7","ETk"],
  "ate pizza": ["ETk"],
  "Athena": ["HGo"],
  "Athenian": ["Kpb"],
  "Athens": ["G6o"],
  "athlete": ["GL8","C5H","E6c","AKO","C5G","AKP","AKT","D8z","AKR","AKN"],
  "athletic": ["GL9","DSV","D81","AKW","AKX","AKU"],
  "athletics": ["GMA","AKZ","E6d","AKY"],
  "Atlantic": ["Jqx"],
  "Atlantic Ocean": ["Jqw"],
  "atlas": ["Fb5","AKf","AKg"],
  "atm": ["GMB","C5I","AKs","AKj","Dwb","AKk","AKm"],
  "atmosphere": ["Fb6","AKn","AKo","AKp","AKr"],
  "atmospheric": ["Jqy"],
  "atmospheric pressure": ["HGp"],
  "atom": ["HGq"],
  "atomic": ["IRB"],
  "atoms": ["HGr"],
  "atop": ["Jqz"],
  "atrocity": ["Jq0"],
  "atrophy": ["IRF"],
  "attach": ["FcC","ALE","AK8","AK9"],
  "attachment": ["FcB","ALD"],
  "attack": ["FcD","ALG","ALF","ALH","ALI"],
  "attacker": ["Jq1"],
  "attain": ["IRG"],
  "attainment": ["Jq2"],
  "attempt": ["IRH"],
  "attend": ["FcE","ALK"],
  "attend to": ["IRI"],
  "attendance": ["ALJ"],
  "attendant": ["Jq3"],
  "attendee": ["Jq4"],
  "attention": ["FcF","ALM","ALN"],
  "attentional": ["Jq5"],
  "attentive": ["IRJ"],
  "attest": ["Jq6"],
  "attic": ["GMC","ALU","E6e","ALT","ALX","ALV","ALW"],
  "attire": ["IRN"],
  "attitude": ["FcI","ALY","ALZ"],
  "attorney": ["IRO"],
  "attract": ["FcJ","ALb","ALc","ALj"],
  "attraction": ["Ex5"],
  "attractive": ["GMD","ALe","ALi","ALf","ALd","ALg","ALh"],
  "attributable": ["Jq7"],
  "attribute": ["IRQ"],
  "attribute a to b": ["IRP"],
  "attribution": ["Jq8"],
  "atypical": ["Jq9"],
  "Au": ["HGx"],
  "au pair": ["DSY"],
  "Auckland": ["JrA"],
  "auction": ["ALm"],
  "auction off": ["IRR"],
  "audible": ["IRS"],
  "audience": ["GME","ALp","E6f","ALo","ALn"],
  "audio": ["IRT"],
  "audit": ["IRW"],
  "audition": ["IRU"],
  "auditor": ["JrB"],
  "auditorium": ["GMF","Doh"],
  "auditory": ["IRV"],
  "augment": ["IRX"],
  "August": ["GMG","Doi","E6g"],
  "aunt": ["GMH","DZK","E6h","DSX","ALr","D85","ALq"],
  "auntie": ["FcK","DSW"],
  "aura": ["JrC"],
  "aurora": ["ALv"],
  "Aurora Australis": ["HGy"],
  "Aurora Borealis": ["HGz"],
  "auspice": ["JrD"],
  "auspicious": ["IRY"],
  "Aussie": ["Kpe"],
  "Australia": ["GMJ","AL4","E6i","C5L","ALw","ALz","AL2","AL0","D86","Dwc","AL1"],
  "Australia and Oceania": ["AL3"],
  "Australia flag": ["FcL","C5J"],
  "Australian": ["GMI","Kpf","C5K","EeF"],
  "Australian Rules Football": ["HG0"],
  "Australians": ["Krh"],
  "Austria": ["FcM","AL9","AL6","AL7"],
  "Austrian": ["HBk","Kpg"],
  "authentic": ["IRZ"],
  "authenticity": ["JrE"],
  "author": ["GMK","C5N","C5M","AMC","D88","D89","AMD"],
  "authoritarian": ["JrF"],
  "authoritative": ["IRa"],
  "authority": ["FcN","AME","AMG"],
  "authorization": ["JrG"],
  "authorize": ["IRb"],
  "autism": ["JrH"],
  "auto": ["JrL"],
  "autobiographical": ["JrI"],
  "autobiography": ["IRc"],
  "autograph": ["IRd"],
  "automaker": ["JrJ"],
  "automate": ["IRe"],
  "automatic": ["IRf"],
  "automatically": ["AMK"],
  "automation": ["HG1"],
  "automobile": ["AMN"],
  "automotive": ["JrK"],
  "autonomous": ["IRg"],
  "autonomy": ["IRh"],
  "autumn": ["GML","FcO","AMU","E6j","AMT","AMR","AMO","AMP","AMS","AMQ"],
  "auxiliary": ["IRi"],
  "avail": ["IRk"],
  "availability": ["JrM"],
  "available": ["IRj"],
  "avalanche": ["GMM","AMX","AMZ","AMW","AMV","AMY"],
  "avenge": ["IRl"],
  "avenue": ["IRm"],
  "average": ["IRn"],
  "avert": ["IRo"],
  "aviation": ["IRp"],
  "avid": ["JrN"],
  "avocado": ["GMN","C5O","E6k","AMd","AMb","AMc","Dwd","AMa"],
  "avocado smoothie": ["AMf"],
  "avocados": ["FcP","EgU"],
  "avoid": ["FcQ","DSZ"],
  "avoidance": ["JrO"],
  "await": ["IRq"],
  "awake": ["GMO","DSa"],
  "awaken": ["JrP"],
  "award": ["IRr"],
  "aware": ["DSb"],
  "awareness": ["IRs"],
  "away": ["JrQ"],
  "awe": ["JrR"],
  "awe inspiring": ["DSc","AMg","AMh"],
  "awesome": ["FcR","DSd","AMj"],
  "awful": ["GMP","AMl","E6l","AMk","DSe","AMm"],
  "awfully": ["JrS"],
  "awhile": ["IRt"],
  "awkward": ["FcT","AMn"],
  "awkwardly": ["JrT"],
  "ax": ["FcV","Ex6"],
  "axe": ["GMQ","C5P","E6m","AMq","AMs","AMr","AMt","AMu"],
  "axiom": ["JrU"],
  "axis": ["FcU","AMy","AMw"],
  "axon": ["JrV"],
  "aye": ["JrW"],
  "Azerbaijan": ["FcW","AM2","AMz"],
  "Azerbaijani": ["HBl","Kpi"],
  "Aztec": ["Kpj"],
  "Aztecs": ["Kri"],
  "B": ["DZn","E8R","HBz"],
  "b": ["GOx","DZo","HBm"],
  "b1": ["HG2"],
  "b2": ["HG3"],
  "babble": ["IRu"],
  "babe": ["JrX"],
  "babies": ["FcX","Doj"],
  "baboon": ["GMR","AM5","DSf","AM4","AM3"],
  "baby": ["GMS","DSg","E6n","ANG","AM8","AM6","AM7","AM9"],
  "baby bottle": ["FcY","AND","ANA","ANB","ANC"],
  "baby brother": ["FcZ","Dok"],
  "baby cat": ["Fca","ANE"],
  "baby dog": ["Fcb","ANF"],
  "baby sister": ["Fcc","Dol"],
  "Babylon": ["HG4"],
  "babylonian": ["IRv"],
  "babysitter": ["GMT","ANI","ANH"],
  "Bacchus": ["HG5"],
  "Bach": ["JrY"],
  "bachelor": ["IRw"],
  "back": ["GMW","ANK","E6q","ANJ","ANb"],
  "back and forth": ["IRx"],
  "back away": ["IRy"],
  "back down": ["IRz"],
  "back off": ["IR2"],
  "back out": ["IR3"],
  "back to school": ["Fce","DSj","ANh","ANg"],
  "back up": ["IR4"],
  "backache": ["GMU","DSh","E6o","ANL","ANM","ANO","ANN"],
  "backbone": ["JrZ"],
  "backdrop": ["Jra"],
  "backer": ["Jrb"],
  "backgammon": ["HG6"],
  "background": ["Fcd","DSi","ANQ","ANS","ANR"],
  "backhand": ["IR0"],
  "backlash": ["Jrc"],
  "backlighting": ["IR1"],
  "backpack": ["GMV","C5R","E6p","C5Q","Dwf","ANV","Dwg","ANW","ANY","ANZ","ANa","ANT","ANX","ANU"],
  "backpacking": ["HG7"],
  "backside": ["Jrd"],
  "backstage": ["ANf","ANc"],
  "backup": ["IR5"],
  "backward": ["Jre"],
  "backwards": ["Fcf","ANl","ANj","ANi"],
  "backyard": ["GMX","ANp","E6r","ANm","ANn","ANo"],
  "bacon": ["GMY","C5S","E6s","ANs","ANq","Dwh","ANt","ANr"],
  "bacteria": ["Fcg","ANu","ANx"],
  "bacterial": ["IR6"],
  "bad": ["GMb","AOM","E6u","AN1","ANy","D9A","AN3","AN0","ANz","AN2"],
  "bad for": ["HG8"],
  "bad luck": ["HG9"],
  "bad news": ["AOL"],
  "bad temper": ["Fci","AON"],
  "bad weather": ["HHA"],
  "badge": ["GMZ","AN9","AN6","AN5","AN7","AN4","AN8"],
  "badger": ["Jrf"],
  "badges": ["Fch","AOC","AOB","AOA"],
  "badly": ["ERL"],
  "badminton": ["GMa","C5T","E6t","AOJ","Dwi","AOG","AOI","AOF","AOD","AOE","AOH"],
  "baffle": ["IR7"],
  "bag": ["GMd","AOS","E6v","C5Y","C5U","Dwj","AOR","AOO","AOU","AOP","AOk","AOQ","AOT"],
  "bag of chips": ["Fcl","AOh"],
  "bag of flour": ["Fcm","AOi","AOj"],
  "bagel": ["Fcj","AOV","C5V","AOZ"],
  "bagels": ["AOb"],
  "baggage": ["GMc","AOc","AOg","AOd"],
  "baggage claim": ["Fck","AOf"],
  "baggage handler": ["C5W"],
  "baggy": ["Jrg"],
  "baguette": ["Fcn","C5Z","Dwk"],
  "Bahrain": ["HBo","AOo"],
  "Bahraini": ["HBn","Knb","Knc"],
  "bail": ["Jri"],
  "bail on": ["IR8"],
  "bail out": ["IR9"],
  "bailout": ["Jrh"],
  "bait": ["ISA"],
  "bake": ["GMe","AOv","AOp"],
  "bake a cake": ["HHB"],
  "bake cookies": ["Fcp","AOq"],
  "baked potato": ["Fcq","AOs","AOt","AOu"],
  "baker": ["GMf","C5b","E6w","AOz","D9E","Dwl","AOy","AO0","D9D","AOx","C5a","AO1","AOw"],
  "baker's": ["GMg","AO2","E6x","C5c","AO7"],
  "bakery": ["GMh","C5c","E6y","AO7","AO3","AO4","AO5","AO6"],
  "baking": ["Fcs","Ex7"],
  "baking cookies": ["Fcr","AO8"],
  "baking tray": ["G6p"],
  "balance": ["GMi","APB","AO9","APA"],
  "balcony": ["GMj","APJ","E6z","APK","APF","APH","API","APG"],
  "bald": ["GMk","APM","E60","APP","APL","APN","APO"],
  "Bali": ["Jrj"],
  "balk": ["ISB"],
  "Balkan": ["Jrk"],
  "Balkans": ["Jrl"],
  "ball": ["GMp","Fcu","APt","E63","C5e","APQ","Dwn","APT","APV","APR","APS","APU"],
  "ballad": ["Jrm"],
  "ballerina": ["GMl","APb","APY","APW","APX","APa"],
  "ballet": ["GMm","APf","E61","APd","APi","APc","APe"],
  "ballet classes": ["Fct","APg","APh"],
  "balloon": ["GMn","C5d","Dwm","APl","APj","APo","APk","APn","APm"],
  "balloons": ["GMo","APp","E62","APq","APr","APs"],
  "ballot": ["HHC"],
  "ballroom": ["Jrn"],
  "balls": ["GMq","APu","APv"],
  "balm": ["ISC"],
  "Baltic": ["Jro"],
  "Baltic Sea": ["Jrp"],
  "Baltics": ["Jrq"],
  "bambi": ["AP0"],
  "bamboo": ["HHD"],
  "ban": ["GMw","ARB","AP3","AP2","AP4","AP1","AP5"],
  "banana": ["GMr","C5g","AP8","AQB","EgV","AQA","AP6","AP7","AP9"],
  "banana milkshake": ["Fcv","C5f"],
  "bananas": ["GMs","C5h","E64","AQE","Dwo","AQC","AQG","AQF","AQH","AQD"],
  "band": ["GMu","AQK","E65","AQI","AQJ","AQS","AQL","AQM"],
  "band aid": ["G6q","Fcw","C5j"],
  "bandage": ["GMt","C5i","AQQ","AQP","Dwp","AQR","AQO"],
  "bandanna": ["ISD"],
  "bandwidth": ["Jrr"],
  "bang": ["ISE"],
  "bang up": ["ISF"],
  "bangers and mash": ["AQT"],
  "Bangkok": ["G6r"],
  "Bangladesh": ["HBq","AQZ"],
  "Bangladeshi": ["HBp","Knd","Kne"],
  "bangle": ["AQa"],
  "bangles": ["AQf","AQe"],
  "banish": ["Jrs"],
  "banjo": ["Fcx","AQg","AQj","C5k","AQi"],
  "bank": ["GMv","AQ4","E66","AQm","AQl","AQp","AQn","AQo","AQq","AQr"],
  "bank account": ["Fcy","AQw","DSk","AQs"],
  "bank on": ["ISG"],
  "bank robbers": ["DSm"],
  "banker": ["Jrt"],
  "banking": ["HHE"],
  "banknote": ["Fcz","AQ1","AQ3","AQ2","AQz"],
  "bankrupt": ["DSn","AQ7","AQ5","AQ6"],
  "bankruptcy": ["ISH"],
  "banner": ["Fc0","ARA","AQ9","AQ8"],
  "banquet": ["ISI"],
  "banyan tree": ["Fc1"],
  "baozi": ["ARD"],
  "baptism": ["Jru"],
  "baptize": ["Jrv"],
  "bar": ["GM1","Dom"],
  "barb": ["ISJ"],
  "barbecue": ["GMx","ARM","E67","ARF","ARJ","C5l","ARE","ARI","ARK","ARL","ARH"],
  "barbeque": ["ARE","C5l","ARM","ARF","ARH","ARI","ARJ","ARK","ARL"],
  "barber": ["GMy","ARP","ARO","ARN"],
  "barbers": ["ARQ"],
  "barbershop": ["Fc2","ART"],
  "Barcelona": ["Jrw"],
  "barcode": ["ARV","ARX"],
  "bare": ["ISL"],
  "barefooted": ["Fc3","ARY","ARb"],
  "barely": ["ISK"],
  "bargain": ["Fc4","ARc","ARe"],
  "bargain down": ["ISM"],
  "barge": ["ISO"],
  "barge in": ["ISN"],
  "barista": ["D9G","D9H","C5n","C5m"],
  "bark": ["GMz","ARk","ARg","ARh","ARf"],
  "barking": ["Fc5","ARj"],
  "barley": ["ARm"],
  "barman": ["Dwt"],
  "barn": ["GM0","ARp","ARr","ARu","ARq","ARt","ARs"],
  "baron": ["Jrx"],
  "barrack": ["Jry"],
  "barrage": ["Jrz"],
  "barrel": ["Fc6","AR0"],
  "barren": ["AR4"],
  "barrier": ["ISP"],
  "barrister": ["AR8","AR5","AR6","AR7"],
  "bartender": ["Fc7","D9I","AR9","ASA","ASC"],
  "barter": ["ISQ"],
  "basal": ["Jr0"],
  "base": ["FdA","ASa"],
  "base on": ["ISR"],
  "baseball": ["GM3","C5q","E68","ASS","ASF","Dwu","ASG","ASJ","ASI"],
  "baseball cap": ["GM2","ASM","ASP","ASL","ASK","ASN","ASO"],
  "baseball field": ["Fc8","ASQ","ASR"],
  "baseball player": ["Fc9","Ex8"],
  "baseball stadium": ["ASU"],
  "baseline": ["Jr1"],
  "basement": ["GM4","ASZ","E69","ASX","ASV","ASW","ASY"],
  "bash": ["Jr2"],
  "basic": ["ISS"],
  "basically": ["Jr3"],
  "basil": ["FdB","ASg","ASc","ASf"],
  "basin": ["Ex9"],
  "basis": ["IST"],
  "basket": ["GM6","C5s","ASv","Dww","ASh","ASi","ASj","ASl","ASk","ASm"],
  "basketball": ["GM5","C5r","E7A","ASp","ASo","ASu","Dwv","ASt","ASq","ASr","ASs","ASn"],
  "basketball court": ["FdC"],
  "basketball player": ["FdD","EyA"],
  "Basque": ["Knf"],
  "Basques": ["Krj"],
  "bass": ["FdE","ASz"],
  "bassoon": ["ASy"],
  "bastard": ["Jr4"],
  "bat": ["GM7","GNB","AS0","E7E","C5v","AS2","ATQ","Dwx","AS5","AS6","AS3","AS4","AS1"],
  "batch": ["ISU"],
  "bath": ["GM8","C5t","E7B","ATF","AS9","AS8","AS7"],
  "bath the baby": ["HHG"],
  "bathe": ["FdF","ATC","ATB","ATD"],
  "bathe the dog": ["HHF"],
  "bathroom": ["GM9","C5u","E7C","ATM","ATJ","ATI","ATK","ATH","ATL","ATG"],
  "bathtub": ["GNA","ATP","E7D","ATO","ATN"],
  "batman": ["Don"],
  "bats": ["D9K"],
  "battalion": ["Jr5"],
  "batter": ["ISV"],
  "batteries": ["FdG","ATS","ATT","ATR"],
  "battery": ["HHH","GNC","ATY","E7F","C5w","ATU","ATX","Dwy","ATW"],
  "battle": ["FdH","ATc","ATb","ATZ","ATa"],
  "battlefield": ["Jr6"],
  "battleground": ["Jr7"],
  "baubles": ["GND","ATh","ATg","ATf","ATe"],
  "bay": ["GNE","ATl","E7G","ATi","ATj","ATk"],
  "Bay of Bengal": ["Jr8"],
  "Bay of Biscay": ["Jr9"],
  "bbq": ["C5l","ARM","ARE","ARF","ARH","ARI","ARJ","ARK","ARL"],
  "be": ["JsN"],
  "be a dinosaur": ["D9N"],
  "be a pig": ["D9R","D9S","D9T"],
  "be a superstar": ["D9V","D9W"],
  "be a victim of": ["ISk"],
  "be about to": ["ISW"],
  "be absent from": ["ISX"],
  "be afraid of": ["ISZ"],
  "be all ears": ["D9O","D9P","D9Q"],
  "be angry with": ["ISb"],
  "be anxious about": ["ISc"],
  "be anxious to": ["ISd"],
  "be apt to": ["ISe"],
  "be at a loss": ["ISh"],
  "be away": ["ISl"],
  "be been": ["EVP","EVQ"],
  "be better off": ["ISm"],
  "be bound to": ["ISn"],
  "be broke": ["ISo"],
  "be careful": ["HHL"],
  "be composed of": ["ISs"],
  "be concerned about": ["ISt"],
  "be covered with": ["ISu"],
  "be crazy about": ["ISv"],
  "be crowded with": ["ISw"],
  "be cut out for": ["ISx"],
  "be different from": ["ISy"],
  "be disappointed with": ["ISz"],
  "be divided into": ["IS0"],
  "be down with": ["IS1"],
  "be dressed in": ["IS2"],
  "be excited about": ["IS5"],
  "be familiar with": ["IS6"],
  "be famous for": ["IS7"],
  "be filled with": ["IS8"],
  "be fond of": ["IS9"],
  "be free to": ["ITC"],
  "be full of": ["ITD"],
  "be good at": ["ITF"],
  "be happy": ["Fdb","Det"],
  "be held responsible for": ["ITK"],
  "be impressed by": ["ITL"],
  "be in bad taste": ["ITM"],
  "be in charge of a sports match": ["D9Y"],
  "be in for": ["ITN"],
  "be in on": ["ITO"],
  "be in trouble": ["ITQ"],
  "be interested in": ["ITP"],
  "be known for": ["ITR"],
  "be late for": ["ITS"],
  "be likely to": ["ITV"],
  "be made of": ["ITa"],
  "be no use ing": ["ITi"],
  "be off": ["ITj"],
  "be on about": ["ITk"],
  "be on time": ["Fdk","AW4"],
  "be opposed to": ["ITl"],
  "be out of the question": ["ITm"],
  "be over": ["ITn"],
  "be pleased with": ["ITo"],
  "be proud of": ["ITp"],
  "be quiet": ["GNj","AW6","AW7","Ehy"],
  "be ready to": ["ITr"],
  "be responsible for": ["ITs"],
  "be satisfied with": ["ITt"],
  "be similar to": ["ITw"],
  "be snowed under": ["ITx"],
  "be supposed to": ["ITz"],
  "be sure of": ["IT0"],
  "be surprised at": ["IT1"],
  "be surprised by": ["IT2"],
  "be thankful for": ["IT3"],
  "be the boss of a company": ["D9a"],
  "be through with": ["IT4"],
  "be true of": ["IT5"],
  "be unhappy": ["Deu"],
  "be up for": ["IT7"],
  "be up to": ["IT9"],
  "be up to one": ["IT8"],
  "be used to": ["IUA"],
  "be was": ["Fdq","EUW","Det"],
  "be well off": ["IUC"],
  "be were": ["Fdr","EVF"],
  "be willing to": ["IUE"],
  "be worried about": ["IUF"],
  "be worth": ["IUG"],
  "beach": ["GNG","C5x","E7I","AT2","ATq","DvN","ATm","ATp","ATo","ATn"],
  "beach ball": ["GNF","ATr","E7H","ATv","ATu","ATs","ATt"],
  "beach bucket": ["FdI","ATw"],
  "beach chair": ["FdJ","ATx","ATz"],
  "beach mat": ["FdK","AT1"],
  "beach soccer": ["HHI"],
  "beach towel": ["FdL","AT5","AT3"],
  "beach umbrella": ["FdM","AT6","AT7","AT9","AUA"],
  "beach volleyball": ["HHJ"],
  "bead": ["ISY"],
  "beads": ["FdN","AUC","AUB","AUF","AUD","AUE"],
  "beagle": ["AUG"],
  "beak": ["GNH","C5y","E7J","AUL","AUI","AUK"],
  "beaker": ["HHK"],
  "beam": ["ISa"],
  "bean": ["GNI","Doo"],
  "bean sprouts": ["FdQ","AUY","AUb"],
  "beanbag": ["FdO","AUN"],
  "beanie": ["FdP","AUQ","AUP","AUO"],
  "beans": ["GNJ","C50","E7K","AUW","AUV","AUU","AUX","AUR","AUS","AUT"],
  "beans on toast": ["C5z"],
  "bear": ["GNL","C52","E7M","AUn","Dw0","AUc","AUg","AUd","AUh","AUf","AUe"],
  "bear upon": ["ISf"],
  "bear with": ["ISg"],
  "beard": ["GNK","C51","E7L","AUl","Dwz","AUk","AUj","AUm","AUi"],
  "bearer": ["JsA"],
  "bears": ["FdR","AUp","AUo"],
  "beast": ["FdS","AUs","AUq"],
  "beat": ["GNM","AUv","AUw","AUx","AUt","AUu"],
  "beat up": ["ISj"],
  "beats me": ["ISi"],
  "beautiful": ["GNN","AU2","E7N","C53","D9X","AUy","AUz","AU0","AU4","AU1"],
  "beautifully": ["FdT","AU3","ERD"],
  "beauty": ["FdU","AU8","AU5"],
  "beauty contest": ["AU7"],
  "beauty salon": ["FdV","AU9","AVB"],
  "beaver": ["GNO","AVD","AVI","AVG","AVE","AVF"],
  "because": ["FdW","EyB"],
  "because of": ["ISp"],
  "beckon": ["JsB"],
  "become": ["GNP","AVJ"],
  "become famous overnight": ["ISq"],
  "become of": ["ISr"],
  "bed": ["GNQ","C54","E7O","Dw1","AVM","AVO","AVP","AVS","AVL","AVN","AVK"],
  "bed and breakfast": ["AVQ","AVR"],
  "Bedouin": ["Kng"],
  "bedrock": ["IS3"],
  "bedroom": ["GNR","C55","E7P","AVU","AVW","AVV","AVT"],
  "bedside": ["JsC"],
  "bedside table": ["GNS","AVa","E7Q","AVX","AVY","AVZ"],
  "bedtime": ["FdX","AVe","AVc","AVd"],
  "bee": ["GNU","C57","E7S","AVh","AVt","AVg","Dw3","AVj","AVi","AVk","AVl","AVf"],
  "beef": ["GNT","C56","E7R","EgW","AVo","AVs","AVm","AVp","AVr","AVn","AVq"],
  "beef up": ["IS4"],
  "been": ["EVm","EVP","EVQ","EVR"],
  "been a policeman": ["EVP"],
  "been scuba diving": ["EVm"],
  "been sick": ["EVQ"],
  "been to America": ["EVR"],
  "beep": ["JsD"],
  "beer": ["GNV","AVw","AVy","AVu","AVx","AVz"],
  "bees": ["FdY","AV2","AV0","AV1"],
  "Beethoven": ["JsE"],
  "beetle": ["GNW","C58","E7T","AV7","Dw4","AV3","AV5","AV4"],
  "beetroot": ["GNX","AV8"],
  "beetroots": ["FdZ","AWB","AV9","AWA"],
  "before": ["EyC"],
  "before long": ["ITB"],
  "beforehand": ["ITA"],
  "beg": ["ITG"],
  "beg off": ["ITE"],
  "beggar": ["Fda","AWD","AWE"],
  "begin": ["GNY","AWI","E7U","AWH"],
  "beginner": ["HHM"],
  "behalf": ["ITH"],
  "behave": ["ITI"],
  "behavior": ["HHN"],
  "behavioral": ["JsF"],
  "behaviorism": ["ITJ"],
  "behaviour": ["HHO"],
  "behind": ["GNZ","DdF","E7V","DdH","DdG","Eds","Edr","AWJ"],
  "behind the bush": ["Edr"],
  "behind the door": ["HHP"],
  "behind the tree": ["Eds"],
  "behind you": ["HHQ"],
  "behold": ["JsG"],
  "beige": ["Fdc","C59","AWL"],
  "Beijing": ["G6s","Fdd","AWP","AWN","AWO"],
  "being happy": ["Det"],
  "being polite": ["Dop"],
  "being unhappy": ["Deu"],
  "Belarus": ["HBs"],
  "Belarusian": ["HBr","Knh"],
  "Belgian": ["HBt","Kni"],
  "Belgium": ["GNa","AWT","AWQ","AWR"],
  "belie": ["ITU"],
  "belief": ["ITT"],
  "beliefs": ["HHR"],
  "believe": ["GNb","AWV","E7W","AWU"],
  "believer": ["JsH"],
  "bell": ["GNd","AWb","E7X","AWY","AWW","AWX","AWZ"],
  "bell pepper": ["Fdf","Egz"],
  "bell peppers": ["GNc","C6A","D3y"],
  "bellboy": ["Fde","AWa"],
  "bellow": ["JsI"],
  "bellows": ["ITW"],
  "bells": ["GNe","AWc","E7Y"],
  "belly": ["GNf","C6C","E7Z","Dw6","AWf","AWd","AWe"],
  "belly button": ["Fdg","C6B"],
  "belong": ["ITX"],
  "belong to": ["ITY"],
  "beloved": ["ITZ"],
  "below": ["GNg","AWj","E7a","AWg","AWh"],
  "below zero": ["HHS"],
  "belt": ["GNh","C6D","E7b","AWn","Dw7","AWl","AWm","AWk"],
  "beluga": ["Fdh","AWo"],
  "bench": ["GNi","C6E","E7c","AWr","AWw","Dw8","AWu","AWs","AWx","AWv"],
  "benchmark": ["JsJ"],
  "bend": ["Fdi","Doq"],
  "bend over": ["ITb"],
  "beneath": ["ITc"],
  "benefactor": ["ITd"],
  "beneficent": ["ITe"],
  "beneficial": ["ITf"],
  "beneficiary": ["JsK"],
  "benefit": ["Fdj","AWy"],
  "benefits": ["AWz"],
  "benelux": ["JsL"],
  "benevolent": ["ITg"],
  "bengal fox": ["AW0","AW1"],
  "bengal tiger": ["AW3"],
  "benign": ["ITh"],
  "Benjamin Franklin": ["JsM"],
  "bequeath": ["ITq"],
  "Berber": ["Knj"],
  "bereave": ["JsO"],
  "Berlin": ["G6t"],
  "Berliner": ["Knk"],
  "Bermuda": ["JsP"],
  "berries": ["Fdl","AXB","AW9","AW8"],
  "berry": ["Fdm","AXD","AXC"],
  "berth": ["JsQ"],
  "beside": ["Fdn","EyD"],
  "besides": ["ITu"],
  "besiege": ["ITv"],
  "best": ["GNl","AXE","AXF","AXM"],
  "best friend": ["GNk","AXG","AXH"],
  "best friends": ["AXK"],
  "best regards": ["HHT"],
  "best wishes": ["HHU"],
  "bestow": ["ITy"],
  "bet": ["Fdo","AXN","AXP"],
  "beta": ["JsR"],
  "betray": ["AXR"],
  "betrayal": ["JsS"],
  "better": ["GNm","C6F","ERw","AXS"],
  "between": ["GNn","DdI","DdJ","Edt"],
  "between the earth and the sun": ["Edt"],
  "between the lines": ["HHV"],
  "between two trees": ["HHW"],
  "between us": ["HHX"],
  "between you and me": ["IT6"],
  "beverage": ["Fdp","AXV","AXT"],
  "beverages": ["DSo"],
  "beware": ["IUB"],
  "bewilder": ["IUD"],
  "beyond": ["IUH"],
  "Bhutan": ["HBv","Fds","AXb","AXX"],
  "Bhutanese": ["HBu","Knl"],
  "bi": ["Jse"],
  "biannual": ["IUI"],
  "bias": ["IUK"],
  "biased": ["IUJ"],
  "biathlon": ["HHY"],
  "bib": ["GNo","Dor"],
  "bible": ["JsT"],
  "biblical": ["JsU"],
  "bibliography": ["JsV"],
  "bicameral": ["IUL"],
  "bicycle": ["GNp","AXd","E7d","AXf","AXe","AXc"],
  "bid": ["IUM"],
  "bidder": ["JsW"],
  "big": ["GNr","C6K","C6G","D9b","EhE","AXv","EhF"],
  "Big Bang": ["HHZ"],
  "Big Ben": ["Fdt","Dos"],
  "big brother": ["Fdu","AXg","AXh"],
  "big buddha": ["AXi","AXj"],
  "big car": ["HHa"],
  "big city": ["Fdv"],
  "Big Dipper": ["HHb"],
  "big dog": ["AXl"],
  "big ears": ["Fdw","AXm","AXn"],
  "big elephant": ["AXr"],
  "big eyes": ["Fdx","AXt","AXu"],
  "big family": ["HHc"],
  "big house": ["HHd"],
  "big sister": ["Fdy","AXw"],
  "big teeth": ["AXx"],
  "big toe": ["C6L"],
  "big wheel": ["Fdz","AXz"],
  "bigger": ["GNq","C6J","C6H","EgP","C6I"],
  "bike": ["GNs","C6M","E7e","Dw9","AYD","AX0","AX3","AX4","AX2","AX1"],
  "bike lock": ["AX5","AX6","AX7","AX8"],
  "bike path": ["AX9","AYB"],
  "bike rack": ["Fd0","AYE","AYF","AYG"],
  "bike rides": ["Fd1","AYH"],
  "bikini": ["Fd2","AYL","AYN","AYJ","AYM"],
  "bilateral": ["IUN"],
  "bile": ["JsX"],
  "bilingual": ["HHe"],
  "bilingualism": ["IUO"],
  "bill": ["GNt","Dot"],
  "billboard": ["Fd3","C6N"],
  "billiards": ["HHf"],
  "billion": ["G6u"],
  "billionaire": ["IUP"],
  "bills": ["G6v"],
  "bin": ["GNv","C6O","E7f","AYR","AYY","AYO","AYP","DxB","AYQ"],
  "bin bag": ["AYS"],
  "binary": ["IUQ"],
  "binary star": ["HHg"],
  "bind": ["IUR"],
  "bingo": ["HHh"],
  "binocular": ["JsY"],
  "binoculars": ["GNu","AYX","AYV","AYW","AYU"],
  "biochemical": ["IUS"],
  "biodiversity": ["Fd4","AYZ","AYa"],
  "biofuel": ["IUT"],
  "biographer": ["JsZ"],
  "biographical": ["Jsa"],
  "biography": ["Fd5","Dou"],
  "biological": ["IUU"],
  "biologist": ["IUV"],
  "biology": ["GNw","C6P","E7g","AYd","AYc","DxC","AYb"],
  "biomass": ["Jsb"],
  "bionic": ["AYg","AYe","AYf"],
  "biopsy": ["Jsc"],
  "biosphere": ["IUW"],
  "biotechnology": ["IUX"],
  "bipartisan": ["Jsd"],
  "bipolar": ["Jsf"],
  "birch": ["AYh"],
  "bird": ["GNx","C6Q","E7h","AYj","DxD","AYu","C6R","AYn","AYi","AYl","AYm","AYk"],
  "bird bath": ["AYp"],
  "bird house": ["AYs","AYt"],
  "bird table": ["AYy"],
  "birds": ["GNy","AYv","E7i","D9c","AYx","AYw"],
  "Birmingham": ["G6w"],
  "birth": ["Fd7","AY8"],
  "birthday": ["GN2","AY1","E7k","AYz","AY0","AY3","AY7","AY2"],
  "birthday cake": ["GNz","Dov","E7j"],
  "birthday card": ["GN0","AY4","AY5"],
  "birthday hat": ["Fd6","AY6"],
  "birthday party": ["GN1","C6S"],
  "birthplace": ["EyE"],
  "biscuit": ["GN3","AZB","E7l","AY9","AZA"],
  "biscuits": ["GN4","AZD","E7m","C6T","AZC","AZE"],
  "bisect": ["IUY"],
  "bishop": ["Jsg"],
  "bison": ["Fd8","AZJ","AZF"],
  "bit": ["ESX"],
  "bit me": ["ESX"],
  "bitcoin": ["AZK"],
  "bite": ["GN5","Dew","E7n","AZO","AZL","AZN","Dev","EdC"],
  "bite bit": ["Fd9","Dew","Dev","ESX"],
  "bite someone": ["EdC","Dew"],
  "bite someones head off": ["D9d","D9e","D9f"],
  "biting": ["Dew","EdC","Dev"],
  "biting someone": ["Dew"],
  "bitter": ["GN6","AZR","AZQ","AZP"],
  "bitterly": ["Jsi"],
  "bitterly cold": ["HHi"],
  "bitterness": ["Jsj"],
  "bizarre": ["IUZ"],
  "black": ["GOB","C6f","E7q","AZS","AZl"],
  "black and blue": ["C6U"],
  "black and orange": ["C6V"],
  "black and pink": ["C6W"],
  "black and red": ["C6X"],
  "black and white": ["C6Y"],
  "black and yellow": ["C6Z"],
  "black bird": ["FeA","AZX","AZZ","AZY"],
  "black cat": ["GN9","AZc","E7p","D9g"],
  "black coffee": ["C6b"],
  "black currant": ["AZe"],
  "black dress": ["Ef4"],
  "black eye": ["FeB","C6d"],
  "black gloves": ["EgE","C6e"],
  "black hair": ["GOA","AZh"],
  "Black Hole": ["HHj"],
  "black ice": ["HHk"],
  "black out": ["IUa"],
  "black panther": ["AZk"],
  "black widow": ["AZm"],
  "blackbeard": ["AZT"],
  "blackberry": ["GN7","AZV","AZU","AZW"],
  "blackboard": ["GN8","AZa","E7o","C6a","AZb","DxE"],
  "blacken": ["Jsk"],
  "blackmail": ["Jsl"],
  "blackness": ["Jsm"],
  "blackout": ["Jsn"],
  "blacksmith": ["IUb"],
  "bladder": ["Jso"],
  "blade": ["FeC","AZr","AZq","AZp"],
  "blah": ["Jsp"],
  "blame": ["FeD","AZv","AZs","AZt","AZu"],
  "bland": ["IUc"],
  "blank": ["IUe"],
  "blank out": ["IUd"],
  "blanket": ["GOC","AZx","E7r","AZy","AZw"],
  "blast": ["FeE","AZ2","AZ0","AZ1"],
  "blast off": ["IUf"],
  "blastocyst": ["Jsq"],
  "blastomere": ["Jsr"],
  "blatant": ["Jss"],
  "blaze": ["AZ5","AZ3"],
  "blaze away": ["IUg"],
  "blazer": ["FeF","C6g","DxG"],
  "bleach": ["IUh"],
  "bleak": ["IUi"],
  "bleed": ["IUj"],
  "blend": ["IUl"],
  "blend in": ["IUk"],
  "blender": ["GOD","AZ6","E7s","AaA","AZ8","AZ9","AZ7"],
  "bless": ["IUm"],
  "bless you": ["HHl","G6x"],
  "blew": ["EUj"],
  "blew air": ["EUj"],
  "blight": ["Jst"],
  "blind": ["FeG","AaF","AaB","AaC","AaD"],
  "blindly": ["Jsu"],
  "blindness": ["Jsv"],
  "blink": ["FeH","AaG","AaH"],
  "bliss": ["IUn"],
  "blister": ["Jsw"],
  "blizzard": ["GOE","C6i","E7t","AaK","AaL","AaI","AaJ"],
  "bloc": ["Jsz"],
  "block": ["GOF","AaR","E7u","AaM","AaN","Dex","AaO","AaP"],
  "block blocked": ["Dex"],
  "block of flats": ["FeI","AaQ"],
  "block the sun": ["Dex"],
  "blockade": ["Jsx"],
  "blockbuster": ["Jsy"],
  "blocking": ["Dex"],
  "blocking the sun": ["Dex"],
  "blocks": ["GOG","AaT","E7v","AaS"],
  "blog": ["FeJ","AaV","AaW","AaU"],
  "blogger": ["Js0"],
  "bloke": ["Js1"],
  "blond": ["GOH","AaY","E7w","AaZ","AaX","Dow"],
  "blond hair": ["FeK","EyG"],
  "blonde": ["EyF"],
  "blonde hair": ["EyF"],
  "blood": ["GOI","Aaa","E7x","Aad","Aab","Aac"],
  "blood pressure": ["FeL","Aae","Aaf"],
  "blood test": ["FeM","Aag"],
  "bloody": ["Js2"],
  "bloom": ["FeN","Aaj","Aai","Aah"],
  "blossom": ["FeO","Aal","Aak"],
  "blot": ["Js3"],
  "blot out": ["IUo"],
  "blouse": ["GOJ","C6j","E7y","Aam","Aan","DxH","Aao"],
  "blow": ["GOK","Dey","E7z","Dez","Ebx","EWd"],
  "blow a balloon": ["HHm"],
  "blow air": ["Dey","EWd"],
  "blow away": ["IUp"],
  "blow blew": ["Dey","EUj","Dez"],
  "blow bubbles": ["FeP","Aap","Aaq"],
  "blow nose": ["Ebx"],
  "blow off": ["IUq"],
  "blow out": ["IUr"],
  "blow out candles": ["HHn"],
  "blow over": ["IUs"],
  "blow up": ["HHo"],
  "blow your nose": ["Dez"],
  "blowfish": ["FeQ","Aat","Aar","Aas"],
  "blowing": ["FeR","Dez","Ebx","Dey"],
  "blowing air": ["Dey"],
  "blowing your nose": ["FeS","Dez"],
  "blue": ["GOO","FeU","C6q","E72","Aa4","Aau","EhG","EhH"],
  "blue and green": ["C6k"],
  "blue and white": ["C6l"],
  "blue bird": ["FeT","Aa0"],
  "blue coats": ["EgF","C6n"],
  "blue collar": ["IUt"],
  "blue eyes": ["GON","Aa3","E71","Aa1","Aa2"],
  "blue hair": ["EhH","EhG"],
  "blue hat": ["C6o","Ef5"],
  "blue pants": ["C6p","EgG"],
  "blue shift": ["HHq"],
  "blue whale": ["FeV","Aa7","Aa5","Aa6","Aa9"],
  "blueberries": ["GOL","C6m","E70","Aav","Aay","Aax","Aaw"],
  "blueberry": ["GOM","Aaz"],
  "blueprint": ["HHp"],
  "blues": ["HHr"],
  "bluff": ["IUu"],
  "blunder": ["Js4"],
  "blunt": ["IUv"],
  "bluntly": ["Js5"],
  "blur": ["IUw"],
  "blurred": ["AbB"],
  "blurt": ["IUy"],
  "blurt out": ["IUx"],
  "blush": ["IUz"],
  "blushing": ["FeW","AbD","AbE","AbC"],
  "bluster": ["IU0"],
  "BMX": ["HHs"],
  "boar": ["FeY","AbF","AbW"],
  "board": ["GOR","AbM","E75","AbL","AbJ","AbV","AbK","AbI"],
  "board a bus": ["HHt"],
  "board game": ["GOP","C6r","E73","AbN","AbO","AbP","AbQ"],
  "board games": ["HHu"],
  "boarding card": ["HHv"],
  "boarding pass": ["GOQ","AbS","E74","AbT","DSp","AbR"],
  "boarding school": ["FeX","DSq","AbU"],
  "boast": ["IU1"],
  "boat": ["GOS","C6s","E76","Abd","DxI","Abc","Abb","AbX","AbZ","Aba","AbY"],
  "bob": ["Js6"],
  "bobble hat": ["FeZ","Abe","Abf","Abh","Abi"],
  "bobsled": ["HHw"],
  "bobsleigh": ["HHx"],
  "bode": ["IU2"],
  "bodily": ["Js7"],
  "body": ["GOT","C6t"],
  "body language": ["Abl"],
  "bodybuilding": ["HHy"],
  "bodyguard": ["Fea","Abj","Abk"],
  "bog": ["Js8"],
  "bog down": ["IU3"],
  "boil": ["GOV","De0","E77","Abt","EdJ","Abm","EWf"],
  "boil boiled": ["EUr","De0"],
  "boil down": ["IU4"],
  "boil down to": ["IU5"],
  "boil over": ["IU6"],
  "boil water": ["EWf","De0"],
  "boiled": ["Fed","EUr"],
  "boiled egg": ["Feb","Abn","Abo","Abr","Abp","Abq"],
  "boiled eggs": ["Fec","C6u","DxJ"],
  "boiler": ["Js9"],
  "boiling": ["GOU","C6w","C6v","De0","Abs","EdJ"],
  "boiling hot": ["HHz"],
  "boiling water": ["De0"],
  "bold": ["IU7"],
  "boldly": ["JtA"],
  "Bolivia": ["HBx","G6y"],
  "Bolivian": ["HBw","Knm"],
  "bolster": ["IU8"],
  "bolt": ["Fee","Abx","Abv","Abu","Abw"],
  "bomb": ["HH0"],
  "bombard": ["JtB"],
  "bomber": ["JtC"],
  "Bon appetit": ["HH1"],
  "Bon voyage": ["HH3"],
  "bonanza": ["IU9"],
  "bond": ["HH2"],
  "bone": ["GOW","Ab0","E78","Aby","Abz"],
  "bones": ["GOX","C6y","Ab1","Ab2","DxL"],
  "bonfire": ["Fef","Ab5","Ab3","Ab4"],
  "bonnet": ["JtD"],
  "bonus": ["JtE"],
  "bony": ["IVA"],
  "boo": ["JtI"],
  "book": ["GOZ","C60","E8A","DxN","Ab7","Ab8","AcA","Ab6","AcJ","Ab9","AcB"],
  "book bag": ["Feg","AcC"],
  "book in": ["IVB"],
  "book shelf": ["GOa","AcN","AcP","AcM","AcO"],
  "book shelves": ["Fei","AcQ","AcR","AcS"],
  "book store": ["Fej"],
  "bookcase": ["GOY","C6z","E79","DxM","AcI","AcD","AcG","AcE","AcH"],
  "booking": ["Feh"],
  "booklet": ["JtF"],
  "books": ["GOd","C61","E8D","AcY","DxO","AcK","AcL"],
  "bookseller": ["JtG"],
  "bookshelf": ["GOb","Dox","E8B"],
  "bookshop": ["GOc","AcX","E8C","AcU","AcW","AcV","AcT"],
  "bookstore": ["GOe","Acc","Acb","Aca","AcZ"],
  "boom": ["Fek","Ach"],
  "boomer": ["JtH"],
  "boomerang": ["Ace","Acg"],
  "boon": ["IVC"],
  "boost": ["IVD"],
  "boost up": ["IVE"],
  "booster": ["HH4"],
  "boot": ["GOf","Acj","E8E","Ack","Aci","Acr"],
  "booth": ["Fel","Acq","Acp","Aco"],
  "boots": ["GOg","C62","E8F","Acx","DxP","Acu","Acv","Acw","Acy","Acs","Act"],
  "booze": ["JtJ"],
  "border": ["HH5"],
  "border on": ["IVF"],
  "borderline": ["JtK"],
  "bore": ["JtM"],
  "bored": ["GOh","C63","E8G","Ac0","Acz","Ac3","D9h","Ac1","Ac2"],
  "boredom": ["JtL"],
  "boring": ["GOi","Ac6","E8H","D9i","Ac5","Ac4"],
  "born": ["Fem","Ac8","Ac7"],
  "borough": ["JtN"],
  "borrow": ["GOj","De1","De2","EWg","AdA","AdB","Ac9"],
  "borrow a book": ["Fen","De1","EWg"],
  "borrow a pen": ["De2"],
  "borrow borrowed": ["De1","De2"],
  "borrower": ["JtO"],
  "borrowing": ["Feo","De2","De1"],
  "borrowing a book": ["De1"],
  "borrowing a pen": ["De2"],
  "Bosnia": ["Fep","AdF","AdD"],
  "Bosnia and Herzegovina": ["D9k"],
  "Bosnian": ["HBy","Knn","G6z"],
  "bosom": ["IVG"],
  "boss": ["GOk","Doy","E8I"],
  "boss about": ["IVH"],
  "boss around": ["IVI"],
  "bossy": ["Feq","EyI","EyH"],
  "Boston": ["G60"],
  "botany": ["IVJ"],
  "both": ["GOl","AdG"],
  "bother": ["IVK"],
  "bottle": ["GOn","C65","AdO","AdJ","AdI","DxR","AdK","AdH"],
  "bottle of ketchup": ["Fer","AdL"],
  "bottle of water": ["GOm","AdM","E8J","AdN"],
  "bottle opener": ["C64"],
  "bottle up": ["IVL"],
  "bottled water": ["EyJ"],
  "bottles": ["Fes","AdQ","AdR","AdS"],
  "bottom": ["GOo","DdK"],
  "bottom line": ["IVM"],
  "bottom out": ["IVN"],
  "bought": ["GOp","ESf","EWL"],
  "bought a TV": ["EWL"],
  "bought some groceries": ["ESf"],
  "boulder": ["Fet","AdW"],
  "bounce": ["GOq","AdX","E8K","AdY"],
  "bounce back": ["IVO"],
  "bounce off": ["IVP"],
  "bound": ["IVR"],
  "boundary": ["IVQ"],
  "bountiful": ["IVS"],
  "bouquet": ["Feu","Ada","DSr","Adb"],
  "bourgeois": ["JtP"],
  "bout": ["JtQ"],
  "boutique": ["Fev","Adc"],
  "bovine": ["JtR"],
  "bow": ["GOt","Adf","E8N","Ade","Add","Adv"],
  "bow tie": ["Fez","C68","DxU"],
  "bowel": ["JtS"],
  "bowl": ["GOs","Adu","E8M","C67","Adg","DxT","Adi","Adh","De3","Adj","Adk","Eab"],
  "bowl bowled": ["De3"],
  "bowl of soup": ["Fey","Adr","Ads"],
  "bowl of strawberries": ["Adt"],
  "bowler": ["JtT"],
  "bowling": ["GOr","Fex","C66","E8L","Adm","De3","Adq","Eab","Adn","DxS"],
  "bowling alley": ["Few","Ado","Adp"],
  "box": ["GOv","C7A","E8P","DxW","Ady","Adw","Ad5","Adx","Adz"],
  "boxer": ["Fe0","Ad1"],
  "boxes": ["Fe1","Doz"],
  "boxing": ["GOu","C69","E8O","Ad4","DxV","Ad3","Ad2"],
  "boy": ["GOw","AeE","E8Q","Ad6","Ad7","Ad8"],
  "boy scout": ["AeG","AeH"],
  "boycott": ["IVT"],
  "boyfriend": ["Fe2","DZL","AeA","AeD","Ad9","AeB","AeC"],
  "boys": ["Fe3","AeI","AeF"],
  "bra": ["JtW"],
  "brace": ["IVU"],
  "bracelet": ["GOy","AeN","E8S","C7B","AeJ","AeM","DxX","AeK","C7C"],
  "bracket": ["JtU"],
  "brag": ["IVV"],
  "bragging": ["Fe4","DSs"],
  "braid": ["IVW"],
  "braids": ["Fe5","DSt","AeP"],
  "braille": ["IVX"],
  "brain": ["GOz","DSu","E8T","AeR","AeW","AeT","AeV","AeU","AeS"],
  "brainstorm": ["IVY"],
  "brake": ["GO0","AeX","Aea","AeZ"],
  "branch": ["GO1","DSv","E8U","Aej","Aeb","Aef","Aee","Aec","Aeg"],
  "branch out": ["IVZ"],
  "branches": ["Fe6","Aei","Aeh"],
  "brand": ["HH6"],
  "brand new": ["IVb"],
  "branding": ["IVa"],
  "brandy": ["JtV"],
  "brass": ["IVc"],
  "brave": ["GO2","Aem","Aek","Ael","Aeq"],
  "brave out": ["IVd"],
  "bravely": ["Fe7","Aen","Aep","Aeo"],
  "Brazil": ["GO4","C7F","E8V","Aeu","D9m","DxY","Aes","Aer","Aet"],
  "Brazil flag": ["Fe8","C7D"],
  "Brazilian": ["GO3","Kno","C7E","EeG"],
  "breach": ["IVe"],
  "bread": ["GO5","C7G","E8W","Aev","DxZ","Aez","C7H","Aey","Aex","Aew"],
  "bread roll": ["Fe9","Ae0"],
  "bread rolls": ["FfA","C7I"],
  "breadth": ["IVf"],
  "breadwinner": ["EyK"],
  "break": ["GO7","De7","E8Y","De4","De5","Ae1","Ae4","AfK","Ae2","Ae3"],
  "break a cup": ["De4"],
  "break a leg": ["HH7"],
  "break a plate": ["HH9"],
  "break a window": ["De5"],
  "break an egg": ["HH8"],
  "break away": ["IVh"],
  "break away from": ["IVg"],
  "break broke": ["FfB","ESg","De5","De7","De4"],
  "break broken": ["EVd","EVV"],
  "break down": ["FfC","De6","Ae6","D9n"],
  "break down broke down": ["De6"],
  "break in": ["HIB"],
  "break in half": ["HIA"],
  "break into": ["FfD","AfI","AfJ"],
  "break off": ["IVj"],
  "break out": ["HIC"],
  "break the rules": ["HID"],
  "break through": ["IVk"],
  "break time": ["G61"],
  "break up": ["FfE","De8","D9o"],
  "break up broke up": ["De8"],
  "breakdown": ["IVi"],
  "breaker": ["Ae7"],
  "breakfast": ["GO6","Ae8","E8X","AfF","Ae9","AfE","AfA","AfD","AfC","AfB"],
  "breaking": ["De7","De4","De5"],
  "breaking a cup": ["De4"],
  "breaking a window": ["De5"],
  "breaking down": ["De6"],
  "breaking news": ["AfG","AfH"],
  "breaking up": ["De8"],
  "breakthrough": ["IVl"],
  "breast": ["JtX"],
  "breath": ["FfF","DSx"],
  "breathe": ["GO8","AfM","DSw","AfN","AfO","AfL"],
  "breathing": ["IVm"],
  "breathless": ["JtY"],
  "breathtaking": ["AfQ"],
  "breed": ["FfG","AfS","AfT"],
  "breeder": ["JtZ"],
  "breeze": ["FfH","AfV","AfW","AfU"],
  "breezy": ["EyL"],
  "brew": ["IVn"],
  "brewer": ["Jta"],
  "brewery": ["Jtb"],
  "bribe": ["IVo"],
  "brick": ["GO9","AfY","Afa","AfX","AfZ"],
  "bricks": ["FfI","Afc","Afb"],
  "bride": ["GPA","Do0"],
  "bridge": ["GPB","Afi","E8Z","Aff","C7J","Afg","Afh","Dxb","Afe","Afd"],
  "brief": ["HIE"],
  "briefcase": ["FfJ","Afj","C7L","C7K","Afn","Afl","Afm"],
  "briefly": ["Jtc"],
  "brigade": ["Jtd"],
  "bright": ["GPC","C7N","E8a","Afo","D9p","Afp","EhI"],
  "bright sunshine": ["HIF"],
  "brighten": ["IVp"],
  "brighten up": ["IVq"],
  "brighter": ["FfK","C7M"],
  "brightly": ["Jte"],
  "brightness": ["Jtf"],
  "brilliance": ["Jtg"],
  "brilliant": ["FfL"],
  "brilliantly": ["Jth"],
  "brim": ["Jti"],
  "bring": ["FfM","EyN","EyM"],
  "bring a book": ["HIG"],
  "bring a friend": ["HII"],
  "bring about": ["HIH"],
  "bring around": ["IVr"],
  "bring back": ["HIJ"],
  "bring down": ["IVs"],
  "bring forth": ["IVt"],
  "bring forward": ["IVu"],
  "bring in": ["HIK"],
  "bring it here": ["HIL"],
  "bring lunch": ["HIM"],
  "bring on": ["IVv"],
  "bring out": ["IVw"],
  "bring over": ["IVx"],
  "bring together": ["IVy"],
  "bring up": ["HIN"],
  "bring water": ["HIO"],
  "brink": ["Jtj"],
  "brisk": ["IVz"],
  "briskly": ["Jtk"],
  "bristle": ["Jtl"],
  "bristle at": ["IV0"],
  "Brit": ["Knq"],
  "Britain": ["GPD","Afu","E8b"],
  "British": ["Jto","Krk","GPE","Afv","Afw"],
  "British Columbia": ["Jtm"],
  "British Isles": ["Jtn"],
  "British pound": ["Afx","Afy"],
  "Briton": ["Knp"],
  "brittle": ["Af0","Afz"],
  "broad": ["IV3"],
  "broadband": ["Af2","Af1"],
  "broadcast": ["IV2"],
  "broadcaster": ["IV1"],
  "broaden": ["Jtp"],
  "broadly": ["Jtq"],
  "broccoli": ["GPF","Af9","E8c","Af3","C7O","Dxd","Af5","Af7","Af6","Af4","Af8"],
  "brochure": ["FfN","AgB","AgC","AgA"],
  "broke": ["FfO","ESg","AgM","AgD","AgE"],
  "broke a mug": ["ESg"],
  "broken": ["GPI","C7R","EhJ","EhK","EVV","EVd","AgF","AgL"],
  "broken arm": ["GPG","C7P","E8d","EhK","Dxe","AgH"],
  "broken his arm": ["EVd"],
  "broken leg": ["GPH","AgK","E8e","C7Q","Dxf","AgJ"],
  "broken the window": ["EVV"],
  "broker": ["Jts"],
  "brokerage": ["Jtr"],
  "brontosaurus": ["AgO","AgN"],
  "bronze": ["FfP","AgR","AgP"],
  "Bronze Age": ["HIP"],
  "brood": ["Jtt"],
  "brook": ["IV4"],
  "Brooklyn": ["Jtu"],
  "broom": ["GPJ","C7T","E8f","AgT","AgV","Dxg","AgX","AgU","AgW"],
  "broomstick": ["GPK","AgZ","AgY"],
  "brother": ["GPL","DZM","E8g","Agd","Aga","Agc","D9s","Agb","D9r"],
  "brothers": ["GPM","Agf","Age","Agg"],
  "brow": ["FfS","Agq","Agj"],
  "brown": ["GPP","C7Y","E8h","Agp"],
  "brown belt": ["FfQ","C7U","Ef6"],
  "brown coat": ["C7V","Ef7"],
  "brown dwarf": ["HIQ"],
  "brown eyes": ["GPN","Agl","Agm","Agk"],
  "brown hair": ["GPO","Ago","Agn"],
  "brown pants": ["EgH","C7X"],
  "brownies": ["FfR","C7W","EgY"],
  "browse": ["FfT","De9","Ags","EWi"],
  "browse browsed": ["De9"],
  "browse the Internet": ["EWi","De9"],
  "browser": ["HIR"],
  "browsing": ["De9"],
  "browsing the Internet": ["De9"],
  "bruise": ["GPQ","Agt"],
  "Brummie": ["Knr"],
  "Brunei": ["FfU","Agx","Agu"],
  "Bruneian": ["HB0","Kns"],
  "brush": ["GPT","DfB","E8k","DfA","Agz","Ag2","DfC","Eac","EWj","Eby"],
  "brush aside": ["IV5"],
  "brush brushed": ["DfB","EVl","ETl","DfA","DfC"],
  "brush hair": ["GPR","Ag0","E8i","Ag1","Eby"],
  "brush my hair": ["FfZ","EyO"],
  "brush my teeth": ["GPS","Do1","E8j"],
  "brush off": ["IV6"],
  "brush past": ["IV7"],
  "brush teeth": ["GPU","Eac","E8l","Ag6","Ag4","Ag3","Ag7","Ag5"],
  "brush the dog": ["HIS"],
  "brush the floor": ["HIT"],
  "brush up": ["IV9"],
  "brush up against": ["IV8"],
  "brush your hair": ["GPV","DfB"],
  "brush your teeth": ["GPW","DfC","E8m","EWj"],
  "brushed": ["FfV","ETl","EVl"],
  "brushed her hair": ["ETl"],
  "brushed her teeth": ["EVl"],
  "brushing": ["FfW","DfB","Eac","DfA","Eby","DfC"],
  "brushing your hair": ["FfX","DfB"],
  "brushing your teeth": ["FfY","DfC"],
  "Brussels": ["G62"],
  "brutal": ["Jtw"],
  "brutality": ["Jtv"],
  "brute": ["IWA"],
  "bubble": ["GPX","AhA","Ag8","Ag9"],
  "bubble tea": ["GPY","AhH","AhF","AhG","AhI"],
  "bubbles": ["Ffa","AhD","AhC","AhE"],
  "buck": ["IWE"],
  "buck up": ["IWF"],
  "bucket": ["GPZ","C7Z","E8n","AhN","Dxh","AhK","AhL","AhJ"],
  "bucket and spade": ["Ffb","AhM"],
  "buckle": ["IWB"],
  "buckle under": ["IWC"],
  "buckle up": ["IWD"],
  "bud": ["Ffd","EyP"],
  "Budapest": ["G63"],
  "Buddha": ["HIU"],
  "buddhism": ["AhP"],
  "Buddhist": ["HIV"],
  "buddy": ["IWG"],
  "budget": ["HIW","Ffc","AhU","AhS"],
  "budgetary": ["Jtx"],
  "budgie": ["GPa","AhW","AhX","AhV"],
  "Buenos Aires": ["G64"],
  "buff": ["Jt0"],
  "buffalo": ["GPb","Aha","E8o","Ahb","AhZ","AhY"],
  "buffalo wings": ["Ahc"],
  "buffer": ["Jty"],
  "buffet": ["Jtz"],
  "bug": ["GPc","Ahe","E8p","Ahg","Ahf"],
  "bug spray": ["Ffe","Ahh"],
  "bugger": ["Jt1"],
  "build": ["GPf","DfG","Ead","DfD","DfE","DfF","Ahs","Ahk","EWl","Ahj","EWk"],
  "build a bridge": ["HIX"],
  "build a building": ["D9u"],
  "build a house": ["HIY"],
  "build a nest": ["DfD","EWk"],
  "build a robot": ["Fff","EWl","DfE"],
  "build a snowman": ["Ffg","DfF"],
  "build a tower": ["HIZ"],
  "build a wall": ["Ffh","DfG","Ead"],
  "build built": ["Ffi","ESh","DfF","DfD","DfE","DfG"],
  "build on": ["IWH"],
  "build together": ["HIa"],
  "build up": ["IWI"],
  "build with blocks": ["HIb"],
  "builder": ["GPd","Ahl","E8q","Dxi","Aho","Ahn","Ahm"],
  "builders": ["Ffj"],
  "building": ["GPe","Ahr","E8r","Ahq","Ahp","DfG","DfE","Ead","DfD","DfF"],
  "building a nest": ["DfD"],
  "building a robot": ["DfE"],
  "building a snowman": ["DfF"],
  "building a wall": ["Ead","DfG"],
  "building blocks": ["Ffk"],
  "buildings": ["EyQ"],
  "built": ["Ffl","ESh","Do2"],
  "built a wall": ["ESh"],
  "bulb": ["IWJ"],
  "Bulgaria": ["HB2","D9w"],
  "Bulgarian": ["HB1","Knt"],
  "bulge": ["Jt2"],
  "bulk": ["IWK"],
  "bulk up": ["IWL"],
  "bulky": ["Jt3"],
  "bull": ["GPg","C7a","E8s","D9x","Ahx","Ahu","Aht","Ahv"],
  "bulldog": ["Ffm","Ahw"],
  "bullet": ["HIc"],
  "bulletin": ["IWM"],
  "bulletin board": ["G65"],
  "bully": ["IWN"],
  "bum": ["Jt5"],
  "bump": ["Ffo","Ahz","Ah3","Ahy","Ah0"],
  "bump into": ["IWO"],
  "bumper": ["Jt4"],
  "bumper cars": ["Ffn","Ah1","Ah2"],
  "bun": ["GPi","AiJ","E8u","Ah4","Ah5"],
  "bunch": ["Ffq","Ah7","Ah9","Ah6"],
  "bunch of bananas": ["Ffp","Ah8"],
  "bundle": ["IWP"],
  "bungalow": ["Jt6"],
  "bungee jumping": ["Ffr","AiB","AiC"],
  "bunk": ["Jt8"],
  "bunkbed": ["EyR"],
  "bunker": ["Jt7"],
  "bunnies": ["AiD"],
  "bunny": ["GPh","AiI","E8t","AiG","AiE","AiH","AiF"],
  "buns": ["Ffs","AiK"],
  "Bunsen burner": ["HId"],
  "buoy": ["IWQ"],
  "buoyancy": ["HIe"],
  "buoyant": ["AiO","AiM","AiN"],
  "burden": ["AiQ","AiP"],
  "bureau": ["IWT"],
  "bureaucracy": ["IWR"],
  "bureaucrat": ["IWS"],
  "bureaucratic": ["Jt9"],
  "burgeon": ["IWU"],
  "burger": ["GPj","AiZ","E8v","AiT","C7c","AiS","AiR"],
  "burger and chips": ["Fft","AiV"],
  "burger and fries": ["Ffu","AiY","AiX"],
  "burgers": ["GPk","Aic","E8w","Aia","Aib"],
  "burglar": ["JuA"],
  "burglary": ["JuB"],
  "burial": ["JuC"],
  "burial tomb": ["Aid"],
  "Burj Khalifa": ["HIf"],
  "Burmese": ["HB3","Knu","G66"],
  "burn": ["GPl","DfH","E8x","Aig","Aif","Aih"],
  "burn burnt": ["DfH"],
  "burn down": ["IWV"],
  "burn out": ["IWW"],
  "burn the midnight oil": ["D9y","D9z","D90"],
  "burn through": ["IWX"],
  "burner": ["JuD"],
  "burning": ["Ffv","DfH","Ehv","Ehu"],
  "burrito": ["Ffw","Ail","Aii","Dxk","C7d","Aij"],
  "burrow": ["Ffx","Aim"],
  "burst": ["IWc"],
  "burst in": ["IWZ"],
  "burst into": ["IWa"],
  "burst out": ["IWb"],
  "bury": ["Ffy","Do3"],
  "bus": ["GPr","C7i","E81","Ai7","Aio","Ain","Dxm","Aip"],
  "bus driver": ["GPm","Aiq","E8y","Air","Ais"],
  "bus station": ["GPs","Ai9","E82","Ai8","AjA"],
  "bus stop": ["GPt","AjB","E83","C7j","AjD","Do4","AjF","AjE","AjC"],
  "bush": ["GPn","Aiy","E8z","C7e","Aiu","Dxl","Aiv"],
  "bushes": ["Ffz","Aix"],
  "bushfire": ["HIg"],
  "busier": ["C7f"],
  "business": ["GPp","Ai3","DS0"],
  "business person": ["Ff0"],
  "businessman": ["GPo","C7h","E80","DSz","D92","D91","Ai2","Ai0","Ai1","C7g","Aiz"],
  "businesswoman": ["GPq","DS1","Ai6","Ai4","Ai5"],
  "bust": ["JuE"],
  "bust out": ["IWe"],
  "bustle": ["IWd"],
  "busy": ["GPu","AjI","E84","AjH","D93","AjG"],
  "but": ["EyS"],
  "butcher": ["GPv","AjJ","E85","AjL","AjK"],
  "butcher's": ["GPw","Ff1","Do5","E86","AjM","AjO","AjN"],
  "butchery": ["Ff2","AjR","Do5","AjM"],
  "butler": ["IWf"],
  "butter": ["GPy","C7l","E88","Dxo","Aja","AjT","AjU","AjS"],
  "butter up": ["IWg"],
  "butterflies": ["EyT"],
  "butterflies in your stomach": ["D94","D95","D96"],
  "butterfly": ["GPx","C7k","E87","AjV","AjY","Dxn","AjZ","AjX","AjW"],
  "button": ["GPz","C7m","E89","Ajd","Dxp","Ajc","Ajb"],
  "button up": ["IWh"],
  "button your shirt": ["HIh"],
  "buttons": ["Ff3","Aje"],
  "buy": ["GP2","DfL","DfK","DfJ","Eaf","EWn","Eae","DfI","Ajf"],
  "buy a coffee": ["Eae"],
  "buy a ticket": ["HIi"],
  "buy a TV": ["DfI"],
  "buy bought": ["GP0","DfK","DfL","EWL","ESf","DfI","DfJ"],
  "buy coffee": ["DfJ"],
  "buy groceries": ["GP1","DfK","Eaf"],
  "buy off": ["IWi"],
  "buy some food": ["EWn"],
  "buyer": ["JuF"],
  "buying": ["Ff4","DfL","Eaf","DfI","DfJ","DfK","Eae"],
  "buying a TV": ["DfI"],
  "buying coffee": ["DfJ"],
  "buying groceries": ["DfK","Eaf"],
  "buzz": ["Ff5","Ajg"],
  "by": ["JuH"],
  "by accident": ["IWj"],
  "by all means": ["IWk"],
  "by and large": ["IWl"],
  "by bike": ["Ff6"],
  "by boat": ["Ff7"],
  "by bus": ["Ff8"],
  "by car": ["Ff9"],
  "by chance": ["IWm"],
  "by email": ["HIk"],
  "by hand": ["HIl"],
  "by myself": ["HIm"],
  "by oneself": ["IWo"],
  "by product": ["IWp"],
  "by the door": ["HIn"],
  "by the lake": ["Ajk"],
  "by the river": ["Ajl"],
  "by the sea": ["Ajm"],
  "by the way": ["HIo","G67"],
  "by the window": ["HIp"],
  "by train": ["FgA"],
  "by way of": ["IWq"],
  "bye": ["GP3","Aji","Ajh"],
  "bye bye": ["HIj"],
  "bygone": ["IWn"],
  "bypass": ["JuG"],
  "C": ["FkW","DZp","HCG"],
  "c": ["GUI","FBk","DZq","HB4"],
  "cab": ["GP9","Ajo","Ajn","Ajp","Aj5"],
  "cabbage": ["GP4","C7n","E9A","Ajq","Ajr","Dxq"],
  "cabbages": ["FgB","Ajs"],
  "cabin": ["GP6","Ajt","Ajv","Aj0","Ajw"],
  "cabinet": ["GP5","Ajz","E9B","Ajx","Ajy"],
  "cable": ["GP8","Aj1","Aj4"],
  "cable car": ["GP7","Aj2","Aj3"],
  "cache": ["IWr"],
  "cactus": ["GQA","Aj8","Aj6","Aj7"],
  "caddie": ["JuI"],
  "Caesar": ["JuJ"],
  "cafe": ["GQB","C7p","E9C","AkD","AkA","AkB","Aj9","AkC"],
  "cafe latte": ["FgC","C7o","Egp"],
  "cafeteria": ["GQC","AkF","E9D","AkE"],
  "caffeine": ["JuK"],
  "cage": ["GQD","AkJ","E9E","AkI","AkH","AkG"],
  "Cairo": ["G68"],
  "Cajun": ["Knv"],
  "cake": ["GQE","AkN","E9F","AkQ","C7q","AkP","AkK","AkM","Dxr","AkL","AkO"],
  "cakes": ["GQF","AkR"],
  "calamitous": ["IWs"],
  "calcium": ["FgD"],
  "calculable": ["IWt"],
  "calculate": ["HIq","FgE","AkU","AkT","AkS"],
  "calculated risk": ["IWu"],
  "calculation": ["JuL"],
  "calculator": ["GQG","C7s","E9G","AkV","Aka","AkW","Dxs","C7r","AkY","AkZ","AkX"],
  "calculus": ["IWv"],
  "calendar": ["GQH","Akf","E9H","Akd","Ake","Akb","Akc"],
  "calf": ["GQI","Akh","E9I","Akg"],
  "California": ["JuN","D97"],
  "Californian": ["JuM","Knw"],
  "call": ["GQJ","DfN","E9J","DfM","EWo","Aki","Akk","Akl","Akj"],
  "call a friend": ["FgF","DfM"],
  "call back": ["HIr"],
  "call called": ["FgG","ESi","DfN","DfM"],
  "call for": ["IWw"],
  "call forth": ["IWx"],
  "call his grandma": ["D98"],
  "call in": ["IWy"],
  "call it a day": ["IWz"],
  "call off": ["HIt"],
  "call on": ["HIu"],
  "call out": ["IW0"],
  "call someone on the phone": ["EWo"],
  "call up": ["HIv"],
  "called": ["FgH","ESi"],
  "called her": ["ESi"],
  "caller": ["JuO"],
  "calling": ["DfN","DfM"],
  "calling a friend": ["DfM"],
  "Callisto": ["HIs"],
  "calm": ["GQK","Akm","E9K","Akn","Ako"],
  "calm down": ["HIw"],
  "calmly": ["JuP"],
  "calorie": ["EyV","EyU"],
  "cam": ["JuR"],
  "Cambodia": ["GQL","Akt","Akp","D99","Akr","Aks"],
  "Cambodian": ["HB5","Knx","G69"],
  "camcorder": ["FgI"],
  "camel": ["GQM","C7t","E9L","Aku","Dxu","Aky","Akv","Akw","Akx"],
  "camera": ["GQN","C7w","E9M","Dxv"],
  "cameraman": ["FgK","C7v","EAB","C7u"],
  "Cameroon": ["HB7","EAC"],
  "Cameroonian": ["HB6","Kny","G7A"],
  "camouflage": ["FgL","Ak1","Ak0"],
  "camp": ["GQQ","Ak3","E9P","AlB","Ak2"],
  "campaign": ["IW1"],
  "campaigner": ["JuQ"],
  "camper": ["FgM","Ak6","Ak4","Ak5"],
  "campfire": ["GQO","Do6","E9N"],
  "camping": ["GQP","Ak7","E9O","Ak8"],
  "camping tent": ["AlA"],
  "campsite": ["GQR","C7x","AlE","AlC","AlD"],
  "campus": ["IW2"],
  "can": ["GQc","C8A","E9V","AlG","AlI","AlF","Al5","Dx0","AlH","Ed3","Edx","Ed2","Ed1","Ed0","Edv"],
  "can catch a ball": ["HIx"],
  "can climb a tree": ["FgO","C71"],
  "can cook": ["HI1"],
  "can dance": ["HI2"],
  "can draw": ["HI3"],
  "can drive": ["FgP","C73"],
  "can drive a car": ["Edv"],
  "can feed the dog": ["HI4"],
  "can fly a kite": ["HI5"],
  "can hear": ["HI6"],
  "can help": ["HI7"],
  "can i borrow a book": ["EAF"],
  "can i borrow a pen": ["EAG"],
  "can I go": ["HI8"],
  "can jump": ["FgS","C75"],
  "can kick a ball": ["HI9"],
  "can make a cake": ["HJA"],
  "can opener": ["C76"],
  "can plant a tree": ["HJB"],
  "can play football": ["HJC"],
  "can play the guitar": ["HJD"],
  "can play the piano": ["FgV","C77","Edx"],
  "can play the trumpet": ["FgW","C78"],
  "can play the violin": ["C79"],
  "can ride a horse": ["HJE"],
  "can see": ["HJF"],
  "can sing": ["HJG"],
  "can skate": ["HJH"],
  "can speak": ["FgY","C8D"],
  "can speak Chinese": ["C8B","Ed0"],
  "can speak English": ["FgX","C8C","Ed1"],
  "can swim": ["FgZ","C8E","C8F","Ed2"],
  "can talk": ["Ed3"],
  "can throw a ball": ["HJR"],
  "can walk the dog": ["HJh"],
  "can wash the car": ["HJi"],
  "can we play": ["HJj"],
  "can write": ["HJk"],
  "can you hear": ["HJl"],
  "can you repeat that": ["HJm"],
  "can you see": ["HJn"],
  "can you speak French": ["EAK"],
  "can you swim": ["EAL"],
  "can you type": ["EAM"],
  "can't": ["JuX","Fge","EeB","Ed8","Ed9","Ed5","Ed7"],
  "can't afford": ["IXA"],
  "can't catch a ball": ["HJI"],
  "can't climb a tree": ["Fgb","C8G"],
  "can't cook": ["HJJ"],
  "can't dance": ["HJK"],
  "can't draw": ["HJL"],
  "can't drive": ["Fgc","C8H"],
  "can't drive a car": ["Ed5"],
  "can't feed the dog": ["HJM"],
  "can't find it": ["HJN"],
  "can't fly a kite": ["HJO"],
  "can't hear": ["HJP"],
  "can't help": ["IXB","HJQ"],
  "can't kick a ball": ["HJS"],
  "can't make a cake": ["HJT"],
  "can't open it": ["HJU"],
  "can't plant a tree": ["HJV"],
  "can't play football": ["HJW"],
  "can't play the guitar": ["Fgd","C8I"],
  "can't read": ["Fgf","C8J"],
  "can't read a book": ["Ed7"],
  "can't ride a bike": ["Fgg","C8K","Ed8"],
  "can't ride a horse": ["HJX"],
  "can't see": ["HJY"],
  "can't sing": ["HJZ"],
  "can't skate": ["HJa"],
  "can't sleep": ["HJb"],
  "can't stand": ["IXC"],
  "can't swim": ["Fgh","C8L","Ed9"],
  "can't take a bus": ["Fgi","C8M"],
  "can't teach an old dog new tricks": ["EAH","EAI","EAJ"],
  "can't throw a ball": ["HJc"],
  "can't understand": ["Fgj","C8N"],
  "can't understand Chinese": ["EeB"],
  "can't use a computer": ["C8O"],
  "can't wait": ["HJd"],
  "can't walk the dog": ["HJe"],
  "can't wash the car": ["HJf"],
  "can't write": ["HJg"],
  "Canada": ["GQS","AlO","E9Q","C7z","AlJ","Dxw","AlL","AlM","EAD","AlK"],
  "Canada flag": ["C7y"],
  "Canadian": ["GQT","Knz","C70","EeH"],
  "Canadians": ["Krl"],
  "canal": ["IW3"],
  "canary": ["FgN","AlP","AlQ"],
  "Canary Islands": ["JuS"],
  "cancel": ["IW5"],
  "cancel out": ["IW4"],
  "cancellation": ["HIy"],
  "cancelled": ["HIz"],
  "Cancer": ["HI0"],
  "candid": ["IW7"],
  "candidacy": ["JuT"],
  "candidate": ["IW6"],
  "candies": ["GQU","AlT","AlS"],
  "candle": ["GQV","C72","E9R","AlW","AlV","Dxx","AlX","AlU","AlY"],
  "candles": ["GQW","Alc","E9S","AlZ","EAE","Ala","Alb"],
  "candy": ["GQY","C74","E9U","Dxy","Ale","Alk","Alg","Ald","Alf"],
  "candy bar": ["FgQ","Alh"],
  "candy cane": ["GQX","Alj","E9T","Ali"],
  "candy store": ["FgR","All","Alo"],
  "cane": ["GQZ","Alq","Alr","Als","Alp"],
  "cannabis": ["JuU"],
  "canned food": ["FgT","Alt","Alu"],
  "cannibalism": ["IW8"],
  "cannon": ["FgU","Aly","Alv"],
  "canoe": ["GQb","Al1","Al0","Al4","Alz"],
  "canoeing": ["GQa","Al3","Al2"],
  "canon": ["JuW"],
  "canonical": ["JuV"],
  "canopy": ["IW9"],
  "cantaloupe": ["Fga","Al9","AmB","Al6","Al7","AmA"],
  "canteen": ["GQd","AmD","E9W","AmC","AmE"],
  "Canuck": ["Kn0"],
  "canvas": ["Fgk","AmG","AmF"],
  "canvass": ["IXD"],
  "canyon": ["Fgl","EyW"],
  "cap": ["GQg","C8P","E9Y","Dx1","AmL","AmJ","AmK","AmI","AmR"],
  "capability": ["IXE"],
  "capable": ["IXF"],
  "capacity": ["IXG"],
  "cape": ["GQe","AmN","E9X","AmO","AmM"],
  "Cape Town": ["G7B"],
  "capillary": ["IXH"],
  "capita": ["Jua"],
  "capital": ["HJo","GQf","AmQ","AmP"],
  "capital a": ["DZl"],
  "capital b": ["DZn"],
  "capital c": ["DZp"],
  "capital city": ["Fgm","EyX"],
  "capital d": ["DZr"],
  "capital e": ["DZt"],
  "capital f": ["DZv"],
  "capital g": ["DZx"],
  "capital h": ["DZz"],
  "capital i": ["DZ"],
  "capital j": ["DZ3"],
  "capital k": ["DZ5"],
  "capital l": ["DZ7"],
  "capital letter": ["G7C"],
  "capital m": ["DZ9"],
  "capital n": ["DaB"],
  "capital o": ["DaD"],
  "capital p": ["DaF"],
  "capital punishment": ["IXK"],
  "capital q": ["DaH"],
  "capital r": ["DaJ"],
  "capital s": ["DaL"],
  "capital t": ["DaN"],
  "capital u": ["DaP"],
  "capital v": ["DaR"],
  "capital w": ["DaT"],
  "capital x": ["DaV"],
  "capital y": ["DaX"],
  "capital z": ["DaZ"],
  "capitalism": ["IXI"],
  "capitalist": ["IXJ"],
  "capitalization": ["JuY"],
  "capitalize": ["JuZ"],
  "capoeira": ["HJp"],
  "cappuccino": ["C8Q"],
  "Capricorn": ["HJq"],
  "capsule": ["HJr"],
  "captain": ["GQh","AmV","AmU","AmT","AmS"],
  "Captain Cook": ["Jub"],
  "caption": ["IXL"],
  "captivate": ["Juc"],
  "captive": ["IXM"],
  "captivity": ["IXN"],
  "capture": ["AmW","AmX"],
  "car": ["GQt","C8Y","E9g","And","Dx7","AmZ","Amb","Ama","AmY"],
  "car crash": ["Fgr","Amp","Amo","Amq"],
  "car hire": ["HJz"],
  "car park": ["GQq","AnS","E9d","C8V","AnQ","Dx5","AnP"],
  "car parking": ["Fgz","AnR"],
  "car racing": ["GQu","Ane"],
  "car salesman": ["Fg5","C8b","C8a","Dx9"],
  "car wash": ["Fg6","AoA","An9","AoB"],
  "caravan": ["Fgn","Ame","Amd","Amc"],
  "carbohydrate": ["IXO"],
  "carbohydrates": ["Fgo","Ami","Amf","Amg","Amh"],
  "carbon": ["HJu"],
  "carbon dioxide": ["Fgq","Amm","Amn","Aml"],
  "carbon footprint": ["HJs"],
  "carbon monoxide": ["HJt"],
  "carbon neutral": ["IXP"],
  "carbonated": ["Amj"],
  "carbonated water": ["Fgp","Amk"],
  "carcass": ["Jud"],
  "carcinoma": ["Jue"],
  "card": ["GQk","Am3","E9a","Ams","Amr","Amt"],
  "card games": ["HJv"],
  "card machine": ["Am2"],
  "cardboard": ["GQi","Amv","Amw","Amu"],
  "cardiac": ["IXQ"],
  "cardigan": ["GQj","C8R","E9Z","Amz","Amx","Amy","Am0","Dx2"],
  "cardinal": ["IXR"],
  "cardiovascular": ["Juf"],
  "cards": ["GQl","Fgs","C8S","E9b","Am4","Dx3","C8T","Am5"],
  "care": ["GQo","DS5","Am6","AnC"],
  "care about": ["IXS"],
  "care for": ["IXT"],
  "career": ["Fgt","DS2","Am7"],
  "careful": ["GQn","DS4","E9c","AnB","Am8"],
  "careful not to fall": ["HJw"],
  "careful with fire": ["HJx"],
  "careful with scissors": ["HJy"],
  "carefully": ["GQm","DS3","Am9","AnA","ERB"],
  "caregiver": ["Jug"],
  "careless": ["Fgu","Do7"],
  "carer": ["Juh"],
  "caress": ["Jui"],
  "caretaker": ["G7D"],
  "cargo": ["AnD","AnE"],
  "cargo shorts": ["Dx4","C8U"],
  "Caribbean": ["Juj"],
  "caribou": ["IXU"],
  "caricature": ["Juk"],
  "caring": ["GQp","Do8"],
  "carnation": ["Fgv","AnI","AnH"],
  "carnival": ["Jul"],
  "carnivore": ["Fgw","AnK","AnL"],
  "carol singers": ["Fgx","EAN"],
  "carousel": ["Fgy","AnM","AnO","AnN"],
  "carp": ["Jum"],
  "carpenter": ["GQr","C8W","E9e","C8X","AnX","AnU","AnT","AnW","EAO","EAP","Dx6","AnV"],
  "carpet": ["GQs","Anb","E9f","AnZ","AnY","Ana","Anc"],
  "carriage": ["Fg0","Ang","Anf"],
  "carried": ["ESj"],
  "carried a bag": ["ESj"],
  "carrier": ["Jun"],
  "carrot": ["GQv","Ani","Anh","EgZ","Ank","Ann","Anj"],
  "carrot cake": ["Anm"],
  "carrots": ["GQw","C8Z","E9h","Anp","Ano","Dx8"],
  "carry": ["GQx","DfP","E9i","Anu","Ebz","Ant","DfO","Anq","Ans","Eag","DfQ","Anr","EWp"],
  "carry a bag": ["Fg1","Eag","DfO","EWp"],
  "carry a box": ["Fg2","DfP","Ebz"],
  "carry around": ["IXV"],
  "carry books": ["HJ0"],
  "carry boxes": ["HJ1"],
  "carry carried": ["Fg3","DfP","ESj","DfO","DfQ"],
  "carry food": ["HJ2"],
  "carry off": ["IXW"],
  "carry on": ["EyY"],
  "carry out": ["HJ4"],
  "carry over": ["IXX"],
  "carry the baby": ["HJ5"],
  "carry water": ["HJ6"],
  "carrying": ["Fg4","Ebz","DfO","DfP","Eag","DfQ"],
  "carrying a bag": ["Eag","DfO"],
  "carrying a box": ["Ebz","DfP"],
  "carryon": ["HJ3"],
  "cart": ["GQ1","Anv","Anw","Anx","An6"],
  "cartel": ["Juo"],
  "cartilage": ["IXY"],
  "carton": ["GQz","Anz","An3","Any","An0"],
  "carton of milk": ["GQy","An2","An1"],
  "cartoon": ["GQ0","An4","An5"],
  "cartridge": ["Jup"],
  "carve": ["GQ2","An8","An7"],
  "cascade": ["IXZ"],
  "cascara": ["IXa"],
  "case": ["GQ3","AoD","AoE","AoC"],
  "cash": ["GQ5","AoK","E9k","AoH","AoF","AoG"],
  "cash out": ["IXb"],
  "cash register": ["Fg8","AoL","AoM"],
  "cashier": ["GQ4","Fg7","C8c","E9j","C8d","AoJ","EAS","DyA","EAT"],
  "casino": ["Juq"],
  "cask": ["AoN"],
  "Caspian Sea": ["Jur"],
  "cassette": ["IXc"],
  "cast": ["Fg9","AoS"],
  "cast off": ["IXd"],
  "cast out": ["IXe"],
  "caste": ["Jus"],
  "castle": ["GQ6","C8e","E9l","DyB","AoR","AoO","AoQ","AoP"],
  "casual": ["FhA","AoW","AoU","AoT","AoV"],
  "casual dress": ["IXf"],
  "casually": ["Jut"],
  "casualty": ["IXg"],
  "cat": ["GRC","C8g","E9p","Aoz","AoZ","AoX","EAV","AoY","DyD","Aoa","Aob"],
  "cat and mouse": ["FhB","Aoc","Aod","Aof"],
  "catalog": ["IXh"],
  "catalyst": ["IXi"],
  "catapult": ["Aoj","Aoi"],
  "catastrophe": ["IXj"],
  "catastrophic": ["IXk"],
  "catch": ["GQ9","DfR","E9n","Eah","Aok","DfT","Aol","DfS","EWq","Aor","Aom"],
  "catch a ball": ["GQ7","DfR","E9m","Eah","Aon"],
  "catch a bus": ["FhC"],
  "catch a cold": ["FhD","Aop","DS7"],
  "catch a fish": ["FhE","DfS","EWq"],
  "catch a plane": ["HJ7"],
  "catch a train": ["HJ8"],
  "catch caught": ["FhF","EVL","ESk","DfR","DfS","DfT"],
  "catch fire": ["HJ9"],
  "catch fish": ["EAU"],
  "catch me": ["HKA"],
  "catch on": ["IXl"],
  "catch the bus": ["FhH","EyZ"],
  "catch up": ["HKB"],
  "catch up with": ["IXm"],
  "catcher": ["Juu"],
  "catching": ["GQ8","DfR","Eah","DfS","DfT"],
  "catching a ball": ["FhG","DfR","Eah"],
  "catching a fish": ["DfS"],
  "catchy": ["IXn"],
  "categorical": ["Juv"],
  "categorization": ["Juw"],
  "categorize": ["IXo"],
  "category": ["IXp"],
  "cater": ["IXq"],
  "caterpillar": ["GRA","Aos","E9o","Aov","C8f","Aot","DyC","Aow","Aou"],
  "catfish": ["FhI","Aoy","Aox"],
  "cathedral": ["GRB","Do9"],
  "catholic": ["IXr"],
  "cation": ["Jux"],
  "cats": ["GRD","Ao0"],
  "cattle": ["FhJ","Ao1","Ao2"],
  "Caucasian": ["Juy"],
  "Caucasus": ["Juz"],
  "caucus": ["Ju0"],
  "caught": ["FhK","EVL","ESk","Ao3"],
  "caught a fish": ["ESk","EVL"],
  "caught red handed": ["EAW","EAX","EAY"],
  "cauldron": ["GRE","Ao5","Ao7","Ao6"],
  "cauliflower": ["GRF","C8h","E9q","ApD","ApA","DyE","Ao8","ApB","Ao9"],
  "cauliflower cheese": ["ApC"],
  "causal": ["IXs"],
  "cause": ["IXt"],
  "caution": ["FhL","ApF","ApE"],
  "cautious": ["FhM","ApG"],
  "cautiously": ["Ju1"],
  "cavalry": ["Ju2"],
  "cave": ["GRG","ApJ","E9r","ApI","ApH"],
  "cave in": ["IXu"],
  "caveat": ["Ju3"],
  "cavern": ["ApL"],
  "caving": ["FhN"],
  "cavity": ["IXv"],
  "cd": ["GRI","ApP","ApN"],
  "cd player": ["GRH","ApO","E9s"],
  "cds": ["FhO","ApQ"],
  "cease": ["ApR"],
  "ceasefire": ["Ju4"],
  "cedar": ["ApT","ApS"],
  "cede": ["Ju5"],
  "CEFR": ["HKC"],
  "ceiling": ["GRJ","ApX","E9t","ApV","ApU","ApW"],
  "celebrate": ["GRK","DfV","E9u","DfW","DfU","ApZ","ApY","EWr"],
  "celebrate a birthday": ["EAa"],
  "celebrate celebrated": ["DfU","DfV","DfW"],
  "celebrate Christmas": ["FhP","EWr","DfU","EhM","EhL"],
  "celebrate Halloween": ["EAd"],
  "celebrate New Year": ["DfV"],
  "celebrating": ["DfW","DfU","DfV"],
  "celebrating Christmas": ["DfU"],
  "celebrating New Year": ["DfV"],
  "celebration": ["GRL","Apc"],
  "celebrity": ["IXw"],
  "celery": ["GRM","C8i","E9v","Apg","DyF","Apf"],
  "celestial": ["DS8"],
  "celestial body": ["HKD"],
  "cell": ["FhQ","Apu"],
  "cell membrane": ["HKE"],
  "cell phone": ["GRP","Apq","E9w","Apr","Apt","Aps"],
  "cell wall": ["HKF"],
  "cellar": ["GRN","Apl","Apk","Apj"],
  "cellist": ["IXx"],
  "cello": ["GRO","App","Apm","Apn"],
  "cellphone": ["Ju6"],
  "cells": ["Apw"],
  "cellular": ["IXy"],
  "celsius": ["HKG"],
  "Celt": ["Kn2","Kn1"],
  "Celts": ["Krn","Krm"],
  "cement": ["FhR","Apx"],
  "cemetery": ["FhS","Ap0","Ap1","Apy"],
  "censor": ["IXz"],
  "censorship": ["Ju7"],
  "censure": ["Ju8"],
  "census": ["IX0"],
  "cent": ["JvA"],
  "Centaur": ["HKH"],
  "centennial": ["IX1"],
  "center": ["FhT","DpA"],
  "centerpiece": ["Ju9"],
  "centigrade": ["HKI"],
  "centimeter": ["HKJ"],
  "centimetre": ["HKK"],
  "centipede": ["FhU","Ap4","Ap2"],
  "central": ["JvH"],
  "Central America": ["JvC"],
  "Central American": ["JvB"],
  "Central Asia": ["JvE"],
  "Central Asian": ["JvD"],
  "centralize": ["JvF"],
  "centrally": ["JvG"],
  "centre": ["FhV","DpA"],
  "centric": ["IX2"],
  "centrifuge": ["JvI"],
  "century": ["HKL"],
  "CEO": ["FhW","C8k","C8j"],
  "ceramic": ["FhX","Ap9","Ap7","Ap8"],
  "cereal": ["GRQ","C8l","E9x","AqD","AqF","DyG","AqB","AqC"],
  "cereal bar": ["FhY","AqE"],
  "cerebral": ["IX3"],
  "ceremonial": ["IX4"],
  "ceremony": ["FhZ","AqH","AqG"],
  "Ceres": ["HKM"],
  "certain": ["IX5"],
  "certainly": ["HKN"],
  "certainty": ["JvJ"],
  "certificate": ["HKO"],
  "certification": ["JvK"],
  "certify": ["IX6"],
  "certitude": ["IX7"],
  "cervical": ["JvL"],
  "chafe": ["IX8"],
  "chagrin": ["IX9"],
  "chain": ["GRR","AqL","C8m","AqK","AqJ","AqI"],
  "chair": ["GRS","C8n","E9y","DyI","AqO","AqP","AqQ","AqM","AqN"],
  "chair a meeting": ["IYA"],
  "chairman": ["JvM"],
  "chairs": ["GRT","AqU","AqV","AqT","AqS","AqR"],
  "chalet": ["AqW","AqX"],
  "chalk": ["GRU","Aqd","E9z","Aqa","Aqb","AqZ","Aqc"],
  "chalk up": ["IYB"],
  "challenge": ["GRV","Aqg","Aqe","Aqf"],
  "challenger": ["JvN"],
  "challenging": ["Fha","Aqh"],
  "chamber": ["IYC"],
  "chameleon": ["GRW","Aqi","Aqm","Aqk","Aqj","Aql"],
  "champ": ["JvP"],
  "champagne": ["JvO"],
  "champion": ["IYD"],
  "champions league": ["HKP"],
  "championship": ["Fhb","Eya"],
  "chance": ["Fhc","Aqo","Aqn"],
  "chance on": ["IYE"],
  "chancellor": ["JvQ"],
  "change": ["HKS","GRX","DfY","E90","Aqr","DfX","EWs","Aqp","Aqq"],
  "change a lightbulb": ["DfX"],
  "change a nappy": ["HKQ"],
  "change a tyre": ["HKR"],
  "change changed": ["Fhd","DfX","DfY"],
  "change into a butterfly": ["DfY","EWs"],
  "change one's mind": ["IYF"],
  "changing": ["DfX","DfY"],
  "changing a lightbulb": ["DfX"],
  "changing into a butterfly": ["DfY"],
  "channel": ["IYG"],
  "Channel Tunnel": ["HKT"],
  "chant": ["IYH"],
  "chaos": ["Aqs"],
  "chaotic": ["IYI"],
  "chap": ["JvS"],
  "chapel": ["IYJ"],
  "chaplain": ["JvR"],
  "chapter": ["IYK"],
  "char": ["IYU"],
  "character": ["Fhe"],
  "characteristic": ["IYL"],
  "characteristically": ["JvT"],
  "characterization": ["JvU"],
  "characterize": ["IYM"],
  "charades": ["HKU"],
  "charcoal": ["IYN"],
  "charge": ["Fhg","DfZ","EdG","Aqz","Aqx","Dfa"],
  "charge a phone": ["Fhf","DfZ","Dfa"],
  "charge charged": ["ESY","Dfa","DfZ"],
  "charge with": ["IYO"],
  "charge your phone": ["EAh"],
  "charged": ["ESY"],
  "charged my phone": ["ESY"],
  "charger": ["GRY","Aq0","E91","Aq2","Aq1"],
  "charging": ["EdG","Dfa","DfZ"],
  "charging a phone": ["DfZ","Dfa"],
  "charisma": ["IYP"],
  "charismatic": ["IYQ"],
  "charitable": ["IYR"],
  "charity": ["GRZ","Aq6","Aq3","Aq4","Aq5"],
  "charity shop": ["Fhh","Aq7"],
  "Charlemagne": ["JvV"],
  "Charles Darwin": ["JvW","Aq8"],
  "Charles Dickens": ["JvX"],
  "charm": ["IYT"],
  "charming": ["IYS"],
  "chart": ["HKV"],
  "charter": ["IYV"],
  "chase": ["GRa","Dfb","E92","Aq9","EWu","ArA","ArC","ArB"],
  "chase a mouse": ["EWu","Dfb"],
  "chase chased": ["Dfb"],
  "chase off": ["IYW"],
  "chase up": ["IYX"],
  "chased": ["Fhi"],
  "chasing": ["Dfb"],
  "chasing a mouse": ["Dfb"],
  "chaste": ["IYY"],
  "chat": ["GRb","DpB","E93"],
  "chat online": ["Fhj"],
  "chat up": ["IYa"],
  "chat with my friends": ["Fhk"],
  "chateau": ["Eyb"],
  "chatter": ["IYZ"],
  "chauffeur": ["Fhl","C8o"],
  "cheap": ["GRc","C8s","EAk","ArD","ArE"],
  "cheaper": ["Fhm","C8q","C8r"],
  "cheaply": ["JvY"],
  "cheat": ["Fhn","DS9"],
  "cheat on": ["IYb"],
  "check": ["GRe","DTC","E95","Dfc","EWv"],
  "check checked": ["Dfc"],
  "check electricity": ["EAl"],
  "check in": ["GRd","DTB","E94"],
  "check off": ["IYc"],
  "check on": ["IYd"],
  "check out": ["HKY"],
  "check teeth": ["EAm"],
  "check the bill": ["DTD"],
  "check the dog": ["EWv","Dfc"],
  "checked": ["DTA"],
  "checker": ["JvZ"],
  "checkers": ["HKW"],
  "checkin": ["HKX"],
  "checking": ["Dfc"],
  "checking the dog": ["Dfc"],
  "checklist": ["Jva"],
  "checkout": ["HKZ"],
  "checkpoint": ["Jvb"],
  "cheek": ["GRf","ArF","E96"],
  "cheeks": ["GRg","DTE"],
  "cheer": ["GRi","ArM","DTH"],
  "cheer on": ["IYe"],
  "cheer up": ["HKb"],
  "cheerful": ["GRh","DTF","E97","ArG","EAn"],
  "cheerfully": ["Jvc"],
  "cheerleader": ["DTG","ArK","ArH"],
  "cheers": ["HKa","G7E"],
  "cheese": ["GRj","C8u","E98","Are","DyL","ArO","ArQ","ArR","ArP","ArN"],
  "cheese and tomato": ["ArS"],
  "cheese burger": ["C8t"],
  "cheese sandwich": ["GRk","Arg","Arf"],
  "cheese toastie": ["Ega","C8v"],
  "cheeseburger": ["Fho","ArX","ArU","ArY","ArV"],
  "cheesecake": ["Fhp","Ard","Arc","ArZ"],
  "cheetah": ["GRl","Arj","E99","Ari","Arh"],
  "chef": ["GRm","C8x","FAA","EAo","Arp","C8w","Arm","EAp","Arn","Arl","DyM","Ark","Aro"],
  "chemical": ["Fhr"],
  "chemical engineer": ["Fhq","C8y","C8z"],
  "chemical equation": ["HKc"],
  "chemical fertilizer": ["Arq"],
  "chemical formula": ["HKd"],
  "chemical industry": ["HKe"],
  "chemical reaction": ["HKf"],
  "chemicals": ["HKg"],
  "chemist": ["GRn","DpC"],
  "chemist's": ["Fhs","Eyc"],
  "chemistry": ["GRo","C80","FAB","DTI","DyN","Aru","Ars","Art"],
  "chemotherapy": ["Jvd"],
  "cheque": ["Jve"],
  "chequers": ["HKh"],
  "cherish": ["Arw"],
  "Cherokee": ["Kn3"],
  "cherries": ["GRp","C81","FAC","Arx","Arz","Ary","DyO"],
  "cherry": ["GRq","Ar2","Egb"],
  "cherry blossom": ["HKi"],
  "cherry pie": ["Ar0"],
  "Chesapeake Bay": ["Jvf"],
  "chess": ["GRr","Fht","C82","FAD","Ar6","Ar4","Ar5","DyP","Ar3"],
  "chest": ["GRt","AsB","FAE","Ar7"],
  "chest of drawers": ["GRs","Ar8","AsA","Ar9"],
  "chest x ray": ["AsC"],
  "chestnut": ["Jvg"],
  "chew": ["IYi"],
  "chew on": ["IYf"],
  "chew out": ["IYg"],
  "chew over": ["IYh"],
  "chewing gum": ["Fhu","AsE"],
  "chewy": ["Eyd"],
  "chic": ["IYk"],
  "Chicago": ["G7F"],
  "chichen itza": ["AsF"],
  "chick": ["GRv","Asb","FAG","AsG","AsH"],
  "chicken": ["GRu","AsL","FAF","C87","AsT","AsJ","C83","DyQ","AsI","Egc","AsM","AsK","DyR"],
  "chicken and rice": ["C84"],
  "chicken leg": ["Fhv","AsO","C85","AsN"],
  "chicken nugget": ["AsQ","AsR","AsP"],
  "chicken nuggets": ["Fhw","AsS","C86"],
  "chicken out": ["IYj"],
  "chicken wing": ["Fhx","C88","AsU"],
  "chicken wings": ["Fhy","AsX","AsW","AsV"],
  "chickpeas": ["Fhz","Asa","AsZ"],
  "chief": ["IYm"],
  "chief claim to fame": ["IYl"],
  "chiefly": ["Jvh"],
  "child": ["GRw","Asf","FAH","Ase","Asc","Asd","EAq"],
  "child development": ["HKj"],
  "childhood": ["Eye"],
  "childish": ["Jvi"],
  "children": ["GRx","Ash","FAI","Asg","Asj","Asi"],
  "Chile": ["HB9","EAr"],
  "Chilean": ["HB8","Kn4"],
  "chili": ["GRy","Ask","FAJ","Asl","Egd","Asm","Asn"],
  "chili peppers": ["Asp","Asq","Asr","Ass"],
  "chilies": ["Fh0","C89","DyS"],
  "chill": ["Fh4","Ast"],
  "chill out": ["IYn"],
  "chilli": ["Fh3","Ask","Asn","Asm","Asl"],
  "chilli peppers": ["Fh2","Asp","Asr","Asq","Ass"],
  "chillies": ["Fh1","DyS","C89"],
  "chilly": ["Fh5","Asu"],
  "chime": ["Jvj"],
  "chime in": ["IYo"],
  "chimney": ["GRz","Asy","FAK","Asx","C9A","Asw","DyT"],
  "chimp": ["GR1","As3"],
  "chimpanzee": ["GR0","As1","As0","As2"],
  "chin": ["GR4","C9F","FAN","As4","DyW","AtF","As5"],
  "China": ["GR2","AtA","FAL","C9C","As6","As7","EAs","As8","DyU","As9"],
  "China flag": ["Fh6","C9B"],
  "Chinese": ["HCA","C9D","Kn5","GR3","C9E","FAM","EeI","DyV","AtE","AtC","AtB"],
  "Chinese Mythology": ["HKk"],
  "Chinese New Year": ["Fh7","AtD"],
  "Chinese Phoenix": ["HKl"],
  "chip": ["IYr"],
  "chip away": ["IYp"],
  "chip in": ["IYq"],
  "chips": ["GR5","AtI","FAO","AtL","AtH","DyX","AtJ","AtG","AtK"],
  "chips and dip": ["C9G"],
  "chirp": ["Fh8","AtN"],
  "chisel": ["Fh9","AtO","AtR"],
  "chivalrous": ["IYs"],
  "chloride": ["Jvk"],
  "chlorine": ["HKm"],
  "chlorophyll": ["HKn"],
  "chocolate": ["GR8","AtT","FAQ","C9I","AtU","Atg","DyY","AtV","AtS"],
  "chocolate bar": ["GR6","AtY","AtX","AtW","AtZ"],
  "chocolate cake": ["GR7","Atb","FAP","Ata","Atc","Atd","Ate"],
  "chocolate milk": ["FiA","Atf"],
  "chocolate milkshake": ["C9H"],
  "choice": ["FiB","Ati","Atj","Ath"],
  "choir": ["GR9","Atl","Atk"],
  "choke": ["FiC","Atm"],
  "choke back": ["IYt"],
  "cholera": ["Jvl"],
  "cholesterol": ["IYu"],
  "choose": ["GSA","Ato","Atn"],
  "chop": ["GSB","Dfd","FAR","Atr","Eai","Atp","Atq"],
  "chop an onion": ["Eai","Dfd"],
  "chop chopped": ["Dfd"],
  "chop vegetables": ["HKo"],
  "chopping": ["Dfd","Eai"],
  "chopping an onion": ["Eai","Dfd"],
  "chopping board": ["FiD","C9J","DyZ"],
  "choppy": ["IYv"],
  "chopsticks": ["GSC","C9K","FAS","Dya","Atx","Att","Atu","Atv","Ats"],
  "chord": ["HKp"],
  "chords": ["HKq"],
  "chore": ["IYx"],
  "choreograph": ["IYw"],
  "choreographer": ["Jvm"],
  "chorus": ["IYy"],
  "chow": ["IYz"],
  "Christ": ["AuF"],
  "Christ the Redeemer": ["AuG"],
  "Christmas": ["GSF","C9L","FAT","At7","Atz","EhM","Aty","EhL","EhN"],
  "Christmas candle": ["GSD","At1","At2","EAt","At0"],
  "Christmas decorations": ["FiE","EhX"],
  "Christmas dinner": ["GSE","At4","At6","At5","EhL","At3"],
  "Christmas elf": ["FiF","Ehb"],
  "Christmas gift": ["FiG","Ehg"],
  "Christmas gifts": ["Ehh"],
  "Christmas morning": ["EhM"],
  "Christmas present": ["FiH","Ehg"],
  "Christmas presents": ["FiI","Ehh"],
  "Christmas reindeer": ["Eh0"],
  "Christmas sleigh": ["FiJ","Eh4"],
  "Christmas snowman": ["FiK","Eh8"],
  "Christmas stocking": ["GSG","At8","AuA","AuB","At9","Eh9"],
  "Christmas tree": ["GSH","FiL","C9M","FAU","EiG","AuC","AuE","AuD","EAu"],
  "Christmas turkey": ["EiH"],
  "Christmas wreath": ["EiK"],
  "chromatin": ["Jvn"],
  "chromosome": ["HKr"],
  "chronic": ["IY2"],
  "chronical": ["IY0"],
  "chronicle": ["IY1"],
  "chronological": ["IY3"],
  "chronology": ["IY4"],
  "chrysanthemum": ["FiM","AuH","AuI"],
  "chubby": ["FiN","AuK","AuJ","AuL","AuM"],
  "chuck": ["Jvp"],
  "chuckle": ["Jvo"],
  "chunk": ["IY5"],
  "church": ["GSI","C9N","FAV","Dyb","AuN","AuQ","AuP","AuO"],
  "churchyard": ["Jvq"],
  "churn": ["Jvr"],
  "churn up": ["IY6"],
  "churro": ["FiO","AuR","AuS"],
  "cider": ["IY7"],
  "cigar": ["Jvt"],
  "cigarette": ["Jvs"],
  "Cinderella": ["FiP","AuV","AuU"],
  "cinema": ["GSJ","AuZ","AuX","AuY"],
  "cipher": ["IY8"],
  "circle": ["GSK","Aua","FAW","Aub","Auc"],
  "circle the answer": ["HKs"],
  "circuit": ["HKt"],
  "circuits": ["HKu"],
  "circular": ["IY9"],
  "circular saw": ["Auf"],
  "circulate": ["IZA"],
  "circulation": ["HKv"],
  "circulatory system": ["HKw"],
  "circumference": ["IZB"],
  "circumstance": ["IZC"],
  "circus": ["GSL","Aul","FAX","Auk","Auj","Aui"],
  "citadel": ["Aum"],
  "citation": ["Jvu"],
  "cite": ["IZD"],
  "citizen": ["HKx"],
  "citizenship": ["HKy"],
  "city": ["GSM","Aut","FAY","Auq","Aun","Aup","Auo"],
  "city hall": ["FiQ","Aur","Aus"],
  "City of London": ["Jvv"],
  "civic": ["IZE"],
  "civil": ["HKz"],
  "civil engineer": ["FiR","C9P","EAv"],
  "civil servant": ["IZG"],
  "civilian": ["IZF"],
  "civilization": ["FiS","Auv","Auu"],
  "civilize": ["Jvw"],
  "clad": ["Jvx"],
  "claim": ["IZH"],
  "claimant": ["Jvy"],
  "clam": ["GSN","Aux","Auw"],
  "clam up": ["IZK"],
  "clamber": ["Jvz"],
  "clamor": ["IZI"],
  "clamp": ["Jv0"],
  "clamp down on": ["IZJ"],
  "clams": ["FiT","Au0","Auz"],
  "clan": ["IZL"],
  "clap": ["GSO","Au5","FAZ","Au4","Au1","Au3"],
  "clap your hands": ["HK0"],
  "clarification": ["Jv1"],
  "clarify": ["IZM"],
  "clarinet": ["GSP","Au7","Au9","Dyc","C9Q"],
  "clarity": ["Jv2"],
  "clash": ["Jv3"],
  "clasp": ["AvA"],
  "class": ["GSS","AvL","AvB"],
  "classic": ["AvI","AvD"],
  "classical": ["FiV","AvH","AvE"],
  "classical music": ["FiU","Eyf","AvG","AvF"],
  "classification": ["Jv4"],
  "classify": ["IZN"],
  "classmate": ["GSQ","AvJ","FAa"],
  "classmates": ["GSR","AvK"],
  "classroom": ["GST","FiW","C9R","FAb","AvO","AvM","AvN"],
  "clatter": ["Jv5"],
  "clause": ["Jv6"],
  "claw": ["GSU","AvQ","FAc","AvP"],
  "claws": ["GSV","AvR","FAd"],
  "clay": ["GSW","DpD"],
  "clay pot": ["Eyg"],
  "clean": ["GSZ","Dfe","C9W","Dff","AvS","EWw","Ava","EA3"],
  "clean as a whistle": ["EAx","EAy","EAz"],
  "clean cleaned": ["FiX","Dfe","ETm","Dff"],
  "clean dishes": ["EA0"],
  "clean off": ["IZO"],
  "clean out": ["IZP"],
  "clean teeth": ["Fib","Avb"],
  "clean the board": ["HK1"],
  "clean the car": ["HK2"],
  "clean the floor": ["Fic","Dfe","EA4"],
  "clean the house": ["GSa","Avc","Avd"],
  "clean the room": ["HK3"],
  "clean the window": ["GSb","Dff"],
  "clean the windows": ["HK4"],
  "clean up": ["GSc","Ave","FAf","Avf"],
  "clean windows": ["Fid","EWw","EA5"],
  "clean your teeth": ["HK5"],
  "cleaned": ["FiY","FiZ","ETm"],
  "cleaned the floor": ["ETm"],
  "cleaner": ["GSX","C9S","AvV","C9V","AvW","C9T","C9U","AvX","AvT","AvU","EA1","ERh","EA2","Dyd"],
  "cleaning": ["GSY","Dfe","FAe","Dff","AvZ","AvY"],
  "cleaning the floor": ["Fia","Dfe"],
  "cleaning the window": ["Dff"],
  "cleanse": ["Jv7"],
  "cleanup": ["Avg"],
  "clear": ["GSd","Avi","Avh"],
  "clear cut": ["IZQ"],
  "clear out": ["IZR"],
  "clear sky": ["Fie","Avj","Avk"],
  "clear the table": ["Fif","Eyh"],
  "clear up": ["IZS"],
  "clearance": ["Jv8"],
  "clearly": ["Jv9"],
  "cleave": ["JwA"],
  "cleaver": ["Fig","C9X","Avl"],
  "clench": ["IZT"],
  "Cleopatra": ["JwB"],
  "clergy": ["JwD"],
  "clergyman": ["JwC"],
  "cleric": ["JwF"],
  "clerical": ["JwE"],
  "clerk": ["Fih","Avq","Avp"],
  "clever": ["GSe","Avr","FAg","Avt","Avs"],
  "cliche": ["JwG"],
  "click": ["GSf","Dfg","FAh","Avw"],
  "click clicked": ["ESZ","Dfg"],
  "click on": ["Fii","DpE"],
  "click the mouse": ["Dfg"],
  "clicked": ["ESZ"],
  "clicked the mouse": ["ESZ"],
  "clicking": ["Dfg"],
  "clicking the mouse": ["Dfg"],
  "client": ["HK6"],
  "clientele": ["JwH"],
  "cliff": ["GSg","Avx","FAi","Avz","Avy"],
  "cliffs": ["Fij","Dyf","C9Y","Av1","Av0"],
  "climate": ["GSi","Av7","Av4","Av2","Av3"],
  "climate change": ["GSh","Av5","Av6"],
  "climatic": ["IZU"],
  "climax": ["JwI"],
  "climb": ["GSl","Dfj","FAl","Dfh","Dfk","EWy","AwD","Av8","EdL","EWx","Dfi"],
  "climb a mountain": ["Fik","Dfi","EdL","EWx"],
  "climb a tree": ["GSj","Dfj","FAj","EWy"],
  "climb a wall": ["HK7"],
  "climb carefully": ["HK8"],
  "climb climbed": ["EWO","ESl","Dfh","Dfi","Dfj","Dfk"],
  "climb down": ["HK9"],
  "climb the stairs": ["HLB"],
  "climb up": ["HLC"],
  "climbed": ["Fil","EWO","ESl"],
  "climbed a tree": ["ESl"],
  "climbed the mountain": ["EWO"],
  "climber": ["Fim","Av9"],
  "climbing": ["GSk","Dfk","FAk","AwC","Dfj","Dfh","AwB","EdL","Dfi"],
  "climbing a mountain": ["EdL","Dfi"],
  "climbing a tree": ["Dfj"],
  "climbing wall": ["HLA"],
  "clinch": ["JwJ"],
  "cling": ["IZW"],
  "cling on": ["IZV"],
  "clinic": ["GSm","AwE","FAm","AwF"],
  "clinical": ["JwL"],
  "clinically": ["JwK"],
  "clinician": ["JwM"],
  "clip": ["GSn","AwG"],
  "clipboard": ["Fin","C9Z"],
  "clipper": ["IZX"],
  "cloak": ["JwN"],
  "cloakroom": ["G7G"],
  "clock": ["GSo","C9a","FAn","AwK","Dyh","AwL","AwJ","AwH","AwI"],
  "clock in clock out": ["IZY"],
  "clocks": ["Fio","AwM"],
  "clockwise": ["IZZ"],
  "clog": ["IZa"],
  "clone": ["IZb"],
  "cloning": ["IZc"],
  "close": ["GSp","Dfp","FAo","Dfo","Dfl","EW0","Eb0","Dfn","Dfm","Eak","EWz"],
  "close a book": ["HLD"],
  "close a door": ["HLE"],
  "close a laptop": ["Fip","Dfm"],
  "close a window": ["Fiq","Dfn"],
  "close call": ["IZd"],
  "close closed": ["Fir","ESa","Dfm","Dfn","Dfo","Dfl","Dfp"],
  "close down": ["HLF"],
  "close in on": ["IZe"],
  "close in the evening": ["EWz"],
  "close laptop": ["Eb0"],
  "close off": ["IZf"],
  "close the book": ["HLG"],
  "close the door": ["HLH"],
  "close the gate": ["HLI"],
  "close the window": ["Fit","Dfp","Eak","EW0"],
  "close up": ["IZg"],
  "close your book": ["Fiu"],
  "close your eyes": ["HLJ"],
  "close your mouth": ["HLK"],
  "closed": ["Fis","DpF","ESa"],
  "closed my laptop": ["ESa"],
  "closely": ["ERJ"],
  "closeness": ["JwO"],
  "closet": ["GSq","C9b","FAp","AwN","Dyi"],
  "closing": ["Eb0","Eak","Dfo","Dfl","Dfm","Dfn","Dfp"],
  "closing a laptop": ["Dfm"],
  "closing a window": ["Dfn"],
  "closing the window": ["Dfp","Eak"],
  "closure": ["JwP"],
  "cloth": ["Fix","Awc"],
  "clothe": ["JwQ"],
  "clothes": ["GSr","AwT","FAq","AwO","AwP"],
  "clothes line": ["Fiv","AwS","AwR"],
  "clothes lines": ["C9c"],
  "clothes peg": ["G7H"],
  "clothes rack": ["AwU","AwV","AwW"],
  "clothes shop": ["GSs","AwX","FAr","AwZ","Awb","AwY","Awa"],
  "clothes store": ["Fiw"],
  "clothespin": ["G7I"],
  "clothing": ["JwR"],
  "clothing store": ["GSt","DpG"],
  "cloud": ["GSu","Awg","FAs","Awd","Awe","Awi","Awf","Awh"],
  "cloud over": ["IZh"],
  "clouds": ["GSv","C9d","FAt","Awj","Awo","Awn","Awm","Dyk","Awl","Awk"],
  "cloudy": ["GSw","Awq","FAu","C9f","C9e","Awp","EA6","EhO","Awr"],
  "clout": ["JwS"],
  "clown": ["GSx","C9h","FAv","Awu","Aws","Awv","Awx","EA8","Awt","Dyl","EA7","C9g"],
  "clown mask": ["Aww"],
  "club": ["GSy","Awz","Awy"],
  "clubhouse": ["JwT"],
  "clue": ["GSz","Aw1","Aw0"],
  "clue in": ["IZi"],
  "clump": ["IZj"],
  "clumsy": ["IZk"],
  "clunky": ["Eyi"],
  "cluster": ["Aw2"],
  "clutch": ["IZl"],
  "clutter": ["JwU"],
  "clutter up": ["IZm"],
  "CO2": ["HLL"],
  "coach": ["GS0","C9j","DpH","Aw5","Aw6","EBA","C9i","Aw4","Aw3"],
  "coal": ["Fiy","AxB","AxA","Aw7","Aw9","Aw8"],
  "coal miner": ["EBC","EBB","C9k","C9l"],
  "coalition": ["IZn"],
  "coarse": ["IZo"],
  "coast": ["HLN","GS1","AxC","FAw","AxD","AxE"],
  "coastal": ["HLM"],
  "coastline": ["IZp"],
  "coat": ["GS2","C9o","FAx","AxF","Dyo","AxH","AxI","AxK","AxG"],
  "coat hangar": ["C9m"],
  "coat hanger": ["Dym"],
  "coat hook": ["C9n"],
  "coat rack": ["Fiz","C9p","Dyp","AxM"],
  "coathook": ["AxJ"],
  "coax": ["JwV"],
  "cobble": ["JwW"],
  "cobbler": ["AxQ"],
  "cobblestone": ["AxS","AxR"],
  "cobra": ["Fi0","AxU","AxT"],
  "cobweb": ["Fi1","AxY","AxZ"],
  "coca cola": ["Fi2","Axd","Axb","Axc"],
  "cocaine": ["JwX"],
  "cock": ["Eyj"],
  "cockerel": ["Fi3","Axg","Axe","Axf"],
  "Cockney": ["Kn7","Kn6"],
  "cockpit": ["JwY"],
  "cockroach": ["GS3","Axh","FAy","Axj","Axo","Axi","Axk"],
  "cockroaches": ["Fi4","Axn","Axl","Axm"],
  "cocktail": ["JwZ"],
  "cocoa": ["Fi5","Axp","Axr","Axs"],
  "coconut": ["GS4","Axu","FAz","Ax4","Axv","Axw","Ege","Egf","Axt","Axx"],
  "coconut juice": ["Axy","Axz"],
  "coconut milk": ["Fi6","Ax2","Ax3","Ax0","Ax1"],
  "coconuts": ["Fi7","Ax9","Ax6","Ax7","Ax8"],
  "cod": ["Jwa"],
  "code": ["IZq"],
  "codify": ["IZr"],
  "coding": ["Fi8","AyB","AyC"],
  "coefficient": ["IZs"],
  "coercion": ["Jwb"],
  "coexist": ["IZt"],
  "coffee": ["GS6","C9r","FA0","AyG","AyD","AyJ","Dys","AyF","AyH","AyE","AyI"],
  "coffee machine": ["GS5","C9q","Dyr"],
  "coffee shop": ["G7M","G7L","G7K","G7J","GS7","AyP","FA1","AyK","AyM","AyN"],
  "coffee table": ["GS8","AyR","FA2","AyT","AyS","AyQ"],
  "coffin": ["Fi9","DpI"],
  "cognition": ["IZu"],
  "cognitive": ["IZv"],
  "cohabitation": ["IZw"],
  "cohere": ["IZy"],
  "coherence": ["Jwc"],
  "coherent": ["IZx"],
  "cohesion": ["IZz"],
  "cohesive": ["IZ0"],
  "cohort": ["Jwd"],
  "coil": ["IZ1"],
  "coin": ["GS9","AyU","FA3","AyX","AyW","AyV"],
  "coincide": ["IZ2"],
  "coincidence": ["Jwe"],
  "coins": ["GTA","C9s","FA4","Ayc","Ayb","Ayd","Dyt","AyY","Aya"],
  "coke": ["GTB","DpJ","FA5"],
  "cola": ["GTC","C9t","FA6","Dyu","Ayh","Aye","Ayg","Ayi","Ayf"],
  "cold": ["GTD","FjB","C9x","FA7","C9u","EBE","Aym","Ayk","EhQ","EhP","C9v","Ayl","Ayj"],
  "cold day": ["HLO"],
  "cold drink": ["HLP"],
  "cold front": ["HLQ"],
  "cold hands": ["HLR"],
  "cold weather": ["HLS"],
  "colder": ["FjA","C9w"],
  "coldly": ["Jwf"],
  "coli": ["Jwg"],
  "colitis": ["Jwh"],
  "collaborate": ["IZ3"],
  "collaboration": ["Jwi"],
  "collaborative": ["IZ4"],
  "collaborator": ["IZ5"],
  "collapse": ["FjC","Ayo","Dfq","Ayn","Ayp"],
  "collapse collapsed": ["EUg","Dfq"],
  "collapsed": ["EUg"],
  "collapsing": ["Dfq"],
  "collar": ["FjD","DpK"],
  "collateral": ["Jwj"],
  "colleague": ["IZ6"],
  "collect": ["GTE","Ays","FA8","Ayq","Dfr","EW1"],
  "collect collected": ["Dfr"],
  "collect eggs": ["HLT"],
  "collect garbage": ["Dfr"],
  "collect shells": ["Eyk"],
  "collect stamps": ["FjG","DpL"],
  "collect trash": ["EW1"],
  "collecting": ["FjE","Dfr"],
  "collecting garbage": ["Dfr"],
  "collection": ["FjF","Ayr"],
  "collective": ["IZ7"],
  "collectively": ["Jwk"],
  "collector": ["Jwl"],
  "college": ["GTF","Ayz","Ayx","Ayv","Ayy"],
  "collide": ["IZ8"],
  "collision": ["IZ9"],
  "colloquial": ["IaA"],
  "Colombia": ["HCC","EBG"],
  "Colombian": ["HCB","Kn8"],
  "colon": ["Jwo"],
  "colonel": ["Ay0"],
  "colonial": ["IaB"],
  "colonic": ["Jwm"],
  "colonist": ["Jwn"],
  "colonization": ["IaC"],
  "colonize": ["IaD"],
  "colony": ["FjH","Ay1"],
  "color": ["GTJ","Ay3","FBA","AzI","Ay2"],
  "color pen": ["AzH"],
  "Colorado": ["Jwp"],
  "colored pencil": ["GTG","Ay4","Ay5","Ay6","Ay7"],
  "colored pencils": ["GTH","Ay6","FA9","Ay5","Ay7","Ay4"],
  "colorful": ["GTI","Ay9","Ay8","C9y","AzB","EBH","EhR","EhS","AzA"],
  "coloring book": ["FjI","AzC","AzE"],
  "coloring picture": ["AzF","AzG"],
  "colors": ["GTK","AzJ","FBB","AzK","AzL","DpN"],
  "colossal": ["IaE"],
  "colosseum": ["FjJ","AzQ","AzO"],
  "Colossus of Rhodes": ["HLU"],
  "colour": ["FjL","AzI","Ay2","Ay3"],
  "colour pen": ["AzH"],
  "coloured pencil": ["Ay5","Ay4","Ay6","Ay7"],
  "coloured pencils": ["GTL","DpM"],
  "colourful": ["FjK","AzB","Ay9","AzA","EBH","C9y","Ay8"],
  "colouring book": ["AzC","AzE"],
  "colouring picture": ["AzG","AzF"],
  "colours": ["GTM","DpN","AzJ","AzL","AzK"],
  "Columbus": ["Jwq"],
  "column": ["FjM","AzR","AzS","AzW"],
  "columnist": ["IaF"],
  "comb": ["GTN","C9z","FBC","AzX","Dfs","AzY","Eb1","Dyv","Azc","AzZ","EW2","Dft"],
  "comb combed": ["Dft","Dfs"],
  "comb hair": ["FjN","Aza","Eb1"],
  "comb her hair": ["FjO","Dfs"],
  "comb my hair": ["FjQ","Eyl"],
  "comb through": ["IaI"],
  "comb your hair": ["GTO","Dft","EW2"],
  "combat": ["IaG"],
  "combatant": ["Jwr"],
  "combination": ["IaH"],
  "combine": ["FjP","Azb"],
  "combing": ["Eb1","Dft","Dfs"],
  "combing her hair": ["Dfs"],
  "combing your hair": ["Dft"],
  "combo": ["Jws"],
  "combustible": ["IaJ"],
  "combustion": ["HLV"],
  "come": ["GTS","Dfu","FBE"],
  "come about": ["IaK"],
  "come across": ["Eym"],
  "come along": ["HLW"],
  "come around": ["IaL"],
  "come back": ["HLX"],
  "come by": ["IaM"],
  "come came": ["GTP","Dfu"],
  "come down": ["IaN"],
  "come down to": ["IaO"],
  "come down with": ["FjS"],
  "come early": ["HLY"],
  "come forward": ["IaP"],
  "come from": ["EW3"],
  "come from America": ["FjT","Dfu","EW3","EeD"],
  "come from Argentina": ["EeE"],
  "come from Australia": ["EeF"],
  "come from Brazil": ["EeG"],
  "come from Canada": ["EeH"],
  "come from China": ["EeI"],
  "come from Egypt": ["EeJ"],
  "come from England": ["EeK"],
  "come from France": ["EeL"],
  "come from Germany": ["EeM"],
  "come from India": ["EeN"],
  "come from Ireland": ["EeO"],
  "come from Italy": ["EeP"],
  "come from Japan": ["EeQ"],
  "come from Mexico": ["EeR"],
  "come from Russia": ["EeS"],
  "come from South Africa": ["EeT"],
  "come from Spain": ["EeU"],
  "come from Thailand": ["EeV"],
  "come from Turkey": ["EeW"],
  "come here": ["FjU","DpQ"],
  "come home": ["Eyn"],
  "come in": ["GTR","Azd"],
  "come in for": ["IaQ"],
  "come into": ["IaR"],
  "come late": ["HLZ"],
  "come on": ["HLa"],
  "come out": ["HLb"],
  "come out of": ["IaS"],
  "come over": ["HLc"],
  "come through": ["IaT"],
  "come to": ["IaV"],
  "come to an end": ["IaU"],
  "come true": ["IaW"],
  "come up": ["IaX"],
  "come up to": ["IaY"],
  "come up with": ["HLd"],
  "come with me": ["HLe"],
  "comeback": ["Jwt"],
  "comedian": ["FjR","DpO"],
  "comedy": ["GTQ","DpP","FBD"],
  "comet": ["GTT","Azh","FBF","Azf","Azg","Aze"],
  "comfort": ["Azj","Azk"],
  "comfortable": ["GTU","Azl","FBG","DTJ","Azn","Azo","Azm"],
  "comfortably": ["ERS"],
  "comforter": ["Azp"],
  "comic": ["FjV"],
  "comic book": ["GTV","Azs","FBH"],
  "comics": ["FjW"],
  "coming": ["Dfu"],
  "coming from America": ["Dfu"],
  "comma": ["G7N"],
  "command": ["IaZ"],
  "commander": ["Jwu"],
  "commandment": ["Jwv"],
  "commando": ["Jww"],
  "commemorate": ["Iaa"],
  "commence": ["Iab"],
  "commencement": ["Jwx"],
  "commend": ["Jwy"],
  "comment": ["Iad"],
  "commentary": ["Iac"],
  "commentator": ["Jwz"],
  "commenter": ["Jw0"],
  "commerce": ["Iae"],
  "commercial": ["Jw2"],
  "commercially": ["Jw1"],
  "commission": ["Iaf"],
  "commissioner": ["Jw3"],
  "commit": ["Iag"],
  "commitment": ["Jw4"],
  "committee": ["Iah"],
  "commodity": ["Iai"],
  "common": ["FjX","DpR"],
  "commonly": ["Jw5"],
  "commonplace": ["Iaj"],
  "Commonwealth Games": ["HLf"],
  "communal": ["DTM"],
  "communal house": ["FjY","DTL"],
  "commune": ["Iak"],
  "communicate": ["FjZ","DpS"],
  "communication": ["GTW","DpT"],
  "communicative": ["Jw6"],
  "communion": ["Jw7"],
  "communism": ["Jw8"],
  "communist": ["Jw9"],
  "community": ["GTX","DTN","FBI","Azt"],
  "community service": ["Ial"],
  "commute": ["Iam"],
  "commuter": ["JxA"],
  "compact": ["Ian"],
  "companion": ["Azx"],
  "company": ["GTY","DTP"],
  "comparable": ["Iao"],
  "comparative": ["Iap"],
  "comparatively": ["JxB"],
  "compare": ["Fja","Azz","Azy"],
  "comparison": ["DTQ"],
  "compartment": ["JxC"],
  "compass": ["HLg","GTZ","DTS","FBJ","Az2","Az3","Az1"],
  "compassion": ["DTR"],
  "compassionate": ["Iaq"],
  "compatibility": ["JxD"],
  "compatible": ["Az4"],
  "compel": ["Ias"],
  "compelling": ["Iar"],
  "compensate": ["Iat"],
  "compensation": ["Iau"],
  "compete": ["Iax"],
  "competence": ["Iav"],
  "competency": ["JxE"],
  "competent": ["Iaw"],
  "competition": ["GTa","Az5","FBK"],
  "competitive": ["Fjb","Az6"],
  "competitiveness": ["JxF"],
  "competitor": ["JxG"],
  "compilation": ["JxH"],
  "compile": ["Iay"],
  "compiler": ["JxI"],
  "complacence": ["Iaz"],
  "complain": ["Ia2"],
  "complain about": ["Ia0"],
  "complain of": ["Ia1"],
  "complaint": ["Ia3"],
  "complement": ["Ia5"],
  "complementary": ["Ia4"],
  "complete": ["GTb","Az7","Az8"],
  "completely": ["JxJ"],
  "completion": ["Ia6"],
  "complex": ["Fjc","DTT","A0B","Az9"],
  "complexion": ["JxK"],
  "complexity": ["JxL"],
  "compliance": ["JxM"],
  "compliant": ["JxN"],
  "complicate": ["Ia7"],
  "complicated": ["Fjd","A0D","A0C"],
  "complication": ["JxO"],
  "compliment": ["Ia8"],
  "comply": ["DTU"],
  "component": ["Ia9"],
  "compose": ["DTV"],
  "compose a song": ["IbA"],
  "composer": ["Fje","DpU"],
  "composite": ["JxP"],
  "composition": ["JxQ"],
  "compost": ["JxR"],
  "compound": ["HLh"],
  "compounds": ["HLi"],
  "comprehend": ["A0E"],
  "comprehensible": ["IbB"],
  "comprehension": ["DTW"],
  "comprehensive": ["IbC"],
  "compress": ["IbE"],
  "compressible": ["IbD"],
  "compression": ["HLj"],
  "comprise": ["IbF"],
  "compromise": ["IbG"],
  "compulsion": ["JxS"],
  "compulsory": ["IbH"],
  "computation": ["JxU"],
  "computational": ["JxT"],
  "compute": ["IbI"],
  "computer": ["GTf","C90","FBM","Dyw","A0G","A0Q","A0F","A0H"],
  "computer game": ["GTc","A0J","FBL","A0K","A0I"],
  "computer games": ["GTd","DpV"],
  "computer lab": ["GTe","A0M","A0L"],
  "computer mouse": ["Fjf","A0O","A0N","A0P"],
  "computer problem": ["A0R"],
  "computer programmer": ["GTg","A0T","A0S"],
  "computer room": ["GTh","A0U"],
  "computer studies": ["Fjg"],
  "computer technician": ["Fjh","C91","C92","EBI","EBJ","A0V"],
  "computerize": ["JxV"],
  "computing": ["Fji","C93","Dyy"],
  "comrade": ["JxW"],
  "con": ["JxX"],
  "concave": ["IbJ"],
  "conceal": ["IbK"],
  "concede": ["IbL"],
  "conceit": ["IbM"],
  "conceivable": ["IbN"],
  "conceive": ["IbO"],
  "concentrate": ["Fjj","Dfv","Eb2"],
  "concentrate concentrated": ["Dfv","ETn"],
  "concentrate on": ["IbP"],
  "concentrated": ["ETn"],
  "concentrating": ["Dfv","Eb2"],
  "concentration": ["Fjk","A0X","DTX"],
  "concentric": ["IbQ"],
  "concept": ["DTY"],
  "conception": ["JxY"],
  "conceptual": ["IbS"],
  "conceptualisation": ["IbR"],
  "conceptualize": ["JxZ"],
  "concern": ["IbT"],
  "concerned": ["Fjl","DTZ","DTa"],
  "concert": ["GTi","A0d","FBN","A0a","A0Z"],
  "concert hall": ["Fjm","A0c","A0b"],
  "concerto": ["IbU"],
  "concession": ["Jxa"],
  "conciliate": ["IbV"],
  "concise": ["IbW"],
  "conclude": ["IbX"],
  "conclusion": ["IbY"],
  "conclusive": ["IbZ"],
  "concomitant": ["Iba"],
  "concord": ["Ibb"],
  "concrete": ["Ibd"],
  "concrete jungle": ["Ibc"],
  "concur": ["Ibe"],
  "concurrent": ["Jxb"],
  "condemn": ["Ibf"],
  "condemnation": ["Jxc"],
  "condensation": ["HLk"],
  "condense": ["Ibh"],
  "condensed": ["Ibg"],
  "condiment": ["Ibi"],
  "condition": ["Ibj"],
  "conditional": ["Jxd"],
  "conditioner": ["Jxe"],
  "condole": ["Ibk"],
  "condom": ["Jxf"],
  "condor": ["A0e"],
  "conducive": ["Ibl"],
  "conduct": ["A0i"],
  "conduction": ["HLl"],
  "conductivity": ["Ibm"],
  "conductor": ["Fjn","A0h","DTb","A0g"],
  "conduit": ["Jxg"],
  "cone": ["GTj","DTc","FBO","A0j","A0k","A0l"],
  "confederacy": ["Ibn"],
  "confer": ["Ibo"],
  "conference": ["Jxh"],
  "confess": ["Ibq"],
  "confession": ["Ibp"],
  "confidant": ["Ibr"],
  "confide": ["Jxk"],
  "confidence": ["Ibs"],
  "confident": ["GTk","DTd","FBP","A0m"],
  "confidential": ["Ibt"],
  "confidentiality": ["Jxi"],
  "confidently": ["Jxj"],
  "configuration": ["Ibu"],
  "configure": ["Jxl"],
  "confine": ["Ibv"],
  "confinement": ["Jxm"],
  "confirm": ["A0q","A0n"],
  "confirmation": ["A0p"],
  "confiscate": ["Ibw"],
  "conflict": ["Ibx"],
  "conform": ["Iby"],
  "conformity": ["Jxn"],
  "confound": ["Jxo"],
  "confront": ["Ibz"],
  "confrontation": ["Jxp"],
  "Confucius": ["Jxq"],
  "confuse": ["Ib0"],
  "confused": ["GTl","Fjo","C94","FBQ","A0s","EBK","A0r"],
  "confusing": ["Fjp","DTf","A0u","A0t"],
  "confusion": ["Ib1"],
  "conga": ["A0v"],
  "congenial": ["Ib2"],
  "congenital": ["Jxr"],
  "congest": ["Ib4"],
  "congested": ["Ib3"],
  "congestion": ["Jxs"],
  "conglomerate": ["Jxt"],
  "Congo": ["Jxu"],
  "Congo River": ["Jxv"],
  "Congolese": ["HCD"],
  "congrats": ["HLm"],
  "congratulate": ["Ib5"],
  "congratulation": ["Ib6"],
  "congratulations": ["HLn"],
  "congratulations on": ["Ib7"],
  "congregation": ["Jxw"],
  "congress": ["HLo"],
  "congressional": ["Ib8"],
  "congressman": ["Jxx"],
  "conjecture": ["Jxy"],
  "conjunction": ["Jxz"],
  "conjure": ["Ib9"],
  "conk out": ["IcA"],
  "connect": ["GTm","Dfw","A0w","EW4","A0x"],
  "connect a phone": ["Dfw"],
  "connect a phone to a computer": ["EW4"],
  "connect connected": ["Dfw"],
  "connect four": ["HLp"],
  "connecting": ["Dfw"],
  "connecting a phone": ["Dfw"],
  "connection": ["Eyp","Eyo"],
  "connectivity": ["Jx0"],
  "connector": ["Jx1"],
  "connotation": ["Jx2"],
  "connote": ["IcB"],
  "conquer": ["IcC"],
  "conquest": ["IcD"],
  "conscience": ["IcE"],
  "conscientious": ["IcF"],
  "conscious": ["HLq"],
  "consciously": ["Jx3"],
  "consciousness": ["Jx4"],
  "consecutive": ["IcG"],
  "consensus": ["IcH"],
  "consent": ["IcI"],
  "consequence": ["IcJ"],
  "consequences": ["IcK"],
  "consequent": ["IcL"],
  "consequently": ["Jx5"],
  "conservation": ["Fjq","A0y","DTg","A0z"],
  "conservationist": ["IcM"],
  "conservatism": ["Jx6"],
  "conservative": ["HLr"],
  "conservatory": ["Jx7"],
  "conserve": ["IcN"],
  "consider": ["IcR"],
  "considerable": ["IcO"],
  "considerably": ["Jx8"],
  "considerate": ["IcP"],
  "consideration": ["IcQ"],
  "consist": ["IcV"],
  "consist of": ["IcU"],
  "consistency": ["IcS"],
  "consistent": ["IcT"],
  "consistently": ["Jx9"],
  "consolation": ["JyA"],
  "console": ["Fjr","DTh"],
  "consolidate": ["IcW"],
  "consolidation": ["JyB"],
  "consonant": ["IcX"],
  "consort": ["IcY"],
  "consortium": ["JyC"],
  "conspicuous": ["DTi"],
  "conspicuous consumption": ["IcZ"],
  "conspiracy": ["Ica"],
  "conspire": ["JyD"],
  "constable": ["JyE"],
  "constant": ["Icb"],
  "constantly": ["JyF"],
  "constellation": ["Fjs","DTj","A02"],
  "constituency": ["JyG"],
  "constituent": ["Icc"],
  "constitute": ["Icd"],
  "constitution": ["HLs"],
  "constitutional": ["A03"],
  "constitutionalist": ["DTk"],
  "constrain": ["Ice"],
  "constraint": ["JyH"],
  "constricted": ["Icf"],
  "construct": ["Fjv","Dfx"],
  "construct a building": ["Dfx"],
  "construct constructed": ["EUv","Dfx"],
  "constructed": ["EUv"],
  "constructed a building": ["EUv"],
  "constructing": ["Dfx"],
  "constructing a building": ["Dfx"],
  "construction": ["Fjt"],
  "construction area": ["A05","A04"],
  "construction site": ["Fju","C95","Dyz"],
  "construction worker": ["GTn","C96","EBM","C97","EBL","A08","A09"],
  "constructive": ["JyI"],
  "construe": ["JyJ"],
  "consulate": ["HLt"],
  "consult": ["Icg"],
  "consultancy": ["JyK"],
  "consultant": ["JyL"],
  "consultation": ["JyM"],
  "consume": ["Ich"],
  "consumer": ["HLu"],
  "consumers": ["Fjw","DTl"],
  "consumption": ["DTm"],
  "contact": ["Ici"],
  "contagious": ["Icj"],
  "contain": ["Ick"],
  "container": ["Fjx","A1B","A1A"],
  "containers": ["Fjy","DTn"],
  "containment": ["JyN"],
  "contaminate": ["Icm"],
  "contaminated": ["Icl"],
  "contamination": ["Icn"],
  "contemplate": ["Ico"],
  "contemporary": ["Icp"],
  "contempt": ["Icq"],
  "contend": ["Ics"],
  "contender": ["Icr"],
  "content": ["Eyq"],
  "contention": ["JyO"],
  "contentious": ["JyP"],
  "contest": ["Fjz","A1C"],
  "contestant": ["JyQ"],
  "context": ["Ict"],
  "contextual": ["JyR"],
  "contiguous": ["Icu"],
  "continent": ["HLv"],
  "continental": ["JyS"],
  "contingency": ["JyT"],
  "contingent": ["JyU"],
  "continual": ["JyW"],
  "continually": ["JyV"],
  "continuation": ["Icv"],
  "continue": ["Icw"],
  "continuity": ["Icx"],
  "continuous": ["JyY"],
  "continuous rain": ["HLw"],
  "continuously": ["JyX"],
  "continuum": ["Icy"],
  "contour": ["Icz"],
  "contraception": ["JyZ"],
  "contraceptive": ["Jya"],
  "contract": ["Fj0","DTo","A1G"],
  "contraction": ["Jyb"],
  "contractor": ["Jyc"],
  "contractual": ["Jyd"],
  "contradict": ["Ic1"],
  "contradiction": ["Jye"],
  "contradictory": ["Ic0"],
  "contrail": ["DTp","A1J","A1H","A1I"],
  "contrary": ["Ic2"],
  "contrast": ["HLx"],
  "contribute": ["Fj1","DTq"],
  "contribution": ["Jyf"],
  "contributor": ["Ic3"],
  "contributory": ["Ic4"],
  "contrive": ["Jyg"],
  "control": ["GTo","Dfy","Eal"],
  "control a drone": ["Eal","Dfy"],
  "control controlled": ["ESb","Dfy"],
  "controling": ["Dfy"],
  "controling a drone": ["Dfy"],
  "controlled": ["ESb"],
  "controlled the drone": ["ESb"],
  "controller": ["Fj2","C98","Dy0"],
  "controlling": ["Eal"],
  "controversial": ["Ic5"],
  "controversy": ["Ic6"],
  "convection": ["HLy"],
  "convene": ["Ic7"],
  "convenience": ["Ic8"],
  "convenience store": ["GTp","C99"],
  "convenient": ["Ic9"],
  "conveniently": ["Jyh"],
  "convent": ["Jyi"],
  "convention": ["IdB"],
  "conventional": ["IdA"],
  "converge": ["IdC"],
  "convergence": ["Jyj"],
  "conversation": ["GTq","DTr","A1K","A1N","A1M"],
  "conversational": ["Jyk"],
  "converse": ["IdD"],
  "conversely": ["Jyl"],
  "conversion": ["IdE"],
  "convert": ["IdF"],
  "convertible": ["Jym"],
  "convex": ["IdG"],
  "convey": ["IdH"],
  "convict": ["IdJ"],
  "convicted criminal": ["IdI"],
  "conviction": ["Jyn"],
  "convince": ["IdK"],
  "convincingly": ["Jyo"],
  "convoy": ["Jyp"],
  "cook": ["GTv","Dfz","FBV","Df1","EW5","Eb3","A1T","A1O","Df0"],
  "cook a meal": ["Fj3"],
  "cook breakfast": ["HLz"],
  "cook cooked": ["Fj4","ESm","Df0","Dfz","Df1"],
  "cook dinner": ["Fj5","EBN"],
  "cook food": ["Fj7","Df0","EW5"],
  "cook lunch": ["HL0"],
  "cook on the stove": ["HL1"],
  "cook rice": ["HL2"],
  "cook together": ["HL3"],
  "cook up": ["IdM"],
  "cooked": ["Fj6","ESm","DpW"],
  "cooked some food": ["ESm"],
  "cooker": ["GTr","DpX","FBR"],
  "cookie": ["GTs","A1P","FBS","DAA","Dy2","A1Q"],
  "cookies": ["GTt","A1S","FBT","A1R"],
  "cooking": ["GTu","Fj9","Dfz","FBU","Df1","Eb3","Df0"],
  "cooking food": ["Fj8","Df0"],
  "cookout": ["IdL"],
  "cool": ["GTw","Df2","FBW","EBP"],
  "cool cooled": ["ESV","Df2"],
  "cool down": ["HL4"],
  "cool the room": ["Df2"],
  "cooled": ["ESV"],
  "cooled the room": ["ESV"],
  "cooling": ["Df2"],
  "cooling the room": ["Df2"],
  "cooperate": ["IdN"],
  "cooperate with": ["IdO"],
  "cooperation": ["IdP"],
  "cooperative": ["IdQ"],
  "coordinate": ["IdR"],
  "coordination": ["Jyq"],
  "coordinator": ["Jyr"],
  "cop": ["Jyt"],
  "cop out": ["IdW"],
  "cope": ["IdS"],
  "cope with": ["IdT"],
  "Copenhagen": ["G7O"],
  "Copernicus": ["Jys"],
  "copilot": ["IdU"],
  "copious": ["IdV"],
  "copper": ["FkA","A1V","A1W","A1U"],
  "copy": ["HL5"],
  "copyright": ["Jyu"],
  "coral": ["GTx","DTs","A1Y","A1X"],
  "coral reef": ["FkB","A1a"],
  "cord": ["FkC","A1b"],
  "cordial": ["IdX"],
  "core": ["FkD","A1d","A1c"],
  "corgi": ["A1f","A1e"],
  "coriander": ["FkE","A1g"],
  "cork": ["Jyv"],
  "corkscrew": ["FkF","DAC"],
  "corn": ["GTz","DAD","FBY","A1m","Dy4","A1n","A17","A1k","A1o","A1j","A1l"],
  "corn dog": ["A1p"],
  "corn field": ["FkH","A1w"],
  "cornbread": ["DTt"],
  "corner": ["GTy","DTu","FBX","A1t","A1r","A1s","A1u"],
  "corner shop": ["FkG","DTv","A1v"],
  "cornerstone": ["IdY"],
  "cornflakes": ["FkI","A1y","A10","A11","A1z"],
  "cornflower": ["A14"],
  "cornish pasty": ["A15","A16"],
  "corollary": ["IdZ"],
  "corona": ["HL6"],
  "coronary": ["Jyw"],
  "coronation": ["Jyx"],
  "coroner": ["Jyy"],
  "corporal": ["Jyz"],
  "corporate": ["Ida"],
  "corporation": ["Jy0"],
  "corporeal": ["Idb"],
  "corps": ["Idd"],
  "corpse": ["Idc"],
  "corpus": ["Ide"],
  "correct": ["FkJ"],
  "correction": ["HL7"],
  "corrective": ["Jy1"],
  "correctly": ["Jy2"],
  "correctness": ["Jy3"],
  "correlate": ["Jy4"],
  "correlation": ["Jy5"],
  "correspond": ["Idg"],
  "correspondence": ["Jy6"],
  "correspondent": ["Idf"],
  "corridor": ["GT0","DAE","FBZ","A18","DTw","A19","A2A"],
  "corrosion": ["Idh"],
  "corrosive": ["Idi"],
  "corrupt": ["Idj"],
  "corruption": ["DTx"],
  "Corsica": ["Jy7"],
  "cortex": ["Idk"],
  "cortical": ["Jy8"],
  "cortisol": ["Jy9"],
  "cosmetic": ["JzA"],
  "cosmetics": ["Idl"],
  "cosmic": ["HL8"],
  "cosmic ray": ["HL9"],
  "cosmonaut": ["HMA"],
  "cosmopolitan": ["Idm"],
  "cosmos": ["A2B"],
  "cost": ["GT1","Df3","EW6","A2C"],
  "cost an arm and a leg": ["EBQ","EBR","EBS"],
  "cost cost": ["Df3"],
  "cost one dollar": ["Df3","EW6"],
  "Costa Rica": ["HCF","EBT"],
  "Costa Rican": ["HCE","Kn9","G7P"],
  "costar": ["JzB"],
  "costing": ["Df3"],
  "costly": ["JzC"],
  "costs": ["HMB"],
  "costume": ["GT2","A2F","FBa","A2D","A2E"],
  "costumer": ["JzD"],
  "cosy": ["FkK","EBU","A2J","A2G","A2I"],
  "cot": ["GT3","A2O","A2K","A2L"],
  "cottage": ["GT4","A2R","A2S","A2Q","A2P"],
  "cotton": ["GT5","A2U","FBb","A2T","A2W","A2V"],
  "couch": ["GT6","A2Y","FBc","A2X","A2a","A2b","A2Z"],
  "cough": ["GT7","Df4","FBd","DAF","Eb4","A2c","Dy5"],
  "cough coughed": ["ETo","Df4"],
  "cough syrup": ["FkM","A2d"],
  "cough up": ["Idn"],
  "coughed": ["ETo"],
  "coughing": ["FkL","Df4","Eb4"],
  "could": ["JzE"],
  "could you repeat that": ["HMC"],
  "council": ["HMD"],
  "councilor": ["JzF"],
  "counsel": ["Idp"],
  "counseling": ["HME"],
  "counselling": ["HMF"],
  "counselor": ["Ido"],
  "count": ["FkN","Eyr"],
  "count in": ["Idt"],
  "count on": ["Idu"],
  "count the money": ["HMG"],
  "countenance": ["JzG"],
  "counter": ["GT8","DpY"],
  "counteract": ["Idq"],
  "counterfeit": ["Idr"],
  "counterpart": ["Ids"],
  "counting": ["GT9","A2g","FBe","A2e","A2f"],
  "countless": ["JzH"],
  "countries": ["FkO"],
  "country": ["GUA","A2k","FBf"],
  "country house": ["FkP","A2i"],
  "country music": ["Eys"],
  "countryman": ["JzI"],
  "countryside": ["GUB","A2l","FBg","A2m"],
  "county": ["Idv"],
  "coup": ["JzJ"],
  "couple": ["GUC","A2p","A2n","A2o"],
  "coupon": ["Idw"],
  "coupons": ["FkQ","A2q"],
  "courage": ["FkR","A2r"],
  "courageous": ["Idx"],
  "courgette": ["FkS"],
  "courier": ["Idy"],
  "course": ["HMH"],
  "court": ["Id1"],
  "courteous": ["Idz"],
  "courtesy": ["Id0"],
  "courthouse": ["FkT","A2s","A2t"],
  "courtroom": ["JzK"],
  "courtyard": ["FkU","A2v","A2u"],
  "cousin": ["GUD","DZN","FBh","EBV","EBW"],
  "cousins": ["GUE","A2y","FBi","DZO","A2x"],
  "covalent bond": ["HMI"],
  "cove": ["Id2"],
  "covenant": ["JzL"],
  "cover": ["Id4"],
  "cover up": ["Id5"],
  "coverage": ["Id3"],
  "covert": ["JzM"],
  "covet": ["JzN"],
  "cow": ["GUG","DAG","A25","EBX","A20","A2z","Dy6"],
  "coward": ["FkV","A21"],
  "cowboy": ["GUF","A23","FBj","A22","A24"],
  "cowhand": ["Id6"],
  "cows": ["GUH","A28","A27","A26"],
  "cozy": ["Eyt"],
  "cozy up": ["Id7"],
  "crab": ["GUJ","DAH","FBl","A3E","A3C","Dy7","A3B","A29","A3A","A3D"],
  "crack": ["GUL","A3G","Df5","A3F"],
  "crack cracked": ["Df5"],
  "crack the screen": ["Df5"],
  "crackdown": ["JzO"],
  "cracked": ["FkX","EBY","DAI","EhT"],
  "cracked screen": ["EhT"],
  "cracker": ["GUK","A3K","A3L","A3I"],
  "crackers": ["FkY","DpZ"],
  "cracking": ["Df5"],
  "cracking the screen": ["Df5"],
  "crackle": ["JzP"],
  "cradle": ["Id8"],
  "craft": ["HMJ"],
  "craftsman": ["Id9"],
  "cram": ["IeB"],
  "cramp": ["IeC"],
  "cramped": ["IeA"],
  "crane": ["FkZ","A3Q","A3N","A3P"],
  "cranial": ["IeD"],
  "crank": ["JzQ"],
  "cranky": ["A3R"],
  "crap": ["JzR"],
  "crash": ["GUM","Df6","A3T","A3U"],
  "crash a car": ["Df6"],
  "crash crashed": ["Df6"],
  "crashed": ["EVW","ESn"],
  "crashed his car": ["EVW","ESn"],
  "crashing": ["Df6"],
  "crashing a car": ["Df6"],
  "crate": ["JzS"],
  "crater": ["Fka","A3W","A3V"],
  "crave": ["JzT"],
  "crawl": ["GUN","A3X","FBm","A3Y"],
  "crayon": ["GUO","A3Z","FBn"],
  "crayons": ["GUP","DAJ","FBo","A3e","A3b","A3c","Dy8","A3d"],
  "craze": ["IeE"],
  "crazy": ["GUQ","DTy","A3f","A3h","A3i","A3g"],
  "crazy about": ["Fkb"],
  "creak": ["JzU"],
  "cream": ["GUR","A3j"],
  "creamy": ["JzV"],
  "crease": ["JzW"],
  "create": ["Fkc","Eyu"],
  "create graphics": ["EBZ"],
  "creation": ["JzX"],
  "creative": ["GUS","A3k"],
  "creativity": ["Fkd","DTz"],
  "creator": ["JzY"],
  "creature": ["GUT","A3m","DT0"],
  "credence": ["IeF"],
  "credential": ["IeH"],
  "credentialism": ["IeG"],
  "credentials": ["IeI"],
  "credibility": ["JzZ"],
  "credible": ["IeJ"],
  "credit": ["IeK"],
  "credit card": ["GUU","DAK","FBp","A3r","A3p","A3n","A3q","Dy9"],
  "credit rating": ["IeL"],
  "creditor": ["Jza"],
  "creed": ["Jzb"],
  "creek": ["IeM"],
  "creep": ["IeO"],
  "creep in": ["IeN"],
  "creep into": ["IeN"],
  "creepy": ["Fke","DT1","A3v","A3s"],
  "creepy clown": ["A3t"],
  "creepy house": ["A3u"],
  "Creole": ["KoA"],
  "crepe": ["Fkf","A3w","A3y","A3x"],
  "crescent": ["GUV","A3z","A30","A31"],
  "crescent moon": ["HMK"],
  "crest": ["A32"],
  "Crete": ["Jzc"],
  "crevice": ["IeP"],
  "crew": ["Fkg","A33","A34"],
  "crib": ["Fkh","Dpa"],
  "cricket": ["GUW","DAL","FBq","A35","A4B","A36","A37","A38","A39","DzA","A4A"],
  "crickets": ["IeQ"],
  "cried": ["Fki","ETp","Dpb"],
  "crime": ["GUX","A4C","A4D"],
  "criminal": ["Fkj","A4E"],
  "criminal activity": ["IeR"],
  "criminal offence": ["IeS"],
  "criminal record": ["IeT"],
  "crimson": ["Jzd"],
  "cripple": ["A4F"],
  "crippling": ["IeU"],
  "crisis": ["IeV"],
  "crisp": ["IeW"],
  "crisps": ["GUY","A4H","FBr","A4G"],
  "crispy": ["Fkk","Eyv"],
  "criss cross": ["IeX"],
  "criteria": ["IeY"],
  "criterion": ["IeZ"],
  "critic": ["Ied"],
  "critical": ["Jzf"],
  "critically": ["Jze"],
  "criticism": ["Iea"],
  "criticize": ["Iec"],
  "criticize a for b": ["Ieb"],
  "critique": ["Iee"],
  "Croatia": ["HCI","EBa"],
  "Croatian": ["HCH","KoB"],
  "crocodile": ["GUZ","DAM","FBs","A4N","DzB","A4M","A4L","A4I","A4K","A4J"],
  "croissant": ["GUa","A4T","DzC","DAN","A4O"],
  "croissants": ["A4W","A4U","A4V"],
  "crook": ["Ief"],
  "crooked": ["Fkl"],
  "crop": ["Eyw"],
  "crops": ["GUb","A4Y","A4X"],
  "croquet": ["A4c"],
  "cross": ["GUc","Df7","FBt","A4e","Eam","A4i","A4d"],
  "cross carefully": ["HML"],
  "cross crossed": ["ESo","Df7"],
  "cross off": ["Ieg"],
  "cross out": ["HMO"],
  "cross out a mistake": ["HMN"],
  "cross over": ["Ieh"],
  "cross the bridge": ["HMP"],
  "cross the river": ["EBb"],
  "cross the river carefully": ["ERB"],
  "cross the road": ["GUd","Df7","Eam"],
  "cross walk": ["A4m","A4n","A4o","A4p"],
  "cross your arms": ["HMQ"],
  "cross your legs": ["HMR"],
  "crossed": ["ESo"],
  "crossed the road": ["ESo"],
  "CrossFit": ["HMM"],
  "crossing": ["Fkn","A4h","Df7","Eam"],
  "crossing guard": ["Fkm","A4g","A4f"],
  "crossing the road": ["Eam","Df7"],
  "crossover": ["Jzg"],
  "crossroad": ["Fko","A4l","A4j"],
  "crosswalk": ["Fkp","Dpc"],
  "crossword": ["Fkq","A4q","A4r"],
  "crouch": ["Jzh"],
  "crow": ["GUh","A47","FBw","A4s","A4v","A4u"],
  "crowd": ["GUf","A4w","A42","A4x"],
  "crowded": ["GUe","A41","FBu","A4z","A4y","EBc","A40"],
  "crown": ["GUg","A46","FBv","A43","DAO","A44","DzD","A45"],
  "crucial": ["Iei"],
  "crucially": ["Jzi"],
  "crude": ["Iej"],
  "crude oil": ["A48","A49"],
  "cruel": ["Iek"],
  "cruelty": ["Jzj"],
  "cruise": ["GUi","A5C","A5A"],
  "cruise ship": ["Fkr","Eyx"],
  "crumb": ["Jzk"],
  "crumble": ["Iel"],
  "crumple": ["Iem"],
  "crunch": ["Jzl"],
  "crunches": ["A5D"],
  "crusade": ["Ien"],
  "crush": ["Fks","A5E"],
  "crust": ["Fkt","A5G"],
  "crustacean": ["A5F"],
  "crustal": ["Ieo"],
  "crutches": ["Fku","DAP","DzE"],
  "cry": ["GUk","Df8","FBx","A5J","Eb5"],
  "cry cried": ["ETp","Df8"],
  "cry like a baby": ["EBd"],
  "cry out for": ["Iep"],
  "cry tears": ["HMT"],
  "crying": ["GUj","Df8","A5H","Eb5"],
  "crypt": ["Jzm"],
  "crystal": ["Ier"],
  "crystallization": ["HMS"],
  "crystallize": ["Ieq"],
  "crystals": ["Fkv","A5K"],
  "cub": ["GUm","A5T","FBy"],
  "Cuba": ["Fkw","A5P","A5N","A5O","A5M"],
  "Cuban": ["HCJ","KoC","G7Q"],
  "cube": ["GUl","A5R","A5Q"],
  "cubic": ["Jzn"],
  "cubism": ["Ies"],
  "cuboid": ["Fkx","A5S"],
  "cucumber": ["GUn","DAQ","FBz","A5X","DzF","A5V","A5W","A5U"],
  "cucumbers": ["GUo","A5Y"],
  "cuddle": ["Eyy"],
  "cue": ["Fky","A5Z"],
  "cuff": ["Jzo"],
  "cuisine": ["Iet"],
  "culinary": ["Ieu"],
  "cull": ["Jzp"],
  "culminate": ["Iev"],
  "culpable": ["Iew"],
  "culprit": ["Iex"],
  "cult": ["Jzr"],
  "cultivar": ["Jzq"],
  "cultivate": ["Fkz","DT2","A5b"],
  "cultivation": ["DT3","A5c"],
  "cultural": ["HMU"],
  "culturally": ["Jzs"],
  "culture": ["GUp","Dpd"],
  "culture shock": ["HMV"],
  "cumbersom": ["DT4"],
  "cumbersome": ["Iey"],
  "cumulative": ["Iez"],
  "cumulus": ["Jzt"],
  "cuneiform": ["Ie0"],
  "cunning": ["DT5","A5d"],
  "cup": ["GUs","DAT","FB2","A55","DzH","A5e","A5h","A5f","A5g"],
  "cup cake": ["Fk0","DAS"],
  "cup of coffee": ["Fk3","A5x"],
  "cup of hot chocolate": ["A50"],
  "cup of tea": ["Fk4","A53","A54","A51"],
  "cupboard": ["GUq","DAR","FB0","DzG","A5i","A5m","A5j","A5l","A5k"],
  "cupcake": ["GUr","A5o","FB1","A5p","A5n","A5q"],
  "cupcakes": ["Fk1","A5r","A5t","A5s"],
  "cupid": ["Fk2","A5u","A5v"],
  "cups": ["Fk5","A56"],
  "curative": ["Ie1"],
  "curator": ["Jzu"],
  "curb": ["G7R"],
  "cure": ["Fk6","DT6"],
  "curfew": ["DT7"],
  "curiosity": ["Ie2"],
  "curious": ["GUt","DT8","FB3","A57"],
  "curiously": ["Jzv"],
  "curl": ["Ie3"],
  "curling": ["HMW"],
  "curly": ["GUv","A6A","FB5"],
  "curly hair": ["GUu","A58","FB4","A59"],
  "currency": ["Fk7","A6D","A6B","A6C"],
  "current": ["HMX"],
  "currently": ["Jzw"],
  "curriculum": ["Ie4"],
  "curry": ["GUw","A6G","FB6","A6E","A6F"],
  "curry and rice": ["Fk8","DAU"],
  "curse": ["Ie5"],
  "curtail": ["Ie6"],
  "curtain": ["GUx","A6I","FB7","A6H"],
  "curtains": ["GUy","DAV","FB8","A6J","A6L","A6M","DzI","A6K"],
  "curtsy": ["Ie7"],
  "curvature": ["Jzx"],
  "curve": ["Ie8"],
  "cushion": ["GUz","DAW","FB9","A6O","DzJ","A6N","A6P","A6Q"],
  "cushions": ["GU0","A6S","A6T"],
  "custard apple": ["A6U"],
  "custodian": ["Jzy"],
  "custody": ["DT9"],
  "custom": ["HMY"],
  "customary": ["Jzz"],
  "customer": ["GU1","Dpe","FCA"],
  "customers": ["Fk9","DUA"],
  "customize": ["DUB"],
  "customs": ["FlA","DUC"],
  "cut": ["GU3","DgA","FCB","DAX","DgC","EW8","DgB","Eb6","Df9","ESp","DzK"],
  "cut an apple": ["HMZ"],
  "cut back": ["Ie9"],
  "cut carefully": ["HMa"],
  "cut cut": ["FlB","DgA","ESp","DgB","Df9","DgC"],
  "cut down": ["EW7","EBh"],
  "cut down a tree": ["FlC","Df9"],
  "cut down on": ["IfB"],
  "cut down trees": ["EBi"],
  "cut hair": ["EBj"],
  "cut in": ["IfC"],
  "cut in half": ["HMb"],
  "cut in line": ["G7S"],
  "cut off": ["HMc"],
  "cut out": ["Eyz"],
  "cut paper": ["DgB","Eb6","EW8","ESp","DgA"],
  "cut the bread": ["HMd"],
  "cut the grass": ["HMe"],
  "cut the paper": ["HMf"],
  "cut up": ["HMg"],
  "cut your hair": ["HMh"],
  "cut your nails": ["HMi"],
  "cutback": ["IfA"],
  "cute": ["GU2","A6W"],
  "cutlery": ["FlD","A6X","A6Y"],
  "cutter": ["Jz0"],
  "cutting": ["FlE","DgC","DgB","DgA","Eb6","Df9"],
  "cutting down a tree": ["Df9"],
  "cutting edge": ["IfD"],
  "cutting paper": ["DgA","Eb6","DgB"],
  "cyan": ["DAY"],
  "cyberbullying": ["FlF","DUD"],
  "cyberspace": ["IfE"],
  "cycle": ["GU4","DgD"],
  "cycle cycled": ["DgD"],
  "cycle in the park": ["EBk"],
  "cycle lane": ["FlG","A6Z"],
  "cycle quickly": ["ERC"],
  "cyclic": ["Jz1"],
  "cyclin": ["Jz2"],
  "cycling": ["GU5","DgD","FCC","A6d","DzL","DAZ","A6e","A6f"],
  "cyclist": ["G7T"],
  "cyclone": ["HMj"],
  "Cyclops": ["HMk"],
  "cylinder": ["GU6","A6h","A6g"],
  "cynical": ["IfF"],
  "cynicism": ["Jz3"],
  "cypress tree": ["A6i"],
  "Cypriot": ["HCK","KoD","G7U"],
  "Cyprus": ["HCL","EBl"],
  "cytoplasm": ["Jz5"],
  "cytoplasmic": ["Jz4"],
  "czar": ["A6j"],
  "Czech": ["HCM","KoE","G7V"],
  "Czech flag": ["DAa"],
  "Czech Republic": ["FlH","FlI","A6m","A6k"],
  "D": ["DZr","FnG","HCQ"],
  "d": ["GWe","FC1","DZs","HCN"],
  "dab": ["Jz6"],
  "dachshund": ["FlJ","A6n"],
  "dad": ["GU8","A6q","FCE","A6o","A6t","A6p","EBn","EBo"],
  "daddy": ["GU7","A6s","FCD","A6r"],
  "daffodil": ["GU9","A6u"],
  "daft": ["Jz7"],
  "dagger": ["Jz8"],
  "dahlia": ["A6v"],
  "daily": ["Jz9"],
  "dairy": ["GVA","A6x","A6w"],
  "dairy product": ["Ey0"],
  "daisy": ["GVB","A60","A6z","A6y"],
  "Dallas": ["G7W"],
  "dam": ["GVD","DUF","FCF","A65","A61","A62"],
  "damage": ["GVC","DUE","A64","A63"],
  "damaged": ["Ey1"],
  "damn": ["J0A"],
  "damp": ["FlK","A66"],
  "dampen": ["J0B"],
  "dance": ["GVE","DgF","FCG","DgE","EdM","EXA","A69","EBp","A67","A68"],
  "dance a dance": ["HMl"],
  "dance beautifully": ["ERD"],
  "dance danced": ["FlL","EUw","DgF","DgE"],
  "dance with a friend": ["EXA"],
  "danced": ["FlM","EUw","Dpf"],
  "dancer": ["GVF","DAc","FCH","A7B","A7A","DAb","EBr","EBq"],
  "dancing": ["GVG","DgF","FCI","DgE","EdM","A7C"],
  "Dane": ["KoF"],
  "danger": ["GVI","A7G","FCK","A7D","A7E"],
  "dangerous": ["GVH","DAd","FCJ","EBs","EhU","A7F"],
  "dangerously": ["ERO"],
  "dangle": ["J0C"],
  "Dangun": ["HMm"],
  "Danish": ["HCO","G7X"],
  "Danube": ["J0D"],
  "Danube River": ["J0E"],
  "dare": ["IfG"],
  "dark": ["GVK","A7K","FCM","A7H"],
  "dark blue": ["FlN","DAe"],
  "dark brown": ["FlO","DAf"],
  "Dark Energy": ["HMn"],
  "dark green": ["FlP","DAh"],
  "dark hair": ["GVJ","A7I","FCL"],
  "Dark Matter": ["HMo"],
  "dark red": ["DAi"],
  "darken": ["J0F"],
  "darker": ["DAg"],
  "darkness": ["FlQ","A7J"],
  "darling": ["J0G"],
  "darn": ["J0H"],
  "dart": ["J0I"],
  "darts": ["FlR","DzN","A7O","DAj","A7L"],
  "dash": ["IfI"],
  "dash off": ["IfH"],
  "data": ["J0J"],
  "database": ["IfJ"],
  "date": ["GVL","A7S","A7R"],
  "date back to": ["IfK"],
  "dateline": ["IfL"],
  "daughter": ["GVM","A7V","DZQ","A7U","A7T","EBt","EBv"],
  "daughter in law": ["EBu","DZP"],
  "daughterinlaw": ["FlS","EBu"],
  "daunt": ["J0K"],
  "daunting": ["IfM"],
  "dawn": ["FlT","A7X","A7Y","A7W"],
  "day": ["GVN","Ey2"],
  "day after day": ["IfN"],
  "day in and day out": ["IfO"],
  "day off": ["G7Y"],
  "daybreak": ["HMp"],
  "daydream": ["FlU","A7b","A7Z","A7a"],
  "daylight": ["IfP"],
  "daytime": ["IfQ"],
  "daze": ["J0L"],
  "dazzle": ["J0M"],
  "dazzling": ["A7c"],
  "dead": ["GVO","DAk","EBw","EhV","EhW"],
  "deadline": ["IfR"],
  "deadly": ["J0N"],
  "deaf": ["IfS"],
  "deal": ["FlV","A7d"],
  "deal in": ["IfT"],
  "deal with": ["IfU"],
  "dealer": ["J0O"],
  "dean": ["J0P"],
  "dear": ["IfV"],
  "dearly": ["J0Q"],
  "dearth": ["IfW"],
  "death": ["FlW","Dpg"],
  "debatable": ["IfX"],
  "debate": ["FlX","DgG","EdN"],
  "debate debated": ["EUx","DgG"],
  "debated": ["EUx"],
  "debating": ["EdN","DgG"],
  "debit": ["J0R"],
  "debris": ["IfY"],
  "debt": ["HMq"],
  "debtor": ["J0S"],
  "debut": ["IfZ"],
  "decade": ["Ifb"],
  "decadent": ["Ifa"],
  "decay": ["FlY","A7e"],
  "decease": ["J0T"],
  "deceased": ["Ifc"],
  "deceitful": ["Ifd"],
  "deceive": ["Ife"],
  "December": ["GVP","Dph"],
  "decency": ["J0U"],
  "decent": ["Iff"],
  "decentralize": ["J0V"],
  "deception": ["Ifg"],
  "deceptive": ["Ifh"],
  "decide": ["GVQ","Dpi","FCN"],
  "decidedly": ["J0W"],
  "deciduous": ["Ifi"],
  "decimal": ["Ifj"],
  "decipher": ["Ifk"],
  "decision": ["Ifl"],
  "decisive": ["Ifm"],
  "deck": ["Fla","A7i"],
  "deck chair": ["A7f","A7g"],
  "deckchair": ["FlZ","DAl"],
  "declaration": ["J0X"],
  "declare": ["DUG"],
  "decline": ["Flb","A7l","A7k"],
  "decode": ["Ifn"],
  "decompose": ["Flc","A7m","DUI"],
  "decomposer": ["HMr"],
  "decomposition": ["J0Y"],
  "decor": ["J0a"],
  "decorate": ["GVR","DUJ"],
  "decoration": ["J0Z"],
  "decorations": ["GVS","A7n","FCO","EhX","EBx"],
  "decorative": ["Ifo"],
  "decorator": ["EBy","EBz","DzP","DAn","DAm"],
  "decrease": ["Fld","DgH","A7q"],
  "decrease decreased": ["ETg","DgH"],
  "decreased": ["ETg"],
  "decreasing": ["DgH"],
  "decree": ["Ifp"],
  "dedicate": ["Ifq"],
  "dedication": ["Ifr"],
  "deduce": ["J0b"],
  "deduct": ["Ift"],
  "deductible": ["J0c"],
  "deduction": ["J0d"],
  "deductive": ["Ifs"],
  "deed": ["Ifu"],
  "deem": ["Ifv"],
  "deep": ["GVT","A7r","FCP"],
  "deep space": ["HMs"],
  "deepen": ["J0e"],
  "deeper": ["Fle","DAo"],
  "deeply": ["J0f"],
  "deer": ["GVU","DAp","FCQ","A7v","A7s","A7t","DzQ","A7u"],
  "default": ["Ifw"],
  "defeat": ["Flf","A7w"],
  "defecate": ["Ifx"],
  "defect": ["Ify"],
  "defective": ["J0g"],
  "defence": ["HMt"],
  "defend": ["Flg","A7x"],
  "defendant": ["J0h"],
  "defender": ["J0i"],
  "defense": ["HMu"],
  "defensive": ["J0j"],
  "defer": ["Ifz"],
  "defer to": ["If0"],
  "defiance": ["J0k"],
  "defiant": ["If1"],
  "deficiency": ["If2"],
  "deficient": ["If3"],
  "deficit": ["If4"],
  "define": ["If5"],
  "definite": ["If6"],
  "definitely": ["HMv","G7Z"],
  "definition": ["J0l"],
  "definitive": ["If7"],
  "deflect": ["If8"],
  "deforestation": ["GVV","A70","A7z","DUK"],
  "deform": ["IgA"],
  "deformed": ["If9"],
  "defy": ["IgB"],
  "degenerate": ["IgC"],
  "degenerative": ["IgD"],
  "degradation": ["IgE"],
  "degrade": ["IgF"],
  "degree": ["Flh","DUL","A71"],
  "degrees": ["HMw"],
  "dehydrate": ["IgG"],
  "deity": ["HMx"],
  "dejected": ["DUM","A72"],
  "delay": ["HMy"],
  "delectable": ["IgH"],
  "delegate": ["IgI"],
  "delegation": ["J0m"],
  "delete": ["Fli","DUN","A73"],
  "deletion": ["J0n"],
  "Delhi": ["G7a"],
  "deliberate": ["IgJ"],
  "deliberately": ["J0o"],
  "deliberation": ["J0p"],
  "delicacy": ["J0q"],
  "delicate": ["IgK"],
  "delicately": ["J0r"],
  "delicious": ["GVW","DUO"],
  "delight": ["IgL"],
  "delighted": ["GVX","Dpj","EB0"],
  "delightful": ["J0s"],
  "delineate": ["IgM"],
  "delinquency": ["IgN"],
  "delinquent": ["J0t"],
  "delirium": ["IgO"],
  "deliver": ["GVY","DgJ","DgI","Ean","A76","A74"],
  "deliver a package": ["Ean","DgI"],
  "deliver delivered": ["ESq","DgI","DgJ"],
  "deliver letters": ["EB1"],
  "deliver packages": ["EXB","EB2"],
  "delivered": ["ESq"],
  "delivered a package": ["ESq"],
  "delivering": ["Ean","DgJ","DgI"],
  "delivering a package": ["Ean","DgI"],
  "delivery": ["Flk","A77"],
  "delivery man": ["Flj","DAq","DAr","EB3","EB4"],
  "deliveryman": ["DzR"],
  "delta": ["A78"],
  "delve": ["J0u"],
  "demand": ["HMz"],
  "demanding": ["IgP"],
  "dementia": ["J0v"],
  "Demeter": ["HM0"],
  "demise": ["IgQ"],
  "demo": ["J02"],
  "demobilize": ["IgR"],
  "democracy": ["HM1"],
  "democrat": ["IgS"],
  "democratic": ["J0w"],
  "Democratic Republic of Congo": ["EB5"],
  "democratization": ["J0x"],
  "demographic": ["J0y"],
  "demographics": ["IgT"],
  "demolish": ["IgU"],
  "demolition": ["J0z"],
  "demon": ["J00"],
  "demonstrate": ["IgV"],
  "demonstration": ["HM2"],
  "demonstrator": ["J01"],
  "den": ["IgY"],
  "denial": ["J03"],
  "denim": ["Fll","A8B","A8A","A79"],
  "Denmark": ["GVZ","A8F","A8C","EB6","A8D"],
  "Denmark flag": ["DAs"],
  "denomination": ["J04"],
  "denominator": ["J05"],
  "denote": ["IgW"],
  "denounce": ["IgX"],
  "dense": ["IgZ"],
  "densely": ["J06"],
  "density": ["HM3"],
  "dent": ["Iga"],
  "dental": ["J07"],
  "dental floss": ["Flm","DAt"],
  "dentist": ["GVa","DAv","FCR","DAu","A8H","EB7","A8G","EB8","DzT"],
  "dentistry": ["A8I"],
  "denude": ["J08"],
  "deny": ["Igb"],
  "depart": ["Fln","DgK","EXC"],
  "depart departed": ["DgK"],
  "depart the station": ["DgK","EXC"],
  "departing": ["DgK"],
  "departing the station": ["DgK"],
  "department": ["J1A"],
  "department store": ["GVb","DUP","FCS","A8J"],
  "departmental": ["J09"],
  "departure": ["GVc","Dpk"],
  "depend": ["Igf"],
  "depend on": ["Ige"],
  "dependence": ["Igc"],
  "dependency": ["Igd"],
  "dependent": ["J1B"],
  "depict": ["Igg"],
  "depiction": ["J1C"],
  "deplete": ["Igh"],
  "depletion": ["J1D"],
  "deplore": ["Igi"],
  "deploy": ["Igj"],
  "deployment": ["J1E"],
  "deport": ["Igk"],
  "depose": ["Igl"],
  "deposit": ["Flo","DgL","Eao"],
  "deposit deposited": ["ESr","DgL"],
  "deposit money": ["DgL","Eao"],
  "deposited": ["ESr"],
  "deposited money": ["ESr"],
  "depositing": ["Eao","DgL"],
  "depositing money": ["DgL","Eao"],
  "deposition": ["J1F"],
  "depot": ["Igm"],
  "depreciation": ["J1G"],
  "depredation": ["Ign"],
  "depress": ["Igo"],
  "depressed": ["GVd","A8M","A8L","EB9","A8K"],
  "depression": ["HM4"],
  "depressive": ["J1H"],
  "deprivation": ["J1I"],
  "deprive": ["Igp"],
  "depth": ["J1J"],
  "deputy": ["Igq"],
  "deputy head": ["G7b"],
  "deregulation": ["J1K"],
  "derelict": ["J1L"],
  "derivation": ["Igr"],
  "derivative": ["Igs"],
  "derive": ["Igt"],
  "desalination": ["Igu"],
  "descend": ["Igv"],
  "descendant": ["J1M"],
  "descent": ["Igw"],
  "describe": ["Ey3"],
  "description": ["Igx"],
  "descriptive": ["Igy"],
  "desegregate": ["Igz"],
  "desert": ["GVe","A8P","FCT","A8N","DAw","DzU","A8O"],
  "deserted": ["Ig0"],
  "deserve": ["Ig1"],
  "design": ["GVg","DgM","DgN","DgO","DUQ","EXD","Eb7","EXE"],
  "design a building": ["DgM"],
  "design buildings": ["EXD"],
  "design clothes": ["Flp","DgN","Eb7","EXE"],
  "design designed": ["ETq","DgM","DgN","DgO"],
  "design electricity": ["ECC"],
  "design machines": ["ECD"],
  "design nuclear power": ["ECE"],
  "design software": ["ECF"],
  "designate": ["Ig2"],
  "designation": ["J1N"],
  "designed": ["ETq"],
  "designed clothes": ["ETq"],
  "designer": ["GVf","Dpl","FCU"],
  "designer label": ["Ig3"],
  "designing": ["Eb7","DgO","DgM","DgN"],
  "designing a building": ["DgM"],
  "designing clothes": ["Eb7","DgN"],
  "desirable": ["Ig4"],
  "desire": ["Ig5"],
  "desk": ["GVh","DAx","FCV","A8S","DzV","A8R","A8T"],
  "desktop": ["J1O"],
  "desktop computer": ["Flq","DAy","DzW"],
  "desolate": ["DUR"],
  "despair": ["Ig6"],
  "desperate": ["DUS","A8U"],
  "desperately": ["J1P"],
  "desperation": ["J1Q"],
  "despise": ["Ig7"],
  "despite": ["Ig8"],
  "despoil": ["Ig9"],
  "despondent": ["IhA"],
  "dessert": ["GVi","A8V","FCW","A8X","A8W"],
  "desserts": ["Flr","Dpm"],
  "destination": ["Fls","Dpn"],
  "destine": ["J1R"],
  "destined": ["IhB"],
  "destiny": ["IhC"],
  "destroy": ["GVj","A8Y"],
  "destruction": ["DUT","A8Z"],
  "destructive": ["Flt","DUU"],
  "detach": ["J1T"],
  "detachment": ["J1S"],
  "detail": ["IhD"],
  "detain": ["J1V"],
  "detainee": ["J1U"],
  "detect": ["IhF"],
  "detectable": ["IhE"],
  "detection": ["J1W"],
  "detective": ["GVk","A8c","FCX","A8d"],
  "detector": ["J1X"],
  "detention": ["J1Y"],
  "deter": ["IhK"],
  "detergent": ["IhG"],
  "deteriorate": ["IhH"],
  "deterioration": ["IhI"],
  "determinant": ["J1Z"],
  "determination": ["J1a"],
  "determine": ["IhJ"],
  "determined": ["Flu","Dpo"],
  "deterrent": ["J1b"],
  "detest": ["IhL"],
  "detour": ["J1c"],
  "detox": ["Ey4"],
  "detract": ["IhM"],
  "detrimental": ["J1d"],
  "devaluation": ["J1e"],
  "devastate": ["IhN"],
  "devastation": ["IhO"],
  "develop": ["IhP"],
  "developer": ["J1f"],
  "development": ["Ey5"],
  "developmental": ["J1g"],
  "deviant": ["IhQ"],
  "deviate": ["J1h"],
  "deviation": ["J1i"],
  "device": ["IhR"],
  "devil": ["IhS"],
  "devils": ["ECG"],
  "devise": ["IhT"],
  "devoid": ["IhU"],
  "devote": ["IhV"],
  "devoted": ["DUV"],
  "devotion": ["J1j"],
  "devour": ["IhW"],
  "devout": ["IhX"],
  "dew": ["Flv","A8g","A8e"],
  "dexterous": ["IhY"],
  "diabetes": ["Flw","DUW","A8j","A8h"],
  "diabetic": ["J1k"],
  "diagnose": ["IhZ"],
  "diagnosis": ["J1l"],
  "diagnostic": ["J1m"],
  "diagonal": ["Iha"],
  "diagram": ["HM5"],
  "dial": ["A8k"],
  "dial down": ["Ihb"],
  "dial in": ["Ihc"],
  "dial up": ["Ihd"],
  "dialect": ["HM6"],
  "dialog": ["J1n"],
  "diameter": ["Ihe"],
  "diamond": ["GVl","A8m","FCY","A8n","A8o","A8l"],
  "Diana": ["HM7"],
  "diaper": ["J1o"],
  "diarrhea": ["J1p"],
  "diary": ["GVm","A8q","FCZ","A8p"],
  "dice": ["GVn","DAz","FCa","A8s","A8u","A8t","A8r","DzX"],
  "dichotomy": ["J1q"],
  "dictate": ["Ihf"],
  "dictator": ["J1r"],
  "dictatorship": ["HM8"],
  "diction": ["Ihg"],
  "dictionary": ["GVo","A8v","FCb","A8x","A8w"],
  "did": ["Fly","ETr"],
  "did homework": ["Flx","ETr"],
  "die": ["GVp","A8z","DgP"],
  "die died": ["EUk","DgP"],
  "die down": ["Ihh"],
  "die of": ["Ihi"],
  "die out": ["DUX","A8y"],
  "died": ["EUk"],
  "diesel": ["J1s"],
  "diet": ["GVq","DUZ","DUY","A80"],
  "dietary": ["J1t"],
  "differ": ["Ihn"],
  "differ from": ["Ihm"],
  "difference": ["Ihj"],
  "different": ["GVr","A84","FCc","DUa","A86","A85","A83","A82"],
  "different from": ["HM9"],
  "differential": ["Ihk"],
  "differentiate": ["Ihl"],
  "differentiation": ["J1u"],
  "differently": ["J1v"],
  "difficult": ["GVs","A88","FCd","A87","DUb"],
  "difficulty": ["J1w"],
  "diffuse": ["Iho"],
  "diffusion": ["Ihp"],
  "dig": ["GVu","DgQ","FCe","A9C","Eap","DgR"],
  "dig a hole": ["Flz","DgQ","DgR"],
  "dig dug": ["ETx","DgQ","DgR"],
  "dig in": ["Ihr"],
  "dig out": ["Ihv"],
  "dig up": ["Ihx"],
  "dig up coal": ["ECH"],
  "digest": ["Ihq"],
  "digestion": ["HNA"],
  "digestive system": ["HNB"],
  "digging": ["Fl0","A89","DgQ","Eap","DgR"],
  "digging a hole": ["DgQ","DgR"],
  "digit": ["J1x"],
  "digital": ["Fl1","A9A","A9B"],
  "digital camera": ["GVt","Dpp"],
  "digitize": ["Ihs"],
  "dignify": ["Iht"],
  "dignity": ["Ihu"],
  "digression": ["Ihw"],
  "dike": ["J1y"],
  "dilapidated": ["Ihy"],
  "dilate": ["Ihz"],
  "dilemma": ["Ih0"],
  "diligence": ["J1z"],
  "diligent": ["Ih1"],
  "dilute": ["Ih2"],
  "dilution": ["J10"],
  "dim": ["Ih7"],
  "dime": ["J11"],
  "dimension": ["Ih4"],
  "dimensional": ["Ih3"],
  "diminish": ["Ih5"],
  "diminution": ["Ih6"],
  "diminutive": ["J12"],
  "dimples": ["Fl2","A9D"],
  "dimsum": ["A9H"],
  "din": ["Ih8"],
  "dine": ["Fl3","A9I"],
  "diner": ["A9M","A9J","A9K","A9L"],
  "dingy": ["A9N"],
  "dining room": ["GVv","A9P","FCf","A9O","A9Q"],
  "dining table": ["Fl4","A9S","A9R"],
  "dinner": ["GVw","A9T","FCg","A9Y","A9V","A9U","A9X","A9W"],
  "dinosaur": ["GVx","DA0","FCh","A9Z","A9e","ECI","A9b","A9c","A9a","A9d"],
  "dinosaurs": ["Fl5","A9f","A9g","A9h"],
  "diocese": ["J13"],
  "Dionysus": ["HNC"],
  "dioxide": ["Ih9"],
  "dip": ["Fl6","A9j","A9m","A9i"],
  "diploma": ["IiA"],
  "diplomacy": ["J14"],
  "diplomat": ["HND"],
  "diplomatic": ["IiB"],
  "dire": ["IiE"],
  "direct": ["IiD"],
  "direction": ["HNE"],
  "directive": ["J15"],
  "directly": ["J16"],
  "director": ["GVy","A9n"],
  "directory": ["IiC"],
  "dirt": ["GVz","A9p","A9o"],
  "dirtier": ["Fl7","DA1","DA2"],
  "dirty": ["GV0","A9u","FCi","DA5","DA4","DA3","ECJ","EhY","A9r","EhZ","Eha","A9t","A9q","A9s"],
  "dirty dishes": ["EhZ"],
  "disability": ["J17"],
  "disable": ["J18"],
  "disabled": ["IiF"],
  "disadvantage": ["IiG"],
  "disagree": ["IiH"],
  "disagree with": ["IiI"],
  "disagreement": ["Fl8","DUd","DUc","A9v","A9x","A9y"],
  "disappear": ["GV1","A91","DUe","A9z"],
  "disappearance": ["J19"],
  "disappeared": ["IiJ"],
  "disappoint": ["IiK"],
  "disappointed": ["GV2","DUf","FCj","A94","A95","ECK","A93","A92"],
  "disappointing": ["Fl9","A97","A96"],
  "disappointment": ["FmA","DUh"],
  "disapproval": ["J2A"],
  "disapprove": ["IiM"],
  "disapprove of": ["IiL"],
  "disarm": ["IiN"],
  "disarmament": ["J2B"],
  "disaster": ["IiO"],
  "disastrous": ["IiP"],
  "disbelief": ["J2C"],
  "disc": ["DzY","DA6"],
  "discard": ["IiQ"],
  "discern": ["IiR"],
  "discharge": ["IiS"],
  "disciple": ["IiT"],
  "disciplinary": ["J2D"],
  "discipline": ["IiU"],
  "disclaimer": ["J2E"],
  "disclose": ["IiV"],
  "disclosure": ["J2F"],
  "disco": ["FmB","BAA","A98","A99"],
  "discomfort": ["J2G"],
  "disconcert": ["IiW"],
  "disconnect": ["J2H"],
  "discontent": ["J2I"],
  "discontinue": ["J2J"],
  "discontinuity": ["J2K"],
  "discord": ["IiX"],
  "discount": ["GV3","DgS","BAE","DUi","BAC","BAD"],
  "discount discounted": ["EUy","DgS"],
  "discounted": ["EUy"],
  "discounted the price": ["EUy"],
  "discounting": ["DgS"],
  "discourage": ["IiY"],
  "discourse": ["IiZ"],
  "discover": ["GV4","Dpq"],
  "discovery": ["FmC","DUj"],
  "discredit": ["Iia"],
  "discreet": ["J2L"],
  "discrepancy": ["J2M"],
  "discrete": ["Iib"],
  "discretion": ["J2O"],
  "discretionary": ["J2N"],
  "discriminate": ["Iic"],
  "discrimination": ["HNF"],
  "discus": ["HNG"],
  "discuss": ["FmD","DUl"],
  "discussion": ["DUk","BAF"],
  "disdain": ["J2P"],
  "disease": ["FmE"],
  "disgrace": ["Iid"],
  "disguise": ["Iie"],
  "disgust": ["FmH","BAM"],
  "disgusted": ["GV5","FmF","DA7","BAJ","BAH","BAK","BAI"],
  "disgusting": ["FmG","BAL","ECL"],
  "dish": ["GV7","BAN","BAO","BAS","BAP","BAQ"],
  "dish out": ["Iif"],
  "dishcloth": ["FmI","DA8"],
  "dishes": ["GV6","BAR"],
  "dishonest": ["Ey6"],
  "dishwasher": ["GV8","BAV","FCk","BAT","ECM","DA9","BAU","DBA"],
  "disillusion": ["J2Q"],
  "disintegrate": ["Iig"],
  "disinterest": ["Iii"],
  "disinterested": ["Iih"],
  "disk": ["J2R"],
  "dislike": ["GV9","DgT","EXF","BAW","BAX","BAY","BAZ"],
  "dislike disliked": ["DgT"],
  "dislike ice cream": ["EXF"],
  "dislike icecream": ["DgT"],
  "disliking": ["DgT"],
  "dismal": ["DUm"],
  "dismantle": ["J2S"],
  "dismay": ["DUn"],
  "dismiss": ["Iij"],
  "dismissal": ["J2T"],
  "disneyland": ["FmJ","BAe"],
  "disobedient": ["Iik"],
  "disorder": ["Iil"],
  "disorganize": ["J2U"],
  "disparate": ["Iim"],
  "disparity": ["J2V"],
  "dispatch": ["Iin"],
  "dispel": ["Iio"],
  "dispense": ["J2W"],
  "dispersal": ["Iip"],
  "disperse": ["Iiq"],
  "dispersion": ["J2X"],
  "displace": ["Iir"],
  "displacement": ["J2Y"],
  "display": ["FmK","DgU","BAf"],
  "display clothes": ["DgU"],
  "display displayed": ["EUn","DgU"],
  "displayed": ["EUn"],
  "displayed tshirts": ["EUn"],
  "displaying": ["DgU"],
  "displaying clothes": ["DgU"],
  "disposable": ["FmL","BAg","DUo","BAh"],
  "disposable income": ["Iis"],
  "disposal": ["Iit"],
  "dispose": ["Iiv"],
  "dispose of": ["Iiu"],
  "disposition": ["J2Z"],
  "disproportionate": ["Iiw"],
  "disprove": ["Iix"],
  "dispute": ["Iiy"],
  "disqualify": ["J2a"],
  "disquiet": ["Iiz"],
  "disregard": ["J2b"],
  "disrepute": ["Ii0"],
  "disrespect": ["Ii1"],
  "disrupt": ["Ii2"],
  "disruption": ["J2c"],
  "disruptive": ["J2d"],
  "dissatisfaction": ["J2e"],
  "dissatisfied": ["Ii3"],
  "dissatisfy": ["Ii4"],
  "dissect": ["J2f"],
  "disseminate": ["Ii5"],
  "dissemination": ["J2g"],
  "dissent": ["Ii7"],
  "dissenter": ["Ii6"],
  "dissertation": ["J2h"],
  "dissident": ["J2i"],
  "dissimulate": ["Ii8"],
  "dissipate": ["Ii9"],
  "dissociation": ["J2j"],
  "dissolute": ["IjA"],
  "dissolution": ["J2k"],
  "dissolve": ["FmM","DUp","BAi"],
  "dissuade": ["IjB"],
  "distal": ["J2l"],
  "distance": ["FmN","BAj","BAk"],
  "distant": ["FmO","BAo"],
  "distasteful": ["IjC"],
  "distill": ["J2m"],
  "distillation": ["BAq","BAp"],
  "distinct": ["IjE"],
  "distinction": ["J2n"],
  "distinctive": ["IjD"],
  "distinctly": ["J2o"],
  "distinguish": ["IjF"],
  "distort": ["IjG"],
  "distortion": ["J2p"],
  "distract": ["DUq","BAr"],
  "distracting": ["IjH"],
  "distraction": ["J2q"],
  "distress": ["BAt","BAs"],
  "distribute": ["IjI"],
  "distribution": ["J2r"],
  "distributor": ["IjJ"],
  "district": ["IjK"],
  "distrust": ["IjL"],
  "disturb": ["IjO"],
  "disturbance": ["IjM"],
  "disturbing": ["IjN"],
  "ditch": ["IjP"],
  "dive": ["GWA","DgV","FCl","BAw","Eb8","BAv","BAu"],
  "dive dived": ["ETs"],
  "dive dove": ["DgV"],
  "dive in": ["IjQ"],
  "dive into the water": ["FmP","DgV"],
  "dive into water": ["Eb8"],
  "dived": ["ETs"],
  "dived into water": ["ETs"],
  "diver": ["FmQ","BAy"],
  "diverge": ["IjR"],
  "divergence": ["J2s"],
  "divergent": ["J2t"],
  "diverse": ["FmR","BAz","BA0"],
  "diversification": ["J2u"],
  "diversify": ["IjS"],
  "diversion": ["IjT"],
  "diversity": ["FmS","DUr"],
  "divert": ["IjU"],
  "divide": ["FmT","DUt"],
  "divided": ["DUs"],
  "dividend": ["IjV"],
  "divine": ["IjW"],
  "diving": ["GWB","BA2","FCm","DgV","DBB","Eb8"],
  "diving into the water": ["FmU","DgV"],
  "division": ["IjX"],
  "divisional": ["J2v"],
  "divorce": ["FmV","Ey7"],
  "dizzy": ["GWC","Dpr","FCn"],
  "dj": ["FmW","BA6","BA4","BA5"],
  "dna": ["FmX","BA9","BA7","BA8"],
  "DNA": ["HNH"],
  "do": ["GWW","DgW","FCy","DgY","Eb9","DgX","EXL","EXI","EXH","EXG","EXM","EXK","EXJ"],
  "do a jigsaw": ["FmY","DgW","EXG"],
  "do a job": ["HNI"],
  "do athletics": ["FmZ"],
  "do away with": ["IjY"],
  "do badly in": ["IjZ"],
  "do business": ["ECP"],
  "do did": ["GWF","ETr","DgW","DgX","DgY","DgZ","Dga","Dgc"],
  "do done": ["EVy","EVe","EWJ"],
  "do exercise": ["Fmd","ECV","ECU"],
  "do exercises": ["Fme"],
  "do experiments": ["Fmf","DgX"],
  "do gymnastics": ["Fmh","Ey8"],
  "do homework": ["GWJ","Dga","DgY","DgZ","Eb9","EXH","ECX","ECW"],
  "do homework well": ["ERE"],
  "do housework": ["GWK","Dpt"],
  "do it again": ["HNK"],
  "do judo": ["Ey9"],
  "do karate": ["GWL","Dgb","EXI"],
  "do laundry": ["GWM","Dgc","FCr","EXJ"],
  "do magic": ["Fmp","Dgd","ECY"],
  "do magic tricks": ["EXK"],
  "do maths": ["Dge"],
  "do more harm than good": ["Ijm"],
  "do my homework": ["GWQ","Dpu","FCu"],
  "do not": ["HNL"],
  "do one's best": ["Ijq"],
  "do one's homework": ["Ijr"],
  "do operations": ["ECd"],
  "do out": ["Ijs"],
  "do over": ["Ijt"],
  "do push ups": ["EXL","Dgf"],
  "do pushups": ["Fmy","EXL"],
  "do puzzles": ["Fmz","EzA"],
  "do research": ["Fm0","Dgg"],
  "do some research": ["EXM"],
  "do sport": ["HNV"],
  "do the dishes": ["GWX","Dpv"],
  "do the laundry": ["Fm2","EzB"],
  "do the shopping": ["Fm3","EzC"],
  "do the washing": ["Fm4","EzD"],
  "do the washing up": ["Fm5","EzE"],
  "do up": ["FnB","Dgh","ECf"],
  "do up didup": ["Dgh"],
  "do well in": ["Ij4"],
  "do without": ["Ij5"],
  "do yoga": ["FnD","Dpz","ECg"],
  "do you drink coffee": ["ECh"],
  "do you have a cat": ["ECi"],
  "do you have an umbrella": ["ECj"],
  "do you know how to drive": ["ECk"],
  "do you like": ["HNX"],
  "do you like cats": ["ECl"],
  "do you like ice cream": ["ECm"],
  "do you like Indian food": ["ECn"],
  "do you like spicy food": ["ECo"],
  "do you mind": ["HNY"],
  "do your best": ["HNZ"],
  "do your homework": ["FnE","Dp0"],
  "dock": ["Fma","BBF","BBB","BBE"],
  "doctor": ["GWD","Fmb","DBD","FCo","BBJ","BBG","ECR","DBC","ECQ","BBI","BBH","Dzc"],
  "doctrine": ["Ija"],
  "document": ["Fmc","DUu","BBM","BBK","BBL"],
  "documentary": ["GWE","Dps","FCp"],
  "documentation": ["Ijb"],
  "dodge": ["J2w"],
  "dodgeball": ["HNJ"],
  "dodo": ["BBP","BBO"],
  "does your friend have long hair": ["ECS"],
  "does your friend like chocolate": ["ECT"],
  "dog": ["GWH","BBa","FCq","DBE","Dzd","BBU","BBT","BBR","BBS","BBQ"],
  "dog bed": ["Fmg","BBV"],
  "dog house": ["GWG","BBX","BBY","BBW","BBZ"],
  "dogged": ["Ijc"],
  "dogs": ["GWI","BBb"],
  "doing": ["Fml","DgY","DgW","Eb9","DgX"],
  "doing a jigsaw": ["DgW"],
  "doing exercise": ["Fmi","BBc"],
  "doing experiments": ["Fmj","DgX"],
  "doing homework": ["Fmk","Dga","Eb9","DgY","DgZ"],
  "doing karate": ["Dgb"],
  "doing laundry": ["Dgc"],
  "doing magic": ["Dgd"],
  "doing maths": ["Dge"],
  "doing push ups": ["Dgf"],
  "doing research": ["Dgg"],
  "doing up": ["Dgh"],
  "dole": ["J2x"],
  "dole out": ["Ijd"],
  "doll": ["GWO","Fmm","BBg","FCs","BBd","BBj","BBe","BBf"],
  "doll house": ["GWN","BBi","BBh"],
  "doll up": ["Ije"],
  "dollar": ["J2y"],
  "dolls": ["Fmn","BBk"],
  "dolphin": ["GWP","DBF","FCt","BBt","Dze","BBm","BBl","BBr","BBo","BBn","BBq","BBp","BBs"],
  "dolphins": ["Fmo","BBv","BBu"],
  "domain": ["Ijf"],
  "dome": ["Fmq","BBx","BBw"],
  "domestic": ["Ijh"],
  "domesticate": ["Ijg"],
  "domicile": ["Iji"],
  "dominance": ["Ijj"],
  "dominant": ["Ijk"],
  "dominate": ["Ijl"],
  "domination": ["J2z"],
  "Domingo": ["Fmr"],
  "Dominican": ["HCP","KoG","G7c"],
  "Dominican Republic": ["Fms","BB0","BBy"],
  "domino": ["BB6"],
  "dominoes": ["BB1","BB4"],
  "don't break": ["HNM"],
  "don't drop": ["HNN"],
  "don't forget": ["HNO"],
  "don't have a beard": ["EeX"],
  "don't have a moustache": ["EeY"],
  "don't have a shell": ["Eea"],
  "don't have a tail": ["Eeb"],
  "don't have arms": ["EeZ"],
  "don't have feathers": ["Eec"],
  "don't have hair": ["Eed"],
  "don't have legs": ["Eee"],
  "don't have long hair": ["Eef"],
  "don't have wings": ["Eeg"],
  "don't hurry": ["HNP"],
  "don't like cake": ["Eeh"],
  "don't like doing yoga": ["Eei"],
  "don't like drinking coffee": ["Eej"],
  "don't like hamburgers": ["Eek"],
  "don't like maths": ["Eel"],
  "don't like paying money": ["Eem"],
  "don't like playing cards": ["Een"],
  "don't like playing the trumpet": ["Eeo"],
  "don't like table tennis": ["Eep"],
  "don't like taking exams": ["Eeq"],
  "don't like wine": ["Eer"],
  "don't mention it": ["HNQ"],
  "don't run": ["HNR"],
  "don't shout": ["HNS"],
  "don't touch": ["HNT"],
  "don't worry": ["HNU"],
  "donate": ["GWR","BB7"],
  "donation": ["J20"],
  "done": ["Fmt","EVy","EVe","EWJ"],
  "done her homework": ["EVy"],
  "done laundry": ["EVe"],
  "done yoga": ["EWJ"],
  "donkey": ["GWS","BB9","FCv","DBG","BCC","Dzf","BB8","BCA","BCD","BCB"],
  "donor": ["Ijn"],
  "dont cry over spilt milk": ["ECa","ECb","ECc"],
  "donut": ["GWT","DBH","FCw","BCE","BCH","Egg","BCI","BCF"],
  "donuts": ["GWU","DBI","BCM","BCL","Dzg","BCK"],
  "doodle": ["Ijo"],
  "doom": ["J21"],
  "doomed": ["Ijp"],
  "door": ["GWV","DBL","FCx","Dzj","BCQ","BCR","BCW","BCP","BCO","BCN"],
  "door handle": ["Fmv","DBJ","Dzh"],
  "doorbell": ["Fmu","BCV","BCS","BCT"],
  "doormat": ["Fmw","DBK"],
  "doors": ["Fmx","BCX"],
  "doorstep": ["J22"],
  "doorway": ["J23"],
  "dope": ["J24"],
  "dorm": ["J25"],
  "dormancy": ["Iju"],
  "dormant": ["Ijv"],
  "dormintory": ["DUv"],
  "dormitory": ["Fm1","BCY"],
  "dormouse": ["BCZ"],
  "dorsal": ["Ijw"],
  "dosage": ["Ijx"],
  "dose": ["Ijy"],
  "dot": ["Fm6","EzF"],
  "dote": ["Ijz"],
  "dots": ["GWY","BCa"],
  "double": ["Ij1"],
  "double bass": ["Fm7","BCb","BCc","BCd","BCe"],
  "double bed": ["Fm8","BCh","BCg","BCf"],
  "double click": ["HNW"],
  "double decker bus": ["Fm9","BCj"],
  "double down": ["Ij0"],
  "double up": ["Ij2"],
  "doubt": ["Ij3"],
  "doubtful": ["J26"],
  "doubtless": ["J27"],
  "dough": ["FnA","BCr","BCo","BCn"],
  "doughnut": ["GWZ","BCq","BCp"],
  "dove": ["GWa","BCw","BCt","BCs","BCu"],
  "down": ["GWc","Dpw","Dpy"],
  "downfall": ["J28"],
  "downhill": ["J29"],
  "download": ["GWb","BCy","FCz","BC0","BCx","Dpx"],
  "downpour": ["BC1"],
  "downright": ["J3A"],
  "downside": ["Ij6"],
  "downsize": ["J3B"],
  "downstairs": ["GWd","BC2","FC0"],
  "downstream": ["J3C"],
  "downtown": ["FnC","BC3"],
  "downturn": ["J3D"],
  "downward": ["Ij7"],
  "downwards": ["J3E"],
  "doze": ["BC7","BC4","BC5"],
  "doze off": ["Ij8"],
  "dozen": ["FnF","BC6"],
  "drab": ["Ij9"],
  "dracula": ["GWf","BC9","BC8"],
  "draft": ["IkA"],
  "drag": ["HNb"],
  "drag on": ["IkB"],
  "drag out": ["IkC"],
  "dragon": ["GWi","BDO","FC4","DBN","BDA","BDB","Dzk","BDC"],
  "dragon boat festival": ["FnH","BDD","BDE"],
  "dragon dance": ["FnI"],
  "dragon fruit": ["GWh","DBM","FC3","BDM","BDL","BDK","BDN","Egh"],
  "Dragon King": ["HNa"],
  "dragonfly": ["GWg","BDH","FC2","BDF","BDJ","BDG","BDI"],
  "drain": ["FnJ","DBO","Dzl"],
  "drainage": ["J3F"],
  "drama": ["GWj","BDP","FC5"],
  "drama club": ["EzG"],
  "dramatic": ["IkD"],
  "dramatically": ["J3G"],
  "dramatize": ["IkE"],
  "drank": ["GWk","ETt"],
  "drank water": ["FnK","ETt"],
  "drape": ["J3H"],
  "drastic": ["IkF"],
  "drastically": ["J3I"],
  "draughts": ["HNc"],
  "draw": ["GWr","Dgl","Dgj","EXO","BDX","Dgk","EcA","BDQ","Dgi","EXN"],
  "draw a face": ["HNd"],
  "draw a house": ["HNe"],
  "draw a line": ["EXN","Dgi"],
  "draw a picture": ["GWl","BDR"],
  "draw a tree": ["HNf"],
  "draw drawn": ["EVz"],
  "draw drew": ["GWm","ETv","Dgj","Dgk","Dgl","Dgi"],
  "draw images": ["FnL","EXO"],
  "draw in": ["IkH"],
  "draw on": ["IkI"],
  "draw on paper": ["HNg"],
  "draw on the board": ["Dgk","EcA","Dgj"],
  "draw pictures": ["GWq","Dp1","ECr"],
  "draw the line at": ["IkJ"],
  "draw with crayons": ["HNh"],
  "drawback": ["IkG"],
  "drawer": ["GWn","BDT","FC6","BDS"],
  "drawers": ["GWo","DBP","FC7","BDV","Dzm","BDU"],
  "drawing": ["GWp","FnP","Dgl","FC8","Dgj","BDW","EcA","Dgk","Dgi"],
  "drawing a line": ["Dgi"],
  "drawing a picture": ["FnM","EzH"],
  "drawing on the board": ["FnN","Dgj","Dgk","EcA"],
  "drawing pictures": ["FnO","EzI"],
  "drawl": ["J3J"],
  "drawn": ["EVz"],
  "drawn on the board": ["EVz"],
  "dread": ["IkK"],
  "dreadful": ["EzJ"],
  "dream": ["GWs","Dgn","FC9","Dgo","Eaq","EXP","Dgm","BDZ","BDa"],
  "dream a dream": ["HNj"],
  "dream about basketball": ["EXP","Dgn"],
  "dream about holidays": ["HNi"],
  "dream dreamed": ["Dgm","ETu","Dgn","Dgo"],
  "dream of": ["IkL"],
  "dream up": ["IkM"],
  "dreamed": ["ETu"],
  "dreaming": ["FnQ","Dgn","Dgo","Dgm","Eaq"],
  "dreaming about basketball": ["Dgn"],
  "dreary": ["IkN"],
  "drench": ["IkO"],
  "dress": ["GWu","DBS","FDB","Dzp","BDe","BDg","BDd","BDf","BDc","BDb","BDh","BDk"],
  "dress up": ["GWv","Dgq","Dgp","EXQ","ECs"],
  "dress up dressed up": ["Dgp","Dgq"],
  "dress up for halloween": ["EXQ"],
  "dressage": ["HNk"],
  "dresser": ["GWt","DBQ","FDA","Dzn","BDj","BDi"],
  "dressing gown": ["FnR","DBR","Dzo"],
  "dressing table": ["EzK"],
  "dressing up": ["Dgp","Dgq"],
  "drew": ["FnS","ETv"],
  "drew on the board": ["ETv"],
  "dribble": ["J3K"],
  "dried": ["EUi"],
  "drier": ["FnT","DBT"],
  "drift": ["IkR"],
  "drift along": ["IkP"],
  "drift apart": ["IkQ"],
  "drill": ["GWw","DBU","BDp","Dzq","BDn","BDo"],
  "drink": ["GWz","Dgu","FDD","Dgv","EcB","Dgr","BDu","EdO","BDr","EXS","Dgs","Dgt","BDq","EXR"],
  "drink coffee": ["FnU","Dgr","Dgt","EdO","EXR","Dgs"],
  "drink drank": ["GWx","ETt","Dgv","Dgr","Dgt","Dgu","Dgs"],
  "drink drunk": ["EV0"],
  "drink hot chocolate": ["HNl"],
  "drink in": ["IkS"],
  "drink juice": ["HNm"],
  "drink lemonade": ["FnX"],
  "drink milk": ["HNn"],
  "drink slowly": ["HNo"],
  "drink some water": ["HNp"],
  "drink tea": ["HNq"],
  "drink up": ["IkT"],
  "drink water": ["GW1","Dgv","EcB","EXS"],
  "drinker": ["J3L"],
  "drinking": ["GWy","Dgu","FDC","EcB","Dgv","Dgr","BDs","EdO","Dgt","BDt","Dgs"],
  "drinking coffee": ["FnV","Dgr","Dgt","EdO","Dgs"],
  "drinking water": ["FnW","Dgv","EcB"],
  "drinks": ["GW0","BDv","FDE"],
  "drip": ["FnY","BDw"],
  "drive": ["GW3","Dgy","FDG","Dgw","Dgx","BD0","EcC","BDy","EXT","BDx"],
  "drive a bus": ["FnZ","BDz"],
  "drive a car": ["GW2","Dgw","FDF","Dgx","EcC","EXT","ECt"],
  "drive a limo": ["ECu"],
  "drive a truck": ["ECv"],
  "drive by": ["IkU"],
  "drive carefully": ["HNr"],
  "drive driven": ["EVS"],
  "drive drove": ["Fna","Dgw","Dgx","Dgy","ESs"],
  "drive fast": ["HNs"],
  "drive home": ["HNt"],
  "drive one crazy": ["IkV"],
  "drive slowly": ["HNu"],
  "drive through": ["IkW"],
  "drive to": ["Fnb"],
  "drive to work": ["HNv"],
  "drive up": ["IkX"],
  "driven": ["EVS"],
  "driven his car": ["EVS"],
  "driver": ["GW4","DBV","FDH","DBW","BD3","ECw","BD2","Dzr","BD1","ECx"],
  "driveway": ["IkY"],
  "driving": ["GW5","Dgy","Dgx","Dgw","EcC","BD5"],
  "driving a car": ["Fnc","EcC","Dgw","Dgx"],
  "drizzle": ["Fnd","DBY","DBX"],
  "drone": ["GW6","DBZ","BD8","Dzs","BEA","BD6","BD9"],
  "droop": ["J3M"],
  "drop": ["GW7","Dgz","FDI","EcD","BEE","BEB","BEC"],
  "drop a ball": ["EcD","Dgz"],
  "drop behind": ["HNw"],
  "drop by": ["IkZ"],
  "drop dropped": ["ETw","Dgz"],
  "drop in": ["Ika"],
  "drop it": ["HNx"],
  "drop off": ["HNy"],
  "drop out": ["Ikb"],
  "drop someone a line": ["Ikc"],
  "drop the ball": ["HNz"],
  "droplet": ["J3N"],
  "dropped": ["ETw"],
  "dropped a ball": ["ETw"],
  "dropping": ["EcD","Dgz"],
  "dropping a ball": ["EcD","Dgz"],
  "drought": ["GW8","BEI","FDJ","BEG","BEF","BEH"],
  "drove": ["Fne","ESs"],
  "drown": ["Ikd"],
  "drowsy": ["BEK"],
  "drug": ["J3O"],
  "drug store": ["Fnf"],
  "drugstore": ["GW9","BEL","FDK"],
  "drum": ["GXA","BEP","FDL","BEO","BEM","BEN"],
  "drum up": ["Ike"],
  "drummer": ["J3P"],
  "drums": ["GXB","DBa","FDM","Dzt","BEU","BES","BET","BEQ","BER"],
  "drunk": ["Fng","EV0","BEW"],
  "drunk coffee": ["EV0"],
  "drunken": ["J3Q"],
  "dry": ["GXC","Dg0","FDN","BEa","EXU","ECy","BEX","EdD"],
  "dry clothes": ["Dg0"],
  "dry dried": ["EUi","Dg0"],
  "dry in the sun": ["EXU"],
  "dry out": ["Ikf"],
  "dry the clothes": ["HN0"],
  "dry the dishes": ["Fni","Dp2"],
  "dryer": ["Fnh","BEY","BEZ"],
  "drying": ["Dg0","EdD"],
  "drying clothes": ["Dg0"],
  "dryly": ["J3R"],
  "dual": ["Ikg"],
  "dual citizen": ["KoH"],
  "dub": ["J3S"],
  "Dubai": ["G7d"],
  "dubious": ["Ikh"],
  "Dublin": ["G7e","BEb"],
  "duck": ["GXE","Fnk","DBb","BEl","BEd","Dzu","BEc","BEf","BEe"],
  "duck out": ["Iki"],
  "duckling": ["GXD","BEh","BEi","BEg"],
  "ducklings": ["Fnj","BEk","BEj"],
  "ducks": ["Fnl","BEm"],
  "duct": ["J3T"],
  "duct tape": ["BEn"],
  "ductile": ["Ikj"],
  "dude": ["J3U"],
  "due": ["Ikk"],
  "due to": ["G7f"],
  "duel": ["J3V"],
  "dug": ["ETx"],
  "dug a hole": ["ETx"],
  "duke": ["Ikl"],
  "dull": ["Fnm","Dp3"],
  "duly": ["J3W"],
  "dumb": ["Ikm"],
  "dummy": ["J3X"],
  "dump": ["Fno","BEu","BEp"],
  "dumpling": ["Fnn","BEq"],
  "dumplings": ["GXF","BEt","DBc","BEs","BEr"],
  "dune": ["Fnp","BEw"],
  "dung": ["Ikn"],
  "dung beetle": ["BE1","BE2"],
  "dungarees": ["BEy","BEx"],
  "dunno": ["J3Y"],
  "duo": ["J3Z"],
  "dupe": ["Iko"],
  "duplicate": ["Ikp"],
  "durable": ["Ikq"],
  "duration": ["DUw","BE3"],
  "durian": ["GXG","BE7","FDO","BE5","BE6","BE4"],
  "during": ["J3a"],
  "dusk": ["HN1"],
  "dust": ["GXH","BE9"],
  "dust off": ["Ikr"],
  "dust oneself down": ["Iks"],
  "dust storm": ["HN2"],
  "dust the furniture": ["HN3"],
  "dustbin": ["Fnq"],
  "dustpan and brush": ["Fnr","DBd","BE8","Dzv"],
  "dusty": ["DUx"],
  "Dutch": ["HCR","G7g"],
  "Dutchman": ["KoI"],
  "duty": ["Ikt"],
  "dvd player": ["GXI","Dp4"],
  "dwarf": ["GXJ","BFB"],
  "dwarf planet": ["HN4"],
  "dwell": ["J3b"],
  "dwell on": ["Iku"],
  "dwell upon": ["Ikv"],
  "dwindle": ["Ikw"],
  "dye": ["Fns","BFC"],
  "dying": ["DgP"],
  "dynamic": ["Iky"],
  "dynamical": ["Ikx"],
  "dynamics": ["Ikz"],
  "dynamo": ["BFD"],
  "dynasty": ["HN5"],
  "dysfunction": ["J3d"],
  "dysfunctional": ["J3c"],
  "E": ["DZt","Fo4","HCb"],
  "e": ["GYE","FD3","DZu","HCS"],
  "each": ["J3e"],
  "each other": ["G7h"],
  "eager": ["Fnt","BFE","BFF"],
  "eagerly": ["J3f"],
  "eagle": ["GXK","DBe","FDP","BFJ","BFG","Dzw","BFI","BFH"],
  "ear": ["GXP","DBj","FDR","BFK","BFU","BFL"],
  "ear buds": ["Fnv","DBf","Dzx"],
  "ear lobe": ["Fnw","DBg"],
  "ear piercing": ["Fnx","BFT","BFS"],
  "earache": ["Fnu","EzL"],
  "earl": ["Ik0"],
  "early": ["GXL","DUy","BFM"],
  "earmark": ["J3g"],
  "earmuffs": ["GXM","DBh"],
  "earn": ["GXN","BFN"],
  "earnest": ["Ik1"],
  "earnestly": ["J3h"],
  "earnings": ["Ik2"],
  "earphones": ["GXO","DBi","FDQ","BFO","Dzy","BFQ","BFR","BFP"],
  "earring": ["GXQ","DBk","Dzz"],
  "earrings": ["GXR","DBl"],
  "ears": ["DBm","FDS","Dz0"],
  "earth": ["GXS","BFW","FDT","D6q","DOi","BFV"],
  "earthquake": ["GXT","BFX","FDU","BFY","BFZ"],
  "earthworm": ["Fny","BFc","BFa","BFb"],
  "ease": ["Ik6"],
  "ease into": ["Ik3"],
  "ease off": ["Ik4"],
  "ease out": ["Ik5"],
  "easel": ["HN6"],
  "easier": ["DBn"],
  "easily": ["ERH"],
  "east": ["HN8","EzM"],
  "East Africa": ["J3j"],
  "East African": ["J3i"],
  "East Asia": ["J3l"],
  "East Asian": ["J3k"],
  "East Asian Mythology": ["HN7"],
  "easter": ["GXV","Fn0","BFh","FDW","BFd"],
  "Easter Bunny": ["Fnz","BFe"],
  "easter egg": ["GXU","BFf","FDV","BFg"],
  "Easter Island": ["J3m"],
  "eastern": ["J3n"],
  "eastward": ["J3o"],
  "easy": ["GXX","BFi","FDX","ECz"],
  "easygoing": ["GXW","DUz"],
  "eat": ["GXd","Dg1","FDd","Dg2","EcE","Dg6","Dg3","Dg8","BFk","EdP","EXV","Dg4","Dg7","BFn","EXY","BFj","Dg5","Dg9","BFl","EC0","EXX","EXW"],
  "eat a burger": ["Fn1","Dg2","EXV"],
  "eat a spider": ["Fn3","Dg4","EXW"],
  "eat an apple": ["Fn2","Dg3","EC1"],
  "eat ate": ["GXY","ETk","FDY","Dg2","Dg1","Dg8","Dg3","Dg5","Dg6","Dg4","Dg7","Dg9"],
  "eat away at": ["Ik7"],
  "eat breakfast": ["GXZ","Dp5","FDZ","Dp6"],
  "eat cake": ["Fn4","Dg5","EdP"],
  "eat carrots": ["EXX"],
  "eat dinner": ["GXa","Dp7","FDa"],
  "eat eaten": ["EVu","EVM","EVn","EV1"],
  "eat fruit": ["Fn6","EzN"],
  "eat hastily": ["ERF"],
  "eat healthy food": ["HN9"],
  "eat ice cream": ["Fn7"],
  "eat in": ["Ik9"],
  "eat in eat out": ["Ik8"],
  "eat into": ["IlA"],
  "eat like a horse": ["EC2","EC3","EC4"],
  "eat lunch": ["GXc","Dg6","FDc","EC5"],
  "eat meat": ["HOA"],
  "eat messily": ["ERG"],
  "eat out": ["FoA","Dp8"],
  "eat pizza": ["FoB","Dg7","EcE"],
  "eat popcorn": ["Dg9"],
  "eat seafood": ["FoC"],
  "eat slowly": ["HOB"],
  "eat snacks": ["FoD","EzO"],
  "eat soup": ["EXY"],
  "eat together": ["HOC"],
  "eat too much": ["HOD"],
  "eat up": ["IlB"],
  "eat vegetables": ["FoE","EzP"],
  "eaten": ["Fn5","EVu","EVM","EVn","EV1"],
  "eaten a spider": ["EVu"],
  "eaten an apple": ["EVM"],
  "eaten lunch": ["EVn"],
  "eaten the banana": ["EV1"],
  "eating": ["GXb","Dg2","FDb","Dg1","EcE","Dg5","BFm","EdP","Dg8","Dg3","Dg6","Dg7","Dg9","Dg4"],
  "eating a burger": ["Fn8","Dg2"],
  "eating a spider": ["Dg4"],
  "eating an apple": ["Dg3"],
  "eating cake": ["EdP","Dg5"],
  "eating lunch": ["Dg6"],
  "eating pizza": ["Fn9","Dg7","EcE"],
  "eating popcorn": ["Dg9"],
  "ebb": ["J3p"],
  "ebook": ["FoF","BFs","BFo","BFp","BFq","BFr"],
  "eccentric": ["IlC"],
  "ecclesiastical": ["J3q"],
  "echo": ["HOE"],
  "eclectic": ["J3r"],
  "eclecticism": ["IlD"],
  "eclipse": ["HOF"],
  "eco friendly": ["IlE"],
  "ecological": ["IlF"],
  "ecology": ["IlG"],
  "ecommerce": ["BFu"],
  "economic": ["HOG"],
  "economical": ["IlH"],
  "economically": ["J3s"],
  "economics": ["HOH"],
  "economist": ["J3t"],
  "economy": ["FoG","BFv"],
  "ecosystem": ["FoH","BFx","BFw"],
  "ecstasy": ["J3u"],
  "Ecuador": ["HCU","G7i"],
  "Ecuadorian": ["HCT","Kpk"],
  "edge": ["EzQ"],
  "edgy": ["BFy"],
  "edible": ["IlI"],
  "edifice": ["IlJ"],
  "Edinburgh": ["J3v"],
  "Edison": ["J3w"],
  "edit": ["IlL"],
  "edition": ["J3x"],
  "editor": ["J3y"],
  "editorial": ["IlK"],
  "educate": ["J3z"],
  "educated": ["IlM"],
  "education": ["GXe","DU0","BFz","BF0","BF1"],
  "education policy": ["HOI"],
  "educational": ["J30"],
  "educator": ["J31"],
  "eel": ["GXf","BF3","FDe","BF4","BF2"],
  "eerie": ["EzR"],
  "effect": ["IlO"],
  "effective": ["IlN"],
  "effectively": ["J32"],
  "effectiveness": ["J33"],
  "efficacy": ["J34"],
  "efficiency": ["HOJ"],
  "efficient": ["IlP"],
  "efficiently": ["J35"],
  "effluent": ["IlQ"],
  "effort": ["IlR"],
  "egg": ["GXh","DBp","FDg","BF6","D0o","BF8","BGJ","BF9","BF5","BF7"],
  "egg cup": ["BGB","BGC"],
  "egg on": ["IlS"],
  "egg tarts": ["BGP","BGQ"],
  "eggplant": ["GXg","DBo","FDf","BGD","BGF","Dz1","BGI","BGE","BGH","BGG"],
  "eggs": ["GXi","BGK","FDh","BGN","BGO","BGL","BGM","DxJ","Dz2"],
  "ego": ["IlT"],
  "egotistical": ["IlU"],
  "Egypt": ["HCW","GXj","DBs","FDi","BGV","BGS","EC7","Dz3","BGT","BGR","BGU"],
  "Egypt flag": ["FoI","DBq"],
  "Egyptian": ["HCV","Kpl","FoJ","DBr","EeJ"],
  "Eid": ["BGW"],
  "Eiffel Tower": ["HOK"],
  "eigenvalue": ["J36"],
  "eight": ["GXl","FoO","Daf","FDk","Dab"],
  "eight apples": ["HOL"],
  "eight birds": ["HOM"],
  "eight hundred": ["FoM","Dae"],
  "Eight Immortals": ["HOO"],
  "eight o'clock": ["FoN","Dd8"],
  "eight thousand": ["Dag"],
  "eighteen": ["GXk","FoK","Dad","FDj","Dac"],
  "eighteen chairs": ["HON"],
  "eighteenth": ["HBD"],
  "eighth": ["HBR"],
  "eighty": ["GXm","FoU","Dan","FDl","Dah"],
  "eighty eight": ["FoP","Dai"],
  "eighty five": ["FoQ","Daj"],
  "eighty four": ["FoR","Dak"],
  "eighty nine": ["FoS","Dal"],
  "eighty one": ["FoT","Dam"],
  "eighty seven": ["FoV","Dao"],
  "eighty six": ["FoW","Dap"],
  "eighty thousand": ["Daq"],
  "eighty three": ["FoX","Dar"],
  "eighty two": ["FoY","Das"],
  "either": ["G7j"],
  "either a or b": ["IlV"],
  "eject": ["IlW"],
  "El Salvador": ["HCX","EDE"],
  "elaborate": ["IlX"],
  "elaboration": ["J37"],
  "elapse": ["IlY"],
  "elastic": ["Ila"],
  "elasticity": ["IlZ"],
  "elbow": ["GXn","DBt","FDm","Dz4"],
  "elder": ["Foa","BGX","BGY"],
  "elderly": ["FoZ","EC8","Ehs"],
  "eldest": ["J38"],
  "elect": ["J4B"],
  "election": ["HOP"],
  "elective": ["Ilb"],
  "electoral": ["J39"],
  "electorate": ["J4A"],
  "electric": ["Foe"],
  "electric car": ["Fob"],
  "electric drill": ["Foc","BGZ","BGa"],
  "electric guitar": ["Fod","BGb","BGc","BGd","BGe","BGf","BGg"],
  "electric piano": ["BGo"],
  "electric toothbrush": ["Fof","BGp"],
  "electrical": ["HOQ"],
  "electrical engineer": ["EDA","EC9","DBu","DBv"],
  "electrician": ["GXo","DBw","FDn","DBx","DU1","EDC","Dz5","EDB","BGi"],
  "electricity": ["GXp","BGm","FDo","DU2","BGn"],
  "electrode": ["Ilc"],
  "electrolysis": ["Ild"],
  "electromagnetic": ["Ile"],
  "electron": ["HOR"],
  "electronic": ["Ilf"],
  "electronically": ["J4C"],
  "elegance": ["J4D"],
  "elegant": ["Fog","BGq","BGr"],
  "element": ["HOT"],
  "element symbol": ["HOV"],
  "elementary": ["HOS"],
  "elements": ["HOU"],
  "elephant": ["GXq","DBy","FDp","BGx","Dz6","BGs","BGt","BGu","BGv","BGw"],
  "elephants": ["GXr","BGy"],
  "elevate": ["Ilg"],
  "elevation": ["J4E"],
  "elevator": ["GXs","DBz","FDq","BG1","BGz","Dz7","BG0"],
  "eleven": ["GXt","Foi","Dau","Dat"],
  "eleven apples": ["HOW"],
  "eleven minutes past five": ["Foh","Dd9"],
  "eleventh": ["HA6"],
  "elf": ["GXu","Foj","BG6","FDr","Ehb","BG3","BG5","EDD","BG4"],
  "elicit": ["Ilh"],
  "eligibility": ["J4F"],
  "eligible": ["Ili"],
  "eliminate": ["Ilj"],
  "elimination": ["J4G"],
  "elite": ["Ilk"],
  "ellipse": ["Ill"],
  "elliptical": ["Ilm"],
  "elliptical galaxy": ["HOX"],
  "elm": ["Iln"],
  "elm tree": ["Fok","BG7"],
  "elongate": ["Ilo"],
  "eloquent": ["Ilp"],
  "else": ["Ilq"],
  "elsewhere": ["J4H"],
  "elucidate": ["J4I"],
  "elude": ["Ilr"],
  "elusive": ["Ils"],
  "email": ["GXv","BG8","FDs","BHB","BHA","BG9"],
  "emanate": ["Ilt"],
  "emancipate": ["Ilu"],
  "emancipation": ["J4J"],
  "embargo": ["Ilv"],
  "embark": ["Ilw"],
  "embarrass": ["Ilx"],
  "embarrassed": ["GXx","GXw","Fol","DU3","BHE","FDt","BHC","DB0","BHD"],
  "embarrassing": ["BHF"],
  "embarrassment": ["J4K"],
  "embassy": ["EzS"],
  "embed": ["Ily"],
  "embellish": ["Ilz"],
  "emblem": ["Il0"],
  "embody": ["Il1"],
  "embrace": ["Il2"],
  "embroider": ["J4L"],
  "embryo": ["HOY"],
  "embryonic": ["J4M"],
  "emerald": ["Fom","BHH","BHG"],
  "emerge": ["Il4"],
  "emergence": ["J4N"],
  "emergency": ["GXy","Dp9"],
  "emergency exit": ["Fon","BHJ","BHI"],
  "emergency services": ["Foo"],
  "emergent": ["Il3"],
  "emigrant": ["Kpm"],
  "emigrate": ["Il5"],
  "eminent": ["Il6"],
  "Emirati": ["HCY","Kpn"],
  "emission": ["Fop","DU4","BHM"],
  "emissions": ["Il7"],
  "emit": ["Il8"],
  "emo": ["BHO","BHN"],
  "emoji": ["G7k"],
  "emotion": ["HOZ"],
  "emotional": ["Il9"],
  "emotionally": ["J4O"],
  "emotions": ["Foq","BHP"],
  "empathy": ["ImA"],
  "emperor": ["For","BHQ"],
  "emphasis": ["ImB"],
  "emphasize": ["ImC"],
  "empire": ["HOa"],
  "empire state building": ["HOb"],
  "empirical": ["J4Q"],
  "empirically": ["J4P"],
  "empiricism": ["ImD"],
  "employ": ["ImF"],
  "employee": ["HOc"],
  "employer": ["HOd"],
  "employment": ["Fos","BHS","BHR"],
  "employment opportunities": ["ImE"],
  "empower": ["ImG"],
  "empowerment": ["J4R"],
  "empress": ["ImH"],
  "emptied": ["ESt"],
  "emptied a bin": ["ESt"],
  "emptiness": ["J4S"],
  "empty": ["GXz","DhA","FDu","EDF","BHW","BHV","BHT","BHU","Ear"],
  "empty emptied": ["ESt"],
  "empty the bin": ["Fot","DhA","Ear"],
  "emptying": ["Ear","DhA"],
  "emptying the bin": ["Ear","DhA"],
  "emulate": ["ImI"],
  "en": ["J4p"],
  "enable": ["ImJ"],
  "enact": ["ImL"],
  "enactment": ["ImK"],
  "enamel": ["J4T"],
  "encapsulate": ["J4U"],
  "encase": ["ImM"],
  "enceladus": ["HOe"],
  "enchant": ["ImN"],
  "encircle": ["J4V"],
  "enclave": ["J4W"],
  "enclose": ["ImO"],
  "enclosure": ["J4X"],
  "encode": ["J4Y"],
  "encompass": ["ImP"],
  "encounter": ["DU5"],
  "encourage": ["Fou","DhB","BHY","Eas","DU6"],
  "encourage a friend": ["DhB"],
  "encourage encouraged": ["ESu","DhB"],
  "encourage someone": ["Eas"],
  "encouraged": ["ESu"],
  "encouraged his friend": ["ESu"],
  "encouragement": ["J4Z"],
  "encouraging": ["DhB","Eas"],
  "encouraging a friend": ["DhB"],
  "encroach": ["ImQ"],
  "encrust": ["ImR"],
  "encyclopedia": ["J4a"],
  "end": ["GX1","BHa","BHZ"],
  "end up": ["HOf"],
  "endanger": ["ImS"],
  "endangered": ["GX0","DU7"],
  "endeavor": ["ImT"],
  "endemic": ["J4b"],
  "endless": ["ImU"],
  "endlessly": ["J4c"],
  "endogenous": ["J4d"],
  "endorse": ["ImV"],
  "endorsement": ["J4e"],
  "endow": ["ImW"],
  "endowment": ["J4f"],
  "endurance": ["Fov","DU8","BHb"],
  "endure": ["ImX"],
  "enemy": ["ImY"],
  "energetic": ["GX2","BHc","DU9"],
  "energize": ["J4g"],
  "energy": ["GX3","DqA","FDv"],
  "energy bar": ["Fow","EzT"],
  "energy crisis": ["ImZ"],
  "energy source": ["BHd"],
  "enforce": ["Ima"],
  "enforcement": ["J4h"],
  "engage": ["Imc"],
  "engage in": ["Imb"],
  "engage with": ["Imd"],
  "engagement": ["J4i"],
  "engaging": ["Ime"],
  "engender": ["J4j"],
  "engine": ["GX5","BHg","FDx","BHf","BHh","BHe"],
  "engineer": ["GX4","Dz8","FDw"],
  "engineering": ["HOg"],
  "England": ["HCZ","GX6","DB2","FDy","BHm","BHl","BHj","EDG","Dz9"],
  "England flag": ["DB1"],
  "English": ["GX7","DB3","HCa","Kro","FDz","BHo","DB5","D0A","EeK"],
  "English breakfast": ["DB4"],
  "English class": ["Fox","BHn"],
  "Englishman": ["Kpq","Kpo","Kpp"],
  "engrave": ["Imf"],
  "engraving": ["Img"],
  "engulf": ["Imh"],
  "enhance": ["Foy","DVA"],
  "enhancement": ["J4k"],
  "enigma": ["Imi"],
  "enjoy": ["GX8","DVB","FD0","DhC","BHp","BHq","BHs","EXZ"],
  "enjoy enjoyed": ["Foz","DhC","ETy"],
  "enjoy oneself": ["Imj"],
  "enjoy reading": ["EXZ","DhC"],
  "enjoyable": ["EzU"],
  "enjoyed": ["ETy"],
  "enjoyed reading a book": ["ETy"],
  "enjoying": ["BHr","DhC"],
  "enjoying reading": ["DhC"],
  "enjoyment": ["J4l"],
  "enlarge": ["Imk"],
  "enlargement": ["J4m"],
  "enlighten": ["Imm"],
  "enlightenment": ["Iml"],
  "enlist": ["Imn"],
  "enormous": ["GX9","BHt","BHv","BHu"],
  "enormously": ["J4n"],
  "enough": ["J4o"],
  "enquire": ["J4q"],
  "enquiry": ["J4r"],
  "enrich": ["Imo"],
  "enrichment": ["J4s"],
  "enroll": ["Imq"],
  "enrollment": ["Imp"],
  "ensconce": ["Imr"],
  "ensemble": ["J4t"],
  "enslave": ["Ims"],
  "ensue": ["Imt"],
  "ensure": ["Imu"],
  "entail": ["Imv"],
  "enter": ["Fo0","EzV"],
  "enterprise": ["Imw"],
  "entertain": ["Fo1","BHw"],
  "entertain children": ["EDH"],
  "entertainer": ["J4u"],
  "entertainment": ["GYA","DVC"],
  "enthusiam": ["DVD"],
  "enthusiasm": ["BHx"],
  "enthusiast": ["J4v"],
  "enthusiastic": ["Imx"],
  "Enthusiastically": ["DVE"],
  "entice": ["Imy"],
  "entire": ["Imz"],
  "entirely": ["J4w"],
  "entirety": ["J4x"],
  "entitle": ["Im0"],
  "entitlement": ["J4y"],
  "entity": ["Im1"],
  "entourage": ["Im2"],
  "entrance": ["GYB","BH0","BHy","BHz"],
  "entrant": ["J4z"],
  "entreat": ["Im3"],
  "entrench": ["Im4"],
  "entrepreneur": ["Im5"],
  "entrepreneurial": ["J40"],
  "entrepreneurship": ["J41"],
  "entropy": ["J42"],
  "entrust": ["J43"],
  "entry": ["J44"],
  "enunciate": ["Im6"],
  "envelop": ["Im7"],
  "envelope": ["GYC","DB6","FD1","D0B","BH3","BH2","BH4","BH1"],
  "envious": ["EzW"],
  "environment": ["GYD","BH7","FD2","BH5","BH9","BH6"],
  "environmental": ["Im8"],
  "environmentalist": ["Fo2","DVF","BH8"],
  "environmentally": ["J45"],
  "environmentally friendly": ["Fo3","DVG"],
  "envisage": ["J46"],
  "envision": ["Im9"],
  "envoy": ["J47"],
  "envy": ["InA"],
  "enzyme": ["InB"],
  "ephemeral": ["InC"],
  "Ephesus": ["HOh"],
  "epic": ["InD"],
  "epidemic": ["InE"],
  "episode": ["InF"],
  "epithelial": ["J48"],
  "epithelium": ["J49"],
  "epitome": ["InG"],
  "epitomize": ["InH"],
  "epoch": ["InI"],
  "equal": ["InJ"],
  "equality": ["Fo5","DVH","BIB","BIA"],
  "equally": ["J5A"],
  "equals": ["HOi"],
  "equals sign": ["EzX"],
  "equate": ["InK"],
  "equation": ["Fo6","BID","BIC"],
  "equator": ["DVJ"],
  "equestrian": ["HOj"],
  "equilibrium": ["InL"],
  "equinox": ["HOk"],
  "equip": ["InM"],
  "equipment": ["GYF","BIF","BIE"],
  "equitable": ["InN"],
  "equity": ["InO"],
  "equivalence": ["J5B"],
  "equivalent": ["Fo7","DVK"],
  "era": ["InQ"],
  "eradicate": ["InP"],
  "erase": ["Fo8","EzY"],
  "eraser": ["GYG","BIH","FD4","BII","BIG","DB7","D0C"],
  "ere": ["J5C"],
  "erect": ["InR"],
  "erode": ["DVL","BIK","BIJ"],
  "erosion": ["Fo9","DVM","BIL"],
  "err": ["InW"],
  "errand": ["InS"],
  "erratic": ["InT"],
  "erroneous": ["InU"],
  "error": ["InV"],
  "error message": ["BIO"],
  "erupt": ["FpB","DhD"],
  "erupt erupted": ["DhD"],
  "erupting": ["DhD"],
  "eruption": ["FpA","BIP","BIR","BIQ"],
  "es": ["J5G"],
  "escalate": ["DVN"],
  "escalation": ["J5D"],
  "escalator": ["GYH","DB8","BIV","BIS","BIT","BIU"],
  "escape": ["GYI","BIX","DVO","BIW"],
  "eschew": ["InX"],
  "escort": ["InY"],
  "esophageal": ["J5E"],
  "especially": ["G7l"],
  "espionage": ["J5F"],
  "esports": ["HOl"],
  "espouse": ["InZ"],
  "espresso": ["FpC","DB9","Egi"],
  "essay": ["Ina"],
  "essence": ["Inb"],
  "essential": ["EzZ"],
  "essentially": ["J5H"],
  "establish": ["Ind"],
  "establishment": ["Inc"],
  "estate": ["Ine"],
  "esteem": ["Inf"],
  "esteemed": ["DVP"],
  "estimate": ["FpD","DVQ"],
  "estimation": ["J5I"],
  "estimator": ["J5J"],
  "Estonia": ["HCd","EDI"],
  "Estonian": ["HCc","Kps"],
  "estrogen": ["J5K"],
  "estuary": ["J5L"],
  "etcetera": ["J5M"],
  "etch": ["J5N"],
  "eternal": ["Ing"],
  "eternity": ["J5O"],
  "ethanol": ["J5P"],
  "ethic": ["Ini"],
  "ethical": ["Inh"],
  "ethics": ["Inj"],
  "Ethiopia": ["HCf","EDJ"],
  "Ethiopian": ["HCe","Kpt","G7m"],
  "ethnic": ["Ink"],
  "ethnic minorities": ["DVR"],
  "ethnic minority": ["DqB"],
  "ethnicity": ["J5Q"],
  "ethnology": ["Inl"],
  "ethos": ["J5R"],
  "etiology": ["J5S"],
  "etiquette": ["Inm"],
  "EU citizen": ["Kpu"],
  "euphemism": ["Inn"],
  "euphoria": ["Ino"],
  "euro": ["J5U"],
  "Europa": ["HOm"],
  "Europe": ["J5T","GYJ","BIY","FD5","BIb","BId","BIa","BIZ"],
  "European": ["HCg","KoJ"],
  "European Union": ["BIc"],
  "Europeans": ["Krq","Krp"],
  "evacuate": ["Inp"],
  "evacuation": ["Inq"],
  "evade": ["Inr"],
  "evaluate": ["Ins"],
  "evaluation": ["J5V"],
  "evangelical": ["J5W"],
  "evaporate": ["FpE","DVS"],
  "evaporation": ["FpF","DVT"],
  "Eve": ["J5X"],
  "even": ["HOn"],
  "even if": ["G7n"],
  "even numbers": ["Eza"],
  "even out": ["Inu"],
  "even though": ["G7o"],
  "even up": ["Inw"],
  "evening": ["GYK","BIe","FD6"],
  "evenly": ["Int"],
  "event": ["GYL","BIf"],
  "event horizon": ["HOo"],
  "eventual": ["Inv"],
  "eventually": ["Ezb"],
  "ever": ["Iny"],
  "Everest": ["BIi","BIg","BIh"],
  "evergreen": ["Inx"],
  "every": ["FpG","Ezc"],
  "every cloud has a silver lining": ["Inz"],
  "every so often": ["In0"],
  "everybody": ["J5Y"],
  "everyday": ["J5Z"],
  "everyone": ["GYM","BIj"],
  "everything": ["G7p"],
  "everywhere": ["G7q"],
  "evidence": ["In1"],
  "evident": ["In2"],
  "evidently": ["J5a"],
  "evil": ["FpH","BIl","BIm","BIk"],
  "eviscerate": ["In3"],
  "evoke": ["In4"],
  "evolution": ["BIo","BIn"],
  "evolutionary": ["J5b"],
  "evolve": ["DVU"],
  "ex": ["J6A"],
  "exacerbate": ["In5"],
  "exact": ["In6"],
  "exactly": ["J5c"],
  "exaggerate": ["FpI","DVV"],
  "exaggeration": ["J5d"],
  "exalt": ["In8"],
  "exalted": ["In7"],
  "exam": ["GYO","BIr","BIp"],
  "examination": ["J5e"],
  "examine": ["FpJ","BIq","DhE","EXb"],
  "examine a patient": ["DhE"],
  "examine examined": ["DhE"],
  "examine eyes": ["EDK"],
  "examine someone": ["EXb"],
  "examiner": ["J5f"],
  "examining": ["DhE"],
  "examining a patient": ["DhE"],
  "example": ["GYN","DqC"],
  "exasperate": ["J5g"],
  "excavate": ["DVW"],
  "excavation": ["BIs"],
  "exceed": ["BIt"],
  "exceedingly": ["J5h"],
  "excel": ["IoA"],
  "excellence": ["J5i"],
  "excellent": ["In9"],
  "except": ["IoC"],
  "exception": ["IoB"],
  "exceptional": ["J5k"],
  "exceptionally": ["J5j"],
  "excerpt": ["IoD"],
  "excess": ["IoE"],
  "excessive": ["J5m"],
  "excessively": ["J5l"],
  "exchange": ["GYP","DhG","DhF","DVY","BIu","EdQ"],
  "exchange exchanged": ["ESd","DhF","DhG"],
  "exchange money": ["DhG","EdQ","DhF"],
  "exchange rate": ["HOp"],
  "exchange student": ["HOq"],
  "exchanged": ["ESd"],
  "exchanged money": ["ESd"],
  "exchanging": ["DhF","DhG"],
  "exchanging money": ["EdQ","DhF","DhG"],
  "excise": ["IoF"],
  "excite": ["IoH"],
  "excited": ["GYQ","FpK","DVZ","FD7","DCA","BIv","BIw","EDL"],
  "excitement": ["IoG"],
  "exciting": ["GYR","BIx","FD8","BIy","DCB"],
  "exclaim": ["IoI"],
  "exclamation mark": ["G7r"],
  "exclude": ["IoJ"],
  "exclusion": ["J5n"],
  "exclusive": ["IoK"],
  "exclusively": ["J5o"],
  "excursion": ["IoL"],
  "excuse": ["IoM"],
  "excuse me": ["HOr","G7s"],
  "execute": ["IoN"],
  "execution": ["J5p"],
  "executioner": ["BIz"],
  "executive": ["IoO"],
  "exemplar": ["J5q"],
  "exemplary": ["IoP"],
  "exemplify": ["IoQ"],
  "exempt": ["IoR"],
  "exemption": ["J5r"],
  "exercise": ["GYS","DhH","FD9","EdR","BI3","BI4","BI1","BI2"],
  "exercise exercised": ["FpL","DhH","EUz"],
  "exercised": ["EUz"],
  "exercising": ["FpM","DhH","EdR"],
  "exert": ["IoS"],
  "exhale": ["IoT"],
  "exhaust": ["IoU"],
  "exhausted": ["GYT","DCC","BI7","EDM"],
  "exhaustion": ["J5s"],
  "exhaustive": ["J5t"],
  "exhibit": ["FpN","DVb"],
  "exhibition": ["GYU","BI9","DVa","BJA"],
  "exhilarate": ["DVd"],
  "exhilarated": ["DVc"],
  "exhilarating": ["IoV"],
  "exhort": ["IoW"],
  "exile": ["DVe","Kpy"],
  "exist": ["IoY"],
  "existence": ["IoX"],
  "existential": ["J5u"],
  "exit": ["FpO","DqD"],
  "exodus": ["IoZ"],
  "exogenous": ["J5v"],
  "exoplanet": ["HOs"],
  "exorbitant": ["Ioa"],
  "exotic": ["FpP","BJF","BJD"],
  "expand": ["FpQ","BJG"],
  "expanse": ["J5w"],
  "expansion": ["Iob"],
  "expansive": ["J5x"],
  "expat": ["Kpz"],
  "expatriate": ["J5y","Kp0"],
  "expect": ["Ioc"],
  "expectancy": ["J5z"],
  "expectation": ["J50"],
  "expedient": ["Iod"],
  "expedition": ["Ioe"],
  "expeditious": ["Iof"],
  "expel": ["DVg"],
  "expend": ["J51"],
  "expenditure": ["DVh"],
  "expense": ["Iog"],
  "expensive": ["GYV","DCD","FEA","Ehc","DVi","EDN","BJH","BJJ"],
  "experience": ["GYW","DqE"],
  "experiment": ["FpR","Ezd"],
  "experimental": ["Ioh"],
  "experimentation": ["J52"],
  "experimenter": ["J53"],
  "expert": ["Ioj"],
  "expertise": ["Ioi"],
  "expiration": ["J54"],
  "expire": ["Iok"],
  "expired": ["DVj"],
  "explain": ["GYX","DhI","DVk","BJO","EXc","BJL","BJN"],
  "explain explained": ["DhI"],
  "explain some science": ["EXc"],
  "explaining": ["DhI"],
  "explanation": ["J55"],
  "explanatory": ["J56"],
  "explicit": ["Iol"],
  "explicitly": ["J57"],
  "explode": ["Iom"],
  "exploit": ["Ion"],
  "exploitation": ["J58"],
  "exploration": ["Eze"],
  "exploratory": ["J59"],
  "explore": ["GYY","BJQ","FEB","BJP"],
  "explorer": ["GYZ","DVl","FEC","BJR"],
  "explosion": ["GYa","BJU","BJS","BJT"],
  "explosive": ["HOt"],
  "exponent": ["Ioo"],
  "exponential": ["J6B"],
  "export": ["HOu"],
  "exporter": ["J6C"],
  "expose": ["Iop"],
  "exposition": ["Ioq"],
  "exposure": ["Ior"],
  "express": ["Iot"],
  "expression": ["J6D"],
  "expressive": ["Ios"],
  "expressly": ["J6E"],
  "expropriate": ["Iou"],
  "expulsion": ["J6F"],
  "expunge": ["DVm"],
  "exquisite": ["Iov"],
  "extant": ["J6G"],
  "extend": ["Iow"],
  "extended family": ["FpS","Ezf"],
  "extension": ["Iox"],
  "extension cord": ["BJV","BJW"],
  "extensive": ["Ioy"],
  "extensively": ["J6H"],
  "extent": ["Ioz"],
  "exterior": ["DVn"],
  "external": ["Io1"],
  "externality": ["Io0"],
  "externalize": ["J6I"],
  "externally": ["J6J"],
  "extinct": ["FpT","DVo"],
  "extinction": ["HOv"],
  "extinguish": ["Io2"],
  "extol": ["Io3"],
  "extort": ["Io4"],
  "extra": ["Io5"],
  "extracellular": ["J6K"],
  "extract": ["BJX"],
  "extraction": ["J6L"],
  "extradition": ["J6M"],
  "extraordinarily": ["J6N"],
  "extraordinary": ["DVq"],
  "extrapolate": ["Io6"],
  "extraterrestrial": ["HOw"],
  "extravagant": ["Io7"],
  "extreme": ["Io8"],
  "extremely": ["J6O"],
  "extremist": ["J6P"],
  "extremity": ["Io9"],
  "extrinsic": ["IpA"],
  "eye": ["GYe","DCI","FEF","BJj","BJa","BJZ","BJY"],
  "eye of the storm": ["HOx"],
  "eyebrow": ["GYb","DCE","FED","D0E","BJd","BJb"],
  "eyebrows": ["GYc","DCF","FEE"],
  "eyelash": ["FpU","DCH","BJe","BJi","BJf","BJg"],
  "eyelashes": ["GYd","DCG","BJh"],
  "eyelid": ["J6Q"],
  "eyes": ["GYf","DCJ","FEG","D0F","BJk","BJm","BJl"],
  "F": ["DZv","Gah","Frq","FFU","HCn"],
  "f": ["DZw","HCh"],
  "fable": ["IpB"],
  "fabric": ["GYg","BJo","BJn"],
  "fabricate": ["IpC"],
  "fabrication": ["J6R"],
  "fabulous": ["IpD"],
  "facade": ["J6S"],
  "façade": ["IpE"],
  "face": ["GYh","DCK","DVr","BJp","BJr","BJs","BJq"],
  "face off": ["IpF"],
  "face to face": ["FpW","DVs"],
  "face up to": ["IpH"],
  "facebook": ["FpV","DqF"],
  "facet": ["IpG"],
  "facial": ["IpI"],
  "facial expression": ["FpX","BJt","BJv","BJu"],
  "facilitate": ["IpJ"],
  "facility": ["GYi","BJw"],
  "fact": ["IpN"],
  "faction": ["IpK"],
  "factor": ["IpM"],
  "factor in": ["IpL"],
  "factories": ["FpY"],
  "factory": ["GYj","DCL","FEH","D0G","BJz","BJy","BJx"],
  "factual": ["IpO"],
  "faculty": ["IpP"],
  "fad": ["IpR"],
  "fade": ["IpQ"],
  "fahrenheit": ["HOy"],
  "fail": ["GYk","DhJ"],
  "fail a test": ["Fpb","DhJ"],
  "fail an exam": ["Fpa","DVt"],
  "fail failed": ["DhJ","EVT","ESv"],
  "failed": ["EVT","ESv"],
  "failed a test": ["ESv"],
  "failed the test": ["EVT"],
  "failing": ["DhJ"],
  "failing a test": ["DhJ"],
  "failure": ["IpS"],
  "faint": ["IpT"],
  "faintly": ["J6T"],
  "fair": ["Fpc","Ezg"],
  "fair hair": ["GYl","BJ0","FEI"],
  "fairly": ["J6U"],
  "fairness": ["J6V"],
  "fairy": ["GYm","BJ4","FEJ","BJ3","BJ1","BJ2"],
  "fairy tale": ["Ezh"],
  "fairy tales": ["GYn","DVu"],
  "faith": ["IpU"],
  "faithful": ["J6X"],
  "faithfully": ["J6W"],
  "fake": ["IpV"],
  "falcon": ["Fpd","BJ5","BJ6","BJ8","BJ7"],
  "fall": ["GYq","BKD","FEK","DhM","DhK","DhN","BKC","EXe","BKH","BJ9","BKB","BKA","DhL"],
  "fall apart": ["HOz"],
  "fall asleep": ["GYo","DhL"],
  "fall asleep fell asleep": ["DhL"],
  "fall away": ["IpW"],
  "fall back": ["IpY"],
  "fall back into": ["IpX"],
  "fall behind": ["HO0"],
  "fall down": ["Fpe","EDO"],
  "fall fell": ["GYp","DhK","EUq","DhN"],
  "fall for": ["IpZ"],
  "fall from": ["HO1"],
  "fall from a tree": ["EXe"],
  "fall in": ["Ipb"],
  "fall in love": ["Fpg","BKG","DVv"],
  "fall in love with": ["Ipa"],
  "fall into": ["HO3"],
  "fall off": ["HO4"],
  "fall out": ["DVw"],
  "fall over": ["Fph","DhM","Eat"],
  "fall over fell over": ["DhM"],
  "fall short of": ["Ipc"],
  "fall through": ["Ipd"],
  "fall under": ["Ipe"],
  "falling": ["Fpf","DhK","DhN","DhL","DhM"],
  "falling asleep": ["DhL"],
  "falling over": ["Eat","DhM"],
  "falling rocks": ["BKE"],
  "falling star": ["HO2"],
  "fallorautumn": ["DqG"],
  "fallout": ["J6Y"],
  "false": ["Fpi"],
  "falter": ["Ipf"],
  "fame": ["Ipg"],
  "familial": ["J6Z"],
  "familiar": ["Ipi"],
  "familiarity": ["J6a"],
  "familiarize": ["Iph"],
  "family": ["GYr","Fpj","DZR","FEL","BKK","BKJ","BKI"],
  "family reunion": ["Fpk","Ezi"],
  "famine": ["Fpl","DVx"],
  "famish": ["Ipj"],
  "famished": ["DVy"],
  "famous": ["GYs","DVz","FEM"],
  "famous for": ["Ezj"],
  "famously": ["J6b"],
  "fan": ["GYt","DCM","FEN","BKR","D0H","BKM","BKL","BKN","BKO"],
  "fan out": ["Ipl"],
  "fanatic": ["J6c"],
  "fanciful": ["Ipk"],
  "fancy": ["Fpm","DqH"],
  "fangs": ["Fpn","BKQ","BKP"],
  "fanny pack": ["Ezk"],
  "fans": ["Fpo","DqI"],
  "fantastic": ["GYu","DV0","BKS"],
  "fantasy": ["GYv","BKT","FEO"],
  "far": ["GYy","BKU","FEQ","BKh"],
  "far fetched": ["Ipp"],
  "far from": ["HO5"],
  "faraway": ["EDQ"],
  "farce": ["Ipm"],
  "fare": ["Ipn"],
  "farewell": ["Ipo"],
  "farm": ["GYx","BKg","FEP","BKX","BKW","BKZ","BKY","BKV"],
  "farm house": ["Fpp","BKf"],
  "farmer": ["GYw","DCO","EDS","DCN","BKd","BKe","EDR","BKa","BKb","BKc","D0I"],
  "farmhouse": ["J6d"],
  "farmland": ["J6e"],
  "fascinate": ["Ipq"],
  "fascinating": ["Fpq","DV1"],
  "fascination": ["J6f"],
  "fascist": ["J6g"],
  "fashion": ["Fpt","BKl"],
  "fashion accessory": ["Ipr"],
  "fashion designer": ["Fps","DCP","D0J","DV2","EDT","DCQ"],
  "fashionable": ["Fpr","BKi","BKk"],
  "fast": ["GY0","DCT","FER","BKm","BKp","EDY","Ehd","BKn"],
  "fast as lightning": ["EDV","EDW","EDX"],
  "fast car": ["HO6"],
  "fast computer": ["HO7"],
  "fast food": ["Ezl"],
  "fast food restaurant": ["Fpv"],
  "fast horse": ["BKo"],
  "fast internet": ["HO8"],
  "fast runner": ["HO9"],
  "fast train": ["HPA"],
  "fasten": ["Fpu"],
  "faster": ["GYz","DCR","DCS"],
  "fastly": ["J6h"],
  "fat": ["GY3","DCU","FET","Ehe","EDc","BKq","BKs","BKr"],
  "fatal": ["BKt"],
  "fatality": ["J6i"],
  "fate": ["Ips"],
  "father": ["GY2","Fpx","BKv","FES","DZT","BKu","EDb"],
  "Father Christmas": ["Fpw","EDZ","Eh3"],
  "father in law": ["GY1","EDa","DZS"],
  "fatherinlaw": ["EDa"],
  "fatigue": ["Ipt"],
  "fatter": ["Fpy","DCV"],
  "fatty": ["J6j"],
  "faucet": ["GY4","BKz","DCW","D0K","BK0","BKx"],
  "fault": ["Ipu"],
  "faulty": ["J6k"],
  "fauna": ["Ipv"],
  "favor": ["Ipw"],
  "favorable": ["J6l"],
  "favorably": ["J6m"],
  "favorite": ["Fpz","Ezm"],
  "favourite": ["Fp0"],
  "fawn": ["Fp1","BK1","BK2"],
  "fawn over": ["Ipx"],
  "fax": ["J6n"],
  "fax machine": ["BK3"],
  "fear": ["GY5","BK4","BK6"],
  "fearful": ["Fp2","BK5"],
  "fearless": ["DV3"],
  "feasibility": ["J6o"],
  "feasible": ["Ipy"],
  "feast": ["GY6","DV4","BK7"],
  "feat": ["Ipz"],
  "feather": ["GY7","BK8","FEU","BLA"],
  "feather duster": ["Fp3","BK9"],
  "feathers": ["GY8","DCX","FEV","BLB","D0L"],
  "feature": ["Ip0"],
  "February": ["GY9","DqJ","FEW"],
  "fecal": ["J6p"],
  "feces": ["J6q"],
  "fed": ["Fp4","ETz"],
  "fed the dog": ["Fp5","ETz"],
  "fed up": ["EDd","EDe","EDf"],
  "fed up with": ["Ip2"],
  "federal": ["HPB"],
  "federation": ["Ip1"],
  "fee": ["Ip6"],
  "feeble": ["DV5"],
  "feed": ["GZA","DhP","FEX","DhO","BLG","EcF","EXf","BLC","BLD"],
  "feed a cat": ["Fp6","DhO","EXf"],
  "feed a dog": ["EcF"],
  "feed fed": ["Fp8","DhO","ETz","DhP"],
  "feed my pet": ["FqA","Ezn"],
  "feed off": ["Ip3"],
  "feed the baby": ["HPC"],
  "feed the cat": ["GZB","DqK"],
  "feed the chickens": ["HPD"],
  "feed the dog": ["GZC","DhP","BLH"],
  "feed the fish": ["FqB"],
  "feedback": ["Fp7","BLE","BLF"],
  "feeder": ["J6r"],
  "feeding": ["Fp9","DhP","DhO","EcF"],
  "feeding a cat": ["DhO"],
  "feeding the dog": ["DhP"],
  "feel": ["GZD","DhR","FEY","DhQ","EXg"],
  "feel anxious": ["DV6"],
  "feel blue": ["EDg","EDh","EDi"],
  "feel bored": ["FqC","DhQ"],
  "feel cold": ["HPE"],
  "feel dizzy": ["FqD","DV7"],
  "feel felt": ["FqE","DhR","ET0","DhQ"],
  "feel for": ["Ip4"],
  "feel happy": ["HPF"],
  "feel hot": ["HPG"],
  "feel hungry": ["HPH"],
  "feel like": ["Ip5"],
  "feel sad": ["HPI"],
  "feel sick": ["GZE","DhR","DV8","EXg"],
  "feel tired": ["FqI","DV9"],
  "feel weak": ["Ezp"],
  "feeling": ["FqG","DhR","DhQ"],
  "feeling bored": ["FqF","DhQ"],
  "feeling sick": ["FqH","DhR"],
  "feelings": ["Ezo"],
  "feels like": ["HPJ"],
  "feet": ["GZF","DCY","FEZ","BLJ","BLK","BLI"],
  "feign": ["Ip7"],
  "fell": ["FqJ","EUq"],
  "fellow": ["Ip8"],
  "fellowship": ["Ip9"],
  "felony": ["J6s"],
  "felt": ["FqK","ET0"],
  "felt bored": ["ET0"],
  "felt tip": ["FqL","BLL"],
  "female": ["FqM","BLN","BLM"],
  "feminine": ["IqA"],
  "feminism": ["J6t"],
  "feminist": ["IqB"],
  "femur": ["DWA","BLO"],
  "fence": ["GZG","DCZ","FEa","BLQ","BLP","D0M"],
  "fencing": ["GZH","DqL"],
  "fend": ["IqD"],
  "fend off": ["IqC"],
  "Fenghuang": ["HPK"],
  "ferment": ["IqE"],
  "fermentation": ["HPL"],
  "fern": ["FqN","BLS","BLR"],
  "ferocious": ["BLT"],
  "Ferrari": ["DqM"],
  "ferret": ["FqO","BLU"],
  "ferris wheel": ["GZI","BLV","BLW"],
  "ferry": ["GZJ","BLX","FEb"],
  "fertile": ["DWB","BLY"],
  "fertility": ["J6u"],
  "fertilization": ["J6v"],
  "fertilize": ["J6w"],
  "fertilizer": ["J6x"],
  "fervor": ["IqF"],
  "festival": ["GZK","DWC","FEc","BLZ"],
  "festive": ["IqG"],
  "festivity": ["J6y"],
  "fetal": ["J6z"],
  "fetch": ["FqP","BLa"],
  "fetus": ["J60"],
  "feud": ["J61"],
  "feudal": ["IqH"],
  "fever": ["GZL","BLc","FEd","BLb"],
  "few": ["G7t"],
  "fiber": ["IqI"],
  "fibre": ["IqJ"],
  "fibrous": ["IqK"],
  "fiction": ["IqM"],
  "fictional": ["IqL"],
  "fictitious": ["IqN"],
  "fiddle": ["J62"],
  "fiddle away": ["IqO"],
  "fidelity": ["IqP"],
  "fidget toy": ["BLd","BLe"],
  "field": ["GZM","BLj","FEe","BLi","BLh","BLg","BLf"],
  "field hockey": ["HPM"],
  "field trip": ["FqQ"],
  "fierce": ["FqR","BLk"],
  "fiercely": ["J63"],
  "fiery": ["IqQ"],
  "fifteen": ["GZN","FqS","Daw","FEf","Dav"],
  "fifteen eggs": ["HPN"],
  "fifteen thousand": ["Dax"],
  "fifteenth": ["HBA"],
  "fifth": ["HBO","FqT","Ezq"],
  "fiftieth": ["HBN"],
  "fifty": ["GZP","FqY","Da4","Day"],
  "fifty eight": ["FqU","Daz"],
  "fifty five": ["GZO","Da0"],
  "fifty four": ["FqV","Da1"],
  "fifty nine": ["FqW","Da2"],
  "fifty one": ["FqX","Da3"],
  "fifty seven": ["FqZ","Da5"],
  "fifty six": ["Fqa","Da6"],
  "fifty thousand": ["Da7"],
  "fifty three": ["Fqb","Da8"],
  "fifty two": ["Fqc","Da9"],
  "fig": ["GZR","BLn","FEh","BLm","BLq","BLl"],
  "fight": ["GZQ","DhS","FEg","BLp","EdS","BLo"],
  "fight back": ["IqR"],
  "fight down": ["IqS"],
  "fight fought": ["EU0","DhS"],
  "fight off": ["IqT"],
  "fight over": ["IqU"],
  "fighter": ["J64"],
  "fighting": ["Fqd","DhS","EdS"],
  "figs": ["Fqe","BLr","BLu"],
  "figurative": ["IqV"],
  "figure": ["IqW"],
  "figure out": ["HPO"],
  "figure skating": ["HPP"],
  "Fiji": ["HCj","EDj"],
  "Fijian": ["HCi","KoK","G7u"],
  "filament": ["IqX"],
  "file": ["GZS","BLv","BLw","BLx"],
  "file your nails": ["HPQ"],
  "filial": ["IqY"],
  "Filipina": ["HCk","KoL"],
  "Filipino": ["KoM","HCl"],
  "fill": ["GZT","DhT","DhU","EcG","DWD"],
  "fill a balloon": ["HPR"],
  "fill a glass": ["DhT","EcG","DhU"],
  "fill filled": ["ESe","DhT","DhU"],
  "fill in": ["HPS"],
  "fill in the form": ["HPT"],
  "fill out": ["Fqf","DhW","EDk","DhV","EcH"],
  "fill out a form": ["EcH","DhV"],
  "fill out filled out": ["DhV","DhW"],
  "fill the bottle": ["HPU"],
  "fill the bucket": ["HPV"],
  "fill the cup": ["HPW"],
  "fill up": ["Fqg","DhX"],
  "fill up filled up": ["DhX"],
  "fill up with petrol": ["HPX"],
  "fill with": ["IqZ"],
  "fill with water": ["HPY"],
  "filled": ["ESe"],
  "filled a glass": ["ESe"],
  "filler": ["J65"],
  "filling": ["EcG","DhU","DhT"],
  "filling a glass": ["EcG","DhT","DhU"],
  "filling out": ["EcH","DhW","DhV"],
  "filling out a form": ["EcH","DhV"],
  "filling up": ["DhX"],
  "film": ["GZU","BLz","FEi"],
  "film director": ["Fqh","Ezr"],
  "film movies": ["EDm"],
  "film star": ["Fqi","DWE","BL0"],
  "filmmaker": ["J66"],
  "filter": ["Iqa"],
  "filtered coffee": ["BL1"],
  "filth": ["Iqb"],
  "filthy": ["J67"],
  "filtration": ["HPZ"],
  "fin": ["GZb","DCd","FEm","BL4","BL3","BL2","BMN"],
  "final": ["Iqe"],
  "finale": ["J68"],
  "finalize": ["Iqc"],
  "finally": ["Iqd"],
  "finance": ["Iqf"],
  "financial": ["Iqg"],
  "financially": ["J69"],
  "financier": ["J7A"],
  "finch": ["Iqh"],
  "find": ["GZW","BL6","FEj","BL5"],
  "find a book": ["HPa"],
  "find a key": ["HPb"],
  "find a seat": ["HPc"],
  "find fault with": ["Iqi"],
  "find found": ["Fqj","Ezs"],
  "find it": ["HPd"],
  "find out": ["GZV","DWF"],
  "find the way": ["HPe"],
  "find your keys": ["HPf"],
  "finds": ["Iqj"],
  "fine": ["Fqk","Ezt"],
  "finely": ["J7B"],
  "finger": ["GZX","DCb","FEk","BL7","BL8","D0N","BL9"],
  "finger nail": ["Fql","DCa"],
  "fingernail": ["J7C"],
  "fingerprint": ["Fqm","BMB"],
  "fingerprint scan": ["BMC"],
  "fingers": ["GZY","DCc","BMD","BME"],
  "fingers crossed": ["HPg"],
  "fingertip": ["J7D"],
  "finish": ["GZZ","BMG","FEl","BMH","DhY","DWH","BMF","EXh"],
  "finish class": ["DWG"],
  "finish finished": ["Fqn","DhY","EV2","EV3"],
  "finish line": ["Fqo"],
  "finish school": ["Fqp","DhY","EXh"],
  "finish up": ["Iqk"],
  "finish work": ["Fqq","DWI"],
  "finished": ["EV2","EV3"],
  "finished her homework": ["EV2"],
  "finished the painting": ["EV3"],
  "finishing": ["DhY"],
  "finishing school": ["DhY"],
  "finite": ["J7E"],
  "fink out": ["Iql"],
  "Finland": ["GZa","BMM","BMI","BML"],
  "Finn": ["KoN"],
  "Finnish": ["HCm"],
  "fins": ["Fqr","BMO"],
  "fir": ["J7I"],
  "fire": ["GZh","BMj","FEq","BMQ","BMP","BMR"],
  "fire away": ["Iqm"],
  "fire engine": ["GZc","BMW","FEn","DCe","BMX","BMY","D0O"],
  "fire extinguisher": ["Fqs","DCf","D0P"],
  "fire station": ["GZi","BMk","FEr"],
  "fire truck": ["GZj","BMl","FEs"],
  "fire up": ["Iqn"],
  "firearm": ["J7F"],
  "fireball": ["BMV","BMS","BMT","BMU"],
  "fired": ["DWJ"],
  "firefighter": ["GZd","DCh","FEo","BMa","DCg","BMb","BMd","EDp","EDo","BMZ","BMc","D0Q"],
  "firefighters": ["GZe","DqN"],
  "fireman": ["GZf","BMf","FEp","BMe"],
  "fireplace": ["GZg","DCi","BMi","D0R","BMg"],
  "firework": ["J7G"],
  "fireworks": ["GZk","BMo","FEt","BMn","BMm","DCj","D0S"],
  "firm": ["Iqo"],
  "firmly": ["J7H"],
  "first": ["HBF","GZm","DqO","FEu"],
  "first aid kit": ["GZl","BMp","BMq"],
  "first left": ["Ezu"],
  "first right": ["Ezv"],
  "firsthand": ["Iqp"],
  "firstly": ["J7J"],
  "fiscal": ["J7K"],
  "fish": ["GZr","Fqv","Ezw","FEx","DCp","D0T","DCk","BNH","BMt","BMs","BMr","DCl","BMu","DhZ","D0V","Eau","BMv"],
  "fish and chips": ["GZn","BMw","DCm","BMy","Egj","BMx"],
  "fish bowl": ["Fqt","BM2","BM3","BMz","BM0","BM1"],
  "fish fished": ["DhZ"],
  "fisherman": ["GZo","DCo","FEv","DCn","BM6","EDr","EDq","BM7","BM4","BM5"],
  "fishery": ["J7L"],
  "fishing": ["GZp","DhZ","FEw","BNA","Eau","BM8","BM9"],
  "fishing rod": ["GZq","BNC","BNB","BND"],
  "fishmonger": ["Fqu","BNG","BNF"],
  "fist": ["Fqw","BNK","BNI","BNJ"],
  "fit": ["GZs","BNP","FEy","BNL","EDy"],
  "fit as a fiddle": ["EDs","EDt","EDu"],
  "fit in": ["Iqq"],
  "fit like a glove": ["EDv","EDw","EDx"],
  "fitness": ["Fqy","BNO"],
  "fitness center": ["Fqx","BNM","BNN"],
  "fitness centre": ["BNN","BNM"],
  "five": ["GZt","Fq1","DbC","DbA"],
  "five apples": ["HPh"],
  "five hundred": ["Fqz","DbB"],
  "five o'clock": ["Fq0","DeA"],
  "five past six": ["DeB","EfR"],
  "five past twelve": ["DeC"],
  "five pens": ["HPi"],
  "five thousand": ["DbD"],
  "five to twelve": ["DeD","EfS"],
  "fix": ["GZu","Dhc","FEz","Dha","Eav","Dhb","BNQ","EXi","BNS","BNR","EXj"],
  "fix a bike": ["HPj"],
  "fix a car": ["Fq2","Dha","Eav"],
  "fix a computer": ["Fq3","Dhb"],
  "fix a problem": ["HPk"],
  "fix cars": ["EDz"],
  "fix computers": ["ED0"],
  "fix fixed": ["Dha","Dhb","Dhc"],
  "fix it": ["HPl"],
  "fix the computer": ["EXi"],
  "fix the tap": ["HPm"],
  "fix the water": ["Dhc"],
  "fix the water pipes": ["EXj"],
  "fix up": ["Iqr"],
  "fix water pipes": ["ED1"],
  "fix your hair": ["HPn"],
  "fixation": ["J7M"],
  "fixing": ["Fq5","Eav","Dhc","Dha","Dhb"],
  "fixing a car": ["Fq4","Dha","Eav"],
  "fixing a computer": ["Dhb"],
  "fixing the water": ["Dhc"],
  "fixture": ["J7N"],
  "fizzy drink": ["Fq6","BNT"],
  "flag": ["GZv","DCq","BNW","BNU","BNV","D0W"],
  "flag down": ["Iqs"],
  "flagellum": ["Iqt"],
  "flags": ["Fq7","BNY","BNX"],
  "flagship": ["J7O"],
  "flair": ["Iqu"],
  "flake": ["Iqv"],
  "flamboyant": ["Iqw"],
  "flame": ["GZw","BNd","BNc","BNZ","BNa","BNb"],
  "flamingo": ["GZx","BNg","FE0","BNf","BNh","BNe"],
  "flammable": ["HPo"],
  "flank": ["Iqx"],
  "flap": ["Fq8","BNi"],
  "flare": ["J7P"],
  "flare up": ["Iqy"],
  "flash": ["Iq0"],
  "flash back": ["Iqz"],
  "flash drive": ["Fq9","Ezx"],
  "flash flood": ["HPp"],
  "flashlight": ["GZy","DCr","FE1","D0X","BNj","BNk","BNl","BNm"],
  "flask": ["HPq"],
  "flat": ["GZz","DCs","ED2","Ehf"],
  "flat screen": ["Ezy"],
  "flat tire": ["BNo"],
  "flat tires": ["Ehf"],
  "flat tyre": ["BNo"],
  "flat tyres": ["Ehf"],
  "flatly": ["J7Q"],
  "flatten": ["J7R"],
  "flatter": ["Iq1"],
  "flaunt": ["Iq2"],
  "flavor": ["BNp"],
  "flavors": ["DWK","BNq"],
  "flavour": ["FrA","BNp"],
  "flavours": ["DWK","BNq"],
  "flaw": ["Iq3"],
  "flax": ["BNr"],
  "flea": ["J7S"],
  "flee": ["Iq4"],
  "fleece": ["J7T"],
  "fleet": ["Iq6"],
  "fleeting": ["Iq5"],
  "flesh": ["Iq7"],
  "flew": ["FrB","EUf"],
  "flex": ["J7U"],
  "flexibility": ["Iq8"],
  "flexible": ["FrC","BNt","BNs","DWL"],
  "flick": ["Iq9"],
  "flicker": ["J7V"],
  "flies": ["FrD","DqP"],
  "flight": ["GZ1","BNw","FE3"],
  "flight attendant": ["GZ0","DCt","FE2","DWM","ED4","DCu","ED3","BNu","BNv"],
  "flinch": ["J7W"],
  "fling": ["J7X"],
  "flint": ["IrA"],
  "flip": ["IrC"],
  "flip chart": ["FrE","D0Y","DCv","BNy"],
  "flip flops": ["GZ2","DCw","FE4","D0Z","BNz","BN1","BN0","BN2","BN3"],
  "flip out": ["IrB"],
  "flip through": ["IrD"],
  "flippers": ["GZ3","BN4","BN5"],
  "flirt": ["J7Y"],
  "float": ["GZ4","DWN","DWO"],
  "float around": ["IrE"],
  "flock": ["IrF"],
  "flock to": ["IrG"],
  "flood": ["GZ5","DCy","FE5","BOA","BN7","BN9","BN8","BOB","DCx"],
  "flood in": ["IrI"],
  "flood warning": ["HPr"],
  "flooding": ["IrH"],
  "floodwater": ["HPs"],
  "floor": ["GZ6","BOF","FE6","BOE","BOD","BOC"],
  "floorball": ["HPt"],
  "flop": ["J7Z"],
  "floppy": ["J7a"],
  "flora": ["IrK"],
  "floral": ["IrJ"],
  "Florentine": ["KoO"],
  "Florida": ["J7b","ED5"],
  "florist": ["GZ7","DC1","FE7","DC0","BOH","ED7","DCz","D0b","ED6","D0a","BOG"],
  "florist's": ["FrF","Ezz"],
  "flounder": ["J7c"],
  "flour": ["GZ8","BOI","FE8","BOK","BOJ"],
  "flourish": ["IrL"],
  "flow": ["FrH","BOW"],
  "flower": ["GZ9","DC3","BON","D0c","BOL","DC2","BOM","D0d"],
  "flower pot": ["FrG","BOO","BOP","BOQ"],
  "flower shop": ["Ez0"],
  "flowerpot": ["BOR"],
  "flowers": ["GaA","BOS","FE9","BOV","BOT","BOU"],
  "flu": ["GaB","BOY","FFA","BOX"],
  "fluctuate": ["DWP"],
  "fluctuation": ["IrM"],
  "fluency": ["HPu"],
  "fluent": ["DWQ"],
  "fluently": ["J7d"],
  "fluffy": ["FrI"],
  "fluid": ["IrN"],
  "flunk out": ["IrO"],
  "fluorescence": ["J7e"],
  "fluorescent": ["IrP"],
  "fluorine": ["HPv"],
  "flurry": ["J7f"],
  "flush": ["IrR"],
  "flush out": ["IrQ"],
  "flute": ["GaC","BOb","FFB","BOZ","BOa"],
  "flutter": ["J7g"],
  "flux": ["IrS"],
  "fly": ["GaI","Dhf","FFE","BOc","DC4","BOd","EXk","Eaw","Dhd","D0e"],
  "fly a kite": ["GaD","Dhd","FFC","Eaw"],
  "fly a plane": ["GaE","DqQ","ED8"],
  "fly across": ["IrT"],
  "fly flew": ["GaF","Dhe","EUf","Dhf","Dhd"],
  "fly in the sky": ["EXk"],
  "fly over": ["Dhe"],
  "fly over the mountains": ["Dhe"],
  "flyer": ["HPw"],
  "flying": ["GaH","Dhf","FFD","Dhd","Eaw"],
  "flying a kite": ["GaG","Dhd","Eaw"],
  "flying over": ["Dhe"],
  "flying over the mountains": ["Dhe"],
  "flying vehicles": ["Ez1"],
  "foal": ["GaJ","BOe","BOf"],
  "foam": ["IrU"],
  "focal": ["IrW"],
  "focalize": ["IrV"],
  "focus": ["IrY"],
  "focus on": ["IrX"],
  "foe": ["IrZ"],
  "fog": ["GaL","BOk","FFG","BOi","BOh","BOg"],
  "foggy": ["GaK","BOj","FFF"],
  "foil": ["J7h"],
  "fold": ["GaN","DqR"],
  "fold the laundry": ["HPx"],
  "fold the paper": ["HPy"],
  "fold up": ["Ira"],
  "folder": ["GaM","DC5","FFH","D0f","BOo","BOp","BOn","BOl"],
  "foliage": ["Irb"],
  "folk": ["HP0"],
  "folklore": ["HPz"],
  "folktale": ["FrJ","Ez2"],
  "folkway": ["Irc"],
  "follicle": ["J7i"],
  "follicular": ["J7j"],
  "follow": ["GaO","Dhg","BOq","EXl"],
  "follow accepted behaviour": ["Ird"],
  "follow followed": ["Dhg","ESc"],
  "follow mother": ["EXl","Dhg"],
  "follow through": ["Ire"],
  "follow up": ["Irg"],
  "follow up on": ["Irf"],
  "followed": ["ESc"],
  "followed mother": ["ESc"],
  "follower": ["J7k"],
  "following": ["Dhg"],
  "following mother": ["Dhg"],
  "folly": ["J7l"],
  "foment": ["Irh"],
  "fond": ["Iri"],
  "fond of": ["FrK","DWR"],
  "fondu": ["BOr"],
  "fondue": ["BOr"],
  "font": ["HP1"],
  "food": ["GaP","DqT","FFI","DqS"],
  "food chain": ["HP2"],
  "food pyramid": ["FrL","BOs"],
  "food shop": ["FrM"],
  "food web": ["HP3"],
  "foods": ["FrN","BOt"],
  "fool": ["FrO","BOu","BOw"],
  "fool around": ["Irj"],
  "foolish": ["Irk"],
  "foot": ["GaT","DC6","FFM","D0g","BOy","BO9","BOx"],
  "footage": ["J7m"],
  "football": ["GaS","BOz","FFL","BO3","BO1","BO0"],
  "football pitch": ["FrP"],
  "football player": ["GaR","BO2","FFK"],
  "footballer": ["GaQ","DqU","FFJ"],
  "footnote": ["J7n"],
  "footpath": ["FrQ","BO5","BO8"],
  "footprint": ["J7o"],
  "footprints": ["FrR","BPD","BPA","BPC","BPB"],
  "footstep": ["J7p"],
  "footwear": ["J7q"],
  "for": ["J77"],
  "for a long time": ["Irn"],
  "for a while": ["Iro"],
  "for ages": ["Irm"],
  "for example": ["Iry"],
  "for good": ["Ir2"],
  "for sale": ["IsB"],
  "for short": ["IsC"],
  "for some time": ["IsD"],
  "for sure": ["IsE"],
  "for the first time": ["IsG"],
  "for the most part": ["IsH"],
  "for the sake of": ["IsI"],
  "for the time being": ["IsJ"],
  "for you": ["HQB"],
  "forage": ["Irl"],
  "forager": ["DWS"],
  "foray": ["J7r"],
  "forbid": ["DWT","BPE"],
  "force": ["FrS","DWU","BPF"],
  "forceful": ["J7t"],
  "forcefully": ["J7s"],
  "forces": ["HP4"],
  "fore": ["Irt"],
  "forearm": ["BPG"],
  "forecast": ["GaU","BPI"],
  "foreclosure": ["J7u"],
  "forefinger": ["Irp"],
  "forefront": ["Irq"],
  "forego": ["J7v"],
  "foreground": ["J7w"],
  "forehead": ["GaV","BPJ","FFN"],
  "foreign": ["Irr"],
  "foreign language": ["HP5"],
  "foreign national": ["KoQ"],
  "foreigner": ["Ez3","KoP"],
  "foreman": ["J7x"],
  "foremost": ["Irs"],
  "forensic": ["J7y"],
  "forerunner": ["Iru"],
  "foresee": ["Irv"],
  "foreseeable": ["J7z"],
  "foreshorten": ["Irw"],
  "forest": ["GaX","BPP","FFO","BPK","DC9","D0h","BPL"],
  "forest fire": ["GaW","BPO","DC8","BPN","DC7","BPM"],
  "forestall": ["Irx"],
  "forestry": ["J70"],
  "forever": ["FrT","DWV","BPQ"],
  "forfeit": ["Irz"],
  "forge": ["Ir0"],
  "forget": ["GaY","Dhh","EXm","DWW"],
  "forget a name": ["HP6"],
  "forget forgot": ["FrU","Dhh","ESw"],
  "forget forgotten": ["EVU"],
  "forget me not": ["BPR"],
  "forget your car key": ["EXm"],
  "forget your key": ["Dhh"],
  "forgeting": ["Dhh"],
  "forgive": ["Ir1"],
  "forgiveness": ["J71"],
  "forgot": ["FrV","ESw","DqV"],
  "forgot his key": ["ESw"],
  "forgotten": ["EVU"],
  "forgotten his keys": ["EVU"],
  "fork": ["GaZ","DDA","FFP","BPT","D0i","BPS"],
  "fork out": ["Ir3"],
  "form": ["HP7"],
  "formal": ["FrW","DWX","BPU","BPV"],
  "formality": ["J72"],
  "formalize": ["J73"],
  "formally": ["J74"],
  "format": ["Ir5"],
  "formation": ["Ir4"],
  "formative": ["J75"],
  "former": ["Ir6"],
  "formerly": ["J76"],
  "formidable": ["Ir7"],
  "formula": ["HQA"],
  "formula 1": ["HP8"],
  "formula one": ["HP9"],
  "formulate": ["Ir8"],
  "formulation": ["Ir9"],
  "forsake": ["IsA"],
  "fort": ["IsL"],
  "forth": ["J78"],
  "forthcoming": ["IsF"],
  "fortieth": ["HBL"],
  "fortify": ["IsK"],
  "fortnight": ["G7v"],
  "fortress": ["FrX","BPW"],
  "fortuitous": ["IsM"],
  "fortunate": ["IsN"],
  "fortunately": ["J79"],
  "fortune": ["FrY","BPX","DWZ"],
  "forty": ["Gaa","Fre","DbK","FFQ","DbE"],
  "forty eight": ["FrZ","DbF"],
  "forty five": ["Fra","DbG"],
  "forty four": ["Frb","DbH"],
  "forty nine": ["Frc","DbI"],
  "forty one": ["Frd","DbJ"],
  "forty seven": ["Frf","DbL"],
  "forty six": ["Frg","DbM"],
  "forty thousand": ["DbN"],
  "forty three": ["Frh","DbO"],
  "forty two": ["Fri","DbP"],
  "forum": ["IsO"],
  "forward": ["Frj","BPZ","DWa"],
  "fossil": ["HQE","Gab","BPa","BPb"],
  "fossil fuel": ["HQC"],
  "fossil fuels": ["HQD","Frk","DWb"],
  "fossils": ["HQF"],
  "foster": ["IsP"],
  "fought": ["EU0"],
  "foul": ["IsQ"],
  "found": ["Frl","Ez4"],
  "foundation": ["IsR"],
  "founder": ["J8A"],
  "fountain": ["Gac","DDC","FFR","BPe","BPc","D0k","BPd"],
  "fountain pen": ["DDB"],
  "four": ["Gad","Frn","DbS","DbQ"],
  "four apples": ["HQG"],
  "four books": ["HQH"],
  "four hundred": ["Frm","DbR"],
  "four thousand": ["DbV"],
  "fourteen": ["Gae","Fro","DbU","FFS","DbT"],
  "fourteen balls": ["HQI"],
  "fourteenth": ["HA9"],
  "fourth": ["HBM","Gaf","DqW"],
  "fox": ["Gag","DDD","FFT","BPj","D0l","BPh","BPg","BPi","BPf"],
  "fox spirit": ["HQJ"],
  "foyer": ["J8B"],
  "fraction": ["HQK"],
  "fracture": ["DWc","BPk"],
  "fragile": ["IsS"],
  "fragment": ["IsT"],
  "fragmentation": ["J8C"],
  "fragrance": ["J8D"],
  "fragrant": ["IsU"],
  "frail": ["IsV"],
  "frame": ["Gai","DWd","BPl"],
  "framework": ["IsW"],
  "franc": ["J8E"],
  "France": ["Gaj","BPp","FFV","DDF","BPm","BPn","D0m","ED9"],
  "France flag": ["Frr","DDE"],
  "franchise": ["IsX"],
  "frank": ["IsY"],
  "frankenstein": ["Gak","BPt","BPs","BPr","BPq"],
  "frankly": ["J8F"],
  "Franks": ["Krr"],
  "frantic": ["IsZ"],
  "frantically": ["J8G"],
  "fraternity": ["J8H"],
  "fraud": ["Isa"],
  "fraudulent": ["Isb"],
  "fraught": ["J8I"],
  "fray": ["Isc"],
  "freak": ["J8J"],
  "freak out": ["Isd"],
  "freckles": ["Gal","BPv","BPw","BPx"],
  "free": ["Ise"],
  "freedom": ["J8K"],
  "freelance": ["J8L"],
  "freely": ["J8M"],
  "freeway": ["Isf"],
  "freeze": ["Gam","BP0","BPy","BPz"],
  "freezer": ["Gan","BP1"],
  "freezing": ["Gao","DDH","FFW","DDG","BP2"],
  "freezing cold": ["HQL"],
  "freight": ["HQM"],
  "French": ["HCo","Krs","Gaq","DDI","FFY","EeL"],
  "french fries": ["Gap","BP3","FFX","BP5","BP4"],
  "french horn": ["BP8"],
  "Frenchman": ["KoR"],
  "frenzy": ["Isg"],
  "frequency": ["HQN","BP9"],
  "frequent": ["Ish"],
  "frequently": ["Frs","DWe"],
  "fresco": ["Isi"],
  "fresh": ["Gar","DqX"],
  "fresh air": ["Frt"],
  "freshen up": ["Isj"],
  "freshly": ["J8N"],
  "freshman": ["J8O"],
  "freshwater": ["J8P"],
  "fret": ["J8Q"],
  "friction": ["HQO"],
  "Friday": ["Gas","DDL","FFZ","DDK","DDJ"],
  "fridge": ["Gat","DDM","FFa","BQD","D0n","BQC","BQB","BQA"],
  "fried chicken": ["Gau","BQE","FFb","BQG","DDN","BQF"],
  "fried egg": ["Fru","BQI","BQH","BQL","D0o","BQK"],
  "fried eggs": ["Frv","BQN","BQM","BQO"],
  "fried food": ["BQP"],
  "fried rice": ["Gav","BQR","BQQ","DDO","BQT","BQS"],
  "friend": ["Gax","BQX","FFd","BQU","BQV"],
  "friendliness": ["J8R"],
  "friendly": ["Gaw","BQW","FFc"],
  "friends": ["Gaz","DWf","FFe","BQZ","BQY","BQb","BQe","BQa"],
  "friendship": ["Gay","BQd","BQc"],
  "fries": ["Ga0","DWg","DDP","BQg","D0p","BQf"],
  "fright": ["Isk"],
  "frighten": ["Frx","DWi"],
  "frightened": ["Ga1","DWh","FFf","BQh","BQj","EEC"],
  "frightening": ["Frw","BQl","BQm","BQk"],
  "frigid": ["Isl"],
  "fringe": ["J8S"],
  "frisbee": ["Ga2","BQn","FFg","BQp","BQo"],
  "frisk": ["DWj"],
  "fritter away": ["Ism"],
  "frivolity": ["Isn"],
  "frivolous": ["Iso"],
  "fro": ["Isu"],
  "frock": ["J8T"],
  "frog": ["Ga3","DDQ","FFh","BQs","EED","BQr","BQq","D0q"],
  "frogs": ["Fry","DqY"],
  "from": ["J8U"],
  "from home": ["HQP"],
  "from now on": ["Isp"],
  "from scratch": ["Isq"],
  "from the shop": ["HQQ"],
  "from time to time": ["Isr"],
  "front": ["Ist"],
  "front door": ["Ga4","BQw","BQx","BQu","BQy","BQt"],
  "frontal": ["J8V"],
  "frontier": ["Iss"],
  "frost": ["Frz","BQ0","BQz"],
  "frostbite": ["HQR"],
  "frosty": ["Fr0","DWk","BQ2","BQ1"],
  "frown": ["Ga5","Fr2","Dhi","BQ4"],
  "frown frowned": ["Dhi"],
  "frown on": ["Isv"],
  "frowning": ["Fr1","Dhi"],
  "frozen": ["Fr3","BQ6","BQ8","BQ7"],
  "frugal": ["Isw"],
  "fruit": ["Ga7","DDR","FFi","BQ9","BRF","DqZ","EEE","BRA"],
  "fruit juice": ["Ga6","BRB","BRC","BRE","BRD"],
  "fruit salad": ["Ga8","BRG","BRH","BRI"],
  "fruit smoothie": ["Fr4","DDS"],
  "fruit stall": ["BRM"],
  "fruit stand": ["Fr5","BRN"],
  "fruitful": ["J8W"],
  "frustrate": ["Isx"],
  "frustrated": ["Ga9","BRP","BRO"],
  "frustration": ["J8X"],
  "fry": ["GbB","Dhj","FFk","BRQ","BRR","BRU"],
  "fry an egg": ["HQS"],
  "fry fried": ["Dhj"],
  "frying": ["Fr6","BRS","Dhj","BRT"],
  "frying pan": ["GbA","DDT","FFj","D0r"],
  "fuchsia": ["Fr7","BRW","BRV"],
  "fuel": ["GbC","BRX","DWl"],
  "fugitive": ["J8Z"],
  "fulfill": ["Isy"],
  "fulfillment": ["J8a"],
  "full": ["Fr9","Ez5"],
  "full moon": ["Fr8","BRY","BRZ"],
  "full stop": ["HQT","G7w"],
  "fully": ["J8b"],
  "fumble": ["J8c"],
  "fume": ["FsA","BRe","BRf"],
  "fumes": ["Isz"],
  "fumigate": ["Is0"],
  "fun": ["GbF","Dqd","FFm","Dqa","Dqb"],
  "function": ["Is1"],
  "functional": ["J8e"],
  "functionality": ["J8d"],
  "fund": ["Is4"],
  "fundamental": ["Is2"],
  "fundamentalist": ["J8f"],
  "fundamentally": ["J8g"],
  "funding": ["Is3"],
  "funeral": ["Is5"],
  "funfair": ["GbD","BRg","FFl","BRi","BRh"],
  "fungi": ["FsB","BRk","BRj","BRl"],
  "fungus": ["HQU"],
  "funky": ["J8h"],
  "funnel": ["FsC","Dqc"],
  "funny": ["GbE","FsD","BRo","DWm","BRn","BRp","EEF","BRm"],
  "fur": ["GbI","DDU","FFo"],
  "furious": ["GbG","BRs","DWn","BRr","BRq"],
  "furiously": ["J8i"],
  "furnace": ["DWo","BRt"],
  "furnish": ["Is7"],
  "furnish a with b": ["Is6"],
  "furniture": ["GbH","BRv","FFn"],
  "furrow": ["J8j"],
  "furry": ["GbJ","BRw"],
  "further": ["Is8"],
  "furthermore": ["G7x"],
  "fury": ["J8k"],
  "fuse": ["Is9"],
  "fuses": ["BRx"],
  "fusion": ["ItA"],
  "fuss": ["ItB"],
  "futile": ["ItC"],
  "futsal": ["BRy"],
  "future": ["HQV"],
  "futuristic": ["ItD"],
  "fuzzy": ["J8l"],
  "G": ["DZx","FGW","HCv"],
  "g": ["Gcd","DZy","HCp"],
  "gadget": ["J8m"],
  "Gaelic football": ["HQW"],
  "gain": ["ItG"],
  "gain insight into": ["ItE"],
  "gain on": ["ItF"],
  "gait": ["ItH"],
  "Galapagos Islands": ["J8n","HQX"],
  "galaxy": ["GbK","BR1","FFp","BR2","BRz","BR0"],
  "gale": ["FsE"],
  "Galileo": ["J8o"],
  "gall": ["J8q"],
  "gallery": ["GbL","BR5","BR4"],
  "gallon": ["J8p"],
  "gallop": ["ItI"],
  "galvanize": ["J8r"],
  "gamble": ["ItJ"],
  "game": ["GbN","BR8","FFr","BR7","BR9","BR6"],
  "game console": ["GbM","Dqe","FFq"],
  "game designer": ["FsF","DWp"],
  "game show": ["FsG","DWq"],
  "games": ["GbP","Dqf"],
  "games console": ["GbO","DDV","FFs","BSA","BSB","BSC"],
  "gamete": ["J8s"],
  "gamma": ["J8t"],
  "Gandhi": ["J8u"],
  "gang": ["ItK"],
  "Ganges": ["J8v"],
  "Ganges River": ["J8w"],
  "gangster": ["J8x"],
  "Ganymede": ["HQY"],
  "gap": ["J8z"],
  "gape": ["J8y"],
  "garage": ["GbQ","DDW","FFt","BSD","D0t"],
  "garb": ["ItM"],
  "garbage": ["GbR","BSG","FFu","BSP","BSE","BSH","BSF","BSI"],
  "garbage can": ["FsI","BSJ","BSL","BSM","BSN"],
  "garbage collection": ["ItL"],
  "garbage truck": ["FsK","BSQ","BSR"],
  "garbageman": ["FsJ","DDY","DDX","EEG","BSO"],
  "garden": ["GbU","DDb","FFx","BST","BSW","BSS"],
  "gardener": ["GbS","DDa","FFv","DDZ","BSU","EEJ","EEI","D0u"],
  "gardening": ["GbT","BSV","FFw"],
  "gargoyle": ["BSZ","BSX","BSY"],
  "garlic": ["GbV","BSe","FFy","DDc","BSb","D0v","BSa","BSd","BSc"],
  "garment": ["ItN"],
  "garner": ["J80"],
  "garrison": ["J81"],
  "gas": ["GbW","BSf"],
  "gas station": ["GbX","BSh","FFz","DDd","BSg","BSi","D0w"],
  "gaseous": ["ItO"],
  "gasoline": ["ItP"],
  "gasp": ["ItQ"],
  "gastric": ["J82"],
  "gastrointestinal": ["J83"],
  "gate": ["GbY","BSl","FF0","DDe","BSn","D0x","BSj","BSm","BSp","BSo","BSk"],
  "gateway": ["J84"],
  "gather": ["FsM","DWr","BSq"],
  "gather up": ["ItR"],
  "gathering": ["FsL","Dqg"],
  "gauge": ["ItS"],
  "gave": ["FsN","ESx"],
  "gave her a gift": ["ESx"],
  "gay": ["FsO"],
  "gaze": ["FsQ","BSr","DWs"],
  "gazelle": ["FsP","BSt","BSu","BSs"],
  "gazette": ["ItT"],
  "GDP": ["HQZ"],
  "gear": ["HQa"],
  "gear up": ["ItU"],
  "gears": ["HQb"],
  "gecko": ["GbZ","BSw","BSy","BSx"],
  "gee": ["J86"],
  "geek": ["J85"],
  "geese": ["Gba","BSz","BS1","BS0"],
  "geisha": ["HQc"],
  "gel": ["J87"],
  "gem": ["FsR","BS2","BS3","BS6","BS5"],
  "Gemini": ["HQd"],
  "gemstone": ["ItV"],
  "gender": ["ItW"],
  "gene": ["HQe"],
  "general": ["HQf"],
  "generality": ["J88"],
  "generalization": ["ItX"],
  "generalize": ["ItY"],
  "generally": ["J89"],
  "generally speaking": ["ItZ"],
  "generate": ["Ita"],
  "generation": ["Ez6"],
  "generator": ["J9A"],
  "generic": ["Itb"],
  "generosity": ["J9B"],
  "generous": ["Gbb","DWt","FF1"],
  "generously": ["J9C"],
  "genes": ["HQg"],
  "genesis": ["Itc"],
  "genetic": ["Ite"],
  "genetically": ["J9D"],
  "genetically modified food": ["Itd"],
  "genetics": ["HQh"],
  "Geneva": ["G7y"],
  "Genghis Khan": ["J9E"],
  "genial": ["Itf"],
  "genius": ["Itg"],
  "genocide": ["J9F"],
  "genome": ["Ith"],
  "genotype": ["J9G"],
  "genre": ["Iti"],
  "gentility": ["Itj"],
  "gentle": ["J9H","Itl"],
  "gentleman": ["Itk"],
  "gentlemen": ["FsS","BS7"],
  "gently": ["J9I"],
  "gentry": ["J9J"],
  "genuine": ["Itm"],
  "genuinely": ["J9K"],
  "genus": ["J9L"],
  "geographic": ["J9O"],
  "geographical": ["J9N"],
  "geographically": ["J9M"],
  "geography": ["Gbc","FsT","DDf","BTB","BS8","BTA","D0y","BS9"],
  "geological": ["J9P"],
  "geologist": ["J9Q"],
  "geology": ["Itn"],
  "geometric": ["Ito"],
  "geometry": ["Itp"],
  "Geordie": ["KoS"],
  "George Washington": ["J9R"],
  "Georgia": ["HCr","EEK"],
  "Georgian": ["HCq","KoT"],
  "germ": ["Itr"],
  "German": ["HCs","KoU","Gbd","DDg","EeM"],
  "German shepherd": ["BTC"],
  "Germanic": ["KrY"],
  "Germans": ["Krt"],
  "Germany": ["Gbe","BTH","FF2","DDi","EEL","D0z","BTD","BTF","BTE"],
  "Germany flag": ["FsU","DDh"],
  "germinal": ["J9S"],
  "germinate": ["Itq"],
  "germination": ["J9T"],
  "germs": ["FsV","BTK","BTJ","BTI"],
  "gestation": ["J9U"],
  "gesture": ["Its"],
  "get": ["Gbj","Dhk","Dhl","EcI","EXr","EcJ","EXu","EXs","EXq","EXo"],
  "get a book": ["FsW","Dhk","EcI"],
  "get a burger": ["EEM"],
  "get a drink": ["FsX","Dhl"],
  "get a haircut": ["Gbf","Dhm","Dhn","EXo","EcJ"],
  "get a hold of": ["Itu"],
  "get a massage": ["EEN"],
  "get ahead": ["Itt"],
  "get along": ["HQi"],
  "get along with": ["Itv"],
  "get an injection": ["FsY","Dho"],
  "get angry": ["HQj"],
  "get around": ["Itw"],
  "get around to": ["Itx"],
  "get away": ["HQk"],
  "get away with": ["HQl"],
  "get back": ["HQm"],
  "get back at": ["Ity"],
  "get back into": ["Itz"],
  "get back to someone": ["It0"],
  "get better": ["HQn"],
  "get by": ["It1"],
  "get carried away": ["It2"],
  "get cold": ["HQo"],
  "get down": ["It4"],
  "get down on": ["It3"],
  "get dressed": ["Gbg","Dhp","EXq","EEO"],
  "get dressed got dressed": ["Dhp"],
  "get even with": ["It5"],
  "get eyes checked": ["Dhq"],
  "get got": ["Gbh","Dhk","ET1","EVp","Dhl"],
  "get his phone fixed": ["EEP"],
  "get home": ["FsZ","Dqh"],
  "get in on": ["It6"],
  "get in touch with": ["It8"],
  "get into": ["It7"],
  "get involved in": ["It9"],
  "get it wrong": ["IuA"],
  "get juice from the fridge": ["EXr"],
  "get lost": ["Fsa"],
  "get married": ["Fsb","Dhr"],
  "get married got married": ["Dhr"],
  "get married to": ["IuB"],
  "get nowhere with": ["IuC"],
  "get off": ["Ez7"],
  "get off a bus": ["HQp"],
  "get on": ["Gbi","Dhu","Dhs","Eax","EER","Dht"],
  "get on a bus": ["Fsc","Dht","EER","Eax"],
  "get on got on": ["Dhs","Dhu"],
  "get on with": ["HQq"],
  "get out": ["IuE"],
  "get out of": ["IuD"],
  "get over": ["Ez8"],
  "get over with": ["IuF"],
  "get ready": ["HQr"],
  "get rid of": ["HQs"],
  "get some rest": ["Ez9"],
  "get some sleep": ["E0A"],
  "get stuck": ["IuG"],
  "get the better of": ["IuH"],
  "get through": ["HQt"],
  "get tired of": ["IuI"],
  "get to": ["Dhv"],
  "get to got to": ["Dhv"],
  "get to work": ["Fsd","Dhv","EXs"],
  "get together": ["IuJ"],
  "get undressed": ["Fse"],
  "get up": ["Gbk","Dhx","FF3","Dhw","EXt","Eay","EEU"],
  "get up early": ["Fsf","EXt"],
  "get up got up": ["Dhw","Dhx"],
  "get used to": ["IuK"],
  "get well": ["HQu"],
  "get well soon": ["HQv"],
  "get wet": ["HQw"],
  "get your eyes checked": ["EXu"],
  "get your nails painted": ["Dhy"],
  "getting": ["EcI","Dhl","EcJ","Dhk"],
  "getting a book": ["Dhk","EcI"],
  "getting a drink": ["Dhl"],
  "getting a haircut": ["EcJ","Dhm","Dhn"],
  "getting an injection": ["Dho"],
  "getting dressed": ["Dhp"],
  "getting eyes checked": ["Dhq"],
  "getting married": ["Dhr"],
  "getting on": ["Dhs","Eax","Dhu","Dht"],
  "getting on a bus": ["Dht","Eax"],
  "getting to": ["Dhv"],
  "getting to work": ["Dhv"],
  "getting up": ["Dhw","Eay","Dhx"],
  "getting your nails painted": ["Dhy"],
  "Ghana": ["HCu","EEV"],
  "Ghanaian": ["HCt","KoV"],
  "ghastly": ["J9V"],
  "gherkin": ["BTL"],
  "gherkins": ["BTN","BTM"],
  "ghetto": ["J9W"],
  "ghost": ["Gbl","BTO","FF4","BTP","BTR","EEW","BTQ"],
  "ghosts": ["EEX"],
  "giant": ["Gbm","BTS"],
  "gibe": ["IuL"],
  "gift": ["Gbn","DDj","FF5","BTU","BTT","Ehg","EEY","BTV"],
  "gift shop": ["Gbo","Dqi"],
  "gifts": ["Gbp","BTY","Ehh","BTW","BTX"],
  "gig": ["J9Y"],
  "gigantic": ["BTa"],
  "giggle": ["J9X"],
  "gild": ["J9Z"],
  "gilding": ["IuM"],
  "gills": ["Fsg","Dqj"],
  "gilt": ["J9a"],
  "gimmick": ["IuN"],
  "gin": ["IuO"],
  "ginger": ["Gbt","BTp","DDk","BTd","BTb","D01"],
  "ginger hair": ["Fsh","BTm"],
  "gingerbread": ["Gbs","BTl","FF7","BTe"],
  "gingerbread house": ["Gbq","BTg","BTf","BTh"],
  "gingerbread man": ["Gbr","BTk","FF6","Ehi","BTi","BTj"],
  "giraffe": ["Gbu","DDl","FF8","BTr","BTs","D02","BTq","BTu","BTt"],
  "girder": ["BTx","BTv","BTw"],
  "girl": ["Gbv","BTz","FF9","BTy","BT1","BT0"],
  "girlfriend": ["J9b"],
  "gist": ["IuP"],
  "give": ["Gbx","Dhz","FGA","Eaz","BT8","BT3","EXv","Dh0","BT4","Dh1","BT2"],
  "give a gift": ["Fsi","Dhz","Dh0","Eaz","EXv"],
  "give a hand": ["BT5","BT6"],
  "give a hug": ["HQx"],
  "give a presentation": ["Dh1"],
  "give away": ["HQy"],
  "give back": ["HQz"],
  "give birth": ["IuQ"],
  "give birth to": ["IuR"],
  "give flowers": ["BT7"],
  "give food": ["HQ0"],
  "give gave": ["Gbw","ESx","Dhz","Dh0","Dh1"],
  "give given": ["EVo"],
  "give in": ["HQ1"],
  "give it a try": ["IuS"],
  "give it back": ["HQ2"],
  "give it up for": ["IuT"],
  "give me": ["HQ3"],
  "give off": ["HQ4"],
  "give on to": ["IuU"],
  "give out": ["Dh2"],
  "give out gave out": ["Dh2"],
  "give out money": ["Dh2"],
  "give rise to": ["IuV"],
  "give someone a hand": ["EEc","EEd","EEe"],
  "give someone the cold shoulder": ["EEf","EEg","EEh"],
  "give thanks": ["HQ5"],
  "give to": ["HQ6"],
  "give up": ["E0B"],
  "give yourself something to aim for": ["IuW"],
  "given": ["EVo"],
  "given a presentation": ["EVo"],
  "giving": ["Fsj","Dhz","Eaz","Dh1","Dh0"],
  "giving a gift": ["Dhz","Eaz","Dh0"],
  "giving a presentation": ["Dh1"],
  "giving out": ["Dh2"],
  "giving out money": ["Dh2"],
  "Giza": ["HQ7"],
  "glacial": ["IuX"],
  "glacier": ["Gby","BUB","BT9","BUA"],
  "glad": ["Gbz","BUC","BUI","BUD"],
  "gladiator": ["BUH","BUE"],
  "gladly": ["J9c"],
  "glamor": ["J9d"],
  "glamorous": ["IuY"],
  "glance": ["Iua"],
  "glance off": ["IuZ"],
  "gland": ["Iub"],
  "glare": ["Iuc"],
  "glass": ["Gb1","DDo","FGC","BUW","BUN","D05","BUK","BUM","BUJ","BUL"],
  "glass of milk": ["Fsk","BUT","BUS"],
  "glass water": ["BUZ"],
  "glasses": ["Gb0","DDn","FGB","BUR","DDm","D03","BUO","BUQ","Ehz","D04","BUP"],
  "glaze": ["Iud"],
  "gleam": ["Iue"],
  "glean": ["Iuf"],
  "glial": ["J9e"],
  "glide": ["Iug"],
  "glider": ["J9f"],
  "glimmer": ["Iuh"],
  "glimpse": ["Iui"],
  "glint": ["J9g"],
  "glisten": ["J9h"],
  "glitch": ["DWu"],
  "glitter": ["Iuj"],
  "global": ["Fsl","BUd","DWv","BUc"],
  "global warming": ["Gb2","BUe"],
  "globalization": ["HQ8"],
  "globally": ["J9i"],
  "globe": ["Gb3","DDp","D06","BUf","BUg"],
  "globular cluster": ["HQ9"],
  "gloom": ["Iuk"],
  "gloomy": ["Fsm","BUh","BUi"],
  "glorify": ["Iul"],
  "glorious": ["Ium"],
  "glory": ["J9j"],
  "gloss": ["Iuo"],
  "gloss over": ["Iun"],
  "glossary": ["J9k"],
  "glossy": ["Iup"],
  "glove": ["Gb4","BUj","FGD","BUk"],
  "gloves": ["Gb5","DDq","FGE","BUl","D07","BUo","BUn","BUm"],
  "glow": ["Iuq"],
  "glucose": ["HRA"],
  "glue": ["Gb6","BUq","BUp","DWw"],
  "glue stick": ["Gb7","BUr","FGF"],
  "glue the paper": ["HRB"],
  "gluten free": ["DWx"],
  "gnaw": ["Iur"],
  "go": ["GcR","Dh8","FGQ","Dh9","EdT","EX1","EXz","EXx","EX0","EXy"],
  "go about": ["Ius"],
  "go against": ["Iut"],
  "go ahead": ["HRC"],
  "go along": ["HRD"],
  "go at": ["Iuu"],
  "go away": ["HRE"],
  "go back": ["Fso","Dqk"],
  "go been": ["EVm","EVR"],
  "go by": ["HRF"],
  "go camping": ["GcA","EEi"],
  "go cycling": ["GcB","Dql"],
  "go diving": ["Fsp","Dh3"],
  "go down": ["HRH"],
  "go downstairs": ["HRI"],
  "go dutch": ["Iuw"],
  "go first": ["HRJ"],
  "go fishing": ["GcC","Dqm","FGI","EEj"],
  "go for": ["Iux"],
  "go for a walk": ["GcD","Dqn","FGJ"],
  "go hiking": ["GcF","Dh4"],
  "go hiking in the mountains": ["EXx"],
  "go home": ["GcG","Dqo","FGL"],
  "go horseback riding": ["Fsr","E0C"],
  "go in": ["Iuz"],
  "go in for": ["Iuy"],
  "go into": ["HRK"],
  "go into space": ["EEk"],
  "go jogging": ["GcH","Dqp"],
  "go karting": ["HRL"],
  "go last": ["HRM"],
  "go off": ["HRU"],
  "go on": ["HRV"],
  "go on a journey": ["E0D"],
  "go on a picnic": ["Iu6"],
  "go on to": ["Iu7"],
  "go online": ["E0E"],
  "go out": ["Fs5","E0F"],
  "go outside": ["Fs6"],
  "go over": ["HRW"],
  "go rock climbing": ["EEm"],
  "go running": ["Fs7","E0G"],
  "go sailing": ["Fs8","E0H"],
  "go scuba diving": ["EXy"],
  "go shopping": ["GcT","Dh5","FGS"],
  "go shopping went shopping": ["Dh5"],
  "go sightseeing": ["GcU","Dqv"],
  "go skating": ["Fs9","Dqw"],
  "go skiing": ["GcV","Dqx","EEo","EEn"],
  "go straight": ["FtB","E0I","E0J"],
  "go surfing": ["FtC","E0K"],
  "go swimming": ["GcW","Dqy"],
  "go through": ["HRX"],
  "go through with": ["IvD"],
  "go to": ["FtE","Dh6","Dh7"],
  "go to a cafe": ["FtD","Dh6","EXz"],
  "go to bed": ["GcX","Dh7","FGT","EX0","EEp"],
  "go to school": ["GcY","Dh8","FGU","EdT"],
  "go to sleep": ["FtF","E0L"],
  "go to the beach": ["FtG","E0M"],
  "go to the cinema": ["GcZ","Dqz"],
  "go to the doctor": ["HRY"],
  "go to the gym": ["FtH","E0N"],
  "go to the movies": ["E0O"],
  "go to the park": ["FtI","E0P"],
  "go to the shop": ["HRZ"],
  "go to the toilet": ["HRa"],
  "go to the WC": ["Dh9","EX1"],
  "go to the zoo": ["FtJ","Dq0"],
  "go to went to": ["Dh7"],
  "go to work": ["Gca","Dq1"],
  "go under": ["IvF"],
  "go up": ["HRb"],
  "go upstairs": ["HRc"],
  "go viral": ["DW0"],
  "go went": ["Gcc","Dh8","FGV","EVE","Dh4","Dh3"],
  "go without saying": ["IvI"],
  "go wrong": ["IvJ"],
  "goal": ["Gb8","BUt","FGG","BUs"],
  "goat": ["Gb9","DDr","FGH","BUw","BUu","D08","BUy","BUx","BUv"],
  "goats": ["Fsn","BU0","BUz"],
  "gobble up": ["Iuv"],
  "god": ["Fsq","BU1"],
  "goddess": ["HRG"],
  "gog": ["J9l"],
  "goggles": ["GcE","DDs","FGK","BU4","BU3","BU5","D09","BU2"],
  "going": ["Fss","Dh8","Dh9","EdT"],
  "going diving": ["Dh3"],
  "going hiking": ["Dh4"],
  "going shopping": ["Fst","Dh5"],
  "going to": ["Dh6","Dh7"],
  "going to a cafe": ["Dh6"],
  "going to bed": ["Dh7"],
  "going to buy a TV": ["Ees"],
  "going to clean the windows": ["Eet"],
  "going to cut down the tree": ["Eeu"],
  "going to do laundry": ["Eev"],
  "going to drink coffee": ["Eew"],
  "going to eat a banana": ["Eex"],
  "going to fly a kite": ["Eey"],
  "going to have a picnic": ["Eez"],
  "going to jump into the water": ["Ee0"],
  "going to land": ["Ee1"],
  "going to play football": ["Ee2"],
  "going to play tennis": ["Ee3"],
  "going to school": ["Fsu","Dh8","EdT"],
  "going to shave his beard": ["Ee4"],
  "going to sleep": ["Ee5"],
  "going to swim": ["Ee6"],
  "going to take a bath": ["Ee7"],
  "going to take a photo": ["Ee8"],
  "going to take a train": ["Ee9"],
  "going to the movies": ["Fsv"],
  "going to the WC": ["Dh9"],
  "going to walk the dog": ["EfA"],
  "going to watch a movie": ["EfB"],
  "gold": ["GcJ","BVJ","FGN","BU8","DDt","BU6","BU7"],
  "golden": ["Fsw"],
  "golden eagle": ["BVB","BVC"],
  "golden opportunity": ["Iu0"],
  "goldfish": ["GcI","BVE","FGM","BVD","BVI","BVG","BVF"],
  "goldfish bowl": ["BVH"],
  "golf": ["GcK","DDu","D1A","BVN","BVL","BVM","BVK"],
  "golfer": ["J9m"],
  "gondola": ["Iu1"],
  "good": ["GcP","BVT","EEl","DWz"],
  "good afternoon": ["Fsx","Fsy"],
  "good bye": ["GcL","Dqq"],
  "good evening": ["Fs0","Fsz","Dqr"],
  "good for": ["HRQ"],
  "good for you": ["HRR"],
  "good idea": ["BVR","BVS"],
  "good job": ["HRS"],
  "good luck": ["HRT","G7z"],
  "good morning": ["GcN","Fs1","Dqs"],
  "good night": ["GcO","Fs2","Dqt","Dqu"],
  "goodbye": ["GcM","BVQ","FGO","BVP","DWy","BVO"],
  "goodbye everyone": ["HRN"],
  "goodbye for now": ["HRO"],
  "goodbye friend": ["HRP"],
  "goodness": ["J9n"],
  "goodnight": ["J9o"],
  "goods": ["Iu2"],
  "goodwill": ["J9p"],
  "goody": ["J9q"],
  "goof around": ["Iu3"],
  "goof off": ["Iu4"],
  "goof up": ["Iu5"],
  "google": ["Fs3","BVU"],
  "goose": ["GcQ","BVW","FGP","BVV","BVa","BVX"],
  "gooseberry": ["Fs4","BVZ","BVY"],
  "gorge": ["Iu9"],
  "gorgeous": ["Iu8"],
  "gorilla": ["GcS","DDv","FGR","BVf","BVe","D1B","BVd","BVc","BVb"],
  "gosh": ["J9r"],
  "gosling": ["FtA","BVi","BVg","BVh"],
  "gospel": ["IvA"],
  "gossip": ["IvB"],
  "got": ["FtK","ET1","EVp"],
  "got a book": ["ET1"],
  "got an injection": ["EVp"],
  "gothic": ["IvC"],
  "Goths": ["Kru"],
  "gouge": ["IvE"],
  "gourd": ["IvG"],
  "gourmet": ["IvH"],
  "govern": ["HRe"],
  "governance": ["J9s"],
  "government": ["HRd","Gcb","BVk","BVj"],
  "governmental": ["J9t"],
  "governor": ["J9u"],
  "gown": ["FtL","BVl"],
  "gps": ["FtM","BVo","BVm","BVn"],
  "grab": ["Gce","Dq2"],
  "grace": ["IvK"],
  "graceful": ["FtN","BVq","DW1"],
  "gracious": ["IvL"],
  "grad": ["J9w"],
  "grade": ["IvM"],
  "grader": ["J9v"],
  "gradient": ["IvN"],
  "grading": ["IvO"],
  "gradual": ["IvP"],
  "gradually": ["BVs"],
  "graduate": ["FtO","DW2","DiA","BVu"],
  "graduate college": ["DiA"],
  "graduate from college": ["EEq"],
  "graduate graduated": ["EWP","DiA"],
  "graduated": ["EWP"],
  "graduated from college": ["EWP"],
  "graduating": ["DiA"],
  "graduating college": ["DiA"],
  "graduation": ["FtP","BVy"],
  "graduation ceremony": ["BVx"],
  "graffiti": ["IvQ"],
  "graft": ["J9x"],
  "grain": ["FtQ","BV1","BV0","BVz"],
  "grains": ["FtR","Dq3"],
  "gram": ["HRg"],
  "grammar": ["HRf"],
  "grammatical": ["J9y"],
  "grand": ["G70"],
  "Grand Canyon": ["HRh"],
  "Grand Prix": ["HRi"],
  "grandad": ["Gcf","DW4","DW3"],
  "grandchild": ["J9z"],
  "granddad": ["FtS"],
  "granddaughter": ["Gcg","DW5","FGX","DZU","DW6","BV2","EEr","BV3"],
  "grandeur": ["J90"],
  "grandfather": ["Gch","DZV","FGY","DW7","BV4","BV6","EEs","BV5","DW8"],
  "grandma": ["Gci","DXA","FGZ","BV9","DW9","BV7","BV8"],
  "grandmother": ["Gcj","BWA","FGa","DZW","DXB","EEt"],
  "grandpa": ["Gck","DXC","FGb","BWC","BWB"],
  "grandparent": ["J91"],
  "grandparents": ["Gcl","DXD","FGc","BWE","BWD"],
  "grandson": ["Gcm","DXE","DZX","BWH","BWG","BWF","EEu"],
  "granite": ["BWI","BWJ"],
  "granny": ["FtT","DXG","BWN","BWM"],
  "grant": ["IvR"],
  "granular": ["IvS"],
  "granule": ["J92"],
  "grape": ["J93"],
  "grape juice": ["FtU","BWT","BWU"],
  "grapefruit": ["Gcn","DDw","FGd","BWO","BWP","BWS","BWQ","D1C","Egk","BWR"],
  "grapes": ["Gco","DDx","FGe","BWZ","D1D","BWW","BWY","BWX","BWV"],
  "grapeshot": ["J94"],
  "graph": ["HRk"],
  "graphic": ["J96"],
  "graphic design": ["HRj"],
  "graphic designer": ["Gcp","DDy","DDz","D1E","BWa"],
  "graphical": ["J95"],
  "graphics": ["IvT"],
  "graphite": ["IvU"],
  "grapple": ["J97"],
  "grasp": ["BWb"],
  "grass": ["Gcs","BWj","FGg","BWe","BWd","BWc"],
  "grasshopper": ["Gcq","DD0","FGf","BWh","BWg","D1F","BWf","BWi"],
  "grassland": ["Gcr","Dq4"],
  "grassroot": ["J98"],
  "grassy": ["J99"],
  "grate": ["FtV","BWl"],
  "grateful": ["E0Q"],
  "gratefully": ["KAA"],
  "grater": ["FtW","DD1","D1G"],
  "gratify": ["IvV"],
  "gratitude": ["IvW"],
  "grave": ["IvX"],
  "gravel": ["FtX","BWq"],
  "gravely": ["KAB"],
  "graveyard": ["Gct","BWv","BWr","BWs","BWt"],
  "gravitational": ["IvY"],
  "gravity": ["Gcu","DXH"],
  "gravy": ["FtY","BWx","BWw"],
  "gray": ["Gcv","BWy","FGh","DD6"],
  "gray hair": ["FtZ"],
  "graze": ["BW0"],
  "grazing": ["BW3","BW2"],
  "grease": ["IvZ"],
  "greasy": ["KAC"],
  "great": ["Ftc","E0R"],
  "Great Barrier Reef": ["HRl"],
  "great grandfather": ["Fta","DXI","BW4"],
  "great grandmother": ["Ftb","DXJ"],
  "Great Lakes": ["KAD"],
  "Great Plains": ["KAG"],
  "Great Pyramid of Giza": ["HRm"],
  "great red spot": ["HRn"],
  "Great Sphinx": ["HRo"],
  "Great Wall of China": ["Ftd","BW7","BW5","BW6"],
  "great white shark": ["Fte","BW8"],
  "greatly": ["KAE"],
  "greatness": ["KAF"],
  "Greece": ["HCw","Gcw","BXC","FGi","BW9","EEy","BXA","BXB"],
  "Greece flag": ["DD2"],
  "greed": ["Iva"],
  "greedy": ["Ftf","Dq5"],
  "Greek": ["HCx","KoW","Ftg","Dq6"],
  "Greek Mythology": ["HRp"],
  "Greeks": ["Krv"],
  "green": ["Gc1","Ftm","DD3","BXX"],
  "green bean": ["Fth","BXE","BXD","BXG"],
  "green beans": ["Gcx","Dq7"],
  "green eyes": ["Gcy","BXH"],
  "green frog": ["Fti","BXI"],
  "green pepper": ["Ftl","BXT"],
  "green peppers": ["BXV"],
  "green salad": ["BXY"],
  "green scarf": ["Ftn","DD4","Ef8"],
  "green shorts": ["Fto","DD5","EgI"],
  "green tea": ["Ftp","BXa","BXb"],
  "greengrocer": ["Gcz","BXM","FGj","BXJ","BXK","BXL"],
  "greengrocer's": ["Gc0","Ftj","Dq8","E0S"],
  "greenhouse": ["Ftk","BXP","BXQ","BXO","BXS"],
  "greenhouse effect": ["BXR"],
  "greenhouse gas": ["Ivb"],
  "Greenland": ["HCy"],
  "greet": ["Ftr","DiB","EX2"],
  "greet greeted": ["ET2","DiB"],
  "greet people": ["EX2"],
  "greeted": ["ET2"],
  "greeted guests": ["ET2"],
  "greeting": ["Ftq","DiB"],
  "greetings": ["DXK"],
  "gregarious": ["Ivc"],
  "grenade": ["KAH"],
  "grew": ["EUl"],
  "grey": ["Gc2","DD6","FGk","BWy"],
  "grid": ["Ivd"],
  "grief": ["Ive"],
  "grievance": ["KAI"],
  "grieve": ["KAJ"],
  "grievous": ["Ivf"],
  "grill": ["Gc3","BXc","FGl"],
  "grim": ["Fts","BXd"],
  "grim reaper": ["EE0","EE1"],
  "grimace": ["KAK"],
  "grimly": ["Ivg"],
  "grin": ["Ftt","BXe","BXf"],
  "grind": ["Ivj"],
  "grind down": ["Ivh"],
  "grind out": ["Ivi"],
  "grip": ["Ftu","BXh"],
  "gripe": ["Ivk"],
  "grit": ["KAL"],
  "groan": ["Ivl"],
  "grocer": ["Ivm"],
  "grocery": ["Gc4","BXi"],
  "grocery store": ["Gc5","BXj","FGm"],
  "groom": ["Gc6","Dq9","BXk"],
  "groove": ["Ivn"],
  "gross": ["Ivo"],
  "grossly": ["KAM"],
  "grotesque": ["KAN"],
  "ground": ["Gc7","BXl","FGn"],
  "ground floor": ["Ftv","DXL"],
  "groundwater": ["DXM"],
  "group": ["Gc8","BXp","BXn","BXo"],
  "grouse": ["Ivp"],
  "grove": ["Ivr"],
  "grovel": ["Ivq"],
  "grow": ["Gc9","DiC","BXs"],
  "grow apart": ["Ivs"],
  "grow bigger": ["HRq"],
  "grow food": ["Ftw","BXq","EE2"],
  "grow grew": ["EUl","DiC"],
  "grow out of": ["Ivt"],
  "grow up": ["E0V"],
  "grower": ["KAO"],
  "growing": ["Ftx","DiC"],
  "growl": ["Ftz"],
  "growling": ["Fty","BXr"],
  "grown up": ["E0T"],
  "growth": ["E0U"],
  "grudge": ["Ivu"],
  "grueling": ["Ivv"],
  "grumble": ["Ivw"],
  "grump": ["Ivx"],
  "grumpy": ["GdA","BXu","EE3","BXt"],
  "grunt": ["KAP"],
  "guacamole": ["DD7"],
  "guanyin": ["HRr"],
  "guarantee": ["Ivy"],
  "guarantor": ["KAQ"],
  "guard": ["Ft0","DiD","DiE","EdU"],
  "guard a building": ["EE4"],
  "guard guarded": ["EU1","DiD","DiE"],
  "guard the door": ["EdU","DiE"],
  "guarded": ["EU1"],
  "guarded a door": ["EU1"],
  "guardian": ["Ivz"],
  "guarding": ["EdU","DiD","DiE"],
  "guarding the door": ["EdU","DiE"],
  "Guatemala": ["HC0","EE5"],
  "Guatemalan": ["HCz","KoX"],
  "guava": ["GdB","BXw","FGo","BXx","BXv","BXy"],
  "guerrilla": ["KAR"],
  "guess": ["Iv0"],
  "guess what": ["HRs"],
  "guest": ["GdC","DXN"],
  "guests": ["GdD","DXO"],
  "guidance": ["KAS"],
  "guide": ["GdE","DiF","FGp","BX0","EX4"],
  "guide book": ["Ft1","BXz"],
  "guide guided": ["DiF"],
  "guide tourists": ["Ft2","DiF","EX4"],
  "guidebook": ["HRt"],
  "guideline": ["Iv1"],
  "guiding": ["DiF"],
  "guiding tourists": ["DiF"],
  "guild": ["KAT"],
  "guilt": ["KAU"],
  "guilty": ["Iv2"],
  "Guinea": ["KAV"],
  "guinea pig": ["GdF","BX3","FGq","BX2","BX1","BX4"],
  "guise": ["KAW"],
  "guitar": ["GdG","DD8","FGr","BX5","BX9","D1H","BX8","BX6","BX7"],
  "guitarist": ["KAX"],
  "gulf": ["Iv3"],
  "Gulf Coast": ["KAY"],
  "Gulf of Mexico": ["KAZ"],
  "gull": ["Ft3","BYD","BYB","BYC"],
  "gullible": ["Iv4"],
  "gulp": ["KAa"],
  "gum": ["GdH","BYE","FGs","BYF","BYG","BYJ"],
  "gumiho": ["HRu"],
  "gummybears": ["Ft4","BYH","BYI"],
  "gun": ["HRv"],
  "gunman": ["KAb"],
  "guru": ["KAc"],
  "gush": ["Iv5"],
  "gust": ["E0W"],
  "gut": ["KAe"],
  "Gutenberg": ["KAd"],
  "guts": ["Iv6"],
  "gutter": ["KAf"],
  "guy": ["Ft5","BYK"],
  "Guyana": ["HC1"],
  "Guyanese": ["HC2"],
  "guzzle down": ["Iv7"],
  "gym": ["GdJ","DD9","FGu","BYN","BYR","BYM","BYL"],
  "gymnasium": ["Ft6","BYO"],
  "gymnastics": ["GdI","BYQ","FGt","BYP"],
  "gypsy": ["KoY"],
  "H": ["FwL","DZz","FH6","HDA"],
  "h": ["Ge6","DZ0","HC3"],
  "H2": ["HRx"],
  "H2O": ["HRw"],
  "habit": ["HRy"],
  "habitable": ["Ft7","DXP"],
  "habitat": ["GdK","BYS","FGv"],
  "habitual": ["Iv8"],
  "hack": ["Ft8","BYU","BYT"],
  "hack into": ["Iv9"],
  "hack off": ["IwA"],
  "hacker": ["KAg"],
  "hacksaw": ["Ft9","BYY","BYW"],
  "had": ["FuB","EWK","EV4","EVq","ET3","EVr"],
  "had a cat": ["FuA","EVq"],
  "had a haircut": ["EV4"],
  "had a job interview": ["EVr"],
  "had better": ["IwB"],
  "had breakfast": ["EWK"],
  "had two pens": ["ET3"],
  "Hades": ["HRz"],
  "haetae": ["HR0"],
  "haha": ["FuC"],
  "hail": ["GdL","DEB","FGw","DEA","BYa","BYZ"],
  "hailstorm": ["HR1"],
  "hair": ["GdP","DEG","FG0","D1L","BYl","BYb"],
  "hair dryer": ["GdO","DEF","FGz","BYi","BYh","D1K","BYj"],
  "hair salon": ["GdQ","DEH","BYn","BYo","BYm"],
  "hair stylist": ["FuE","BYq","BYp"],
  "hairbrush": ["GdM","DEC","FGx","D1I","BYd","BYe","BYc"],
  "haircut": ["E0X"],
  "hairdresser": ["GdN","DED","FGy","BYf","EE7","BYg","DEE","EE8","D1J"],
  "hairline": ["FuD","BYk"],
  "hairy": ["KAh"],
  "Haiti": ["HC5","EE9"],
  "Haitian": ["HC4","KoZ"],
  "half": ["G71","G73","GdS","BYr"],
  "half a dozen": ["G72"],
  "half moon": ["HR2"],
  "half past": ["HR3"],
  "half past 12": ["DeH"],
  "half past 2": ["DeI"],
  "half past 5": ["DeF"],
  "half past 7": ["DeG"],
  "half past five": ["FuI","DeF"],
  "half past seven": ["FuJ","DeG","EfT"],
  "half past twelve": ["FuK","DeH","EfU"],
  "half past two": ["FuL","DeI","EfV"],
  "halfway": ["KAi"],
  "halicarnassus": ["HR4"],
  "hall": ["GdU","BYs","FG2","BY1","BYt","BYu"],
  "hallmark": ["IwC"],
  "halloween": ["GdT","BY0","FG1","BYx","BYv","BYw"],
  "halloween candy": ["FuM","BYz","BYy"],
  "hallway": ["GdV","BY4","FG3","BY3","BY2"],
  "halt": ["BY6","BY5"],
  "halve": ["KAj"],
  "ham": ["GdY","DEK","FG6","BY9","BY8","BZR","BY7"],
  "hamburger": ["GdW","BZF","FG4","BZC","BZA","D1M","BZD","BZB","BZE"],
  "hamburgers": ["FuN","BZG"],
  "hamlet": ["BZH"],
  "hammer": ["GdX","DEI","FG5","BZJ","BZI","BZM","BZK","D1N","DiG"],
  "hammer a nail": ["DiG"],
  "hammer away": ["IwD"],
  "hammer hammered": ["DiG"],
  "hammering": ["DiG"],
  "hammering a nail": ["DiG"],
  "hammock": ["FuO","BZQ","DEJ","BZP","BZN","BZO"],
  "hamper": ["IwE"],
  "hamster": ["GdZ","BZT","FG7","BZY","BZV","BZS","BZU"],
  "hamster cage": ["BZX"],
  "hand": ["Gdb","DEN","FG9","D1R","BZZ","BZl","BZa"],
  "hand down": ["IwG"],
  "hand drill": ["BZh"],
  "hand dryer": ["D1Q","DEM"],
  "hand in": ["FuQ","DiH","Ea0","EFA"],
  "hand in handed in": ["DiH"],
  "hand in homework": ["DiH","Ea0"],
  "hand luggage": ["HR5"],
  "hand off": ["IwJ"],
  "hand out": ["DiI","EcK"],
  "hand out fliers": ["EcK","DiI"],
  "hand out handed out": ["DiI"],
  "hand over": ["HR6"],
  "hand to": ["IwL"],
  "handbag": ["Gda","DEL","FG8","BZf","D1P","BZb","BZe","BZd","BZc"],
  "handball": ["FuP","BZg"],
  "handbook": ["IwF"],
  "handcuff": ["KAk"],
  "handful": ["IwH"],
  "handgun": ["KAl"],
  "handhold": ["KAm"],
  "handicap": ["IwI"],
  "handing in": ["Ea0","DiH"],
  "handing in homework": ["Ea0","DiH"],
  "handing out": ["EcK","DiI"],
  "handing out fliers": ["EcK","DiI"],
  "handkerchief": ["KAn"],
  "handle": ["E0Z"],
  "handlebar": ["E0Y"],
  "handlebars": ["FuR","BZk","BZj"],
  "handler": ["KAo"],
  "handout": ["KAp"],
  "handrail": ["FuS","DEO"],
  "hands": ["Gdd","DEP","BZu","BZo","BZm","BZn"],
  "hands on": ["IwK"],
  "hands up": ["FuU","BZv"],
  "handsaw": ["FuT","BZq"],
  "handshake": ["E0a"],
  "handsome": ["Gdc","BZs","FHA","BZt","BZr"],
  "handwrite": ["KAq"],
  "handy": ["IwM"],
  "handyman": ["EFD","DER"],
  "hang": ["Gdh","BZ2","BZw","BZx"],
  "hang around": ["IwN"],
  "hang on": ["G74"],
  "hang out": ["Gdf","DiK","DiJ","EX5","EFE"],
  "hang out hung out": ["DiJ","DiK"],
  "hang out with friends": ["Gdg","DiK","EX5","EFF"],
  "hang up": ["FuX","DiL","DiM","EcL","Ea1"],
  "hang up a coat": ["Ea1"],
  "hang up clothes": ["FuW","DiL","EcL"],
  "hang up hung up": ["DiL","DiM"],
  "hanger": ["Gde","BZ0","BZy"],
  "hangers": ["BZ1"],
  "Hanging Gardens of Babylon": ["HR7"],
  "hanging out": ["FuV","DiK","DiJ"],
  "hanging out with friends": ["DiK"],
  "hanging up": ["EcL","Ea1","DiM","DiL"],
  "hanging up clothes": ["EcL","DiL"],
  "hangover": ["KAr"],
  "haphazard": ["IwO"],
  "happen": ["IwP"],
  "happen to": ["IwQ"],
  "happier": ["FuY","DES"],
  "happily": ["ERW"],
  "happily ever after": ["G75"],
  "happiness": ["FuZ","DXQ","BZ3"],
  "happy": ["Gdi","Fua","DET","FHB","BZ6","Ehk","BZ5","DXR","EFH","BZ7","Ehj","BZ4"],
  "happy birthday": ["HR8"],
  "happy ending": ["HR9"],
  "happy face": ["HSA"],
  "happy new year": ["HSB"],
  "harass": ["IwR"],
  "harassment": ["KAs"],
  "harbor": ["Fub","BaA","BZ8","BZ9","BaC","BaB"],
  "harbour": ["Fuc","BZ8","BZ9","BaA","BaB","BaC"],
  "harbour master": ["HSC"],
  "Harbour of Rio de Janeiro": ["HSD"],
  "hard": ["Gdj","BaD","FHC","EFI","ERU"],
  "hard hat": ["HSE"],
  "hard luck": ["HSF"],
  "hard working": ["Gdk","DrA","FHD"],
  "harden": ["KAt"],
  "hardened criminal": ["IwS"],
  "hardly": ["IwT"],
  "hardship": ["KAu"],
  "hardware": ["HSG"],
  "hardwood": ["BaE"],
  "hardworking": ["Gdl","DXS","FHE","BaF"],
  "hardy": ["IwU"],
  "hare": ["Gdm","BaI","BaG","BaH"],
  "harm": ["IwY"],
  "harmful": ["KAv"],
  "harmful gas": ["DXT"],
  "harmless": ["Fud","DXU"],
  "harmonic": ["IwV"],
  "harmonica": ["Fue","DEU","BaL","D1T","BaJ"],
  "harmonious": ["IwW"],
  "harmonize": ["IwX"],
  "harmony": ["HSH"],
  "harness": ["Fuf","E0b"],
  "harp": ["Gdn","DEV","BaO","BaN","BaQ","D1U","BaR","BaP"],
  "harsh": ["IwZ"],
  "harshly": ["KAw"],
  "harvest": ["Gdo","BaT","BaS"],
  "harvest crops": ["HSI"],
  "hash out": ["Iwa"],
  "hashtag": ["G76"],
  "hassle": ["KAx"],
  "haste": ["Iwb"],
  "hasten": ["KAy"],
  "hastily": ["ERF"],
  "hasty": ["KAz"],
  "hat": ["Gdp","DEY","FHF","DEX","DEW","BaU","D1V","BaW","BaX","BaV"],
  "hatch": ["Iwc"],
  "hate": ["Fug","E0c"],
  "hatred": ["Iwd"],
  "haul": ["Iwe"],
  "haunt": ["Iwf"],
  "haunted house": ["Gdq","BaY","FHG","Bab","Baa","BaZ"],
  "havana": ["KA0"],
  "have": ["Gdz","Dif","Die","EYB","EX6","EX7","EYA"],
  "have a baby": ["Fuh","DiN"],
  "have a barbecue": ["Fui","DrB"],
  "have a bath": ["Fuj","E0d"],
  "have a bbq": ["DiO"],
  "have a birthday party": ["EFK"],
  "have a campfire": ["DiP"],
  "have a cat": ["Fuk","DiQ","EX6"],
  "have a chip on your shoulder": ["EFM","EFN","EFO"],
  "have a dog": ["DiR","EX7"],
  "have a fever": ["E0e"],
  "have a fin": ["EfC"],
  "have a go": ["HSN"],
  "have a good day": ["HSJ"],
  "have a good holiday": ["HSK"],
  "have a good time": ["Iwh"],
  "have a good trip": ["HSL"],
  "have a good weekend": ["HSM"],
  "have a great day": ["HSO"],
  "have a heart of gold": ["EFP","EFQ","EFR"],
  "have a look": ["HSP"],
  "have a meeting": ["Ful","DiS"],
  "have a music lesson": ["Gdr","DrC"],
  "have a nice day": ["HSQ"],
  "have a party": ["Fum","DiU"],
  "have a photo taken": ["EX9","DiV"],
  "have a picnic": ["Gds","DrD"],
  "have a point": ["Iwi"],
  "have a rest": ["HSR"],
  "have a safe trip": ["HSS"],
  "have a shell": ["EfD"],
  "have a shower": ["Gdt"],
  "have a snack": ["Fun","E0f"],
  "have a snowball fight": ["DiW"],
  "have a sore throat": ["E0g"],
  "have a sweet tooth": ["EFU","EFV","EFW"],
  "have a tail": ["EfE"],
  "have access to": ["Iwg"],
  "have an online meeting": ["DiT"],
  "have at": ["Iwj"],
  "have bad breath": ["DiX"],
  "have breakfast": ["Gdu","Fuo","DiZ","FHH","DiY","EYA","EFY","EFX"],
  "have class": ["Fup","Dia","EFZ"],
  "have coffee": ["Dib"],
  "have coffee with friends": ["EFa"],
  "have cooking class": ["Dic"],
  "have dinner": ["Gdv","Fuq","DrE","FHI"],
  "have diverse tastes": ["Iwk"],
  "have eight legs": ["EfF"],
  "have four legs": ["EfG"],
  "have fun": ["Gdw","DrF"],
  "have got": ["HST"],
  "have had": ["Gdx","DiQ","EVq","EWK","DiO","Die","ET3","DiP","EVr","EV4"],
  "have her photo taken": ["EFb"],
  "have his eyes checked": ["EFc"],
  "have lessons": ["Fus","E0h"],
  "have lessons at school": ["Fur"],
  "have long ears": ["EfH"],
  "have long hair": ["EfI"],
  "have lunch": ["Gdy","Did","FHJ"],
  "have money to burn": ["EFd","EFe","EFf"],
  "have no idea": ["Iwl"],
  "have nothing to do with": ["Iwm"],
  "have over": ["Iwo"],
  "have the time of your life": ["EFg","EFh","EFi"],
  "have time on your hands": ["Iwp"],
  "have to": ["HSU"],
  "have to do with": ["Iwq"],
  "have trouble": ["Iwr"],
  "have trouble with": ["Iws"],
  "have two arms": ["EfJ"],
  "have two ears": ["EfK"],
  "have two eyes": ["EfL"],
  "have two pens": ["Die"],
  "have two phones": ["EYB","Dif"],
  "have your ducks in a row": ["EFj","EFk","EFl"],
  "haven": ["Iwn"],
  "having": ["Dif","Die"],
  "having a baby": ["DiN"],
  "having a bbq": ["DiO"],
  "having a campfire": ["DiP"],
  "having a cat": ["DiQ"],
  "having a dog": ["DiR"],
  "having a meeting": ["DiS"],
  "having a party": ["DiU"],
  "having a photo taken": ["DiV"],
  "having a snowball fight": ["DiW"],
  "having an online meeting": ["DiT"],
  "having bad breath": ["DiX"],
  "having breakfast": ["DiZ","DiY"],
  "having class": ["Dia"],
  "having coffee": ["Dib"],
  "having cooking class": ["Dic"],
  "having lunch": ["Did"],
  "having two pens": ["Die"],
  "having two phones": ["Dif"],
  "havoc": ["Iwt"],
  "Hawaii": ["KA1","HC6"],
  "hawk": ["Fut","Bag","Bae","Baf","Bad"],
  "hay": ["Gd0","Bal","FHK","Bak","Bai","Bah","Baj"],
  "hay fever": ["Fuu","DXV"],
  "haystack": ["E0i"],
  "hazard": ["HSV"],
  "hazardous": ["KA2"],
  "haze": ["HSW"],
  "hazel": ["Bao"],
  "hazelnuts": ["Ban","Bam"],
  "he": ["GeJ","FvB","E0o"],
  "he adds sugar to his coffee": ["Eaa"],
  "he bowls": ["Eab"],
  "he brushes his teeth": ["Eac"],
  "he builds a wall": ["Ead"],
  "he buys a coffee": ["Eae"],
  "he buys groceries": ["Eaf"],
  "he carries a bag": ["Eag"],
  "he catches a ball": ["Eah"],
  "he chops an onion": ["Eai"],
  "he climbs": ["Eaj"],
  "he closes the window": ["Eak"],
  "he controls a drone": ["Eal"],
  "he crosses the road": ["Eam"],
  "he delivers a package": ["Ean"],
  "he deposits money at a bank": ["Eao"],
  "he digs": ["Eap"],
  "he dreams": ["Eaq"],
  "he empties the bin": ["Ear"],
  "he encourages his friend": ["Eas"],
  "he falls over": ["Eat"],
  "he fishes": ["Eau"],
  "he fixes a car": ["Eav"],
  "he flies a kite": ["Eaw"],
  "he gets on a bus": ["Eax"],
  "he gets up": ["Eay"],
  "he gives her a gift": ["Eaz"],
  "he hands in his homework": ["Ea0"],
  "he hangs up his coat": ["Ea1"],
  "he has already caught a fish": ["EFs"],
  "he has already eaten an apple": ["EFt"],
  "he has already washed his car": ["EFu"],
  "he has already washed the dishes": ["EFv"],
  "he has been a policeman since he was ": ["EFw"],
  "he has been sick since yesterday": ["EFx"],
  "he has been to America": ["EFy"],
  "he has driven his car since o'clock": ["EFz"],
  "he has failed the test times": ["EF0"],
  "he has forgotten his keys times": ["EF1"],
  "he has just broken the window": ["EF2"],
  "he has just crashed his car": ["EF3"],
  "he has just lost the game": ["EF4"],
  "he has just scored a goal": ["EF5"],
  "he has made a sandwich": ["EF6"],
  "he has made a speech times": ["EF7"],
  "he has never planted a tree": ["EF8"],
  "he has never shaved his head": ["EF9"],
  "he has read the book": ["EGF"],
  "he has seen an elephant": ["EGG"],
  "he has supported liverpool since ": ["EGH"],
  "he hasn't broken his arm": ["EGA"],
  "he hasn't done laundry for weeks": ["EGB"],
  "he hasn't ordered a pizza": ["EGC"],
  "he hasn't slept for days": ["EGD"],
  "he hasn't watched TV for one year": ["EGE"],
  "he hides behind the tree": ["Ea2"],
  "he holds up a sign": ["Ea3"],
  "he is a boy": ["HSj"],
  "he is adding sugar to his coffee": ["Eaa"],
  "he is bowling": ["Eab"],
  "he is brushing his teeth": ["Eac"],
  "he is building a wall": ["Ead"],
  "he is buying a coffee": ["Eae"],
  "he is buying groceries": ["Eaf"],
  "he is carrying a bag": ["Eag"],
  "he is catching a ball": ["Eah"],
  "he is chicken": ["EGI","EGJ","EGK"],
  "he is chopping an onion": ["Eai"],
  "he is climbing": ["Eaj"],
  "he is closing the window": ["Eak"],
  "he is cold": ["EhQ"],
  "he is controlling a drone": ["Eal"],
  "he is crossing the road": ["Eam"],
  "he is delivering a package": ["Ean"],
  "he is depositing money at a bank": ["Eao"],
  "he is digging": ["Eap"],
  "he is dreaming": ["Eaq"],
  "he is eating": ["HSk"],
  "he is emptying the bin": ["Ear"],
  "he is encouraging his friend": ["Eas"],
  "he is falling over": ["Eat"],
  "he is fat": ["Ehe"],
  "he is fishing": ["Eau"],
  "he is fixing a car": ["Eav"],
  "he is flying a kite": ["Eaw"],
  "he is getting on a bus": ["Eax"],
  "he is getting up": ["Eay"],
  "he is giving her a gift": ["Eaz"],
  "he is handing in his homework": ["Ea0"],
  "he is hanging up his coat": ["Ea1"],
  "he is happy": ["Ehk"],
  "he is hiding behind the tree": ["Ea2"],
  "he is holding up a sign": ["Ea3"],
  "he is jumping over a puddle": ["Ea4"],
  "he is kicking a ball": ["Ea5"],
  "he is kneeling down": ["Ea6"],
  "he is laying out the table": ["Ea7"],
  "he is leaving": ["Ea8"],
  "he is lifting weights": ["Ea9"],
  "he is locking the door": ["EbA"],
  "he is looking at the clock": ["EbB"],
  "he is lying down": ["EbC"],
  "he is making a sandwich": ["EbD"],
  "he is making coffee": ["EbE"],
  "he is my friend": ["HSl"],
  "he is old": ["Eht"],
  "he is ordering food": ["EbF"],
  "he is painting a picture": ["EbG"],
  "he is picking apples": ["EbH"],
  "he is picking up litter": ["EbI"],
  "he is playing chess": ["EbJ"],
  "he is playing pool": ["EbK"],
  "he is playing the guitar": ["EbL"],
  "he is pointing at the clock": ["EbM"],
  "he is pulling a rope": ["EbN"],
  "he is pushing a car": ["EbO"],
  "he is putting his books in his bag": ["EbP"],
  "he is putting on a coat": ["EbQ"],
  "he is putting on shoes": ["EbR"],
  "he is putting out a fire": ["EbS"],
  "he is reading a newspaper": ["EbU"],
  "he is reading aloud": ["EbT"],
  "he is refusing money": ["EbV"],
  "he is relaxing": ["EbW"],
  "he is repairing a phone": ["EbX"],
  "he is rescuing someone": ["EbY"],
  "he is riding a bike": ["EbZ"],
  "he is riding a motorbike": ["Eba"],
  "he is running": ["HSm"],
  "he is sad": ["Eh1"],
  "he is shaving": ["Ebb"],
  "he is shutting the door": ["Ebc"],
  "he is signing his name": ["Ebd"],
  "he is squeezing an orange": ["Ebe"],
  "he is stealing a wallet": ["Ebf"],
  "he is strong": ["EiA"],
  "he is sweeping the floor": ["Ebg"],
  "he is swimming": ["Ebh"],
  "he is taking off his coat": ["Ebi"],
  "he is taking out the trash": ["Ebj"],
  "he is tall": ["HSn"],
  "he is telling her a secret": ["Ebk"],
  "he is throwing a ball": ["Ebl"],
  "he is throwing away a bottle": ["Ebm"],
  "he is turning on the TV": ["Ebn"],
  "he is typing": ["Ebo"],
  "he is unhappy": ["Eh1"],
  "he is using a tablet": ["Ebp"],
  "he is using his phone": ["Ebq"],
  "he is washing his face": ["Ebr"],
  "he is washing his hands": ["Ebs"],
  "he is washing the dishes": ["Ebt"],
  "he is writing": ["Ebu"],
  "he is yawning": ["Ebv"],
  "he jumps over a puddle": ["Ea4"],
  "he kicks a ball": ["Ea5"],
  "he kneels down": ["Ea6"],
  "he lays out the table": ["Ea7"],
  "he leaves": ["Ea8"],
  "he lies down": ["EbC"],
  "he lifts weights": ["Ea9"],
  "he locks the door": ["EbA"],
  "he looks at the clock": ["EbB"],
  "he makes a sandwich": ["EbD"],
  "he makes coffee": ["EbE"],
  "he orders food": ["EbF"],
  "he paints a picture": ["EbG"],
  "he picks apples": ["EbH"],
  "he picks up litter": ["EbI"],
  "he plays chess": ["EbJ"],
  "he plays pool": ["EbK"],
  "he plays the guitar": ["EbL"],
  "he points at the clock": ["EbM"],
  "he pulls a rope": ["EbN"],
  "he pushes a car": ["EbO"],
  "he puts his books in his bag": ["EbP"],
  "he puts on a coat": ["EbQ"],
  "he puts on shoes": ["EbR"],
  "he puts out a fire": ["EbS"],
  "he reads a newspaper": ["EbU"],
  "he reads aloud": ["EbT"],
  "he refuses money": ["EbV"],
  "he relaxes": ["EbW"],
  "he repairs a phone": ["EbX"],
  "he rescues someone": ["EbY"],
  "he rides a bike": ["EbZ"],
  "he rides a motorbike": ["Eba"],
  "he shaves": ["Ebb"],
  "he shuts the door": ["Ebc"],
  "he signs his name": ["Ebd"],
  "he squeezes an orange": ["Ebe"],
  "he steals a wallet": ["Ebf"],
  "he sweeps the floor": ["Ebg"],
  "he swims": ["Ebh"],
  "he takes off his coat": ["Ebi"],
  "he takes out the trash": ["Ebj"],
  "he tells her a secret": ["Ebk"],
  "he throws a ball": ["Ebl"],
  "he throws away a bottle": ["Ebm"],
  "he turns on the TV": ["Ebn"],
  "he types": ["Ebo"],
  "he uses a tablet": ["Ebp"],
  "he uses his phone": ["Ebq"],
  "he washes his face": ["Ebr"],
  "he washes his hands": ["Ebs"],
  "he washes the dishes": ["Ebt"],
  "he writes": ["Ebu"],
  "he yawns": ["Ebv"],
  "head": ["Gd3","DEd","FHN","DEZ","D1Z","Ba0","Bap"],
  "head back": ["Iwu"],
  "head down": ["Iwv"],
  "head for": ["Iww"],
  "head of lettuce": ["Bat"],
  "head off": ["Iwz"],
  "head out": ["Iw0"],
  "head over heels in love": ["EFm","EFn","EFo"],
  "headache": ["Gd1","DEa","FHL","D1W","Bar","DXW","Baq"],
  "headband": ["Fuv","Bas"],
  "header": ["KA3"],
  "heading": ["Iwx"],
  "headlight": ["KA4"],
  "headline": ["Iwy"],
  "headmaster": ["KA5"],
  "headphone": ["E0j"],
  "headphones": ["Gd2","DEc","FHM","Bav","DEb","D1X","Bax","D1Y","Baz","Baw"],
  "headquarter": ["KA6"],
  "headquarters": ["Iw1"],
  "headscarf": ["E0k"],
  "headset": ["Fuw","Ba1","DEe","Ba4","Ba3"],
  "headteacher": ["G77"],
  "heady": ["KA7"],
  "heal": ["Iw3"],
  "healing": ["Iw2"],
  "health": ["Gd4","Ba5"],
  "health certificate": ["HSY"],
  "healthcare": ["HSX"],
  "healthful": ["Iw4"],
  "healthier": ["Fux","DEf"],
  "healthy": ["Gd5","Ba6","FHO","EFp"],
  "heap": ["Iw5"],
  "hear": ["Gd6","Dig","FHP","Ba8"],
  "hear a noise": ["Fuy","Dig"],
  "hear a story": ["HSZ"],
  "hear about": ["Iw6"],
  "hear from": ["Iw7"],
  "hear heard": ["Fu0","Dig","ESy"],
  "hear me": ["HSa"],
  "hear music": ["HSb"],
  "hear of": ["Iw8"],
  "hear out": ["Iw9"],
  "hear the bell": ["HSc"],
  "heard": ["Fuz","ESy"],
  "heard a noise": ["ESy"],
  "hearing": ["Fu1","Ba7","Dig"],
  "hearing a noise": ["Dig"],
  "hearsay": ["IxA"],
  "heart": ["Gd7","BbI","FHQ","BbC","BbB","Ba9","BbD","BbA"],
  "heart attack": ["Fu2","BbF","BbE","BbH","BbG"],
  "heartbeat": ["KA8"],
  "heartbroken": ["Fu3","EFq"],
  "heartburn": ["KA9"],
  "hearth": ["KBA"],
  "hearty": ["IxB"],
  "heat": ["Gd9","BbN","FHR","BbK","BbJ"],
  "heat index": ["HSd"],
  "heat wave": ["HSf","G78"],
  "heater": ["Gd8","DEg","D1b"],
  "heather": ["KBB"],
  "heating": ["Fu4","BbL","BbM"],
  "heatstroke": ["HSe"],
  "heatwave": ["HSg","G79"],
  "heave": ["KBD"],
  "heaven": ["HSh"],
  "heavenly": ["KBC"],
  "heavier": ["Fu5","DEh","DEi"],
  "heavily": ["KBE"],
  "heavy": ["GeA","DEk","FHS","DEj","BbP","EFr","BbS","Ehl","BbR","BbQ","BbO"],
  "heavy rain": ["HSi"],
  "heavyweight": ["KBF"],
  "heck": ["KBG"],
  "hectare": ["IxC"],
  "hectic": ["KBH"],
  "hedge": ["Fu6","Bbb","BbU"],
  "hedgehog": ["GeB","Bba","FHT","BbZ","BbY","BbW","BbX"],
  "heed": ["IxD"],
  "heel": ["GeC","DEl","FHU","D1c"],
  "hefty": ["KBI"],
  "height": ["GeD","Bbc","DXX","Bbd"],
  "heighten": ["IxE"],
  "heir": ["IxF"],
  "held": ["ET4"],
  "held a baby": ["ET4"],
  "helicopter": ["GeE","DEm","FHV","Bbj","D1d","Bbf","Bbh","Bbe","Bbg","Bbi"],
  "heliosphere": ["HSo"],
  "helium": ["HSp"],
  "hell": ["Fu9","Bbl","Bbk"],
  "hello": ["Fu7","Fu8","E0m","E0l"],
  "hello everyone": ["HSq"],
  "hello friend": ["HSr"],
  "hello mum": ["HSs"],
  "hello there": ["HSt"],
  "hello world": ["HSu"],
  "helm": ["KBJ"],
  "helmet": ["GeF","DEn","FHW","Bbp","Bbo","Bbn","D1e","Bbm"],
  "help": ["GeH","Bbr","Bbq"],
  "help a friend": ["HSv"],
  "help at home": ["HSw"],
  "help me": ["HSx"],
  "help my mum": ["FvA","E0n"],
  "help oneself to": ["IxG"],
  "help out": ["IxH"],
  "help sick people": ["EGL"],
  "help the teacher": ["HSy"],
  "help your mother": ["HSz"],
  "helper": ["KBK"],
  "helpful": ["GeG","DXY","FHX"],
  "helpless": ["KBM"],
  "helplessly": ["KBL"],
  "hem": ["KBO"],
  "hem in": ["IxI"],
  "hemisphere": ["HS0"],
  "hemorrhage": ["KBN"],
  "hemp": ["IxJ"],
  "hen": ["GeI","Bbt","FHY","Bbs"],
  "hence": ["IxL"],
  "henceforth": ["IxK"],
  "heparin": ["KBP"],
  "hepatitis": ["KBQ"],
  "Hephaestus": ["HS1"],
  "her bag is heavy": ["Ehl"],
  "her hair is long": ["Ehn"],
  "her shirt is dirty": ["EhY"],
  "her sweater is big": ["EhE"],
  "Hera": ["HS2"],
  "herald": ["IxM"],
  "herb": ["IxN"],
  "herbal": ["FvC","Bbx","Bbw","Bbu"],
  "herbivore": ["FvD","DXZ"],
  "herbs": ["FvE"],
  "Hercules": ["HS3"],
  "herd": ["IxO"],
  "here": ["FvF","E0p"],
  "here you are": ["IxQ"],
  "hereafter": ["KBR"],
  "hereby": ["KBS"],
  "hereditary": ["IxP"],
  "heredity": ["HS4"],
  "herein": ["KBT"],
  "heritage": ["IxR"],
  "Hermes": ["HS5"],
  "hermit": ["IxS"],
  "hero": ["GeK","DrG"],
  "heroics": ["KBU"],
  "heroin": ["KBW"],
  "heroine": ["KBV"],
  "heron": ["FvG","Bbz","Bby"],
  "herring": ["KBX"],
  "hers": ["G8A"],
  "herself": ["KBY"],
  "hesitant": ["IxT"],
  "hesitate": ["FvH","DXa"],
  "hesitation": ["KBZ"],
  "Hestia": ["HS6"],
  "heterogeneity": ["KBa"],
  "heterogeneous": ["KBb"],
  "heterosexual": ["KBc"],
  "hexagon": ["GeL","Bb1","FHZ","Bb2"],
  "hey": ["KBd"],
  "heyday": ["IxU"],
  "hi": ["FvY"],
  "hibernate": ["FvJ","DXb","Bb3","Bb4"],
  "hibernation": ["FvK","DXc"],
  "hiccup": ["FvL","Bb5"],
  "hid": ["FvQ","ESz"],
  "hidden": ["FvM","BcA","Bb9"],
  "hide": ["GeN","Ea2","FHb","Dih","BcB","BcD","BcC"],
  "hide a toy": ["HS7"],
  "hide and seek": ["GeM","DrH","FHa"],
  "hide away": ["IxV"],
  "hide behind the tree": ["Dih"],
  "hide hid": ["FvN","Dih","ESz"],
  "hide under": ["HS8"],
  "hideing": ["Dih"],
  "hideous": ["KBe"],
  "hiding": ["FvP","Ea2"],
  "hiding behind the tree": ["FvO","Dih"],
  "hierarchical": ["KBf"],
  "hierarchy": ["IxW"],
  "hieratic": ["IxX"],
  "hieroglyph": ["IxY"],
  "hieroglyphics": ["FvR","BcH","BcF"],
  "high": ["GeQ","DEr","BcJ","BcT","EiC","BcI"],
  "high heels": ["GeO","DEp","D1f"],
  "high jump": ["FvT","DEq","D1g"],
  "high pressure": ["HS9"],
  "high profile": ["IxZ"],
  "high rise": ["Ixb"],
  "high rise building": ["Ixa"],
  "high time": ["Ixc"],
  "higher": ["FvS","DEo"],
  "highland": ["KBg"],
  "highlands": ["FvU","BcO","BcP","BcM"],
  "highlight": ["FvV","Dii","EcM"],
  "highlight highlighted": ["ET5","Dii"],
  "highlight lines": ["EcM","Dii"],
  "highlighted": ["ET5"],
  "highlighted some lines": ["ET5"],
  "highlighter": ["GeP","BcS","FHc","BcQ","BcR"],
  "highlighting": ["EcM","Dii"],
  "highlighting lines": ["EcM","Dii"],
  "highly": ["KBh"],
  "highway": ["G8B"],
  "hijack": ["KBj"],
  "hijacker": ["KBi"],
  "hike": ["GeR","BcW","FHd","BcV","BcU"],
  "hike hiked": ["EWN"],
  "hiked": ["EWN"],
  "hiked in the mountains": ["EWN"],
  "hiking": ["GeS","Bcd","FHe","BcX"],
  "hiking boots": ["FvW","Bca","BcZ","Bcb"],
  "hiking trail": ["Bcf"],
  "hilarious": ["FvX","DXd"],
  "hill": ["GeT","Bck","FHf","Bcl","Bcj","Bci"],
  "hills": ["GeU","Bco","Bcm","Bcn"],
  "hillside": ["KBk"],
  "himalaya": ["Bcq","Bcp"],
  "Himalayan": ["KBl"],
  "Himalayas": ["KBm"],
  "himself": ["KBn"],
  "hind": ["Ixe"],
  "hinder": ["Ixd"],
  "hindsight": ["KBo"],
  "hinge": ["KBp"],
  "hinge on": ["Ixf"],
  "hint": ["Ixh"],
  "hinterland": ["Ixg"],
  "hip": ["FvZ","E0s","E0q"],
  "hip hop": ["E0r"],
  "hippie": ["KBq"],
  "hippo": ["GeV","DEs","FHg","Bcr","D1h","Bcu","Bct","Bcs"],
  "hippopotamus": ["GeW","DrI"],
  "hippos": ["Fva","Bcw","Bcv"],
  "hips": ["GeX","DXe"],
  "hire": ["Ixi"],
  "hired": ["Fvb","Bcx"],
  "his": ["G8C","E0t"],
  "his arm is broken": ["EhK"],
  "his hair is blue": ["EhH"],
  "his name is": ["Fvc"],
  "his shirt is colorful": ["EhR"],
  "his sweater is small": ["Eh6"],
  "Hispanic": ["Koa"],
  "hiss": ["KBr"],
  "histone": ["KBs"],
  "historian": ["KBt"],
  "historic": ["Fve","Bc1","Bc0","Bcz","Bcy"],
  "historical": ["Fvd"],
  "historically": ["KBu"],
  "history": ["GeY","Fvf","DEt","Bc4","Bc2","D1i"],
  "history book": ["Bc3"],
  "hit": ["GeZ","Dij","FHh","Dik","Bc6","Bc5","ES0","EYC"],
  "hit a ball": ["Fvg","Dij","ES0"],
  "hit a nail": ["Dik","EYC"],
  "hit hit": ["Dij","ES0","Dik"],
  "hit on": ["Ixm"],
  "hit out": ["Ixn"],
  "hit the ball": ["Fvh"],
  "hit the sack": ["EGM","EGN","EGO"],
  "hit up": ["Ixp"],
  "hit upon": ["Ixo"],
  "hitch": ["Ixk"],
  "hitchhike": ["Ixj"],
  "hitherto": ["Ixl"],
  "hitter": ["KBv"],
  "hitting": ["Fvj","Dij","Dik"],
  "hitting a ball": ["Fvi","Dij"],
  "hitting a nail": ["Dik"],
  "hive": ["Gea","Bc7","BdA","Bc8"],
  "hoard": ["Ixq"],
  "hobbies": ["Fvk"],
  "hobby": ["Geb","DXf","BdB"],
  "hockey": ["Gec","DEu","FHi","BdC","BdG","D1j","BdF","BdE","BdD"],
  "hoe": ["Fvl","BdI","BdH"],
  "hog": ["KBw"],
  "hoist": ["KBx"],
  "hold": ["Ged","Dim","FHj","Din","Dil","BdL","EYD","EcN"],
  "hold a baby": ["Fvm","EcN","Dil"],
  "hold a bag": ["HTA"],
  "hold a ball": ["Fvn","Dim","EYD"],
  "hold against": ["Ixr"],
  "hold back": ["Ixs"],
  "hold down": ["Ixt"],
  "hold hands": ["Fvo","BdK","Din","EdV"],
  "hold held": ["Fvp","Din","ET4","Dil","Dim"],
  "hold in": ["Ixu"],
  "hold off": ["Ixv"],
  "hold on": ["Fvr","Dio","EGP"],
  "hold on held on": ["Dio"],
  "hold out": ["Dip"],
  "hold out held out": ["Dip"],
  "hold over": ["Ixw"],
  "hold still": ["HTB"],
  "hold the baby": ["HTC"],
  "hold the rope": ["HTD"],
  "hold tight": ["HTE"],
  "hold to": ["Ixx"],
  "hold up": ["Ea3","Diq"],
  "hold up a sign": ["Ea3","Diq"],
  "hold up held up": ["Diq"],
  "holder": ["KBy"],
  "holding": ["Fvq","Dim","Dil","EcN","Din"],
  "holding a baby": ["EcN","Dil"],
  "holding a ball": ["Dim"],
  "holding hands": ["EdV","Din"],
  "holding on": ["Dio"],
  "holding out": ["Dip"],
  "holding up": ["Ea3","Diq"],
  "holding up a sign": ["Ea3","Diq"],
  "hole": ["Gee","BdO","FHk","BdP","BdQ","BdN","BdM"],
  "hole punch": ["Fvs","BdS","BdR"],
  "hole up": ["Ixy"],
  "holiday": ["Gef","BdV","FHl","BdU"],
  "holistic": ["Ixz"],
  "Holland": ["HC7"],
  "Hollander": ["Kob"],
  "hollow": ["Fvt","BdW"],
  "holly": ["Geg","BdX","FHm"],
  "holy": ["KBz"],
  "homage": ["Ix0"],
  "home": ["Gei","Bda","FHn","Bdf","BdZ","BdY"],
  "home in on": ["Ix1"],
  "homeland": ["Bdb"],
  "homeless": ["Geh","Bdd","Bde","Bdc"],
  "homelessness": ["KB0"],
  "homemade": ["KB1"],
  "homeowner": ["KB2"],
  "Homer": ["KB3"],
  "homestay": ["HTF"],
  "homestead": ["Ix2"],
  "hometown": ["Fvu","DXg"],
  "homework": ["Gej","Bdi","FHo","Bdg","Bdh"],
  "homicide": ["KB4"],
  "homing": ["Ix3"],
  "hominid": ["Ix4"],
  "homogeneous": ["Ix5"],
  "homosexual": ["KB5"],
  "homosexuality": ["Ix6"],
  "Honduran": ["HC8","Koc"],
  "Honduras": ["HC9","EGR"],
  "hone": ["Ix7"],
  "honest": ["E0u"],
  "honestly": ["KB6"],
  "honesty": ["Ix8"],
  "honey": ["Gek","DEv","FHp","Bdj","Bdm","Bdl"],
  "honeybee": ["Fvv","E0v"],
  "honeymoon": ["KB7"],
  "Hong Kong": ["G8D"],
  "Hong Kong flag": ["DEw"],
  "Hong Konger": ["Kod"],
  "Hongkonger": ["Koe"],
  "honor": ["Ix9"],
  "honorable": ["KB8"],
  "honorary": ["KB9"],
  "hood": ["Fvw"],
  "hoodie": ["Gel","DEx","FHq","D1k","Bdp","Bdr","Bdn","Bds"],
  "hoof": ["IyA"],
  "hook": ["Gem","Bdt","Bdv","Bdu"],
  "hook up": ["IyB"],
  "hoop": ["IyC"],
  "hooves": ["Fvx","Bdx"],
  "hop": ["Geo","DXj","FHs"],
  "hop in": ["IyD"],
  "hop on off": ["IyE"],
  "hop out": ["IyF"],
  "hope": ["Gen","Bdz","FHr","DXi"],
  "hopeful": ["Bdy"],
  "hopefully": ["KCA"],
  "hopeless": ["KCC"],
  "hopelessly": ["KCB"],
  "hopscotch": ["Fvy","E0w"],
  "horde": ["IyG"],
  "horizon": ["Fvz","DXk","Bd1"],
  "horizontal": ["IyH"],
  "hormone": ["DXl"],
  "horn": ["IyI"],
  "Horn of Africa": ["KCD"],
  "horns": ["Gep","Bd3","FHt","Bd4","Bd2"],
  "horoscope": ["HTG"],
  "horrendous": ["KCE"],
  "horrible": ["Fv0"],
  "horribly": ["KCF"],
  "horrific": ["KCG"],
  "horrified": ["IyJ"],
  "horrify": ["KCH"],
  "horrifying": ["IyK"],
  "horror": ["Geq","Bd5","FHu"],
  "horse": ["Ger","Fv1","DEy","FHv","Bd7","D1l","Bd9","Bd6","Bd8"],
  "horse racing": ["Fv2","BeC","BeA","BeB"],
  "horse riding": ["Ges","DEz","FHw","BeE","D1m","BeD","BeF"],
  "horseback": ["KCI"],
  "horseback riding": ["HTH"],
  "horses": ["Get","BeI","BeJ","BeG","BeH"],
  "hose": ["Geu","BeK","FHx","BeN","BeM"],
  "hospice": ["KCJ"],
  "hospitable": ["IyL"],
  "hospital": ["Gev","DE0","FHy","D1n","BeR","BeP","BeO","BeQ"],
  "hospitality": ["IyM"],
  "hospitalize": ["KCK"],
  "host": ["IyN"],
  "host family": ["HTI"],
  "hostage": ["KCL"],
  "hostel": ["Fv3","BeS","DXm"],
  "hostess": ["KCM"],
  "hostile": ["DXn"],
  "hostility": ["KCN"],
  "hot": ["Ge0","DE7","FH3","DE1","EGU","Ehm","DE2","Bep","BeT"],
  "hot air balloon": ["Gew","BeV","FHz","BeU","BeW"],
  "hot and spicy": ["BeX"],
  "hot chocolate": ["Gex","DE3","FH0","Beb","D1o","Bec","Bed","Bea"],
  "hot cross buns": ["Fv4","Bee","Beg"],
  "hot dog": ["Gey","Bej","FH1","Beh","DE4","Bei","Bek","D1p","Bel"],
  "hot dogs": ["Fv5","Bem"],
  "hot food": ["HTJ"],
  "hot soup": ["Beq","Ber"],
  "hot water": ["HTK"],
  "hot weather": ["HTL"],
  "hotel": ["Gez","Beo","FH2","Ben"],
  "hotel manager": ["Fv6","DE6","EGT"],
  "hotel receptionist": ["Fv7"],
  "hotter": ["Fv8","DE8"],
  "hou yi": ["HTM"],
  "hound": ["Bet"],
  "hounds": ["Bey","Bew","Bex"],
  "hour": ["Fv9","DrJ"],
  "hourly": ["KCO"],
  "house": ["Ge2","DE9","FH4","Be5","D1q","Be1","Bez","Be0","Be2"],
  "house husband": ["E0x"],
  "household": ["IyP"],
  "household chores": ["Ge1","DXo"],
  "household name": ["IyO"],
  "housekeeper": ["FwA","Be3","Be4"],
  "housekeeping": ["IyQ"],
  "housewife": ["Ge3","Be8","FH5","Be6","Be9","Be7"],
  "housework": ["FwB","E0y"],
  "housing estate": ["IyR"],
  "hover": ["IyS"],
  "how": ["Ge5","Ddk"],
  "how are you": ["Ge4","FwC","DrK"],
  "how are you doing": ["HTN"],
  "how come": ["IyT"],
  "how do you do": ["HTO"],
  "how do you go to school": ["FwD","Ddk"],
  "how do you spell your name": ["EGW"],
  "how expensive is the book": ["EGX"],
  "how far": ["FwE","Ddl"],
  "how far is London": ["Ddl"],
  "how fast": ["HTP"],
  "how heavy": ["Ddm"],
  "how heavy are you": ["Ddm"],
  "how heavy is he": ["EGZ"],
  "how long": ["HTQ"],
  "how lovely": ["HTR"],
  "how many": ["HTS"],
  "how many apples do you want": ["EGa"],
  "how much": ["FwG","Ddn"],
  "how much is the book": ["FwF","Ddn"],
  "how much is the skateboard": ["EGb"],
  "how nice": ["HTT"],
  "how often": ["HTU"],
  "how old": ["FwJ","Ddo"],
  "how old are you": ["FwI","FwH","Ddo"],
  "how old is he": ["EGd"],
  "how soon": ["HTX"],
  "how soon is now": ["HTW"],
  "how tall": ["Ddp"],
  "how tall are you": ["FwK","Ddp"],
  "how's it going": ["HTV"],
  "how's the weather": ["HTY"],
  "however": ["E0z"],
  "howl": ["IyU"],
  "hub": ["KCP"],
  "Hubble Space Telescope": ["HTZ"],
  "Hubble Telescope": ["HTa"],
  "huddle": ["BfB","BfA"],
  "Hudson Bay": ["KCQ"],
  "hue": ["IyV"],
  "hug": ["Ge8","Dis","FH7","Dir","BfC","EdW","BfF","EYE","BfD"],
  "hug a friend": ["EYE"],
  "hug hugged": ["Dir","EU2","Dis"],
  "hug someone": ["Dis"],
  "huge": ["Ge7","EGe"],
  "hugely": ["KCR"],
  "hugged": ["EU2"],
  "hugging": ["FwM","EdW","Dis","Dir"],
  "hugging someone": ["Dis"],
  "hula hoop": ["FwN","E00"],
  "hulk": ["FwO","DXp"],
  "hull": ["HTb"],
  "hum": ["E02"],
  "human": ["FwP","E01"],
  "humane": ["IyW"],
  "humanitarian": ["IyX"],
  "humanities": ["IyY"],
  "humanity": ["IyZ"],
  "humble": ["KCS","Iya"],
  "humid": ["Ge9","DrL"],
  "humidity": ["HTc"],
  "humiliate": ["Iyb"],
  "humility": ["KCT"],
  "hummingbird": ["GfA","BfG","BfI","BfH"],
  "humor": ["KCU"],
  "humorous": ["Iyc"],
  "hump": ["GfB","BfJ"],
  "hunch": ["KCV"],
  "hundred": ["GfC","DrM"],
  "hundredth": ["HA4"],
  "hung up": ["ET6"],
  "hung up clothes": ["ET6"],
  "Hungarian": ["HDB","Kof"],
  "Hungary": ["HDC","EGf"],
  "hunger": ["Iyd"],
  "hungry": ["GfD","BfK","FH8","EGg"],
  "hungry child": ["HTd"],
  "hungry for lunch": ["HTe"],
  "hunker down": ["Iye"],
  "hunt": ["GfE","BfQ","FH9","BfL"],
  "hunt down": ["Iyf"],
  "hunter": ["FwQ","BfM","BfP","BfN"],
  "hunting": ["HTf"],
  "hurdle": ["Iyg"],
  "hurdles": ["HTg"],
  "hurl": ["Iyh"],
  "hurricane": ["GfF","BfR","FIA","BfT","DFB","BfS","DFA"],
  "hurriedly": ["KCW"],
  "hurry": ["FwR","E03"],
  "hurry home": ["HTh"],
  "hurry up": ["HTi"],
  "hurt": ["GfG","DFC","FIB","EGh","BfU"],
  "husband": ["GfH","BfY","FIC","DZY","BfX","BfV","BfW","EGi"],
  "husbandry": ["Iyi"],
  "hush": ["KCX"],
  "hush up": ["Iyj"],
  "husk": ["Iyk"],
  "hustle": ["Iyl"],
  "hut": ["GfI","Bfc","FID","Bfb","Bfd","BfZ","Bfa"],
  "hyacinth": ["Bff","Bfe"],
  "hybrid": ["Iym"],
  "hybridization": ["KCY"],
  "hydraulic": ["Iyn"],
  "hydrochloric acid": ["HTj"],
  "hydrogen": ["HTl"],
  "hydrogen peroxide": ["HTk"],
  "hydrothermal": ["Iyo"],
  "hyena": ["GfJ","Bfg","Bfi","Bfj"],
  "hygiene": ["Iyp"],
  "hygienic": ["Iyq"],
  "hymn": ["Iyr"],
  "hype": ["KCZ"],
  "hypertension": ["KCa"],
  "hypertext": ["Iys"],
  "hypocrisy": ["KCb"],
  "hypocritical": ["Iyt"],
  "hypothesis": ["Iyu"],
  "hypothesize": ["Iyv"],
  "hypothetical": ["Iyw"],
  "hysteria": ["KCc"],
  "hysterical": ["KCd"],
  "I": ["Gfy","FxW","DZ1","HDJ"],
  "i": ["DZ2","HDD"],
  "I agree": ["HTm"],
  "I am a student": ["HTn"],
  "I am happy": ["FwS","DrN"],
  "I am hungry": ["HTo"],
  "I am sad": ["HTp"],
  "I am six": ["HTq"],
  "I am sorry": ["HTr","G8E"],
  "I am tired": ["HTs"],
  "I brush my teeth": ["FwT"],
  "I can run": ["FwU"],
  "I disagree": ["HTw"],
  "I don't know": ["HTx"],
  "I don't think so": ["HTy"],
  "I don't understand": ["HTz"],
  "I go to school": ["Fwj"],
  "I hope not": ["HT2"],
  "I hope so": ["HT3"],
  "I like": ["HT4"],
  "I mean": ["G8F"],
  "I play soccer": ["FxV"],
  "I see": ["HUl"],
  "I take a shower": ["Fxg"],
  "I think so": ["HUm"],
  "I understand": ["HU2"],
  "I want a ball": ["Fxk"],
  "I watch TV": ["Fxl"],
  "I will try": ["HU3"],
  "I'm afraid not": ["HT5"],
  "I'm afraid so": ["HT6"],
  "i'm happy": ["Fwm"],
  "I'm not sure": ["HUB"],
  "I'm sorry": ["HUD","G8G"],
  "Iberia": ["KCf"],
  "Iberian": ["KCe"],
  "ibiza": ["KCg"],
  "ice": ["GfN","DFG","FIG","BgL","D1s","Bfk","Bfm","Bfl"],
  "ice age": ["Bfo"],
  "ice coffee": ["FwW","DFD","Egl"],
  "ice cream": ["GfK","DFE","FIE","Bfq","Bfu","D1r","Bfr","Bfs","DFF","Bft"],
  "ice cream stand": ["FwX","Bfv"],
  "ice cream van": ["FwY","Bfw","Bfx","Bfy"],
  "ice cube": ["Bfz"],
  "ice cubes": ["Bf0","Bf1"],
  "ice giant": ["Fwa","BgA"],
  "ice hockey": ["GfL","BgB","FIF","BgD","BgC"],
  "ice lolly": ["GfM","BgK","BgJ"],
  "ice rink": ["GfO","BgN","BgM"],
  "ice skate": ["GfP","BgO","FIH","BgP","BgQ"],
  "ice skates": ["GfQ","BgS","BgR","BgT"],
  "ice skating": ["GfR","BgW","FII","BgV","BgU"],
  "ice storm": ["HTt"],
  "ice tea": ["Fwc","DFH","Egm"],
  "iceberg": ["FwV","Bfp"],
  "icecream": ["KCh"],
  "iced coffee": ["Bf4"],
  "iced tea": ["FwZ","Bf6","Bf8"],
  "Iceland": ["HDG","Fwb","BgI","BgG","BgH","BgF"],
  "Icelander": ["HDE","Kp2"],
  "Icelandic": ["HDF"],
  "icicle": ["Fwd","BgY"],
  "icicles": ["Fwe","Bgd","BgZ"],
  "icing": ["KCi"],
  "icon": ["KCj"],
  "ICT": ["Fwf"],
  "icy": ["GfS","Bgg","Bge","Bgh","Bgf"],
  "icy road": ["HTu"],
  "id": ["Fwh","Bgn","Bgi","Bgk","Bgj"],
  "ID card": ["GfT","DFI","D1t"],
  "idea": ["GfU","Bgl","FIJ"],
  "ideal": ["Iyz"],
  "idealised": ["Iyx"],
  "idealize": ["Iyy"],
  "ideally": ["KCk"],
  "identical": ["Iy0"],
  "identifiable": ["KCl"],
  "identification": ["Iy1"],
  "identifier": ["KCm"],
  "identify": ["Fwg","Bgm"],
  "identify with": ["Iy2"],
  "identity": ["HTv"],
  "ideological": ["KCn"],
  "ideology": ["Iy3"],
  "ideomotor": ["Iy4"],
  "idiom": ["Iy5"],
  "idiosyncratic": ["KCo"],
  "idiot": ["Iy6"],
  "idle": ["Iy7"],
  "idol": ["KCp"],
  "idyllic": ["Iy8"],
  "if": ["KCq"],
  "if you don't mind": ["HT0"],
  "igloo": ["GfV","Bgo","FIK","Bgp","Bgr","Bgq"],
  "igneous": ["Bgs"],
  "ignite": ["Iy9"],
  "ignorance": ["IzA"],
  "ignorant": ["IzB"],
  "ignore": ["Fwi","Dit","EcO"],
  "ignore ignored": ["Dit","ET7"],
  "ignore someone": ["EcO","Dit"],
  "ignored": ["ET7"],
  "ignored him": ["ET7"],
  "ignoring": ["EcO","Dit"],
  "ignoring someone": ["EcO","Dit"],
  "iguana": ["GfW","Bgv","FIL","Bgt","Bgu"],
  "Iguazu Falls": ["HT1"],
  "ill": ["GfX","Bgw","FIM","Bgx"],
  "ill at ease": ["IzC"],
  "illegal": ["KCs"],
  "illegally": ["KCr"],
  "illegible": ["IzD"],
  "illegitimate": ["KCt"],
  "illicit": ["KCu"],
  "Illinois": ["KCv","EHW"],
  "illiterate": ["DXq"],
  "illness": ["KCw"],
  "illuminate": ["IzE"],
  "illuminated": ["Bg0","Bgy","Bgz"],
  "illumination": ["KCx"],
  "illusion": ["IzF"],
  "illusory": ["IzG"],
  "illustrate": ["IzH"],
  "illustration": ["Bg3","Bg2"],
  "illustrative": ["IzI"],
  "illustrator": ["Fwk","DFJ","EHY","D1u","DFK"],
  "image": ["Fwl","Bg4"],
  "imagery": ["KCy"],
  "imaginary": ["IzJ"],
  "imagination": ["IzK"],
  "imaginative": ["IzL"],
  "imagine": ["GfY","Bg5"],
  "imagist": ["IzM"],
  "imbalance": ["KCz"],
  "imbibe": ["IzN"],
  "imitate": ["IzO"],
  "imitation": ["IzP"],
  "immaculate": ["KC0"],
  "immature": ["IzQ"],
  "immeasurable": ["IzR"],
  "immediate": ["IzT"],
  "immediately": ["IzS"],
  "immense": ["IzU"],
  "immensely": ["KC1"],
  "immerse": ["IzV"],
  "immersion": ["HT7"],
  "immigrant": ["IzW","Kp4"],
  "immigrate": ["IzX"],
  "immigration": ["HT8"],
  "imminent": ["KC2"],
  "immoral": ["IzY"],
  "immortal": ["HT9"],
  "immune": ["IzZ"],
  "immune system": ["HUA"],
  "immunity": ["Iza"],
  "immutable": ["Izb"],
  "impact": ["Fwn","DXs"],
  "impair": ["Izc"],
  "impairment": ["KC3"],
  "impart": ["Ize"],
  "impartial": ["Izd"],
  "impatience": ["KC4"],
  "impatient": ["GfZ","DXt"],
  "impatiently": ["KC5"],
  "impeach": ["KC7"],
  "impeachment": ["KC6"],
  "impede": ["Izf"],
  "impediment": ["KC8"],
  "impel": ["Izg"],
  "impend": ["KC9"],
  "impending": ["Izh"],
  "impenetrable": ["Izi"],
  "imperative": ["DXu"],
  "imperceptible": ["Izj"],
  "imperfect": ["KDA"],
  "imperial": ["Izk"],
  "imperialism": ["KDB"],
  "impermeable": ["Izl"],
  "impersonal": ["Izm"],
  "impetus": ["Izn"],
  "implant": ["DXv"],
  "implement": ["Izo"],
  "implementation": ["KDC"],
  "implicate": ["Izp"],
  "implication": ["Izq"],
  "implicit": ["Izr"],
  "implicitly": ["KDD"],
  "implore": ["Izs"],
  "imply": ["Izt"],
  "impolite": ["Izu"],
  "import": ["HUC"],
  "importance": ["Izv"],
  "important": ["Gfa","Bg7","Bg6"],
  "importantly": ["KDE"],
  "impose": ["Izw"],
  "imposition": ["KDF"],
  "impossibility": ["KDG"],
  "impossible": ["KDH"],
  "imposter": ["Fwo","DXw"],
  "impoverish": ["KDI"],
  "impractical": ["DXx"],
  "imprecise": ["Izx"],
  "impress": ["Iz0"],
  "impression": ["Izy"],
  "impressive": ["Izz"],
  "imprint": ["Iz1"],
  "imprison": ["KDK"],
  "imprisonment": ["KDJ"],
  "improbable": ["KDL"],
  "improper": ["KDM"],
  "improve": ["Fwp"],
  "improvement": ["KDN"],
  "improvisation": ["KDO"],
  "improvise": ["Iz2"],
  "impulse": ["Iz3"],
  "impure": ["Bg8"],
  "in": ["Gfj","DdQ","DdL","Bho","DdM","EfO","EfP"],
  "in a hurry": ["HUE"],
  "in a moment": ["I0B"],
  "in accordance with": ["Iz5"],
  "in addition": ["G8H"],
  "in addition to": ["Iz8"],
  "in advance": ["Iz9"],
  "in bed": ["HUF"],
  "in between": ["HUG"],
  "in brief": ["I0F"],
  "in case": ["G8I"],
  "in case of": ["I0H"],
  "in charge": ["DXy"],
  "in charge of": ["I0N"],
  "in class": ["HUI"],
  "in comparison with": ["I0X"],
  "in fact": ["I06"],
  "in favor of": ["I1A"],
  "in front": ["Fw3","DdP"],
  "in front of": ["Gff","DdN","DdO","EfN","EfM"],
  "in front of the coffee shop": ["EfM"],
  "in front of the TV": ["Fw2","EfN"],
  "in general": ["I1Z"],
  "in harmony": ["I1e"],
  "in harmony with": ["I1f"],
  "in honor of": ["I1i"],
  "in just a minute": ["I1m"],
  "in light of": ["I1p"],
  "in line skate": ["Fw9"],
  "in love": ["Gfi","Bhl","Bhm","Bhn"],
  "in need": ["I1s"],
  "in need of": ["I1r"],
  "in next to no time": ["I1v"],
  "in no time": ["I1y"],
  "in one's way": ["I12"],
  "in order to": ["G8K"],
  "in regard to": ["I15"],
  "in retrospect": ["I16"],
  "in search of": ["I19"],
  "in short": ["I2B"],
  "in silence": ["I2E"],
  "in spite of": ["I2M"],
  "in terms of": ["I20"],
  "in the afternoon": ["FxL","E07"],
  "in the bag": ["FxM","EfO"],
  "in the blink of an eye": ["I3E"],
  "in the box": ["FxN"],
  "in the car": ["HUW"],
  "in the cold light of day": ["I3F"],
  "in the evening": ["FxO","E08"],
  "in the fridge": ["FxP","EfP"],
  "in the garden": ["HUX"],
  "in the kitchen": ["HUY"],
  "in the long run": ["I3G"],
  "in the meantime": ["I3H"],
  "in the middle": ["FxQ","DdR","EfQ"],
  "in the middle of": ["I3I"],
  "in the middle of the line": ["EfQ"],
  "in the morning": ["FxR","E09"],
  "in the public eye": ["I3J"],
  "in time": ["I3L"],
  "in vain": ["I3Z"],
  "in vogue": ["I3j"],
  "inability": ["KDP"],
  "inaccessible": ["Iz4"],
  "inaccurate": ["KDQ"],
  "inactivate": ["Iz6"],
  "inactive": ["Iz7"],
  "inadequacy": ["KDR"],
  "inadequate": ["KDS"],
  "inadvertent": ["I0A"],
  "inadvertently": ["KDT"],
  "inanimate": ["I0C"],
  "inanity": ["I0D"],
  "inappropriate": ["Bg9"],
  "inaudible": ["KDU"],
  "inaugural": ["KDV"],
  "inaugurate": ["I0E"],
  "incapable": ["KDW"],
  "incapacitate": ["I0G"],
  "incarnation": ["KDX"],
  "Incas": ["Krw"],
  "incense": ["I0I"],
  "incentive": ["I0J"],
  "inception": ["I0K"],
  "incessant": ["I0M"],
  "incessantly": ["I0L"],
  "inch": ["HUH"],
  "incidence": ["KDY"],
  "incident": ["I0P"],
  "incidental": ["I0O"],
  "incidentally": ["KDZ"],
  "incinerate": ["I0Q"],
  "inclination": ["I0R"],
  "incline": ["I0S"],
  "include": ["I0T"],
  "inclusion": ["I0U"],
  "inclusive": ["I0V"],
  "income": ["Fwq","DXz"],
  "incoming": ["I0W"],
  "incompatible": ["I0Y"],
  "incompetence": ["KDa"],
  "incompetent": ["KDb"],
  "incomplete": ["KDc"],
  "incomprehensible": ["KDd"],
  "incongruity": ["I0Z"],
  "inconsiderate": ["I0a"],
  "inconsistency": ["I0b"],
  "inconsistent": ["KDe"],
  "inconspicuous": ["I0c"],
  "inconvenience": ["KDf"],
  "inconvenient": ["Fwr","DX0"],
  "incorporate": ["I0d"],
  "incorporation": ["KDg"],
  "incorrect": ["KDi"],
  "incorrectly": ["KDh"],
  "increase": ["Fws","BhB","BhA"],
  "increasingly": ["KDj"],
  "incredible": ["I0e"],
  "incredibly": ["KDk"],
  "incredulous": ["I0f"],
  "increment": ["I0g"],
  "incremental": ["KDl"],
  "incubate": ["I0h"],
  "incubation": ["KDm"],
  "incumbent": ["KDn"],
  "incur": ["I0i"],
  "incursion": ["I0j"],
  "indebted": ["KDo"],
  "indecipherable": ["I0k"],
  "indecisive": ["I0l"],
  "indeed": ["I0m"],
  "indefinite": ["KDq"],
  "indefinitely": ["KDp"],
  "indemnity": ["KDr"],
  "independence": ["HUJ"],
  "independent": ["I0n"],
  "independently": ["KDs"],
  "index": ["I0o"],
  "India": ["Gfc","BhG","FIN","DFN","EHe","D1v","BhC","BhD","BhE"],
  "India flag": ["Fwt","DFL"],
  "Indian": ["HDH","Kp5","Gfb","DFM","EeN"],
  "Indian elephant": ["BhF"],
  "Indian Ocean": ["KDt"],
  "Indian Subcontinent": ["KDu"],
  "indicate": ["DX1"],
  "indication": ["KDv"],
  "indicative": ["I0p"],
  "indicator": ["KDw"],
  "indict": ["I0q"],
  "indictment": ["KDx"],
  "Indie": ["KDy"],
  "indifference": ["I0r"],
  "indifferent": ["I0s"],
  "indigenous": ["I0t"],
  "indigent": ["I0u"],
  "indigestion": ["I0v"],
  "indignant": ["DX2"],
  "indignation": ["KDz"],
  "indigo": ["Fwu","DFO"],
  "indirect": ["I0w"],
  "indirectly": ["KD0"],
  "indispensable": ["I0x"],
  "indistinguishable": ["KD1"],
  "individual": ["Fwv","BhH","BhI"],
  "individualism": ["KD2"],
  "individuality": ["KD3"],
  "individually": ["KD4"],
  "indochina": ["KD5"],
  "Indochinese": ["KD6"],
  "indolent": ["I0y"],
  "Indonesia": ["Gfd","BhM","BhJ","EHf"],
  "Indonesia flag": ["Fww","DFP"],
  "Indonesian": ["HDI","Kp6"],
  "indoor": ["KD7"],
  "induce": ["I0z"],
  "induct": ["I00"],
  "induction": ["KD8"],
  "indulge": ["KD9"],
  "industrial": ["HUK"],
  "industrialist": ["KEA"],
  "industrialization": ["KEB"],
  "industrialize": ["KEC"],
  "industrious": ["I01"],
  "industry": ["Fwx","BhQ"],
  "ineffective": ["KED"],
  "inefficiency": ["KEE"],
  "inefficient": ["KEF"],
  "inequality": ["HUL"],
  "inert": ["I03"],
  "inertia": ["I02"],
  "inevitable": ["I04"],
  "inevitably": ["I05"],
  "inexpensive": ["DX3"],
  "inexperience": ["KEG"],
  "infamous": ["I07"],
  "infancy": ["I08"],
  "infant": ["Fwy","BhR","BhT"],
  "infantry": ["KEH"],
  "infatuate": ["I09"],
  "infect": ["I1C"],
  "infection": ["Fwz","BhU"],
  "infectious": ["I1B"],
  "infer": ["I1E"],
  "inference": ["KEI"],
  "inferior": ["I1D"],
  "infest": ["I1F"],
  "infiltrate": ["I1G"],
  "infinite": ["I1H"],
  "infinitely": ["KEJ"],
  "infinitesimal": ["I1I"],
  "infinitive": ["KEK"],
  "infinity": ["KEL"],
  "infirm": ["I1J"],
  "inflame": ["KEM"],
  "inflammation": ["I1K"],
  "inflammatory": ["KEN"],
  "inflate": ["I1L"],
  "inflation": ["HUM"],
  "inflection": ["KEO"],
  "inflict": ["DX4"],
  "inflow": ["KEP"],
  "influence": ["I1M"],
  "influential": ["I1N"],
  "influenza": ["I1O"],
  "influx": ["I1P"],
  "info": ["KEQ"],
  "inform": ["I1U"],
  "informal": ["I1Q"],
  "informant": ["I1R"],
  "information": ["Gfe","BhV","BhX"],
  "information board": ["Fw0","BhW"],
  "information technology": ["Fw1","E04"],
  "informational": ["KER"],
  "informative": ["I1S"],
  "informed": ["I1T"],
  "infrared": ["I1V"],
  "infrastructure": ["I1W"],
  "infringement": ["KES"],
  "infuriate": ["I1X"],
  "infuriating": ["I1Y"],
  "infuse": ["KET"],
  "infusion": ["KEU"],
  "ingenious": ["I1a"],
  "ingenuity": ["KEV"],
  "ingredient": ["G8J"],
  "ingredients": ["Gfg","Bha","BhY","BhZ"],
  "inhabit": ["I1c"],
  "inhabitant": ["I1b"],
  "inhale": ["I1d"],
  "inhaling": ["DX6"],
  "inherent": ["I1g"],
  "inherently": ["KEW"],
  "inherit": ["DX7"],
  "inheritance": ["Fw4"],
  "inhibit": ["I1h"],
  "inhibition": ["KEX"],
  "inhibitor": ["KEY"],
  "inhibitory": ["KEZ"],
  "initial": ["DX8"],
  "initially": ["KEa"],
  "initiate": ["I1j"],
  "initiation": ["KEb"],
  "initiative": ["Fw5","DX9"],
  "inject": ["I1k"],
  "injection": ["Fw6","Bhb"],
  "injunction": ["KEc"],
  "injure": ["Fw7","DYA"],
  "injurious": ["I1l"],
  "injury": ["Fw8","Bhf","Bhd","Bhc","Bhe"],
  "injustice": ["I1n"],
  "ink": ["Gfh","Bhh","FIO","Bhg","Bhi"],
  "inland": ["I1o"],
  "inlet": ["KEd"],
  "inline skates": ["FxA","Bhk","Bhj"],
  "inmate": ["KEe"],
  "inn": ["I11"],
  "innate": ["I1q"],
  "inner": ["I1u"],
  "inner city slum": ["I1t"],
  "inner core": ["FxB","DYB"],
  "inning": ["KEf"],
  "innocence": ["I1w"],
  "innocent": ["I1x"],
  "innovate": ["I1z"],
  "innovation": ["FxC","DYC"],
  "innovative": ["I10"],
  "innovator": ["KEg"],
  "innumerable": ["KEh"],
  "inorganic chemistry": ["HUN"],
  "input": ["I13"],
  "inquest": ["KEi"],
  "inquire": ["I14"],
  "inquiry": ["KEj"],
  "insane": ["KEk"],
  "insanity": ["I17"],
  "inscribe": ["I18"],
  "inscription": ["KEl"],
  "insect": ["Gfk","DFQ","FIP","Bhp"],
  "insects": ["Gfl","DrO","FIQ","EHj"],
  "insecure": ["KEm"],
  "insecurity": ["KEn"],
  "insemination": ["KEo"],
  "insensitive": ["KEp"],
  "inseparable": ["I2A"],
  "insert": ["Diu"],
  "insert inserted": ["ETY","Diu"],
  "inserted": ["ETY"],
  "inserted a usb stick": ["ETY"],
  "inserting": ["Diu"],
  "insertion": ["KEq"],
  "inset": ["KEr"],
  "inside": ["Gfm","Bhq","FIR"],
  "insider": ["KEs"],
  "insight": ["I2C"],
  "insightful": ["KEt"],
  "insignificance": ["I2D"],
  "insignificant": ["KEu"],
  "insist": ["I2G"],
  "insistence": ["I2F"],
  "insofar": ["KEv"],
  "insolvent": ["I2H"],
  "insomnia": ["I2I"],
  "inspect": ["I2J"],
  "inspection": ["HUO"],
  "inspector": ["KEw"],
  "inspiration": ["I2K"],
  "inspirational": ["FxD","Bhr"],
  "inspire": ["I2L"],
  "instability": ["KEx"],
  "install": ["I2N"],
  "installation": ["KEy"],
  "installment": ["KEz"],
  "instance": ["I2O"],
  "instant": ["I2R"],
  "instant celebrities": ["I2Q"],
  "instant coffee": ["FxE","DFR"],
  "instant noodles": ["FxF","DFS","Bht"],
  "instantaneous": ["I2P"],
  "instantly": ["KE0"],
  "instead": ["I2S"],
  "instead of": ["G8L"],
  "instill": ["I2T"],
  "instinct": ["I2U"],
  "instinctively": ["KE1"],
  "instinctual": ["I2V"],
  "institute": ["I2W"],
  "institution": ["I2X"],
  "institutional": ["KE3"],
  "institutionalize": ["KE2"],
  "instruct": ["I2a"],
  "instruction": ["I2Y"],
  "instructional": ["KE4"],
  "instructive": ["KE5"],
  "instructor": ["I2Z"],
  "instrument": ["E05"],
  "instrumental": ["KE7"],
  "instrumentality": ["KE6"],
  "instruments": ["Gfn","DrP","FIS"],
  "insufficient": ["I2b"],
  "insulate": ["I2c"],
  "insulation": ["KE8"],
  "insulator": ["HUP"],
  "insulin": ["I2d"],
  "insult": ["I2e"],
  "insurance": ["FxG","DYD","Bhx"],
  "insure": ["KE9"],
  "insurer": ["KFA"],
  "insurgency": ["KFB"],
  "insurgent": ["KFC"],
  "insurmountable": ["I2f"],
  "intact": ["I2g"],
  "intake": ["I2h"],
  "intangible": ["KFD"],
  "integer": ["KFE"],
  "integral": ["I2i"],
  "integrate": ["I2j"],
  "integration": ["DYE"],
  "integrity": ["I2k"],
  "intellect": ["I2l"],
  "intellectual": ["I2m"],
  "intellectually": ["KFF"],
  "intelligence": ["HUQ"],
  "intelligent": ["Gfo","Bh0","FIT","Bhz","Bhy"],
  "intelligible": ["I2n"],
  "intend": ["I2o"],
  "intense": ["I2p"],
  "intensely": ["KFG"],
  "intensify": ["KFH"],
  "intensity": ["KFI"],
  "intensive": ["KFJ"],
  "intent": ["I2r"],
  "intention": ["KFL"],
  "intentional": ["KFK"],
  "intentionally": ["I2q"],
  "intently": ["KFM"],
  "inter": ["KFZ"],
  "interact": ["KFN","I2u"],
  "interaction": ["I2s"],
  "interactive": ["I2t"],
  "interactive whiteboard": ["FxH","Bh1","Bh2"],
  "intercept": ["KFO"],
  "interchange": ["I2v"],
  "interconnect": ["KFP"],
  "interdependence": ["KFQ"],
  "interdisciplinary": ["KFR"],
  "interest": ["HUR"],
  "interested": ["Gfp","Bh3"],
  "interesting": ["Gfq","DYF","FIU","EHm"],
  "interestingly": ["KFS"],
  "interface": ["I2w"],
  "interfere": ["I2x"],
  "interference": ["KFT"],
  "interim": ["I2y"],
  "interior": ["Bh4"],
  "interior design": ["HUS"],
  "intermediary": ["KFU"],
  "intermediate": ["HUT"],
  "intermittent": ["I2z"],
  "intern": ["I22"],
  "internal": ["I21"],
  "internalize": ["KFV"],
  "internally": ["KFW"],
  "international": ["E06"],
  "International Space Station": ["HUU"],
  "internationally": ["KFX"],
  "Internet": ["Gfr","Bh6","FIV","Bh5"],
  "internship": ["I23"],
  "interpersonal": ["KFY"],
  "interplay": ["I24"],
  "interpret": ["FxJ","EYF","Div"],
  "interpret Chinese to English": ["EYF"],
  "interpret interpreted": ["Div"],
  "interpretation": ["I25"],
  "interpreter": ["FxI","DFT","EHo"],
  "interpreting": ["Div"],
  "interpretive": ["KFa"],
  "interrelate": ["I26"],
  "interrogate": ["I27"],
  "interrogation": ["KFb"],
  "interrupt": ["I28"],
  "interruption": ["KFc"],
  "intersect": ["KFd"],
  "intersection": ["I29"],
  "intersperse": ["KFe"],
  "interstate": ["KFf"],
  "interstellar": ["HUV"],
  "intertwine": ["KFg"],
  "interval": ["I3A"],
  "intervene": ["I3B"],
  "intervening": ["I3C"],
  "intervention": ["KFh"],
  "interview": ["Gfs","Dix","Diw","EYG","Bh7","Bh8"],
  "interview interviewed": ["EU3","Diw","Dix"],
  "interview people": ["EHp"],
  "interview someone": ["EYG","Dix"],
  "interviewed": ["EU3"],
  "interviewed her": ["EU3"],
  "interviewee": ["KFi"],
  "interviewer": ["KFj"],
  "interviewing": ["Dix","Diw"],
  "interviewing someone": ["Dix"],
  "interweave": ["I3D"],
  "intestinal": ["KFk"],
  "intestine": ["KFl"],
  "intestines": ["FxK","Bh9","BiA"],
  "intimacy": ["KFm"],
  "intimate": ["I3K"],
  "intimately": ["KFn"],
  "intimidate": ["I3M"],
  "intimidation": ["KFo"],
  "into": ["KFq"],
  "intolerable": ["I3N"],
  "intonation": ["KFp"],
  "intoxication": ["I3O"],
  "intracellular": ["KFr"],
  "intranet": ["KFs"],
  "intrepid": ["I3P"],
  "intricate": ["I3Q"],
  "intrigue": ["I3R"],
  "intriguing": ["I3S"],
  "intrinsic": ["I3T"],
  "introduce": ["FxS","DrQ"],
  "introduce to": ["I3U"],
  "introduction": ["I3V"],
  "introductory": ["KFt"],
  "intrude": ["I3W"],
  "intruder": ["KFu"],
  "intrusion": ["I3X"],
  "intrusive": ["KFv"],
  "intuition": ["BiB"],
  "intuitive": ["I3Y"],
  "Inuit": ["Kp7"],
  "invade": ["HUZ"],
  "invader": ["KFw"],
  "invalid": ["I3a"],
  "invaluable": ["KFx"],
  "invariably": ["KFy"],
  "invariant": ["KFz"],
  "invasion": ["HUa"],
  "invasive": ["I3b"],
  "invent": ["Gfv","BiC"],
  "invention": ["Gft","DrR"],
  "inventive": ["I3c"],
  "inventor": ["Gfu","BiD","DYG"],
  "inventory": ["I3d"],
  "inverse": ["I3e"],
  "inversion": ["KF0"],
  "invert": ["I3f"],
  "invertebrate": ["HUb"],
  "invest": ["I3h"],
  "investigate": ["I3g"],
  "investigation": ["KF1"],
  "investigative": ["KF2"],
  "investigator": ["KF3"],
  "investment": ["FxT","BiE"],
  "investor": ["HUc"],
  "invisible": ["FxU","DrS"],
  "invitation": ["Gfw","DYH","FIW"],
  "invite": ["Gfx","DYI","FIX"],
  "inviting": ["I3i"],
  "invoice": ["KF4"],
  "invoke": ["I3k"],
  "involuntary": ["KF5"],
  "involve": ["I3l"],
  "involvement": ["KF6"],
  "inward": ["I3m"],
  "Io": ["HUg"],
  "iodine": ["HUd"],
  "ion": ["HUf"],
  "ionic bond": ["HUe"],
  "iphone": ["BiG","BiF"],
  "IQ": ["HUh"],
  "Iran": ["FxX","BiK","EHr"],
  "Iranian": ["HDK","Kp8","G8M"],
  "Ireland": ["Gfz","BiQ","FIY","DFW","BiL","D1x","BiN","BiP"],
  "Ireland flag": ["FxY","DFV"],
  "Irish": ["HDL","Krx","FxZ","DFX","EeO"],
  "Irishman": ["Kp9"],
  "iron": ["Gf0","Diy","FIZ","EcP","BiR"],
  "iron a shirt": ["Fxa","Diy","EcP"],
  "Iron Age": ["HUi"],
  "iron ironed": ["Diy"],
  "iron out": ["I3o"],
  "iron oxide": ["HUj"],
  "ironic": ["I3n"],
  "ironically": ["KF7"],
  "ironing": ["Fxb","Diy","EcP"],
  "ironing a shirt": ["EcP","Diy"],
  "ironing board": ["G8N"],
  "irony": ["I3p"],
  "irrational": ["KF8"],
  "irregular": ["I3q"],
  "irregular galaxy": ["HUk"],
  "irregularity": ["KF9"],
  "irrelevant": ["KGA"],
  "irresistible": ["I3r"],
  "irrespective": ["KGB"],
  "irresponsible": ["I3s"],
  "irreverent": ["I3t"],
  "irrigate": ["I3u"],
  "irrigation": ["KGC"],
  "irritable": ["I3v"],
  "irritate": ["I3w"],
  "irritated": ["Fxc","DYJ"],
  "irritating": ["DYK"],
  "irritation": ["KGD"],
  "is it hot today": ["EHt"],
  "is it raining": ["EHu"],
  "is the music loud": ["EHv"],
  "is was": ["Fxe","Deu"],
  "is your bag heavy": ["EHw"],
  "is your dog dangerous": ["EHx"],
  "is your friend beautiful": ["EHy"],
  "Isaac Newton": ["KGE"],
  "island": ["Gf1","BiU","FIa","BiS","DFY","D1y","BiT"],
  "isolate": ["I3x"],
  "isolated": ["Fxd","DYL"],
  "isolation": ["KGF"],
  "isotope": ["KGG"],
  "issuance": ["KGH"],
  "issue": ["I3y"],
  "issuer": ["KGI"],
  "Istanbul": ["G8O"],
  "IT": ["Fxf","E1A"],
  "it is big": ["HUn"],
  "it is cloudy": ["EhO"],
  "it is cold": ["HUo"],
  "it is Monday": ["HUp"],
  "it is raining": ["HUq"],
  "it is sunny": ["EiB"],
  "it is time": ["HUr"],
  "it's all right": ["HUs"],
  "it's cloudy": ["HUt"],
  "it's cold": ["DrU"],
  "it's cool": ["HUu"],
  "it's five past six": ["EfR"],
  "it's five to twelve": ["EfS"],
  "it's foggy": ["HUv"],
  "it's half past seven": ["EfT"],
  "it's half past twelve": ["EfU"],
  "it's half past two": ["EfV"],
  "it's hot": ["HUw"],
  "it's nine o'clock": ["EfW"],
  "it's okay": ["HUx"],
  "it's quarter past eleven": ["EfX"],
  "it's quarter past one": ["EfY"],
  "it's quarter past six": ["EfZ"],
  "it's quarter past twelve": ["Efa"],
  "it's quarter to eight": ["Efb"],
  "it's quarter to five": ["Efc"],
  "it's quarter to four": ["Efd"],
  "it's raining": ["HUy"],
  "it's snowing": ["HUz"],
  "it's sunny": ["DrV"],
  "it's ten past eight": ["Efe"],
  "it's ten to five": ["Eff"],
  "it's three o'clock": ["Efg"],
  "it's twenty five past eleven": ["Efh"],
  "it's twenty five to ten": ["Efi"],
  "it's twenty past two": ["Efj"],
  "it's twenty to four": ["Efk"],
  "it's warm": ["HU0"],
  "it's windy": ["HU1"],
  "Italian": ["Gf2","KqA","DFZ","EeP"],
  "Italians": ["Kry"],
  "Italy": ["Gf3","FIb","Bia","DFb","BiV","D1z","BiZ","EHz","BiW","BiY"],
  "Italy flag": ["DFa"],
  "itch": ["Bib"],
  "itchy": ["Fxh","DrT"],
  "item": ["I3z"],
  "iteration": ["KGJ"],
  "itinerary": ["Fxi","DYM"],
  "itself": ["KGK"],
  "Ivorian": ["KGL"],
  "ivory": ["I30"],
  "Ivory Coast": ["KGM"],
  "ivy": ["I31"],
  "izanagi": ["HU4"],
  "izanami": ["HU5"],
  "J": ["DZ3","Fx4","FIz","HDQ"],
  "j": ["GgV","DZ4","HDM"],
  "jab": ["KGN"],
  "jack": ["KGO"],
  "jack fruit": ["Fxm","Bih","Big"],
  "jack in the box": ["Gf6","Bii"],
  "jack o lantern": ["Gf7","DrX","FId"],
  "jacket": ["Gf4","DFc","FIc","D10","Bid","Bie","Bif","Bic"],
  "jackfruit": ["Gf5","DrW"],
  "jackolantern": ["EH0"],
  "jade": ["Fxn","Bik","Bij"],
  "jade emperor": ["HU6"],
  "jade rabbit": ["Fxo"],
  "jag": ["KGP"],
  "jagged": ["I32"],
  "jaguar": ["Gf8","Bio","Bim","Bin","Bil"],
  "jail": ["I33"],
  "jailbreak": ["DYN"],
  "Jakarta": ["G8P"],
  "jam": ["Gf9","Bip","FIe","Biw","Biq","Bir"],
  "Jamaica": ["Fxp","Biv","Bis","Biu"],
  "Jamaican": ["HDN","Kog"],
  "janitor": ["GgA","DFd","FIf","DFe"],
  "January": ["GgB","DrY","FIg"],
  "Japan": ["HDP","GgD","Bi2","FIk","DFh","Bix","EH4","Bi1","D11","Biy"],
  "Japan flag": ["Fxq","DFg"],
  "Japanese": ["HDO","GgC","Krz","Koh","DFf","FIi","FIh","FIj","EeQ"],
  "Japanese Mythology": ["HU7"],
  "jar": ["GgE","Bi3","FIl","Bi7","Bi5","Bi6","Bi4"],
  "jargon": ["KGQ"],
  "jasmine": ["Fxr","Bi8","Bi9"],
  "javelin": ["DFi"],
  "jaw": ["Fxs","BjA"],
  "jazz": ["GgF","BjC","BjB"],
  "jealous": ["GgG","Fxt","DFj","FIm","DYO","EH5"],
  "jealousy": ["I34"],
  "jeans": ["GgH","DFk","FIn","BjI","D13","BjE","BjG","BjD","BjF"],
  "jeep": ["GgI","BjM","FIo","BjJ","BjK","BjL"],
  "Jeju Island": ["HU8"],
  "jello": ["Fxu","BjO","BjN"],
  "jelly": ["GgK","BjP","FIq","BjU"],
  "jellybeans": ["Fxv","BjQ","BjR"],
  "jellyfish": ["GgJ","BjT","FIp","BjS"],
  "jenga": ["HU9"],
  "jeopardize": ["I35"],
  "jeopardy": ["KGR"],
  "jerk": ["KGS"],
  "Jersey": ["KGT"],
  "jester": ["Fxw","BjV","BjW"],
  "jet": ["GgL","Bja","FIr","BjZ","Bjb"],
  "jet lag": ["HVA"],
  "jewel": ["Fxx","Bje","Bjc","Bjd"],
  "jewelry": ["GgM","DrZ","FIs"],
  "jewelry store": ["Fxy","Bjg","Bjf"],
  "jigsaw": ["GgN","Bjj","DFl","Bjh","Bji"],
  "jingle": ["I36"],
  "jingle bells": ["Fxz","Bjk","Bjl","Bjn"],
  "Joan of Arc": ["KGU"],
  "job": ["GgO","Bjo","FIt"],
  "jockey": ["Bjr"],
  "jog": ["GgQ","Bjt","FIv","Diz","Bj1","Bjs","Bju","Bjw"],
  "jog jogged": ["Diz"],
  "jogging": ["GgP","Diz","FIu","Bjy","Bj0","Bjz","Bjx"],
  "Johannesburg": ["G8Q"],
  "join": ["GgR","Di0","FIw","Bj2"],
  "join a book club": ["Fx0","Di0"],
  "join in": ["E1B"],
  "join joined": ["Di0"],
  "joining": ["Di0"],
  "joining a book club": ["Di0"],
  "joint": ["I37"],
  "jointly": ["KGV"],
  "joints": ["Fx1","Bj3"],
  "joke": ["GgS","DYP"],
  "jolly": ["DYQ"],
  "jolt": ["I38"],
  "jot": ["I4A"],
  "jot down": ["I39"],
  "joule": ["HVB"],
  "journal": ["Fx2"],
  "journalism": ["I4B"],
  "journalist": ["GgT","DFm","FIx","Bj4","DFn","EH6","EH7"],
  "journalistic": ["KGW"],
  "journey": ["GgU","Bj5","FIy","Bj7","Bj8","Bj6"],
  "Journey to the West": ["HVC"],
  "joy": ["Fx3","BkA","BkB","Bj9"],
  "judge": ["GgW","BkC","FI0","BkE","BkF","BkD"],
  "judgment": ["I4C"],
  "judicial": ["KGX"],
  "judiciary": ["KGY"],
  "judo": ["GgX","BkJ","FI1","BkH","BkK","BkI","BkG"],
  "jug": ["GgZ","DFo","FI3","BkS","D14","BkN","BkM","BkL"],
  "juggle": ["GgY","BkP","FI2","BkO"],
  "juggler": ["Fx6","BkQ","BkR"],
  "juice": ["Gga","BkT","FI4","BkV","BkU"],
  "juice up": ["I4D"],
  "juicy": ["Fx7"],
  "July": ["Ggb","Dra","FI5"],
  "jumble": ["I4E"],
  "jump": ["Gge","Di4","FI8","Di2","EdX","EYI","BkW","BkX","BkY","Bkg","Di1","EYJ","Di3"],
  "jump far": ["HVD"],
  "jump high": ["HVE"],
  "jump in": ["HVF"],
  "jump into": ["HVG"],
  "jump jumped": ["Fx9","Di2","Di3","EVv","ES1","Di1","Di4"],
  "jump on a trampoline": ["EYI"],
  "jump on the bed": ["HVH"],
  "jump out of the water": ["EYJ"],
  "jump over": ["Ea4"],
  "jump over a puddle": ["Di3","Ea4"],
  "jump rope": ["Ggf","Bkj","FI9","Bkh","Bkk","Bki"],
  "jump up": ["HVI"],
  "jumped": ["Fx8","EVv","ES1"],
  "jumped on a trampoline": ["EVv"],
  "jumped over a puddle": ["ES1"],
  "jumper": ["Ggc","Bkc","FI6","Bkd","Bkb","Bka","BkZ"],
  "jumping": ["Ggd","Di4","FI7","Di2","EdX","Bkf","Di1","Bke","Di3"],
  "jumping over": ["Ea4"],
  "jumping over a puddle": ["Ea4","Di3"],
  "junction": ["I4F"],
  "juncture": ["KGZ"],
  "June": ["Ggg","Drb","FJA"],
  "jungle": ["Ggh","Bkn","FJB","Bko","Bkl"],
  "junior": ["I4G"],
  "junk": ["KGb"],
  "junk food": ["FyA","Bkp","Bkq","Bkr"],
  "junkie": ["KGa"],
  "Juno": ["HVJ"],
  "jupiter": ["Ggi","Bkt","FJC","Bks"],
  "Jupiter's moons": ["HVK"],
  "juridical": ["I4H"],
  "jurisdiction": ["KGc"],
  "juror": ["KGd"],
  "jury": ["I4I"],
  "just": ["KGf"],
  "just a moment": ["HVL"],
  "just in time": ["I4L"],
  "justice": ["I4J"],
  "justification": ["KGe"],
  "justify": ["I4K"],
  "justly": ["I4M"],
  "jut": ["KGg"],
  "juvenile": ["I4O"],
  "juvenile crime": ["I4N"],
  "K": ["DZ5","GhH","Fyd","HDW"],
  "k": ["DZ6","HDR"],
  "kabaddi": ["HVM"],
  "Kami": ["HVN"],
  "kangaroo": ["Ggj","DFp","FJD","D15","Bky","Bkv","Bkw","Bkz","Bkx","Bku"],
  "kappa": ["HVO"],
  "karate": ["Ggk","DFq","FJE","Bk2","Bk0","D16","Bk3","Bk1"],
  "kayak": ["Ggm","Bk5","Bk9","Bk4"],
  "kayaking": ["Ggl","Bk8","FJF","Bk7","Bk6"],
  "Kazakhstan": ["HDT","G8S"],
  "Kazakhstani": ["HDS","Koi","G8R"],
  "kebab": ["FyB","Egn"],
  "kebabs": ["D17"],
  "keel over": ["I4P"],
  "keen": ["I4Q"],
  "keenly": ["KGh"],
  "keep": ["Ggn","BlA"],
  "keep an eye on": ["I4R"],
  "keep away": ["I4T"],
  "keep away from": ["I4S","HVP"],
  "keep fit": ["FyC"],
  "keep from": ["I4U"],
  "keep in": ["I4W"],
  "keep in mind": ["I4V"],
  "keep in touch": ["HVQ"],
  "keep off": ["HVR"],
  "keep on": ["HVS"],
  "keep one's fingers crossed": ["I4X"],
  "keep one's word": ["I4Y"],
  "keep out": ["HVT"],
  "keep out of": ["I4Z"],
  "keep track of": ["I4a"],
  "keep track of money": ["EH8"],
  "keep up": ["HVU"],
  "keep warm": ["E1C"],
  "keeper": ["KGi"],
  "kennel": ["I4b"],
  "Kenya": ["HDV","FyD","BlF","BlB","BlC","BlE","EH9","BlD"],
  "Kenyan": ["HDU","Koj"],
  "kernel": ["I4c"],
  "kerosene": ["I4d"],
  "ketchup": ["Ggo","DFr","FJG","BlG","D18","BlI","BlH"],
  "kettle": ["Ggp","DFs","FJH","BlK","D19","BlM","BlL","BlJ"],
  "key": ["Ggs","BlO","FJJ","BlN","BlV","BlP"],
  "keyboard": ["Ggq","Ggr","BlU","FJI","BlT","DFu","DFt","BlS","D2A","BlQ","BlR","D2B"],
  "keyring": ["FyE","BlZ","BlY","BlX","BlW"],
  "keys": ["Ggt","DFv","FJK","Blb","Bla","D2C"],
  "keyword": ["KGj"],
  "khaki": ["DFw"],
  "kick": ["Ggw","Di5","FJL","Ea5","Ble","Bld","Blf","Blg","Blc","Blh"],
  "kick a ball": ["Ggu","Di5","Ea5"],
  "kick back": ["I4e"],
  "kick in": ["I4f"],
  "kick kicked": ["ES2","Di5"],
  "kick off": ["I4g"],
  "kick out": ["I4h"],
  "kick the ball": ["FyG"],
  "kick up": ["I4i"],
  "kicked": ["ES2"],
  "kicked the ball": ["ES2"],
  "kicking": ["Ggv","Di5","Ea5"],
  "kicking a ball": ["FyF","Di5","Ea5"],
  "kid": ["Ggx","Bll","FJM"],
  "kidnap": ["I4j"],
  "kidney": ["FyH","Bli","Blj"],
  "kidneys": ["FyI","Blk"],
  "kids": ["Ggy","Blm"],
  "kill": ["E1D"],
  "kill off": ["I4k"],
  "killer": ["KGk"],
  "killer whale": ["Ggz","Bln","Blp","Blq","Blo"],
  "kiln": ["I4l"],
  "kilo": ["KGl"],
  "kilogram": ["HVV","FyJ","Blr","Bls"],
  "kilometer": ["HVW"],
  "kilometre": ["HVX"],
  "kin": ["I4q"],
  "kinase": ["KGm"],
  "kind": ["Gg0","Blt","FJN"],
  "kind of": ["G8T"],
  "kind regards": ["HVY"],
  "kindergarten": ["KGn"],
  "kindle": ["I4m"],
  "kindly": ["I4n"],
  "kindness": ["KGo"],
  "kinetic": ["I4o"],
  "king": ["Gg1","Blu","FJO","Bl0","Blv"],
  "king cobra": ["Blw"],
  "kingdom": ["I4p"],
  "kingfisher": ["FyK","Blx"],
  "kinship": ["I4r"],
  "kiosk": ["KGp"],
  "kiss": ["Gg2","Bl3","FJP","Bl4","Bl1","Bl2"],
  "kiss up to": ["I4s"],
  "kiss your mum": ["HVZ"],
  "kit": ["Gg5","BmF"],
  "kitchen": ["Gg3","DFx","FJQ","Bl6","Bl8","Bl7","Bl5"],
  "kite": ["Gg4","FyL","Bl9","FJR","DFy","BmE","D2D","BmA","BmC","BmB"],
  "kite flying": ["BmD"],
  "kites": ["FyM","Drc"],
  "kitsune": ["HVa"],
  "kitten": ["Gg6","BmK","FJS","BmH","BmG","BmI","BmJ"],
  "kittens": ["FyN","BmM","BmL"],
  "kiwi": ["Gg7","BmR","FJT","BmN","BmO"],
  "Kiwi": ["Kok"],
  "kiwi fruit": ["FyO","BmP","DFz","BmQ"],
  "kiwifruit": ["D2E"],
  "knack": ["I4t"],
  "knead": ["FyP","BmT","Di6","BmS"],
  "knead dough": ["Di6"],
  "knead kneaded": ["Di6"],
  "kneading": ["Di6"],
  "kneading dough": ["Di6"],
  "knee": ["Gg8","DF0","FJU","D2F","BmU"],
  "kneel": ["FyQ","Di7"],
  "kneel down": ["Ea6","Di7"],
  "kneel knelt": ["Di7"],
  "kneeling": ["Di7"],
  "kneeling down": ["Ea6","Di7"],
  "knees": ["Gg9","Drd","FJV"],
  "knew": ["FyR","E1E"],
  "knife": ["GhA","DF1","FJW","BmW","BmX","D2G","BmV"],
  "knight": ["GhB","BmZ","FJX","Bmb","BmY","Bma"],
  "knit": ["GhC","Di8","EYK"],
  "knit a scarf": ["EYK"],
  "knit knitted": ["Di8"],
  "knitting": ["GhD","FyS","Di8","Bme","Bmc"],
  "knives": ["FyT","Bmf"],
  "knob": ["KGq"],
  "knock": ["FyU","E1F"],
  "knock back": ["I4u"],
  "knock down": ["I4v"],
  "knock off": ["I4w"],
  "knock out": ["I4x"],
  "knock over": ["I4y"],
  "knot": ["FyV"],
  "know": ["GhE","Di9","EYL"],
  "know knew": ["FyW","Di9"],
  "know the answer": ["FyZ","Di9","EYL"],
  "know which way the wind is blowing": ["I4z"],
  "knowing": ["Di9"],
  "knowing the answer": ["Di9"],
  "knowingly": ["KGr"],
  "knowledge": ["FyX","Bmg"],
  "knowledgeable": ["KGs"],
  "known": ["FyY"],
  "knuckle": ["Fya","DF2"],
  "knuckles": ["Fyb","DF3"],
  "koala": ["GhF","Bml","FJY","Bmh","Bmj","Bmi","Bmk"],
  "Komodo Island": ["HVb"],
  "Korea": ["GhG","Bmp","FJZ","Bmm","EIA","Bmo"],
  "Korea flag": ["DF4"],
  "Korean": ["KGu","Kol","Fyc"],
  "Korean Mythology": ["HVc"],
  "Korean Peninsula": ["KGt"],
  "Kuala Lumpur": ["KGv"],
  "Kuiper Belt": ["HVd"],
  "kumquat": ["Fye","Bms","Bmt","Bmr","Bmq"],
  "kung fu": ["Fyf","Bmu","Bmw","Bmx"],
  "Kurd": ["Kom"],
  "Kurds": ["Kr0"],
  "Kyiv": ["KGw"],
  "kyoto": ["KGx"],
  "L": ["DZ7","Gix","F0U","FKc","HDe"],
  "l": ["DZ8","HDX"],
  "lab": ["HVe"],
  "lab technician": ["Fyh","Bm5","Bm6"],
  "label": ["I40"],
  "labor": ["I42"],
  "laboratory": ["GhI","Bm1","FJa","Bmz","Bmy","Bm0"],
  "laborer": ["KGy"],
  "laborious": ["I41"],
  "labrador": ["Fyg","Bm4","Bm3","Bm2"],
  "labyrinth": ["HVf"],
  "lace": ["Fyi","Bm8","Bm7"],
  "laces": ["Fyj","Bm9"],
  "lack": ["I43"],
  "lacrosse": ["HVg"],
  "lad": ["KG0"],
  "ladder": ["GhJ","DF5","FJb","D2H","BnD","BnA","BnC","BnB"],
  "laden": ["KGz"],
  "ladies": ["Fyk","BnF","BnE"],
  "ladies first": ["HVh"],
  "ladle": ["Fyl","Dre"],
  "lady": ["GhM","BnH","BnS","BnI","BnG"],
  "ladybird": ["GhK","BnK","FJc","BnN","BnL","BnJ"],
  "ladybug": ["GhL","BnO","FJd","BnP"],
  "ladybugs": ["Fym","BnQ","BnR"],
  "lag": ["I44"],
  "lager": ["KG1"],
  "lagoon": ["KG2"],
  "Lagos": ["G8U"],
  "lake": ["GhN","BnV","FJe","DF6","BnY","D2I","BnU","BnW","BnX","BnT"],
  "Lake Baikal": ["KG3"],
  "Lake Erie": ["KG4"],
  "Lake Huron": ["KG5"],
  "Lake Michigan": ["KG6"],
  "Lake Superior": ["KG7"],
  "lamb": ["GhO","Bnc","FJf","DF7","Bnb","Ego","BnZ","D2J","Bna"],
  "lame": ["I46"],
  "lament": ["I45"],
  "lamp": ["GhP","DF8","FJg","DF9","D2K","Bne","Bnd","Bnf"],
  "land": ["GhQ","Bnr","FJh","Bng","Bnh","Bni","Bnj"],
  "landfill": ["Fyn","Bnk","Bno","Bnl","Bnn"],
  "landing": ["I47"],
  "landing module": ["HVi"],
  "landlord": ["G8V"],
  "landmark": ["Fyo","Bnq","Bnp"],
  "landmass": ["I48"],
  "landowner": ["KG8"],
  "landscape": ["GhR","Drf"],
  "landslide": ["GhS","Bnv","Bnt","Bnu"],
  "lane": ["GhT","Bnw","Bny","Bnx"],
  "language": ["GhU","Bnz","FJi"],
  "language exchange": ["HVj"],
  "language learning": ["HVk"],
  "languages": ["Fyp","Bn0"],
  "languish": ["I49"],
  "lantern": ["GhV","Bn2","FJj","Bn3","Bn1"],
  "lanterns": ["Fyq","Bn4","Bn5","Bn6"],
  "Laos": ["HDY","G8W"],
  "Laotian": ["Kon"],
  "lap": ["KG9"],
  "lapse": ["I5A"],
  "laptop": ["GhW","DGB","FJk","BoB","DGA","D2L","BoA","Bn8","D2M","Bn9","Bn7"],
  "large": ["GhX","BoD","FJl","BoC","EhE","EIB","EhF"],
  "largely": ["KHA"],
  "larva": ["I5B"],
  "larynx": ["I5C"],
  "Las Vegas": ["KHD"],
  "laser": ["I5D"],
  "laser tag": ["HVl"],
  "lash": ["I5F"],
  "lash out": ["I5E"],
  "lass": ["KHB"],
  "last": ["E1G"],
  "lasting": ["I5G"],
  "lastly": ["KHC"],
  "latch": ["KHE"],
  "latch on": ["I5H"],
  "late": ["GhY","BoE","FJm","EIC"],
  "lately": ["KHF"],
  "latency": ["KHG"],
  "latent": ["I5I"],
  "later": ["I5K"],
  "lateral": ["I5J"],
  "Latin": ["I5L"],
  "Latin America": ["KHI"],
  "Latin American": ["KHH","Kop","Koq"],
  "Latina": ["Kor","Koo"],
  "Latino": ["Kos"],
  "latitude": ["HVm"],
  "latte": ["Fyr","BoH","Egp","BoI","BoJ","BoK"],
  "latter": ["I5M"],
  "lattice": ["KHJ"],
  "Latvia": ["HDa","EID"],
  "Latvian": ["HDZ","Kot"],
  "laudable": ["I5N"],
  "laugh": ["Gha","DjA","FJn","BoM","BoN","BoS"],
  "laugh at": ["I5O"],
  "laugh at a joke": ["HVn"],
  "laugh laughed": ["DjA"],
  "laugh off": ["I5P"],
  "laughing": ["GhZ","DjA","BoP","BoQ","BoO"],
  "laughter": ["Fys","BoW","BoU","BoT"],
  "launch": ["I5Q"],
  "launch pad": ["HVo"],
  "laundromat": ["Fyt","BoZ","BoY"],
  "laundry": ["Ghb","Bob","FJo","Bod","Boc","Boa"],
  "laundry room": ["Ghc","Drg","FJp"],
  "laureate": ["I5R"],
  "lava": ["Fyu","Bog","Boe","Bof"],
  "lavatory": ["KHK"],
  "lavender": ["Fyv","Boi","Boh"],
  "lavish": ["I5S"],
  "law": ["E1H"],
  "lawful": ["KHL"],
  "lawmaker": ["KHM"],
  "lawn": ["Fyx","Bou","Bok","Bon","Bol"],
  "lawn mower": ["Fyw","DGC","Bop","Boq","Bot","Boo"],
  "lawsuit": ["I5T"],
  "lawyer": ["Ghd","DGE","FJq","Bow","Bov","DGD","Boy","EIF","Box","EIE"],
  "lawyer up": ["I5U"],
  "lax": ["I5V"],
  "lay": ["Fy2","EYN","DjB","ES3"],
  "lay down": ["ES3"],
  "lay eggs": ["Fyy","DjB","EYN"],
  "lay laid": ["DjB"],
  "lay off": ["I5W"],
  "lay on": ["I5X"],
  "lay out": ["Ea7","DjC"],
  "lay out a table": ["Fy1","DjC"],
  "lay out laid out": ["DjC"],
  "lay out the table": ["Ea7"],
  "lay the table": ["Fy3"],
  "lay up": ["I5Y"],
  "layer": ["E1I"],
  "layers": ["Fyz","Boz"],
  "laying": ["DjB"],
  "laying eggs": ["DjB"],
  "laying out": ["Ea7","DjC"],
  "laying out a table": ["Fy0","DjC"],
  "layoff": ["KHN"],
  "layout": ["HVp"],
  "lazy": ["Ghe","Bo0","FJr","Bo3","Bo2","Bo1"],
  "leach": ["I5Z"],
  "lead": ["HVq"],
  "lead the way": ["I5b"],
  "lead to": ["I5c"],
  "lead up to": ["I5d"],
  "leader": ["KHO"],
  "leader of the opposition": ["I5a"],
  "leadership": ["KHP"],
  "leaf": ["Ghf","DGF","FJs","Bo4","Bo6","D2O","Bo5","Bo7"],
  "leaflet": ["KHQ"],
  "league": ["I5e"],
  "leak": ["I5f"],
  "lean": ["I5i"],
  "lean back": ["I5g"],
  "lean on": ["I5h"],
  "Leaning Tower of Pisa": ["HVr"],
  "leap": ["I5j"],
  "learn": ["Ghh","DjE","EYO","DjD","Bo9","Bo8"],
  "learn a language": ["HVs"],
  "learn by heart": ["I5k"],
  "Learn English": ["HVt"],
  "learn Japanese": ["Fy5","EYO","DjD"],
  "learn learned": ["DjD","ET8"],
  "learn learnt": ["Fy6","DjE"],
  "learn maths": ["DjE"],
  "learn something by heart": ["I5l"],
  "learn to drive": ["EIG"],
  "learned": ["ET8"],
  "learned maths": ["ET8"],
  "learner": ["KHR"],
  "learning": ["Ghg","DjE","DjD"],
  "learning Japanese": ["Fy4","DjD"],
  "learning maths": ["DjE"],
  "lease": ["I5m"],
  "leash": ["BpC"],
  "least": ["I5n"],
  "leather": ["Ghi","BpE","FJt","BpF"],
  "leave": ["Ghj","DjF","FJu","DjH","Ea8","EYP","DjG"],
  "leave aside": ["I5o"],
  "leave left": ["Fy7","ES4","DjF","DjH","DjG"],
  "leave off": ["I5p"],
  "leave out": ["I5q"],
  "leave school": ["Fy8","DjG","EIH"],
  "leave work": ["Fy9","DjH","EYP"],
  "leaves": ["Ghk","BpK","FJv","BpG","BpJ","BpI","BpH"],
  "leaving": ["FzA","DjF","Ea8","DjG","DjH"],
  "leaving school": ["DjG"],
  "leaving work": ["DjH"],
  "lecture": ["I5r"],
  "lecturer": ["BpM"],
  "ledge": ["I5s"],
  "ledger": ["KHS"],
  "leek": ["FzB","BpN","BpO"],
  "left": ["Ghl","ES4"],
  "left wing": ["HVu"],
  "leftover": ["I5t"],
  "leg": ["Gho","DGH","FJx","D2P","BpU","BpP"],
  "legacy": ["I5u"],
  "legal": ["I5v"],
  "legalize": ["KHT"],
  "legally": ["KHU"],
  "legend": ["HVv"],
  "legendary": ["KHV"],
  "leggings": ["Ghm","DGG"],
  "legible": ["I5w"],
  "legion": ["KHW"],
  "legislate": ["I5x"],
  "legislation": ["KHX"],
  "legislative": ["I5y"],
  "legislator": ["KHY"],
  "legislature": ["I5z"],
  "legitimacy": ["KHZ"],
  "legitimate": ["I50"],
  "lego": ["Ghn","BpT","FJw","BpQ","BpS","BpR"],
  "legs": ["Ghp","DGJ","FJy","DGI","BpX","BpW","BpV"],
  "leisure": ["I51"],
  "leisurely": ["KHa"],
  "lemma": ["KHb"],
  "lemon": ["Ghr","DGL","FJ0","BpZ","D2R","Bpa","Bpg","BpY"],
  "lemon juice": ["FzC","Bpe"],
  "lemon tea": ["FzD","Bpn","DGN","Bpm"],
  "lemonade": ["Ghq","DGK","FJz","Bpc","Bpd","D2Q","Bpb"],
  "lemons": ["Ghs","DGM","Bpl","Bpk","Egq","Bpj"],
  "lend": ["Ght","Bpq","EYQ","Bpr"],
  "lend a book": ["DjI","EYQ"],
  "lend lent": ["DjI"],
  "lender": ["KHc"],
  "lending a book": ["DjI"],
  "length": ["FzE","Bps"],
  "lengthen": ["I52"],
  "lengthy": ["KHd"],
  "lenient": ["I53"],
  "lens": ["HVw"],
  "lentil": ["I54"],
  "lentils": ["FzF","Bpx","Bpv","Bpw","Bpt","Bpu"],
  "Leo": ["HVx"],
  "Leonardo da Vinci": ["KHe"],
  "leopard": ["Ghu","Bp2","FJ1","Bpy","Bpz","Bp1","Bp0"],
  "lesbian": ["KHf"],
  "lesion": ["KHg"],
  "less": ["HVy"],
  "lessen": ["I55"],
  "lesser": ["KHh"],
  "lesson": ["FzG"],
  "lest": ["KHi"],
  "let": ["I6C"],
  "let alone": ["I56"],
  "let down": ["HVz"],
  "let go": ["FzH","Drh"],
  "let go of": ["I57"],
  "let in": ["I6A","HV0"],
  "let into": ["I6A"],
  "let me see": ["HV1"],
  "let me think": ["HV2"],
  "let off": ["HV3"],
  "let on": ["I6B"],
  "let out": ["HV4"],
  "let through": ["I6D"],
  "let up": ["I6E"],
  "let's eat": ["HV5"],
  "let's go": ["HV6"],
  "let's play": ["HV7"],
  "let's start": ["HV8"],
  "let's try": ["HV9"],
  "lethal": ["I58"],
  "lethargy": ["I59"],
  "letter": ["Gh1","DGO","FJ2","D2S"],
  "letter a": ["Ghv","DZm"],
  "letter b": ["Ghw","DZo"],
  "letter c": ["Ghx","DZq"],
  "letter d": ["Ghy","DZs"],
  "letter e": ["Ghz","DZu"],
  "letter f": ["FzI","DZw"],
  "letter g": ["Gh0","DZy"],
  "letter h": ["FzJ","DZ0"],
  "letter i": ["FzK","DZ2"],
  "letter j": ["FzL","DZ4"],
  "letter k": ["FzM","DZ6"],
  "letter l": ["FzN","DZ8"],
  "letter m": ["FzO","DaA"],
  "letter n": ["FzP","DaC"],
  "letter o": ["FzQ","DaE"],
  "letter p": ["FzR","DaG"],
  "letter q": ["FzS","DaI"],
  "letter r": ["FzT","DaK"],
  "letter s": ["FzU","DaM"],
  "letter t": ["FzV","DaO"],
  "letter u": ["FzW","DaQ"],
  "letter v": ["FzX","DaS"],
  "letter w": ["FzY","DaU"],
  "letter x": ["FzZ","DaW"],
  "letter y": ["Fza","DaY"],
  "letter z": ["Fzb","Daa"],
  "letters": ["Gh2","Bp5","Bp6","Bp4"],
  "lettuce": ["Gh3","Bp9","FJ3","DGP","BqA","D2T","Bp7","Bp8"],
  "leukemia": ["KHj"],
  "Levant": ["KHl"],
  "Levantine": ["KHk"],
  "level": ["Fzc","BqB"],
  "level out": ["I6F"],
  "level up": ["I6G"],
  "level with": ["I6H"],
  "lever": ["HWA"],
  "leverage": ["KHm"],
  "levy": ["I6I"],
  "lexical": ["KHn"],
  "lexicon": ["KHo"],
  "li": ["KIA"],
  "liability": ["KHp"],
  "liable": ["I6J"],
  "liaison": ["KHq"],
  "liar": ["KHr"],
  "libel": ["I6K"],
  "liberal": ["HWB"],
  "liberalism": ["KHs"],
  "liberalization": ["KHt"],
  "liberalize": ["KHu"],
  "liberate": ["I6L"],
  "liberation": ["KHv"],
  "libertarian": ["KHw"],
  "liberty": ["I6M"],
  "Libra": ["HWC"],
  "librarian": ["Gh4","BqC","FJ4"],
  "library": ["Gh5","Fzd","DGQ","FJ5","BqF","BqD","BqE"],
  "Libya": ["HDc","EII"],
  "Libyan": ["HDb","Kou"],
  "licence": ["Fze","BqG"],
  "license": ["Fzf","BqG"],
  "lichen": ["I6N"],
  "lick": ["Gh6","BqH","BqI"],
  "lid": ["Gh7","BqN","FJ6","BqM"],
  "lie": ["KHx","Gh9","BqP","FJ7","BqO"],
  "lie down": ["Gh8","DjJ","EYR","DjK","EbC"],
  "lie down lay down": ["DjK"],
  "lie down on the sofa": ["EYR"],
  "lie in": ["I6O"],
  "lie lay": ["DjJ","ES3"],
  "lie on the bed": ["HWD"],
  "lieutenant": ["I6P"],
  "life": ["I6Q"],
  "life cycle": ["HWE"],
  "life jacket": ["GiB","Bqa","BqZ"],
  "life science": ["HWF"],
  "life sentence": ["I6R"],
  "lifebelt": ["BqS"],
  "lifeboat": ["Fzg","BqV","BqU"],
  "lifeguard": ["GiA","DGS","FJ8","EIL","BqY","BqW","BqX"],
  "lifelong": ["KHy"],
  "lifespan": ["I6S"],
  "lifestyle": ["E1J"],
  "lifetime": ["KHz"],
  "lift": ["HWH","GiC","Bqc","FJ9","DjL","DjM","Ea9","EYS"],
  "lift a box": ["HWG"],
  "lift lifted": ["ES5","DjL","DjM"],
  "lift up": ["I6T"],
  "lift weights": ["Fzh","EYS","Ea9","DjM"],
  "lift weights easily": ["ERH"],
  "lifted": ["ES5"],
  "lifted weights": ["ES5"],
  "lifting": ["Ea9","DjL","DjM"],
  "lifting weights": ["Ea9","DjM"],
  "ligand": ["KH0"],
  "light": ["GiG","Bqh","FKB","DGc","Bqi","EIO","Bqg","DjN","Bqv","D2Y"],
  "light a candle": ["DjN"],
  "light blue": ["Fzi","DGT"],
  "light brown": ["DGU"],
  "light bulb": ["GiD","DGV","D2U","Bqk","Bqj"],
  "light bulbs": ["Fzj","Bql","Bqm"],
  "light green": ["Fzl","DGY"],
  "light lighted": ["ETb","DjN"],
  "light rain": ["HWJ"],
  "light red": ["DGd"],
  "light speed": ["HWK"],
  "light up": ["I6X"],
  "light year": ["HWL"],
  "lighted": ["ETb"],
  "lighted a candle": ["ETb"],
  "lighten": ["KH1"],
  "lighten up": ["I6U"],
  "lighter": ["Fzk","DGW","DGX","D2V"],
  "lighthearted": ["I6V"],
  "lighthouse": ["GiE","DGZ","Bqp","Bqr","D2W","Bqo","Bqq"],
  "Lighthouse of Alexandria": ["HWI"],
  "lighting": ["DjN"],
  "lighting a candle": ["DjN"],
  "lightly": ["I6W"],
  "lightning": ["GiF","Bqu","FKA","DGb","Bqs","Bqt","D2X","DGa"],
  "lights": ["GiH","Bqy","FKC","Bqz","Bqx","Bqw"],
  "lightweight": ["KH2"],
  "lightyear": ["HWM"],
  "like": ["GiI","DjQ","FKD","Bq0","Bq1","DjO","DjP","EYT","EYU"],
  "like apples": ["Fzm","DjO","EYT"],
  "like chocolate": ["Efl"],
  "like doing exercise": ["Efm"],
  "like football": ["DjP","EYU"],
  "like giving gifts": ["Efn"],
  "like icecream": ["DjQ"],
  "like liked": ["Fzo","ET9","DjO","DjQ","DjP"],
  "like listening to music": ["Efo"],
  "like milk": ["Efp"],
  "like music": ["HWN"],
  "like pizza": ["Efq"],
  "like playing the drums": ["Efr"],
  "like reading books": ["Fzp","Efs"],
  "like surfing": ["Eft"],
  "like swimming": ["HWO"],
  "liked": ["Fzn","ET9"],
  "liked ice cream": ["ET9"],
  "likelihood": ["KH3"],
  "likely": ["I6Y"],
  "liken": ["KH4"],
  "likeness": ["I6Z"],
  "likewise": ["I6a"],
  "liking": ["DjQ","DjO","DjP"],
  "lily": ["GiJ","Bq3","Bq4","Bq2"],
  "limb": ["I6b"],
  "lime": ["GiK","Bq6","FKE","DGe","D2Z","Bq7","BrB","Bq5","Egr"],
  "lime juice": ["Bq8"],
  "limes": ["Fzq","BrC","DGf"],
  "limestone": ["I6c"],
  "Limey": ["Kov"],
  "limit": ["I6e"],
  "limitation": ["I6d"],
  "limo": ["D2a","DGg"],
  "limp": ["I6f"],
  "line": ["GiL","DGh","D2b"],
  "line up": ["GiM","Dri"],
  "lineage": ["Fzr"],
  "linear": ["I6g"],
  "linebacker": ["KH5"],
  "linen": ["I6h"],
  "liner": ["KH6"],
  "lines": ["E1K"],
  "lineup": ["KH7"],
  "linger": ["I6i"],
  "linguist": ["I6k"],
  "linguistic": ["I6j"],
  "linguistics": ["KH8"],
  "lining": ["I6l"],
  "link": ["Fzs","BrE"],
  "linkage": ["KH9"],
  "lion": ["GiN","DGi","FKF","D2c","BrJ","BrH","BrF","BrI","BrG"],
  "lions": ["GiO","BrL","BrK","BrN","BrM"],
  "lip": ["GiP","Drj","FKG"],
  "lip stick": ["DGj"],
  "lipid": ["I6m"],
  "lips": ["GiQ","BrS","FKH","BrO","BrR","BrQ","BrP"],
  "lipstick": ["GiR","BrW","BrU","D2d","BrT","BrV"],
  "liquefy": ["I6n"],
  "liquid": ["GiS","BrZ","FKI","BrX","BrY"],
  "liquidate": ["KIB"],
  "liquidation": ["KIC"],
  "liquidity": ["KID"],
  "liquor": ["KIE"],
  "Lisbon": ["G8X"],
  "list": ["GiX","Drl"],
  "listen": ["GiV","DjS","FKK","DjR","Brb","EYV","EdY","EIP","Bra","Brd"],
  "listen carefully": ["ERI"],
  "listen in class": ["HWP"],
  "listen in on": ["I6o"],
  "listen listened": ["Fzv","DjR","EWM","DjS"],
  "listen to": ["Fzw","Drk"],
  "listen to a story": ["HWQ"],
  "listen to me": ["HWR"],
  "listen to music": ["GiW","DjS","FKL","Brf","EYV","EdY","Bre","Brg"],
  "listen to people's problems": ["EIQ"],
  "listen to the radio": ["Fzx"],
  "listen to the teacher": ["HWS"],
  "listen up": ["HWT"],
  "listened": ["Fzt","EWM"],
  "listened to music": ["Fzu","EWM"],
  "listener": ["KIF"],
  "listening": ["GiT","DjS","DjR","EdY"],
  "listening to music": ["GiU","DjS","FKJ","Brc","EdY"],
  "listless": ["I6p"],
  "liter": ["HWU"],
  "literacy": ["I6q"],
  "literal": ["KIH"],
  "literally": ["KIG"],
  "literary": ["I6r"],
  "literate": ["KII"],
  "literature": ["GiY","Bri","Brk","Brh","Brj"],
  "lithosphere": ["I6s"],
  "Lithuania": ["Fzy","Bro"],
  "Lithuanian": ["HDd","Kow"],
  "litigation": ["KIJ"],
  "litre": ["HWV"],
  "litter": ["GiZ","Brp","FKM","Brs","Brq","Brr"],
  "little": ["Gia","EIS","FKN"],
  "little brother": ["Fzz","Brt"],
  "little by little": ["I6t"],
  "Little Dipper": ["HWW"],
  "little sister": ["Fz0","Bru"],
  "live": ["Gib","DjT","FKO","EYW"],
  "live in London": ["Fz1","DjT","EYW"],
  "live lived": ["Fz2","EVt","DjT"],
  "live off": ["I6v"],
  "live on": ["I6w"],
  "live up to": ["I6y"],
  "lived": ["EVt"],
  "lived in London": ["EVt"],
  "livelihood": ["I6u"],
  "lively": ["E1L"],
  "liver": ["Gic","Brv","Brw"],
  "Liverpool": ["G8Y","Drm"],
  "livestock": ["I6x"],
  "living": ["DjT"],
  "living in London": ["DjT"],
  "living room": ["Gid","DGk","FKP","Brx","Br0","Brz","Br1","Bry","Br2"],
  "living thing": ["HWX"],
  "lizard": ["Gie","DGl","FKQ","Br5","Br7","D2e","Br3","Br6","Br4"],
  "llama": ["Fz3","Drn"],
  "load": ["HWY"],
  "loaf": ["Gif","Dro"],
  "loaf of bread": ["Fz4","Br8","BsA","Br9","BsB"],
  "loan": ["HWZ"],
  "loath": ["I6z"],
  "loathe": ["KIK"],
  "loathsome": ["I60"],
  "loaves": ["Fz5","BsF","BsD"],
  "lobby": ["Fz6","BsI"],
  "lobbyist": ["KIL"],
  "lobe": ["KIM"],
  "lobster": ["Gig","DGm","FKR","BsP","BsK","D2f","BsL","BsM","BsO"],
  "local": ["HWb"],
  "Local": ["Koy","Kox"],
  "local government": ["HWa"],
  "locale": ["I61"],
  "locality": ["I62"],
  "localization": ["KIN"],
  "localize": ["KIO"],
  "locally": ["KIP"],
  "locate": ["I63"],
  "location": ["E1M"],
  "Loch": ["KIR"],
  "Loch Ness": ["KIQ"],
  "lock": ["Gii","BsR","FKS","DjV","Bsb","EYX","DjU","BsQ","BsS","EbA"],
  "lock a door": ["DjU"],
  "lock in": ["I64"],
  "lock locked": ["DjV","ETc","DjU"],
  "lock the door": ["EbA","EYX","DjV"],
  "lock up": ["I65"],
  "locked": ["ETc"],
  "locked the door": ["ETc"],
  "locker": ["Gih","BsT","BsV","BsW","BsU"],
  "lockers": ["DGn"],
  "locket": ["BsY"],
  "locking": ["EbA","DjV","DjU"],
  "locking a door": ["DjU"],
  "locking the door": ["EbA","DjV"],
  "locomotion": ["I66"],
  "locomotive": ["I67"],
  "locus": ["KIS"],
  "locust": ["Bsc"],
  "lodge": ["Bse"],
  "loft": ["KIT"],
  "lofty": ["I68"],
  "log": ["Gij","Bsh","FKT","Bsg"],
  "log in": ["I7A","HWc","G8Z"],
  "log off": ["I7C"],
  "log offlog out": ["I7B"],
  "log on": ["I7D"],
  "log out": ["HWd","G8a"],
  "logic": ["KIV"],
  "logical": ["I69"],
  "logically": ["KIU"],
  "logistic": ["KIW"],
  "logo": ["Drp"],
  "logs": ["Bsj","Bsi"],
  "lollipop": ["Gik","Bsn","FKU","D2h","Bso","Bsk","Bsl","Bsm"],
  "lollipops": ["Fz7","Drq"],
  "London": ["Fz8","Drr"],
  "Londoner": ["Ko1","Koz","Ko0"],
  "lone": ["I7E"],
  "loneliness": ["KIX"],
  "lonely": ["Gil","Bss","FKV","Bsp","Bsr"],
  "long": ["Gio","DGr","Bsy","Ehn","EIT","Eho"],
  "long for": ["I7G"],
  "long hair": ["Gin","Bsu","FKW","Bsw","Bst","Ehn","Eho","Bsv"],
  "long jump": ["Fz9","DGq","D2i"],
  "long neck": ["Bsx"],
  "long term": ["I7J"],
  "long time no see": ["HWf"],
  "long to": ["I7H"],
  "longer": ["Gim","DGp","DGo"],
  "longevity": ["I7F"],
  "longing": ["I7I"],
  "longitude": ["HWe"],
  "longitudinal": ["KIY"],
  "longtime": ["KIZ"],
  "loo": ["KIc"],
  "look": ["Gir","DjX","FKY","Dja","EYZ","EYY","Bsz"],
  "look after": ["Gip","DjW","FKX","Bs0","EcQ"],
  "look after animals": ["EIU"],
  "look after children": ["EcQ"],
  "look after looked after": ["DjW"],
  "look after passengers": ["EIW"],
  "look after sick people": ["EIY"],
  "look after the baby": ["F0A"],
  "look ahead": ["I7K"],
  "look around": ["HWg"],
  "look at": ["Giq","DjZ","EIa","DjY","Bs2","Bs1","EdZ","EbB"],
  "look at a clock": ["F0B","DjY"],
  "look at a picture": ["EIZ"],
  "look at art": ["EYY"],
  "look at each other": ["EdZ","DjZ"],
  "look at looked at": ["DjX"],
  "look at pictures": ["F0C","DjX"],
  "look at the clock": ["EbB"],
  "look away": ["HWh"],
  "look back": ["HWi"],
  "look back on": ["I7L"],
  "look behind": ["HWj"],
  "look closely": ["ERJ"],
  "look down on": ["HWk"],
  "look for": ["F0D","E1N"],
  "look forward to": ["HWl"],
  "look happy": ["HWm"],
  "look here": ["HWn"],
  "look in on": ["I7M"],
  "look in the mirror": ["EYZ","Dja"],
  "look into": ["HWo"],
  "look like": ["HWp"],
  "look looked": ["F0F","Dja","DjZ","EU5","DjY"],
  "look on": ["I7O"],
  "look on a as b": ["I7N"],
  "look out": ["I7P","HWq"],
  "look out onto": ["I7Q"],
  "look over": ["I7R"],
  "look sad": ["HWr"],
  "look through": ["F0G","Djb"],
  "look through a telescope": ["Djb"],
  "look to a for b": ["I7S"],
  "look up": ["E1O"],
  "look up to": ["HWs"],
  "looked": ["EU5"],
  "looked at each other": ["EU5"],
  "looking": ["F0E","DjX","Dja"],
  "looking after": ["DjW","EcQ"],
  "looking at": ["EdZ","EbB","DjY","DjZ"],
  "looking at a clock": ["DjY"],
  "looking at each other": ["DjZ","EdZ"],
  "looking at pictures": ["DjX"],
  "looking in the mirror": ["Dja"],
  "looking through": ["Djb"],
  "looking through a telescope": ["Djb"],
  "lookout": ["KIa"],
  "loom": ["I7T"],
  "loop": ["I7U"],
  "loophole": ["KIb"],
  "loose": ["I7W"],
  "loosely": ["KId"],
  "loosen": ["KIe"],
  "loosen up": ["I7V"],
  "loot": ["KIf"],
  "lope": ["I7X"],
  "lord": ["I7Y"],
  "lordship": ["KIg"],
  "lore": ["I7Z"],
  "lorry": ["Gis","Bs9","FKZ","Bs8","Bs7","Bs6","Bs5"],
  "Los Angeles": ["G8b"],
  "lose": ["Git","Djc"],
  "lose a game": ["HWt"],
  "lose a wallet": ["HWu"],
  "lose control of": ["I7a"],
  "lose lost": ["F0H","EVX","Djc","ES6"],
  "lose one's head": ["I7b"],
  "lose one's temper": ["I7c"],
  "lose out": ["I7d"],
  "lose the game": ["F0I","Djc"],
  "lose track of": ["I7e"],
  "loser": ["KIh"],
  "losing": ["F0J","Djc"],
  "losing the game": ["Djc"],
  "loss": ["HWv"],
  "lost": ["F0K","ES6","EVX"],
  "lost and found": ["I7f"],
  "lost property": ["HWw"],
  "lost the game": ["EVX","ES6"],
  "lot": ["I7g"],
  "lotion": ["KIi"],
  "lottery": ["HWx"],
  "lotus": ["F0L","BtA"],
  "loud": ["Giu","DGs","FKa","BtC","BtE","BtF","BtD"],
  "loudly": ["F0M","E1P"],
  "loudspeaker": ["KIj"],
  "lounge": ["I7h"],
  "lousy": ["KIk"],
  "love": ["KIl","Giw","F0P","Djd","FKb","BtI","EYa","BtH","BtG","BtJ"],
  "love cats": ["EYa"],
  "love loved": ["F0O","Djd"],
  "love the cat": ["Djd"],
  "loved": ["F0N"],
  "lovely": ["Giv","Drs"],
  "lover": ["KIm"],
  "loving": ["F0Q","Djd"],
  "lovingly": ["KIn"],
  "low": ["F0S","E1Q"],
  "low pressure": ["HWy"],
  "lower": ["F0R","DGt","ER4"],
  "lowercase": ["G8c"],
  "lowland": ["KIo"],
  "loyal": ["F0T","BtK"],
  "loyalist": ["KIp"],
  "loyalty": ["KIq"],
  "lubricant": ["I7i"],
  "luck": ["Giy","BtL"],
  "luck into": ["I7j"],
  "luckily": ["KIr"],
  "lucky": ["Gi0","BtM"],
  "lucky money": ["Giz","Drt"],
  "lucrative": ["I7k"],
  "ludicrous": ["KIs"],
  "luge": ["HWz"],
  "luggage": ["Gi1","DGu","FKd","BtS","BtN","BtR","D2j","BtO","BtP","BtQ"],
  "lull": ["KIt"],
  "lumber": ["I7l"],
  "lumberjack": ["F0V","DGw","EIb","D2k"],
  "luminosity": ["I7m"],
  "luminous": ["I7n"],
  "lump": ["I7o"],
  "lunar": ["HW3"],
  "lunar eclipse": ["HW0"],
  "lunar lander": ["HW1"],
  "lunar module": ["HW2"],
  "lunatic": ["KIu"],
  "lunch": ["Gi4","BtW","FKh","BtT"],
  "lunch box": ["Gi2","BtU","FKf","FKe","BtV"],
  "lunch is ready": ["HW4"],
  "lunchbox": ["Gi3","Dru","FKg"],
  "luncheon": ["KIv"],
  "lunchtime": ["KIw"],
  "lung": ["HW5"],
  "lunge": ["I7p"],
  "lungs": ["Gi5","BtX","FKi","BtZ","BtY"],
  "lurch": ["KIx"],
  "lure": ["I7q"],
  "lurk": ["KIy"],
  "lush": ["I7r"],
  "lust": ["I7t"],
  "luster": ["I7s"],
  "Luxembourg": ["F0X","Btc","Bta"],
  "Luxembourger": ["HDf","Ko2"],
  "Luxembourgish": ["HDg"],
  "luxurious": ["I7u"],
  "luxury": ["F0Y","Btf"],
  "luxury goods": ["I7v"],
  "lychee": ["Gi6","Bth","Bti","Btj","Btg"],
  "lying down": ["DjJ","DjK","EbC"],
  "lymphocyte": ["KIz"],
  "lyric": ["E1S","E1R"],
  "lyrical": ["KI0"],
  "lyrics": ["HW6"],
  "M": ["Gk9","F2B","DZ9","HDx"],
  "m": ["FLw","HDh"],
  "ma": ["KJb"],
  "Maasai": ["Ko3"],
  "machine": ["Gi7","Btn","FKj","Btl","Btm","Btk"],
  "machinery": ["HW7"],
  "macho": ["KI1"],
  "machu picchu": ["F0Z","Bto"],
  "macro": ["KI3"],
  "macroeconomic": ["KI2"],
  "mad": ["Gi8","Btt","FKk","Btp"],
  "mad as hell": ["EIe","EIf","EIg"],
  "Madagascar": ["HDi","F0a","Bts","Btr","Btq"],
  "madam": ["KI4"],
  "made": ["F0c","EVa","EVZ","ES7","EWI"],
  "made a sandwich": ["F0b","EVZ"],
  "made a snowman": ["EWI"],
  "made a speech": ["EVa"],
  "made coffee": ["ES7"],
  "made from": ["HW8"],
  "madness": ["KI5"],
  "Madrid": ["G8d"],
  "magazine": ["Gi9","Btx","FKl","Btu","Btw","Btv"],
  "magazines": ["F0d","Bty"],
  "Magellan": ["KI6"],
  "magenta": ["F0e","DGx"],
  "Maghreb": ["KI8"],
  "Maghrebi": ["KI7"],
  "magic": ["GjB","Bt5","FKn","Btz","Bt0"],
  "magic show": ["E1T"],
  "magical": ["I7w"],
  "magician": ["GjA","DGz","FKm","DGy","Bt4","EIh","Bt3"],
  "magistrate": ["KI9"],
  "maglev": ["I7x"],
  "magma": ["I7y"],
  "magnesium": ["HW9"],
  "magnet": ["GjC","DG0","FKo","Bt6","Bt9","Bt8","D2l","Bt7"],
  "magnetic": ["HXA"],
  "magnetism": ["HXB"],
  "magnetosphere": ["HXC"],
  "magnets": ["HXD"],
  "magnification": ["KJA"],
  "magnificent": ["I7z"],
  "magnify": ["I70"],
  "magnifying glass": ["GjD","BuA","BuB","BuC","BuE","BuF","BuD"],
  "magnitude": ["I71"],
  "mahjong": ["BuI","BuH"],
  "mahogany": ["KJB"],
  "maid": ["F0f","DG2","BuJ","DG1","BuL","BuK"],
  "maiden": ["KJC"],
  "mail": ["GjH","BuM","FKq","BuU","BuN"],
  "mail carrier": ["GjF","Drv","FKp"],
  "mailbox": ["GjE","BuO","BuR","BuS","BuP","BuQ"],
  "mailman": ["GjG","DG4","D2m","EIm"],
  "main": ["I72"],
  "main course": ["GjI","Drw"],
  "mainframe": ["KJD"],
  "mainland": ["KJE"],
  "mainly": ["KJF"],
  "mainstream": ["I73"],
  "maintain": ["E1U"],
  "maintain a building": ["EIn"],
  "maintenance": ["HXE"],
  "maize": ["F0g","BuX","BuV"],
  "majestic": ["I74"],
  "majesty": ["I75"],
  "major": ["I76"],
  "majority": ["Drx"],
  "make": ["GjO","Djj","FKt","Dje","Djf","EbE","EbD","Dji","EYb","Djh","EYd","Djg"],
  "make a cake": ["GjJ","Dry"],
  "make a campfire": ["F0h"],
  "make a concerted effort": ["I77"],
  "make a difference": ["I78"],
  "make a mistake": ["HXF"],
  "make a model": ["F0i","Dje"],
  "make a model plane": ["EYb"],
  "make a name for yourself": ["I79"],
  "make a phone call": ["HXG"],
  "make a point of": ["I8A"],
  "make a sandcastle": ["F0j","E1V"],
  "make a sandwich": ["GjK","Djf","EbD"],
  "make a snack": ["F0k"],
  "make a snowman": ["GjL","Drz","FKr"],
  "make a speech": ["F0l","Djg"],
  "make a web": ["Djh","EYd"],
  "make a website": ["EIq"],
  "make believe": ["I8B"],
  "make bread": ["EIr"],
  "make breakfast": ["F0m"],
  "make clothes": ["EIs"],
  "make coffee": ["F0n","Dji","EbE"],
  "make computer software": ["EIu"],
  "make dinner": ["HXH"],
  "make do": ["I8C"],
  "make drinks": ["EIv"],
  "make faces": ["I8D"],
  "make friends": ["F0o","Dr0"],
  "make friends with": ["I8E"],
  "make fun of": ["I8F"],
  "make made": ["GjM","Dje","EWI","EVZ","Djf","Djh","Dji","Djj","EVa","ES7"],
  "make models": ["F0p","E1W"],
  "make music": ["EIw"],
  "make my bed": ["GjN","Dr1","FKs","Dr2"],
  "make noise": ["HXI"],
  "make of": ["I8H"],
  "make off": ["I8G"],
  "make one's way": ["I8J"],
  "make oneself at home": ["I8I"],
  "make out": ["I8K"],
  "make room for": ["I8L"],
  "make sense": ["I8M"],
  "make snacks": ["F0q"],
  "make some food": ["F0r","Djj"],
  "make sure": ["HXJ"],
  "make the bed": ["GjP","E1X"],
  "make the most of": ["I8N"],
  "make things": ["F0s"],
  "make things with wood": ["EIx"],
  "make up": ["F0t","E1Y"],
  "make up for": ["HXK"],
  "make up one's mind": ["I8O"],
  "make up with": ["I8P"],
  "make use of": ["I8Q"],
  "make videos": ["F0u"],
  "make websites": ["EIy"],
  "maker": ["KJG"],
  "makeshift": ["KJH"],
  "makeup": ["KJI"],
  "making": ["F0y","EbD","Djj","Dje","EbE","Djf","Djg","Djh","Dji"],
  "making a model": ["Dje"],
  "making a sandwich": ["Djf","EbD"],
  "making a speech": ["Djg"],
  "making a web": ["Djh"],
  "making cards": ["F0v"],
  "making coffee": ["EbE","Dji"],
  "making headlines": ["I8R"],
  "making jewelry": ["F0w"],
  "making models": ["F0x"],
  "making pottery": ["F0z"],
  "making some food": ["Djj"],
  "Malagasy": ["HDj","Ko4"],
  "malaria": ["KJJ"],
  "Malaysia": ["HDl","GjQ","Bua","FKu","BuY","BuZ","EIz"],
  "Malaysia flag": ["F00","DG5"],
  "Malaysian": ["HDk","Ko5"],
  "Maldives": ["KJK"],
  "male": ["I8S"],
  "Mali": ["HDn","EI0"],
  "Malian": ["HDm","Ko6","G8e"],
  "malice": ["I8T"],
  "malicious": ["I8U"],
  "malignant": ["KJL"],
  "mall": ["GjR","Bub","FKv","Buc","Bui","Bue","Bud"],
  "malleable": ["I8V"],
  "mallet": ["Buh","Buf","Bug"],
  "malnutrition": ["I8W"],
  "malt": ["KJM"],
  "maltreat": ["KJO"],
  "maltreatment": ["KJN"],
  "mama": ["F01"],
  "mammal": ["GjS","DG6"],
  "mammalian": ["KJP"],
  "mammals": ["GjT","Dr3","EI1"],
  "mammoth": ["F02","Bul","Bum","Buj","Buk"],
  "man": ["GjZ","Dr6","FKy"],
  "man up": ["I8p"],
  "manage": ["F03","Dr4"],
  "manage a hotel": ["EI2"],
  "manage a sports team": ["EI3"],
  "manageable": ["KJQ"],
  "management": ["KJR"],
  "manager": ["GjU","Dr5","FKw"],
  "managerial": ["I8X"],
  "Manchester": ["G8f"],
  "mandarin": ["I8Y"],
  "mandate": ["I8Z"],
  "mandatory": ["I8a"],
  "mandolin": ["Buq","Bun","Buo","Bup"],
  "mane": ["GjV","DG7","FKx","Bus","Bur"],
  "maneuver": ["I8b"],
  "mango": ["GjX","Buu","DG9","Buw","Buv","Bux","Egs","Buz","Buy"],
  "mangoes": ["GjW","DG8","D2n"],
  "mangosteen": ["GjY","Bu4","Bu0","Bu1","Bu3","Bu2"],
  "Manhattan": ["KJS"],
  "mania": ["I8c"],
  "manic": ["KJT"],
  "manifest": ["I8f"],
  "manifestation": ["I8d"],
  "manifesto": ["I8e"],
  "Manila": ["G8g"],
  "manipulate": ["I8g"],
  "manipulation": ["KJU"],
  "manipulator": ["KJV"],
  "mankind": ["I8h"],
  "manner": ["I8j"],
  "mannerism": ["I8i"],
  "manor": ["I8k"],
  "manpower": ["KJW"],
  "mansion": ["I8l"],
  "manslaughter": ["KJX"],
  "mantis": ["F04","Bu5","Bu8"],
  "mantle": ["I8m"],
  "manual": ["I8n"],
  "manually": ["KJY"],
  "manufacture": ["F05","BvA"],
  "manufacturer": ["I8o"],
  "manufacturing": ["HXL"],
  "manure": ["KJZ"],
  "manuscript": ["I8q"],
  "many": ["Gja","Dr7"],
  "many hands make light work": ["EI4","EI5","EI6"],
  "many thanks": ["HXM"],
  "Maori": ["Ko7"],
  "map": ["Gjb","DHA","FKz","BvD","D2o","BvC","BvB"],
  "maple": ["KJa"],
  "mar": ["I8x"],
  "marathon": ["Gjc","BvG","BvF"],
  "marble": ["Gjd","BvI","BvJ"],
  "marbles": ["Gje","BvN","FK0","BvK","BvL","BvM"],
  "march": ["F06","BvP","BvO"],
  "March": ["Gjf","Dr8","FK1"],
  "Marco Polo": ["KJc"],
  "mare": ["KJd"],
  "margin": ["I8r"],
  "marginal": ["KJg"],
  "marginalize": ["KJe"],
  "marginally": ["KJf"],
  "marigold": ["F07","BvR","BvQ"],
  "marijuana": ["KJh"],
  "marina": ["HXN"],
  "marine": ["F08","BvT"],
  "mariner": ["I8s"],
  "marital": ["KJi"],
  "maritime": ["HXO"],
  "mark": ["I8w"],
  "mark down": ["I8t"],
  "marked": ["I8u"],
  "markedly": ["KJj"],
  "marker": ["Gjg","DHB","FK2","BvV","BvW","D2p","BvU"],
  "markers": ["Gjh","BvY","FK3","BvX"],
  "market": ["HXP","Gji","BvZ","FK4","Bvb","Bvd","Bvc","Bva"],
  "market stall": ["HXQ"],
  "marketer": ["KJk"],
  "marketing": ["I8v"],
  "marketplace": ["KJl"],
  "marriage": ["F09","Bvh","Bvg","Bve"],
  "married": ["Gjj","Bvi"],
  "marrow": ["I8y"],
  "marry": ["F1A","Bvk","Bvj","Bvl"],
  "marry off": ["I8z"],
  "marry to": ["I80"],
  "mars": ["Gjl","Bvn","FK5","Bvs","Bvm"],
  "Mars rover": ["HXR"],
  "marsh": ["I82"],
  "marshal": ["I81"],
  "marshmallow": ["Gjk","Bvr","Bvp","Bvq","Bvo"],
  "martial": ["I83"],
  "martial arts": ["F1C"],
  "martian": ["Bvt"],
  "martyr": ["KJm"],
  "marvel": ["I84"],
  "marvelous": ["KJn"],
  "mascot": ["Bvv"],
  "masculine": ["I85"],
  "mash": ["I86"],
  "mashed potato": ["E1Z"],
  "mashed potatoes": ["Gjm","Bvy","Bvw","Bvx"],
  "mask": ["Gjn","Bv1","FK6","Bv2","Bv0","Bvz"],
  "mason": ["I87"],
  "mass": ["HXS"],
  "mass branding": ["I88"],
  "Massachusetts": ["KJo"],
  "massacre": ["KJp"],
  "massage": ["EYe","Djk"],
  "massage massaged": ["Djk"],
  "massage people": ["EI7"],
  "massage someone": ["EYe"],
  "massaging": ["Djk"],
  "masseuse": ["F1D","DHC"],
  "massive": ["I89"],
  "mast": ["HXT"],
  "master": ["I9B"],
  "masterpiece": ["I9A"],
  "mastery": ["KJq"],
  "mat": ["Gjt","Bv4","FK9","Bv3","BwJ"],
  "match": ["Gjp","BwD","Bv5","Bv7","Bv6"],
  "matchbox": ["Bv9"],
  "matches": ["Gjo","BwC","BwA"],
  "mate": ["I9C"],
  "material": ["HXU"],
  "materialize": ["KJr"],
  "materially": ["KJs"],
  "maternal": ["I9D"],
  "maternity": ["KJt"],
  "math": ["Gjr","F1F","BwG","FK7","BwE"],
  "math class": ["F1E"],
  "mathematical": ["KJu"],
  "mathematician": ["KJv"],
  "mathematics": ["Gjq","BwF"],
  "maths": ["Gjs","F1G","DHE","FK8","EdF","D2r","BwH","BwI"],
  "matrimony": ["I9E"],
  "matrix": ["KJw"],
  "matter": ["I9F"],
  "mattress": ["KJx"],
  "maturation": ["KJy"],
  "mature": ["F1H","BwK"],
  "maturity": ["I9G"],
  "maui": ["KJz"],
  "Mausoleum at Halicarnassus": ["HXV"],
  "maximal": ["KJ0"],
  "maximize": ["I9H"],
  "maximum": ["I9I"],
  "maximum speed": ["BwL"],
  "May": ["Gju","DsA","FLA"],
  "Maya": ["Ko8"],
  "maybe": ["G8h"],
  "mayo": ["F1J","BwN"],
  "mayonnaise": ["F1I","BwM"],
  "mayor": ["HXW","F1K","Dr9"],
  "maze": ["I9J"],
  "me neither": ["HXg"],
  "me too": ["HXr"],
  "meadow": ["KJ1"],
  "meager": ["I9K"],
  "meal": ["Gjv","BwO","FLB","BwQ","BwP"],
  "mean": ["Gjw","DsB","FLC"],
  "meaningful": ["I9L"],
  "meaningless": ["KJ2"],
  "means tested": ["I9M"],
  "meantime": ["I9N"],
  "meanwhile": ["E1a"],
  "measurable": ["KJ3"],
  "measure": ["Gjx","BwR","BwS"],
  "measure the table": ["HXX"],
  "measure up": ["I9O"],
  "measurement": ["KJ4"],
  "meat": ["Gjz","BwV","FLE","BwU","Bwb","BwT"],
  "meatball": ["F1L","BwW"],
  "meatballs": ["Gjy","BwZ","FLD","BwX","BwY","Bwa"],
  "Mecca": ["KJ5"],
  "mechanic": ["Gj0","DHI","FLF","DHF","Bwf","EJD","Bwd","Bwe","EJA","Bwc","D2s"],
  "mechanical": ["HXY"],
  "mechanical engineer": ["F1M","DHG","DHH"],
  "mechanics": ["I9P"],
  "mechanism": ["I9Q"],
  "mechanize": ["I9R"],
  "medal": ["Gj1","DHJ","Bwi","Bwh"],
  "medals": ["F1N","Bwk"],
  "media": ["F1O","DsC"],
  "media attention": ["I9S"],
  "medial": ["KJ6"],
  "median": ["KJ7"],
  "mediate": ["I9T"],
  "mediation": ["KJ8"],
  "mediator": ["KJ9"],
  "medical": ["I9U"],
  "medication": ["I9V"],
  "medicine": ["Gj2","Bwl","FLG","DHK","Bwn","Bwo","D2u","Bwm"],
  "medieval": ["I9W"],
  "mediocre": ["KKA"],
  "meditate": ["I9X"],
  "meditation": ["KKB"],
  "Mediterranean": ["KKC"],
  "Mediterranean Sea": ["KKD"],
  "medium": ["I9Y"],
  "Medusa": ["HXZ"],
  "meerkat": ["Gj3","Bws","Bwq","Bwp"],
  "meet": ["Gj6","Djl","FLH","Eda"],
  "meet a friend": ["HXa"],
  "meet each": ["Eda"],
  "meet each other": ["Eda"],
  "meet friends": ["Gj4","DsD"],
  "meet met": ["F1P","Djl","EU6"],
  "meet someone": ["F1Q","Djl"],
  "meet up": ["I9Z"],
  "meet with": ["I9a"],
  "meeting": ["Gj5","Bwu","Bwt","Bwv","Djl","Eda"],
  "meeting room": ["Bwy"],
  "meeting someone": ["Djl"],
  "meiosis": ["KKE"],
  "meiotic": ["KKF"],
  "Mekong": ["KKG"],
  "Mekong River": ["KKH"],
  "melancholy": ["F1R","Bw1"],
  "Melanesia": ["KKJ"],
  "Melanesian": ["KKI"],
  "melanin": ["I9b"],
  "Melbourne": ["KKK"],
  "mellow": ["I9c"],
  "melodic": ["I9d"],
  "melodious": ["I9e"],
  "melodrama": ["I9f"],
  "melody": ["HXb"],
  "melon": ["Gj7","Bw4","FLI","Bw6","Bw5","Bw7"],
  "melt": ["Gj8","BxA","FLJ","Bw8","Bw9"],
  "melt down": ["I9g"],
  "melting": ["HXc"],
  "member": ["I9i"],
  "member of parliament": ["I9h"],
  "membership": ["KKL"],
  "membrane": ["I9j"],
  "memo": ["I9k"],
  "memoir": ["KKM"],
  "memorable": ["I9l"],
  "memorandum": ["KKN"],
  "memorial": ["HXd"],
  "memorise": ["HXe"],
  "memorize": ["HXf"],
  "memory": ["F1S","BxB"],
  "memory stick": ["Gj9","DsE"],
  "men": ["F1U","E1b"],
  "menace": ["KKO"],
  "mend": ["F1T","BxC"],
  "mental": ["F1V","BxD"],
  "mental health": ["HXh"],
  "mentality": ["KKP"],
  "mentally": ["KKQ"],
  "mention": ["I9m"],
  "mentor": ["I9n"],
  "menu": ["GkA","DsF"],
  "meow": ["F1W","E1c"],
  "mercantile": ["I9o"],
  "merchandise": ["I9p"],
  "merchant": ["I9q"],
  "mercury": ["GkB","DsH"],
  "mercy": ["I9r"],
  "mere": ["I9s"],
  "merely": ["KKR"],
  "merge": ["I9t"],
  "merger": ["KKS"],
  "meridian": ["I9u"],
  "merit": ["I9v"],
  "mermaid": ["GkC","BxF","BxH","DHL","BxG","BxE"],
  "merry": ["I9w"],
  "Merry Christmas": ["HXi"],
  "merry go round": ["GkD","DsI"],
  "mesh": ["KKT"],
  "mesmerize": ["I9x"],
  "Mesoamerica": ["KKV"],
  "Mesoamerican": ["KKU"],
  "mesolithic": ["I9y"],
  "mess": ["GkF","DsK"],
  "mess around": ["I9z"],
  "mess up": ["I91"],
  "message": ["GkE","DsJ","FLK"],
  "messages": ["F1X","DHM"],
  "messenger": ["I90"],
  "messier": ["ER5","DHN"],
  "messily": ["ERG"],
  "messy": ["GkG","BxK","FLL","DHO","EJE","Ehp","BxI"],
  "messy bathroom": ["Ehp"],
  "met": ["F1Z","EU6"],
  "metabolic": ["I92"],
  "metabolism": ["I93"],
  "metal": ["GkH","BxL","FLM","BxP","BxN","BxM"],
  "metal detector": ["BxO"],
  "metallic": ["I94"],
  "metalloid": ["HXj"],
  "metamorphosis": ["HXk"],
  "metaphase": ["KKW"],
  "metaphor": ["I95"],
  "meteor": ["F1Y","BxS","BxQ","BxR"],
  "meteor shower": ["HXo"],
  "meteorite": ["HXl"],
  "meteoroid": ["HXm"],
  "meteorological": ["I96"],
  "meteorologist": ["HXn"],
  "meteorology": ["I97"],
  "meter": ["HXp"],
  "methane": ["HXq"],
  "methanol": ["I98"],
  "method": ["E1e","E1d"],
  "methodological": ["KKX"],
  "methodology": ["KKY"],
  "meticulous": ["I99"],
  "metre": ["HXs"],
  "metric": ["JAA"],
  "metro": ["F1a","E1g","E1f"],
  "metropolis": ["JAB"],
  "metropolitan": ["BxU","BxT"],
  "Mexican": ["F1b","Ko9","DHP","EeR"],
  "Mexico": ["GkI","BxZ","FLN","DHR","D2v","BxX","EJF","BxY"],
  "Mexico City": ["G8i"],
  "Mexico flag": ["F1c","DHQ"],
  "mi": ["KKx"],
  "Miami": ["G8j"],
  "mice": ["GkJ","Bxb","FLO","Bxa"],
  "microbe": ["HXt"],
  "microbial": ["KKZ"],
  "microchip": ["F1d","Bxd"],
  "microcomputer": ["KKa"],
  "Micronesia": ["KKc"],
  "Micronesian": ["KKb"],
  "microorganism": ["HXu"],
  "microphone": ["GkK","DHS","FLP","Bxg","D2w","Bxh","Bxe"],
  "microprocessor": ["JAC"],
  "microscope": ["GkL","DHT","Bxl","Bxk","D2x","Bxi"],
  "microscopic": ["JAD"],
  "microscopy": ["KKd"],
  "microtubule": ["KKe"],
  "microwave": ["GkM","DHU","FLQ","Bxp","Bxo","Bxm","D2y","Bxn"],
  "microwave oven": ["F1e","DsL"],
  "mid": ["KKh"],
  "Midautumn Festival": ["HXv"],
  "midday": ["F1f","E1h"],
  "middle": ["GkN","DdS"],
  "middle class": ["HXw"],
  "Middle East": ["KKg"],
  "Middle Eastern": ["KKf"],
  "middleman": ["JAE"],
  "midnight": ["GkO","DsM","FLR"],
  "midst": ["JAF"],
  "midterm": ["JAG"],
  "midway": ["KKi"],
  "midwestern": ["KKj"],
  "midwesterner": ["KpA"],
  "midwife": ["KKk"],
  "might": ["KKl"],
  "might as well": ["JAH"],
  "mighty": ["JAI"],
  "migraine": ["JAJ"],
  "migrant": ["KKm","KpB"],
  "migrate": ["JAK"],
  "migration": ["HXx"],
  "mike": ["KKn"],
  "Milan": ["KKo"],
  "mild": ["GkP","DHV","DHW"],
  "mildly": ["KKp"],
  "mile": ["HXy"],
  "mileage": ["KKq"],
  "milestone": ["KKr"],
  "milieu": ["JAL"],
  "militant": ["JAM"],
  "military": ["HXz"],
  "military service": ["JAN"],
  "militia": ["KKs"],
  "milk": ["GkQ","DHX","FLS","Bxt","Bxq","D2z","Bxs","Bxr"],
  "milk a cow": ["HX0"],
  "milkshake": ["GkR","Bxu","FLT","Bxw","Bxv","D20"],
  "milkshakes": ["F1g","Bxy","Bxx"],
  "Milky Way": ["F1h","Bxz"],
  "mill": ["HX5"],
  "millennium": ["JAO"],
  "milliliter": ["HX1"],
  "millilitre": ["HX2"],
  "millimeter": ["HX3"],
  "millimetre": ["HX4"],
  "million": ["G8k"],
  "millionaire": ["JAP"],
  "millipede": ["Bx3"],
  "mime": ["F1i","Bx4"],
  "mimic": ["JAQ"],
  "mince": ["KKt"],
  "mind": ["HX6"],
  "mine": ["HX7","G8l"],
  "minecraft": ["F1j","Bx5"],
  "miner": ["F1l","ByA"],
  "mineral": ["HX8"],
  "mineral water": ["F1k","Bx6","Bx7","Bx8","Bx9"],
  "Minerva": ["HX9"],
  "mingle": ["JAR"],
  "mini": ["ByC"],
  "mini car": ["ByB"],
  "miniature": ["JAS"],
  "minibus": ["KKu"],
  "minimal": ["JAT"],
  "minimize": ["JAU"],
  "minimum": ["JAV"],
  "mining": ["HYA"],
  "minister": ["HYB"],
  "ministerial": ["KKv"],
  "ministry": ["JAW"],
  "minivan": ["ByD"],
  "mink": ["KKw"],
  "minor": ["JAY"],
  "minority": ["JAX"],
  "Minotaur": ["HYC"],
  "mint": ["JAZ"],
  "mints": ["DHY"],
  "minus": ["F1m","ByE"],
  "minuscule": ["JAa"],
  "minute": ["E1i"],
  "miracle": ["JAb"],
  "miraculous": ["KKy"],
  "mirror": ["GkS","DHZ","FLU","D21","ByG","DHa","ByH","ByI","D22","ByF"],
  "miscalculate": ["JAc"],
  "mischief": ["JAd"],
  "mischievous": ["JAe"],
  "misconception": ["JAf"],
  "misconduct": ["KKz"],
  "misdiagnose": ["JAg"],
  "miserable": ["GkT","ByJ"],
  "misery": ["JAh"],
  "misfortune": ["JAi"],
  "misguided": ["JAj"],
  "misinform": ["JAk"],
  "misinterpret": ["JAl"],
  "misjudge": ["JAm"],
  "mislead": ["JAn"],
  "mismanage": ["JAo"],
  "mismatch": ["KK0"],
  "misplace": ["JAp"],
  "misrepresentation": ["KK1"],
  "miss": ["E1j"],
  "miss out": ["JAr"],
  "miss the bus": ["HYF"],
  "missile": ["HYD"],
  "mission": ["JAq"],
  "Mission Control": ["HYE"],
  "missionary": ["KK2"],
  "Mississippi": ["KK3"],
  "Mississippi River": ["KK4"],
  "mist": ["HYG"],
  "mistake": ["GkU","DsN"],
  "mistaken": ["KK5"],
  "mistletoe": ["GkV","EJG","ByK","ByL"],
  "mistress": ["KK6"],
  "mistrust": ["JAs"],
  "misty": ["HYH"],
  "misunderstand": ["JAt"],
  "misuse": ["KK7"],
  "mitigate": ["JAu"],
  "mitochondrial": ["KK8"],
  "mitochondrion": ["KK9"],
  "mittens": ["GkW","DHb","FLV","ByM","D23","ByO","ByN"],
  "mix": ["GkY","ByP","FLW","ByQ"],
  "mix the ingredients": ["HYI"],
  "mix up": ["HYJ"],
  "mixed race": ["KrZ"],
  "mixer": ["GkX","DHc","D24"],
  "mixture": ["F1n","DsO"],
  "moan": ["JAv"],
  "mob": ["JAw"],
  "mobile": ["F1p","DsP"],
  "mobile game": ["F1o","DHd"],
  "mobile phone": ["GkZ","ByR","FLX","ByT"],
  "mobility": ["KLA"],
  "mobilization": ["KLB"],
  "mobilize": ["KLC"],
  "mock": ["JAx"],
  "modal": ["KLE"],
  "modality": ["KLD"],
  "mode": ["JAz"],
  "model": ["Gka","Djm","FLY","DHe","DHg","ByU","EJH","ByV","EYf"],
  "model clothes": ["EYf","Djm"],
  "model modeled": ["Djm"],
  "model plane": ["F1q","DHf"],
  "modeling": ["Djm"],
  "modeling clothes": ["Djm"],
  "modem": ["JAy"],
  "moderate": ["JA0"],
  "moderately": ["KLF"],
  "moderation": ["JA1"],
  "moderator": ["KLG"],
  "modern": ["Gkb","ByX","FLZ","ByW"],
  "Modern Wonders": ["HYK"],
  "modernism": ["KLH"],
  "modernist": ["KLI"],
  "modernity": ["JA2"],
  "modernization": ["KLJ"],
  "modernize": ["KLK"],
  "modest": ["JA3"],
  "modestly": ["KLL"],
  "modesty": ["KLM"],
  "modification": ["KLN"],
  "modify": ["JA4"],
  "modular": ["KLO"],
  "modulate": ["JA5"],
  "modulation": ["KLP"],
  "module": ["KLQ"],
  "moist": ["JA6"],
  "moisture": ["F1r","Bya","ByY"],
  "mold": ["JA7"],
  "Moldova": ["HDp"],
  "Moldovan": ["HDo","KpC"],
  "mole": ["Gkc","Byd","Byb","Byc"],
  "molecular": ["JA8"],
  "molecule": ["HYL"],
  "molecules": ["HYM"],
  "mollusca": ["DHh"],
  "molten": ["Byf"],
  "mom": ["Gkd","Byj","FLa","Byi"],
  "moment": ["JBB"],
  "momentarily": ["KLR"],
  "momentary": ["JA9"],
  "momentous": ["JBA"],
  "momentum": ["JBC"],
  "mona lisa": ["Byn"],
  "Monaco": ["Bym"],
  "monarch": ["JBD"],
  "monarchy": ["HYN"],
  "monastery": ["JBE"],
  "monastic": ["KLS"],
  "Monday": ["Gke","DHk","FLb","DHi","DHj"],
  "Monegasque": ["HDq","G8m"],
  "monetary": ["JBF"],
  "money": ["Gkf","F1s","DHl","FLc","Byp","D25","Byo"],
  "Mongolia": ["EJK"],
  "Mongolia flag": ["F1t","DHm"],
  "Mongolian": ["HDr","KpD","G8n"],
  "monitor": ["Gkg","Byq","FLd","D26","Byr","Bys","Byt"],
  "monk": ["HYP"],
  "monkey": ["Gkh","DHn","FLe","Byw","D27","Byv","Byu"],
  "Monkey King": ["HYO"],
  "monkeys": ["Gki","Byx"],
  "monoclonal": ["KLT"],
  "monogamous": ["JBG"],
  "monogamy": ["JBH"],
  "monograph": ["KLU"],
  "monolingual": ["JBI"],
  "monopoly": ["HYQ"],
  "monotonous": ["JBJ"],
  "monotony": ["JBK"],
  "monster": ["Gkj","DsQ","FLf"],
  "monstrous": ["KLV"],
  "Montenegrin": ["HDs","KpE","G8o"],
  "Montenegro": ["HDt","EJL"],
  "month": ["F1u"],
  "monthly": ["KLW"],
  "Montreal": ["KLX"],
  "monument": ["Gkk","By0","Byz","Byy"],
  "monumental": ["JBL"],
  "mony": ["KLY"],
  "mood": ["JBM"],
  "moon": ["Gkl","By3","FLg","By1","By9","By2","D6r","By4","DOj"],
  "moon cake": ["F1v","DsR"],
  "Moon Festival": ["HYR"],
  "mooncake": ["F1w","By8","By6","By5","By7"],
  "moonlight": ["KLZ"],
  "moor": ["JBN"],
  "moose": ["Gkm","DsS"],
  "mop": ["Gkn","DHp","FLh","Djn","D29","EYg","BzA","BzB","BzC","BzI"],
  "mop mopped": ["Djn"],
  "mop the floor": ["Gko","Djn","EYg","BzJ"],
  "moped": ["F1x","D28","DHo","BzH","BzD"],
  "mopping": ["F1y","Djn"],
  "mopping the floor": ["Djn"],
  "moral": ["JBP"],
  "morale": ["JBO"],
  "morality": ["KLa"],
  "morally": ["KLb"],
  "morbidity": ["KLc"],
  "more": ["HYS"],
  "more beautiful": ["F1z","DHr","DHq"],
  "more boring": ["DHs"],
  "more casual": ["ERf","DHt"],
  "more colorful": ["F10","DHv","DHu"],
  "more colourful": ["DHu","DHv"],
  "more dangerous": ["DHw"],
  "more difficult": ["ERn","DHx"],
  "more exciting": ["ERr","DHy"],
  "more expensive": ["F11","DH0","DHz"],
  "more formal": ["DH1"],
  "more often than not": ["JBQ"],
  "more or less": ["JBR"],
  "moreover": ["JBS"],
  "morgue": ["JBT"],
  "morning": ["Gkp","F13","DYR","FLi","BzM"],
  "morning glory": ["F12","BzK"],
  "Moroccan": ["HDu","KpF","G8p"],
  "Morocco": ["HDv","Gkq","BzP","EJM","BzO"],
  "morpheme": ["KLd"],
  "morphological": ["KLe"],
  "morphology": ["JBU"],
  "mortal": ["JBW"],
  "mortality": ["JBV"],
  "mortar": ["KLf"],
  "mortgage": ["F14","BzQ"],
  "mortify": ["JBX"],
  "mosaic": ["JBY"],
  "Moscow": ["G8q"],
  "mosque": ["Gkr","BzR","FLj"],
  "mosquito": ["Gks","BzU","FLk","BzV","BzT","BzS"],
  "moss": ["JBZ"],
  "most": ["KLh"],
  "mostly": ["KLg"],
  "motel": ["F15","BzY","BzX"],
  "moth": ["Gkv","Bzd","BzZ","Bza"],
  "mother": ["Gku","F16","Bzc","FLl","DZa","Bzb","EJO"],
  "mother in law": ["DZZ","EJN"],
  "mother tongue": ["HYT"],
  "motherboard": ["KLi"],
  "motherhood": ["KLj"],
  "motherinlaw": ["Gkt","EJN"],
  "motif": ["JBa"],
  "motility": ["KLk"],
  "motion": ["HYU"],
  "motionless": ["KLl"],
  "motivate": ["JBb"],
  "motivation": ["HYV"],
  "motive": ["JBc"],
  "motocross": ["HYW"],
  "motor": ["HYX"],
  "motor racing": ["HYY"],
  "motorbike": ["Gkw","DH2","FLm","D3A","Bzg","Bze","Bzh","Bzi","Bzf"],
  "motorboat": ["Bzk"],
  "motorcycle": ["Gkx","Bzo","FLn","Bzp","Bzn"],
  "motorhome": ["F17","Bzt","Bzr","Bzs"],
  "motorist": ["KLm"],
  "motorway": ["F18"],
  "mottled": ["JBd"],
  "motto": ["JBe"],
  "mound": ["JBf"],
  "mount": ["JBg"],
  "Mount Everest": ["HYZ"],
  "Mount Fuji": ["HYa"],
  "Mount Olympus": ["HYb"],
  "mountain": ["Gkz","B0A","FLo","DH3","Bzu","Bzw","D3B","Bzx","Bzv","Bzy","EdA"],
  "mountain bike": ["F19","Bzz","Bz1","Bz2"],
  "mountain biking": ["Gky","Bz4","Bz5","Bz6"],
  "mountainous": ["Bz7","Bz8"],
  "mountains": ["Gk0","B0D","FLp","B0C","B0B"],
  "mourn": ["KLn"],
  "mouse": ["Gk1","Gk2","DH5","FLq","B0I","DH4","D3C","B0F","B0G","D3D","B0H","B0E","EdB"],
  "mousetrap": ["B0J"],
  "moustache": ["Gk3","DH6","FLr","D3E","B0L","B0M"],
  "mouth": ["Gk4","DH7","FLs","D3F","B0N","B0P","B0O","B0Q"],
  "mouth off": ["JBh"],
  "mouth watering": ["E1k"],
  "mouthful": ["KLo"],
  "move": ["Gk5","Djo","FLt","Djq","Djp","Edb","EYh","EcR","B0R"],
  "move a chair": ["Edb","Djo"],
  "move a sofa": ["EYh"],
  "move along": ["JBi"],
  "move away": ["JBj"],
  "move in": ["HYc"],
  "move into": ["JBk"],
  "move luggage": ["EJP"],
  "move moved": ["EU7","Djo","Djp","Djq"],
  "move on": ["HYd"],
  "move out": ["HYe"],
  "move the mouse": ["EcR","Djp"],
  "move the sofa": ["Djq"],
  "move to": ["JBl"],
  "moved": ["EU7"],
  "moved an armchair": ["EU7"],
  "movement": ["KLp"],
  "mover": ["KLq"],
  "movie": ["Gk6","B0S","FLu","B0T"],
  "movie theater": ["Gk8","B0U","FLv","DH8","D3G"],
  "movies": ["Gk7","DsT"],
  "moving": ["F2A","Djq","Djo","Edb","EcR","Djp"],
  "moving a chair": ["Edb","Djo"],
  "moving the mouse": ["EcR","Djp"],
  "moving the sofa": ["Djq"],
  "moving walkway": ["E1l"],
  "mow": ["JBm"],
  "mow the lawn": ["HYf"],
  "Mozambican": ["HDw"],
  "Mozambique": ["EJQ"],
  "Mozart": ["KLr"],
  "mp3 player": ["F2C","B0V","B0W"],
  "much": ["E1m"],
  "muck": ["KLs"],
  "muck around": ["JBn"],
  "muck up": ["JBo"],
  "mucosa": ["KLu"],
  "mucosal": ["KLt"],
  "mud": ["GlA","B0b","FLx","B0a","B0Z","B0Y","B0X"],
  "muddle": ["KLv"],
  "muddy": ["KLw"],
  "muffin": ["GlB","DH9","FLy","D3H","B0h","B0d","B0e","B0c","B0f","B0g"],
  "muffins": ["DsU"],
  "muffle": ["KLx"],
  "mug": ["GlC","DIA","FLz","D3I","B0n","B0m","B0i","B0j","B0k","B0l"],
  "mugging": ["JBp"],
  "muggy": ["JBq"],
  "mule": ["GlD","B0o","B0p"],
  "mull over": ["JBr"],
  "multicultural": ["JBs"],
  "multilateral": ["KLy"],
  "multilingual": ["HYg"],
  "multimedia": ["KLz"],
  "multinational": ["KL0"],
  "multiple": ["JBt"],
  "multiplicative": ["JBu"],
  "multiply": ["F2D","B0q"],
  "multitude": ["JBv"],
  "multivariate": ["KL1"],
  "mum": ["GlF","B0r","FL0","B0s","EJT"],
  "Mumbai": ["G8r"],
  "mumble": ["KL2"],
  "mummies": ["EJR"],
  "mummy": ["GlE","DsV"],
  "mundane": ["JBw"],
  "Munich": ["KL3"],
  "municipal": ["JBx"],
  "municipality": ["KL4"],
  "mural": ["F2E","E1n"],
  "murder": ["KL6"],
  "murderer": ["KL5"],
  "murky": ["KL7"],
  "murmur": ["KL8"],
  "muscle": ["GlG","B0u","B0t"],
  "muscles": ["F2F","DsW"],
  "Muscovite": ["KpH","KpG"],
  "muscular": ["F2G","B0v","B0w"],
  "muse": ["JBz"],
  "muse about": ["JBy"],
  "muse on": ["JBy"],
  "museum": ["GlH","B0z","FL1","B0y","B0x"],
  "mushroom": ["GlI","B04","B02","B01","Egt","B00","B03"],
  "mushrooms": ["GlJ","DIB","FL2","B07","D3J","B06","B05","B08"],
  "music": ["GlM","F2I","DIE","FL5","B1I","D3L","B1C","B1A","B09","B1D","B1B"],
  "music room": ["GlN","DsY","FL6"],
  "musical": ["GlK","DsX","FL3"],
  "musical instrument": ["F2H"],
  "musician": ["GlL","DIC","FL4","DID","EJU","B1H","B1E","B1G","D3K","B1F"],
  "musketeer": ["B1J"],
  "musketeers": ["B1K"],
  "must": ["KMA"],
  "must be quiet": ["HYh"],
  "must go": ["HYi"],
  "must try": ["HYj"],
  "must wear a seatbelt": ["HYk"],
  "mustache": ["F2J","D3E","B0M","DH6","B0L"],
  "mustard": ["GlO","DIF","B1O","B1L","B1M","B1N"],
  "muster": ["KL9"],
  "muster up": ["JB0"],
  "mutant": ["KMB"],
  "mutation": ["KMC"],
  "mute": ["GlP","B1Q","B1P"],
  "mutter": ["KMD"],
  "mutual": ["JB1"],
  "mutually": ["KME"],
  "my": ["G8t","E1o"],
  "my aunt": ["ICJ","DZK","D85"],
  "my baby brother": ["ICK"],
  "my baby sister": ["ICL"],
  "my boyfriend": ["DZL"],
  "my brother": ["ICM","DZM","D9r"],
  "my brothers": ["ICN"],
  "my cousin": ["ICO","EBV","DZN"],
  "my cousins": ["ICP","DZO"],
  "my dad": ["ICR"],
  "my daddy": ["ICQ"],
  "my daughter": ["ICS","EBt","DZQ"],
  "my daughter in law": ["EBu","DZP"],
  "my family": ["ICT","DZR"],
  "my father": ["ICU","EDb","DZT"],
  "my father in law": ["EDa","DZS"],
  "my grandad": ["ICV"],
  "my granddaughter": ["ICW","EEr","DZU"],
  "my grandfather": ["ICX","EEs","DZV"],
  "my grandma": ["ICY"],
  "my grandmother": ["ICZ","EEt","DZW"],
  "my grandpa": ["ICa"],
  "my grandparent": ["ICb"],
  "my grandson": ["ICc","EEu","DZX"],
  "my husband": ["ICd","EGi","DZY"],
  "my mistake": ["G8s"],
  "my mom": ["ICe"],
  "my mother": ["ICf","EJO","DZa"],
  "my mother in law": ["EJN","DZZ"],
  "my mum": ["ICg"],
  "my nephew": ["ICh","EJb","DZb"],
  "my niece": ["ICi","EJk","DZc"],
  "my parent": ["ICj"],
  "my parents": ["ICk","EKN","DZd"],
  "my pleasure": ["HYl"],
  "my sibling": ["ICl"],
  "my sister": ["ICm","EM2","DZe"],
  "my sisters": ["ICn"],
  "my son": ["ICo","ENV","DZg"],
  "my son in law": ["ENW","DZf"],
  "my twin sister": ["EPW","DZh"],
  "my uncle": ["ICp","DZi","EPZ"],
  "my wife": ["ICq","EQo","DZj"],
  "Myanmar": ["F2K","B1U","EJW","B1R"],
  "Myanmar flag": ["B1T"],
  "myopic": ["JB2"],
  "myriad": ["JB3"],
  "myself": ["KMF"],
  "mysterious": ["F2L","B1V","B1W"],
  "mystery": ["F2M"],
  "mystical": ["KMG"],
  "myth": ["E1p"],
  "mythical": ["KMH"],
  "mythology": ["HYm"],
  "N": ["DaB","F29","FMU","HD9"],
  "n": ["Gl8","DaC","HDy"],
  "nag": ["KMI"],
  "nail": ["GlQ","DIH","FL7","B1Z","D3N","B1X"],
  "nail clippers": ["F2N","DIG","B1Y"],
  "nail down": ["JB4"],
  "nail polish": ["F2O","B1a","B1d","B1b"],
  "nails": ["GlR","B1g","B1e","B1f"],
  "Nairobi": ["KMJ"],
  "naive": ["JB5"],
  "name": ["F2P","E1q"],
  "name a after b": ["JB6"],
  "name after": ["JB7"],
  "namely": ["KMK"],
  "Namibia": ["HD0","EJX"],
  "Namibian": ["HDz","KpP"],
  "nanny": ["F2Q","DIJ","DII","EJY","B1h"],
  "nap": ["GlT","B1n","FL8","B1i","B1j"],
  "napkin": ["GlS","B1m","B1l","B1k"],
  "napkins": ["F2R","DsZ"],
  "Napoleon": ["KML"],
  "narrate": ["JB8"],
  "narrative": ["JB9"],
  "narrator": ["KMM"],
  "narrow": ["GlU","B1o"],
  "narrow down": ["JCA"],
  "narrowly": ["KMN"],
  "nasal": ["KMO"],
  "nascar": ["HYn"],
  "nasty": ["JCB"],
  "nation": ["KMS","JCD"],
  "national": ["KMR","Kpc"],
  "national government": ["HYo"],
  "nationalism": ["JCC"],
  "nationalist": ["KMP"],
  "nationality": ["GlV","Dsa"],
  "nationally": ["KMQ"],
  "nationwide": ["KMT"],
  "native": ["JCE"],
  "Native": ["Kpd"],
  "native language": ["HYp"],
  "natural": ["GlW","B1p","B1r","B1q"],
  "natural resources": ["JCG"],
  "natural selection": ["HYq"],
  "Natural Wonders": ["HYr"],
  "naturalist": ["JCF"],
  "naturalistic": ["KMU"],
  "naturally": ["KMV"],
  "nature": ["GlX","B1u","FL9","B1s","B1t"],
  "naught": ["KMW"],
  "naughty": ["GlY","B1v","FMA"],
  "nausea": ["JCH"],
  "nauseous": ["JCI"],
  "Navajo": ["Kph"],
  "naval": ["HYs"],
  "nave": ["KMX"],
  "navigate": ["F2S","B1w","B1x"],
  "navigation": ["KMY"],
  "navigator": ["KMZ"],
  "navy": ["HYt"],
  "near": ["GlZ","E1r"],
  "nearby": ["KMa"],
  "nearly": ["KMb"],
  "neat": ["Gla","B1y"],
  "neatly": ["KMc"],
  "nebula": ["HYu"],
  "necessarily": ["KMd"],
  "necessary": ["JCJ"],
  "necessitate": ["JCK"],
  "necessity": ["JCL"],
  "neck": ["Glc","DIM","FMC","D3P","B15","B1z","B10"],
  "neckache": ["F2T"],
  "necklace": ["Glb","DIK","FMB","DIL","D3O","B11","B12","B13","B14"],
  "necktie": ["F2U","B17"],
  "nectar": ["JCM"],
  "nectarine": ["F2V","B2A","B18","B19"],
  "need": ["F2X","E1s"],
  "needle": ["Gld","DIO","B2C","B2D","D3Q","B2B"],
  "needle and thread": ["F2W","DIN"],
  "needless": ["KMe"],
  "needy": ["JCN"],
  "negate": ["JCO"],
  "negation": ["KMf"],
  "negative": ["JCP"],
  "negatively": ["KMg"],
  "neglect": ["JCQ"],
  "negligence": ["KMh"],
  "negligent": ["JCR"],
  "negligible": ["JCS"],
  "negotiate": ["JCT"],
  "negotiation": ["JCU"],
  "negotiator": ["KMi"],
  "neighbor": ["Glf","Dsb","FMD","Dsc"],
  "neighborhood": ["Gle","B2E","B2F","B2G"],
  "neighbour": ["Glg","Dsc","Dsb"],
  "Neil Armstrong": ["KMj"],
  "neither": ["G8u"],
  "neither a nor b": ["JCV"],
  "Nelson Mandela": ["KMk"],
  "nematode": ["KMl"],
  "neoclassical": ["JCW"],
  "neolithic": ["JCX"],
  "neon": ["HYv"],
  "neon sign": ["B2H","B2I","B2J"],
  "neonatal": ["KMm"],
  "Nepal": ["HD2","F2Y","EJa"],
  "Nepalese": ["HD1","Kpr"],
  "nephew": ["Glh","DZb","FME","EJb"],
  "neptune": ["Gli","B2K"],
  "nerve": ["HYw"],
  "nerves": ["HYx"],
  "nervous": ["Glj","F2Z","DIP","FMF","EJd","EJc"],
  "nervous system": ["HYy"],
  "nervously": ["KMn"],
  "nest": ["Glk","B2L","FMG","B2O","B2N","B2M"],
  "nestle": ["KMo"],
  "net": ["Gll","B2Q","FMH","B2R","B2P","B2S"],
  "netball": ["HYz"],
  "Netherlands": ["F2b","EJe"],
  "Netherlands flag": ["F2a","DIQ"],
  "network": ["KMp"],
  "neural": ["KMq"],
  "neurological": ["KMr"],
  "neuron": ["JCY"],
  "neuronal": ["KMs"],
  "neutral": ["HY1"],
  "neutrality": ["KMt"],
  "neutralization": ["HY0"],
  "neutralize": ["KMu"],
  "neutron": ["HY2"],
  "neutron star": ["HY3"],
  "Nevada": ["KMv"],
  "never": ["KMw"],
  "never mind": ["HY4","G8v"],
  "nevertheless": ["JCZ"],
  "new": ["Glm","EJf","FMI"],
  "new found fame": ["JCb"],
  "new moon": ["HY5"],
  "New Phone": ["KMy"],
  "New Year party": ["F2f","B2b"],
  "New Year's Eve": ["F2g"],
  "New York": ["F2h","Dsf"],
  "New Yorker": ["Kpw","Kpv"],
  "New Zealand": ["Glq","B2c","B2f","EJh","B2e","B2d"],
  "New Zealander": ["HD3","Kpx","G8w"],
  "newborn": ["E1t"],
  "newcomer": ["JCa"],
  "newer": ["F2c","DIR"],
  "newly": ["KMx"],
  "news": ["Glp","Dse","FMK"],
  "news reporter": ["F2e","B2W","B2X"],
  "newsagent's": ["Gln","F2d","E1u","Dsd"],
  "newsletter": ["JCc"],
  "newspaper": ["Glo","DIS","FMJ","B2V","B2T","B2U","D3R"],
  "newsprint": ["JCd"],
  "newsroom": ["KMz"],
  "newt": ["B2a","B2Z"],
  "Newton": ["HY6"],
  "Newton's Laws": ["HY7"],
  "next": ["F2i","Dsg"],
  "next to": ["Glr","DdT","FML","DdV","Efu","DdU","Efv"],
  "next to me": ["HY8"],
  "next to the bookcase": ["Efu"],
  "next to the school": ["HY9"],
  "next to the stove": ["Efv"],
  "next to the window": ["HZA"],
  "Nezha": ["HZB"],
  "Niagara Falls": ["HZC"],
  "Nian": ["HZD"],
  "nibble": ["KM0"],
  "Nicaragua": ["HD5","EJj"],
  "Nicaraguan": ["HD4","Kp1"],
  "nice": ["F2j","E1v"],
  "nice to meet you": ["F2k"],
  "nice weather": ["HZE"],
  "nice work": ["HZF"],
  "nicely": ["KM1"],
  "niche": ["JCe"],
  "nick": ["JCg"],
  "nickel": ["JCf"],
  "nickname": ["KM2"],
  "nicotine": ["JCh"],
  "niece": ["Gls","DZc","FMM","EJk"],
  "Nigeria": ["F2l","B2i","B2h","B2g"],
  "Nigeria flag": ["DIT"],
  "Nigerian": ["HD6","Kp3"],
  "night": ["Glt","F2o","B2p","FMN","B2k","B2j"],
  "night market": ["F2n","B2n"],
  "night sky": ["HZG"],
  "night stand": ["E1w"],
  "nightclub": ["KM3"],
  "nightlife": ["KM4"],
  "nightly": ["KM5"],
  "nightmare": ["F2m","B2m","B2l"],
  "Nike": ["HZH"],
  "Nikola Tesla": ["KM6"],
  "nil": ["KM9"],
  "Nile": ["KM7"],
  "Nile River": ["KM8"],
  "nimble": ["JCi"],
  "nine": ["Glu","F2r","DbY","DbW"],
  "nine apples": ["HZI"],
  "nine cars": ["HZJ"],
  "nine hundred": ["F2p","DbX"],
  "nine o'clock": ["F2q","DeJ","EfW"],
  "nine thousand": ["Dbb"],
  "ninetailed fox": ["HZK"],
  "nineteen": ["Glv","F2s","Dba","DbZ"],
  "nineteen bananas": ["HZL"],
  "nineteenth": ["HBE"],
  "ninety": ["Glw","F2u","Dbi","FMO","Dbc"],
  "ninety eight": ["Dbd"],
  "ninety five": ["Dbe"],
  "ninety four": ["Dbf"],
  "ninety nine": ["F2t","Dbg"],
  "ninety one": ["Dbh"],
  "ninety seven": ["Dbj"],
  "ninety six": ["Dbk"],
  "ninety thousand": ["Dbl"],
  "ninety three": ["Dbm"],
  "ninety two": ["Dbn"],
  "ninja": ["HZM"],
  "ninth": ["HBS","F2v","E1x"],
  "nip": ["KNA"],
  "nitrate": ["KNB"],
  "nitric acid": ["HZN"],
  "nitrogen": ["HZO"],
  "nitrous oxide": ["HZP"],
  "no": ["F22","E1z"],
  "no apples": ["HZQ"],
  "no cats": ["HZR"],
  "no entry": ["F2x","B2q"],
  "no hurry": ["HZS"],
  "no idea": ["HZT"],
  "no matter": ["G8y"],
  "no one": ["HZV","G80"],
  "no parking": ["F21","Dsi"],
  "no problem": ["HZX"],
  "no problem at all": ["HZW"],
  "no thank you": ["HZd"],
  "no way": ["HZl"],
  "no wonder": ["JDL"],
  "no worries": ["HZm"],
  "nobility": ["KNC"],
  "noble": ["JCj"],
  "nobody": ["G8x"],
  "nocturnal": ["JCk"],
  "nod": ["F2w"],
  "nod off": ["JCl"],
  "node": ["KND"],
  "noise": ["F2y","E1y"],
  "noise pollution": ["JCm"],
  "noisier": ["F2z","DIU"],
  "noisily": ["ERT"],
  "noisy": ["Glx","B2r","FMP","Ehq","EJm"],
  "nomadic": ["JCn"],
  "nominal": ["JCo"],
  "nominate": ["JCp"],
  "nomination": ["KNE"],
  "nominee": ["JCq"],
  "non": ["KNH"],
  "none": ["G8z"],
  "nonetheless": ["JCr"],
  "nonfiction": ["KNF"],
  "nonlinear": ["KNG"],
  "nonmetal": ["HZU"],
  "nonprofit": ["KNI"],
  "nonsense": ["JCs"],
  "nonverbal": ["JCt"],
  "noodle": ["KNJ"],
  "noodle soup": ["F20","B2w","B2x","B2y","B2z"],
  "noodles": ["Gly","DIV","FMQ","B2t","B2u","D3S","B2v","B20","B2s"],
  "noon": ["Glz","Dsh"],
  "nope": ["JCu"],
  "nor": ["G81"],
  "norm": ["HZY"],
  "normal": ["JCw"],
  "normality": ["KNK"],
  "normalize": ["KNL"],
  "normally": ["JCv"],
  "Norman": ["KqB"],
  "Normans": ["Kr1"],
  "normative": ["KNM"],
  "north": ["HZZ"],
  "North Africa": ["KNO"],
  "North African": ["KNN"],
  "North America": ["Gl0","B21"],
  "North American": ["KqD","KqC"],
  "North Korea": ["EJn"],
  "North Korean": ["HD7","KqE"],
  "North Sea": ["KNT"],
  "North Star": ["HZa"],
  "northeast": ["KNQ"],
  "northeastern": ["KNP"],
  "northern": ["JCx"],
  "Northern Ireland": ["KNR"],
  "Northern Irish": ["KNS"],
  "northern lights": ["F23","B22","B23"],
  "northward": ["KNU"],
  "northwest": ["KNW"],
  "northwestern": ["KNV"],
  "Norway": ["Gl1","B28","B24","B25"],
  "Norwegian": ["HD8","KqF","G82"],
  "nose": ["Gl2","DIX","FMR","B29","D3U","B3A"],
  "nose bleed": ["F24","DIW","D3T"],
  "nostalgia": ["JCy"],
  "nostalgic": ["JCz"],
  "nostril": ["KNX"],
  "nosy": ["JC0"],
  "not": ["E11"],
  "not a cloud in the sky": ["JC2"],
  "not at all": ["HZb"],
  "not bad": ["HZc"],
  "not have the foggiest idea": ["JC8"],
  "not now": ["HZe"],
  "not really": ["HZf"],
  "not sure": ["HZg"],
  "not when": ["HZh"],
  "not yet": ["HZi"],
  "notable": ["JC1"],
  "notably": ["KNY"],
  "notate": ["JC3"],
  "notation": ["JC4"],
  "notch": ["JC5"],
  "note": ["Gl4","B3E"],
  "note down": ["E10"],
  "notebook": ["Gl3","B3D","FMS","B3B","B3C"],
  "noted": ["JC6"],
  "notepad": ["F25","DIY","D3V"],
  "notes": ["F26","B3G"],
  "noteworthy": ["JC7"],
  "nothing": ["F27","Dsj"],
  "nothing but": ["JC9"],
  "notice": ["Gl5","Dsk"],
  "noticeable": ["JDA"],
  "noticeably": ["KNZ"],
  "noticeboard": ["G83"],
  "notification": ["KNa"],
  "notify": ["JDB"],
  "notion": ["JDC"],
  "notorious": ["JDD"],
  "notoriously": ["KNb"],
  "notwithstanding": ["JDE"],
  "nought": ["G84"],
  "noughts and crosses": ["HZj"],
  "noun": ["KNc"],
  "nourish": ["JDG"],
  "nourishment": ["JDF"],
  "nova": ["HZk"],
  "Nova Scotia": ["KNd"],
  "novel": ["Gl6","B3H","B3I","B3K","B3J"],
  "novelist": ["KNe"],
  "novelty": ["JDH"],
  "November": ["Gl7","Dsl","FMT"],
  "novice": ["JDI"],
  "now": ["F28","Dsm"],
  "now and then": ["JDK"],
  "now that": ["JDM"],
  "nowadays": ["JDJ"],
  "nowhere": ["G85"],
  "noxious": ["JDN"],
  "nuance": ["KNf"],
  "nuclear": ["JDO"],
  "nuclear energy": ["HZn"],
  "nuclear engineer": ["DIa"],
  "nuclear family": ["F3A","E12"],
  "nucleotide": ["KNg"],
  "nucleus": ["HZo"],
  "nudge": ["KNh"],
  "nuggets": ["F3B","B3L","B3M"],
  "nuisance": ["JDP"],
  "null": ["KNi"],
  "numb": ["JDQ"],
  "number": ["F3C","E13"],
  "numbers": ["Gl9","B3O","FMV","B3P","B3N"],
  "numeric": ["JDR"],
  "numerical": ["KNj"],
  "numerous": ["JDS"],
  "nun": ["KNk"],
  "nurse": ["GmA","DIc","FMW","EJs","B3Q","B3S","DIb","EJr","B3R","D3W"],
  "nursery": ["JDT"],
  "nurses office": ["F3D"],
  "nurture": ["JDU"],
  "nut": ["GmB","B3T"],
  "nutrient": ["E14"],
  "nutrition": ["JDV"],
  "nutritional": ["KNl"],
  "nutritious": ["JDW"],
  "nuts": ["GmC","B3X","FMX","B3W","B3U","DId","B3V"],
  "Nuwa": ["HZp"],
  "nylon": ["KNm"],
  "Nymph": ["HZq"],
  "O": ["DaD","Gmh","F3i"],
  "o": ["FMn","DaE","HEB","HEA"],
  "o'clock": ["JDx"],
  "O2": ["HZr"],
  "oak": ["JDX"],
  "oar": ["F3E","B3Z","B3Y"],
  "oasis": ["GmD","B3c","B3a","B3b"],
  "oat": ["KNo"],
  "oath": ["JDY"],
  "oatmeal": ["KNn"],
  "oats": ["GmE","B3f","B3d","B3e","B3g"],
  "obedience": ["JDZ"],
  "obedient": ["F3F","B3h"],
  "obelisk": ["F3G","B3k","B3i","B3j"],
  "obese": ["KNp"],
  "obesity": ["F3H"],
  "obey": ["JDa"],
  "obituary": ["JDb"],
  "object": ["JDd"],
  "object to": ["JDe"],
  "objection": ["KNq"],
  "objective": ["JDc"],
  "objectivity": ["KNr"],
  "obligate": ["JDf"],
  "obligation": ["KNs"],
  "obligatory": ["KNt"],
  "oblige": ["JDg"],
  "obliterate": ["JDh"],
  "oblivious": ["JDi"],
  "oblong": ["JDj"],
  "oboe": ["F3I","B3n","B3l"],
  "obscene": ["JDk"],
  "obscure": ["JDl"],
  "observable": ["KNu"],
  "observation": ["F3J","B3p","B3o"],
  "observatory": ["F3K","B3q"],
  "observe": ["GmF","B3s","B3r"],
  "observer": ["KNv"],
  "obsess": ["JDm"],
  "obsession": ["KNw"],
  "obsessive": ["KNx"],
  "obsidian": ["B3v","B3u"],
  "obsolete": ["JDn"],
  "obstacle": ["F3L","B3y","B3w","B3x"],
  "obstruct": ["JDo"],
  "obstruction": ["KNy"],
  "obtain": ["JDp"],
  "obvious": ["JDq"],
  "obviously": ["KNz"],
  "occasion": ["JDs"],
  "occasional": ["JDr"],
  "occasional rain": ["HZs"],
  "occasionally": ["KN0"],
  "occultation": ["HZt"],
  "occupant": ["KN1"],
  "occupation": ["JDt"],
  "occupational": ["KN2"],
  "occupier": ["KN3"],
  "occupy": ["JDu"],
  "occur": ["JDv"],
  "occurrence": ["KN4"],
  "ocean": ["GmG","B30","FMY","B3z","B31"],
  "oceanographer": ["JDw"],
  "octagon": ["F3M","B33","B32"],
  "October": ["GmH","Dsn","FMZ"],
  "octopus": ["GmI","B36","FMa","DIe","B34","D3X","B35","B38","B39","B37"],
  "odd": ["HZu","F3N","Dso"],
  "odd numbers": ["E15"],
  "oddly": ["KN5"],
  "odor": ["JDz"],
  "odorous": ["JDy"],
  "Odysseus": ["HZv"],
  "of": ["KOB"],
  "of course": ["HZw"],
  "of one's own accord": ["JD7"],
  "off": ["KN9"],
  "offence": ["JD0"],
  "offend": ["JD1"],
  "offender": ["KN6"],
  "offense": ["JD2"],
  "offensive": ["JD3"],
  "offer": ["GmJ","B4B","B4A"],
  "offerer": ["KN7"],
  "office": ["GmK","DIf","FMb","B4F","B4H","B4E","B4D","B4C","B4G"],
  "office worker": ["GmL","DIh","FMc","DIg","EJu","B4J","EJt","B4I"],
  "office workers": ["F3O","B4K"],
  "officer": ["HZx"],
  "official": ["E16"],
  "officially": ["KN8"],
  "officious": ["JD4"],
  "offline": ["G86"],
  "offset": ["JD5"],
  "offshore": ["KOA"],
  "offspring": ["JD6"],
  "often": ["GmM","DYS"],
  "oh dear": ["HZy"],
  "oh no": ["HZz"],
  "oh well": ["HZ0"],
  "Ohio": ["KOC"],
  "oil": ["GmN","B4P","FMd","B4L","B4N","B4O","B4M"],
  "oil rig": ["B4Q","B4R","B4S","B4T"],
  "oil tanker": ["B4U"],
  "oil well": ["B4V"],
  "ok": ["F3Q","Dsp"],
  "okay": ["F3P","B4W"],
  "old": ["GmP","DIm","B4Y","DIi","B4a","EJv","B4j","DIj","Ehs","Eht","Ehr","B4Z","B4X"],
  "old age pension": ["JD8"],
  "old city": ["F3R","B4b"],
  "old fashioned": ["F3S","B4e","B4d","B4c"],
  "old man": ["B4h","B4g"],
  "old woman": ["F3T","B4k","B4l"],
  "older": ["GmO","DIl","DIk"],
  "olfactory": ["JD9"],
  "olive": ["GmR","B4p","Egu","B4m"],
  "olive oil": ["GmQ","B4n","FMe","B4o"],
  "olives": ["GmS","DIo","FMf","B4r","D3Y","B4q","B4s"],
  "olympic": ["F3U","B4u","B4v"],
  "Olympic Games": ["HZ1"],
  "olympics": ["F3V","B4x","B4w"],
  "Olympus": ["HZ2"],
  "omelette": ["GmT","B40","FMg","B4y"],
  "omen": ["JEA"],
  "ominous": ["KOD"],
  "omission": ["JEB"],
  "omit": ["JEC"],
  "on": ["Gma","DdW","FMl","Ef1","DdX","DdY","Ef0"],
  "on account of": ["JED"],
  "on and on": ["JEE"],
  "on average": ["JEF"],
  "on behalf of": ["JEG"],
  "on fire": ["F3Z","DIp","Ehv","Ehu"],
  "on foot": ["F3a"],
  "on hand": ["JEK"],
  "on holiday": ["HZ7"],
  "on Monday": ["HZ9"],
  "on no account": ["JEM"],
  "on one's own": ["JEN"],
  "on one's way": ["JEO"],
  "on purpose": ["JEP"],
  "on schedule": ["JEQ"],
  "on the bus": ["HaA"],
  "on the contrary": ["JET"],
  "on the fence": ["EJz","EJ0","EJ1"],
  "on the left": ["Gmb","DdZ","Ddb","Efx","Dda","Efw"],
  "on the left of the building": ["Efw"],
  "on the left of the sofa": ["Efx"],
  "on the other hand": ["JEV"],
  "on the receiving end": ["JEW"],
  "on the right": ["Gmc","Ddd","Dde","Ddc","Efy","Efz"],
  "on the right of the classroom": ["Efy"],
  "on the right of the flag": ["Efz"],
  "on the roof": ["Ef0"],
  "on the spot": ["JEX"],
  "on the table": ["F3c","Ef1"],
  "on the way": ["JEY"],
  "on the weekend": ["JEZ"],
  "on the whole": ["JEa"],
  "on time": ["HaB"],
  "on top": ["F3d","DYU"],
  "once": ["KOE"],
  "once and for all": ["JEH"],
  "once in a while": ["JEI"],
  "once upon a time": ["G87"],
  "one": ["GmV","F3Y","Dbs","FMi","Dbo"],
  "one another": ["G88"],
  "one apple": ["HZ3"],
  "one billion": ["G89"],
  "one book": ["HZ4"],
  "one hundred": ["GmU","Dbp","FMh"],
  "one hundred thousand": ["F3W","Dbq"],
  "one million": ["F3X","Dbr"],
  "one moment": ["HZ5"],
  "one thousand": ["GmW","Dbt"],
  "one way": ["HZ6"],
  "oneself": ["KOF"],
  "onfire": ["EJw"],
  "ongoing": ["JEJ"],
  "Oni": ["HZ8"],
  "onion": ["GmX","DIq","FMj","B45","B44","B41","B42","Egv","B43"],
  "onions": ["GmY","DIr","FMk","B48","B49","D3Z","B46"],
  "online": ["GmZ","B5D"],
  "online class": ["B5A","B5B"],
  "online retailer": ["JEL"],
  "only": ["F3b","DYT"],
  "onset": ["JER"],
  "onslaught": ["JES"],
  "onstage": ["KOG"],
  "ontario": ["KOH"],
  "onto": ["KOI"],
  "onward": ["KOJ"],
  "onwards": ["KOK"],
  "oocyte": ["KOL"],
  "ooh": ["KOM"],
  "Oort Cloud": ["HaC"],
  "ooze": ["JEb"],
  "opal": ["B5E"],
  "opaque": ["HaD"],
  "open": ["Gmd","Djt","FMm","Djv","Djs","Djr","EYj","EcT","Ehx","Dju","EcS","DYX","EYi","EJ4","DIs","Ehw"],
  "open a book": ["HaE"],
  "open a bottle": ["EcS","Djr"],
  "open a door": ["HaF"],
  "open a file": ["HaG"],
  "open a window": ["Djs","EcT"],
  "open cluster": ["HaH"],
  "open door": ["Ehx","Ehw"],
  "open in the morning": ["EYi"],
  "open minded": ["DYW"],
  "open opened": ["F3f","Djt","EUA","Djr","Djs","Dju","Djv"],
  "open the book": ["F3g","Dsq"],
  "open the box": ["HaI"],
  "open the door": ["Gme","Djt","EYj"],
  "open the gate": ["HaJ"],
  "open the lid": ["HaK"],
  "open the store": ["Dju"],
  "open the window": ["F3h","Djv"],
  "open up": ["HaL"],
  "open wide": ["HaM"],
  "open window": ["DYY"],
  "open your book": ["Gmf","Dsr"],
  "open your mouth": ["E17"],
  "opened": ["EUA"],
  "opened the window": ["EUA"],
  "opener": ["KON"],
  "opening": ["F3e","EcT","Djv","Djt","EcS","Djr","Djs","Dju"],
  "opening a bottle": ["EcS","Djr"],
  "opening a window": ["EcT","Djs"],
  "opening presents": ["DYV"],
  "opening the door": ["Djt"],
  "opening the store": ["Dju"],
  "opening the window": ["Djv"],
  "openly": ["KOO"],
  "openness": ["KOP"],
  "opera": ["Gmg","DYZ","B5F"],
  "operant": ["JEc"],
  "operate": ["JEd"],
  "operation": ["JEe"],
  "operational": ["KOQ"],
  "operative": ["KOR"],
  "operator": ["KOS"],
  "opinion": ["JEf"],
  "opossum": ["E18"],
  "opponent": ["JEg"],
  "opportunity": ["E19"],
  "oppose": ["F3j","DYa"],
  "opposed": ["JEh"],
  "opposite": ["Gmi","B5I","FMo","B5J","B5H"],
  "opposition": ["DYb"],
  "oppress": ["JEj"],
  "oppression": ["KOT"],
  "oppressive": ["JEi"],
  "opt": ["JEt"],
  "opt out": ["JEs"],
  "optic": ["JEk"],
  "optical": ["KOU"],
  "optician": ["F3k","DIt","DIu","B5K"],
  "optics": ["DYc"],
  "optimal": ["JEl"],
  "optimism": ["JEm"],
  "optimist": ["JEo"],
  "optimistic": ["JEn"],
  "optimization": ["KOV"],
  "optimize": ["JEp"],
  "optimum": ["KOW"],
  "option": ["JEr"],
  "optional": ["JEq"],
  "optometrist": ["B5N"],
  "or": ["KOj"],
  "or else": ["G9A"],
  "or so": ["JFH"],
  "oracle": ["HaN"],
  "oral": ["JEu"],
  "orange": ["Gmk","F3l","DIv","B5Q","B5X","B5R","DIz","Egw"],
  "orange hats": ["DIw","EgJ"],
  "orange juice": ["Gmj","DIx","FMp","B5V","D3a","B5U","B5T","DIy","B5S","B5W"],
  "orange shirt": ["DI0","Ef9"],
  "oranges": ["Gml","DI1","FMq","B5Y","B5Z","D3b"],
  "orangutan": ["JEv"],
  "oratorio": ["JEw"],
  "orbit": ["Gmm","DYd"],
  "orbital": ["JEx"],
  "orc": ["EJ8","EJ7"],
  "orca": ["F3m"],
  "orchard": ["F3n","B5e","B5c","B5b"],
  "orchestra": ["F3o"],
  "orchestral": ["KOX"],
  "orchestrate": ["KOY"],
  "orchid": ["F3p","B5g","B5f"],
  "ordain": ["KOZ"],
  "ordeal": ["JEy"],
  "order": ["Gmn","Djw","FMr","Djx","EbF","B5i","EYk","B5h"],
  "order a pizza": ["Djw","EYk"],
  "order food": ["F3q","Djx","EbF"],
  "order in": ["JEz"],
  "order ordered": ["Djw","EVf","ES8","Djx"],
  "ordered": ["EVf","ES8"],
  "ordered a pizza": ["EVf"],
  "ordered some food": ["ES8"],
  "ordering": ["EbF","Djx","Djw"],
  "ordering a pizza": ["Djw"],
  "ordering food": ["EbF","Djx"],
  "orderly": ["KOa"],
  "ordinal": ["JE0"],
  "ordinarily": ["KOb"],
  "ordinary": ["JE1"],
  "ordinate": ["JE2"],
  "ore": ["JE3"],
  "Oregon": ["KOc"],
  "organ": ["E2B"],
  "organic": ["JE4"],
  "organic chemistry": ["HaO"],
  "organised crime": ["JE5"],
  "organism": ["HaP"],
  "organisms": ["HaQ"],
  "organization": ["KOe"],
  "organizational": ["KOd"],
  "organize": ["E2A"],
  "organize holidays": ["EKA"],
  "organizer": ["KOf"],
  "organutan": ["E2C"],
  "orient": ["JE7"],
  "orientation": ["JE6"],
  "origin": ["JFB"],
  "original": ["JE8"],
  "originality": ["KOg"],
  "originally": ["KOh"],
  "originate": ["JFA"],
  "originate from": ["JE9"],
  "Orion": ["HaR"],
  "ornament": ["JFD"],
  "ornamental": ["JFC"],
  "ornaments": ["Gmo","Dss","FMs"],
  "ornate": ["JFE"],
  "ornithology": ["JFF"],
  "orphan": ["JFG"],
  "orphanage": ["KOi"],
  "orthodox": ["JFI"],
  "orthodoxy": ["KOk"],
  "os": ["KOn"],
  "Osaka": ["KOl"],
  "oscillation": ["KOm"],
  "Oslo": ["G9B"],
  "ostensibly": ["KOo"],
  "ostrich": ["Gmp","B5l","FMt","B5j","B5m","B5k"],
  "other": ["KOp"],
  "otherwise": ["G9C"],
  "otter": ["Gmq","B5p","FMu","B5o","B5n"],
  "ought": ["JFJ"],
  "ounce": ["KOq"],
  "our": ["E2D"],
  "ourselves": ["KOr"],
  "oust": ["KOs"],
  "out": ["F3s","E2E"],
  "out of breath": ["JFb"],
  "out of date": ["JFc"],
  "outback": ["JFK"],
  "Outback": ["KOt"],
  "outbreak": ["JFL"],
  "outburst": ["JFM"],
  "outcome": ["JFN"],
  "outcrop": ["KOu"],
  "outcry": ["JFO"],
  "outdate": ["KOv"],
  "outdated": ["JFP"],
  "outdoor": ["KOw"],
  "outer": ["KOx"],
  "outer space": ["HaS"],
  "outer suburbs": ["JFR"],
  "outermost": ["JFQ"],
  "outfit": ["JFS"],
  "outgas": ["JFT"],
  "outgoing": ["KOy"],
  "outlaw": ["JFU"],
  "outlet": ["F3r","B5q"],
  "outline": ["JFV"],
  "outlive": ["JFW"],
  "outlook": ["JFX"],
  "outlying": ["JFY"],
  "outmoded": ["JFZ"],
  "outnumber": ["JFa"],
  "outpatient": ["KOz"],
  "outperform": ["KO0"],
  "outpost": ["KO1"],
  "output": ["JFd"],
  "outrage": ["JFh"],
  "outraged": ["JFe"],
  "outrageous": ["JFg"],
  "outrageously": ["JFf"],
  "outreach": ["KO2"],
  "outright": ["JFi"],
  "outset": ["KO3"],
  "outside": ["Gmr","B5r","FMv"],
  "outsider": ["KO4"],
  "outskirt": ["KO5"],
  "outskirts": ["B5s"],
  "outsource": ["KO6"],
  "outspoken": ["JFj"],
  "outstanding": ["F3t","B5t"],
  "outstretch": ["KO7"],
  "outstretched": ["JFk"],
  "outward": ["KO8"],
  "outweigh": ["JFl"],
  "oval": ["Gms","B5x","FMw","B5w","B5v","B5u"],
  "ovarian": ["KO9"],
  "ovary": ["KPA"],
  "oven": ["Gmt","B51","FMx","B5y","B50","B5z"],
  "oven glove": ["G9D"],
  "oven mitts": ["G9E"],
  "over": ["F3v","E2G"],
  "over the bridge": ["HaU"],
  "over the moon": ["EKB","EKC","EKD"],
  "over the wall": ["HaW"],
  "over the water": ["E2I"],
  "over there": ["HaV"],
  "overact": ["JFm"],
  "overall": ["JFn"],
  "overboard": ["JFo"],
  "overcast": ["F3u","B55","DI2","B54","EhO"],
  "overcast sky": ["HaT"],
  "overcharge": ["JFp"],
  "overcome": ["E2F"],
  "overcrowd": ["KPB"],
  "overcrowded": ["JFq"],
  "overdo": ["KPC"],
  "overdose": ["JFr"],
  "overdue": ["JFs"],
  "overflow": ["JFt"],
  "overgraze": ["JFu"],
  "overhang": ["KPD"],
  "overhaul": ["JFv"],
  "overhead": ["JFw"],
  "overhear": ["KPE"],
  "overjoyed": ["JFx"],
  "overlap": ["JFy"],
  "overlay": ["KPF"],
  "overload": ["JFz"],
  "overlook": ["JF0"],
  "overly": ["KPG"],
  "overnight": ["JF1"],
  "overpopulated": ["JF2"],
  "overpopulation": ["F3w","B57","B56"],
  "overpower": ["KPH"],
  "override": ["KPI"],
  "overrun": ["JF3"],
  "overseas": ["E2H"],
  "oversee": ["JF4"],
  "overshadow": ["KPJ"],
  "oversight": ["KPK"],
  "oversleep": ["F3x","B58"],
  "overstate": ["KPL"],
  "overt": ["JF5"],
  "overtake": ["B59"],
  "overthrow": ["KPM"],
  "overtime": ["HaX"],
  "overturn": ["KPN"],
  "overview": ["JF6"],
  "overweight": ["Gmu","B6C","B6A","B6B"],
  "overwhelm": ["JF7"],
  "overwhelmingly": ["KPO"],
  "overwork": ["JF8"],
  "ovulation": ["KPP"],
  "ovum": ["KPQ"],
  "owe": ["JF9"],
  "owing to": ["JGA"],
  "owl": ["Gmv","B6E","FMy","DI3","B6H","EKE","B6F","D3c","B6D","B6G"],
  "own": ["JGB"],
  "own up": ["JGC"],
  "owner": ["F3y","B6J","B6I"],
  "ownership": ["KPR"],
  "ox": ["Gmw","B6M","FMz","B6K","B6L"],
  "oxide": ["HaY"],
  "oxygen": ["E2J"],
  "oyster": ["Gmx","B6O","B6P"],
  "ozone": ["HaZ"],
  "ozone layer": ["B6R"],
  "Ozzie": ["KqH","KqG"],
  "P": ["DaF","F6Z","FOn","HEN"],
  "p": ["DaG","GqI","HEC"],
  "pace": ["JGD"],
  "Pacific": ["KPU"],
  "Pacific Islander": ["KqM","KqL"],
  "Pacific Northwest": ["KPS"],
  "Pacific Ocean": ["KPT"],
  "pack": ["Gmz","Djy","FM0","EYl"],
  "pack a bag": ["F3z","Djy","EYl"],
  "pack packed": ["Djy"],
  "pack up": ["JGF"],
  "package": ["Gmy","B6W","B6T","B6S","B6U","B6V"],
  "packaging": ["F30","B6X"],
  "packed": ["JGE"],
  "packet": ["KPV"],
  "packing": ["F32","Djy"],
  "packing a bag": ["F31","Djy"],
  "pact": ["JGG"],
  "pad": ["Gm1","B6c","B6Y"],
  "pad out": ["JGH"],
  "paddle": ["Gm0","B6b","B6a","B6Z"],
  "paddles": ["F33","DI4"],
  "padel": ["Haa"],
  "padlock": ["F34","DI5"],
  "pagan": ["KPW"],
  "page": ["Gm2","B6d","FM1"],
  "pagoda": ["Gm3","Dst"],
  "paid": ["F35","Dsu","ETe"],
  "paid some money": ["ETe"],
  "pail": ["Gm4","B6f","B6e"],
  "pain": ["Gm5","B6i","B6g","B6h"],
  "painful": ["E2K"],
  "painfully": ["KPX"],
  "painless": ["E2L"],
  "painstaking": ["JGI"],
  "paint": ["GnB","Dj2","FM5","B6j","B62","Djz","B6l","EYm","Dj3","EbG","B6k","Dj1","Dj0","EYn"],
  "paint a fence": ["Hab"],
  "paint a picture": ["Gm6","Djz","EYm","B6n","Dj1","EbG","B6m","Dj0"],
  "paint beautifully": ["ERK"],
  "paint brush": ["Gm7","Dsv"],
  "paint painted": ["F4A","EUB","Djz","Dj2","Dj0","Dj1","Dj3"],
  "paint pictures": ["F4B","Dsw"],
  "paint roller": ["F4C","B65","B63"],
  "paint the wall": ["F4D","EYn","Dj3"],
  "paintball": ["Hac"],
  "paintbrush": ["Gm8","DI6","FM2","B6p","B6s","B6r","D3e","B6o","B6q"],
  "painted": ["F36","EUB"],
  "painted a picture": ["EUB"],
  "painter": ["Gm9","B6v","FM3","B6t","B6u"],
  "painting": ["GnA","F38","Dj2","FM4","Djz","B6w","B6x","Dj1","EbG","Dj0","Dj3","B60"],
  "painting a picture": ["F37","B6z","EbG","Djz","Dj0","Dj1"],
  "painting the wall": ["Dj3"],
  "paintings": ["F39","B61"],
  "paints": ["GnC","B67","B66"],
  "pair": ["F4E"],
  "pair off": ["JGJ"],
  "pajamas": ["GnD","B68","FM6","CI1"],
  "Pakistan": ["EKI"],
  "Pakistan flag": ["F4F","DI7"],
  "Pakistani": ["HED","KqN"],
  "pal": ["KPY"],
  "palace": ["GnE","B7A","FM7","B7E","B7C","B69","B7B","B7D"],
  "palatable": ["JGK"],
  "palate": ["JGL"],
  "pale": ["F4G","B7H","B7G","B7F"],
  "paleolithic": ["JGM"],
  "palette": ["Had"],
  "palm": ["F4H","E2M"],
  "palm tree": ["F4I","B7I","B7J","B7K"],
  "paltry": ["JGN"],
  "pamphlet": ["JGO"],
  "pan": ["GnI","B7M","FNA","B7e","B7L"],
  "pan out": ["JGS"],
  "Panama": ["HEF","F4J","B7Q","B7N"],
  "Panama Canal": ["Hae"],
  "Panamanian": ["HEE","KqO"],
  "pancake": ["GnF","B7S","B7R"],
  "pancakes": ["GnG","DI8","FM8","B7U","B7W","B7V","B7T"],
  "pancreas": ["B7X"],
  "pancreatic": ["KPZ"],
  "panda": ["GnH","B7b","FM9","DI9","B7Z","B7a","D3f","B7Y"],
  "pandas": ["F4K","B7c"],
  "pane": ["KPa"],
  "panel": ["JGP"],
  "pangolin": ["B7d"],
  "Pangu": ["Haf"],
  "panic": ["JGQ"],
  "panini": ["DJA"],
  "panorama": ["JGR"],
  "pant": ["KPb"],
  "pants": ["GnJ","DJB","FNB","DJC","B7f","D3g","B7i","B7h","B7j","B7g"],
  "papal": ["KPc"],
  "paparazzi": ["JGT"],
  "papaya": ["GnK","B7o","FNC","B7m","B7l","B7k"],
  "papaya salad": ["B7q"],
  "paper": ["GnN","DJE","FNE","B7r","D3i","B70"],
  "paper clip": ["GnL","B7u","FND","B7v","B7w"],
  "paper clips": ["GnM","B7x","B7z","DJD","D3h"],
  "paper towel": ["F4M","B72","B71"],
  "paper towels": ["F4N","DJF","B73"],
  "paperback": ["KPd"],
  "paperbag": ["F4L","B7t"],
  "paperwork": ["KPe"],
  "Papua New Guinea": ["EKK"],
  "Papua New Guinean": ["HEG","G9F"],
  "par": ["KPr"],
  "parachute": ["GnO","B74","B75"],
  "parade": ["GnP","B76","FNF"],
  "paradigm": ["JGU"],
  "paradise": ["F4O","B78","B77"],
  "paradox": ["JGV"],
  "paradoxically": ["KPf"],
  "paragraph": ["F4P","B79"],
  "Paraguay": ["HEI"],
  "Paraguayan": ["HEH","KqP"],
  "parallax": ["Hag"],
  "parallel": ["B8A"],
  "Paralympic Games": ["Hah"],
  "Paralympics": ["Hai"],
  "paralysis": ["JGW"],
  "paralyze": ["JGX"],
  "paramedic": ["GnQ","B8C","DJG","EKL","DJH","EKM"],
  "parameter": ["JGY"],
  "paramilitary": ["KPg"],
  "paramount": ["JGZ"],
  "paranoia": ["KPh"],
  "paranoid": ["KPi"],
  "paraphrase": ["JGa"],
  "parasite": ["JGb"],
  "parasol": ["B8F","B8D","B8E"],
  "parcel": ["F4Q","B8G"],
  "pardon": ["Hak"],
  "pardon me": ["Haj","G9G"],
  "pare back": ["JGc"],
  "pare down": ["JGd"],
  "parent": ["F4R","B8H"],
  "parental": ["KPj"],
  "parenthesis": ["KPk"],
  "parents": ["GnR","DZd","FNG","B8J","B8I","EKN"],
  "parents evening": ["G9H"],
  "Paricutin": ["Hal"],
  "Paris": ["F4S","Dsx"],
  "parish": ["KPl"],
  "Parisian": ["KqR","KqQ"],
  "parity": ["KPm"],
  "park": ["GnT","B8K","FNH","DJI","B8S","B8L","B8M"],
  "park the car": ["Han"],
  "parking": ["JGe"],
  "parking garage": ["F4T","B8P","B8N"],
  "parking lot": ["GnS","B8Q","B8R"],
  "parkour": ["Ham"],
  "parliament": ["Hao"],
  "parliamentary": ["KPn"],
  "parlor": ["KPo"],
  "parody": ["KPp"],
  "parole": ["KPq"],
  "parrot": ["GnU","DJJ","FNI","B8W","D3k","B8U","B8T","B8V"],
  "parse": ["KPs"],
  "parsec": ["Hap"],
  "part": ["JGl"],
  "part time": ["JGm"],
  "part with": ["JGn"],
  "Parthenon": ["Haq"],
  "partial": ["JGg"],
  "partiality": ["JGf"],
  "partially": ["KPt"],
  "participant": ["JGh"],
  "participate": ["JGi"],
  "participation": ["KPu"],
  "particle": ["Har"],
  "particles": ["Has"],
  "particular": ["JGj"],
  "particularly": ["KPv"],
  "partisan": ["KPw"],
  "partition": ["KPx"],
  "partly": ["KPy"],
  "partly cloudy": ["F4U","Dsy"],
  "partner": ["F4V","Dsz"],
  "partnership": ["JGk"],
  "party": ["GnW","B8X","FNJ","B8Y"],
  "party hat": ["GnV","Ds0"],
  "pas": ["KPz"],
  "pass": ["GnZ","Dj4"],
  "pass a test": ["F4W","Dj4"],
  "pass an exam": ["Hat"],
  "pass around": ["JGp"],
  "pass away": ["Hau"],
  "pass by": ["JGq"],
  "pass on": ["JGt"],
  "pass out": ["Hav"],
  "pass over": ["JGu"],
  "pass passed": ["EV5","Dj4"],
  "passage": ["JGo"],
  "passed": ["EV5"],
  "passed the test": ["EV5"],
  "passenger": ["GnX","B8a","FNK","B8Z"],
  "passengers": ["F4X","B8c","B8b"],
  "passing": ["Dj4"],
  "passing a test": ["Dj4"],
  "passion": ["JGr"],
  "passion fruit": ["GnY","B8d","B8f","B8g"],
  "passionate": ["KP1"],
  "passionately": ["KP0"],
  "passive": ["JGs"],
  "passport": ["Gna","B8j","FNL","B8i","B8h"],
  "password": ["Gnb","Ds1"],
  "past": ["Hax"],
  "pasta": ["Gnc","DJK","FNM","B8n","B8l","B8m","D3l","B8k"],
  "paste": ["Haw"],
  "pastel": ["JGv"],
  "pastime": ["JGw"],
  "pastor": ["KP3"],
  "pastoral": ["KP2"],
  "pastries": ["Gnd","B8q","B8o"],
  "pastry": ["F4Y","B8r","B8s"],
  "pasture": ["B8w","B8t","B8u","B8v"],
  "pat": ["Gng","B84"],
  "Patagonia": ["KP5"],
  "Patagonian": ["KP4"],
  "patch": ["JGx"],
  "patch up": ["JGy"],
  "patchy rain": ["Hay"],
  "patent": ["JGz"],
  "paternal": ["KP6"],
  "path": ["Gne","B8x","FNN","B8z","B8y"],
  "pathetic": ["JG0"],
  "pathogen": ["KP7"],
  "pathological": ["JG1"],
  "pathologist": ["KP8"],
  "pathology": ["JG2"],
  "pathway": ["KP9"],
  "patience": ["JG3"],
  "patient": ["Gnf","B80","FNO","B83","B81","B82"],
  "patiently": ["KQA"],
  "patio": ["KQB"],
  "patriarch": ["JG5"],
  "patriarchic": ["JG4"],
  "patriarchy": ["JG6"],
  "patriot": ["B88"],
  "patriotic": ["KQC"],
  "patriotism": ["KQD"],
  "patrol": ["KQE"],
  "patron": ["JG8"],
  "patronage": ["KQF"],
  "patronize": ["JG7"],
  "pattern": ["Gnh","B89","B9B","B9A"],
  "paucity": ["JG9"],
  "pause": ["JHA"],
  "pave": ["JHB"],
  "pavement": ["Gni","B9F","FNP","B9C","B9E"],
  "pavilion": ["KQG"],
  "paw": ["Gnj","B9I","FNQ","B9H","B9G","B9J"],
  "pawn": ["KQH"],
  "paws": ["Gnk","B9L","B9K"],
  "pay": ["Gnl","Dj6","FNR","EcU","B9N","B9P","EYo","Dj5","B9O","B9M"],
  "pay a visit": ["JHD"],
  "pay attention": ["F4Z","Ds2"],
  "pay attention to": ["JHC"],
  "pay back": ["Haz"],
  "pay down": ["JHE"],
  "pay for": ["JHF"],
  "pay money": ["EcU","Dj5","EYo"],
  "pay off": ["Ha1"],
  "pay paid": ["ETe","Dj6","Dj5"],
  "pay the bill": ["Ha2"],
  "pay up": ["JHG"],
  "payable": ["KQI"],
  "paycheck": ["KQJ"],
  "payer": ["KQK"],
  "paying": ["F4a","Dj6","EcU","Dj5"],
  "paying money": ["EcU","Dj5"],
  "payload": ["Ha0"],
  "payment": ["KQL"],
  "payoff": ["KQM"],
  "payroll": ["KQN"],
  "pc": ["F4b","B9Q"],
  "PE": ["GoA","F4c","F4q","E2N"],
  "PE kit": ["F4k"],
  "pea": ["Gnu","B9o"],
  "peace": ["Gnn","B9V","B9R","B9S"],
  "peaceful": ["Gnm","B9U","B9T"],
  "peacefully": ["KQO"],
  "peach": ["Gnp","B9W","FNS","DJN","B9c","Egx","DJL"],
  "peach blossom": ["F4d","B9X"],
  "peaches": ["Gno","DJM","B9b","B9a","D3m","B9Z"],
  "peacock": ["Gnq","B9f","FNT","DJO","B9e","D3n"],
  "peak": ["JHH"],
  "peanut": ["Gns","B9n","B9g"],
  "peanut butter": ["Gnr","DJP","B9i","B9h","B9j","B9k","B9l","B9m"],
  "peanuts": ["Gnt","Ds3","D3o"],
  "pear": ["Gnv","DJQ","FNU","B9v","B9r","B9p","Egy","B9q"],
  "pearl": ["B9s"],
  "pearls": ["B9t"],
  "pears": ["Gnw","DJR","FNV","B9w","B9y","B9x","D3p"],
  "peas": ["Gnx","DJS","FNW","B9z","B91","D3q","B90","DJT"],
  "peasant": ["KQP"],
  "peat": ["KQQ"],
  "pebble": ["JHI"],
  "pebbles": ["F4e","B95","B92","B93"],
  "peck": ["JHJ"],
  "peculiar": ["JHK"],
  "pedagogy": ["JHL"],
  "pedal": ["F4f","B96"],
  "pedals": ["B98"],
  "peddler": ["B99"],
  "pedestal": ["CAB","CAA"],
  "pedestrian": ["Gny","CAC","CAH"],
  "pedestrian crossing": ["F4g","CAF","CAD","CAG"],
  "pedestrians": ["F4h","CAJ"],
  "pediatric": ["KQR"],
  "pedigree": ["KQS"],
  "pee": ["KQU"],
  "peek": ["KQT"],
  "peel": ["Gnz","Dj7","FNX","CAK","CAL","EcV","CAN","CAM"],
  "peel a banana": ["Dj7","EcV"],
  "peel an orange": ["Ha3"],
  "peel off": ["JHM"],
  "peel peeled": ["Dj7"],
  "peeler": ["F4i","DJU","D3r"],
  "peeling": ["EcV","Dj7"],
  "peeling a banana": ["EcV","Dj7"],
  "peep": ["KQV"],
  "peer": ["JHN"],
  "peer group": ["Ha4"],
  "peg": ["Gn0","DJV","FNY","CAQ","CAO","D3s","CAP"],
  "Pegasus": ["Ha5"],
  "pegs": ["F4j","CAR"],
  "pelican": ["F4l","CAS","CAU","CAT"],
  "pellet": ["KQW"],
  "pen": ["Gn6","F4p","DJa","FNd","DJW","D3t","CAW","D3x","CAv","CAV","CAX"],
  "penal": ["KQX"],
  "penalize": ["JHO"],
  "penalty": ["JHP"],
  "pence": ["KQY"],
  "pencil": ["Gn2","F4n","DJY","FNa","CAd","CAZ","CAY","D3v","CAa"],
  "pencil box": ["F4m","CAb"],
  "pencil case": ["Gn1","DJX","FNZ","CAc","D3u"],
  "pencil sharpener": ["Gn3","CAh","FNb","CAg","CAi"],
  "pencils": ["Gn4","CAf","CAe","CAj"],
  "pendant": ["CAm","CAk","CAl"],
  "penetrate": ["JHQ"],
  "penetration": ["KQZ"],
  "penguin": ["Gn5","DJZ","FNc","CAp","CAo","CAn","D3w"],
  "penguins": ["F4o","CAr","CAq"],
  "penicillin": ["JHR"],
  "peninsula": ["Ha6","CAs"],
  "penmanship": ["JHS"],
  "Pennsylvania": ["KQa"],
  "penny": ["JHT"],
  "pens": ["KQd","Gn7","CAy","CAw","CAx"],
  "pension": ["KQc"],
  "pensioner": ["KQb"],
  "pensive": ["JHU"],
  "pentagon": ["Gn8","CAz","FNe"],
  "people": ["Gn9","CA0","FNf"],
  "pep": ["KQe"],
  "pepper": ["GoB","CA3","CA2","Egz","CA4","CA1","CA9"],
  "peppermint": ["CA7"],
  "pepperoni": ["CA8"],
  "peppers": ["GoC","CBD","FNg","CBB","CBA","D3y","CBC"],
  "peptide": ["KQf"],
  "per": ["JHu"],
  "perceive": ["JHV"],
  "percent": ["Ha7"],
  "percentage": ["KQg"],
  "perception": ["JHW"],
  "perceptive": ["JHX"],
  "perceptual": ["JHY"],
  "perch": ["JHZ"],
  "percolate": ["JHa"],
  "percussion": ["JHb"],
  "perennial": ["KQh"],
  "perfect": ["GoD","CBE"],
  "perfection": ["KQi"],
  "perfectly": ["KQj"],
  "perform": ["F4r","CBF","CBJ"],
  "perform on stage": ["EKO"],
  "performance": ["GoE","E2O","CBH","CBI","CBG"],
  "performer": ["KQk"],
  "perfume": ["GoF","CBM","FNh","CBK","CBL"],
  "perhaps": ["G9I"],
  "peril": ["KQl"],
  "perimeter": ["JHc"],
  "period": ["JHf"],
  "periodic": ["JHe"],
  "Periodic Table": ["Ha9"],
  "Periodic Table of Elements": ["Ha8"],
  "periodical": ["JHd"],
  "periodically": ["KQm"],
  "peripheral": ["JHg"],
  "periphery": ["JHh"],
  "perish": ["JHj"],
  "perishable": ["JHi"],
  "perjury": ["KQn"],
  "perk": ["KQo"],
  "perk up": ["JHk"],
  "permanence": ["JHl"],
  "permanent": ["JHm"],
  "permanent resident": ["KqT","KqS"],
  "permanently": ["KQp"],
  "permeate": ["JHn"],
  "permissible": ["KQq"],
  "permission": ["JHo"],
  "permit": ["JHp"],
  "pernicious": ["JHq"],
  "perpendicular": ["JHr"],
  "perpetrator": ["KQr"],
  "perpetual": ["JHs"],
  "perpetuate": ["JHt"],
  "perplex": ["KQs"],
  "perquisite": ["JHv"],
  "persecute": ["JHw"],
  "persecution": ["KQt"],
  "Persephone": ["HbA"],
  "Persian": ["KQv"],
  "Persian Gulf": ["KQu"],
  "Persians": ["Kr2"],
  "persist": ["JHy"],
  "persistence": ["KQw"],
  "persistent": ["JHx"],
  "person": ["F4t","E2P"],
  "persona": ["KQy"],
  "personal": ["JH1"],
  "personal consumption": ["JHz"],
  "personal trainer": ["F4s","DJb","DJc"],
  "personality": ["HbB"],
  "personalize": ["JH0"],
  "personally": ["KQx"],
  "personnel": ["JH2"],
  "perspective": ["JH3"],
  "perspicuous": ["JH4"],
  "perspire": ["JH5"],
  "persuade": ["JH6"],
  "persuasion": ["JH7"],
  "persuasive": ["JH8"],
  "pertain": ["JH9"],
  "pertinent": ["JIA"],
  "perturbation": ["KQz"],
  "Peru": ["HEJ","GoG","CBN","CBQ","CBP","EKR"],
  "Peruvian": ["HEK","KqU","G9J"],
  "pervasive": ["JIB"],
  "perverse": ["KQ0"],
  "pessimistic": ["JIC"],
  "pest": ["JIE"],
  "pesticide": ["JID"],
  "pet": ["GoH","CBS","FNi","CBR","CBY","CBT"],
  "pet food": ["CBV","CBW"],
  "pet shop": ["F4v","E2Q"],
  "pet store": ["GoK","DJe","D3z"],
  "petal": ["JIF"],
  "Peter": ["KQ1"],
  "peter out": ["JIG"],
  "petition": ["JIH"],
  "Petra": ["HbC"],
  "petrified": ["JII"],
  "petrochemicals": ["JIJ"],
  "petrol": ["F4u","CBb","CBc","CBZ"],
  "petrol station": ["GoI","CBd","CBe","CBf"],
  "petroleum": ["JIK"],
  "pets": ["GoJ","CBh","FNj","CBg"],
  "petty": ["KQ2"],
  "petty crime": ["JIL"],
  "pH": ["HbJ"],
  "phantom": ["JIM"],
  "pharaoh": ["JIN"],
  "pharmaceutical": ["JIO"],
  "pharmacist": ["GoL","DJg","FNk","CBj","DJf","CBk","CBi","EKS"],
  "pharmacy": ["GoM","DJh","FNl","CBl"],
  "Pharos of Alexandria": ["HbD"],
  "phase": ["JIP"],
  "phases of the moon": ["HbE"],
  "phenomenal": ["JIQ"],
  "phenomenon": ["JIR"],
  "phenotype": ["KQ3"],
  "pheromone": ["JIS"],
  "philanthropy": ["JIT"],
  "Philippines": ["GoN","CBp","CBm","EKU","CBn"],
  "Philippines flag": ["DJi"],
  "philosopher": ["KQ4"],
  "philosophical": ["KQ5"],
  "philosophy": ["JIU"],
  "phobia": ["HbF"],
  "Phoenix": ["HbG"],
  "phoenix": ["JIV"],
  "phone": ["GoO","DJl","FNm","DJj","CBt","CBq","ETd","CBr","D33","D31","CBs"],
  "phone charger": ["F4w","DJk"],
  "phone in": ["JIW"],
  "phone rang": ["ETd"],
  "phoneme": ["KQ6"],
  "phonetic": ["KQ7"],
  "phonological": ["KQ8"],
  "phonology": ["KQ9"],
  "phony": ["KRA"],
  "phosphate": ["KRB"],
  "phosphorus": ["HbH"],
  "phosphorylation": ["KRC"],
  "photo": ["GoR","CB2","FNp"],
  "photo album": ["F4x","CBu"],
  "photocopier": ["CBx"],
  "photocopy": ["KRD"],
  "photodissociation": ["JIX"],
  "photograph": ["E2R"],
  "photographer": ["GoP","DJm","FNn","CB0","DJn","EKV","CBy","CBz","D34","EKW"],
  "photographic": ["KRE"],
  "photography": ["GoQ","CB1","FNo"],
  "photon": ["KRF"],
  "photosynthesis": ["HbI"],
  "phrase": ["F4y","CB3"],
  "phrasebook": ["HbK"],
  "physic": ["KRI"],
  "physical": ["JIY"],
  "physical education": ["GoS","F4z","DJo","FNq","D35"],
  "physical therapy": ["CB4"],
  "physically": ["KRG"],
  "physician": ["JIZ"],
  "physicist": ["KRH"],
  "physics": ["GoT","DJp","FNr","CB6","CB5","D36"],
  "physiological": ["KRJ"],
  "physiology": ["JIa"],
  "physiotherapy": ["CB7"],
  "pi": ["KRU"],
  "pianist": ["KRK"],
  "piano": ["GoU","DJq","FNs","CB8","CCA","CCB","D37","CB9","CCC"],
  "Picasso": ["KRL"],
  "pick": ["GoV","Dj8","FNt","CCE","CCD","EbH","EcW","Dj9"],
  "pick a card": ["HbL"],
  "pick a number": ["HbM"],
  "pick apples": ["F40","Dj8","EbH"],
  "pick away": ["JIb"],
  "pick flowers": ["Dj9","EcW"],
  "pick fruit": ["HbN"],
  "pick on": ["JId"],
  "pick oneself up": ["JIc"],
  "pick out": ["HbP"],
  "pick picked": ["ES9","Dj8","Dj9"],
  "pick up": ["GoW","DkA","FNu","EKX","EbI"],
  "pick up litter": ["F42","EbI"],
  "pick up picked up": ["F43","DkA"],
  "pick up steam": ["JIe"],
  "pick up the phone": ["HbQ"],
  "pick your nose": ["HbR"],
  "picked": ["ES9"],
  "picked apples": ["ES9"],
  "picket": ["KRM"],
  "picking": ["F41","Dj8","Dj9","EcW","EbH"],
  "picking apples": ["Dj8","EbH"],
  "picking flowers": ["EcW","Dj9"],
  "picking up": ["EbI","DkA"],
  "pickle": ["KRN"],
  "pickleball": ["HbO"],
  "pickup": ["KRO"],
  "picky": ["JIf"],
  "picnic": ["GoX","CCH","FNv","CCI","CCG","CCF"],
  "pictionary": ["HbS"],
  "pictorial": ["JIg"],
  "picture": ["GoY","DJr","FNw","CCK","D38","CCL","CCJ"],
  "pictures": ["F44","CCM"],
  "picturesque": ["F45","CCP","CCO"],
  "pie": ["Goa","DJt","FNx","CCQ","CCZ","DJs","CCR","D39","CCS"],
  "piece": ["GoZ","CCY"],
  "piece by piece": ["JIh"],
  "piece of cake": ["F46","CCX","CCU","CCW"],
  "pier": ["F47","CCb","CCa"],
  "pierce": ["JIi"],
  "pig": ["God","DJu","FNz","D4A","CCr","CCf","CCe","CCg","CCh"],
  "pig pen": ["CCq"],
  "pigeon": ["Gob","CCj","FNy","CCk","CCi"],
  "piglet": ["Goc","CCo","CCn","CCp","CCm"],
  "pigment": ["JIj"],
  "pilates": ["HbT"],
  "pile": ["F48","CCu","CCt"],
  "pile on": ["JIk"],
  "pile out": ["JIl"],
  "pile up": ["JIm"],
  "pilgrim": ["KRQ"],
  "pilgrimage": ["KRP"],
  "pill": ["Gof","CCv","CC4","CCw"],
  "pillar": ["JIn"],
  "pillow": ["Goe","DJv","FN0","D4B","CCz","CCy","CCx"],
  "pillows": ["F49","CC3","CC0","CC2","CC1"],
  "pills": ["F5A","CC7","CC5","CC6"],
  "pilot": ["Gog","DJx","FN1","CDB","DJw","EKZ","EKY","CDA","CC9","CC8","D4C"],
  "pin": ["Gok","CDC","FN4","CDS"],
  "pin on": ["JIq"],
  "pinball": ["CDD"],
  "pinch": ["JIo"],
  "pine": ["Goi","CDM"],
  "pineapple": ["Goh","DJy","FN2","CDG","CDJ","D4D","CDE","CDF"],
  "pineapple juice": ["CDH","CDI"],
  "pineapples": ["F5B","CDL","CDK"],
  "pinecone": ["F5C","Ds4"],
  "ping pong": ["F5D","CDN","CDO","CDP","CDQ"],
  "pink": ["Goj","F5E","DJz","FN3"],
  "pink shirt": ["EgA"],
  "pink tshirt": ["DJ0"],
  "pinnacle": ["JIp"],
  "pinocchio": ["CDR"],
  "pinpoint": ["JIr"],
  "pins": ["F5F","DJ1"],
  "pint": ["KRR"],
  "pinwheel": ["E2S"],
  "pioneer": ["JIs"],
  "pip": ["E2U","E2T"],
  "pipe": ["Gol","Ds5"],
  "pipeline": ["KRS"],
  "pipette": ["KRT"],
  "pique": ["JIt"],
  "piracy": ["JIu"],
  "piranha": ["F5G","CDT"],
  "pirate": ["Gom","CDV","CDW","CDU","EKa"],
  "pirate ship": ["F5H","CDY","CDX"],
  "Pisces": ["HbU"],
  "piss": ["KRV"],
  "piss off": ["JIv"],
  "pistol": ["KRW"],
  "pit": ["JIx"],
  "pitch": ["Gon","Ds6"],
  "pitch in": ["JIw"],
  "pitcher": ["F5I","CDa","CDZ"],
  "pitfall": ["KRX"],
  "pity": ["JIy"],
  "pivot": ["JIz"],
  "pivotal": ["KRY"],
  "pixel": ["KRZ"],
  "pizza": ["Goo","CDd","FN5","DJ3","DJ2","CDg","D4F","CDc","CDe","CDf","CDb"],
  "place": ["F5J","E2V"],
  "place under": ["JI0"],
  "placebo": ["KRa"],
  "placement": ["KRb"],
  "placid": ["JI1"],
  "plague": ["JI2"],
  "plaid": ["F5K","CDh"],
  "plain": ["Gop","CDi"],
  "plainly": ["KRc"],
  "plaintiff": ["KRd"],
  "plan": ["F5L","E2W"],
  "plan ahead": ["JI3"],
  "plan for": ["JI5"],
  "plane": ["Goq","DJ4","FN6","D4G","CDk","CDm","CDl","CDo","CDn","CDj"],
  "planet": ["Gor","CDp","DJ5","D4H"],
  "planetary": ["JI4"],
  "planets": ["Gos","CDs","CDq","CDr"],
  "plank": ["JI6"],
  "plankton": ["JI7"],
  "planner": ["KRe"],
  "plant": ["Gou","DJ6","FN7","DkB","D4I","CDv","CDy","EYp","CDt","CDw","CDu","CDx"],
  "plant a tree": ["Got","EYp","DkB","EKb"],
  "plant flowers": ["F5M","E2X"],
  "plant planted": ["EVb","DkB"],
  "plant seeds": ["HbV"],
  "plantation": ["JI8"],
  "planted": ["EVb"],
  "planted a tree": ["EVb"],
  "planting": ["F5O","DkB"],
  "planting a tree": ["F5N","DkB"],
  "plants": ["Gov","CDz","FN8","CD0","CD1"],
  "plaque": ["JI9"],
  "plasma": ["JJA"],
  "plaster": ["F5P"],
  "plastic": ["Gox","CD7","FN9","CD2","CD3"],
  "plastic bag": ["Gow","CD5","CD6","CD4"],
  "plastic bottle": ["F5Q"],
  "plastic straw": ["CD8"],
  "plate": ["Goy","DJ7","FOA","CEB","CED","D4J","CEC"],
  "plateau": ["HbW"],
  "platelet": ["KRf"],
  "plates": ["F5R","CEF","CEE"],
  "platform": ["Goz","CEG","CEH"],
  "platinum": ["KRg"],
  "platitude": ["JJB"],
  "Plato": ["KRi"],
  "platoon": ["KRh"],
  "platypus": ["Go0","Ds7"],
  "plaudit": ["JJC"],
  "plausible": ["JJD"],
  "play": ["GpN","DkC","Edf","DkG","DkP","DkD","DkE","DkM","DkF","DkK","Edd","EYv","DkR","DkJ","DkT","Ede","EYr","DkI","DkL","DkQ","EbL","EYq","Edc","EbJ","EYx","EYw","DkS","EbK","EYt","DkH","EYu","EYs","DkN"],
  "play a boardgame": ["Go1","DkC"],
  "play a game": ["Go2","DkD","FOB"],
  "play a guitar": ["Go3","DkE"],
  "play a part in": ["JJF"],
  "play a video game": ["Go4","DkF"],
  "play alone": ["HbX"],
  "play along": ["JJE"],
  "play an instrument": ["F5S","E2Y"],
  "play at": ["JJG"],
  "play badminton": ["Go5"],
  "play baseball": ["F5T","EKc"],
  "play basketball": ["Go6","DkG","FOC","EYq"],
  "play board games": ["F5U","EYr","EKd"],
  "play cards": ["Go7","DkI","DkH","Edc"],
  "play cards played cards": ["DkH"],
  "play chess": ["Go8","DkJ","FOD","EbJ"],
  "play computer games": ["Go9","EYs"],
  "play cricket": ["HbY"],
  "play dodgeball": ["HbZ"],
  "play down": ["JJI"],
  "play fairly": ["Hba"],
  "play football": ["GpB","DkK","FOE","Edd"],
  "play frisbee": ["E2a"],
  "play games": ["F5X","E2b"],
  "play games on your phone": ["EYt"],
  "play golf": ["Hbb"],
  "play guitar": ["F5Y","E2c"],
  "play hide and seek": ["F5Z","E2d"],
  "play hockey": ["F5a","Ds8"],
  "play in the garden": ["Hbc"],
  "play in the park": ["F5o","E2h"],
  "play music": ["GpM","DkL","EYu"],
  "play nicely": ["Hbd"],
  "play off": ["JJJ"],
  "play on a swing": ["F5p","DkM","EYv"],
  "play outside": ["F5q","E2i"],
  "play played": ["F5r","DkT","EU8","DkC","DkK","EV6","DkF","DkG","EWR","DkD","DkE","DkI","DkJ","DkL","DkN"],
  "play pool": ["EbK","DkN"],
  "play rugby": ["Hbe"],
  "play saxophone": ["DkO"],
  "play soccer": ["GpO","DkP","FOI","EYw"],
  "play sport": ["F5s","EKf"],
  "play sports": ["F5t"],
  "play table tennis": ["F5u","EKg"],
  "play tag": ["E2j"],
  "play tennis": ["GpP","DkQ","FOJ","Ede","EKh"],
  "play tennis badly": ["ERL"],
  "play the drums": ["GpQ","Ds9"],
  "play the flute": ["EKi"],
  "play the flute well": ["ERM"],
  "play the guitar": ["GpR","DkR","FOK","EbL","EKj","EYx"],
  "play the guitar badly": ["ERN"],
  "play the piano": ["GpS","DtA","FOL"],
  "play the trumpet": ["F5v","DkS"],
  "play the violin": ["F5w","EKk"],
  "play together": ["Hbf"],
  "play tricks on": ["JJH"],
  "play up": ["JJK"],
  "play video games": ["GpT","DkT","FOM","Edf"],
  "play videogames": ["F5x"],
  "play volleyball": ["GpU","EKl"],
  "play with friend": ["F5y","DtB"],
  "play with friends": ["GpV","DtC","FON"],
  "play with toys": ["F5z"],
  "played": ["GpA","EU8","EV6","EWR"],
  "played a board game": ["EWR"],
  "played soccer": ["EU8"],
  "played the trumpet": ["EV6"],
  "player": ["F5V","E2Z"],
  "playful": ["F5W","CEI"],
  "playground": ["GpC","DJ8","FOF","CEL","CEK"],
  "playing": ["GpH","DkC","DkT","DkE","DkP","DkK","Edf","DkD","DkG","DkJ","DkM","Edd","DkS","DkF","DkH","DkI","DkQ","DkR","Ede","Edc","EbL","EbK","EbJ","DkL","DkN"],
  "playing a boardgame": ["F5b","DkC"],
  "playing a game": ["F5c","DkD"],
  "playing a guitar": ["GpD","DkE"],
  "playing a video game": ["F5d","DkF"],
  "playing badminton": ["F5e","E2e"],
  "playing basketball": ["GpE","DkG","FOG"],
  "playing board games": ["F5f"],
  "playing card games": ["F5g"],
  "playing cards": ["F5h","DkH","DkI","Edc"],
  "playing chess": ["GpF","DkJ","EbJ"],
  "playing football": ["GpG","DkK","FOH","Edd"],
  "playing games": ["F5i","E2f"],
  "playing music": ["F5j","DkL"],
  "playing on a swing": ["DkM"],
  "playing pool": ["EbK","DkN"],
  "playing saxophone": ["DkO"],
  "playing soccer": ["GpI","DkP"],
  "playing tennis": ["GpJ","DkQ","Ede"],
  "playing the guitar": ["GpK","DkR","EbL"],
  "playing the piano": ["F5k","E2g"],
  "playing the trumpet": ["DkS"],
  "playing video games": ["GpL","DkT","Edf"],
  "playing videogames": ["F5l"],
  "playing volleyball": ["F5m"],
  "playing with marbles": ["F5n"],
  "playoff": ["KRj"],
  "playwright": ["JJL"],
  "plaza": ["KRk"],
  "plea": ["JJN"],
  "plead": ["JJM"],
  "pleasant": ["F50","CEM"],
  "pleasant weather": ["Hbg"],
  "pleasantly": ["KRl"],
  "please": ["GpW","DtD"],
  "please and thank you": ["Hbh"],
  "please help": ["Hbj"],
  "please sit down": ["Hbk"],
  "please wait": ["Hbl"],
  "pleased": ["F51","EKm"],
  "pleased to meet you": ["Hbi"],
  "pleasing": ["JJO"],
  "pleasure": ["JJP"],
  "pledge": ["JJQ"],
  "plentiful": ["KRm"],
  "plenty": ["G9L"],
  "plenty of": ["G9K"],
  "plenty of fish in the sea": ["EKn","EKo","EKp"],
  "pliable": ["JJR"],
  "pliant": ["JJS"],
  "pliers": ["F52","CEP","CEN","CEO"],
  "plight": ["JJT"],
  "plot": ["JJU"],
  "plough": ["F53","CEV","CEU","CEQ"],
  "plough through": ["JJV"],
  "plow": ["CEV","CEQ","CEU"],
  "ploy": ["JJW"],
  "pluck": ["KRn"],
  "pluck up": ["JJX"],
  "plug": ["GpX","DJ9","CEX","CEY","CEa","D4K","DKB"],
  "plug hole": ["D4L","DKA"],
  "plug in": ["F54","Dkh","CEZ","EYy","DkU"],
  "plug in a laptop": ["EYy","DkU"],
  "plug in plugged in": ["Dkh"],
  "plug plugged": ["DkU"],
  "plugging in": ["Dkh","DkU"],
  "plugging in a laptop": ["DkU"],
  "plum": ["GpZ","CEc","CEb","DKE","Eg0","CEh"],
  "plumage": ["JJY"],
  "plumb": ["KRo"],
  "plumber": ["GpY","DKD","FOO","DKC","CEe","EKs","EKr","CEd","D4N","CEf"],
  "plumbing": ["JJZ"],
  "plume": ["KRp"],
  "plummet": ["KRq"],
  "plump": ["Gpa","CEg","FOP","CEi"],
  "plums": ["Gpb","DKF","CEm","CEl","D4O","CEj","CEk"],
  "plunge": ["JJa"],
  "plunger": ["CEn"],
  "plural": ["KRr"],
  "pluralism": ["JJb"],
  "plus": ["Gpc","CEq","CEp"],
  "plus sign": ["E2k"],
  "pluto": ["Gpd","F55","CEr"],
  "plutonium": ["KRs"],
  "ply": ["KRt"],
  "pneumonia": ["JJc"],
  "poach": ["JJd"],
  "poached egg": ["F56","CEs"],
  "poached eggs": ["CEt"],
  "pocket": ["Gpe","CEw","FOQ","CEu","CEv"],
  "pocketbook": ["JJe"],
  "pod": ["KRu"],
  "podium": ["JJf"],
  "poem": ["F57","CEz","CEx"],
  "poet": ["F58","CE0"],
  "poetic": ["JJg"],
  "poetry": ["JJh"],
  "poignant": ["JJi"],
  "point": ["Gpf","CE2","FOR","DkW","EbM","CE1"],
  "point at": ["F6A","DkV"],
  "point at a clock": ["F59","DkV"],
  "point at the board": ["Hbm"],
  "point at the clock": ["EbM"],
  "point at the TV": ["F6B","DkW"],
  "point out": ["Hbn"],
  "point pointed": ["ETA","DkV","DkW"],
  "pointed": ["ETA"],
  "pointed at a TV": ["ETA"],
  "pointer": ["KRv"],
  "pointing": ["F6D","DkW","EbM"],
  "pointing at": ["DkV"],
  "pointing at a clock": ["F6C","DkV"],
  "pointing at the TV": ["DkW"],
  "pointless": ["KRw"],
  "poise": ["KRx"],
  "poison": ["F6E","DtE"],
  "poisonous": ["Gpg","CE4","CE3"],
  "poke": ["JJj"],
  "poker": ["KRy"],
  "Poland": ["Gph","CE9","FOS","CE6","EKt","CE7"],
  "Poland flag": ["DKG"],
  "polar": ["JJk"],
  "polar bear": ["Gpi","CFC","FOT","CFB","CFA"],
  "polarize": ["KRz"],
  "pole": ["F6G","DtF"],
  "Pole": ["KqV"],
  "Pole Star": ["Hbo"],
  "pole vault": ["Hbp"],
  "Poles": ["Kr3"],
  "police": ["Gpm","CFK"],
  "police car": ["Gpj","CFE","CFF","CFD"],
  "police man": ["F6H","D4P"],
  "police officer": ["Gpl","DKI","FOV","CFH","DKH","EKv","CFG","CFI","CFJ","EKu"],
  "police station": ["Gpn","CFL","FOW"],
  "police woman": ["DtG"],
  "policeman": ["Gpk","D4P","FOU"],
  "policewoman": ["F6I","DtG"],
  "policies": ["Hbq"],
  "policy": ["Hbr"],
  "policymaker": ["KR0"],
  "polish": ["G9M","CFM"],
  "Polish": ["HEL"],
  "polish off": ["JJl"],
  "polite": ["F6J","E2l"],
  "politely": ["KR1"],
  "politeness": ["KR2"],
  "political": ["KR4"],
  "political party": ["Hbs"],
  "politically": ["KR3"],
  "politician": ["Gpo","DKK","DKJ","EKw","CFN"],
  "politics": ["Hbt"],
  "polity": ["KR5"],
  "polka dot": ["F6K","CFO"],
  "poll": ["JJn"],
  "pollen": ["Hbu"],
  "pollinate": ["JJm"],
  "pollster": ["KR6"],
  "pollutant": ["JJo"],
  "pollute": ["F6L","CFQ","CFS"],
  "polluted": ["Gpp","CFR"],
  "pollution": ["Gpq","CFV","FOX","CFT","CFU"],
  "polo": ["Hbv"],
  "polo shirt": ["Gpr","DKL","D4R"],
  "polyester": ["JJp"],
  "polygamous": ["JJq"],
  "polygamy": ["JJr"],
  "polygon": ["JJs"],
  "polymer": ["KR8"],
  "polymerase": ["KR7"],
  "polymorphism": ["KR9"],
  "Polynesia": ["KSB"],
  "Polynesian": ["KSA","KqW","KqX"],
  "polynomial": ["KSC"],
  "pom": ["KSD","KqY"],
  "pomegranate": ["Gps","CFX","CFa","CFY","CFW","CFZ"],
  "pomelo": ["Gpt","CFd","CFc","CFb"],
  "pond": ["Gpu","CFf","FOY","CFj","CFg","CFi","CFe","CFh"],
  "ponder": ["JJu"],
  "ponderous": ["JJt"],
  "pony": ["Gpv","CFm","CFl","CFk","CFo"],
  "ponytail": ["Gpw","CFp","CFq"],
  "ponytails": ["CFs"],
  "pool": ["Gpx","DKN","FOZ","CFv","DKM","CFw","CFt","CFu","D4S"],
  "pool party": ["E2m"],
  "poor": ["Gpy","CFx","FOa","EKy"],
  "poorly": ["KSE"],
  "pop": ["E2n"],
  "pop a balloon": ["Hbw"],
  "pop music": ["F6M","CF2"],
  "pop out": ["JJv"],
  "pop star": ["F6O","CF9"],
  "popcorn": ["Gpz","DKO","FOb","D4T","CF1","CF0","CFz","CFy"],
  "pope": ["KSF"],
  "poppy": ["F6N","CF4","CF5","CF6","CF3"],
  "popsicle": ["Gp0","CF7","CF8"],
  "popular": ["F6P"],
  "popularity": ["KSG"],
  "populate": ["JJw"],
  "population": ["Hbx","Gp1","CGB","CGA"],
  "populist": ["KSH"],
  "porcelain": ["JJx"],
  "porch": ["Gp2","CGE","CGC","CGD"],
  "porcine": ["KSI"],
  "porcupine": ["F6Q","CGH","CGF"],
  "pore": ["JJy"],
  "pork": ["Gp3","DKQ","FOc","Eg2","CGJ","CGK","CGM","CGI"],
  "pork belly": ["CGL"],
  "pork chop": ["F6R","DKP","Eg1"],
  "porous": ["JJz"],
  "porridge": ["Gp4","CGQ","CGO","CGN"],
  "port": ["Gp5","CGV","CGR","CGT","CGS","CGU"],
  "portable": ["JJ0"],
  "portal": ["KSJ"],
  "porter": ["KSK"],
  "portfolio": ["KSL"],
  "portion": ["JJ1"],
  "portrait": ["F6S","DtH"],
  "portraiture": ["JJ2"],
  "portray": ["JJ3"],
  "portrayal": ["KSM"],
  "Portugal": ["HEM","Gp6","CGZ","FOd","CGW","CGX","EKz","CGY"],
  "Portugal flag": ["DKR"],
  "Portuguese": ["F6T","Kr4","KqZ"],
  "pose": ["JJ4"],
  "Poseidon": ["Hby"],
  "posh": ["KSN"],
  "posit": ["JJ6"],
  "position": ["JJ5"],
  "positive": ["F6U","CGa","CGb"],
  "positively": ["KSO"],
  "possess": ["JJ7"],
  "possession": ["KSP"],
  "possessive": ["KSQ"],
  "possibility": ["KSR"],
  "possible": ["JJ8"],
  "possibly": ["KSS"],
  "post": ["JKB"],
  "post office": ["GqA","DKS","FOh"],
  "postage": ["JJ9"],
  "postal": ["KST"],
  "postcard": ["Gp7","CGc","FOe","CGe","CGd"],
  "poster": ["Gp8","CGh","FOf","CGf","CGg","CGi"],
  "posterior": ["KSU"],
  "postgraduate": ["KSV"],
  "posthumous": ["JKA"],
  "postman": ["Gp9","CGj","FOg"],
  "postpone": ["JKC"],
  "postulate": ["JKD"],
  "posture": ["JKE"],
  "postwar": ["KSW"],
  "pot": ["GqE","CG0","FOl","CGl","CGm","CGk"],
  "pot calling the kettle black": ["EK0","EK1","EK2"],
  "potassium": ["Hbz"],
  "potato": ["GqD","CGn","FOk","CGy","CGp","Eg3","CGo"],
  "potato chips": ["GqB","DKT","FOi","CGq","CGs","CGr","CGt"],
  "potatoes": ["GqC","DKU","FOj","CGx","D4V","CGu","CGv","CGw"],
  "potency": ["JKF"],
  "potent": ["KSY"],
  "potential": ["JKG"],
  "potentially": ["KSX"],
  "potion": ["F6V","CGz"],
  "potted plant": ["CG1","CG2"],
  "pottery": ["GqF","DtI"],
  "pouch": ["JKH"],
  "poultry": ["F6W","CG3","CG4"],
  "pound": ["JKI"],
  "pour": ["GqG","DkX","FOm","DkY","CG5","CG8","EcX","CG6","CG7","EYz"],
  "pour a drink": ["EYz"],
  "pour carefully": ["Hb0"],
  "pour coffee": ["EcX","DkX"],
  "pour into a cup": ["Hb2"],
  "pour milk": ["Hb3"],
  "pour out": ["JKJ"],
  "pour poured": ["DkX","EUC","DkY"],
  "pour the tea": ["Hb4"],
  "pour water": ["Hb5"],
  "poured": ["EUC"],
  "poured coffee": ["EUC"],
  "pouring": ["EcX","DkY","DkX"],
  "pouring coffee": ["EcX","DkX"],
  "pouring rain": ["Hb1"],
  "poverty": ["F6X","CG9"],
  "powder": ["E2o"],
  "power": ["Hb6","GqH","CHD"],
  "power socket": ["CHE"],
  "powerful": ["F6Y","CHC","CHA","CHB"],
  "powerfully": ["KSZ"],
  "powerless": ["KSa"],
  "practicable": ["JKK"],
  "practical": ["JKL"],
  "practicality": ["KSb"],
  "practically": ["KSc"],
  "practice": ["F6a","E2p"],
  "practice the piano": ["GqJ","DtJ","FOo"],
  "practice the saxophone": ["EK3"],
  "practise": ["Hb7"],
  "practitioner": ["JKM"],
  "pragmatic": ["JKN"],
  "Prague": ["G9N"],
  "prairie": ["JKO"],
  "praise": ["JKP"],
  "prawn": ["F6b","CHG","CHF","CHH"],
  "prawns": ["GqK","CHL","CHK","CHJ","CHI"],
  "pray": ["GqL","CHO","CHN","CHP"],
  "prayer": ["KSd"],
  "pre": ["KS4"],
  "preach": ["JKQ"],
  "preacher": ["KSe"],
  "precarious": ["JKR"],
  "precaution": ["JKT"],
  "precautionary": ["JKS"],
  "precede": ["JKU"],
  "precedence": ["KSf"],
  "precedent": ["KSg"],
  "preceding": ["JKV"],
  "precinct": ["KSh"],
  "precious": ["JKX"],
  "precious metal": ["JKW"],
  "precipitate": ["Hb8"],
  "precipitation": ["KSi"],
  "precise": ["JKY"],
  "precisely": ["KSj"],
  "precision": ["KSk"],
  "preclude": ["KSl"],
  "precursor": ["JKZ"],
  "predation": ["JKa"],
  "predator": ["GqM","CHR","CHQ","CHS","CHT"],
  "predecessor": ["JKb"],
  "predetermine": ["KSm"],
  "predicament": ["JKc"],
  "predicate": ["KSn"],
  "predict": ["JKd"],
  "predictable": ["KSo"],
  "predictably": ["KSp"],
  "prediction": ["KSq"],
  "predictive": ["KSr"],
  "predictor": ["KSs"],
  "predispose": ["JKe"],
  "predominant": ["JKf"],
  "predominantly": ["KSt"],
  "predominate": ["JKg"],
  "preeminent": ["JKh"],
  "preface": ["KSu"],
  "prefer": ["E2q"],
  "preferable": ["KSv"],
  "preferably": ["KSw"],
  "preference": ["JKi"],
  "preferential": ["KSx"],
  "prefix": ["KSy"],
  "pregnancy": ["KSz"],
  "pregnant": ["JKj"],
  "prehistoric": ["JKk"],
  "prejudice": ["Hb9"],
  "prejudiced": ["JKl"],
  "preliminary": ["JKm"],
  "preliterate": ["JKn"],
  "prelude": ["JKo"],
  "premature": ["JKp"],
  "prematurely": ["KS0"],
  "premier": ["JKq"],
  "premiere": ["KS1"],
  "premise": ["JKr"],
  "premium": ["JKs"],
  "prenatal": ["KS2"],
  "preoccupation": ["JKt"],
  "preoccupy": ["KS3"],
  "prep": ["KS6"],
  "preparation": ["F6c","CHU"],
  "prepare": ["GqN","DtK"],
  "preponderance": ["JKu"],
  "preposition": ["KS5"],
  "prerequisite": ["JKv"],
  "preschool": ["KS8"],
  "preschooler": ["KS7"],
  "prescribe": ["JKw"],
  "prescriber": ["KS9"],
  "prescription": ["JKx"],
  "presence": ["JKy"],
  "present": ["GqO","CHW","FOp","Ehg","CHV","DkZ","CHZ","EY0"],
  "present a TV show": ["EK4"],
  "present information": ["EY0"],
  "present presented": ["DkZ"],
  "presentation": ["JKz"],
  "presenter": ["F6d","CHY"],
  "presenting": ["DkZ"],
  "presently": ["JK0"],
  "presents": ["GqP","CHa","FOq","CHb","Ehh","CHd","EK5","CHc"],
  "preservation": ["KTA"],
  "preserve": ["F6e","CHf","CHe"],
  "preside": ["JK2"],
  "presidency": ["JK1"],
  "president": ["GqQ","CHg"],
  "presidential": ["KTB"],
  "press": ["F6f","Dka","Dkb","EcY"],
  "press a button": ["EcY","Dka"],
  "press down": ["HcA"],
  "press enter": ["HcB"],
  "press hard": ["HcC"],
  "press on": ["HcD"],
  "press play": ["HcE"],
  "press pressed": ["ETf","Dka","Dkb"],
  "press the button": ["Dkb"],
  "pressed": ["ETf"],
  "pressed a button": ["ETf"],
  "pressed for time": ["JK3"],
  "pressing": ["EcY","Dkb","Dka"],
  "pressing a button": ["EcY","Dka"],
  "pressing the button": ["Dkb"],
  "pressure": ["HcF"],
  "pressurise": ["JK4"],
  "prestige": ["JK5"],
  "prestigious": ["KTC"],
  "presumably": ["KTD"],
  "presume": ["JK6"],
  "presumption": ["KTE"],
  "pretend": ["JK7"],
  "pretense": ["KTF"],
  "pretension": ["JK8"],
  "pretentious": ["JK9"],
  "pretext": ["JLA"],
  "pretty": ["GqR","CHi","FOr"],
  "pretzel": ["F6g","DKV","Eg4","CHj","CHk","CHm"],
  "prevail": ["JLC"],
  "prevailing": ["JLB"],
  "prevalence": ["KTG"],
  "prevalent": ["JLD"],
  "prevent": ["JLE"],
  "prevention": ["KTH"],
  "preventive": ["KTI"],
  "preview": ["JLF"],
  "previous": ["JLG"],
  "previously": ["KTJ"],
  "prey": ["F6h","CHo","CHp","CHq"],
  "prey on": ["JLH"],
  "price": ["GqS","CHr","FOs","CHs"],
  "priceless": ["KTK"],
  "prices": ["HcG"],
  "pricey": ["KTL"],
  "prickly": ["F6i","DtL"],
  "pride": ["JLI"],
  "priest": ["F6j","DtM"],
  "primal": ["JLJ"],
  "primary": ["JLK"],
  "primate": ["JLL"],
  "prime": ["JLM"],
  "prime minister": ["HcH"],
  "primer": ["KTM"],
  "primitive": ["CHu","CHt"],
  "primordial": ["JLN"],
  "prince": ["GqT","CHv","FOt"],
  "princess": ["GqU","CHw","FOu","CHx"],
  "principal": ["GqV","CHz","CHy"],
  "principal's office": ["F6k","CH0"],
  "principally": ["KTN"],
  "principle": ["JLO"],
  "print": ["GqX","Dkc","CH1","CH5"],
  "print printed": ["Dkc"],
  "printer": ["GqW","DKW","FOv","CH2","CH4","D4W"],
  "printing": ["Dkc"],
  "prior": ["JLR"],
  "prioritize": ["JLP"],
  "priority": ["JLQ"],
  "prism": ["HcI"],
  "prison": ["F6l","DtN"],
  "prisoner": ["KTO"],
  "prisoner of war": ["HcJ"],
  "pristine": ["KTP"],
  "privacy": ["JLS"],
  "private": ["JLT"],
  "privately": ["KTQ"],
  "privatization": ["KTR"],
  "privatize": ["KTS"],
  "privilege": ["JLU"],
  "prize": ["GqY","CH7","FOw","CH6","CH8"],
  "pro": ["KTy"],
  "proactive": ["JLV"],
  "probability": ["KTT"],
  "probable": ["JLW"],
  "probably": ["G9O"],
  "probation": ["KTU"],
  "probe": ["JLX"],
  "problem": ["HcK","GqZ","DtO","FOx"],
  "problematic": ["JLY"],
  "procedural": ["KTV"],
  "procedure": ["JLZ"],
  "proceed": ["JLa"],
  "process": ["JLc"],
  "procession": ["JLb"],
  "processor": ["KTW"],
  "proclaim": ["JLd"],
  "procure": ["KTY"],
  "procurement": ["KTX"],
  "prod": ["JLf"],
  "prodigious": ["JLe"],
  "produce": ["JLg"],
  "producer": ["HcL"],
  "product": ["Gqa","DtP"],
  "product design": ["HcM"],
  "production": ["HcN"],
  "productive": ["JLh"],
  "productivity": ["HcO"],
  "prof": ["JLm"],
  "profess": ["KTb"],
  "profession": ["JLi"],
  "professional": ["Gqb","CIA","CH9"],
  "professionalism": ["KTZ"],
  "professionally": ["KTa"],
  "professor": ["Gqc","CIC","FOy","CIB"],
  "proficiency": ["KTc"],
  "proficient": ["JLj"],
  "profile": ["JLk"],
  "profit": ["HcP"],
  "profitability": ["KTd"],
  "profitable": ["F6m","CID"],
  "profound": ["JLl"],
  "profoundly": ["KTe"],
  "progesterone": ["KTf"],
  "prognosis": ["KTg"],
  "program": ["Gqe","DtQ"],
  "programme": ["F6n"],
  "programmer": ["Gqd","CIE","FOz"],
  "progress": ["F6o","CIF"],
  "progression": ["KTh"],
  "progressive": ["JLn"],
  "progressively": ["KTi"],
  "prohibit": ["JLp"],
  "prohibition": ["KTj"],
  "prohibitive": ["JLo"],
  "project": ["E2r"],
  "projection": ["KTk"],
  "projector": ["Gqf","CIH","FO0","CIG","CII"],
  "proliferate": ["JLq"],
  "proliferation": ["KTl"],
  "prolific": ["JLr"],
  "prolong": ["JLt"],
  "prolonged": ["JLs"],
  "promenade": ["KTm"],
  "Prometheus": ["HcQ"],
  "prominence": ["KTn"],
  "prominent": ["JLu"],
  "prominently": ["KTo"],
  "promise": ["F6p","CIJ"],
  "promising": ["JLv"],
  "promote": ["JLw"],
  "promoter": ["KTp"],
  "promotion": ["KTq"],
  "promotional": ["JLx"],
  "prompt": ["JLz"],
  "promptly": ["JLy"],
  "promulgate": ["KTr"],
  "prone": ["JL0"],
  "pronoun": ["KTt"],
  "pronounce": ["JL2"],
  "pronounced": ["JL1"],
  "pronouncement": ["KTs"],
  "pronucleus": ["KTu"],
  "pronunciation": ["HcR"],
  "proof": ["JL3"],
  "proofread": ["JL4"],
  "prop": ["JMG"],
  "propaganda": ["KTv"],
  "propagate": ["JL5"],
  "propagation": ["KTw"],
  "propel": ["JL6"],
  "propensity": ["JL7"],
  "proper": ["JL8"],
  "properly": ["KTx"],
  "properties": ["E2s"],
  "property": ["JL9"],
  "prophecy": ["JMA"],
  "prophet": ["JMB"],
  "proponent": ["JMC"],
  "proportion": ["JMD"],
  "proportional": ["KTz"],
  "proposal": ["JME"],
  "propose": ["JMF"],
  "proposition": ["KT0"],
  "proprietary": ["KT1"],
  "proprietor": ["JMH"],
  "propulsion": ["JMI"],
  "prose": ["JMK"],
  "prosecute": ["JMJ"],
  "prosecution": ["KT2"],
  "prosecutor": ["KT3"],
  "prosodic": ["KT4"],
  "prospect": ["JMM"],
  "prospective": ["KT5"],
  "prospector": ["JML"],
  "prospectus": ["KT6"],
  "prosper": ["JMO"],
  "prosperity": ["JMN"],
  "prosperous": ["KT7"],
  "protagonist": ["JMP"],
  "protect": ["Gqg","CIK","FO1"],
  "protect a from b": ["JMQ"],
  "protection": ["KT8"],
  "protective": ["KT9"],
  "protector": ["KUA"],
  "protein": ["JMR"],
  "protest": ["HcS"],
  "protester": ["KUB"],
  "protocol": ["KUC"],
  "proton": ["KUD"],
  "protons": ["HcT"],
  "prototype": ["HcU"],
  "protract": ["KUE"],
  "protrude": ["JMS"],
  "proud": ["Gqh","DKX","FO2","EK6","CIL"],
  "proudly": ["KUF"],
  "prove": ["JMT"],
  "prove to be": ["JMV"],
  "proverb": ["JMU"],
  "provide": ["JMX"],
  "provide for": ["JMW"],
  "provider": ["KUG"],
  "province": ["JMY"],
  "provincial": ["KUH"],
  "provincialism": ["JMZ"],
  "provision": ["JMa"],
  "provisional": ["KUI"],
  "provocative": ["JMb"],
  "provoke": ["JMc"],
  "prowess": ["KUJ"],
  "proximal": ["KUK"],
  "proximity": ["JMd"],
  "proxy": ["KUL"],
  "prudent": ["JMe"],
  "prune": ["F6q","CIM"],
  "pry": ["KUM"],
  "psyche": ["KUN"],
  "psychiatric": ["JMf"],
  "psychiatrist": ["HcV"],
  "psychiatry": ["JMg"],
  "psychic": ["JMh"],
  "psychoanalysis": ["JMi"],
  "psychological": ["KUP"],
  "psychologically": ["KUO"],
  "psychologist": ["HcW"],
  "psychology": ["HcX"],
  "psychosocial": ["KUQ"],
  "psychotic": ["JMj"],
  "pub": ["F6t","CIN","CIO","CIR"],
  "public": ["E2t"],
  "public holiday": ["G9P"],
  "public restroom": ["F6r","CIP"],
  "public spending": ["HcY"],
  "public transport": ["F6s","CIQ"],
  "publication": ["JMk"],
  "publicity": ["JMl"],
  "publicize": ["JMm"],
  "publicly": ["KUR"],
  "publish": ["JMn"],
  "publisher": ["KUS"],
  "pudding": ["Gqi","CIS","CIT"],
  "puddle": ["Gqj","DtR","FO3"],
  "pueblo": ["JMo"],
  "Puerto Rican": ["KUT"],
  "Puerto Rico": ["KUU"],
  "puff": ["JMp"],
  "pull": ["Gqk","Dkd","FO4","EbN"],
  "pull a rope": ["F6u","Dkd","EbN"],
  "pull at": ["JMq"],
  "pull away": ["JMr"],
  "pull back": ["JMs"],
  "pull faces": ["Hca"],
  "pull in": ["JMt"],
  "pull off": ["JMu"],
  "pull one's leg": ["JMv"],
  "pull out": ["JMw"],
  "pull over": ["Hcb"],
  "pull pulled": ["ETB","Dkd"],
  "pull the door": ["Hcc"],
  "pull the rope": ["Hcd"],
  "pull through": ["JMx"],
  "pull together": ["JMy"],
  "pull up": ["Hce"],
  "pull ups": ["CIU"],
  "pulled": ["ETB"],
  "pulled a rope": ["ETB"],
  "pulley": ["HcZ"],
  "pulling": ["F6v","Dkd","EbN"],
  "pulling a rope": ["Dkd","EbN"],
  "pulling your hair out": ["EK7","EK8","EK9"],
  "pullover": ["F6w"],
  "pulmonary": ["KUV"],
  "pulp": ["JMz"],
  "pulpit": ["KUW"],
  "pulsar": ["Hcf"],
  "pulse": ["JM0"],
  "pump": ["F6x","CIV","Dke","CId"],
  "pump gas": ["Dke"],
  "pump pumped": ["Dke"],
  "pump up": ["JM1"],
  "pumping": ["Dke"],
  "pumping gas": ["Dke"],
  "pumpkin": ["Gqm","DKY","FO5","CIc","CIZ","D4X","CIW","CIX","CIY"],
  "pumpkin pie": ["Gql","CIa","CIb"],
  "pun": ["KUc"],
  "punch": ["F6y","Dkf","CIe"],
  "punch a monster": ["Dkf"],
  "punch in": ["JM2"],
  "punch punched": ["Dkf"],
  "punch up": ["JM3"],
  "punching": ["Dkf"],
  "punching a monster": ["Dkf"],
  "punctual": ["JM4"],
  "punctuality": ["KUX"],
  "punctuate": ["KUY"],
  "puncture": ["JM5"],
  "pundit": ["KUZ"],
  "pungent": ["JM6"],
  "punish": ["JM8"],
  "punishment": ["JM7"],
  "punitive": ["KUa"],
  "punk": ["KUb"],
  "pup": ["Gqp","CIn"],
  "pupil": ["Gqn","CIh","FO6","CIf","CIg"],
  "pupils": ["F6z"],
  "puppet": ["Gqo","CIk","FO7","CIi"],
  "puppeteer": ["CIj"],
  "puppies": ["F60","CIm","CIl"],
  "puppy": ["Gqq","CIr","FO8","CIo","CIp","CIq"],
  "purchase": ["E2u"],
  "purchaser": ["KUd"],
  "pure": ["JM9"],
  "pure substance": ["Hcg"],
  "purely": ["KUe"],
  "purge": ["KUf"],
  "purify": ["KUg"],
  "puritanical": ["JNA"],
  "purity": ["JNB"],
  "purple": ["Gqr","F61","DKZ"],
  "purple socks": ["F62","DKa","EgK"],
  "purport": ["KUh"],
  "purpose": ["JNC"],
  "purse": ["Gqs","DKb","FO9","CIt","CIw","CIv","CIs","D4Y","CIu"],
  "pursuant": ["KUi"],
  "pursue": ["JND"],
  "pursuit": ["JNE"],
  "push": ["Gqt","Dkg","FPA","EbO","CIx"],
  "push a car": ["F63","Dkg","EbO"],
  "push a door": ["Hch"],
  "push a trolley": ["Hci"],
  "push back": ["JNF"],
  "push hard": ["Hcj"],
  "push me": ["Hck"],
  "push off": ["JNG"],
  "push over": ["JNH"],
  "push pushed": ["ETC","Dkg"],
  "push the button": ["Hcl"],
  "push the door": ["Hcm"],
  "push through": ["JNI"],
  "push ups": ["F65","CIy","CIz"],
  "pushed": ["ETC"],
  "pushed a car": ["ETC"],
  "pushing": ["F64","Dkg","EbO"],
  "pushing a car": ["EbO","Dkg"],
  "put": ["Gqw","Dkl","FPB","Dkk","Dki","EbP","Dkm","EY3","EY2","EY4"],
  "put a bottle in the bin": ["EY2","Dki"],
  "put across": ["JNJ"],
  "put aside": ["JNK"],
  "put away": ["Gqu","Dkj","EcZ","ELB"],
  "put away groceries": ["EcZ"],
  "put away put away": ["Dkj"],
  "put away toys": ["Hcn"],
  "put back": ["Hco"],
  "put books in a bag": ["Dkk"],
  "put books in bag": ["EbP"],
  "put down": ["Hcp"],
  "put food in a microwave": ["Dkl"],
  "put food in the microwave": ["EY3"],
  "put forth": ["JNL"],
  "put forward": ["JNM"],
  "put into": ["Hcq"],
  "put it here": ["Hcr"],
  "put ketchup on a burger": ["EY4","Dkm"],
  "put off": ["Hcs"],
  "put on": ["Gqv","Dkn","Dko","Dkp","EbQ","ETD","EbR"],
  "put on a coat": ["F66","Dkn","EbQ"],
  "put on a hat": ["ETD"],
  "put on makeup": ["Hct"],
  "put on put on": ["Dko"],
  "put on shoes": ["F67","Dkp","EbR"],
  "put out": ["F7A","Dkr","EbS","Dkq"],
  "put out a fire": ["F68","Dkq","EbS"],
  "put out fires": ["F69","ELD"],
  "put out put out": ["Dkr"],
  "put over": ["JNN"],
  "put put": ["F7B","Dkk","Dkl","Dki","Dkm"],
  "put someone up": ["JNO"],
  "put something down": ["JNP"],
  "put something down to": ["JNQ"],
  "put the book down": ["Hcu"],
  "put through": ["JNR"],
  "put together": ["JNS"],
  "put toys away": ["F7D"],
  "put up": ["F7E","Dks","Edg"],
  "put up decorations": ["Edg"],
  "put up put up": ["Dks"],
  "put up with": ["Hcv"],
  "putative": ["KUj"],
  "putt": ["KUk"],
  "putting": ["EbP","Dki","Dkk","Dkl","Dkm"],
  "putting a bottle in the bin": ["Dki"],
  "putting away": ["EcZ","Dkj"],
  "putting books in a bag": ["Dkk"],
  "putting food in a microwave": ["Dkl"],
  "putting ketchup on a burger": ["Dkm"],
  "putting on": ["Dkn","EbR","EbQ","Dko","Dkp"],
  "putting on a coat": ["F7C","Dkn","EbQ"],
  "putting on shoes": ["Dkp","EbR"],
  "putting out": ["EbS","Dkr","Dkq"],
  "putting out a fire": ["EbS","Dkq"],
  "putting up": ["Dks","Edg"],
  "puzzle": ["Gqx","CI0","FPC"],
  "puzzle out": ["JNT"],
  "puzzles": ["Gqy","DtS"],
  "pyjamas": ["Gqz","CI1","FPD","B68"],
  "pylorus": ["KUl"],
  "pyramid": ["Gq0","CI5","FPE","CI4","CI3","CI2"],
  "Pyramids of Giza": ["Hcw"],
  "python": ["F7F","CI6"],
  "Q": ["DaH","Gq1","F7G","HER"],
  "q": ["DaI","HEO"],
  "q tips": ["CI7"],
  "Qatar": ["HEQ"],
  "Qatari": ["HEP","Kqa"],
  "qilin": ["Hcx"],
  "quadruple": ["JNU"],
  "quail": ["Gq2","CI8","CJA","CI9"],
  "quaint": ["JNV"],
  "quake": ["KUm"],
  "qualification": ["Hcy"],
  "qualify": ["JNW"],
  "qualitative": ["KUn"],
  "quality": ["JNX"],
  "quality control": ["Hcz"],
  "quantify": ["JNY"],
  "quantitative": ["JNZ"],
  "quantity": ["JNa"],
  "quantum": ["JNb"],
  "quarantine": ["Hc0"],
  "quarrel": ["JNc"],
  "quarry": ["Hc1"],
  "quarter": ["Hc2","G9Q"],
  "quarter past 1": ["F7I","DeL"],
  "quarter past 10": ["DeM"],
  "quarter past 11": ["DeK"],
  "quarter past 2": ["DeN"],
  "quarter past eleven": ["F7K","DeK","EfX"],
  "quarter past one": ["F7L","DeL","EfY"],
  "quarter past six": ["F7M","EfZ"],
  "quarter past ten": ["F7N","DeM"],
  "quarter past twelve": ["F7O","Efa"],
  "quarter past two": ["F7P","DeN"],
  "quarter to 1": ["DeR"],
  "quarter to 10": ["DeS"],
  "quarter to 12": ["DeT"],
  "quarter to 4": ["DeQ"],
  "quarter to 5": ["DeP"],
  "quarter to 8": ["DeO"],
  "quarter to eight": ["F7V","DeO","Efb"],
  "quarter to five": ["F7W","DeP","Efc"],
  "quarter to four": ["F7X","Efd","DeQ"],
  "quarter to one": ["DeR"],
  "quarter to ten": ["DeS"],
  "quarter to twelve": ["DeT"],
  "quarterback": ["KUo"],
  "quarterly": ["JNd"],
  "quartet": ["KUp"],
  "quartz": ["JNe"],
  "quasar": ["Hc3"],
  "quash": ["JNf"],
  "Quebec": ["KUq"],
  "queen": ["Gq3","CJB","FPF"],
  "Queen Victoria": ["KUr"],
  "quell": ["JNg"],
  "quench": ["JNh"],
  "query": ["JNi"],
  "quest": ["JNk"],
  "question": ["Gq4","CJC","FPG","CJD"],
  "question mark": ["G9R"],
  "questionable": ["KUs"],
  "questionnaire": ["JNj"],
  "queue": ["Gq5","CJE"],
  "queue up": ["JNl"],
  "quick": ["Gq7","CJF","ELG"],
  "quicken": ["KUt"],
  "quickly": ["Gq6","DtT","ERC"],
  "quid": ["KUu"],
  "quiescent": ["JNm"],
  "quiet": ["Gq8","DKd","FPH","ELH","Ehy","CJG"],
  "quieter": ["DKc"],
  "quietly": ["F7Y","ERY"],
  "quilt": ["Gq9","DtU","FPI"],
  "quirky": ["KUv"],
  "quit": ["F7Z","CJI","CJH"],
  "quite": ["JNo"],
  "quite a few": ["JNn"],
  "quiver": ["JNp"],
  "quiz": ["GrA","CJJ","FPJ"],
  "quiz show": ["F7a"],
  "quota": ["JNq"],
  "quotation": ["JNr"],
  "quote": ["JNs"],
  "quotient": ["JNt"],
  "R": ["DaJ","Gsw","F8u","FQM","HEU"],
  "r": ["DaK","HES"],
  "rabbi": ["KUw"],
  "rabbit": ["GrB","F7b","DKe","FPK","CJL","D4Z","CJN","CJM","CJK","CJO"],
  "rabbits": ["GrC","DtV"],
  "raccoon": ["GrD","CJP","FPL","CJR","CJS","CJQ"],
  "race": ["GrE","CJU","FPM","CJT"],
  "race car": ["F7c"],
  "racer": ["KUx"],
  "racial": ["JNu"],
  "racing": ["JNv"],
  "racism": ["Hc4"],
  "racist": ["KUy"],
  "rack": ["F7d","CJa","CJW","CJV"],
  "rack up": ["JNw"],
  "racket": ["GrF","CJZ","FPN","CJX","CJY"],
  "racquetball": ["Hc5"],
  "radar": ["JNx"],
  "radial": ["KUz"],
  "radiant": ["KU0"],
  "radiate": ["F7e","CJd","CJc"],
  "radiation": ["Hc6"],
  "radiator": ["KU1"],
  "radical": ["JNy"],
  "radically": ["KU2"],
  "radio": ["GrG","CJe","FPO","CJf"],
  "radio telescope": ["Hc7"],
  "radioactive": ["JNz"],
  "radiotherapy": ["KU3"],
  "radish": ["GrH","CJj","FPP","CJg","CJi","CJh"],
  "radius": ["JN0"],
  "raft": ["JN1"],
  "rafting": ["GrI","DtW"],
  "rag": ["GrJ","CJk","FPQ"],
  "rag on": ["JN4"],
  "rage": ["JN2"],
  "ragged": ["JN3"],
  "raid": ["KU4"],
  "rail": ["E2v"],
  "railroad": ["F7f","CJn","CJm","CJl"],
  "railway": ["GrK","DtX"],
  "railway station": ["GrL","CJo","CJp"],
  "rain": ["GrQ","DKj","FPV","Dkt","DKf","D4c","CJq","CJs","CJ6","CJr"],
  "rain boots": ["F7g","CJt"],
  "rain rained": ["Dkt"],
  "rain shower": ["Hc8"],
  "rainbow": ["GrM","DKh","FPR","CJu","CJx","DKg","D4a","CJv","CJw"],
  "raincoat": ["GrN","DKi","FPS","D4b","CJy","CJz"],
  "raindrops": ["F7h"],
  "rained": ["ETZ"],
  "rainfall": ["JN5"],
  "rainforest": ["GrO","CJ1","FPT","CJ3","CJ2","CJ0"],
  "raining": ["GrP","Dkt","FPU","CJ5","CJ4"],
  "raining cats and dogs": ["ELI","ELJ","ELK"],
  "rainy": ["GrR","CJ8","FPW","CJ7","ELL"],
  "rainy day": ["Hc9"],
  "raise": ["JN6"],
  "raise money": ["E2w"],
  "raise your hand": ["HdA"],
  "raise your voice": ["HdB"],
  "raisin": ["F7i","CJ9","CKB"],
  "raisins": ["GrS","CKE","CKD","CKC"],
  "rake": ["GrT","CKF","FPX","CKG","CKH","CKI"],
  "rake it in": ["JN7"],
  "rake up": ["JN8"],
  "rally": ["JN9"],
  "ram": ["GrU","CKJ","FPY","CKL","CKK"],
  "ramble": ["JOA"],
  "ramification": ["KU5"],
  "ramp": ["KU6"],
  "ramp up": ["JOC"],
  "rampant": ["JOB"],
  "ran": ["GrV","EUD"],
  "ranch": ["F7j","CKP","CKO","CKM"],
  "rancher": ["JOD"],
  "rancorous": ["JOE"],
  "random": ["CKQ"],
  "randomize": ["KU7"],
  "randomly": ["KU8"],
  "range": ["JOF"],
  "ranger": ["CKR"],
  "rank": ["JOG"],
  "ransom": ["JOH"],
  "rant": ["KU9"],
  "rap": ["HdC"],
  "rapid": ["JOJ"],
  "rapidly": ["JOI"],
  "rapper": ["KVA"],
  "rare": ["JOK"],
  "rarely": ["F7k","DtY"],
  "rarity": ["KVB"],
  "rash": ["GrW","DKk","CKS","D4d"],
  "raspberries": ["GrX","CKT","CKU","CKV"],
  "raspberry": ["GrY","CKZ","FPZ","CKW","CKX"],
  "raspberry juice": ["CKY"],
  "rat": ["GrZ","DKl","FPa","D4e","CKc","CKe","CKb","CKa","CKd"],
  "rat out": ["JOT"],
  "ratchet up": ["JOL"],
  "rate": ["JOM"],
  "rather": ["JON"],
  "rather than": ["G9S"],
  "ratification": ["KVC"],
  "ratify": ["JOO"],
  "ratio": ["JOS"],
  "ration": ["JOR"],
  "rational": ["JOQ"],
  "rationale": ["KVD"],
  "rationality": ["JOP"],
  "rationalize": ["KVE"],
  "rattle": ["JOU"],
  "rattlesnake": ["F7l","CKf"],
  "ravage": ["JOV"],
  "rave": ["KVF"],
  "raven": ["JOW"],
  "ravine": ["JOX"],
  "raw": ["JOY"],
  "ray": ["F7m","DtZ"],
  "rayon": ["JOZ"],
  "razor": ["F7n","DKm"],
  "re": ["E25"],
  "reach": ["Gra","CKi","CKg"],
  "reach out to": ["JOa"],
  "reaching": ["CKh"],
  "react": ["F7o","CKj"],
  "reaction": ["HdD"],
  "reactions": ["HdE"],
  "reactive": ["KVG"],
  "reactivity": ["KVH"],
  "reactor": ["JOb"],
  "read": ["Grg","Dkz","Dkv","Dku","Eca","EY6","CKo","ETE","CKk","CKl","Dkw","Dkx","EbT","EbU","Dky","EVi"],
  "read a book": ["Grb","Dku","FPb","Dkv","Eca","EY6","Dkw","ETE","ELM"],
  "read a newspaper": ["F7q","Dky","EbU"],
  "read a story": ["HdG"],
  "read again": ["HdF"],
  "read aloud": ["F7p","Dkx","EbT"],
  "read aloud read aloud": ["Dkx"],
  "read books": ["Grc","Dta","FPc"],
  "read carefully": ["HdH"],
  "read comic books": ["F7r"],
  "read comics": ["Grd","Dtb"],
  "read on": ["HdI"],
  "read out": ["ELN"],
  "read read": ["Grh","Dkz","ETE","Dkv","Dky","Dku","EVi","Dkw"],
  "read the book": ["EVi"],
  "read the newspaper": ["HdJ"],
  "read through": ["JOe"],
  "read up on": ["JOf"],
  "readability": ["JOc"],
  "readable": ["KVI"],
  "reader": ["KVJ"],
  "readership": ["KVK"],
  "readily": ["JOd"],
  "readiness": ["KVL"],
  "reading": ["Grf","F7w","Dkz","FPe","Dkv","Eca","Dku","CKm","CKn","Dkw","EbU","EbT","Dkx","Dky"],
  "reading a book": ["Gre","Dku","FPd","Dkv","Eca","Dkw"],
  "reading a newspaper": ["F7t","Dky","EbU"],
  "reading aloud": ["F7s","Dkx","EbT"],
  "reading books": ["F7u","Dtc"],
  "reading comics": ["F7v"],
  "ready": ["Gri","CKp"],
  "ready for": ["HdK"],
  "ready or not": ["HdL"],
  "ready to go": ["HdM"],
  "reaffirm": ["KVM"],
  "real": ["JOk"],
  "real estate agent": ["ELP","ELO","DKn","DKo"],
  "realism": ["KVN"],
  "realist": ["KVP"],
  "realistic": ["JOg"],
  "realistically": ["KVO"],
  "reality": ["KVQ"],
  "realization": ["JOh"],
  "realize": ["F7x","CKq"],
  "really": ["JOi"],
  "realm": ["JOj"],
  "realtor": ["JOl"],
  "reap": ["KVS"],
  "reappear": ["KVR"],
  "reapply": ["JOm"],
  "rear": ["JOn"],
  "rearrange": ["KVT"],
  "reason": ["JOq"],
  "reason out": ["JOp"],
  "reasonable": ["JOo"],
  "reasonably": ["KVU"],
  "reassurance": ["KVV"],
  "reassure": ["JOr"],
  "rebate": ["JOs"],
  "rebel": ["JOu"],
  "rebellion": ["KVW"],
  "rebellious": ["JOt"],
  "rebound": ["KVX"],
  "rebuild": ["KVY"],
  "rebuke": ["KVZ"],
  "recall": ["JOv"],
  "recapture": ["KVa"],
  "recede": ["JOw"],
  "receipt": ["Grj","CKr","FPf","CKs"],
  "receivable": ["KVb"],
  "receive": ["Grk","Dk1","Dk0","CKt","EY7"],
  "receive a letter": ["HdN"],
  "receive a package": ["EY7","Dk1"],
  "receive an email": ["Dk0"],
  "receive received": ["ETh","Dk0","Dk1"],
  "received": ["ETh"],
  "received an email": ["ETh"],
  "receiver": ["JOx"],
  "receiving": ["Dk1","Dk0"],
  "receiving a package": ["Dk1"],
  "receiving an email": ["Dk0"],
  "recent": ["JOz"],
  "recently": ["JOy"],
  "receptacle": ["JO0"],
  "reception": ["Grm","CKz","CKu"],
  "reception desk": ["CKw"],
  "receptionist": ["Grl","CKy","FPg","CKx","ELR","DKq","ELQ","DKp"],
  "receptive": ["JO1"],
  "receptor": ["JO2"],
  "recess": ["G9T"],
  "recession": ["HdO"],
  "recessive": ["JO3"],
  "recharge": ["JO5"],
  "rechargeable": ["JO4"],
  "recipe": ["G9U"],
  "recipie": ["DYe"],
  "recipient": ["JO6"],
  "reciprocal": ["JO7"],
  "reciprocity": ["JO8"],
  "recital": ["JO9"],
  "recite": ["JPA"],
  "reckless": ["JPB"],
  "reckon": ["KVc"],
  "reclaim": ["KVd"],
  "recline": ["JPC"],
  "recliner": ["DKr"],
  "recognition": ["JPD"],
  "recognizable": ["KVe"],
  "recognize": ["JPE"],
  "recoil": ["JPF"],
  "recollection": ["JPG"],
  "recommend": ["F7y","DYf"],
  "recommendation": ["KVf"],
  "reconcile": ["JPH"],
  "reconciliation": ["KVg"],
  "reconsider": ["KVh"],
  "reconstruct": ["KVi"],
  "reconstruction": ["JPI"],
  "record": ["F7z","Dtd"],
  "recorder": ["Grn","CK0","FPh"],
  "recount": ["JPJ"],
  "recoup": ["JPK"],
  "recourse": ["KVj"],
  "recover": ["JPL"],
  "recovery": ["KVk"],
  "recreate": ["KVl"],
  "recreation": ["JPM"],
  "recreational": ["KVm"],
  "recruit": ["JPN"],
  "recruitment": ["KVn"],
  "rectangle": ["Gro","CK1","FPi"],
  "rectangular": ["F70","CK2"],
  "rectify": ["JPO"],
  "recur": ["JPP"],
  "recurrence": ["KVo"],
  "recurrent": ["KVp"],
  "recurring": ["JPQ"],
  "recyclable": ["JPR"],
  "recycle": ["Grp","CK5","FPj","CK4","CK3"],
  "recycling": ["F72","CK9"],
  "recycling bank": ["CK6"],
  "recycling bin": ["F71","CK7","CK8"],
  "red": ["Grs","F74","DKy"],
  "red and blue": ["DKs"],
  "red and green": ["DKt"],
  "red and white": ["DKu"],
  "red and yellow": ["DKv"],
  "red apple": ["F73","CLA"],
  "red giant": ["HdP"],
  "red glasses": ["DKw","EgL"],
  "red hair": ["Grq","CLB","FPk","CLD","CLC","CLE"],
  "red jacket": ["EgB"],
  "red pepper": ["Grr","CLG","CLH","CLF"],
  "red shift": ["HdQ"],
  "red shoes": ["EgM"],
  "red socks": ["DKz"],
  "red T shirt": ["F75"],
  "reddish": ["JPS"],
  "redeem": ["JPT"],
  "redemption": ["KVq"],
  "redesign": ["KVr"],
  "rediscover": ["KVs"],
  "redneck": ["Kqc","Kqb"],
  "redress": ["KVt"],
  "redshift": ["HdR"],
  "reduce": ["JPU"],
  "reduction": ["KVu"],
  "redundancy": ["KVv"],
  "redundant": ["JPV"],
  "reed": ["JPW"],
  "reef": ["JPX"],
  "reek of": ["JPY"],
  "reel": ["CLI"],
  "reelection": ["KVw"],
  "ref": ["KV7"],
  "refer": ["JPa"],
  "refer to a as b": ["JPb"],
  "referee": ["Grt","DK0","DK1","CLJ","CLK","ELT","ELS","CLL"],
  "reference": ["JPZ"],
  "referendum": ["KVx"],
  "referent": ["KVz"],
  "referential": ["KVy"],
  "referral": ["KV0"],
  "refill": ["KV1"],
  "refinance": ["KV2"],
  "refine": ["JPc"],
  "refinement": ["KV3"],
  "refinery": ["HdS"],
  "reflect": ["F76","Dk3","EY8","CLP","Dk2"],
  "reflect reflected": ["EUs","Dk3","Dk2"],
  "reflect the light": ["EY8"],
  "reflected": ["EUs"],
  "reflected the light": ["EUs"],
  "reflecting": ["Dk3","Dk2"],
  "reflection": ["HdT"],
  "reflective": ["KV4"],
  "reflective vest": ["CLN","CLO"],
  "reflex": ["HdU"],
  "reform": ["JPd"],
  "reformation": ["KV5"],
  "reformer": ["KV6"],
  "refraction": ["HdV"],
  "refrain": ["JPf"],
  "refrain from": ["JPe"],
  "refresh": ["JPg"],
  "refreshing": ["E2x"],
  "refreshment": ["KV8"],
  "refrigerate": ["JPh"],
  "refrigerator": ["Gru","CLS","FPl","CLQ","CLR"],
  "refuge": ["JPi"],
  "refugee": ["HdW","Kqd","Kqe"],
  "refund": ["JPj"],
  "refurbish": ["JPk"],
  "refusal": ["KV9"],
  "refuse": ["F77","CLU","Dk4","CLT","EbV"],
  "refuse money": ["EbV","Dk4"],
  "refuse refused": ["ETF","Dk4"],
  "refused": ["ETF"],
  "refused money": ["ETF"],
  "refusing": ["Dk4","EbV"],
  "refusing money": ["EbV","Dk4"],
  "refute": ["JPl"],
  "regain": ["JPm"],
  "regard": ["JPp"],
  "regardless": ["JPo"],
  "regardless of": ["JPn"],
  "regenerate": ["JPq"],
  "regeneration": ["KWA"],
  "regime": ["KWC"],
  "regimen": ["KWB"],
  "regiment": ["JPr"],
  "region": ["F78","CLV"],
  "regional": ["KWD"],
  "regions": ["CLW"],
  "register": ["G9V"],
  "registrant": ["KWE"],
  "registration": ["KWF"],
  "registry": ["KWG"],
  "regression": ["KWH"],
  "regret": ["F79","CLX"],
  "regular": ["JPt"],
  "regularity": ["KWI"],
  "regularly": ["JPs"],
  "regulate": ["JPu"],
  "regulation": ["KWJ"],
  "regulator": ["KWK"],
  "regulatory": ["KWL"],
  "rehabilitate": ["JPv"],
  "rehabilitation": ["KWM"],
  "rehearsal": ["HdX"],
  "rehearse": ["F8A","CLY"],
  "reign": ["JPw"],
  "reimburse": ["KWO"],
  "reimbursement": ["KWN"],
  "rein": ["KWQ"],
  "rein in": ["JPy"],
  "reindeer": ["Grv","F8B","ELU","FPm","CLb","CLZ","CLa","Eh0"],
  "reinforce": ["JPx"],
  "reinforcement": ["KWP"],
  "reinstate": ["KWR"],
  "reinvent": ["KWS"],
  "reinvest": ["KWU"],
  "reinvestment": ["KWT"],
  "reiterate": ["JPz"],
  "reject": ["JP0"],
  "rejection": ["KWV"],
  "rejoice": ["KWW"],
  "rejoin": ["KWX"],
  "rejuvenate": ["JP1"],
  "rekindle": ["JP2"],
  "relapse": ["KWY"],
  "relate": ["JP3"],
  "relation": ["KWa"],
  "relational": ["KWZ"],
  "relationship": ["F8C","CLd","CLc"],
  "relative": ["E2y"],
  "relatively": ["KWb"],
  "relatives": ["Grw","CLe","FPn","CLf"],
  "relativity": ["JP4"],
  "relax": ["Grz","Dk6","FPp","EbW","Dk5","CLp","EY9","CLh","CLg"],
  "relax on the beach": ["EY9"],
  "relax on the sofa": ["ELW"],
  "relax relaxed": ["ETG","Dk6","Dk5"],
  "relaxation": ["KWc"],
  "relaxed": ["Grx","ETG","FPo","CLk","CLj","CLi"],
  "relaxing": ["Gry","Dk6","Dk5","CLm","CLo","CLn","EbW","CLl"],
  "relay": ["JP5"],
  "relay race": ["HdY"],
  "release": ["JP6"],
  "relegate": ["JP7"],
  "relentless": ["KWe"],
  "relentlessly": ["KWd"],
  "relevance": ["JP8"],
  "relevant": ["JP9"],
  "reliability": ["KWf"],
  "reliable": ["F8D","E2z"],
  "reliably": ["KWg"],
  "reliance": ["JQA"],
  "relic": ["JQB"],
  "relief": ["JQC"],
  "relieve": ["JQE"],
  "relieve a of b": ["JQD"],
  "relieved": ["F8E","E20"],
  "religion": ["HdZ"],
  "religious": ["F8F","CLq"],
  "religious education": ["E21"],
  "relinquish": ["KWh"],
  "relish": ["KWi"],
  "relocate": ["KWj"],
  "relocation": ["KWk"],
  "reluctance": ["JQF"],
  "reluctant": ["JQG"],
  "reluctantly": ["KWl"],
  "rely": ["JQI"],
  "rely on": ["JQH"],
  "remain": ["JQK"],
  "remainder": ["JQJ"],
  "remains": ["JQL"],
  "remake": ["KWm"],
  "remand": ["KWn"],
  "remark": ["JQN"],
  "remarkable": ["JQM"],
  "remarkably": ["KWo"],
  "remedy": ["JQO"],
  "remember": ["F8G","E22"],
  "remember a name": ["Hda"],
  "remembrance": ["KWp"],
  "remind": ["E23"],
  "remind a of b": ["JQP"],
  "reminder": ["KWq"],
  "reminiscent": ["KWr"],
  "remission": ["KWs"],
  "remit": ["KWt"],
  "remnant": ["JQQ"],
  "remnants": ["JQR"],
  "remodel": ["JQS"],
  "remorse": ["JQT"],
  "remote": ["Gr1","DK2","CLs","CLx","D4i","CLr"],
  "remote control": ["Gr0","CLt","FPq","CLu","CLv","CLw"],
  "remotely": ["KWu"],
  "removal": ["JQU"],
  "remove": ["JQW"],
  "remove a from b": ["JQV"],
  "remuneration": ["KWv"],
  "renaissance": ["JQX"],
  "renal": ["KWw"],
  "rename": ["KWx"],
  "render": ["JQY"],
  "rendition": ["JQZ"],
  "renew": ["JQa"],
  "renewable": ["F8H","CLz","CLy"],
  "renewable energy": ["Hdb"],
  "renewal": ["KWy"],
  "renminbi": ["CL0"],
  "renounce": ["KWz"],
  "renovate": ["JQb"],
  "renovation": ["KW0"],
  "renown": ["JQc"],
  "rent": ["G9W"],
  "rent a car": ["Hdc"],
  "rent a motorboat": ["E24"],
  "rental": ["JQd"],
  "reopen": ["KW1"],
  "reorganization": ["KW2"],
  "reorganize": ["KW3"],
  "rep": ["KXD"],
  "repair": ["Gr2","Dk7","EbX","CL2","Dk9","CL1"],
  "repair a car": ["Hdd"],
  "repair a phone": ["F8I","Dk7","EbX"],
  "repair repaired": ["ETH","Dk7","Dk9"],
  "repair the AC": ["Dk9"],
  "repair things": ["ELX"],
  "repaired": ["ETH"],
  "repaired a phone": ["ETH"],
  "repairing": ["EbX","Dk9","Dk7"],
  "repairing a phone": ["EbX","Dk7"],
  "repairing the AC": ["Dk9"],
  "repay": ["JQe"],
  "repayment": ["KW4"],
  "repeal": ["KW5"],
  "repeat": ["Gr3","Dte"],
  "repeatedly": ["KW6"],
  "repel": ["JQf"],
  "repercussion": ["KW7"],
  "repertoire": ["JQg"],
  "repertory": ["JQh"],
  "repetition": ["JQi"],
  "repetitive": ["JQj"],
  "replace": ["JQk"],
  "replacement": ["KW8"],
  "replay": ["KW9"],
  "replenish": ["JQl"],
  "replica": ["JQm"],
  "replicate": ["JQn"],
  "replication": ["KXA"],
  "reply": ["F8J","CL3"],
  "report": ["Gr5","Dtf"],
  "report card": ["G9X"],
  "report the news": ["ELa"],
  "report to": ["JQo"],
  "reportedly": ["KXB"],
  "reporter": ["Gr4","DK4","FPr","DK3","CL4","ELZ","ELY","D4j"],
  "repository": ["KXC"],
  "represent": ["JQq"],
  "representation": ["KXE"],
  "representative": ["JQp"],
  "repress": ["JQr"],
  "repression": ["KXF"],
  "reprint": ["KXG"],
  "reproach": ["JQs"],
  "reproduce": ["JQt"],
  "reproduction": ["Hde"],
  "reproductive": ["JQu"],
  "reptile": ["Gr6","DK5","CL5","CL7"],
  "reptiles": ["ELb"],
  "republic": ["Hdf"],
  "republican": ["KXH"],
  "repurchase": ["KXI"],
  "reputable": ["JQv"],
  "reputation": ["JQw"],
  "repute": ["JQx"],
  "request": ["JQy"],
  "require": ["JQz"],
  "requirement": ["KXJ"],
  "requisite": ["KXK"],
  "resale": ["KXL"],
  "reschedule": ["JQ0"],
  "rescue": ["Gr7","CL9","FPs","DlA","EbY","CL8","DlB"],
  "rescue people": ["ELc"],
  "rescue rescued": ["DlB","ETI","DlA"],
  "rescue someone": ["EbY","DlB"],
  "rescued": ["ETI"],
  "rescued someone": ["ETI"],
  "rescuing": ["EbY","DlA","DlB"],
  "rescuing someone": ["EbY","DlB"],
  "research": ["JQ1"],
  "researcher": ["KXM"],
  "resemblance": ["KXN"],
  "resemble": ["JQ2"],
  "resent": ["JQ3"],
  "resentment": ["KXO"],
  "reservation": ["F8K","Dtg"],
  "reserve": ["E26"],
  "reservoir": ["JQ4"],
  "reset": ["KXP"],
  "reshape": ["KXQ"],
  "reshuffle": ["KXR"],
  "reside": ["JQ6"],
  "residence": ["KXS"],
  "resident": ["JQ5","Kqf","Kqg"],
  "residential": ["KXT"],
  "residual": ["KXU"],
  "residue": ["JQ7"],
  "resign": ["CMB"],
  "resign oneself to": ["JQ8"],
  "resignation": ["KXV"],
  "resilience": ["JQ9"],
  "resilient": ["KXW"],
  "resin": ["JRA"],
  "resist": ["JRC"],
  "resistance": ["Hdg"],
  "resistant": ["JRB"],
  "resolute": ["JRD"],
  "resolution": ["JRE"],
  "resolve": ["JRF"],
  "resonance": ["JRG"],
  "resonate": ["KXX"],
  "resort": ["JRH"],
  "resort to": ["JRI"],
  "resource": ["JRK"],
  "resourceful": ["JRJ"],
  "respect": ["F8L","CMC"],
  "respectable": ["KXY"],
  "respectful": ["KXZ"],
  "respective": ["JRL"],
  "respectively": ["KXa"],
  "respiration": ["Hdh"],
  "respirator": ["JRM"],
  "respiratory": ["KXb"],
  "respiratory system": ["Hdi"],
  "respire": ["JRN"],
  "respond": ["JRP"],
  "respondent": ["JRO"],
  "response": ["JRQ"],
  "responsibility": ["KXc"],
  "responsible": ["Gr8","Dth"],
  "responsive": ["KXe"],
  "responsiveness": ["KXd"],
  "rest": ["GsA","DlC","FPu","EZC","CMI"],
  "rest on the sofa": ["EZC"],
  "rest rested": ["DlC"],
  "restart": ["KXf"],
  "restate": ["JRR"],
  "restaurant": ["Gr9","CMG","FPt","DK6","CME","CMD","CMF"],
  "resting": ["F8M","DlC","CMH"],
  "restless": ["KXg"],
  "restoration": ["JRS"],
  "restore": ["JRT"],
  "restrain": ["JRU"],
  "restraint": ["JRV"],
  "restrict": ["JRW"],
  "restriction": ["KXh"],
  "restrictive": ["KXi"],
  "restroom": ["GsB","CMK","CMJ"],
  "restructure": ["KXj"],
  "result": ["JRZ"],
  "result from": ["JRX"],
  "result in": ["JRY"],
  "resultant": ["KXk"],
  "resume": ["CML"],
  "resumption": ["KXl"],
  "resurgence": ["KXm"],
  "resurrection": ["KXn"],
  "retail": ["JRa"],
  "retailer": ["KXo"],
  "retain": ["JRb"],
  "retaliation": ["KXp"],
  "retard": ["KXq"],
  "retention": ["KXr"],
  "rethink": ["KXs"],
  "retina": ["KXt"],
  "retire": ["JRc"],
  "retiree": ["KXu"],
  "retirement": ["KXv"],
  "retort": ["KXw"],
  "retract": ["JRd"],
  "retreat": ["Hdj"],
  "retrieval": ["JRe"],
  "retrieve": ["JRf"],
  "retrospect": ["JRh"],
  "retrospective": ["JRg"],
  "return": ["JRi"],
  "return a book": ["Hdk"],
  "return books on time": ["F8N"],
  "return ticket": ["Hdl"],
  "reunion": ["JRj"],
  "reunite": ["KXx"],
  "reuse": ["KXy"],
  "rev": ["KX7"],
  "revamp": ["KXz"],
  "reveal": ["JRk"],
  "revel": ["KX1"],
  "revelation": ["KX0"],
  "revenge": ["JRl"],
  "revenue": ["Hdm"],
  "revere": ["JRm"],
  "reversal": ["KX2"],
  "reverse": ["JRn"],
  "reversible": ["JRo"],
  "revert": ["JRp"],
  "review": ["Hdn"],
  "reviewer": ["KX3"],
  "revise": ["Hdo"],
  "revision": ["Hdp"],
  "revisit": ["KX4"],
  "revitalize": ["JRq"],
  "revival": ["JRr"],
  "revive": ["JRs"],
  "revoke": ["JRt"],
  "revolt": ["JRu"],
  "revolution": ["Hdq"],
  "revolutionary": ["KX5"],
  "revolutionize": ["KX6"],
  "revolve": ["Hdr"],
  "reward": ["JRv"],
  "rewrite": ["KX8"],
  "rhetoric": ["KYA"],
  "rhetorical": ["KX9"],
  "Rhine": ["KYB"],
  "Rhine River": ["KYC"],
  "rhino": ["GsD","DK7","FPv","CMP","CMO","D4k","CMM","CMN"],
  "rhinoceros": ["GsC","Dti"],
  "rhodes": ["Hds"],
  "rhubarb": ["F8O","CMT","CMS"],
  "rhyme": ["JRw"],
  "rhythm": ["Hdt"],
  "rhythmic": ["KYD"],
  "rib": ["F8Q","CMa"],
  "rib cage": ["F8P","CMY"],
  "ribbon": ["GsE","CMW","CMV","CMU","CMX"],
  "ribs": ["F8R","CMe","CMd","CMc"],
  "rice": ["GsF","DK9","FPw","CMk","D4l","CMg","CMf","CMj","CMh","CMi"],
  "rice and vegetables": ["DK8"],
  "rice pudding": ["CMl"],
  "rich": ["GsG","CMm","FPx","ELd"],
  "richly": ["KYE"],
  "richness": ["KYF"],
  "rickshaw": ["F8S","CMq","CMp","CMn"],
  "rid": ["JR3"],
  "ridden": ["EV7"],
  "ridden a scooter": ["EV7"],
  "riddle": ["JRx"],
  "ride": ["GsK","DlD","FP0","DlE","Ecb","DlF","EbZ","DlG","CMw","Eba","EZD","EZE"],
  "ride a bicycle": ["GsH","Dtj"],
  "ride a bike": ["GsI","DlD","FPy","CMs","EbZ","CMr","EZD","ELe"],
  "ride a bus": ["Hdu"],
  "ride a camel": ["Hdv"],
  "ride a donkey": ["Hdw"],
  "ride a horse": ["GsJ","DlE","FPz","CMt","Ecb"],
  "ride a jetski": ["E27"],
  "ride a motorbike": ["F8T","DlF","CMu","Eba","ELf"],
  "ride a motorbike dangerously": ["ERO"],
  "ride a roller coaster": ["Hdx"],
  "ride a scooter": ["F8U","DlG","EZE"],
  "ride a skateboard": ["F8V","CMv","ELg"],
  "ride a skateboard safely": ["ERP"],
  "ride in a car": ["Hdy"],
  "ride my bike": ["F8W","Dtk"],
  "ride off": ["JRy"],
  "ride out": ["JRz"],
  "ride ridden": ["EV7"],
  "ride rode": ["F8X","DlD","ETJ","DlE","DlG","DlF"],
  "ride the bus": ["Hdz"],
  "rider": ["E28"],
  "ridge": ["JR0"],
  "ridicule": ["JR1"],
  "ridiculous": ["JR2"],
  "riding": ["GsN","DlD","FP2","DlE","EbZ","DlF","DlG","Ecb","Eba"],
  "riding a bike": ["GsL","DlD","FP1","EbZ"],
  "riding a horse": ["GsM","DlE","Ecb"],
  "riding a motorbike": ["Eba","DlF"],
  "riding a scooter": ["F8Y","DlG"],
  "rife": ["JR4"],
  "rifle": ["Hd0"],
  "rift": ["KYG"],
  "rig": ["JSA"],
  "right": ["GsO","Dtl","ELh"],
  "right away": ["JR5"],
  "right wing": ["Hd1"],
  "righteous": ["JR6"],
  "rightly": ["KYH"],
  "rigid": ["JR7"],
  "rigor": ["JR9"],
  "rigorous": ["JR8"],
  "rim": ["JSB"],
  "ring": ["GsP","CMy","FP3","D4m","CM2","CM1","CMz","DlI","EdH","CM0","DlH"],
  "ring binder": ["G9Y"],
  "Ring of Saturn": ["Hd2"],
  "ring out": ["JSC"],
  "ring rang": ["DlH","DlI"],
  "ring the bell": ["Hd3"],
  "ring up": ["JSD"],
  "ringing": ["EdH","DlI","DlH"],
  "rings": ["E29"],
  "rinse": ["F8Z","CM3"],
  "Rio De Janeiro": ["G9Z"],
  "Rio de Janeiro Harbour": ["Hd4"],
  "riot": ["CM6","CM4","CM5"],
  "rip": ["GsR","CNB","FP4","CM7"],
  "rip off": ["JSF"],
  "ripe": ["GsQ","CM8","CNA","CM9"],
  "ripen": ["JSE"],
  "riper": ["DLA"],
  "ripple": ["JSG"],
  "rise": ["F8a","DlJ","EdI","CNC","EZG"],
  "rise above": ["JSH"],
  "rise in the morning": ["EZG"],
  "rise rose": ["DlJ"],
  "rise up": ["JSI"],
  "rising": ["DlJ","EdI"],
  "risk": ["JSJ"],
  "risky": ["JSK"],
  "rite": ["JSL"],
  "ritual": ["JSM"],
  "rival": ["CND"],
  "rivalry": ["JSN"],
  "river": ["GsS","CNG","FP5","DLB","CNE","CNF","D4n","CNK","CNH"],
  "river bank": ["F8b","CNI","CNJ"],
  "river rapids": ["CNL","CNN"],
  "rivet": ["KYI"],
  "RNA": ["Hd5"],
  "road": ["GsT","CNQ","DLC","CNP","CNO","D4o"],
  "road rage": ["F8c","CNR"],
  "roadside": ["KYJ"],
  "roadworks": ["CNS"],
  "roam": ["JSO"],
  "roar": ["GsU","CNU","FP6","CNT"],
  "roast": ["GsV","CNX"],
  "roast beef": ["F8d","DLD"],
  "roast chicken": ["F8e","CNV","CNW"],
  "roast vegetables": ["CNY"],
  "rob": ["JSQ"],
  "robber": ["KYK"],
  "robbery": ["JSP"],
  "robe": ["F8f","Dtm"],
  "robin": ["F8g","CNb","CNa","CNZ"],
  "robot": ["GsW","CNe","FP7","CNf","CNc","CNd"],
  "robotic": ["KYL"],
  "robust": ["JSR"],
  "rock": ["Gsa","CNu","FQA","CNg"],
  "rock climbing": ["GsX","CNh","FP8","CNk","CNj","CNi"],
  "rock paper scissors": ["Hd7"],
  "rock pool": ["CNv"],
  "rock the baby": ["Hd8"],
  "rocker": ["KYM"],
  "rocket": ["GsY","DLE","FP9","CNm","D4p","CNn","CNq","CNo","CNp"],
  "rocket launch": ["Hd6"],
  "rocking horse": ["GsZ","CNt","CNr"],
  "rocks": ["Gsb","CN0","FQB","CN2","CNy","CNx","CNz","CNw"],
  "rocky": ["KYN"],
  "rod": ["Gsc","Dtn"],
  "rode": ["F8h","ETJ"],
  "rode a motorbike": ["ETJ"],
  "rodent": ["JSS"],
  "rodeo": ["JST"],
  "roe": ["JSU"],
  "rogue": ["KYO"],
  "role": ["Hd9"],
  "roll": ["Gsi","CN3","COP","CN4"],
  "roll down": ["JSV"],
  "roll in": ["JSW"],
  "roll out": ["JSX"],
  "roll out the red carpet": ["ELi","ELj","ELk"],
  "roller": ["KYP"],
  "roller blades": ["Gsd","CN6","FQC","CN5","CN7"],
  "roller blading": ["F8k","CN9","COA"],
  "roller coaster": ["Gse","COC","FQD","COD","COG","COE","COB","COF","COH"],
  "roller hockey": ["HeA"],
  "roller skate": ["Gsf","COI","FQE"],
  "roller skates": ["Gsg","Dtq"],
  "roller skating": ["Gsh","COJ"],
  "rollerblade": ["F8i","E3A"],
  "rollerblades": ["F8j"],
  "rollerblading": ["F8l","Dto"],
  "rollerblads": ["Dtp"],
  "rolling pin": ["F8m","COK","COO","COL","COM"],
  "Roman": ["Kqj","Kqh"],
  "Roman Colosseum": ["HeB"],
  "Roman Empire": ["HeC"],
  "Roman Mythology": ["HeD"],
  "romance": ["Gsj","COV","COQ","COR","COT","COU"],
  "Romania": ["F8n","COZ"],
  "Romanian": ["HET","Kqi","G9a"],
  "Romans": ["Kr6","Kr5"],
  "romantic": ["Gsk","COd","ELm","COa","COc","COb"],
  "Rome": ["G9b"],
  "roof": ["Gsl","COe","FQF","COg","COh","COf","COi"],
  "rooftop": ["KYQ"],
  "rookie": ["KYR"],
  "room": ["Gsm","COk","FQG"],
  "roommate": ["KYS"],
  "roommates": ["F8o","COj"],
  "roomservice": ["COl"],
  "roost": ["JSY"],
  "rooster": ["Gsn","COn","FQH","COp","COo","COm"],
  "root": ["E3B"],
  "root for": ["JSZ"],
  "root up": ["JSa"],
  "roots": ["Gso","COt","FQI","COr","COq","COs"],
  "rope": ["Gsp","COx","FQJ","COv","COy","COu","COw"],
  "rope off": ["JSb"],
  "rosary": ["CO1","COz","CO0"],
  "rose": ["Gsq","CO5","FQK","CO4","CO2","CO3"],
  "roses": ["F8p","CO8","CO7","CO6"],
  "roster": ["KYT"],
  "rosy": ["KYU"],
  "rot": ["JSe"],
  "rotate": ["F8q","CPA","CO9"],
  "rotation": ["HeE"],
  "rotational": ["JSc"],
  "rote": ["JSd"],
  "rotten": ["KYV"],
  "rouge": ["JSf"],
  "rough": ["Gsr","Dtr"],
  "roughly": ["KYW"],
  "round": ["Gst","Dtt","FQL","Dts"],
  "round off": ["JSg"],
  "roundabout": ["Gss","CPB","CPC"],
  "rounders": ["HeF"],
  "rouse": ["JSh"],
  "rout": ["KYZ"],
  "route": ["F8r","Dtu"],
  "router": ["KYX"],
  "routine": ["JSi"],
  "routinely": ["KYY"],
  "rove": ["KYa"],
  "rover": ["HeG"],
  "row": ["Gsv","DlK","EZH"],
  "row a boat": ["F8s","DlK","CPD","EZH"],
  "row rowed": ["DlK"],
  "rowing": ["Gsu","DlK"],
  "rowing a boat": ["DlK"],
  "royal": ["F8t","CPE"],
  "royalty": ["KYb"],
  "rub": ["JSl"],
  "rub off": ["JSk"],
  "rub off on": ["JSk"],
  "rubber": ["Gsx","F8v","CPF","FQN"],
  "rubber band": ["G9c"],
  "rubbish": ["Gsy","CPI","FQO","CPG","CPH"],
  "rubble": ["JSj"],
  "ruble": ["KYc"],
  "rubric": ["KYd"],
  "rucksack": ["Gsz","DLF","FQP","D4q"],
  "rude": ["F8w","E3C"],
  "rudimentary": ["JSm"],
  "rue": ["KYe"],
  "ruffle": ["KYf"],
  "rug": ["Gs1","DLH","CPO","CPJ","D4s"],
  "rugby": ["Gs0","DLG","FQQ","CPM","CPN","CPK","D4r","CPL"],
  "rugby league": ["HeH"],
  "rugby union": ["HeI"],
  "rugged": ["JSn"],
  "ruin": ["JSo"],
  "ruins": ["E3D"],
  "rule": ["E3E"],
  "rule out": ["JSp"],
  "ruler": ["Gs2","DLI","FQR","CPQ","CPR","D4t","CPP"],
  "rum": ["KYh"],
  "rumble": ["KYg"],
  "rumor": ["JSq"],
  "run": ["Gs4","F82","DlM","FQT","DlP","Ecc","CPV","DlL","ELs","CPS","EVs","DlN"],
  "run a marathon": ["F8x","DlN","EVs"],
  "run a race": ["HeJ"],
  "run across": ["JSr"],
  "run after": ["JSs"],
  "run along": ["JSt"],
  "run around": ["JSu"],
  "run away": ["HeL"],
  "run away from": ["HeK"],
  "run back": ["JSv"],
  "run down": ["JSw"],
  "run downstairs": ["HeM"],
  "run fast": ["F8y"],
  "run home": ["HeN"],
  "run in": ["JSx"],
  "run in the park": ["ELn"],
  "run into": ["HeO"],
  "run like the wind": ["ELq"],
  "run off": ["JSy"],
  "run out": ["F81","DlO","ELr"],
  "run out of": ["HeP"],
  "run out ran out": ["DlO"],
  "run over": ["JSz"],
  "run quickly": ["ERQ"],
  "run ran": ["F83","DlM","EUD","DlL","DlP","DlN"],
  "run run": ["EVs"],
  "run up": ["JS1"],
  "run up against": ["JS0"],
  "run upstairs": ["HeQ"],
  "runaway": ["KYi"],
  "runner": ["KYj"],
  "running": ["Gs3","DlM","FQS","DlP","CPU","Ecc","D4u","DlL","DLJ","CPT","DlN"],
  "running a marathon": ["DlN"],
  "running out": ["DlO"],
  "running shoes": ["F8z"],
  "runny nose": ["F80","E3F"],
  "runway": ["KYk"],
  "rupture": ["JS2"],
  "rural": ["CPX"],
  "rural area": ["F84","CPZ"],
  "rush": ["F86","CPe"],
  "rush hour": ["F85","CPd","CPb"],
  "rush into": ["JS3"],
  "rush off": ["JS4"],
  "Russia": ["Gs6","DLM","FQU","CPi","CPf","ELt","CPg","D4v"],
  "Russia flag": ["F87","DLK"],
  "Russian": ["Gs5","Kqk","DLL","EeS"],
  "Russians": ["Kr7"],
  "rust": ["HeR"],
  "rustic": ["JS5"],
  "rustle": ["KYl"],
  "rustproof": ["JS6"],
  "rusty": ["KYm"],
  "ruthless": ["JS7"],
  "Rwanda": ["HEW","G9d"],
  "Rwandan": ["HEV","Kql"],
  "S": ["DaL","GCK","HEq","HEX"],
  "s": ["Gxg","FTS","DaM"],
  "sabotage": ["KYn"],
  "sac": ["JS8"],
  "sack": ["Gs7","Dtv"],
  "sacred": ["F88","CPk","CPj"],
  "sacrifice": ["JS9"],
  "sacrificial": ["JTA"],
  "sad": ["GtA","F9A","DLO","FQV","CPm","Eh1","CPl","ELu","CPr","Eh2"],
  "sad face": ["HeS"],
  "sad news": ["HeT"],
  "sad story": ["HeU"],
  "sadder": ["F89","DLN"],
  "saddle": ["Gs8","CPp","CPo","CPn"],
  "sadly": ["KYo"],
  "sadness": ["Gs9","CPq"],
  "safari": ["GtB","DYg"],
  "safari park": ["F9B"],
  "safe": ["GtC","CPs","FQW","CPu","CPt","ELv"],
  "safeguard": ["KYp"],
  "safely": ["ERP"],
  "safer": ["F9C","DLP"],
  "safety": ["GtD","DYh","CPv"],
  "safety net": ["JTB"],
  "sag": ["KYr"],
  "saga": ["KYq"],
  "sage": ["JTC"],
  "Sagittarius": ["HeV"],
  "Sahara": ["KYt"],
  "Saharan": ["KYs"],
  "Sahel": ["KYv"],
  "Sahelian": ["KYu"],
  "said": ["F9D","EUE"],
  "said hello": ["EUE"],
  "sail": ["GtG","DlQ","FQY","CPw","EZJ","CP5"],
  "sail a boat": ["F9E","DlQ","CPx","EZJ"],
  "sail sailed": ["DlQ"],
  "sail through": ["JTD"],
  "sailboat": ["F9F","CPy"],
  "sailing": ["GtE","DlQ","FQX","DYi","CP1","CPz"],
  "sailing a boat": ["F9G","DlQ"],
  "sailing boat": ["F9H","CP0"],
  "sailor": ["GtF","DLR","CP4","CP2","CP3"],
  "saint": ["F9I","CP6","CP7"],
  "Saint Petersburg": ["KYw"],
  "sake": ["JTE"],
  "sakura": ["HeW"],
  "salad": ["GtH","DLS","FQZ","CQC","D4w","CP8","CP9","CQA","CQB"],
  "salamander": ["JTF"],
  "salami": ["F9J","CQG","CQE","CQF"],
  "salary": ["HeX"],
  "sale": ["F9K"],
  "sales clerk": ["GtI","CQH"],
  "sales representative": ["JTG"],
  "salesman": ["KYx"],
  "salespeople": ["KYy"],
  "salesperson": ["GtJ","Dtw","FQa"],
  "salient": ["JTH"],
  "saline": ["KYz"],
  "saliva": ["JTI"],
  "salmon": ["GtK","CQK","FQb","CQM","CQL","CQI","DLT","CQJ"],
  "salon": ["JTJ"],
  "saloon": ["KY0"],
  "salsa": ["F9L","CQP","CQO"],
  "salt": ["GtL","CQQ","FQc","CQR","CQU","DLU"],
  "salt and pepper": ["F9M","CQS","D4x","CQT"],
  "salty": ["GtM","CQV","FQd"],
  "salute": ["CQX"],
  "Salvadoran": ["HEY","Kqm","G9e"],
  "salvage": ["KY1"],
  "salvation": ["KY2"],
  "same": ["GtN","CQb","FQe","CQa"],
  "same here": ["HeY"],
  "same to you": ["HeZ"],
  "Sami": ["Kqn"],
  "Samoa": ["ELz"],
  "Samoan": ["HEZ","G9f"],
  "samosas": ["DLV"],
  "sample": ["JTK"],
  "samurai": ["Hea"],
  "San Francisco": ["G9g"],
  "San Francisco Bay": ["KY5"],
  "sanction": ["JTL"],
  "sanctuary": ["JTM"],
  "sand": ["GtS","CQc","FQi","CQx","CQd","CQe","CQf"],
  "sand castle": ["GtP","CQl","FQg","CQm","CQn","CQo","CQk"],
  "sand dunes": ["F9P","CQr","CQq"],
  "sandal": ["F9N"],
  "sandals": ["GtO","DLW","FQf","CQj","D4y","CQi","CQg","CQh"],
  "sandbox": ["F9O","E3G"],
  "sandcastle": ["GtQ","Dtx","FQh"],
  "sandpaper": ["CQu"],
  "sandpit": ["GtR","CQw","CQv"],
  "sandstone": ["KY3"],
  "sandstorm": ["F9Q","CQ2","CQ1","CQz","CQ0"],
  "sandwich": ["GtU","E3H","FQk","DLX","D4z","CQ5","CQ3","CQ4","CRB","CQ6"],
  "sandwiches": ["GtT","CRA","FQj","CQ9","CQ8","CQ7"],
  "sandy": ["KY4"],
  "sane": ["JTN"],
  "sang": ["F9R","EUF"],
  "sang a song": ["EUF"],
  "sanitation": ["JTO"],
  "santa": ["GtW","F9T","CRK","FQm","Eh3","CRF","CRE","CRD","CRC","EL0"],
  "Santa Claus": ["GtV","F9S","Eh3","CRG","FQl","CRH","CRI","CRJ"],
  "Santa's sleigh": ["Eh4"],
  "Sao Paulo": ["G9h"],
  "sap": ["JTP"],
  "sapling": ["CRQ","CRL","CRM","CRN","CRO","CRP"],
  "sapphire": ["CRU"],
  "sarcastic": ["JTQ"],
  "sarcophagus": ["CRY"],
  "sardines": ["F9U","CRe","CRa","CRc","CRb"],
  "Sardinia": ["KY6"],
  "sardonic": ["JTR"],
  "sat": ["F9W","EUG"],
  "sat down": ["EUG"],
  "satchel": ["F9V","DLY"],
  "satellite": ["GtX","CRk","FQn","CRh","CRg","CRi","CRj","CRf"],
  "satellite dish": ["DLZ"],
  "satin": ["KY7"],
  "satire": ["JTS"],
  "satiric": ["JTT"],
  "satisfaction": ["JTU"],
  "satisfactorily": ["KY8"],
  "satisfactory": ["JTV"],
  "satisfy": ["JTW"],
  "satsumas": ["CRl"],
  "saturate": ["JTY"],
  "saturated": ["JTX"],
  "saturation": ["JTZ"],
  "Saturday": ["GtY","DLc","FQo","DLa","DLb"],
  "saturn": ["GtZ","CRs","FQp","CRp","CRr","CRo","CRn"],
  "Saturn's rings": ["Heb"],
  "sauce": ["Gtb","CRv","FQq","CRw","CRx","CRu"],
  "saucepan": ["Gta","DLd","D42"],
  "saucer": ["JTa"],
  "saucy": ["JTb"],
  "Saudi": ["HEb","Kqo"],
  "Saudi Arabia": ["F9X","EL1"],
  "Saudi Arabian": ["HEa"],
  "sauna": ["KY9"],
  "saunter": ["JTc"],
  "sausage": ["Gtc","DLe","FQr","Eg6","CRz","CRy"],
  "sausages": ["Gtd","CR0","FQs","DLf","CR2","D43","CR1"],
  "savage": ["JTd"],
  "savannah": ["F9Y","CR3","CR6","CR4","CR5"],
  "save": ["F9Z","E3I"],
  "save for": ["JTe"],
  "save injured people": ["EL2"],
  "save money": ["Gte","CR7"],
  "save up": ["JTf"],
  "savior": ["KZA"],
  "savor": ["KZB"],
  "savoury": ["F9a","CR9","CR8"],
  "savvy": ["KZC"],
  "saw": ["Gtf","DLg","FQt","EUH","D44","CSC","CSA"],
  "saw an elephant": ["EUH"],
  "Saxon": ["Kqp"],
  "Saxons": ["Kr8"],
  "saxophone": ["Gtg","DLh","FQu","CSI","CSD","D45","CSF","CSH","CSE"],
  "say": ["Gth","DlS","FQv","DlR","EZK"],
  "say goodbye": ["Hec"],
  "say hello": ["F9b","DlS","DlR","EZK"],
  "say please": ["Hed"],
  "say said": ["Gti","DlR","DlS","EUE"],
  "say sorry": ["Hee"],
  "say thank you": ["Hef"],
  "say yes": ["Heg"],
  "saying": ["DlR","DlS"],
  "saying hello": ["DlR","DlS"],
  "says": ["Ecd"],
  "says 'hello'": ["Ecd"],
  "scaffold": ["KZD"],
  "scale": ["F9c","Dty"],
  "scale back": ["JTg"],
  "scale up down": ["JTh"],
  "scales": ["Gtj","CSJ","FQw"],
  "scalp": ["KZE"],
  "scam": ["KZF"],
  "scan": ["F9e","CSL"],
  "scandal": ["JTi"],
  "Scandinavia": ["KZH"],
  "Scandinavian": ["KZG","Kqq","Kqr"],
  "scanner": ["F9d","CSK"],
  "scant": ["KZI"],
  "scar": ["Gtn","DLk","D47"],
  "scarce": ["JTj"],
  "scarcely": ["KZJ"],
  "scare": ["JTl"],
  "scare away": ["JTk"],
  "scarecrow": ["Gtk","CSM","FQx","CSR","CSO","EL3","EL4","CSQ"],
  "scared": ["Gtl","F9f","DLi","FQy","CST","EL5","CSS"],
  "scarf": ["Gtm","CSX","FQz","D46","CSU","CSV","DLj","CSW"],
  "scarlet": ["KZK"],
  "scary": ["Gto","CSZ","FQ0","CSY"],
  "scatter": ["JTm"],
  "scatterbrained": ["E3J"],
  "scattered showers": ["Heh"],
  "scavenger": ["JTn"],
  "scenario": ["KZL"],
  "scene": ["JTo"],
  "scenery": ["Gtp","CSc","CSa","CSb"],
  "scenic": ["KZM"],
  "scent": ["F9g","CSd","CSf"],
  "schedule": ["Gtq","Dtz"],
  "schema": ["KZN"],
  "schematic": ["JTp"],
  "scheme": ["JTq"],
  "schizophrenia": ["KZO"],
  "scholar": ["F9i","CSj","CSg","CSh","CSi"],
  "scholarly": ["KZP"],
  "scholarship": ["JTr"],
  "school": ["Gtu","CSv","FQ4","CSl","CSk"],
  "school bag": ["Gtr","CSm","FQ1","CSn","CSo","CSp","CSq"],
  "school bus": ["Gtt","DLl","FQ3","CSr","CSt","CSs","CSu"],
  "school schedule": ["F9j","CSw","CSy","CSx"],
  "school trip": ["F9k","CS0","CSz"],
  "school yard": ["F9l"],
  "schoolbag": ["Gts","Dt0","FQ2"],
  "schoolboy": ["KZQ"],
  "schoolchild": ["KZR"],
  "science": ["Gtx","F9n","DYj","FQ6","CS5"],
  "science fiction": ["Gtv","CS3","FQ5","CS1","CS4","CS2"],
  "science lab": ["Gtw","Dt1"],
  "science museum": ["F9m"],
  "scientific": ["JTs"],
  "scientifically": ["KZS"],
  "scientist": ["Gty","DLm","FQ7","EL6","DLn","CS6","CTA","CS7","D48","CS8","CS9"],
  "scientists": ["F9o","DYk","CTB","CTC"],
  "scissors": ["Gtz","DLo","FQ8","D49","CTE","CTD","CTF"],
  "scoff": ["JTt"],
  "scold": ["JTu"],
  "scoop": ["F9p","CTI","CTG"],
  "scoot over": ["JTv"],
  "scooter": ["Gt0","DLp","CTN","D5A","CTK","CTJ","CTL","CTM"],
  "scope": ["JTw"],
  "scorch": ["CTO"],
  "score": ["Gt2","DlT"],
  "score a goal": ["Gt1","DlT"],
  "score scored": ["EVY","DlT"],
  "scored": ["EVY"],
  "scored a goal": ["EVY"],
  "scorer": ["KZT"],
  "scoring": ["DlT"],
  "scoring a goal": ["DlT"],
  "scorn": ["JTy"],
  "scornful": ["JTx"],
  "Scorpio": ["Hei"],
  "scorpion": ["Gt3","DLq","D5B","CTV","CTR"],
  "Scot": ["Kqs"],
  "Scotland": ["HEc","EL8"],
  "Scots": ["Kr9"],
  "Scotsman": ["Kqt"],
  "Scottish": ["HEd","G9i"],
  "scour": ["KZU"],
  "scourge": ["JTz"],
  "Scouser": ["Kqu"],
  "scout": ["JT0"],
  "scowl": ["KZV"],
  "scrabble": ["Hej"],
  "scramble": ["JT1"],
  "scrambled egg on toast": ["Eg7","DLr"],
  "scrambled eggs": ["F9q","CTZ","CTY","CTW"],
  "scrap": ["JT4"],
  "scrape": ["JT3"],
  "scrape by": ["JT2"],
  "scratch": ["E3K"],
  "scream": ["Gt4","DlU","FQ9","CTc","CTa","CTb"],
  "scream loudly": ["Hek"],
  "scream screamed": ["EUI","DlU"],
  "screamed": ["EUI"],
  "screaming": ["DlU"],
  "screech": ["KZW"],
  "screen": ["Gt5","CTd","FRA","CTg","CTf","CTe","ETK"],
  "screen cracked": ["ETK"],
  "screenplay": ["KZX"],
  "screenshot": ["G9j"],
  "screw": ["Gt7","CTn","DLt"],
  "screw up": ["JT5"],
  "screwdriver": ["Gt6","CTm","DLs","CTj"],
  "scribble": ["JT6"],
  "scribe": ["JT7"],
  "script": ["F9r","Dt2"],
  "scripture": ["KZY"],
  "scroll": ["Hel"],
  "scrub": ["JT8"],
  "scruffy": ["JT9"],
  "scruple": ["JUA"],
  "scrupulous": ["JUB"],
  "scrutinize": ["JUC"],
  "scrutiny": ["JUD"],
  "scuba": ["JUE"],
  "scuba diver": ["F9s","CTp","CTo"],
  "scuba diving": ["Gt8","CTq"],
  "scuffle": ["JUF"],
  "sculpt": ["JUG"],
  "sculptor": ["KZZ"],
  "sculpture": ["Gt9","CTr","FRB","CTt","CTs"],
  "scurry": ["JUH"],
  "sea": ["GuG","CUJ","FRG","CTu","CTw","CTv","DvP"],
  "sea horse": ["GuC","Dt3","FRD"],
  "sea lion": ["GuE","CT8","CT9","CUB","CUA"],
  "sea turtle": ["GuL","CUX","CUW","CUa","CUZ","CUY"],
  "sea weed": ["CUc"],
  "seacoast": ["E3L"],
  "seafood": ["GuA","CTx","FRC"],
  "seagull": ["GuB","CTy","CT1","CTz"],
  "seahorse": ["GuD","CT4","FRE","CT3","CT2"],
  "seal": ["GuF","CT7","FRF","CT5","CUC","CT6"],
  "seal off": ["JUI"],
  "seals": ["F9t","CUE"],
  "seam": ["F9u","CUI"],
  "seaman": ["KZa"],
  "seaplane": ["E3M"],
  "seaport": ["E3N"],
  "search": ["GuH","Dt4"],
  "search engine": ["E3O"],
  "seashell": ["F9v","E3P"],
  "seashore": ["JUJ"],
  "seaside": ["GuI","CUL","CUM","CUN","CUK"],
  "season": ["F9w"],
  "seasonal": ["KZb"],
  "seasoning": ["JUK"],
  "seasons": ["E3Q"],
  "seasons greetings": ["Hem"],
  "seat": ["GuK","CUV","FRH","CUP","CUO","CUQ","CUS","CUR"],
  "seat belt": ["GuJ","CUU","CUT"],
  "seatbelt": ["G9k"],
  "seaweed": ["GuM","Dt5"],
  "secede": ["JUL"],
  "seclude": ["JUN"],
  "secluded": ["JUM"],
  "seclusion": ["JUO"],
  "second": ["HBI","GuN","Dt6"],
  "second language": ["Hen"],
  "secondary": ["KZc"],
  "secondhand": ["JUP"],
  "secondly": ["KZd"],
  "secrecy": ["JUQ"],
  "secret": ["GuP","Dt7"],
  "secretary": ["GuO","DLv","FRI","CUe","DLu","CUd","EL9","EMA"],
  "secrete": ["JUR"],
  "secretion": ["KZe"],
  "secretly": ["KZf"],
  "sect": ["KZh"],
  "sectarian": ["KZg"],
  "section": ["JUS"],
  "sector": ["JUT"],
  "secular": ["JUU"],
  "secure": ["JUV"],
  "securely": ["KZi"],
  "security": ["Heo"],
  "security guard": ["GuQ","DLx","DLw","EMC","CUf","CUh","CUi","EMB","D5E","CUg"],
  "sedentary": ["JUW"],
  "sediment": ["JUY"],
  "sedimentary": ["JUX"],
  "seduce": ["KZj"],
  "seductive": ["KZk"],
  "see": ["GuT","DlW","DlX","DlV","DlY"],
  "see a doctor": ["Hep"],
  "see a ghost": ["DlV"],
  "see an elephant": ["F9x","DlX","DlW"],
  "see eye to eye": ["JUZ"],
  "see off": ["JUd"],
  "see out": ["JUe"],
  "see saw": ["GuU","EUH","FRK","DlW","DlX","DlV","DlY"],
  "see seen": ["EVj"],
  "see the Eiffel Tower": ["DlY"],
  "see through": ["JUg"],
  "see to": ["JUh"],
  "see you": ["Hes"],
  "see you later": ["Her"],
  "see you soon": ["Het"],
  "see you tomorrow": ["Heu"],
  "seed": ["GuR","CUo","CUk","CUj","CUm","CUl","CUn"],
  "seedling": ["KZl"],
  "seeds": ["GuS","CUp","FRJ"],
  "seeing": ["DlY","DlV","DlW","DlX"],
  "seeing a ghost": ["DlV"],
  "seeing an elephant": ["DlW","DlX"],
  "seeing the Eiffel Tower": ["DlY"],
  "seek": ["JUb"],
  "seek out": ["JUa"],
  "seek treasure": ["Heq"],
  "seeker": ["KZm"],
  "seem": ["JUc"],
  "seemingly": ["KZn"],
  "seen": ["F9y","EVj"],
  "seen an elephant": ["EVj"],
  "seep": ["JUf"],
  "seesaw": ["GuV","CUq","FRL","CUs","CUt","CUr"],
  "segment": ["JUi"],
  "segmentation": ["KZo"],
  "segregate": ["JUj"],
  "segregation": ["KZp"],
  "seismic": ["JUk"],
  "seismograph": ["JUl"],
  "seismology": ["JUm"],
  "seize": ["JUn"],
  "seize up": ["JUo"],
  "seizure": ["JUp"],
  "seldom": ["JUq"],
  "select": ["JUt"],
  "selection": ["JUr"],
  "selective": ["JUs"],
  "selectively": ["KZq"],
  "self": ["KZr"],
  "self absorbed": ["JUu"],
  "self assured": ["JUv"],
  "self centred": ["JUw"],
  "self congratulatory": ["JUx"],
  "self deprecating": ["JUy"],
  "self important": ["JUz"],
  "selfie": ["G9l"],
  "selfish": ["GuW","Dt8","FRM"],
  "sell": ["GuX","DlZ","FRN","Ece","Dla","CUu","Dlc","EZN","EZL","Dlb"],
  "sell a car": ["Hev"],
  "sell apples": ["DlZ","Ece"],
  "sell cars": ["EZL","Dla"],
  "sell drinks": ["Dlb"],
  "sell homes": ["EME"],
  "sell medicine": ["EZN","Dlc"],
  "sell out": ["JU0"],
  "sell sold": ["Dla","EUP","DlZ","Dlb","Dlc"],
  "sell things": ["EMG"],
  "seller": ["KZs"],
  "selling": ["DlZ","Ece","Dlc","Dla","Dlb"],
  "selling apples": ["Ece","DlZ"],
  "selling cars": ["Dla"],
  "selling drinks": ["Dlb"],
  "selling medicine": ["Dlc"],
  "semantic": ["JU1"],
  "semantically": ["KZt"],
  "semen": ["KZu"],
  "semester": ["JU2"],
  "semi": ["KZx"],
  "semiconductor": ["KZv"],
  "seminal": ["KZw"],
  "seminar": ["JU3"],
  "semiotics": ["JU4"],
  "senate": ["Hew"],
  "senator": ["JU5"],
  "send": ["GuZ","Dle","FRO","Dld","EZP","Dlf","CUv","EZO","CUw"],
  "send a message": ["GuY","Dld","EZO"],
  "send an email": ["F9z","Dlf","EZP","Dle"],
  "send back": ["Hex"],
  "send off": ["Hey"],
  "send out": ["Hez"],
  "send over": ["JU6"],
  "send sent": ["ETi","Dld","Dle","Dlf"],
  "sending": ["Dlf","Dld","Dle"],
  "sending a message": ["Dld"],
  "sending an email": ["F90","Dlf","Dle"],
  "Senegal": ["HEf","G9m"],
  "Senegalese": ["HEe","Kqv"],
  "senior": ["JU7"],
  "sensation": ["JU9"],
  "sensational": ["JU8"],
  "sense": ["JVA"],
  "senses": ["JVB"],
  "sensibility": ["KZy"],
  "sensible": ["JVC"],
  "sensibly": ["KZz"],
  "sensitive": ["JVD"],
  "sensitivity": ["KZ0"],
  "sensor": ["E3R"],
  "sensory": ["JVE"],
  "sensual": ["JVF"],
  "sent": ["F91","ETi"],
  "sent an email": ["ETi"],
  "sentence": ["JVG"],
  "sentiment": ["JVI"],
  "sentimental": ["JVH"],
  "Seoul": ["G9n"],
  "sepak takraw": ["He0"],
  "separate": ["JVJ"],
  "separately": ["KZ1"],
  "separation": ["KZ2"],
  "separatist": ["KZ3"],
  "September": ["Gua","Dt9","FRP"],
  "sequel": ["KZ4"],
  "sequence": ["JVK"],
  "sequential": ["JVL"],
  "sequoia": ["JVM"],
  "Serbia": ["HEh","EMH"],
  "Serbian": ["HEg","Kqw"],
  "sergeant": ["He1"],
  "serial": ["KZ5"],
  "series": ["JVN"],
  "serious": ["Gub","DuA","FRQ"],
  "seriously": ["KZ6"],
  "seriousness": ["KZ7"],
  "sermon": ["KZ8"],
  "serum": ["KZ9"],
  "servant": ["F92","CUx"],
  "servants": ["CUy"],
  "serve": ["Guc","Dlh","Dlg","Ecf"],
  "serve a country": ["EMI"],
  "serve dinner": ["He2"],
  "serve food": ["F93","Dlg","Ecf"],
  "serve one right": ["JVO"],
  "serve served": ["EUJ","Dlg","Dlh"],
  "served": ["EUJ"],
  "served some food": ["EUJ"],
  "server": ["F94","E3S"],
  "service": ["JVP"],
  "serviceman": ["KaA"],
  "serving": ["Ecf","Dlh","Dlg"],
  "serving food": ["Ecf","Dlg"],
  "sesame": ["JVQ"],
  "session": ["JVR"],
  "set": ["JVc"],
  "set about": ["JVS"],
  "set apart": ["JVT"],
  "set aside": ["JVU"],
  "set back": ["JVV"],
  "set foot in": ["JVX"],
  "set foot on": ["JVX"],
  "set forth": ["JVY"],
  "set in": ["JVZ"],
  "set off": ["JVa"],
  "set out": ["JVb"],
  "set the table": ["Gud","DuB","FRR"],
  "set up": ["He3"],
  "set yourself a goal": ["JVj"],
  "setback": ["JVW"],
  "setting": ["JVd"],
  "settle": ["JVi"],
  "settle down": ["JVe"],
  "settle for": ["JVf"],
  "settle in": ["JVg"],
  "settle on": ["JVh"],
  "settlement": ["KaB"],
  "settler": ["KaC"],
  "setup": ["KaD"],
  "seven": ["Gue","F97","Dbw","FRS","Dbu"],
  "seven apples": ["He4"],
  "seven eggs": ["He5"],
  "seven hundred": ["F95","Dbv"],
  "Seven Natural Wonders of the World": ["He6"],
  "seven o'clock": ["F96","DeU"],
  "seven thousand": ["Dbz"],
  "Seven Wonders of the Ancient World": ["He8"],
  "Seven Wonders of the Modern World": ["He9"],
  "Seven Wonders of the World": ["HfA"],
  "seventeen": ["Guf","F98","Dby","FRT","Dbx"],
  "seventeen cars": ["He7"],
  "seventeenth": ["HBC"],
  "seventh": ["HBQ","F99","E3T"],
  "seventy": ["Gug","GAF","Db6","FRU","Db0"],
  "seventy eight": ["GAA","Db1"],
  "seventy five": ["GAB","Db2"],
  "seventy four": ["GAC","Db3"],
  "seventy nine": ["GAD","Db4"],
  "seventy one": ["GAE","Db5"],
  "seventy seven": ["GAG","Db7"],
  "seventy six": ["GAH","Db8"],
  "seventy thousand": ["Db9"],
  "seventy three": ["GAI","DcA"],
  "seventy two": ["GAJ","DcB"],
  "sever": ["JVl"],
  "several": ["G9o"],
  "severe": ["JVk"],
  "severely": ["KaE"],
  "severity": ["KaF"],
  "sew": ["Guh","Dli","CU6","CU0","EZR","CUz"],
  "sew clothes": ["EZR","Dli"],
  "sew sewed": ["Dli"],
  "sew some clothes": ["EMK"],
  "sewage": ["JVm"],
  "sewage system": ["JVn"],
  "sewer": ["KaG"],
  "sewerage": ["JVo"],
  "sewing": ["GAL","Dli","CU5"],
  "sewing clothes": ["Dli"],
  "sewing machine": ["GAK","CU1","CU3","CU2","CU4"],
  "sexism": ["HfB"],
  "sexual": ["KaJ"],
  "sexuality": ["KaH"],
  "sexually": ["KaI"],
  "sexy": ["KaK"],
  "shabby": ["KaL"],
  "shade": ["Gui","CU8","CU7"],
  "shades": ["GAM","CVB","CVC"],
  "shadow": ["Guj","CVD","CVF","CVE"],
  "shadowy": ["KaM"],
  "shady": ["KaN"],
  "shaft": ["JVp"],
  "shake": ["Gul","Dlj","FRV","CVH","Dlk","CVL","CVG"],
  "shake hands": ["Guk","Dlk","Dlj","Edh","CVI","CVK","CVJ"],
  "shake hands with": ["JVq"],
  "shake off": ["JVr"],
  "shake shook": ["EU9","Dlj","Dlk"],
  "shake up": ["JVs"],
  "shaker": ["CVM"],
  "Shakespeare": ["KaO"],
  "shaking": ["GAO","Dlk","Dlj"],
  "shaking hands": ["GAN","Dlj","Dlk","Edh"],
  "shaky": ["KaP"],
  "shall": ["KaQ"],
  "shallow": ["GAP","DuC"],
  "shame": ["JVt"],
  "shampoo": ["Gum","DLy","FRW","CVO","CVQ","D5F","CVP"],
  "Shanghai": ["G9p"],
  "shape": ["GAQ"],
  "shape up": ["JVu"],
  "shapes": ["Gun","CVR"],
  "share": ["Guo","Dll","FRX"],
  "share a pizza": ["Dll"],
  "share a toy": ["HfC"],
  "share pizza#": ["CVS"],
  "share shared": ["Dll"],
  "share the same taste": ["JVv"],
  "shareholder": ["KaR"],
  "sharing": ["Dll"],
  "sharing a pizza": ["Dll"],
  "shark": ["Gup","DLz","FRY","CVT","CVV","D5G","CVU"],
  "sharp": ["Gur","DL2","FRa","CVW","CVX","CVc"],
  "sharpen": ["JVw"],
  "sharpener": ["Guq","DL0","FRZ","CVZ","D5H","CVY","CVb","CVa"],
  "sharper": ["DL1"],
  "sharply": ["JVx"],
  "shatter": ["JVy"],
  "shave": ["Gus","Dlm","Dln","Ebb"],
  "shave shaved": ["Dlm","EVc","Dln"],
  "shave your face": ["HfD"],
  "shave your head": ["Dln"],
  "shaved": ["EVc"],
  "shaved his head": ["EVc"],
  "shaving": ["GAR","Ebb","Dlm","CVe","Dln"],
  "shaving your head": ["Dln"],
  "shawl": ["DuD"],
  "she": ["Gu0","GAV","E3U"],
  "she asks a question": ["Ebw"],
  "she blows her nose": ["Ebx"],
  "she brushes her hair": ["Eby"],
  "she carries a box": ["Ebz"],
  "she closes her laptop": ["Eb0"],
  "she combs her hair": ["Eb1"],
  "she concentrates": ["Eb2"],
  "she cooks": ["Eb3"],
  "she coughs": ["Eb4"],
  "she cries": ["Eb5"],
  "she cuts paper": ["Eb6"],
  "she designs clothes": ["Eb7"],
  "she dives into the water": ["Eb8"],
  "she does homework": ["Eb9"],
  "she draws on the board": ["EcA"],
  "she drinks water": ["EcB"],
  "she drives a car": ["EcC"],
  "she drops a ball": ["EcD"],
  "she eats pizza": ["EcE"],
  "she feeds a dog": ["EcF"],
  "she fills a glass with water": ["EcG"],
  "she fills out a form": ["EcH"],
  "she gets a book": ["EcI"],
  "she gets a haircut": ["EcJ"],
  "she hands out fliers": ["EcK"],
  "she hangs up clothes": ["EcL"],
  "she highlights lines": ["EcM"],
  "she holds a baby": ["EcN"],
  "she ignores him": ["EcO"],
  "she irons a shirt": ["EcP"],
  "she is a girl": ["HfF"],
  "she is asking a question": ["Ebw"],
  "she is blowing her nose": ["Ebx"],
  "she is brushing her hair": ["Eby"],
  "she is carrying a box": ["Ebz"],
  "she is closing her laptop": ["Eb0"],
  "she is combing her hair": ["Eb1"],
  "she is concentrating": ["Eb2"],
  "she is cooking": ["Eb3"],
  "she is coughing": ["Eb4"],
  "she is crying": ["Eb5"],
  "she is cutting paper": ["Eb6"],
  "she is designing clothes": ["Eb7"],
  "she is diving into the water": ["Eb8"],
  "she is doing homework": ["Eb9"],
  "she is drawing on the board": ["EcA"],
  "she is drinking water": ["EcB"],
  "she is driving a car": ["EcC"],
  "she is dropping a ball": ["EcD"],
  "she is eating": ["HfG"],
  "she is eating pizza": ["EcE"],
  "she is feeding a dog": ["EcF"],
  "she is filling a glass with water": ["EcG"],
  "she is filling out a form": ["EcH"],
  "she is getting a book": ["EcI"],
  "she is getting a haircut": ["EcJ"],
  "she is handing out fliers": ["EcK"],
  "she is hanging up clothes": ["EcL"],
  "she is happy": ["HfH"],
  "she is highlighting lines": ["EcM"],
  "she is holding a baby": ["EcN"],
  "she is hot": ["Ehm"],
  "she is ignoring him": ["EcO"],
  "she is ironing a shirt": ["EcP"],
  "she is looking after children": ["EcQ"],
  "she is moving the mouse": ["EcR"],
  "she is my friend": ["HfI"],
  "she is opening a bottle": ["EcS"],
  "she is opening a window": ["EcT"],
  "she is paying money": ["EcU"],
  "she is peeling a banana": ["EcV"],
  "she is picking flowers": ["EcW"],
  "she is pouring coffee": ["EcX"],
  "she is pressing a button": ["EcY"],
  "she is putting away the groceries": ["EcZ"],
  "she is reading a book": ["Eca"],
  "she is riding a horse": ["Ecb"],
  "she is running": ["Ecc"],
  "she is saying 'hello'": ["Ecd"],
  "she is selling apples": ["Ece"],
  "she is serving food": ["Ecf"],
  "she is shouting": ["Ecg"],
  "she is showing her id": ["Ech"],
  "she is singing": ["Eci"],
  "she is sitting": ["Ecj"],
  "she is six": ["HfJ"],
  "she is skating": ["Eck"],
  "she is skiing": ["Ecl"],
  "she is sleeping": ["Ecm"],
  "she is smelling a flower": ["Ecn"],
  "she is smiling": ["Eco"],
  "she is speaking English": ["Ecp"],
  "she is studying": ["Ecq"],
  "she is taking a photo": ["Ecr"],
  "she is taking a shower": ["Ecs"],
  "she is taking some pizza": ["Ect"],
  "she is talking on the phone": ["Ecu"],
  "she is tall": ["EiD"],
  "she is telling off the boy": ["Ecv"],
  "she is thinking": ["Ecw"],
  "she is tired": ["EiF"],
  "she is trying on a dress": ["Ecx"],
  "she is turning down some cake": ["Ecy"],
  "she is turning on the light": ["Ecz"],
  "she is tying her shoes": ["Ec0"],
  "she is using a computer": ["Ec1"],
  "she is visiting her grandparents": ["Ec2"],
  "she is waking up": ["Ec3"],
  "she is walking the dog": ["Ec4"],
  "she is waving her hand": ["Ec5"],
  "she is wearing glasses": ["Ehz"],
  "she is wiping the table": ["Ec6"],
  "she is withdrawing money": ["Ec7"],
  "she is writing": ["Ec8"],
  "she looks after children": ["EcQ"],
  "she moves the mouse": ["EcR"],
  "she opens a bottle": ["EcS"],
  "she opens a window": ["EcT"],
  "she pays money": ["EcU"],
  "she peels a banana": ["EcV"],
  "she picks flowers": ["EcW"],
  "she pours coffee": ["EcX"],
  "she presses a button": ["EcY"],
  "she puts away the groceries": ["EcZ"],
  "she reads a book": ["Eca"],
  "she rides a horse": ["Ecb"],
  "she runs": ["Ecc"],
  "she says 'hello'": ["Ecd"],
  "she sells apples": ["Ece"],
  "she serves food": ["Ecf"],
  "she shouts": ["Ecg"],
  "she shows her id": ["Ech"],
  "she sings": ["Eci"],
  "she sits": ["Ecj"],
  "she skates": ["Eck"],
  "she skis": ["Ecl"],
  "she sleeps": ["Ecm"],
  "she smells a flower": ["Ecn"],
  "she smiles": ["Eco"],
  "she speaks English": ["Ecp"],
  "she studies": ["Ecq"],
  "she takes a photo": ["Ecr"],
  "she takes a shower": ["Ecs"],
  "she takes some pizza": ["Ect"],
  "she talks on the phone": ["Ecu"],
  "she tells off the boy": ["Ecv"],
  "she thinks": ["Ecw"],
  "she ties her shoes": ["Ec0"],
  "she tries on a dress": ["Ecx"],
  "she turns down some cake": ["Ecy"],
  "she turns on the light": ["Ecz"],
  "she uses a computer": ["Ec1"],
  "she visits her grandparents": ["Ec2"],
  "she wakes up": ["Ec3"],
  "she walks the dog": ["Ec4"],
  "she waves her hand": ["Ec5"],
  "she wipes the table": ["Ec6"],
  "she withdraws money": ["Ec7"],
  "she writes": ["Ec8"],
  "shear": ["JVz"],
  "shear a sheep": ["HfE"],
  "sheath": ["JV0"],
  "shed": ["Gut","DL3","CVf","D5I","CVg","CVh"],
  "sheep": ["Guu","DL4","FRb","CVl","D5J","CVj","CVo","CVk","CVm"],
  "sheepdog": ["DYl"],
  "sheer": ["JV1"],
  "sheet": ["GAS","CVr","CVq"],
  "sheets": ["GAT","CVs"],
  "shelf": ["Guv","CVt","FRc","CVu","CVw","CVv","CVx"],
  "shell": ["Guw","CV0","FRd","CV1","DL5","CVy","CVz"],
  "shellfish": ["JV2"],
  "shells": ["Gux","CV3","FRe","CV2","CV4"],
  "shelter": ["Guy","CV6","CV8","CV5","CV7"],
  "shelves": ["Guz","DL6","FRf","CV9","D5K","CWA","CWC","CWB"],
  "shepherd": ["GAU","CWD","CWF","CWE"],
  "sheriff": ["JV3"],
  "sherry": ["KaS"],
  "shield": ["Gu1","DL7","CWK","CWG","CWI","CWJ"],
  "shift": ["HfK"],
  "shilling": ["KaT"],
  "shimmer": ["KaU"],
  "shine": ["Gu2","CWL","CWM"],
  "Shinto": ["HfL"],
  "shiny": ["Gu3","CWN"],
  "ship": ["Gu4","CWQ","FRg","CWO","CWP"],
  "shipment": ["KaV"],
  "shipping": ["HfM"],
  "shipwreck": ["E3V"],
  "shipwright": ["JV4"],
  "shirk": ["JV5"],
  "shirt": ["Gu5","DL9","FRh","DL8","D5M","CWR","CWS"],
  "shit": ["KaW"],
  "shitzu": ["GAW","CWT","CWU"],
  "shiver": ["JV6"],
  "shock": ["GAX","CWZ"],
  "shocked": ["Gu6","CWW","CWY","CWX"],
  "shoe": ["Gu7","CWa","CWc","CWb"],
  "shoe shop": ["Gu8","CWi","CWh"],
  "shoe store": ["GAY","CWl","CWk"],
  "shoes": ["Gu9","DMC","FRi","DMB","D5N","DMA","CWf","CWj","CWd","CWe","CWg"],
  "shook": ["EU9"],
  "shook hands": ["EU9"],
  "shoot": ["JV7"],
  "shooting star": ["HfN"],
  "shop": ["GvF","Dlo","FRn","Edi"],
  "shop around": ["JV8"],
  "shop assistant": ["GvA","DMD","FRj","DME","EMq","EMr"],
  "shop shopped": ["Dlo"],
  "shopkeeper": ["GAZ"],
  "shopper": ["KaX"],
  "shopping": ["GvE","Dlo","FRm","CWu","CWm","Edi"],
  "shopping cart": ["GAa","DMF"],
  "shopping center": ["GvB","CWn","DMG","DuE","CWo"],
  "shopping centre": ["GvC","DuE","FRk","CWn","DMG","CWo"],
  "shopping list": ["GAb","CWp"],
  "shopping mall": ["GvD","CWs","FRl","CWq","CWr","CWt"],
  "shops": ["GvG","CWv","FRo"],
  "shore": ["GvH","DuF"],
  "shore up": ["JV9"],
  "short": ["GvK","DuH","FRq","DuG","EMs","EMt"],
  "short hair": ["GvJ","CWw","FRp","CWx"],
  "shortage": ["JWA"],
  "shortcoming": ["KaY"],
  "shortcut": ["JWB"],
  "shorten": ["KaZ"],
  "shorter": ["GvI","DMJ","DMH","DMI","ESE"],
  "shortfall": ["Kaa"],
  "shorthand": ["Kab"],
  "shortly": ["JWC"],
  "shorts": ["GvL","DMK","FRr","CW1","D5Q","CW0","CWy","CWz"],
  "shot": ["Kad"],
  "shot put": ["HfO"],
  "shotgun": ["Kac"],
  "should": ["Kae"],
  "should be careful": ["HfP"],
  "should eat vegetables": ["HfQ"],
  "should go now": ["HfR"],
  "should study": ["HfS"],
  "shoulder": ["GvM","DML","FRs","D5R","CW2"],
  "shoulders": ["GvN","CW4","FRt","CW3"],
  "shout": ["GvO","Dlp","FRu","Ecg","CW7","EMu"],
  "shout angrily": ["ERR"],
  "shout for help": ["HfT"],
  "shout shouted": ["Dlp"],
  "shouted": ["GAc"],
  "shouting": ["GAd","Dlp","Ecg","CW6"],
  "shove": ["Kaf"],
  "shove over": ["JWD"],
  "shove up": ["JWE"],
  "shovel": ["GvP","CXB","FRv","CW8","CXA","CW9"],
  "show": ["GvR","Dlq","FRx","Dlr","EZU","Ech"],
  "show a phone": ["EZU","Dlq"],
  "show around": ["JWF"],
  "show id": ["Ech"],
  "show jumping": ["HfU"],
  "show me": ["HfV"],
  "show off": ["JWG"],
  "show respect": ["HfW"],
  "show showed": ["EUK","Dlq","Dlr"],
  "show the picture": ["HfX"],
  "show up": ["HfY"],
  "show your ID": ["Dlr"],
  "show your ticket": ["HfZ"],
  "show your work": ["Hfa"],
  "showcase": ["Kag"],
  "showdown": ["Kah"],
  "showed": ["GAe","EUK"],
  "showed her id": ["EUK"],
  "shower": ["GvQ","CXG","FRw","DMM","CXF","D5S","CXE","CXD","CXC"],
  "showing": ["Ech","Dlr","Dlq"],
  "showing a phone": ["Dlq"],
  "showing your ID": ["Dlr"],
  "showroom": ["Kai"],
  "shred": ["JWH"],
  "shrewd": ["JWI"],
  "shriek": ["Kaj"],
  "shrill": ["Kak"],
  "shrimp": ["GvS","CXH","FRy","DMN","CXL","CXJ","CXK","D5T","Eg8","CXI"],
  "shrine": ["Hfb"],
  "shrink": ["JWJ"],
  "shrivel": ["JWK"],
  "shroud": ["JWL"],
  "shrub": ["JWM"],
  "shrug": ["Kal"],
  "shrugged": ["GAf","CXN","CXM"],
  "shudder": ["Kam"],
  "shuffle": ["JWN"],
  "shun": ["Kan"],
  "shun mainstream values": ["JWO"],
  "shunt": ["Kao"],
  "shut": ["GvT","Dls","EZV","Ebc"],
  "shut away": ["JWP"],
  "shut down": ["JWQ"],
  "shut off": ["JWR"],
  "shut shut": ["Dls"],
  "shut the door": ["GAg","Dls","Ebc","EZV"],
  "shut up": ["Hfc"],
  "shutter": ["JWS"],
  "shutting": ["Ebc","Dls"],
  "shutting the door": ["Ebc","Dls"],
  "shuttle": ["JWT"],
  "shuttlecock": ["GAh","DuI"],
  "shy": ["GvU","CXP","FRz","EMv"],
  "shy away from": ["JWU"],
  "Siberia": ["Kaq"],
  "Siberian": ["Kap"],
  "sibling": ["GAi","CXQ"],
  "siblings": ["GvV","CXR"],
  "sic": ["Kav"],
  "Sicilian": ["Kar"],
  "Sicily": ["Kas"],
  "sick": ["GvW","CXS","FR0","CXU","DMO","EMw","CXT"],
  "sick day": ["G9q"],
  "sicken": ["Kat"],
  "sickness": ["Kau"],
  "side": ["Hfd"],
  "side against": ["JWV"],
  "side by side": ["JWX"],
  "side dish": ["GAj","CXW","CXV"],
  "side effects": ["JWY"],
  "side with": ["JWa"],
  "sidebar": ["JWW"],
  "sideline": ["Kaw"],
  "sidewalk": ["GvX","DuJ","FR1"],
  "sideways": ["JWZ"],
  "siege": ["JWb"],
  "sieve": ["JWc"],
  "sift": ["JWd"],
  "sigh": ["JWe"],
  "sight": ["GvY","DuK"],
  "sightsee": ["Kax"],
  "sightseeing": ["GvZ","CXZ","FR2","CXa"],
  "sign": ["Gva","CXc","FR3","Dlu","CXb","Dlt","Ebd"],
  "sign his name": ["Dlt"],
  "sign in": ["Hfe","G9r"],
  "sign name": ["Ebd"],
  "sign off": ["JWj"],
  "sign out": ["G9s"],
  "sign signed": ["EUe","Dlt","Dlu","Dlv"],
  "sign up": ["Hff"],
  "sign your name": ["Dlu"],
  "signal": ["JWf"],
  "signature": ["JWg"],
  "signed": ["EUe"],
  "signed my name": ["EUe"],
  "significance": ["JWh"],
  "significant": ["GAk","DuL"],
  "significantly": ["Kay"],
  "signify": ["JWi"],
  "signing": ["Dlu","Dlt","Ebd"],
  "signing his name": ["Dlt"],
  "signing your name": ["Dlu"],
  "signpost": ["GAl","CXe","CXg","CXf"],
  "Sikh": ["Kqy","Kqx"],
  "silence": ["GAm","CXh","CXi"],
  "silent": ["GAn","CXj"],
  "silently": ["Kaz"],
  "silhouette": ["Ka0"],
  "silica": ["JWk"],
  "silicate": ["JWl"],
  "silicon": ["JWm"],
  "Silicon": ["Ka1"],
  "Silicon Valley": ["Ka2"],
  "silk": ["Gvb","CXk"],
  "silly": ["Gvc","CXl","FR4","CXm"],
  "silt": ["JWn"],
  "silver": ["Gvd","CXn","FR5","CXo","DMP"],
  "silversmith": ["JWo"],
  "sim card": ["E3W"],
  "similar": ["JWp"],
  "similarity": ["Ka3"],
  "similarly": ["Ka4"],
  "simile": ["JWq"],
  "simmer": ["JWr"],
  "simple": ["JWs"],
  "simple machine": ["Hfg"],
  "simplicity": ["JWt"],
  "simplification": ["Ka5"],
  "simplify": ["JWu"],
  "simplistic": ["Ka6"],
  "simply": ["JWv"],
  "simulate": ["JWw"],
  "simulation": ["Ka7"],
  "simultaneous": ["JWx"],
  "simultaneously": ["Ka8"],
  "sin": ["JW5"],
  "since": ["JWy"],
  "sincere": ["JWz"],
  "sincerely": ["Ka9"],
  "sincerity": ["KbA"],
  "sing": ["Gvi","Dlx","FSA","Dlv","Eci","Dlw","CXp","EZW","CX3","CXq"],
  "sing a song": ["Gvf","CXv","FR7","EZW"],
  "sing karaoke": ["GAp","Dlw"],
  "sing sang": ["GAq","EUF","Dlw","Dlx"],
  "sing songs": ["GAr","EM0"],
  "sing sung": ["EWA"],
  "Singapore": ["HEj","Gve","CXu","FR6","CXt","CXr","EMx","CXs"],
  "Singapore flag": ["GAo","DMQ"],
  "Singaporean": ["HEi","Kqz"],
  "singer": ["Gvg","DMS","FR8","CXx","DMR","D5U","EMy","CXy","CXw","EMz","CXz"],
  "singing": ["Gvh","Dlw","FR9","Dlv","Dlx","Eci","CX2","CX0","CX1"],
  "singing karaoke": ["Dlw"],
  "single": ["E3X"],
  "single out": ["JW0"],
  "singular": ["JW1"],
  "singularity": ["Hfh"],
  "sinister": ["JW2"],
  "sink": ["Gvj","DMT","FSB","CX8","CX4","D5V","CX7","CX5","CX6"],
  "sink in": ["JW3"],
  "sink or swim": ["JW4"],
  "sinuous": ["JW6"],
  "sip": ["Gvk","CX9","FSC"],
  "sir": ["KbC"],
  "siren": ["KbB"],
  "sister": ["Gvl","DZe","FSD","CYA","EM1","EM2","EM5"],
  "sister in law": ["EM3","EM4"],
  "sisterinlaw": ["EM3","EM4"],
  "sit": ["Gvn","CYI","FSF","Ecj","CYD","CYB","CYC","EZX"],
  "sit around": ["JW7"],
  "sit between": ["Hfi"],
  "sit down": ["Gvm","Dly","FSE","EM7","CYG","EM6","CYF"],
  "sit down comfortably": ["ERS"],
  "sit down sat down": ["Dly"],
  "sit here": ["Hfj"],
  "sit in a circle": ["Hfk"],
  "sit next to": ["Hfl"],
  "sit on": ["Dlz"],
  "sit on a chair": ["Hfm"],
  "sit on a sofa": ["Dlz"],
  "sit on the chair": ["Hfn"],
  "sit on the sofa": ["EZX"],
  "sit out": ["JW9"],
  "sit sat": ["Gvo","Dlz","EUG"],
  "sit still": ["Hfo"],
  "sit through": ["JXA"],
  "sit up": ["CYK"],
  "sitcom": ["GAs","DuM"],
  "site": ["JW8"],
  "sitting": ["Gvp","Ecj"],
  "sitting down": ["GAt","Dly"],
  "sitting on": ["Dlz"],
  "sitting on a sofa": ["GAu","Dlz"],
  "sitting room": ["GAv","CYJ"],
  "situate": ["JXC"],
  "situated": ["JXB"],
  "situation": ["KbD"],
  "six": ["Gvq","GAy","DcE","FSG","DcC"],
  "six apples": ["Hfp"],
  "six balls": ["Hfq"],
  "six hundred": ["GAw","DcD"],
  "six o'clock": ["GAx","DeV"],
  "six thousand": ["DcH"],
  "sixteen": ["Gvr","GAz","GA0","DcG","FSH","DcF"],
  "sixteen birds": ["Hfr"],
  "sixteenth": ["HBB"],
  "sixth": ["HBP","GA1","E3Y"],
  "sixty": ["Gvs","GA7","DcO","DcI"],
  "sixty eight": ["GA2","DcJ"],
  "sixty five": ["GA3","DcK"],
  "sixty four": ["GA4","DcL"],
  "sixty nine": ["GA5","DcM"],
  "sixty one": ["GA6","DcN"],
  "sixty seven": ["GA8","DcP"],
  "sixty six": ["GA9","DcQ"],
  "sixty thousand": ["DcR"],
  "sixty three": ["GBA","DcS"],
  "sixty two": ["GBB","DcT"],
  "size": ["JXD"],
  "size up": ["JXE"],
  "sizeable": ["KbE"],
  "skate": ["Gvw","Dl1","FSK","CYQ","Dl0","Eck"],
  "skate on ice": ["Hfs"],
  "skate over": ["JXF"],
  "skate park": ["Gvv","DuN"],
  "skate skated": ["EUL","Dl0","Dl1"],
  "skateboard": ["Gvu","DMV","FSJ","CYL","D5X","CYM","CYP"],
  "skateboarding": ["Gvt","DMU","FSI","CYO","D5W","CYN"],
  "skated": ["EUL"],
  "skates": ["Gvx","CYR"],
  "skating": ["Gvy","Dl1","FSL","CYS","Dl0","Eck"],
  "skating rink": ["GBC","CYT"],
  "skeletal": ["JXG"],
  "skeletal system": ["Hft"],
  "skeleton": ["Gvz","CYV","FSM","CYW","CYU","EM8"],
  "skeletons": ["EM9"],
  "skeptic": ["JXI"],
  "skeptical": ["JXH"],
  "skepticism": ["KbF"],
  "sketch": ["GBD","CYX"],
  "sketch out": ["JXJ"],
  "skew": ["JXK"],
  "ski": ["Gv3","Dl2","CYY","Ecl","CYf","CYZ"],
  "ski down a hill": ["Hfu"],
  "ski jacket": ["CYc"],
  "ski skied": ["Dl2"],
  "skid": ["KbG"],
  "skier": ["KbH"],
  "skiing": ["Gv0","Dl2","FSN","CYb","CYa","Ecl","DMW","D5Y"],
  "skill": ["JXL"],
  "skillful": ["KbI"],
  "skim": ["JXM"],
  "skimp on": ["JXN"],
  "skin": ["Gv2","CYd","FSO"],
  "skinny": ["Gv1","DuO"],
  "skip": ["Gv6","CYi","FSQ","CYe"],
  "skip over": ["JXO"],
  "skip through": ["JXP"],
  "skipper": ["KbJ"],
  "skipping": ["Gv4","CYg"],
  "skipping rope": ["Gv5","CYh","FSP"],
  "skirt": ["Gv7","DMX","FSR","CYj","CYn","D5Z","CYm","CYo","CYk","CYl"],
  "skis": ["Gv8","DMY","CYp"],
  "skull": ["Gv9","CYs","CYr","CYt","CYq"],
  "skunk": ["GwA","DMZ","CYx","CYw","D5a","CYu","CYv"],
  "sky": ["GwC","CY1","FSS","CYy","CYz","CY0","DvQ"],
  "skybridge": ["E3Z"],
  "skydiving": ["GwB","DuP"],
  "skyline": ["KbK"],
  "skyscraper": ["GwD","CY3","FST","CY4"],
  "skyscrapers": ["GBE","CY7","CY6"],
  "skyscrappers": ["DMa"],
  "slab": ["JXQ"],
  "slack": ["KbL"],
  "slacken": ["JXR"],
  "slam": ["JXS"],
  "slander": ["JXT"],
  "slang": ["KbM"],
  "slant": ["KbN"],
  "slap": ["JXU"],
  "slash": ["JXV"],
  "slate": ["E3a"],
  "slaughter": ["KbO"],
  "slave": ["JXW"],
  "slavery": ["KbP"],
  "slay": ["KbQ"],
  "sled": ["GwF","CY8","FSU","CZG","CY9","CZA"],
  "sledding": ["JXX"],
  "sledge": ["GwE","CZB","CZC","CZF","CZE"],
  "sleek": ["JXY"],
  "sleep": ["GwI","Dl6","FSX","Dl3","Ecm","CZP","Dl4","CZH","END","Dl5","CZI","EZY"],
  "sleep early": ["Hfv"],
  "sleep in": ["JXZ"],
  "sleep in bed": ["Hfw"],
  "sleep in class": ["GBF","Dl5","EZY"],
  "sleep late": ["Hfx"],
  "sleep like a log": ["ENA","ENB","ENC"],
  "sleep off": ["JXa"],
  "sleep over": ["JXb"],
  "sleep slept": ["GBH","ETM","Dl3","EVw","Dl5","Dl4","Dl6"],
  "sleep upstairs": ["Hfy"],
  "sleep well": ["Hfz"],
  "sleeping": ["GwH","Dl6","FSW","Ecm","Dl3","Dl4","CZN","Dl5","CZJ","CZK"],
  "sleeping bag": ["GwG","CZL","FSV","CZM"],
  "sleeping in class": ["Dl5"],
  "sleepover": ["GBG","CZO"],
  "sleepy": ["GwJ","CZS","FSY","CZQ","CZR"],
  "sleet": ["Hf0","G9t"],
  "sleeve": ["JXc"],
  "sleigh": ["GwK","GBI","CZX","FSZ","Eh4","CZT","CZU","ENE"],
  "slender": ["JXd"],
  "slept": ["GBJ","EVw","ETM"],
  "slept in class": ["EVw"],
  "slice": ["GwL","CZY","CZZ","CZa","CZe","CZb"],
  "slice bread": ["Hf1"],
  "slice of cake": ["GBK","CZc"],
  "slice of pie": ["CZd"],
  "slick": ["JXe"],
  "slide": ["GwM","DMb","FSa","CZg","D5c","CZh","CZf"],
  "slight": ["JXf"],
  "slightly": ["KbR"],
  "slim": ["GwN","CZi","FSb"],
  "slim down": ["JXg"],
  "sling": ["KbS"],
  "slip": ["GwP","DuQ"],
  "slip away": ["JXh"],
  "slip up": ["JXi"],
  "slipper": ["KbT"],
  "slippers": ["GwO","DMc","FSc","CZl","CZk","D5d","CZm","CZj"],
  "slippery": ["Hf2"],
  "slit": ["KbU"],
  "slog": ["JXk"],
  "slogan": ["JXj"],
  "slope": ["GBL","CZn"],
  "slot": ["JXl"],
  "sloth": ["GwQ","DuR"],
  "slough": ["JXm"],
  "Slovak": ["HEl","Kq0","G9u"],
  "Slovakia": ["HEk","GBM","CZr","CZo","ENF"],
  "Slovene": ["G9v","Kq1"],
  "Slovenia": ["HEn","ENG"],
  "Slovenian": ["HEm"],
  "slow": ["GwR","CZt","FSd","DMe","CZs","ENH"],
  "slow computer": ["Hf3"],
  "slow down": ["Hf4"],
  "slow learner": ["Hf5"],
  "slow walker": ["Hf7"],
  "slowdown": ["KbV"],
  "slower": ["GBN","DMd"],
  "slowly": ["GBO","DuS","ERV"],
  "slowly please": ["Hf6"],
  "slug": ["KbW"],
  "sluggish": ["JXn"],
  "slum": ["KbX"],
  "slumber": ["JXo"],
  "slump": ["KbY"],
  "slur": ["KbZ"],
  "slush": ["Hf8"],
  "sly": ["JXp"],
  "smack": ["Kba"],
  "small": ["GwT","DMj","FSe","DMf","ENI","Eh6","Eh5"],
  "small car": ["Hf9"],
  "small dog": ["HgA"],
  "small enough": ["HgB"],
  "small house": ["HgC"],
  "small tree": ["HgD"],
  "smaller": ["GwS","DMi","DMg","ESG"],
  "smallpox": ["JXq"],
  "smart": ["GwV","CZw","FSg"],
  "smart watch": ["GwW","DMk","D5e"],
  "smartphone": ["GwU","CZu","FSf","CZv"],
  "smash": ["GBP","CZy","CZx"],
  "smash into": ["JXr"],
  "smear": ["JXs"],
  "smell": ["GwX","Dl7","FSh","Ecn","Dl8","DmA","EZa","EZb","Dl9"],
  "smell a flower": ["Dl7","Ecn"],
  "smell bad": ["Eh7","EZa","Dl8","Dl9"],
  "smell flowers": ["GBQ","DmA"],
  "smell nice": ["EZb"],
  "smell smelled": ["EUM","Dl7","Dl8","Dl9","DmA"],
  "smelled": ["EUM"],
  "smelled a flower": ["EUM"],
  "smelling": ["Ecn","DmA","Dl7","Dl8","Dl9"],
  "smelling a flower": ["Ecn","Dl7"],
  "smelling bad": ["Dl8","Dl9"],
  "smelling flowers": ["DmA"],
  "smelly": ["GwY","DMl","ENJ","Eh7"],
  "smelting": ["JXt"],
  "smile": ["GwZ","DmC","FSi","DmB","Eco","CZ0","CZz"],
  "smile on": ["JXu"],
  "smile smiled": ["GBS","EUN","DmC","DmB"],
  "smiled": ["GBR","EUN"],
  "smiling": ["GBT","CZ1","Eco","DmC","DmB","CZ3"],
  "smirk": ["JXv"],
  "smog": ["HgE"],
  "smoke": ["Gwa","CZ4","FSj","CZ5"],
  "smoker": ["Kbb"],
  "smooth": ["Gwc","DuT"],
  "smooth out": ["JXx"],
  "smoothie": ["Gwb","CZ7","FSk","CZ9","CZ6","CaA","CZ8"],
  "smoothly": ["JXw"],
  "smother": ["JXy"],
  "smuggle": ["Kbc"],
  "snack": ["Gwd","DuV","FSl","DuU"],
  "snacks": ["Gwe","DuW"],
  "snag": ["Kbd"],
  "snail": ["Gwf","DMm","FSm","CaE","CaC","D5f","CaB","CaD"],
  "snake": ["Gwg","DMn","FSn","CaI","CaK","D5g","CaF","CaH","CaG","CaJ"],
  "snakes": ["GBU","CaL","CaM"],
  "snap": ["JX0"],
  "snap out of": ["JXz"],
  "snap up": ["JX1"],
  "snapshot": ["Kbe"],
  "snarl": ["Kbf"],
  "snatch": ["JX2"],
  "sneak": ["JX4"],
  "sneak out": ["JX3"],
  "sneak up on": ["JX5"],
  "sneaker": ["GBV","CaO","CaN"],
  "sneakers": ["Gwh","DMo","FSo","CaP","D5h","CaQ","CaR"],
  "sneaky": ["GBW","CaS"],
  "sneer": ["Kbg"],
  "sneeze": ["Gwi","DmD","FSp","CaU","CaT"],
  "sneeze sneezed": ["EUO","DmD"],
  "sneezed": ["EUO"],
  "sneezing": ["GBX","DmD","CaV"],
  "snide": ["JX6"],
  "sniff": ["GBY","CaW"],
  "sniff out": ["JX7"],
  "sniper": ["CaX"],
  "snooker": ["GBZ","CaZ"],
  "snoop around": ["JX8"],
  "snore": ["Gwj","Caa","ENK"],
  "snore noisily": ["ERT"],
  "snorkel": ["Gwl","Cab","FSq","Cad","DMp","Cag","D5i","Cac"],
  "snorkeling": ["Gwk","Caf","Cae"],
  "snort": ["Kbh"],
  "snow": ["Gwu","DmE","FSw","Cah","DMr","Cak","D5j","Cai","DMq","CbR","Caj"],
  "snow day": ["HgF"],
  "snow globe": ["GBa","Ca5","Ca7","Ca6"],
  "snow in": ["JX9"],
  "snow leopard": ["GBb","CbG","CbH","CbD"],
  "snow shoes": ["CbT"],
  "snow shower": ["HgG"],
  "snow snowed": ["ETa","DmE"],
  "snow under": ["JYA"],
  "snowball": ["Gwn","Can","FSr","Cal"],
  "snowball fight": ["Gwm","Cam"],
  "snowboard": ["Gwp","Caw","Cao"],
  "snowboarder": ["Caq","Cap"],
  "snowboarding": ["Gwo","Cau","FSs","Cav","Cas","Cat"],
  "snowed": ["ETa"],
  "snowflake": ["Gwq","Ca0","FSt","Cay","ENL","Cax","Caz"],
  "snowflakes": ["Gwr","Ca4","Ca2","Ca3"],
  "snowing": ["Gws","CbA","FSu","DmE","CbB","Ca9"],
  "snowman": ["Gwt","GBc","CbM","FSv","Eh8","CbO","CbN","CbL","ENM","CbK","CbI"],
  "snowmen": ["GBd","CbP"],
  "snowstorm": ["GBe","CbU","CbW","CbV"],
  "snowy": ["Gwv","CbZ","FSx","CbX","ENN","CbY"],
  "so": ["Kb7"],
  "so called": ["JYH"],
  "so far": ["JYM"],
  "so far so good": ["JYN"],
  "so long": ["HgU"],
  "so that": ["G91"],
  "soak": ["JYC"],
  "soak in": ["JYB"],
  "soak up": ["E3b"],
  "soap": ["Gww","DMs","FSy","Cbe","D5k","Cbd","Cbc","Cba","Cbb"],
  "soar": ["JYD"],
  "sob": ["JYG"],
  "sober": ["JYE"],
  "sober up": ["JYF"],
  "soccer": ["Gwz","GBg","DMt","FS0","Cbs","D5l","Cbg","Cbh","Cbf","Cbi"],
  "soccer ball": ["Gwx","Cbm","Cbk","Cbj","Cbl"],
  "soccer field": ["GBf","Cbn","Cbo"],
  "soccer player": ["Gwy","Cbp","FSz","Cbr","Cbq"],
  "sociable": ["Gw0","DuX"],
  "social": ["HgJ"],
  "social class": ["HgH"],
  "social media": ["Gw1","Cbt"],
  "social services": ["JYJ"],
  "social studies": ["GBh","E3c"],
  "social welfare": ["JYK"],
  "social well being": ["JYL"],
  "socialism": ["Kbi"],
  "socialist": ["HgI"],
  "socialization": ["Kbj"],
  "socialize": ["JYI"],
  "socially": ["Kbk"],
  "societal": ["Kbl"],
  "society": ["HgK"],
  "socioeconomic": ["Kbm"],
  "sociolinguistic": ["Kbn"],
  "sociological": ["Kbo"],
  "sociologist": ["Kbp"],
  "sociology": ["HgL"],
  "sock": ["Gw3","Cbx","FS1","Cbu","Cbv","Cbw"],
  "socket": ["Gw2","DMu","D5m"],
  "socket adapter": ["E3d"],
  "socks": ["Gw4","DMw","FS2","DMv","Cbz","D5n","Cby","Cb1","Cb0"],
  "Socrates": ["Kbq"],
  "sod": ["Kbr"],
  "soda": ["Gw5","Cb5","FS3","DMx","Cb3","Cb4","Cb2","Cb6"],
  "sodium": ["HgN"],
  "sodium chloride": ["HgM"],
  "sofa": ["Gw6","DMy","FS4","D5o","Cb9","CcA","Cb7","Cb8"],
  "soft": ["Gw7","CcC","FS5","ENO","CcB"],
  "softball": ["HgO"],
  "soften": ["Kbs"],
  "softly": ["Kbt"],
  "software": ["HgP"],
  "software developer": ["ENQ","DM0"],
  "software engineer": ["GBi","DM1","ENR"],
  "soil": ["Gw8","CcE","FS6","CcH","CcG","CcD","CcF"],
  "solar": ["JYO"],
  "solar eclipse": ["GBj","CcJ","CcK"],
  "solar energy": ["HgQ"],
  "solar flare": ["HgR"],
  "solar panel": ["HgS"],
  "Solar System": ["Gw9","CcM","FS7","CcN"],
  "solar wind": ["HgT"],
  "sold": ["GBl","EUP","DuY"],
  "sold apples": ["EUP"],
  "solder": ["JYP"],
  "soldier": ["GxA","DM3","FS8","DM4","CcR","CcQ","ENU","D5p","CcO","ENT","CcP"],
  "soldiers": ["GBk","CcT","CcS","CcU"],
  "sole": ["JYR"],
  "solely": ["Kbu"],
  "solemn": ["JYQ"],
  "solicit": ["JYS"],
  "solicitation": ["Kbv"],
  "solicitor": ["Kbw"],
  "solid": ["GxB","CcW"],
  "solidarity": ["JYT"],
  "solidify": ["JYU"],
  "solitary": ["CcY","CcX"],
  "solitude": ["JYV"],
  "solo": ["JYX"],
  "soloist": ["JYW"],
  "solstice": ["HgV"],
  "soluble": ["JYY"],
  "solute": ["HgW"],
  "solution": ["HgX"],
  "solve": ["GxC","CcZ"],
  "solvent": ["HgY"],
  "somatic": ["Kbx"],
  "somber": ["JYZ"],
  "some": ["E3e"],
  "some air pollution": ["ICr"],
  "some alcohol": ["ICs"],
  "some animals": ["ICt"],
  "some appetizers": ["ICu"],
  "some apple juice": ["ICv"],
  "some apple pie": ["ICw"],
  "some apples": ["ICx"],
  "some apps": ["ICy"],
  "some avocado": ["ICz"],
  "some badges": ["IC0"],
  "some balloons": ["IC1"],
  "some balls": ["IC2"],
  "some bananas": ["IC3"],
  "some bats": ["IC4"],
  "some baubles": ["IC5"],
  "some beads": ["IC6"],
  "some beans": ["IC7"],
  "some beavers": ["IC8"],
  "some beef": ["IC9"],
  "some beer": ["IDA"],
  "some bees": ["IDB"],
  "some beetles": ["IDC"],
  "some bells": ["IDD"],
  "some berries": ["IDE"],
  "some bicycles": ["IDF"],
  "some birthday cake": ["IDG"],
  "some biscuits": ["IDH"],
  "some blackberries": ["IDI"],
  "some blankets": ["IDJ"],
  "some blueberries": ["IDK"],
  "some bowls": ["IDL"],
  "some boys": ["IDM"],
  "some bracelets": ["IDN"],
  "some braids": ["IDO"],
  "some bread": ["IDP"],
  "some bricks": ["IDQ"],
  "some broccoli": ["IDR"],
  "some brothers": ["IDS"],
  "some brown hair": ["IDT"],
  "some bubble tea": ["IDU"],
  "some bugs": ["IDV"],
  "some bunnies": ["IDW"],
  "some burgers": ["IDX"],
  "some buses": ["IDY"],
  "some bushes": ["IDZ"],
  "some butter": ["IDb"],
  "some butterflies": ["IDa"],
  "some buttons": ["IDc"],
  "some cabbage": ["IDd"],
  "some cables": ["IDe"],
  "some cafes": ["IDf"],
  "some cake": ["IDg"],
  "some candles": ["IDh"],
  "some candy": ["IDi"],
  "some carrots": ["IDj"],
  "some cats": ["IDk"],
  "some cauliflower": ["IDl"],
  "some CDs": ["IDm"],
  "some cells": ["IDn"],
  "some cereal": ["IDo"],
  "some chalk": ["IDp"],
  "some cheese": ["IDr"],
  "some cheeseburgers": ["IDq"],
  "some cherries": ["IDs"],
  "some chicken": ["IDu"],
  "some chicken nuggets": ["IDt"],
  "some children": ["IDv"],
  "some chimpanzees": ["IDw"],
  "some chimps": ["IDx"],
  "some chocolate": ["ID0"],
  "some chocolate bars": ["IDy"],
  "some chocolate cake": ["IDz"],
  "some chocolates": ["ID1"],
  "some chopsticks": ["ID2"],
  "some clams": ["ID3"],
  "some clocks": ["ID4"],
  "some clothes": ["ID5"],
  "some cockroaches": ["ID6"],
  "some coffee": ["ID7"],
  "some coke": ["ID8"],
  "some cola": ["ID9"],
  "some containers": ["IEA"],
  "some cookies": ["IEB"],
  "some corn": ["IEC"],
  "some costumes": ["IED"],
  "some countries": ["IEE"],
  "some cousins": ["IEF"],
  "some cowboys": ["IEG"],
  "some cows": ["IEH"],
  "some crabs": ["IEI"],
  "some crackers": ["IEJ"],
  "some crayons": ["IEK"],
  "some cream": ["IEL"],
  "some crisps": ["IEM"],
  "some croissants": ["IEN"],
  "some crows": ["IEO"],
  "some cucumber": ["IEP"],
  "some cupcakes": ["IEQ"],
  "some cups": ["IER"],
  "some curtains": ["IES"],
  "some cushions": ["IET"],
  "some customers": ["IEU"],
  "some daffodils": ["IEV"],
  "some daisies": ["IEW"],
  "some decorations": ["IEX"],
  "some dessert": ["IEY"],
  "some diamonds": ["IEZ"],
  "some dinosaurs": ["IEa"],
  "some dogs": ["IEb"],
  "some donuts": ["IEc"],
  "some doughnuts": ["IEd"],
  "some dragon fruit": ["IEf"],
  "some dragonflies": ["IEe"],
  "some dragons": ["IEg"],
  "some drawers": ["IEh"],
  "some ducks": ["IEi"],
  "some dwarves": ["IEj"],
  "some eagles": ["IEk"],
  "some earmuffs": ["IEl"],
  "some earrings": ["IEm"],
  "some eels": ["IEn"],
  "some eggplant": ["IEo"],
  "some eggs": ["IEp"],
  "some elves": ["IEq"],
  "some envelopes": ["IEr"],
  "some eyebrows": ["IEs"],
  "some eyelashes": ["IEt"],
  "some fairies": ["IEu"],
  "some falcons": ["IEv"],
  "some fans": ["IEw"],
  "some farmers": ["IEx"],
  "some farms": ["IEy"],
  "some feathers": ["IEz"],
  "some feet": ["IE0"],
  "some fingers": ["IE1"],
  "some firefighters": ["IE2"],
  "some fireworks": ["IE3"],
  "some fish": ["IE5"],
  "some fish and chips": ["IE4"],
  "some flamingos": ["IE6"],
  "some flights": ["IE7"],
  "some flip flops": ["IE8"],
  "some flour": ["IE9"],
  "some fog": ["IFA"],
  "some food": ["IFB"],
  "some footprints": ["IFC"],
  "some fossils": ["IFD"],
  "some foxes": ["IFE"],
  "some freckles": ["IFF"],
  "some French fries": ["IFG"],
  "some friends": ["IFH"],
  "some frogs": ["IFI"],
  "some fruit": ["IFK"],
  "some fruit juice": ["IFJ"],
  "some fruit salad": ["IFL"],
  "some fruits": ["IFM"],
  "some fur": ["IFN"],
  "some gas": ["IFO"],
  "some germs": ["IFP"],
  "some ghosts": ["IFQ"],
  "some girls": ["IFR"],
  "some glasses": ["IFS"],
  "some gloves": ["IFT"],
  "some glue": ["IFU"],
  "some goals": ["IFV"],
  "some goats": ["IFW"],
  "some goggles": ["IFX"],
  "some goldfish": ["IFY"],
  "some grains": ["IFZ"],
  "some grapes": ["IFa"],
  "some grass": ["IFb"],
  "some guests": ["IFc"],
  "some guitars": ["IFd"],
  "some gummybears": ["IFe"],
  "some hair": ["IFf"],
  "some ham": ["IFh"],
  "some hamburgers": ["IFg"],
  "some handbags": ["IFi"],
  "some hangers": ["IFj"],
  "some hats": ["IFk"],
  "some headphones": ["IFl"],
  "some helmets": ["IFm"],
  "some hens": ["IFn"],
  "some hills": ["IFo"],
  "some hippos": ["IFp"],
  "some homes": ["IFq"],
  "some honey": ["IFr"],
  "some horns": ["IFs"],
  "some hotels": ["IFt"],
  "some hunters": ["IFu"],
  "some huts": ["IFv"],
  "some ice": ["IFx"],
  "some ice cream": ["IFw"],
  "some ids": ["IFy"],
  "some ingredients": ["IFz"],
  "some ink": ["IF0"],
  "some insects": ["IF1"],
  "some instruments": ["IF2"],
  "some islands": ["IF3"],
  "some jam": ["IF4"],
  "some jeans": ["IF5"],
  "some jellybeans": ["IF6"],
  "some jewels": ["IF7"],
  "some journalists": ["IF8"],
  "some juice": ["IF9"],
  "some junk food": ["IGA"],
  "some ketchup": ["IGB"],
  "some kidneys": ["IGC"],
  "some kittens": ["IGD"],
  "some kiwi fruit": ["IGE"],
  "some ladies": ["IGF"],
  "some lamb": ["IGG"],
  "some laundromats": ["IGH"],
  "some lava": ["IGI"],
  "some leaves": ["IGJ"],
  "some leggings": ["IGK"],
  "some lego": ["IGL"],
  "some legs": ["IGM"],
  "some lemonade": ["IGN"],
  "some lemons": ["IGO"],
  "some lentils": ["IGP"],
  "some lettuce": ["IGQ"],
  "some limes": ["IGR"],
  "some lipstick": ["IGS"],
  "some loaves": ["IGT"],
  "some lobster": ["IGU"],
  "some lobsters": ["IGV"],
  "some lollipops": ["IGW"],
  "some lungs": ["IGX"],
  "some machines": ["IGY"],
  "some magazines": ["IGZ"],
  "some mango": ["IGb"],
  "some mangoes": ["IGa"],
  "some marbles": ["IGc"],
  "some marshmallows": ["IGd"],
  "some mats": ["IGe"],
  "some meals": ["IGf"],
  "some meat": ["IGh"],
  "some meatballs": ["IGg"],
  "some medals": ["IGi"],
  "some melon": ["IGj"],
  "some men": ["IGk"],
  "some metal": ["IGl"],
  "some meteors": ["IGm"],
  "some mice": ["IGn"],
  "some milk": ["IGo"],
  "some milkshakes": ["IGp"],
  "some mineral water": ["IGq"],
  "some mistletoe": ["IGr"],
  "some mittens": ["IGs"],
  "some money": ["IGt"],
  "some monkeys": ["IGu"],
  "some monsters": ["IGv"],
  "some mosquitoes": ["IGw"],
  "some moths": ["IGx"],
  "some mountains": ["IGy"],
  "some mud": ["IGz"],
  "some muffins": ["IG0"],
  "some mugs": ["IG1"],
  "some mushrooms": ["IG2"],
  "some music": ["IG4"],
  "some musicians": ["IG3"],
  "some napkins": ["IG5"],
  "some nature": ["IG6"],
  "some needles": ["IG7"],
  "some neighbors": ["IG8"],
  "some neighbours": ["IG9"],
  "some newspapers": ["IHA"],
  "some noodles": ["IHB"],
  "some notebooks": ["IHC"],
  "some numbers": ["IHD"],
  "some nuts": ["IHE"],
  "some oats": ["IHF"],
  "some obstacles": ["IHG"],
  "some oil": ["IHH"],
  "some olives": ["IHI"],
  "some onions": ["IHJ"],
  "some oranges": ["IHK"],
  "some oysters": ["IHL"],
  "some pads": ["IHM"],
  "some paint": ["IHQ"],
  "some paintbrushes": ["IHN"],
  "some painters": ["IHO"],
  "some paintings": ["IHP"],
  "some pajamas": ["IHR"],
  "some pancakes": ["IHS"],
  "some pandas": ["IHT"],
  "some pants": ["IHU"],
  "some papaya": ["IHV"],
  "some papers": ["IHW"],
  "some parcels": ["IHX"],
  "some parents": ["IHY"],
  "some parrots": ["IHZ"],
  "some passengers": ["IHa"],
  "some pasta": ["IHb"],
  "some pastries": ["IHc"],
  "some peaches": ["IHd"],
  "some peanut butter": ["IHe"],
  "some peanuts": ["IHf"],
  "some pears": ["IHg"],
  "some peas": ["IHh"],
  "some pedestrians": ["IHi"],
  "some penguins": ["IHj"],
  "some people": ["IHk"],
  "some pepper": ["IHl"],
  "some peppers": ["IHm"],
  "some photos": ["IHn"],
  "some pictures": ["IHo"],
  "some pie": ["IHq"],
  "some pieces": ["IHp"],
  "some pies": ["IHr"],
  "some pigeons": ["IHs"],
  "some pigs": ["IHt"],
  "some pillows": ["IHu"],
  "some pills": ["IHv"],
  "some pineapple": ["IHw"],
  "some pizza": ["IHx"],
  "some planets": ["IHy"],
  "some plates": ["IHz"],
  "some pliers": ["IH0"],
  "some plums": ["IH1"],
  "some ponytails": ["IH2"],
  "some popcorn": ["IH3"],
  "some pork": ["IH4"],
  "some porridge": ["IH5"],
  "some postcards": ["IH6"],
  "some posters": ["IH7"],
  "some potato chips": ["IH8"],
  "some potatoes": ["IH9"],
  "some pots": ["IIA"],
  "some prawns": ["IIB"],
  "some pretzels": ["IIC"],
  "some pudding": ["IID"],
  "some pumpkin pie": ["IIE"],
  "some pumpkins": ["IIF"],
  "some puppies": ["IIG"],
  "some puzzles": ["IIH"],
  "some pyjamas": ["III"],
  "some rabbits": ["IIJ"],
  "some rackets": ["IIK"],
  "some rags": ["IIL"],
  "some rain": ["IIN"],
  "some raincoats": ["IIM"],
  "some raisins": ["IIO"],
  "some raspberries": ["IIP"],
  "some rectangles": ["IIQ"],
  "some relatives": ["IIR"],
  "some reptiles": ["IIS"],
  "some ribs": ["IIT"],
  "some rice": ["IIU"],
  "some rivers": ["IIV"],
  "some roads": ["IIW"],
  "some rockets": ["IIX"],
  "some roses": ["IIY"],
  "some rubber": ["IIZ"],
  "some sailboats": ["IIa"],
  "some sailors": ["IIb"],
  "some salad": ["IIc"],
  "some salmon": ["IId"],
  "some salt": ["IIf"],
  "some salt and pepper": ["IIe"],
  "some sand": ["IIh"],
  "some sandals": ["IIg"],
  "some sandwiches": ["IIi"],
  "some satellites": ["IIj"],
  "some sauce": ["IIk"],
  "some sauces": ["IIl"],
  "some sausages": ["IIm"],
  "some schoolbags": ["IIn"],
  "some scientists": ["IIo"],
  "some scissors": ["IIp"],
  "some seafood": ["IIq"],
  "some seaweed": ["IIr"],
  "some shampoo": ["IIs"],
  "some sheep": ["IIt"],
  "some shells": ["IIu"],
  "some shelves": ["IIv"],
  "some shirts": ["IIw"],
  "some shoes": ["IIx"],
  "some shorts": ["IIy"],
  "some shrimp": ["IIz"],
  "some signposts": ["II0"],
  "some sisters": ["II1"],
  "some skyscrapers": ["II2"],
  "some slippers": ["II3"],
  "some snacks": ["II4"],
  "some snails": ["II5"],
  "some sneakers": ["II6"],
  "some snow": ["II9"],
  "some snowballs": ["II7"],
  "some snowflakes": ["II8"],
  "some sockets": ["IJA"],
  "some socks": ["IJB"],
  "some soda": ["IJC"],
  "some sodas": ["IJD"],
  "some soldiers": ["IJE"],
  "some soup": ["IJF"],
  "some souvenirs": ["IJG"],
  "some spaghetti": ["IJH"],
  "some sparrows": ["IJI"],
  "some spiders": ["IJJ"],
  "some spinach": ["IJK"],
  "some spoons": ["IJL"],
  "some sports": ["IJM"],
  "some squid": ["IJN"],
  "some stairs": ["IJO"],
  "some star fruit": ["IJP"],
  "some steak": ["IJQ"],
  "some stickers": ["IJR"],
  "some stones": ["IJS"],
  "some strawberries": ["IJT"],
  "some straws": ["IJU"],
  "some stripes": ["IJV"],
  "some students": ["IJW"],
  "some sugar": ["IJX"],
  "some suncream": ["IJY"],
  "some sunflowers": ["IJZ"],
  "some sunglasses": ["IJa"],
  "some sunscreen": ["IJb"],
  "some superheroes": ["IJc"],
  "some sushi": ["IJd"],
  "some sweaters": ["IJe"],
  "some sweatshirts": ["IJf"],
  "some sweets": ["IJg"],
  "some swimmers": ["IJh"],
  "some tacos": ["IJi"],
  "some tadpoles": ["IJj"],
  "some tails": ["IJk"],
  "some tangerines": ["IJl"],
  "some taps": ["IJm"],
  "some taxis": ["IJn"],
  "some tea": ["IJo"],
  "some teaspoons": ["IJp"],
  "some teenagers": ["IJq"],
  "some teeth": ["IJr"],
  "some telephones": ["IJs"],
  "some tents": ["IJt"],
  "some textbooks": ["IJu"],
  "some tickets": ["IJv"],
  "some tigers": ["IJw"],
  "some tissues": ["IJx"],
  "some toast": ["IJy"],
  "some toes": ["IJz"],
  "some tofu": ["IJ0"],
  "some toilets": ["IJ1"],
  "some tomato sauce": ["IJ3"],
  "some tomatoes": ["IJ2"],
  "some tools": ["IJ4"],
  "some toothbrushes": ["IJ5"],
  "some torches": ["IJ6"],
  "some tourists": ["IJ7"],
  "some towels": ["IJ8"],
  "some towers": ["IJ9"],
  "some toys": ["IKA"],
  "some trainers": ["IKB"],
  "some trays": ["IKC"],
  "some trees": ["IKD"],
  "some triangles": ["IKE"],
  "some trousers": ["IKF"],
  "some trucks": ["IKG"],
  "some tshirts": ["IKH"],
  "some tulips": ["IKI"],
  "some tuna": ["IKJ"],
  "some turtles": ["IKK"],
  "some umbrellas": ["IKL"],
  "some vegetables": ["IKM"],
  "some waffles": ["IKN"],
  "some water": ["IKP"],
  "some watermelon": ["IKO"],
  "some whales": ["IKQ"],
  "some wheat": ["IKR"],
  "some wine": ["IKS"],
  "some wolves": ["IKT"],
  "some wood": ["IKU"],
  "some wool": ["IKV"],
  "some words": ["IKW"],
  "some yams": ["IKX"],
  "some yoghurt": ["IKY"],
  "some yogurt": ["IKZ"],
  "some zebras": ["IKa"],
  "some zucchini": ["IKb"],
  "somebody": ["G9w"],
  "someday": ["Kby"],
  "somehow": ["JYa"],
  "someone": ["G9x"],
  "someplace": ["Kbz"],
  "something": ["G9y"],
  "sometime": ["Kb0"],
  "sometimes": ["Kb1"],
  "somewhat": ["JYb"],
  "somewhere": ["G9z"],
  "son": ["GxE","Ccc","DZg","Cca","ENV","ENX"],
  "son in law": ["ENW","DZf"],
  "song": ["GxD","Ccb","FS9"],
  "songwriter": ["Kb2"],
  "soninlaw": ["GBm","ENW"],
  "soon": ["Kb3"],
  "sooner or later": ["JYc"],
  "soothe": ["JYd"],
  "soothing": ["JYe"],
  "sophisticate": ["Kb4"],
  "sophisticated": ["JYf"],
  "sophistication": ["Kb5"],
  "sophomore": ["Kb6"],
  "soprano": ["JYg"],
  "sore": ["JYh"],
  "sore eye": ["GBn"],
  "sore throat": ["GxF","DM5","FTA","D5q","Ccd"],
  "sorrow": ["JYi"],
  "sorry": ["GxG","DuZ"],
  "sorry about that": ["HgZ"],
  "sorry I'm late": ["Hga"],
  "sorry to hear": ["Hgb"],
  "sort": ["JYk"],
  "sort of": ["G90"],
  "sort out": ["JYj"],
  "sort through": ["JYl"],
  "soul": ["GBo","Ccf","Cce"],
  "sound": ["GBp"],
  "sound off": ["JYn"],
  "soundly": ["JYm"],
  "soundtrack": ["Kb8"],
  "soup": ["GxH","Cch","FTB","DM6","Ccg","Ccj","D5r","Cci"],
  "soup spoon": ["Cck","Ccl","Ccm"],
  "sour": ["GBq","E3f"],
  "source": ["JYo"],
  "south": ["Hgd","E3g"],
  "South Africa": ["GxI","Ccq","FTC","DM9","Ccp","Ccn","ENY"],
  "South Africa flag": ["DM7"],
  "South African": ["GBr","Kq2","DM8","EeT"],
  "South America": ["GxJ","Ccs","Ccr"],
  "South American": ["Kq4","Kq3"],
  "South Asia": ["KcA"],
  "South Asian": ["Kb9"],
  "South Korea": ["GxK","Ccv","FTD","Cct"],
  "South Korean": ["HEo","Kq7","G92"],
  "southeast": ["KcE"],
  "Southeast Asia": ["KcC"],
  "Southeast Asian": ["KcB"],
  "southeastern": ["KcD"],
  "southern": ["JYp"],
  "Southern Lights": ["Hgc"],
  "Southerner": ["Kq6","Kq5"],
  "southwest": ["KcG"],
  "southwestern": ["KcF"],
  "souvenir": ["GxL","Ccw","FTE"],
  "sovereign": ["JYq"],
  "sovereignty": ["KcH"],
  "sow": ["JYr"],
  "soy": ["JYt"],
  "soy sauce": ["GBs","Ccy","Ccx","Ccz"],
  "soybean": ["JYs"],
  "spa": ["E3i"],
  "space": ["GxM","Cc3","FTF","Cc0","Cc2","Cc1"],
  "space debris": ["Hge"],
  "space junk": ["Hgf"],
  "space probe": ["Hgg"],
  "space rover": ["Hgh"],
  "space shuttle": ["GBu","Cc7","Cc9"],
  "space station": ["GxO","CdA","FTH","CdB"],
  "space suit": ["GxP","CdC","CdD","CdE"],
  "spacecraft": ["GBt","Dua"],
  "spaceship": ["GxN","Cc6","FTG","Cc4","Cc5"],
  "spacious": ["GBv","CdF","CdG"],
  "spade": ["GxQ","DNA","FTI","CdJ","CdH","D5t"],
  "spaghetti": ["GxR","CdM","FTJ","CdL","DNC","D5v","CdO","CdK","CdN"],
  "spaghetti bolognese": ["D5u","DNB"],
  "Spain": ["GxS","CdS","FTK","DNE","CdP","D5w","ENZ","CdQ"],
  "Spain flag": ["DND"],
  "span": ["JYu"],
  "Spaniard": ["Kq8"],
  "Spanish": ["HEp","KsA","GxT","DNG","FTL","DNF","EeU","D5x"],
  "spanner": ["E3h"],
  "spare": ["JYv"],
  "spare ribs": ["CdT","CdU"],
  "spark": ["GBy","CdY"],
  "sparkle": ["JYw"],
  "sparkler": ["GBw","CdV"],
  "sparkling water": ["GBx","CdX","CdW"],
  "sparrow": ["GBz","Cdb","CdZ"],
  "sparse": ["JYx"],
  "Sparta": ["Kra"],
  "Spartan": ["Kq9"],
  "spatial": ["JYy"],
  "spatula": ["GB0","DNH"],
  "spawn": ["JYz"],
  "speak": ["GxW","DmH","FTN","DmG","Ecp","DmI","DmF","EZd"],
  "speak about politics": ["ENa"],
  "speak Chinese": ["GB1","DmF"],
  "speak different languages": ["ENb"],
  "speak English": ["GxU","DmG","Ecp"],
  "speak ill of": ["JY0"],
  "speak out": ["JY1"],
  "speak soon": ["Hgi"],
  "speak Spanish": ["GB3","DmI","EZd"],
  "speak spoke": ["GB4","DmG","DmF","DmH","DmI","ETN"],
  "speak spoken": ["EV8"],
  "speak up": ["Hgj"],
  "speak well of": ["JY2"],
  "speaker": ["E3j"],
  "speakers": ["GxV","DNI","FTM","Cdf","Cde","D5z"],
  "speaking": ["GB2","DmH","DmG","Ecp","DmF","DmI"],
  "speaking Chinese": ["DmF"],
  "speaking English": ["DmG"],
  "speaking Spanish": ["DmI"],
  "spear": ["GB5","Cdh","Cdj"],
  "spearhead": ["JY3"],
  "spec": ["KcP"],
  "special": ["GxX","Dub","FTO"],
  "specialist": ["KcI"],
  "specialization": ["KcJ"],
  "specialize": ["JY4"],
  "specially": ["KcK"],
  "specialty": ["KcL"],
  "species": ["GB6","Duc"],
  "specific": ["JY5"],
  "specifically": ["KcM"],
  "specification": ["KcN"],
  "specificity": ["KcO"],
  "specify": ["JY6"],
  "specimen": ["JY7"],
  "speck": ["JY9"],
  "speckle": ["JY8"],
  "spectacle": ["JZA"],
  "spectacular": ["JZB"],
  "spectator": ["JZC"],
  "specter": ["KcQ"],
  "spectral": ["KcR"],
  "spectrum": ["JZD"],
  "speculate": ["JZE"],
  "speculation": ["KcS"],
  "speculative": ["KcT"],
  "speech": ["JZF"],
  "speed": ["GB8"],
  "speed by": ["JZG"],
  "speed camera": ["Cdk"],
  "speed limit": ["GB7","Cdn","Cdm"],
  "speed of light": ["Hgk"],
  "speed off": ["JZH"],
  "speed skating": ["Hgl"],
  "speed up": ["Hgm"],
  "speedy": ["KcU"],
  "spell": ["GB9","Cdo"],
  "spell out": ["JZJ"],
  "spellbind": ["JZI"],
  "spelling": ["Hgn","G94"],
  "spelling bee": ["G93"],
  "spend": ["JZM"],
  "spend on": ["JZL"],
  "spending patterns": ["JZK"],
  "sperm": ["KcX"],
  "spermatid": ["KcV"],
  "spermatozoon": ["KcW"],
  "spew": ["JZN"],
  "sphere": ["GxY","Dud"],
  "spherical": ["JZO"],
  "spheroid": ["JZP"],
  "sphinx": ["GCA","Cdp","Cdr"],
  "spice": ["GCB"],
  "spice up": ["JZQ"],
  "spicy": ["GxZ","Cdu","FTP","Cdt","Cds"],
  "spider": ["Gxa","DNJ","FTQ","D50","Cdy","Cdw","Cdx","ENc","Cdv"],
  "spider web": ["GCD","Cd4","Cd2","Cd1"],
  "spiders": ["GCC","Cdz","Cd0"],
  "spike": ["GCE","Cd5"],
  "spiky": ["GCF","Cd9","Cd6","Cd7"],
  "spiky hair": ["Gxb","Cd8"],
  "spill": ["GCG","DmJ","CeA"],
  "spill over": ["JZR"],
  "spill spilt": ["EUt","DmJ"],
  "spill water": ["DmJ"],
  "spilling": ["DmJ"],
  "spilling water": ["DmJ"],
  "spilt": ["EUt"],
  "spin": ["Gxe","Duf"],
  "spin off": ["JZV"],
  "spinach": ["Gxc","CeH","FTR","CeD","CeF","CeE","CeG"],
  "spinal": ["KcY"],
  "spindle": ["KcZ"],
  "spine": ["Gxd","CeJ","CeI"],
  "spine chilling": ["JZS"],
  "spinet": ["JZT"],
  "spinkle": ["Due"],
  "spinning": ["JZU"],
  "spiny": ["JZW"],
  "spiral": ["JZX"],
  "spiral galaxy": ["Hgo"],
  "spire": ["Kca"],
  "spirit": ["JZY"],
  "spiritual": ["Kcc"],
  "spirituality": ["Kcb"],
  "spit": ["GCH","CeK"],
  "spit out": ["JZa"],
  "spite": ["JZZ"],
  "splash": ["Gxf","CeN","CeM","CeL"],
  "splash out": ["JZb"],
  "splashing": ["GCI"],
  "splendid": ["JZc"],
  "splendor": ["Kcd"],
  "splinter": ["Kce"],
  "split": ["GCJ","CeO"],
  "split up": ["JZd"],
  "spoil": ["GCL","CeP","CeQ"],
  "spoke": ["GCM","ETN"],
  "spoken": ["EV8"],
  "spoken Chinese": ["EV8"],
  "spokesman": ["Kcf"],
  "spokesperson": ["Kcg"],
  "spokeswoman": ["Kch"],
  "sponge": ["Gxh","CeS","CeR","CeT"],
  "sponge off": ["JZe"],
  "sponsor": ["JZf"],
  "sponsorship": ["Kci"],
  "spontaneity": ["JZg"],
  "spontaneous": ["JZh"],
  "spontaneously": ["Kcj"],
  "spoon": ["Gxi","DNK","FTT","CeU","CeX","D51","CeW","CeV"],
  "sporadic": ["JZi"],
  "spore": ["Kck"],
  "sport": ["GCN","E3k"],
  "sports": ["Gxm","Duj","FTV"],
  "sports car": ["GCO","CeY","Cea","CeZ"],
  "sports center": ["Gxj","Dug","Duh"],
  "sports centre": ["Gxk","Duh","FTU","Dug"],
  "sports day": ["GCP"],
  "sports field": ["Gxl","Dui"],
  "sports shop": ["GCQ","E3l"],
  "sportsman": ["Kcl"],
  "sporty": ["Gxn","Duk"],
  "spot": ["GCR"],
  "spotlight": ["Kcm"],
  "spots": ["Gxo","Dul","FTW"],
  "spouse": ["JZj"],
  "sprain": ["JZk"],
  "sprawl": ["JZl"],
  "spray": ["GCS","DmK","EZe"],
  "spray sprayed": ["DmK"],
  "spray water": ["EZe"],
  "spraying": ["DmK"],
  "spread": ["Gxp","DmL","EZf"],
  "spread butter": ["EZf","DmL"],
  "spread out": ["JZm"],
  "spread spread": ["DmL"],
  "spreading": ["DmL"],
  "spreading butter": ["DmL"],
  "spreadsheet": ["Kcn"],
  "spring": ["Gxq","Dum","FTX"],
  "spring onion": ["GCT","Cec"],
  "spring onions": ["Ced"],
  "spring roll": ["GCU","Cef","Ceg"],
  "spring rolls": ["GCV","DNL"],
  "spring up": ["JZn"],
  "sprinkle": ["E3m"],
  "sprinkler": ["GCW","Ceh"],
  "sprint": ["Hgp"],
  "sprout": ["JZo"],
  "spruce": ["JZp"],
  "spun": ["JZq"],
  "spur": ["JZs"],
  "spurn": ["JZr"],
  "spurt": ["Kco"],
  "sputnik": ["JZt"],
  "spy": ["Gxr","Cej","Cei"],
  "spy on": ["JZu"],
  "squabble": ["JZv"],
  "squad": ["Kcp"],
  "squadron": ["Kcq"],
  "squall": ["Hgq"],
  "squander": ["JZw"],
  "square": ["Gxs","Cek","FTY"],
  "square off": ["JZx"],
  "square up": ["JZy"],
  "squarely": ["Kcr"],
  "squash": ["Gxt","Cen","Cel","Cem"],
  "squat": ["Kcs"],
  "squats": ["GCX","Ceo","Cep"],
  "squeak": ["Kct"],
  "squeal": ["Kcu"],
  "squeeze": ["GCY","Cer","DmM","Ces","Ceq","Ebe"],
  "squeeze an orange": ["DmM","Ebe"],
  "squeeze squeezed": ["DmM"],
  "squeeze up": ["JZz"],
  "squeezing": ["Ebe","DmM"],
  "squeezing an orange": ["Ebe","DmM"],
  "squid": ["Gxu","Cev","FTZ","Ceu","Cet","Cew"],
  "squint": ["Kcv"],
  "squirrel": ["Gxv","Ce0","FTa","DNM","D52","Cez","Cex"],
  "squirt": ["JZ0"],
  "Sri Lanka": ["HEs","GCZ","ENd","Ce1","Ce3"],
  "Sri Lankan": ["HEr","KrA","G95"],
  "stab": ["JZ1"],
  "stability": ["Kcw"],
  "stabilization": ["Kcx"],
  "stabilize": ["Kcy"],
  "stable": ["GCa","Ce6","Ce5"],
  "stack": ["JZ2"],
  "stack of books": ["GCb","Ce7"],
  "stack up": ["JZ3"],
  "stadium": ["Gxw","CfB","FTb","Ce8","DNN","CfA","D53","Ce9"],
  "staff": ["JZ4"],
  "staffer": ["Kcz"],
  "stage": ["Gxx","CfD","FTc","CfC"],
  "stagecoach": ["JZ5"],
  "stagger": ["JZ8"],
  "staggered": ["JZ6"],
  "staggering": ["JZ7"],
  "stagnant": ["JZ9"],
  "stain": ["JaA"],
  "stainless": ["Kc0"],
  "stair": ["Gxy","CfG","CfF","CfE"],
  "staircase": ["JaB"],
  "stairs": ["Gxz","DNO","FTd","CfH","CfL","CfI","CfM","CfK"],
  "stake": ["JaC"],
  "stakeholder": ["Kc1"],
  "stale": ["JaD"],
  "stalk": ["JaE"],
  "stall": ["E3n"],
  "stamina": ["Kc2"],
  "stamp": ["Gx0","CfP","FTe","CfO","CfN","CfQ"],
  "stampede": ["JaF"],
  "stamps": ["Gx1","CfR"],
  "stance": ["JaG"],
  "stand": ["Gx2","DmN","FTf"],
  "stand a chance": ["JaH"],
  "stand around": ["JaJ"],
  "stand at the front": ["Hgr"],
  "stand back": ["JaK"],
  "stand behind": ["JaL"],
  "stand by": ["JaM"],
  "stand by the door": ["Hgs"],
  "stand for": ["JaN"],
  "stand here": ["Hgt"],
  "stand in a line": ["Hgu"],
  "stand in line": ["Hgv"],
  "stand next to": ["Hgw"],
  "stand out": ["JaO"],
  "stand still": ["Hgx"],
  "stand stood": ["GCe","DmN","EUQ"],
  "stand to reason": ["JaP"],
  "stand up": ["Gx3","DmO","ENe"],
  "stand up stood up": ["DmO"],
  "stand up to": ["JaQ"],
  "standard": ["JaI"],
  "standardization": ["Kc3"],
  "standardize": ["Kc4"],
  "standing": ["GCc","DmN"],
  "standing in line": ["Dun"],
  "standing up": ["GCd","DmO"],
  "standpoint": ["Kc5"],
  "stanza": ["JaR"],
  "staple": ["JaS"],
  "staple the pages": ["Hgy"],
  "stapler": ["Gx4","DNP","FTg","CfT","CfU","CfS","D54"],
  "star": ["Gx8","CfW","FTi","Cfh","CfV"],
  "star cluster": ["Hgz"],
  "star fish": ["Gx5","CfY","CfX","CfZ"],
  "star fruit": ["Gx7","Cfa","Cfc","Cfb","Cfd"],
  "star lantern": ["GCg"],
  "starch": ["JaT"],
  "stardom": ["JaU"],
  "stare": ["GCf","DmP","EZh"],
  "stare at": ["JaV"],
  "stare out the window": ["EZh","DmP"],
  "stare stared": ["DmP"],
  "starfish": ["Gx6","Duo","FTh"],
  "stargazer": ["Hg0"],
  "stargazing": ["Hg1"],
  "staring": ["DmP"],
  "staring out the window": ["DmP"],
  "stark": ["JaW"],
  "starling": ["Cfg","Cfe","Cff"],
  "starry night": ["GCh","Cfi"],
  "stars": ["Gx9","DNQ","FTj","Cfk","Cfj","Cfl","D55","Cfm"],
  "start": ["GyA","DmQ","FTk","Cfo","DmR","EZi"],
  "start a race": ["DmQ"],
  "start again": ["Hg2"],
  "start now": ["Hg3"],
  "start over": ["JaZ"],
  "start school": ["GCi","DmR","EZi"],
  "start started": ["GCj","DmQ","EWQ","DmR"],
  "start the engine": ["Hg4"],
  "start the game": ["Hg5"],
  "start up": ["Jaa"],
  "start work": ["Hg6"],
  "started": ["EWQ"],
  "started the race": ["EWQ"],
  "starter": ["Kc6"],
  "starting": ["DmQ","DmR"],
  "starting a race": ["DmQ"],
  "starting school": ["DmR"],
  "startle": ["JaX"],
  "startling": ["JaY"],
  "startup": ["Kc7"],
  "starvation": ["Kc8"],
  "starve": ["Jad"],
  "starve for": ["Jab"],
  "starve of": ["Jac"],
  "starving": ["GCk"],
  "stash": ["Jae"],
  "stat": ["KdF"],
  "state": ["Hg8"],
  "state of matter": ["Hg7"],
  "stately": ["Kc9"],
  "statement": ["KdA"],
  "states of matter": ["Hg9"],
  "statesman": ["Jaf"],
  "statewide": ["KdB"],
  "static": ["Jag"],
  "station": ["GyB","Cfs","FTl","Cfp","Cfq","Cft","Cfr"],
  "stationary": ["Jah"],
  "stationery": ["KdC"],
  "statistic": ["Jai"],
  "statistical": ["KdE"],
  "statistically": ["KdD"],
  "statue": ["GyC","Cfw","FTm","DNR","Cfy","Cfx","D56","Cfu","Cfv"],
  "Statue of Liberty": ["HhA"],
  "Statue of Zeus at Olympia": ["HhB"],
  "stature": ["Jaj"],
  "status": ["HhC"],
  "status quo": ["Jak"],
  "statute": ["Jal"],
  "statutory": ["KdG"],
  "staunch": ["Jam"],
  "stave off": ["Jan"],
  "stay": ["GCn","EZj"],
  "stay at home": ["GyD","Dup"],
  "stay behind": ["HhD"],
  "stay in": ["GCm","DmS"],
  "stay in bed": ["GCl","DmS","EZj"],
  "stay in touch": ["HhE"],
  "stay out": ["Jap"],
  "stay out of": ["Jao"],
  "stay put": ["Jaq"],
  "stay stayed": ["GCo","DmS"],
  "stay up": ["HhF"],
  "stay up late": ["E3o"],
  "staying in": ["DmS"],
  "staying in bed": ["DmS"],
  "steadily": ["KdH"],
  "steady": ["Jar"],
  "steady rain": ["HhG"],
  "steak": ["GyE","DNT","FTn","Cf4","Cf1","D57","Cfz","Cf3","Cf2","Cf0"],
  "steak and chips": ["DNS"],
  "steal": ["GyF","DmT","Ebf"],
  "steal a sweet": ["HhH"],
  "steal a wallet": ["DmT","Ebf"],
  "steal away": ["Jas"],
  "steal stole": ["ETO","DmT"],
  "stealing": ["GCp","DmT","Ebf"],
  "stealing a wallet": ["Ebf","DmT"],
  "steam": ["GyG","Duq"],
  "steam engine": ["GCq","Cf5","Cf6"],
  "steamer": ["KdI"],
  "steel": ["E3p"],
  "steep": ["GCr","Cf9","Cf7"],
  "steeply": ["KdJ"],
  "steer": ["Jat"],
  "stellar": ["Jau"],
  "stem": ["GyH","Dur","FTo"],
  "step": ["E3q"],
  "step aside": ["Jav"],
  "step back": ["Jaw"],
  "step down": ["Jax"],
  "step forward": ["Jay"],
  "step in": ["Jaz"],
  "step ladder": ["CgC"],
  "step out": ["Ja0"],
  "step up": ["Ja1"],
  "steps": ["GyI","CgG","CgE","CgH","CgF"],
  "stereo": ["GCs","DNU","D58"],
  "stereotype": ["HhI"],
  "sterile": ["Ja2"],
  "sterling": ["KdK"],
  "stern": ["Ja3"],
  "steroid": ["KdL"],
  "stethoscope": ["GCt","DNV","CgK","CgJ"],
  "stew": ["GyJ","CgL","CgM"],
  "steward": ["Ja4"],
  "stick": ["GyL","CgP","FTq","CgO","CgN","CgU"],
  "stick around": ["Ja5"],
  "stick insect": ["GCu","CgS","CgQ","CgR"],
  "stick out like a sore thumb": ["ENf","ENg","ENh"],
  "stick to": ["Ja6"],
  "stick up for": ["Ja7"],
  "stick with": ["Ja8"],
  "sticker": ["KdM"],
  "stickers": ["GyK","Dus","FTp"],
  "sticks": ["GCv","Dut"],
  "sticky": ["GCw","CgV"],
  "sticky rice": ["GCx","Duu"],
  "sticky tape": ["GCy","CgW"],
  "stiff": ["JbA"],
  "stiffen": ["Ja9"],
  "stiffly": ["KdN"],
  "stifle": ["KdO"],
  "stigma": ["JbB"],
  "still": ["JbC"],
  "still hungry": ["HhJ"],
  "still life": ["HhK"],
  "stillness": ["KdP"],
  "stilt house": ["GCz","CgX"],
  "stimulate": ["JbD"],
  "stimulation": ["KdQ"],
  "stimulus": ["JbE"],
  "sting": ["GC0","DmU","CgZ","Cga"],
  "sting stung": ["ESU","DmU"],
  "stinging": ["DmU"],
  "stingray": ["GyM","Duv"],
  "stingy": ["JbF"],
  "stink": ["KdR"],
  "stint": ["KdS"],
  "stipulate": ["JbG"],
  "stir": ["GyN","Cgc","DmV","Cgb"],
  "stir stirred": ["DmV"],
  "stir the soup": ["HhL"],
  "stiring": ["DmV"],
  "stitch": ["JbH"],
  "stitch up": ["JbI"],
  "stochastic": ["KdT"],
  "stock": ["HhM"],
  "stock up": ["JbK"],
  "stockholder": ["KdU"],
  "Stockholm": ["G96"],
  "stocking": ["GyO","Cgd","FTr","Cge","Cgf","Eh9","ENi"],
  "stockpile": ["JbJ"],
  "stole": ["ETO"],
  "stole a wallet": ["ETO"],
  "stomach": ["GyQ","Cgg","FTt"],
  "stomach ache": ["GyP","DNW","FTs","D6A"],
  "stomachache": ["GC1","E3r"],
  "stomp": ["GyR","Duw","FTu"],
  "stone": ["GyS","Cgh","FTv","Cgi"],
  "Stone Age": ["HhN"],
  "Stonehenge": ["HhO"],
  "stood": ["GC2","EUQ"],
  "stood up": ["EUQ"],
  "stool": ["GyT","DNX","D6B"],
  "stoop": ["KdV"],
  "stop": ["GyU","Cgj","FTw","DmX","DmW","EZk","Cgk"],
  "stop at the lights": ["DmW"],
  "stop at the red light": ["EZk"],
  "stop here": ["HhP"],
  "stop off": ["JbL"],
  "stop over": ["JbM"],
  "stop running": ["HhQ"],
  "stop sign": ["GC4","DNY"],
  "stop stopped": ["GC5","DmW","EUh","DmX"],
  "stop talking": ["HhR"],
  "stop the car": ["HhS"],
  "stoplight": ["GC3"],
  "stopped": ["EUh"],
  "stopping": ["DmW","DmX"],
  "stopping at the lights": ["DmW"],
  "storage": ["JbN"],
  "store": ["GyV","DNZ","FTx","Cgl"],
  "stork": ["GC6","Cgq","Cgo"],
  "storm": ["GyW","DNb","FTy","DYm","DNa","Cgs","Cgt","Cgr"],
  "storm warning": ["HhT"],
  "stormy": ["GyX","Cgw","FTz","Cgv","Cgu"],
  "story": ["GyY","Cgz","FT0"],
  "storybook": ["GC7","Cgx","Cgy"],
  "storyteller": ["GC8","Cg0"],
  "stout": ["JbO"],
  "stove": ["GyZ","DNc","Cg4","Cg1","Cg3","D6D","Cg2"],
  "straddle": ["KdW"],
  "straight": ["Gyb","Cg5","FT1","Cg8","Cg6"],
  "straight hair": ["Gya","Cg7"],
  "straighten": ["KdX"],
  "straighten out": ["JbP"],
  "straightforward": ["JbQ"],
  "strain": ["HhU"],
  "strand": ["JbS"],
  "stranded": ["JbR"],
  "strange": ["Gyc","Cg9","ChA","ChB"],
  "strangely": ["KdY"],
  "stranger": ["KdZ"],
  "strangle": ["Kda"],
  "strap": ["JbT"],
  "strategic": ["JbU"],
  "strategically": ["Kdb"],
  "strategist": ["Kdc"],
  "strategy": ["JbV"],
  "stratigraphy": ["JbW"],
  "stratum": ["JbX"],
  "straw": ["Gyf","DNf","FT4","ChC","ChD","D6F","ChG","ChV","ChF"],
  "straw hat": ["ChU"],
  "strawberries": ["Gyd","DNd","FT2","ChJ","ChH","D6E","ChL","ChI","ChK"],
  "strawberry": ["Gye","ChP","FT3","DNe","Eg9","ChN","ChM"],
  "strawberry juice": ["GC9","ChO"],
  "stray": ["JbY"],
  "streak": ["JbZ"],
  "stream": ["Gyg","ChZ","FT5","ChW","ChY","ChX"],
  "streamline": ["Kdd"],
  "street": ["Gyi","Che","FT6","Cha","Chc","Chb","Chd"],
  "street basketball": ["HhV"],
  "street light": ["Gyh","DNg","D6G"],
  "streetlight": ["GDA"],
  "strength": ["GDB","Chf"],
  "strengthen": ["Kde"],
  "strenuous": ["Jba"],
  "stress": ["HhW"],
  "stress out": ["Jbb"],
  "stressed": ["Gyj","Chg","FT7","Chh"],
  "stressful": ["Kdf"],
  "stressor": ["Kdg"],
  "stretch": ["Gyk","DmY","Chi","Chk","Cho"],
  "stretch stretched": ["DmY"],
  "stretcher": ["DNh"],
  "stretching": ["DmY"],
  "strew": ["Kdh"],
  "stricken": ["Jbc"],
  "strict": ["GDC","Chq","Chp"],
  "strictly": ["Kdi"],
  "stride": ["Jbd"],
  "strife": ["Jbe"],
  "strike": ["GDD","Chr","Chs"],
  "strike off": ["Jbf"],
  "strike up": ["Jbg"],
  "striker": ["Kdj"],
  "strikingly": ["Kdk"],
  "string": ["Gyl","Chv","FT8","Cht","Chu","Chw"],
  "stringent": ["Kdl"],
  "strip": ["Jbj"],
  "strip away": ["Jbh"],
  "stripe": ["Jbi"],
  "striped": ["Gym","Chy","Chx"],
  "stripes": ["Gyn","Ch0","FT9","Chz"],
  "stripy": ["Ch1"],
  "strive": ["Jbk"],
  "stroke": ["Jbl"],
  "stroll": ["Jbm"],
  "strong": ["Gyo","DNj","FUA","Ch2","EiA","ENm"],
  "strong as an ox": ["ENj","ENk","ENl"],
  "strong sunshine": ["HhX"],
  "stronger": ["GDE","DNi"],
  "stronghold": ["Kdm"],
  "strongly": ["Kdn"],
  "structural": ["Kdo"],
  "structure": ["HhY"],
  "struggle": ["Jbn"],
  "strut": ["Kdp"],
  "stubborn": ["Gyp","Dux"],
  "stud": ["Kdq"],
  "student": ["Gyq","Ch3","FUB","Ch7","Ch5","Ch6","Ch4"],
  "students": ["Gyr","Ch9","FUC","CiA","Ch8","CiB"],
  "studied": ["GDF","EV9","EVA"],
  "studied maths": ["EV9"],
  "studio": ["Gys","CiC"],
  "study": ["Gyu","Dmb","FUE","DYn","DNk","Dma","Ecq","DmZ","ENp","CiD","CiF","CiE"],
  "study at college": ["ENn"],
  "study at school": ["E3s"],
  "study English": ["GDG","E3t"],
  "study hard": ["ERU"],
  "study in the library": ["ENo"],
  "study languages": ["HhZ"],
  "study maths": ["Hha"],
  "study Spanish": ["ENq"],
  "study studied": ["GDH","Dmb","EV9","DmZ","Dma","EVA"],
  "studying": ["Gyt","Dmb","FUD","Dma","Ecq","DmZ"],
  "stuff": ["Jbo"],
  "stuffed animal": ["GDI"],
  "stumble": ["Jbp"],
  "stump": ["Kdr"],
  "stun": ["Jbr"],
  "stung": ["ESU"],
  "stung me": ["ESU"],
  "stunning": ["Jbq"],
  "stunt": ["Jbs"],
  "stuntman": ["GDJ","CiH","CiG"],
  "stupid": ["Jbt"],
  "stupidity": ["Kds"],
  "sturdy": ["Jbu"],
  "style": ["Hhb"],
  "stylish": ["Jbv"],
  "stylist": ["Kdt"],
  "stylistic": ["Jbw"],
  "stylized": ["Jbx"],
  "sub": ["GDL"],
  "subconscious": ["Jby"],
  "Subcontinental": ["Kdu"],
  "subculture": ["Jbz"],
  "subdivide": ["Jb0"],
  "subdivision": ["Kdv"],
  "subdue": ["Jb1"],
  "subgroup": ["Kdw"],
  "subject": ["GDK","E3u"],
  "subjective": ["Jb2"],
  "subjectivity": ["Kdx"],
  "subjects": ["Gyv","DYo","FUF"],
  "subjugate": ["Jb3"],
  "sublimation": ["Hhc"],
  "sublime": ["Kdy"],
  "subliminal": ["Jb4"],
  "submarine": ["Gyw","DYp","FUG","CiK","CiI","CiL"],
  "submerge": ["Jb5"],
  "submersible": ["DYq"],
  "submission": ["Jb6"],
  "submit": ["Jb7"],
  "subordinate": ["Jb8"],
  "suborn": ["Jb9"],
  "subpoena": ["Kdz"],
  "subprime": ["Kd0"],
  "Subsaharan Africa": ["Kd2"],
  "Subsaharan African": ["Kd1"],
  "subscribe": ["JcA"],
  "subscriber": ["Kd3"],
  "subscription": ["Kd4"],
  "subsection": ["Kd5"],
  "subsequent": ["JcB"],
  "subsequently": ["Kd6"],
  "subset": ["Kd7"],
  "subside": ["Kd8"],
  "subsidiary": ["JcC"],
  "subsidise": ["JcD"],
  "subsidize": ["Kd9"],
  "subsidy": ["JcE"],
  "subsist": ["JcG"],
  "subsistence": ["JcF"],
  "subspecies": ["JcH"],
  "substance": ["JcI"],
  "substantial": ["JcJ"],
  "substantially": ["KeA"],
  "substantiate": ["JcK"],
  "substantive": ["KeB"],
  "substitute": ["JcL"],
  "substitute teacher": ["G97"],
  "substitution": ["KeC"],
  "substrate": ["KeD"],
  "subsystem": ["KeE"],
  "subtitle": ["E3v"],
  "subtle": ["JcM"],
  "subtlety": ["KeF"],
  "subtly": ["KeG"],
  "subtract": ["GDM","CiN"],
  "subtype": ["KeH"],
  "subunit": ["KeI"],
  "suburb": ["JcN"],
  "suburban": ["GDN","CiO"],
  "subversive": ["JcO"],
  "subway": ["Gyx","CiR","FUH","CiS","CiQ","CiT"],
  "succeed": ["JcQ"],
  "succeed in": ["JcP"],
  "success": ["JcT"],
  "successful": ["Gyy","Duy"],
  "successfully": ["KeJ"],
  "succession": ["JcR"],
  "successive": ["JcS"],
  "successor": ["KeK"],
  "succumb": ["JcU"],
  "such": ["KeL"],
  "such as": ["JcV"],
  "suck": ["JcX"],
  "suck into": ["JcW"],
  "sucker": ["KeM"],
  "suction": ["JcY"],
  "Sudan": ["HEu","ENr"],
  "Sudanese": ["HEt","KrB","G98"],
  "sudden": ["JcZ"],
  "suddenly": ["GDO"],
  "sue": ["Jca"],
  "suffer": ["Jcc"],
  "suffer from": ["Jcb"],
  "sufferer": ["KeN"],
  "suffice": ["KeO"],
  "sufficient": ["Jcd"],
  "sufficiently": ["KeP"],
  "suffix": ["KeQ"],
  "suffragist": ["Jce"],
  "sugar": ["Gyz","CiW","FUI","DNl","CiV","CiU"],
  "sugar molecule": ["Hhd"],
  "sugary food": ["DYr"],
  "suggest": ["Jcf"],
  "suggestion": ["KeR"],
  "suggestions": ["GDP","DYs"],
  "suggestive": ["KeS"],
  "suicidal": ["KeT"],
  "suicide": ["Jcg"],
  "suit": ["Gy1","DNn","FUK","Cij","D6J","CiY","CiZ","CiX"],
  "suit and tie": ["Cie"],
  "suitability": ["KeU"],
  "suitable": ["KeV"],
  "suitably": ["KeW"],
  "suitcase": ["Gy0","DNm","FUJ","D6I","Cii","Cif","Cih"],
  "suite": ["Jch"],
  "sulfate": ["KeX"],
  "sulfur": ["Hhf"],
  "sulfuric acid": ["Hhe"],
  "sulk": ["Cik"],
  "sulphur": ["Hhg"],
  "sum": ["GDQ"],
  "sum up": ["Jcn"],
  "summarize": ["Jci"],
  "summary": ["Jcj"],
  "summat": ["KeY"],
  "summer": ["Gy2","Duz","FUL"],
  "Summer Olympics": ["Hhh"],
  "summit": ["Jck"],
  "summon": ["Jcl"],
  "sumo": ["Hhi"],
  "sumptuous": ["Jcm"],
  "sun": ["GzC","Cim","FUQ","Cil","CjE","D6t","DOn"],
  "sun cream": ["Gy4","Du1","FUM"],
  "sun hat": ["Gy9","Ci2","Ci4","Ci1","Ci3"],
  "Sun Tzu": ["KeZ"],
  "Sun Wukong": ["Hhl"],
  "sunbathe": ["Gy3","Dmc","Cip","Cin"],
  "sunbathe sunbathed": ["Dmc"],
  "sunbathing": ["GDR","Dmc"],
  "sunblock": ["E3w"],
  "sunburn": ["GDS","Du0"],
  "suncream": ["Gy5","Ciq"],
  "Sunday": ["Gy6","DNq","FUN","DNo","DNp"],
  "Sunday roast": ["Cir"],
  "sunflower": ["Gy7","Cis","FUO","Cit"],
  "sunflowers": ["GDT","Ciw","Ciu"],
  "sung": ["EWA"],
  "sung the song": ["EWA"],
  "sunglasses": ["Gy8","DNr","Ci0","Ciy","Ciz","D6K","Cix"],
  "sunlight": ["GzA","Ci5","Ci8","Ci6","Ci7"],
  "sunlit": ["Jco"],
  "sunnier": ["ESI","DNs"],
  "sunny": ["GzB","DNu","FUP","DYt","CjA","ENs","EiB","DNt","CjB","CjC","CjD","Ci9"],
  "sunrise": ["GzD","CjI","CjH","CjF","CjG"],
  "sunscreen": ["GzE","DNv","FUR","DYu","CjL","CjK"],
  "sunset": ["GzF","CjN","CjQ","CjP","CjM"],
  "sunshine": ["GzG","CjT","CjS","CjR"],
  "sunspot": ["Hhj"],
  "sunstroke": ["Hhk"],
  "sup": ["Kej"],
  "super": ["Jcv"],
  "super bowl": ["Hhm"],
  "superb": ["Jcp"],
  "superbasketball": ["GDU"],
  "superficial": ["Jcq"],
  "superhero": ["GzH","DNw","CjX","CjV","CjW"],
  "superimpose": ["Jcr"],
  "superintendent": ["Jcs"],
  "superior": ["Jct"],
  "superiority": ["Kea"],
  "superman": ["GDV","Du2"],
  "supermarket": ["GzI","DNx","FUS","CjZ","CjY","Cja"],
  "supernatural": ["Jcu"],
  "supernova": ["Cjb"],
  "superpower": ["Keb"],
  "supersede": ["Kec"],
  "supersonic": ["Jcw"],
  "superstar": ["Ked"],
  "superstition": ["Jcx"],
  "superstitious": ["Jcy"],
  "superstore": ["Kee"],
  "supervise": ["Jcz"],
  "supervision": ["Kef"],
  "supervisor": ["Hhn"],
  "supervisory": ["Keg"],
  "supper": ["E3x"],
  "supplant": ["Jc0"],
  "supplement": ["Jc1"],
  "supplemental": ["Keh"],
  "supplementary": ["Kei"],
  "supplier": ["Jc2"],
  "supplies": ["Jc3"],
  "supply": ["Hho"],
  "supply teacher": ["G99"],
  "support": ["GzJ","Dmd","EZn"],
  "support a team": ["Dmd"],
  "support liverpool": ["EZn"],
  "support supported": ["EVk","Dmd"],
  "supported": ["EVk"],
  "supported liverpool": ["EVk"],
  "supporter": ["Kek"],
  "supporting": ["Dmd"],
  "supporting a team": ["Dmd"],
  "supportive": ["Kel"],
  "suppose": ["Jc4"],
  "supposedly": ["Kem"],
  "suppress": ["Jc5"],
  "suppression": ["Ken"],
  "supremacy": ["Keo"],
  "supreme": ["Jc6"],
  "surcharge": ["Jc7"],
  "sure": ["Hhp"],
  "surely": ["Kep"],
  "surf": ["GzM","Cje","FUT","Cjd","Cjl"],
  "surf board": ["GDW","Cjf","Cjg"],
  "surf the Internet": ["GzN","Du4"],
  "surface": ["Jc8"],
  "surfboard": ["GzK","Du3"],
  "surfer": ["Keq"],
  "surfing": ["GzL","DNy","Cjj","Cjh","Cjk","D6L","Cji"],
  "surge": ["Jc9"],
  "surgeon": ["GzO","DN0","ENt","DNz","Cjo","Cjm","ENu","D6M","Cjn"],
  "surgery": ["GDX","Cjr","Cjp"],
  "surgical": ["Ker"],
  "Suriname": ["HEv"],
  "Surinamese": ["HEw"],
  "surmise": ["JdA"],
  "surname": ["Kes"],
  "surpass": ["JdB"],
  "surplus": ["JdC"],
  "surprise": ["GzQ","Du5"],
  "surprised": ["GzP","GDY","Cju","FUU","DN1","Cjs","ENv","Cjt"],
  "surprisingly": ["Ket"],
  "surrender": ["JdD"],
  "surrogate": ["Keu"],
  "surround": ["JdE"],
  "surveillance": ["Kev"],
  "survey": ["JdF"],
  "surveyor": ["Kew"],
  "survival": ["Kex"],
  "survive": ["E3y"],
  "survivor": ["Key"],
  "Susanoo": ["Hhq"],
  "susceptibility": ["Kez"],
  "susceptible": ["JdG"],
  "sushi": ["GzR","DN2","FUV","Cjx","Cjv","Cjw","D6N"],
  "suspect": ["JdH"],
  "suspend": ["JdI"],
  "suspense": ["JdJ"],
  "suspension": ["GDZ","DYv"],
  "suspicion": ["JdK"],
  "suspicious": ["GDa","Cjy"],
  "suspiciously": ["Ke0"],
  "sustain": ["JdM"],
  "sustainability": ["Ke1"],
  "sustainable": ["JdL"],
  "sustenance": ["JdN"],
  "swallow": ["JdO"],
  "swam": ["GDb","ETP"],
  "swamp": ["GzS","Cj0","Cj2","Cj3","Cj1","Cjz"],
  "swampy": ["JdP"],
  "swan": ["GzT","Cj6","FUW","DN3","Cj5","D6O","Cj4"],
  "swap": ["JdQ"],
  "swarm": ["JdR"],
  "sway": ["JdS"],
  "swear": ["JdU"],
  "swear in": ["JdT"],
  "sweat": ["GDc","CkD","Cj7","Cj8"],
  "sweat out": ["JdV"],
  "sweater": ["GzU","DN4","FUX","CkA","D6P","CkB","Cj9","CkC"],
  "sweatshirt": ["GzV","CkH","CkE","CkF","CkG"],
  "Swede": ["KrC"],
  "Sweden": ["GzW","CkL","CkI","ENw","CkJ"],
  "Swedes": ["KsB"],
  "Swedish": ["HEx"],
  "sweep": ["GzX","Dme","FUY","Dmf","CkN","CkO","Ebg","CkM","EZo"],
  "sweep back": ["JdW"],
  "sweep swept": ["Dme","ETQ","Dmf"],
  "sweep the floor": ["GzY","Dmf","FUZ","Ebg","EZo"],
  "sweep up": ["JdX"],
  "sweeping": ["GDd","Ebg","Dme","Dmf"],
  "sweeping the floor": ["GDe","Dmf","Ebg"],
  "sweet": ["GzZ","Du6"],
  "sweet dreams": ["Hhr"],
  "sweet potato": ["Gza","CkW","CkZ","CkV","CkX"],
  "sweet potatoes": ["GDg","CkY"],
  "sweet shop": ["Gzb","Ckd","Cke"],
  "sweetcorn": ["GDf","DN5","CkR","CkQ"],
  "sweetheart": ["CkT"],
  "sweetness": ["Ke2"],
  "sweets": ["Gzc","Ckf","Ckc","Ckb","Cka"],
  "swell": ["JdY"],
  "swept": ["ETQ"],
  "swept the floor": ["ETQ"],
  "swift": ["JdZ"],
  "swiftly": ["Ke3"],
  "swim": ["Gzh","Dmh","Ckg","Ebh","Dmg","Ckr","EZp"],
  "swim in the pool": ["Hhs"],
  "swim in the sea": ["GDh","Du7"],
  "swim in the water": ["EZp"],
  "swim swam": ["GDl","Dmh","ETP","Dmg"],
  "swimmer": ["GDi","Cki","Ckh"],
  "swimming": ["Gze","Dmh","FUa","Ckl","DN7","Ckj","Ckk","Ebh","Dmg","D6Q"],
  "swimming cap": ["Gzd","DN6"],
  "swimming costume": ["GDj","E3z"],
  "swimming pool": ["Gzf","Cko","FUb","Ckn","Ckm","Ckp"],
  "swimming practice": ["GDk"],
  "swimming trunks": ["Gzg","DN8","FUc","Ckq","D6R"],
  "swimsuit": ["Gzi","Cks","FUd","DN9","D6S"],
  "swindle": ["Jda"],
  "swing": ["Gzj","Dmi","FUe","DOA","D6T","Ckw","Ckx","Cku","Ckt","Ckv"],
  "swing by": ["Jdb"],
  "swing swung": ["Dmi"],
  "swinging": ["GDm","Dmi"],
  "swings": ["GDn","Cky"],
  "swirl": ["Jdc"],
  "Swiss": ["HEy","KsC","KrD","GDo"],
  "switch": ["Gzk","DOB","D6U"],
  "switch off": ["Hht"],
  "switch on": ["Hhu"],
  "switchboard": ["Ke4"],
  "Switzerland": ["Gzl","Ck2","Ckz","ENx"],
  "swivel": ["Ke5"],
  "swivel chair": ["D6V","DOC"],
  "swoon": ["Jdd"],
  "swoop": ["Jde"],
  "sword": ["Gzm","DOD","FUf","D6W"],
  "swordfish": ["GDp","Ck3","Ck4","Ck5"],
  "Sydney": ["HAA"],
  "Sydney Opera House": ["Hhv"],
  "syllable": ["Jdf"],
  "syllabus": ["Jdg"],
  "symbol": ["Hhw"],
  "symbolic": ["Ke6"],
  "symbolism": ["Ke7"],
  "symbolize": ["Ke8"],
  "symmetric": ["KfA"],
  "symmetrical": ["Ke9"],
  "symmetry": ["Jdh"],
  "sympathetic": ["Jdi"],
  "sympathize": ["KfB"],
  "sympathy": ["Jdj"],
  "symphony": ["Jdk"],
  "symposium": ["KfC"],
  "symptom": ["Jdl"],
  "symptomatic": ["KfD"],
  "synagogue": ["KfE"],
  "synaptic": ["KfF"],
  "synchronize": ["Jdm"],
  "synchronizer": ["Jdn"],
  "syndicate": ["KfG"],
  "syndrome": ["Jdo"],
  "synonym": ["Jdp"],
  "synonymous": ["KfH"],
  "syntactic": ["Jdq"],
  "syntax": ["KfI"],
  "synthesis": ["Jdr"],
  "synthesize": ["Jds"],
  "synthetic": ["Jdt"],
  "syphon off": ["Jdu"],
  "syringe": ["GDq","DOE","D6X"],
  "syrup": ["GDr","Ck7","Ck6"],
  "system": ["E30"],
  "systematic": ["Jdv"],
  "systematically": ["KfJ"],
  "systematize": ["Jdw"],
  "systemic": ["KfK"],
  "t": ["G17","GF0","DaN","FVz","DaO","HE5","HEz"],
  "T rex": ["GGG","GGF","Cst","Csu"],
  "t shirt": ["G2g","Ctj","Cth","Ctn"],
  "T shirt": ["E4c","FWN","Ctl"],
  "tab": ["KfM"],
  "table": ["Gzo","DOF","FUg","D6Y","ClC","ClA","Ck9","Ck8","ClB","ClG"],
  "Table Mountain": ["Hhx"],
  "table salt": ["Hhy"],
  "table tennis": ["Gzp","DOG","FUh","ClO","D6Z","ClL","ClM","ClK","ClN"],
  "tablecloth": ["Gzn","ClF","ClE","ClD"],
  "tableland": ["Jdx"],
  "tablespoon": ["GDs","ClH"],
  "tablet": ["Gzq","DOH","FUi","ClJ","D6a","ClI","ClP"],
  "tabloid": ["KfL"],
  "tabloid press": ["Jdy"],
  "taboo": ["Jdz"],
  "tacit": ["KfN"],
  "tack": ["KfO"],
  "tackle": ["Jd0"],
  "taco": ["GDt","DOI","D6b"],
  "tacos": ["GDu","ClT","ClQ","ClR","ClS"],
  "tact": ["Jd4"],
  "tactful": ["Jd1"],
  "tactic": ["Jd2"],
  "tactical": ["KfP"],
  "tactile": ["Jd3"],
  "tadpole": ["Gzr","ClW","ClU","ClV"],
  "taekwondo": ["Gzs","ClY","ClX"],
  "tag": ["GDv","E31"],
  "tag along": ["Jd5"],
  "tag out": ["Jd6"],
  "Tahiti": ["HE0"],
  "tail": ["Gzu","DOL","FUj","D6c","ClZ","Cla"],
  "tail off": ["Jd7"],
  "tailor": ["Gzt","DOJ","DOK","ENy"],
  "taint": ["KfQ"],
  "Taipei": ["HAB"],
  "Taiwan": ["Gzv","Cld","Clb","EN0"],
  "Taiwan flag": ["GDw","DOM"],
  "Taiwanese": ["HE1","KrE"],
  "Taj Mahal": ["Clg","Clf"],
  "take": ["Gz8","Dm0","FUq","Dmv","Dm1","Dm2","EZr","Dmu","EZx","Ecs","Edj","EZw","EZv","EZu","EZt","EZs","EZq"],
  "take a bath": ["Gzw","Dmj","FUk","EZq","EN1"],
  "take a break": ["Hhz"],
  "take a bus": ["GDx"],
  "take a cookie": ["GDy","Dmk","EZr"],
  "take a look at": ["JeA"],
  "take a nap": ["Gzx","Clh","FUl"],
  "take a photo": ["Gzy","Dmm","FUm","Cli","Dml","Edj","EZt","Dmn","Dmo","Clk","Clj"],
  "take a picture": ["Gzz","Du8","EZu"],
  "take a shower": ["Gz0","Dmr","FUn","Dmp","Dmq","EZv","Ecs","EN2"],
  "take a test": ["GDz","Dms"],
  "take advantage of": ["Jd8"],
  "take after": ["Jd9"],
  "take an exam": ["EZs"],
  "take apart": ["JeB"],
  "take away": ["GD0","Du9"],
  "take back": ["Hh0"],
  "take by surprise": ["JeC"],
  "take care": ["GD2","Dmt","EN4"],
  "take care of": ["Gz1","DvA"],
  "take care of a garden": ["EN3"],
  "take care of cast out": ["JeD"],
  "take care of yourself": ["Hh1"],
  "take care took care": ["Dmt"],
  "take down": ["JeE"],
  "take for": ["JeG"],
  "take for granted": ["JeF"],
  "take into account": ["JeH"],
  "take it easy": ["Hh2"],
  "take lessons": ["JeI"],
  "take medicine": ["Gz2","Dmu","EZw"],
  "take money": ["EZx","Dmv"],
  "take notes": ["Hh3"],
  "take off": ["Gz3","Dmw","FUo","Dmx","Ebi","EN6","EN7"],
  "take off a coat": ["EN7","Ebi"],
  "take off took off": ["Dmw"],
  "take off your shoes": ["Hh4"],
  "take on": ["Hh5"],
  "take one's time": ["JeJ"],
  "take out": ["Gz4","Dmz","Dmy","Ebj","EN8"],
  "take out on": ["JeK"],
  "take out the rubbish": ["GD4","E32"],
  "take out the trash": ["Gz5","Dmz","FUp","Ebj","EN8"],
  "take out took out": ["Dmy","Dmz"],
  "take over": ["Hh6"],
  "take part": ["Hh7"],
  "take part in": ["GD5"],
  "take photos": ["Gz6","EOA"],
  "take pictures": ["Gz7","DvB"],
  "take place": ["JeL"],
  "take pride in": ["JeM"],
  "take some pizza": ["Dm0","Dm1"],
  "take stock": ["JeN"],
  "take taken": ["EWB","EWC"],
  "take the bus": ["GD6","Dm2","EOB"],
  "take through": ["JeO"],
  "take time off": ["JeP"],
  "take to": ["JeQ"],
  "take took": ["Gz9","EVH","Dml","Dmo","Dm0","Dmk","Dmv","Dmj","Dmp","Dmu"],
  "take turns": ["JeR"],
  "take up": ["Hh8"],
  "take vitamins": ["E33"],
  "take your time": ["Hh9"],
  "takeaway": ["GD1"],
  "taken": ["GD3","EWC","EWB"],
  "taken a bath": ["EWB"],
  "taken a shower": ["EWC"],
  "takeover": ["KfR"],
  "takes": ["Ect"],
  "takes some pizza": ["Ect"],
  "taking": ["GD9","Dmu","Dm0","Dm2","Ecs","Edj","Dmv","Dm1"],
  "taking a bath": ["GD7","Dmj"],
  "taking a cookie": ["Dmk"],
  "taking a photo": ["G0A","Dml","Dmm","Dmo","Dmn"],
  "taking a shower": ["GD8","Dmp","Ecs","Dmq","Dmr"],
  "taking a test": ["Dms"],
  "taking care": ["Dmt"],
  "taking medicine": ["Dmu"],
  "taking money": ["Dmv"],
  "taking off": ["Dmw","Dmx","Ebi"],
  "taking out": ["Ebj","Dmy","Dmz"],
  "taking out the trash": ["Dmz","Ebj"],
  "taking photos": ["G0B","DvC"],
  "taking some pizza": ["Ect","Dm0","Dm1"],
  "taking the bus": ["Dm2"],
  "tale": ["JeT"],
  "talent": ["JeS"],
  "talent show": ["G0D","DvE"],
  "talented": ["G0C","DvD"],
  "talk": ["G0G","Dm7","FUs","Edl","EZz","Dm4","Dm3","Dm6","Cll","EZy","Dm5"],
  "talk back": ["JeU"],
  "talk down": ["JeV"],
  "talk down to": ["JeW"],
  "talk into": ["JeX"],
  "talk on a headset": ["EZy"],
  "talk on the phone": ["G0F","Dm6","Dm5","Edk"],
  "talk over": ["JeY"],
  "talk talked": ["GEE","Dm4","EVB","Dm3","Dm5","Dm7"],
  "talk to": ["Dm8"],
  "talk to a friend": ["GEF","EZz","Dm8"],
  "talk to friends": ["GEG"],
  "talk together": ["EOF"],
  "talkative": ["GEA","E34"],
  "talked": ["GEB","EVB"],
  "talked to each other": ["EVB"],
  "talker": ["KfS"],
  "talking": ["G0E","Dm7","FUr","Edl","Dm6","Dm3","Dm4","Dm5"],
  "talking on the phone": ["GEC","Dm5","Dm6","Edk"],
  "talking to": ["Dm8"],
  "talking to a brick wall": ["EOC","EOD","EOE"],
  "talking to a friend": ["GED","Dm8"],
  "tall": ["G0I","DOO","FUt","EiD","EOG","EiC"],
  "tall buildings": ["GEH","EiC"],
  "taller": ["G0H","DON"],
  "tally": ["JeZ"],
  "tambourine": ["G0J","DOP","D6d","Clm","Cln"],
  "tame": ["Jea"],
  "tamoxifen": ["KfT"],
  "tamp down": ["Jeb"],
  "tamper": ["KfU"],
  "tamper with": ["Jec"],
  "tan": ["KfX"],
  "tandem": ["KfV"],
  "tangent": ["Jed"],
  "tangerine": ["G0K","Clq","Clo","DOQ","Clp","D6e"],
  "tangerines": ["DOR","Clt"],
  "tangible": ["Jee"],
  "tangle": ["Clv"],
  "tangled": ["Clu"],
  "tank": ["GEI","Clz","Clx","Cly"],
  "tanker": ["KfW"],
  "tanktop": ["GEJ","Cl0"],
  "tantalizing": ["Jef"],
  "tanuki": ["HiA"],
  "Tanzania": ["HE3","Cl3"],
  "Tanzanian": ["HE2","KrF","HAC"],
  "Taoism": ["HiB"],
  "Taoist": ["HiC"],
  "tap": ["G0M","Cl5","FUv","Cl4","CmD","Cl6"],
  "tap into": ["Jeh"],
  "tape": ["G0L","DOT","FUu","CmC","Cl9","D6g","Cl8","Cl7"],
  "tape measure": ["GEK","CmA","DOS","D6f"],
  "taper": ["KfY"],
  "taper off": ["Jeg"],
  "tapestry": ["KfZ"],
  "tar": ["Kfa"],
  "tarantula": ["GEL","CmH","CmI","CmE","CmF","CmG"],
  "target": ["Jei"],
  "tariff": ["Jej"],
  "tarnish": ["Jek"],
  "tart": ["Kfb"],
  "task": ["Jel"],
  "taste": ["G0N","DnA","Dm9","EZ1","EZ0"],
  "taste bad": ["GEM","EZ0","Dm9"],
  "taste good": ["GEN","DnA","EZ1"],
  "taste tasted": ["Dm9","DnA"],
  "tasting": ["DnA","Dm9"],
  "tasting bad": ["Dm9"],
  "tasting good": ["DnA"],
  "tasty": ["GEO","E35"],
  "tattoo": ["Jem"],
  "taught": ["EUR"],
  "taught English": ["EUR"],
  "taunt": ["Kfc"],
  "Taurus": ["HiD"],
  "taut": ["Jen"],
  "tavern": ["Jeo"],
  "tax": ["HiF"],
  "taxable": ["Kfd"],
  "taxation": ["Kfe"],
  "taxes": ["HiE"],
  "taxi": ["G0P","CmJ","FUw","CmK","CmM","CmL"],
  "taxi driver": ["G0O","E36"],
  "taxi rank": ["CmN"],
  "taxpayer": ["Kff"],
  "tea": ["G0U","DOX","FU0","Cmc","CmQ","D6i","CmP","CmO"],
  "tea set": ["GER","Cmj","Cmk","Cmi"],
  "tea towel": ["GES","DOZ"],
  "teach": ["G0S","DnC","FUy","DnB","EZ2"],
  "teach a lesson": ["HiG"],
  "teach a student": ["EOI"],
  "teach class": ["EZ2"],
  "teach English": ["DnB"],
  "teach students": ["EOM"],
  "teach taught": ["GEQ","DnB","DnC","EUR"],
  "teacher": ["G0Q","DOV","FUx","CmV","EOL","DOU","CmS","EOK","CmT","CmR","D6h","CmU"],
  "teachers": ["G0R","DvF"],
  "teaching": ["GEP","DnC","DnB"],
  "teaching English": ["DnB"],
  "teacup": ["CmW"],
  "teacups": ["CmX"],
  "teal": ["DOW"],
  "team": ["G0T","Cmb","FUz","CmY","Cma","CmZ"],
  "team up": ["Jep"],
  "teammate": ["Kfg"],
  "teamwork": ["Kfh"],
  "teapot": ["G0V","Cmd","DOY","Cmg","D6j","Cme","Cmf"],
  "tear": ["G0W","DnD","Cmh"],
  "tear apart": ["Jeq"],
  "tear down": ["Jer"],
  "tear tore": ["EVI","DnD"],
  "tear up": ["DnE"],
  "tear up tore up": ["DnE"],
  "tearing": ["DnD"],
  "tearing up": ["DnE"],
  "tease": ["Jes"],
  "teaspoon": ["G0X","Cmm","Cml"],
  "tech": ["Kfj"],
  "technical": ["Jet"],
  "technically": ["Kfi"],
  "technician": ["G0Y","Cmo","FU1","Cmn"],
  "technique": ["Jeu"],
  "technological": ["Jev"],
  "technology": ["G0Z","GET","DvG","FU2"],
  "tectonic": ["Jew"],
  "tectonics": ["Jex"],
  "teddy": ["G0b","Cmy","FU4","Cmp","Cmr","Cmq","Cms"],
  "teddy bear": ["G0a","GEU","Cmu","FU3","Cmw","Cmt","Cmv","Cmx"],
  "tedious": ["Jey"],
  "tedium": ["Jez"],
  "tee": ["Kfm"],
  "teem": ["Je0"],
  "teen": ["Kfl"],
  "teenage": ["Kfk"],
  "teenager": ["Je1"],
  "teenagers": ["G0c","Cm0","Cmz"],
  "teepee": ["Cm3","Cm2"],
  "teeth": ["G0d","DOa","FU5","D6l","Cm5","Cm6","Cm7"],
  "telecom": ["Kfn"],
  "telecommunication": ["Je2"],
  "telegram": ["Kfo"],
  "telegraph": ["Je3"],
  "telemarketing": ["Je4"],
  "telephone": ["G0e","DvH","FU6"],
  "telescope": ["G0f","DOb","FU7","CnA","Cm9","Cm8","D6m"],
  "televise": ["Kfp"],
  "television": ["G0g","CnF","FU8","CnD","DOc","CnE","CnB","CnC"],
  "tell": ["G0h","DnH","Ebk","DnF","DnG"],
  "tell a from b": ["Je5"],
  "tell a joke": ["HiH"],
  "tell a secret": ["DnF","Ebk"],
  "tell a story": ["HiI"],
  "tell apart": ["Je6"],
  "tell me": ["HiJ"],
  "tell me why": ["HiK"],
  "tell of": ["Je8"],
  "tell off": ["Ecv","EOO"],
  "tell off a boy": ["DnG"],
  "tell off someone": ["Ecv"],
  "tell on": ["Je9"],
  "tell the time": ["HiL"],
  "tell the truth": ["HiM"],
  "tell told": ["GEV","ETS","DnF","DnH","DnG"],
  "teller": ["Je7"],
  "telling": ["Ebk","DnH","DnF","DnG"],
  "telling a secret": ["Ebk","DnF"],
  "telling off": ["Ecv"],
  "telling off a boy": ["DnG"],
  "telly": ["Kfq"],
  "temper": ["JfA"],
  "temperament": ["Kfr"],
  "temperate": ["E37"],
  "temperature": ["GEW","E38"],
  "template": ["JfB"],
  "temple": ["G0i","CnH","FU9","CnG"],
  "Temple of Artemis": ["HiO"],
  "Temple of Artemis at Ephesus": ["HiN"],
  "tempo": ["HiP"],
  "temporal": ["Kfs"],
  "temporarily": ["Kft"],
  "temporary": ["JfC"],
  "tempt": ["JfD"],
  "temptation": ["Kfu"],
  "ten": ["G0l","GEa","DcV","FVB","DcU"],
  "ten apples": ["HiQ"],
  "ten chairs": ["HiR"],
  "ten o'clock": ["GEZ","DeW"],
  "ten past eight": ["DeX","Efe"],
  "ten thousand": ["GEb","DcW"],
  "ten to five": ["GEd","DeY","Eff"],
  "tenacious": ["JfE"],
  "tenancy": ["Kfv"],
  "tenant": ["HAD"],
  "tend": ["JfG"],
  "tend to": ["JfH"],
  "tendency": ["Kfw"],
  "tender": ["E39"],
  "tenderness": ["Kfx"],
  "tendon": ["JfF"],
  "tenement": ["JfI"],
  "tenet": ["JfJ"],
  "tengu": ["HiS"],
  "tennis": ["G0j","DOd","FVA","CnJ","CnI","D6n","CnP","CnL","CnK"],
  "tennis ball": ["GEX","CnM"],
  "tennis court": ["GEY","CnN","CnO"],
  "tennis racket": ["G0k","CnQ","CnR"],
  "tenor": ["Kfy"],
  "tense": ["JfK"],
  "tension": ["HiT"],
  "tent": ["G0m","CnS","FVC","DOe","CnT","CnX","CnW","CnV","D6o","CnU"],
  "tentacle": ["JfL"],
  "tentative": ["JfM"],
  "tentatively": ["Kfz"],
  "tenth": ["HA5","GEc","E4A"],
  "tenuous": ["JfN"],
  "tenure": ["Kf0"],
  "term": ["JfS"],
  "terminal": ["HiU"],
  "terminate": ["JfO"],
  "termination": ["Kf1"],
  "terminology": ["JfP"],
  "terminus": ["JfQ"],
  "termite": ["JfR"],
  "terrace": ["E4B"],
  "Terracotta Army": ["HiV"],
  "terrain": ["JfT"],
  "terrestrial": ["JfU"],
  "terrible": ["G0n","DvI","FVD"],
  "terribly": ["Kf2"],
  "terrific": ["JfV"],
  "terrified": ["JfW"],
  "terrify": ["Kf3"],
  "terrifying": ["JfX"],
  "territorial": ["Kf4"],
  "territory": ["JfY"],
  "terror": ["Jfa"],
  "terrorism": ["JfZ"],
  "terrorist": ["Kf5"],
  "test": ["GEe","E4C"],
  "test tube": ["HiX"],
  "testament": ["Jfb"],
  "tester": ["Kf6"],
  "testify": ["Jfc"],
  "testimony": ["Jfd"],
  "testing": ["HiW"],
  "Texan": ["KrG"],
  "Texas": ["Kf7","EOP"],
  "text": ["GEf","CnY"],
  "text message": ["G0p","DvK"],
  "textbook": ["G0o","DvJ","FVE"],
  "textile": ["HiY"],
  "textual": ["Kf8"],
  "texture": ["HiZ"],
  "Thai": ["HE4","KrH","GEh","DOh","EeV"],
  "Thailand": ["G0q","Cnd","FVF","DOg","EOQ","CnZ","Cnc","D6p","Cnb","Cna"],
  "Thailand flag": ["GEg","DOf"],
  "than": ["KgA"],
  "thank": ["Jfe"],
  "thank you": ["Hid"],
  "thank you for": ["Hic"],
  "thank you for helping": ["Hib"],
  "thank you so much": ["Hie"],
  "thank you very much": ["Hif"],
  "thankful": ["E4D"],
  "thankfully": ["Kf9"],
  "thanks": ["Hia"],
  "thanks for": ["Jff"],
  "thanks to": ["Jfg"],
  "thanksgiving": ["G0r","DvL"],
  "Thanksgiving dinner": ["GEi","Cne"],
  "that": ["HAE","GEj","E4E"],
  "that's all right": ["Hig"],
  "that's great": ["Hih"],
  "that's okay": ["Hii"],
  "that's terrible": ["Hij"],
  "that's too bad": ["Hik"],
  "that's why": ["Him"],
  "that's why not": ["Hil"],
  "that's wonderful": ["Hin"],
  "thatch": ["KgB"],
  "thaw": ["Jfh"],
  "the": ["Kgi"],
  "the Africans": ["Krb"],
  "the air": ["IKc"],
  "the alphabet": ["IKd"],
  "The Alps": ["KgC"],
  "The American Southwest": ["KgD"],
  "the Americans": ["Krd","Krc"],
  "The Andes": ["KgE"],
  "the answer": ["IKe"],
  "The Arabian Peninsula": ["KgF"],
  "the Arabs": ["Kre"],
  "the Asians": ["Krg","Krf"],
  "the atmosphere": ["IKf"],
  "the Australians": ["Krh"],
  "the Aztecs": ["Kri"],
  "The Balkans": ["KgH"],
  "The Baltics": ["KgI"],
  "the Basques": ["Krj"],
  "the bathroom is messy": ["Ehp"],
  "the beach": ["GEk","DvN","C5x","AT2","ATm","ATn","ATo","ATp","ATq"],
  "the bikes are fast": ["Ehd"],
  "the birds are flying over the mountain": ["Ec9"],
  "the black sheep of the family": ["EOR","EOS","EOT"],
  "the book is old": ["Ehr"],
  "the book is worn out": ["Ehr"],
  "the boots smell bad": ["Eh7"],
  "the British": ["Krk"],
  "The British Isles": ["KgJ"],
  "the buildings are high": ["EiC"],
  "the buildings are tall": ["EiC"],
  "the calm before the storm": ["Jfi"],
  "the Canadians": ["Krl"],
  "the car is waiting at the lights": ["EdA"],
  "The Caribbean": ["KgK"],
  "the cat chases a mouse": ["EdB"],
  "the cat is chasing a mouse": ["EdB"],
  "The Caucasus": ["KgL"],
  "the Celts": ["Krn","Krm"],
  "the chair is big": ["EhF"],
  "the chair is on fire": ["Ehu"],
  "the chairs are on fire": ["Ehv"],
  "the clocks are upside down": ["EiI"],
  "the clothes are drying": ["EdC"],
  "the coast": ["IKg"],
  "the countryside": ["IKh"],
  "the day after tomorrow": ["HAF"],
  "the day before yesterday": ["HAG"],
  "the dishes are dirty": ["EhZ"],
  "the dog is biting his hand": ["EdD"],
  "the dog is wet": ["EiJ"],
  "the door is open": ["Ehx"],
  "the doors are open": ["Ehw"],
  "the early bird catches the worm": ["EOU","EOV","EOW"],
  "the earth": ["GEl","DOi","D6q","BFW","BFV"],
  "the English": ["Kro"],
  "the environment": ["IKi"],
  "the equator": ["IKj"],
  "the Europeans": ["Krq","Krp"],
  "the fan blows air": ["EdE"],
  "the fan is blowing air": ["EdE"],
  "the Franks": ["Krr"],
  "the French": ["Krs"],
  "the future": ["IKk"],
  "the Germans": ["Krt"],
  "the girl is learning maths": ["EdF"],
  "the girl learns maths": ["EdF"],
  "the Goths": ["Kru"],
  "the government": ["IKl"],
  "the grass is always greener on the other side": ["EOX","EOY","EOZ"],
  "The Great Lakes": ["KgM"],
  "The Great Plains": ["KgN"],
  "the Greeks": ["Krv"],
  "the ground": ["IKm"],
  "The Gulf of Mexico": ["KgO"],
  "The Himalayas": ["KgP"],
  "the horizon": ["IKn"],
  "The Horn of Africa": ["KgQ"],
  "the Incas": ["Krw"],
  "The Indian Subcontinent": ["KgR"],
  "the Internet": ["IKo"],
  "the Irish": ["Krx"],
  "the Italians": ["Kry"],
  "the Japanese": ["Krz"],
  "The Korean Peninsula": ["KgS"],
  "the Kurds": ["Kr0"],
  "the latest trend": ["Jfk"],
  "The Levant": ["KgT"],
  "the library is quiet": ["Ehy"],
  "the lights are bright": ["EhI"],
  "The Maghreb": ["KgU"],
  "The Mediterranean": ["KgW"],
  "The Middle East": ["KgX"],
  "the moon": ["GEm","DOj","D6r","By9","By1","By2","By3","By4"],
  "the news": ["GEn","E4G"],
  "the Normans": ["Kr1"],
  "the North Pole": ["IKp"],
  "the ocean": ["IKq"],
  "the office": ["E4H"],
  "The Outback": ["Kgf"],
  "The Pacific Northwest": ["Kgg"],
  "the past": ["IKr"],
  "the pencils are broken": ["EhJ"],
  "The Persian Gulf": ["Kgh"],
  "the Persians": ["Kr2"],
  "the phone charges": ["EdG"],
  "the phone is charging": ["EdG"],
  "the phone is ringing": ["EdH"],
  "the phone rings": ["EdH"],
  "the plant is dead": ["EhV"],
  "the plants are dead": ["EhW"],
  "the Poles": ["Kr3"],
  "the police": ["IKs"],
  "the Portuguese": ["Kr4"],
  "the ring is expensive": ["Ehc"],
  "the Romans": ["Kr6","Kr5"],
  "the room is messy": ["Ehp"],
  "the Russians": ["Kr7"],
  "The Sahara": ["Kgm"],
  "The Sahel": ["Kgn"],
  "the same": ["E4J"],
  "the Saxons": ["Kr8"],
  "the Scots": ["Kr9"],
  "the screen is cracked": ["EhT"],
  "the sea": ["G0w","DvP","CTu","CUJ","CTv","CTw"],
  "the sky": ["GEp","DvQ","CY1","CYy","CYz","CY0"],
  "the Spanish": ["KsA"],
  "the stars": ["IKt"],
  "the store hasn't opened yet": ["EOc"],
  "the sun": ["GEq","DOn","D6t","CjE","Cil","Cim"],
  "the sun is rising": ["EdI"],
  "the sun rises": ["EdI"],
  "the Swedes": ["KsB"],
  "the Swiss": ["KsC"],
  "the tires are flat": ["Ehf"],
  "the train hasn't arrived yet": ["EOd"],
  "the Turks": ["KsD"],
  "the tyres are flat": ["Ehf"],
  "the UK": ["G0x","GEr","DvR","FVI"],
  "the Ukrainians": ["KsE"],
  "the universe": ["IKu"],
  "the Vietnamese": ["KsF"],
  "the Vikings": ["KsG"],
  "the water boils": ["EdJ"],
  "the water is boiling": ["EdJ"],
  "the weather": ["IKv"],
  "the Welsh": ["KsH"],
  "the world": ["IKw"],
  "theater": ["G0s","DvM","FVG","Cni","Cnf","Cng","Cnh"],
  "theatre": ["G0t","Cni","FVH","DvM","Cng","Cnh","Cnf"],
  "theatrical": ["KgG"],
  "theft": ["Jfj"],
  "their": ["E4F"],
  "their hair is blue": ["EhG"],
  "their hair is long": ["Eho"],
  "their shirts are colorful": ["EhS"],
  "their sweaters are small": ["Eh5"],
  "theirs": ["HAH"],
  "them": ["HAI"],
  "thematic": ["KgV"],
  "theme": ["Jfl"],
  "theme park": ["G0u","DvO"],
  "themselves": ["KgY"],
  "then": ["KgZ"],
  "theologian": ["Kga"],
  "theological": ["Kgb"],
  "theology": ["Kgc"],
  "theorem": ["Kgd"],
  "theoretical": ["Jfm"],
  "theoretically": ["Kge"],
  "theorist": ["Jfn"],
  "theorize": ["Jfo"],
  "theory": ["Jfp"],
  "therapeutic": ["Jfq"],
  "therapist": ["GEo","DOk","EOb","EOa"],
  "therapy": ["Hio"],
  "there": ["HAK","E4I"],
  "there are five apples": ["Hip"],
  "there are five chairs": ["Hiq"],
  "there are four chairs": ["Hir"],
  "there are many books": ["His"],
  "there are no eggs": ["Hit"],
  "there are some apples": ["Hiu"],
  "there are some flowers": ["Hiv"],
  "there are ten children": ["Hiw"],
  "there are three books": ["Hix"],
  "there are two cats": ["Hiy"],
  "there aren't enough hours in the day": ["Jfr"],
  "there is a bird": ["Hiz"],
  "there is a book": ["Hi0"],
  "there is a cat": ["Hi1"],
  "there is a dog": ["Hi2"],
  "there is a problem": ["Hi4"],
  "there is an apple": ["Hi3"],
  "there is one chair": ["Hi5"],
  "there is time": ["Hi6"],
  "thereafter": ["Kgj"],
  "thereby": ["Jfs"],
  "therefore": ["HAJ"],
  "therein": ["Kgk"],
  "thereof": ["Kgl"],
  "thermal": ["Hi7"],
  "thermometer": ["G0v","DOm","Cnn","Cnm","D6s","Cnj","Cnl"],
  "these": ["HAL","E4K"],
  "thesis": ["Jft"],
  "they": ["HAM","GEy"],
  "they are arguing": ["EdK"],
  "they are birds": ["GEw"],
  "they are climbing a mountain": ["EdL"],
  "they are cold": ["EhP"],
  "they are dancing": ["EdM"],
  "they are debating": ["EdN"],
  "they are drinking coffee": ["EdO"],
  "they are eating cake": ["EdP"],
  "they are exchanging money": ["EdQ"],
  "they are exercising": ["EdR"],
  "they are fighting": ["EdS"],
  "they are going to school": ["EdT"],
  "they are guarding the door": ["EdU"],
  "they are happy": ["Ehj"],
  "they are here": ["Hi8"],
  "they are holding hands": ["EdV"],
  "they are hugging": ["EdW"],
  "they are hungry": ["Hi9"],
  "they are jumping": ["EdX"],
  "they are listening to music": ["EdY"],
  "they are looking at each other": ["EdZ"],
  "they are meeting each other": ["Eda"],
  "they are moving a chair": ["Edb"],
  "they are old": ["Ehs"],
  "they are playing": ["HjA"],
  "they are playing cards": ["Edc"],
  "they are playing football": ["Edd"],
  "they are playing tennis": ["Ede"],
  "they are playing video games": ["Edf"],
  "they are putting up decorations": ["Edg"],
  "they are sad": ["Eh2"],
  "they are shaking hands": ["Edh"],
  "they are shopping": ["Edi"],
  "they are students": ["HjB"],
  "they are taking a photo": ["Edj"],
  "they are talking": ["Edl"],
  "they are talking on the phone": ["Edk"],
  "they are tigers": ["GEx"],
  "they are tired": ["EiE"],
  "they are twins": ["HjC"],
  "they are unhappy": ["Eh2"],
  "they are waiting for a bus": ["Edm"],
  "they are watching TV": ["Edn"],
  "they argue": ["EdK"],
  "they climb a mountain": ["EdL"],
  "they dance": ["EdM"],
  "they debate": ["EdN"],
  "they drink coffee": ["EdO"],
  "they eat cake": ["EdP"],
  "they exchange money": ["EdQ"],
  "they exercise": ["EdR"],
  "they fight": ["EdS"],
  "they go to school": ["EdT"],
  "they guard the door": ["EdU"],
  "they hold hands": ["EdV"],
  "they hug": ["EdW"],
  "they jump": ["EdX"],
  "they listen to music": ["EdY"],
  "they look at each other": ["EdZ"],
  "they meet each other": ["Eda"],
  "they move a chair": ["Edb"],
  "they play cards": ["Edc"],
  "they play football": ["Edd"],
  "they play tennis": ["Ede"],
  "they play video games": ["Edf"],
  "they put up decorations": ["Edg"],
  "they shake hands": ["Edh"],
  "they shop": ["Edi"],
  "they take a photo": ["Edj"],
  "they talk": ["Edl"],
  "they talking on the phone": ["Edk"],
  "they wait for a bus": ["Edm"],
  "they watch TV": ["Edn"],
  "they're": ["HAN"],
  "thick": ["GEz"],
  "thicken": ["Kgo"],
  "thickness": ["Kgp"],
  "thief": ["G0y","Cno","Cnq"],
  "thigh": ["GE0","Cnr"],
  "thimble": ["GE1","Cnu","Cns","Cnt"],
  "thin": ["G00","DOp","FVK","Cnv","EOv","Cnw","Cnx","Cn1"],
  "thin as a rake": ["EOr","EOs","EOt"],
  "thin out": ["Jf0"],
  "thing": ["E4L"],
  "think": ["G0z","DnJ","FVJ","Ecw","Cnz","Cn0","EZ3"],
  "think about": ["GE2","DnI"],
  "think about food": ["HjD"],
  "think about money": ["DnI","EZ3"],
  "think about thought about": ["DnI"],
  "think highly of": ["Jfu"],
  "think it over": ["HjE"],
  "think nothing of it": ["Jfv"],
  "think of": ["Jfw"],
  "think out": ["Jfx"],
  "think over": ["HjF"],
  "think thought": ["GE4","DnJ","EUS"],
  "think through": ["Jfy"],
  "think up": ["Jfz"],
  "thinker": ["Kgq"],
  "thinking": ["GE3","DnJ","Ecw"],
  "thinking about": ["DnI"],
  "thinking about money": ["DnI"],
  "thinly": ["Kgr"],
  "thinner": ["GE5","DOo"],
  "third": ["HjG","HBK","HAO","G01","DvS"],
  "third left": ["E4M"],
  "thirdly": ["Kgs"],
  "thirst": ["Kgt"],
  "thirsty": ["G02","Cn3","FVL","EOw","Cn2"],
  "thirteen": ["G03","GE6","DcY","FVM","DcX"],
  "thirteen pens": ["HjH"],
  "thirteenth": ["HA8"],
  "thirtieth": ["HBJ"],
  "thirty": ["G04","GE7","GFD","Dcf","FVN","DcZ"],
  "thirty eight": ["GE8","Dca"],
  "thirty five": ["GE9","Dcb"],
  "thirty four": ["GFA","Dcc"],
  "thirty nine": ["GFB","Dcd"],
  "thirty one": ["GFC","Dce"],
  "thirty seven": ["GFE","Dcg"],
  "thirty six": ["GFF","Dch"],
  "thirty thousand": ["Dci"],
  "thirty three": ["GFG","Dcj"],
  "thirty two": ["GFH","Dck"],
  "this": ["HAP","E4N"],
  "this is a desk": ["GFI"],
  "this is a dog": ["GFJ"],
  "this is a door": ["GFK"],
  "this is a duck": ["GFL"],
  "this is easy": ["HjI"],
  "this is for you": ["HjJ"],
  "this is my book": ["HjK"],
  "this is tom": ["HjL"],
  "this is wrong": ["HjM"],
  "Thomas Jefferson": ["Kgu"],
  "thorn": ["GFM","Cn4","Cn5"],
  "thorns": ["GFN","Cn6"],
  "thorough": ["Jf1"],
  "thoroughly": ["Kgv"],
  "those": ["HAQ"],
  "thou": ["Kgx"],
  "though": ["Jf2"],
  "thought": ["GFP","EUS"],
  "thoughtful": ["GFO","DvT"],
  "thoughtfully": ["Kgw"],
  "thousand": ["GFQ"],
  "thousandth": ["HA3"],
  "thrash": ["Kgy"],
  "thrash out": ["Jf3"],
  "thread": ["Jf4"],
  "threat": ["Jf5"],
  "threaten": ["Kgz"],
  "three": ["G05","GFT","Dcn","Dcl"],
  "three apples": ["HjN"],
  "three dogs": ["HjO"],
  "three hundred": ["GFR","Dcm"],
  "three o'clock": ["GFS","DeZ","Efg"],
  "three thousand": ["Dco"],
  "threshold": ["Jf6"],
  "threw away": ["ETR"],
  "threw away a bottle": ["ETR"],
  "thrifty": ["Jf7"],
  "thrill": ["Jf9"],
  "thriller": ["Kg0"],
  "thrilling": ["Jf8"],
  "thrive": ["JgA"],
  "throat": ["G06","DvU"],
  "throb": ["Kg1"],
  "throne": ["GFU","Cn9","Cn7","Cn8"],
  "throng": ["JgB"],
  "throttle": ["Kg2"],
  "through": ["JgC"],
  "throughout": ["Kg3"],
  "throw": ["G1A","DnK","FVO","Ebl","CoC","CoA"],
  "throw a ball": ["G07","DnK","Ebl","CoB"],
  "throw away": ["G08","DnM","DnL","EZ4","Ebm"],
  "throw away a bottle": ["Ebm","DnL"],
  "throw away threw away": ["DnM"],
  "throw away trash": ["EZ4","DnM"],
  "throw back": ["HjP"],
  "throw carefully": ["HjQ"],
  "throw hard": ["HjR"],
  "throw out": ["HjS"],
  "throw rubbish": ["HjT"],
  "throw threw": ["GFW","DnK","DnL"],
  "throw to me": ["HjU"],
  "throw up": ["JgD"],
  "throwing": ["G09","DnK","Ebl"],
  "throwing a ball": ["GFV","DnK","Ebl"],
  "throwing away": ["Ebm","DnL","DnM"],
  "throwing away a bottle": ["Ebm","DnL"],
  "throwing away trash": ["DnM"],
  "thrust": ["HjV"],
  "thud": ["Kg4"],
  "thug": ["Kg5"],
  "thumb": ["G1B","DOq","FVP","CoF","D6u","CoE","CoD"],
  "thump": ["JgE"],
  "thunder": ["G1C","CoH","FVQ"],
  "thunder and lightning": ["GFX","CoG"],
  "thunderstorm": ["G1D","DvV","FVR"],
  "Thursday": ["G1E","DOt","FVS","DOr","DOs"],
  "thus": ["JgF"],
  "thwart": ["JgG"],
  "thy": ["Kg6"],
  "ti": ["KhH"],
  "tic tac toe": ["CoQ","CoR"],
  "tick": ["GFZ","CoJ","CoI","CoP"],
  "tick off": ["JgI"],
  "ticket": ["G1F","DOu","FVT","CoM","CoO","CoN","D6v","CoL","CoK"],
  "tickets": ["GFY","DvW"],
  "tickle": ["JgH"],
  "tidal": ["Kg7"],
  "tide": ["HjW"],
  "tide over": ["JgJ"],
  "tidier": ["ESL","DOv"],
  "tidy": ["G1H","DnO","FVU","DnN","CoT","EZ5","EOz","CoS","CoU"],
  "tidy hotel rooms": ["EOy"],
  "tidy my room": ["G1G","DvX"],
  "tidy the bed": ["GFb","DnN","EZ5"],
  "tidy the room": ["GFc","DnO"],
  "tidy tidied": ["DnN","DnO"],
  "tidy up": ["G1I","DnP","EO0"],
  "tidy up tidied up": ["DnP"],
  "tidy your room": ["HjX"],
  "tidying": ["DnO","DnN"],
  "tidying the bed": ["DnN"],
  "tidying the room": ["DnO"],
  "tidying up": ["GFa","DnP"],
  "tie": ["G1J","DOw","FVV","CoV","CoW","D6w","DnR","CoX","CoY","Ec0","EZ6","DnS","DnQ"],
  "tie a knot": ["HjY"],
  "tie her shoes": ["DnQ"],
  "tie shoes": ["Ec0"],
  "tie tied": ["EVG","DnQ","DnR","DnS"],
  "tie up": ["JgK"],
  "tie your shoe": ["EZ6","DnS"],
  "tie your shoes": ["GFd","CoZ"],
  "tied": ["EVG"],
  "tied my laces": ["EVG"],
  "tier": ["Kg8"],
  "tiger": ["G1K","DOx","FVW","D6x","Cob","Cod","Coe","Coc","Coa"],
  "tigers": ["G1L","Cog","Cof"],
  "tigers are dangerous": ["EhU"],
  "tight": ["G1M","DOz"],
  "tighten": ["Kg9"],
  "tighten up": ["JgL"],
  "tighter": ["DOy"],
  "tightly": ["KhA"],
  "tights": ["GFe"],
  "tile": ["JgM"],
  "till": ["KhB"],
  "tilt": ["JgN"],
  "timber": ["GFf","Coj"],
  "time": ["GFg","E4O"],
  "time goes so fast": ["JgO"],
  "time is money": ["EO3"],
  "time zone": ["Hjb"],
  "timeless": ["KhC"],
  "timeline": ["HjZ"],
  "timely": ["KhD"],
  "times": ["Hja"],
  "timetable": ["G1N","Cok"],
  "timid": ["E4P"],
  "tin": ["G1O","Col","FVX"],
  "tin opener": ["HAR"],
  "ting": ["KhF"],
  "tingle": ["KhE"],
  "tinker": ["JgP"],
  "tint": ["KhG"],
  "tiny": ["G1P","EO4"],
  "tip": ["GFh","E4Q"],
  "tip off": ["JgQ"],
  "tipping": ["Hjc"],
  "tire": ["G1R","DvY","Cur","Cus","Cut"],
  "tired": ["G1Q","GFi","DO0","Con","EiF","Com","EO5","EiE"],
  "tired eyes": ["Hjd"],
  "tired feet": ["Hje"],
  "tired legs": ["Hjf"],
  "tired worker": ["Hjg"],
  "tiring": ["E4R"],
  "tissue": ["G1S","Coo","FVY"],
  "tissues": ["G1T","DO1","D6y"],
  "Titan": ["Hjh"],
  "titanic": ["GFj","Coq","Cop"],
  "title": ["JgR"],
  "to": ["KhO"],
  "to buy": ["GFk"],
  "to play": ["GFq","E4V"],
  "to say nothing of": ["Jgn"],
  "to school": ["Hjk"],
  "to sleep": ["GFr"],
  "to tell the truth": ["Jgq"],
  "toad": ["G1U","Cou","Cos","Cor","Cot"],
  "toads": ["Cow","Cov"],
  "toady": ["JgS"],
  "toast": ["G1W","Co5","Cox","EhB","DO3","Coy","Coz"],
  "toaster": ["G1V","DO2","FVZ","D6z","Co3","Co2","Co0","Co1"],
  "tobacco": ["JgT"],
  "Tobagonian": ["KrI"],
  "today": ["E4S"],
  "toddler": ["KhI"],
  "toe": ["G1X","DO6","FVa"],
  "toed": ["JgU"],
  "toenail": ["GFl","DO4"],
  "toenails": ["DO5"],
  "toes": ["G1Y","DO7","FVb","D60","Co9","Co8","Co6","Co7"],
  "tofu": ["G1Z","CpC","CpB","CpA"],
  "together": ["G1a","CpD","FVc","CpE"],
  "toil": ["CpO"],
  "toilet": ["G1c","DO9","FVe","CpG","CpH","D62","CpN","CpF"],
  "toilet paper": ["G1b","DO8","FVd","CpM","D61","CpI","CpL","CpJ"],
  "token": ["JgV"],
  "Tokyo": ["HAS"],
  "told": ["GFm","ETS"],
  "told her something": ["ETS"],
  "tolerable": ["JgW"],
  "tolerance": ["JgX"],
  "tolerant": ["JgY"],
  "tolerate": ["JgZ"],
  "toll": ["E4T"],
  "tom": ["KhJ"],
  "tomato": ["G1e","DPB","FVg","CpQ","EhC","CpY","CpP"],
  "tomato pasta": ["CpW","CpX"],
  "tomato sauce": ["GFn","Cpb","Cpa"],
  "tomato soup": ["Cpe"],
  "tomatoes": ["G1d","DPA","FVf","CpR","CpV","D63","CpT","CpU","CpS"],
  "tomb": ["G1f","Cpg","Cpf"],
  "tomorrow": ["E4U"],
  "ton": ["KhM"],
  "tone": ["Jgb"],
  "tone down": ["Jga"],
  "tongue": ["G1g","DPC","FVh","D64","Cpj","Cpk","Cph"],
  "tonic": ["KhK"],
  "tonight": ["Jgc"],
  "tonne": ["KhL"],
  "too": ["KhN"],
  "too big": ["EhE"],
  "too bright": ["EhI"],
  "too cold": ["EhP","EhQ"],
  "too fast": ["Ehd"],
  "too fat": ["Ehe"],
  "too heavy": ["Ehl"],
  "too hot": ["Hji"],
  "too large": ["EhE"],
  "too small": ["Eh5","Eh6"],
  "too tall": ["EiD"],
  "too tired": ["Hjj"],
  "took": ["GFo","EVH"],
  "took a pizza slice": ["EVH"],
  "tool": ["G1h","Cpo"],
  "toolbox": ["GFp","Cpm","Cpn","Cpl"],
  "tools": ["G1i","Cpr","Cps","Cpp","Cpq"],
  "tooth": ["G1m","Cp4","FVl","Cpt","Cpu"],
  "toothache": ["G1j","Cpv","FVi","Cpw"],
  "toothbrush": ["G1k","DPD","FVj","Cpy","D65","Cp0","Cpx","Cpz"],
  "toothpaste": ["G1l","DPE","FVk","Cp3","Cp2","Cp1","D66"],
  "top": ["G1n","Ddf"],
  "top up": ["E4W"],
  "topic": ["Jge"],
  "topical": ["Jgd"],
  "topography": ["Jgf"],
  "topple": ["KhP"],
  "topsoil": ["Jgg"],
  "torch": ["G1o","Cp8","FVm","Cp5","Cp7"],
  "tore": ["EVI"],
  "tore some money": ["EVI"],
  "torment": ["Jgh"],
  "tornado": ["G1p","Cp9","FVn","DPF","CqA","CqB","D67"],
  "Toronto": ["HAT"],
  "torpor": ["Jgi"],
  "torrent": ["Jgk"],
  "torrential": ["Jgj"],
  "torso": ["KhQ"],
  "tortoise": ["G1q","DPG","FVo","CqF","D68","CqC","CqG","CqD","CqE"],
  "tortuous": ["Jgl"],
  "torture": ["Jgm"],
  "toss": ["Jgo"],
  "total": ["Jgp"],
  "totally": ["KhR"],
  "toucan": ["GFs","CqJ","CqI","CqH"],
  "touch": ["G1r","CqM","FVp","DnT","CqL","CqK","EZ7"],
  "touch down": ["Jgr"],
  "touch the ball": ["Hjl"],
  "touch the screen": ["Hjm"],
  "touch touched": ["DnT"],
  "touch up": ["Hjn"],
  "touch wood": ["Hjo"],
  "touch your nose": ["Hjp"],
  "touch your toes": ["GFt","DnT","EZ7"],
  "touchdown": ["KhS"],
  "touching": ["DnT"],
  "touching your toes": ["DnT"],
  "tough": ["Jgt"],
  "toughen up": ["Jgs"],
  "tour": ["G1u","DvZ"],
  "tour bus": ["CqN"],
  "Tour de France": ["Hjq"],
  "tour guide": ["G1s","DPH","CqQ","DPI","EPA"],
  "tourism": ["Hjr"],
  "tourist": ["G1t","CqS","CqR"],
  "tournament": ["Jgu"],
  "tout": ["Jgv"],
  "tow": ["Jgy"],
  "toward": ["Jgw"],
  "towel": ["G1v","DPJ","FVq","DPK","CqV","D7A","CqT","CqU"],
  "towels": ["GFu","CqW","CqY","CqZ"],
  "tower": ["G1w","Cqc","FVr","Cqb","Cqa"],
  "towering": ["Jgx"],
  "town": ["G1y","Cqi","FVs","Cqd","Cqe"],
  "town center": ["GFv"],
  "town hall": ["G1x","Cqf","Cqg"],
  "town house": ["GFw","Dva"],
  "town square": ["GFx","Cqj","Cql","Cqk"],
  "township": ["KhT"],
  "toxic": ["Hjs"],
  "toxic waste": ["GFy","Cqm"],
  "toxicity": ["KhU"],
  "toxin": ["KhV"],
  "toy": ["G11","Cqo","FVv","Cqu","Cqp"],
  "toy box": ["G1z","Cqq","FVt","Cqr"],
  "toy car": ["G10","Cqs","FVu","Cqt"],
  "toy dinosaur": ["GFz"],
  "toy shop": ["G12","Cqy","FVw","Cqx"],
  "toy soldier": ["G13","Cqz","Cq0"],
  "toy soldiers": ["Cq1"],
  "toy store": ["G15","Cq7","FVy","Cq6","Cq8"],
  "toy train": ["G16","CrA","CrB","Cq9"],
  "toy with": ["Jgz"],
  "toys": ["G14","Cq5","FVx","Cqw","Cqv"],
  "trace": ["Jg0"],
  "trachea": ["CrC"],
  "track": ["G18","CrD","FV0","CrE"],
  "track and field": ["Hjt"],
  "tracks": ["CrG"],
  "tracksuit": ["G19","DPL","FV1","CrJ","D7B","CrH","CrI"],
  "tract": ["Jg1"],
  "traction": ["KhW"],
  "tractor": ["G2A","DPM","FV2","CrN","CrO","CrK","CrL","D7C","CrM"],
  "trade": ["E4X"],
  "trade in": ["Jg2"],
  "trade off": ["Jg3"],
  "trade union": ["Hju"],
  "trademark": ["KhX"],
  "trader": ["KhY"],
  "tradition": ["G2B","Dvb"],
  "traditional": ["E4Y"],
  "traditional dress": ["Jg4"],
  "traditionally": ["KhZ"],
  "traffic": ["G2F","Dvc","FV4"],
  "traffic cone": ["GF1","DPN"],
  "traffic congestion": ["Jg5"],
  "traffic jam": ["G2C","CrR","CrP","CrQ"],
  "traffic light": ["G2D","DPO","FV3","D7E","CrS","CrU","CrT"],
  "traffic lights": ["G2E","CrW","CrX","Crb","CrY","CrZ","Cra"],
  "tragedy": ["Jg6"],
  "tragic": ["Jg7"],
  "trail": ["GF2","Dvd"],
  "trailer": ["Kha"],
  "train": ["G2H","DPP","FV6","Cri","Crd","D7F","Crc","Cre"],
  "train people": ["EPC"],
  "train station": ["G2I","Crj","FV7","DPQ","Crk","D7G","Crm","Crl","Crn"],
  "trainee": ["Khb"],
  "trainer": ["GF3","Crf"],
  "trainers": ["G2G","Crh","FV5","Crg"],
  "training": ["Hjv"],
  "trait": ["Hjw"],
  "traitor": ["Khc"],
  "trajectory": ["Khd"],
  "tram": ["G2J","Cro","FV8","Crq","Crp"],
  "tramp": ["Jg9"],
  "trample": ["Jg8"],
  "trampoline": ["G2K","Crr","Crt","Cru","Crs"],
  "trampolining": ["Hjx"],
  "trance": ["JhA"],
  "tranquil": ["JhB"],
  "tranquility": ["Khe"],
  "trans": ["Kht"],
  "transact": ["JhD"],
  "transaction": ["JhC"],
  "transcend": ["JhF"],
  "transcendent": ["JhE"],
  "transcribe": ["JhG"],
  "transcript": ["Khg"],
  "transcription": ["Khf"],
  "transfer": ["JhH"],
  "transform": ["DYw"],
  "transformation": ["Khh"],
  "transformer": ["Khi"],
  "transfusion": ["Khj"],
  "transgenic": ["Khk"],
  "transient": ["JhI"],
  "transistor": ["Khl"],
  "transit": ["Hjy"],
  "transition": ["JhJ"],
  "transitional": ["Khm"],
  "transitive": ["Khn"],
  "translate": ["GF4","DnU","EZ8"],
  "translate Chinese to English": ["EZ8"],
  "translate translated": ["DnU"],
  "translating": ["DnU"],
  "translation": ["Hjz"],
  "translator": ["GF5","DPR","DPS"],
  "translucent": ["Hj0"],
  "transmission": ["Kho"],
  "transmit": ["JhK"],
  "transmitter": ["Khp"],
  "transnational": ["Khq"],
  "transparency": ["Khr"],
  "transparent": ["Hj1"],
  "transpiration": ["Hj2"],
  "transplant": ["JhL"],
  "transplantation": ["Khs"],
  "transport": ["GF6"],
  "transportation": ["JhM"],
  "trap": ["G2L","Crx","Crv"],
  "trapezium": ["GF7","Crw"],
  "trash": ["G2N","Cr7","FWA","Cr0","Cry","Crz"],
  "trash can": ["G2M","DPT","FV9","Cr1","Cr2","Cr5","Cr3","D7H"],
  "trash collection": ["Cr6"],
  "trauma": ["JhN"],
  "traumatic": ["Khu"],
  "travel": ["G2Q","CsA","FWB"],
  "travel agent": ["G2O","DPV","EPG","EPF"],
  "travel insurance": ["Hj3"],
  "traveler": ["Khv"],
  "traveling": ["GF8","Cr8","Cr9"],
  "travelling": ["G2P","Cr9","Cr8"],
  "travels": ["GF9","CsB","CsC"],
  "traverse": ["JhO"],
  "tray": ["G2R","DPW","FWC","CsD","D7I","CsG","CsE","CsH","CsF"],
  "treacherous": ["Khw"],
  "treachery": ["JhP"],
  "tread": ["JhQ"],
  "treadmill": ["GGA","CsL","CsJ"],
  "treasure": ["G2S","CsM","FWD","CsP","CsN"],
  "treasurer": ["Khx"],
  "treasury": ["Khy"],
  "treat": ["JhR"],
  "treat to": ["JhS"],
  "treat with": ["JhT"],
  "treatise": ["Khz"],
  "treatment": ["Kh0"],
  "treaty": ["Kh1"],
  "tree": ["G2U","DPX","FWF","Csa","D7J","CsT","CsV","CsQ","CsR","EiG","CsS","CsU"],
  "tree hollow": ["GGB","E4Z"],
  "tree house": ["G2T","CsW","FWE","CsY","CsX","CsZ"],
  "treehouse": ["GGC"],
  "trees": ["G2V","Csi","FWG","Csb","Csg","Csc","Csd","Csf","Csh"],
  "trek": ["JhU"],
  "trekking": ["GGD","Csl","Csk"],
  "tremble": ["JhV"],
  "tremendous": ["JhW"],
  "tremendously": ["Kh2"],
  "tremor": ["JhX"],
  "tremulous": ["JhY"],
  "trench": ["GGE","Csn","Css"],
  "trench coat": ["Cso","Csp","Csq","Csr"],
  "trend": ["JhZ"],
  "trendy": ["Jha"],
  "trial": ["Jhb"],
  "triangle": ["G2W","Csw","FWH","Csv"],
  "triangular": ["Kh3"],
  "triathlon": ["Hj4"],
  "tribal": ["Jhc"],
  "tribe": ["GGH","Csy","Csx"],
  "tribunal": ["Kh4"],
  "tributary": ["Jhd"],
  "tribute": ["Jhe"],
  "trick": ["E4a"],
  "trick or treat": ["G2X","Dve","FWI"],
  "trickle": ["Kh5"],
  "trickle down": ["Jhf"],
  "trickortreaters": ["EPH"],
  "tricky": ["Kh6"],
  "tried": ["EUT"],
  "tried on a dress": ["EUT"],
  "trifle": ["Jhg"],
  "trigger": ["Jhh"],
  "trillion": ["Kh7"],
  "trilogy": ["Jhi"],
  "trim": ["Jhj"],
  "Trinidad and Tobago": ["HE6","Cs2"],
  "Trinidadian": ["HE7","KrJ"],
  "trio": ["Cs4","Cs3"],
  "trip": ["G2Y","Cs7","FWJ","Cs6","Cs5"],
  "trip over": ["Jhl"],
  "triple": ["Jhk"],
  "triumph": ["Jhm"],
  "triumphant": ["Kh8"],
  "trivial": ["Jho"],
  "trivialize": ["Jhn"],
  "troll": ["GGI","Cs8","Cs9","CtD"],
  "troll face": ["CtC"],
  "trolley": ["G2Z","CtA","CtB"],
  "troop": ["KiA"],
  "trooper": ["Kh9"],
  "troops": ["Jhp"],
  "trophy": ["G2a","CtI","CtF","CtE","CtH","CtG"],
  "tropic": ["Jhq"],
  "tropical": ["CtK"],
  "tropical fish": ["CtM"],
  "tropics": ["Jhr"],
  "troposphere": ["Jhs"],
  "trot": ["Jht"],
  "trouble": ["Jhu"],
  "troublesome": ["KiB"],
  "trough": ["KiC"],
  "troupe": ["Jhv"],
  "trousers": ["G2b","DPZ","FWK","CtQ","DPY","CtP","CtR","CtO","CtS"],
  "trout": ["KiD"],
  "truce": ["KiE"],
  "truck": ["G2c","DPc","CtW","D7L","CtT","CtY","CtV","CtU"],
  "truck driver": ["GGJ","DPb","EPJ"],
  "true": ["Jhw"],
  "truly": ["KiF"],
  "trump": ["KiG"],
  "trumpet": ["G2d","DPd","FWL","Ctd","Ctc","D7M","Cta","CtZ"],
  "trunk": ["G2e","DPe","FWM","Cte","Ctf"],
  "trust": ["G2f","Ctg"],
  "trustee": ["KiH"],
  "trustworthy": ["Jhx"],
  "truth": ["E4b"],
  "truthful": ["KiI"],
  "try": ["GGL","Ecx"],
  "try again": ["Hj5"],
  "try hard": ["Hj6"],
  "try on": ["GGK","DnV","EPK"],
  "try on a dress": ["Ecx"],
  "try on shoes": ["Hj7"],
  "try on tried on": ["DnV"],
  "try out": ["Hj8"],
  "try out for": ["Jhy"],
  "try this": ["Hj9"],
  "try tried": ["EUT"],
  "try your best": ["HkA"],
  "trying": ["Ecx"],
  "trying on": ["DnV"],
  "tshirt": ["G2h","GGM","DPg","FWO","Cto","D7N","Ctm","DPf","Ctk","Cti"],
  "tsunami": ["G2i","Ctq","Cts","Ctp","Ctr"],
  "tub": ["G2k","Ctz","FWQ","Ctu","Ctt"],
  "tuba": ["GGN","Ctv","Ctw","Cty"],
  "tube": ["G2j","Dvf","FWP"],
  "tuberculosis": ["KiJ"],
  "tuck": ["Jh1"],
  "tuck away": ["Jhz"],
  "tuck in": ["Jh0"],
  "tuck shop": ["HAU"],
  "Tuesday": ["G2l","DPj","FWR","DPh","DPi"],
  "tug": ["Jh2"],
  "tug of war": ["HkB"],
  "tuition": ["Jh3"],
  "tuk tuk": ["E4d"],
  "tulip": ["G2m","Ct2","Ct1"],
  "tulips": ["GGO","Ct5","Ct3"],
  "tumble": ["Jh4"],
  "tumble dry": ["HAW"],
  "tumble dryer": ["HAV"],
  "tummy": ["GGP","E4e"],
  "tumor": ["KiK"],
  "tumult": ["Jh5"],
  "tuna": ["G2n","DPk","FWS","Ct9","Ct8","Ct6","Ct7"],
  "tundra": ["GGQ","E4f"],
  "tune": ["G2o","CuA"],
  "tune in": ["Jh6"],
  "tunnel": ["G2p","DPl","FWT","D7O","CuE","CuB","CuD"],
  "turbine": ["KiL"],
  "turbulence": ["KiM"],
  "turbulent": ["Jh7"],
  "turf": ["Jh8"],
  "Turk": ["KrK"],
  "Turkey": ["HE8","DPn","FWV","CuK","EPM","CuF","D7P","CuG"],
  "turkey": ["G2q","CuH","FWU","CuI","CuJ","EiH","EPL"],
  "Turkey flag": ["DPm"],
  "Turkish": ["GGR","DPo","EeW"],
  "Turks": ["KsD"],
  "turmoil": ["Jh9"],
  "turn": ["JiE"],
  "turn around": ["HkC"],
  "turn away": ["JiA"],
  "turn back": ["HkD"],
  "turn down": ["GGS","DnW","EPN","Ecy"],
  "turn down cake": ["Ecy","DnW"],
  "turn down turned down": ["DnW"],
  "turn in": ["JiB"],
  "turn into": ["GGT","DnX"],
  "turn into turned into": ["DnX"],
  "turn left": ["GGU","E4g"],
  "turn off": ["G2r","DnY","FWW","EZ9","EPP"],
  "turn off the computer": ["HkE"],
  "turn off the engine": ["HkF"],
  "turn off the light": ["GGV","DnY","EZ9"],
  "turn off the oven": ["HkG"],
  "turn off the phone": ["GGW"],
  "turn off the tap": ["HkH"],
  "turn off the tv": ["HkI"],
  "turn off turned off": ["DnY"],
  "turn on": ["G2s","Dna","FWX","DnZ","Ecz","EaA","Dnb","EPQ","Ebn"],
  "turn on a TV": ["GGX","DnZ"],
  "turn on the AC": ["Dnb","EaA"],
  "turn on the computer": ["HkJ"],
  "turn on the fan": ["HkK"],
  "turn on the heating": ["HkL"],
  "turn on the light": ["GGY","Ecz"],
  "turn on the radio": ["HkM"],
  "turn on the tap": ["HkN"],
  "turn on the TV": ["Ebn"],
  "turn on turned on": ["DnZ","Dna","Dnb"],
  "turn out": ["HkO"],
  "turn over": ["GGZ","Dnc","EPR"],
  "turn over turned over": ["Dnc"],
  "turn right": ["GGa","E4h"],
  "turn the corner": ["HkP"],
  "turn the page": ["HkQ"],
  "turn up": ["HkR"],
  "turnaround": ["KiN"],
  "turned on": ["EUU"],
  "turned on a light": ["EUU"],
  "turning down": ["Ecy","DnW"],
  "turning down cake": ["DnW","Ecy"],
  "turning into": ["DnX"],
  "turning off": ["DnY"],
  "turning off the light": ["DnY"],
  "turning on": ["Ecz","Ebn","Dna","DnZ","Dnb"],
  "turning on a TV": ["DnZ"],
  "turning on the AC": ["Dnb"],
  "turning over": ["Dnc"],
  "turnout": ["JiC"],
  "turnover": ["KiO"],
  "turnpike": ["JiD"],
  "turquoise": ["GGb","DPp"],
  "turtle": ["G2t","CuQ","FWY","DPq","CuL","D7Q","CuN","CuM"],
  "turtleneck": ["CuP"],
  "turtlenecked": ["CuO"],
  "turtles": ["GGc","CuR"],
  "tusk": ["G2u","CuS","CuT"],
  "tutor": ["GGd","DPr","Dnd","DPs","EaB"],
  "tutor a student": ["EaB"],
  "tutor tutored": ["Dnd"],
  "tutorial": ["KiP"],
  "tutoring": ["Dnd"],
  "Tuvalu": ["GGe","CuW"],
  "Tuvaluan": ["HE9"],
  "TV": ["G2v","GGf","DPt","FWZ","D7S"],
  "TV presenter": ["GGg","GGh","DPv","DPu"],
  "TV programme": ["GGi"],
  "tweak": ["KiQ"],
  "tweed": ["KiR"],
  "twelfth": ["HA7","GGk"],
  "twelve": ["G2w","GGl","GGm","Dcr","Dcp"],
  "twelve books": ["HkS"],
  "twelve hundred": ["Dcq"],
  "twentieth": ["HBG","GGn"],
  "twenty": ["G20","GGs","Dcy","Dcs"],
  "twenty children": ["HkT"],
  "twenty eight": ["GGo","Dct"],
  "twenty first": ["GGp"],
  "twenty five": ["G2x","Dcu"],
  "twenty five past eleven": ["Efh","Dea"],
  "twenty five past six": ["Deb"],
  "twenty five past ten": ["Dec"],
  "twenty five to ten": ["Ded","Efi"],
  "twenty four": ["G2y","Dcv"],
  "twenty nine": ["GGq","Dcw"],
  "twenty one": ["G2z","Dcx"],
  "twenty past two": ["GGr","Dee","Efj"],
  "twenty seven": ["G21","Dcz"],
  "twenty six": ["GGt","Dc0"],
  "twenty thousand": ["Dc1"],
  "twenty three": ["GGu","Dc2"],
  "twenty to four": ["Def","Efk"],
  "twenty two": ["G22","Dc3"],
  "twentyfirst": ["HBH"],
  "twice": ["GGv"],
  "twig": ["GGw","Cua","CuX","CuY"],
  "twilight": ["HkU"],
  "twin": ["GGy","Cuc"],
  "twin bed": ["GGx","Cub"],
  "twin room": ["Cud"],
  "twin sister": ["GGz","DZh","EPW"],
  "twine": ["JiF"],
  "twinkle": ["KiS"],
  "twinkling": ["JiG"],
  "twins": ["G23","Cue","FWa","Cui","Cuf","Cuh","Cug"],
  "twinsister": ["EPW"],
  "twist": ["JiH"],
  "twisted": ["E4i"],
  "twister": ["HkV"],
  "twitch": ["KiT"],
  "two": ["G24","GG2","Dc6","Dc4"],
  "two apples": ["HkW"],
  "two cats": ["HkX"],
  "two hundred": ["GG0","Dc5"],
  "two o'clock": ["GG1","Deg"],
  "two thirds": ["HAX"],
  "two thousand": ["Dc7"],
  "tycoon": ["JiI"],
  "tying": ["DnR","DnQ","DnS"],
  "tying her shoes": ["DnQ"],
  "tying your shoe": ["DnS"],
  "type": ["G25","Dng","Dne","Dnf","Ebo","EaC","Cul"],
  "type on a keyboard": ["EaC"],
  "type typed": ["EVJ","Dne","Dnf","Dng"],
  "typed": ["EVJ"],
  "typewriter": ["GG3","Cum","Cun"],
  "typewritten": ["JiJ"],
  "typhoon": ["G26","Cup"],
  "typhoon eye": ["HkY"],
  "typical": ["JiK"],
  "typically": ["KiU"],
  "typify": ["JiL"],
  "typing": ["GG4","Dng","Dne","Ebo","Dnf"],
  "typist": ["Cuq"],
  "typography": ["HkZ"],
  "tyrannical": ["JiM"],
  "tyranny": ["JiN"],
  "tyrant": ["JiO"],
  "tyre": ["GG5","Cut","DvY","Cur","Cus"],
  "U": ["DaP","HFI"],
  "u": ["G3R","GHE","DaQ","HFA"],
  "U turn": ["E4n"],
  "UAE": ["HFB"],
  "ubiquitous": ["JiP"],
  "ufo": ["G27","Cuv","Cuw"],
  "Uganda": ["HFD","HAY"],
  "Ugandan": ["HFC","KqI"],
  "uglier": ["GG6","DPw"],
  "ugly": ["G28","Cuz","FWb","EPX","DPx","Cuy","Cux"],
  "ukelele": ["GG7","Cu3","Cu2"],
  "Ukraine": ["G29","Cu6","Cu4","Cu5"],
  "Ukrainian": ["HFE","KrL"],
  "Ukrainians": ["KsE"],
  "ulcer": ["KiW"],
  "ulcerative": ["KiV"],
  "ultimate": ["JiQ"],
  "ultimately": ["KiX"],
  "ultimatum": ["JiR"],
  "ultra": ["KiY"],
  "ultrasound": ["KiZ"],
  "ultraviolet": ["JiS"],
  "uluru": ["GG8","Cu8","Cu7"],
  "umbrella": ["G3A","Cu9","FWc","DPy","D7T","DPz","CvA"],
  "umpire": ["G3B","CvB","FWd"],
  "unable": ["Kia"],
  "unacceptable": ["Kib"],
  "unadorned": ["JiT"],
  "unaffected": ["Kic"],
  "unaided": ["JiU"],
  "unanimous": ["JiV"],
  "unanimously": ["Kid"],
  "unanswered": ["Kie"],
  "unauthorize": ["Kif"],
  "unavailable": ["Kig"],
  "unavoidable": ["JiW"],
  "unaware": ["Kih"],
  "unbearable": ["Kii"],
  "unbelievable": ["Kij"],
  "unblock": ["HAZ"],
  "unbridgeable": ["JiX"],
  "uncanny": ["JiY"],
  "uncertain": ["Kik"],
  "uncertainty": ["Kil"],
  "unchanged": ["Kim"],
  "uncle": ["G3C","DZi","FWe","EPZ"],
  "unclear": ["Kin"],
  "uncomfortable": ["Kio"],
  "uncomfortably": ["Kip"],
  "uncommon": ["Kiq"],
  "unconditional": ["Kir"],
  "unconscious": ["Hka"],
  "unconsciously": ["Kis"],
  "unconsolidated": ["JiZ"],
  "unconstitutional": ["Kit"],
  "unconventional": ["Jia"],
  "uncover": ["Kiu"],
  "undecided": ["Kiv"],
  "undeniable": ["Kiw"],
  "under": ["G3E","GG9","Ddg","Ddh","Ef2","Ef3","Ddi"],
  "under the bed": ["Hkc"],
  "under the bridge": ["E4j"],
  "under the chair": ["GHA","Ef2"],
  "under the sofa": ["GHB","Ef3"],
  "under the table": ["Hkd"],
  "under the tree": ["Hke"],
  "under the water": ["E4k"],
  "under the weather": ["EPa","EPb","EPc"],
  "under water": ["Hkf"],
  "undercover": ["Kix"],
  "undercut": ["Kiy"],
  "underestimate": ["Jib"],
  "undergo": ["Jic"],
  "undergraduate": ["Jid"],
  "underground": ["G3D","Dvg","FWf"],
  "underlie": ["Kiz"],
  "underline": ["Ki0"],
  "underline a word": ["Hkb"],
  "underlying": ["Jif"],
  "underlying causes": ["Jie"],
  "undermine": ["Jig"],
  "underneath": ["Jih"],
  "underpin": ["Ki1"],
  "underscore": ["Jii"],
  "understand": ["G3F","Dvh","FWg"],
  "understandable": ["Ki2"],
  "understandably": ["Ki3"],
  "understate": ["Jij"],
  "undertake": ["Jik"],
  "undertaking": ["Jil"],
  "underwater": ["GHC","CvC"],
  "underway": ["Ki4"],
  "underwear": ["Ki5","Jin","Jim"],
  "underworld": ["Hkg"],
  "underwrite": ["Ki6"],
  "underwriter": ["Ki7"],
  "undesirable": ["Ki8"],
  "undo": ["Ki9"],
  "undoubtedly": ["KjA"],
  "undress": ["KjB"],
  "undue": ["KjC"],
  "unduly": ["KjD"],
  "unearth": ["Jio"],
  "unease": ["KjE"],
  "uneasy": ["KjF"],
  "unemployed": ["KjG"],
  "unemployment": ["Hkh"],
  "unemployment benefit": ["Jip"],
  "unequal": ["Jiq"],
  "uneven": ["Jir"],
  "unexpected": ["KjI"],
  "unexpectedly": ["KjH"],
  "unfair": ["KjK"],
  "unfairly": ["KjJ"],
  "unfamiliar": ["KjL"],
  "unfavorable": ["KjM"],
  "unfinished": ["KjN"],
  "unfold": ["KjO"],
  "unforgettable": ["KjP"],
  "unfortunate": ["Jis"],
  "unfortunately": ["KjQ"],
  "unfriendly": ["GHD","EPd"],
  "unhappiness": ["KjR"],
  "unhappy": ["G3G","Dvi","Eh1","EPe","Eh2"],
  "unhealthy": ["G3H","CvE","EPf","CvD"],
  "unicorn": ["G3I","CvH","CvF","CvG","CvI"],
  "unidentified": ["KjS"],
  "unification": ["KjT"],
  "uniform": ["G3J","CvL","FWh","CvK","CvM","CvJ"],
  "uniformity": ["Jit"],
  "uniformly": ["KjU"],
  "unify": ["Jiu"],
  "unilateral": ["KjV"],
  "unimportant": ["KjW"],
  "unintelligible": ["KjX"],
  "union": ["Hki"],
  "unionist": ["KjY"],
  "unique": ["Jiv"],
  "uniquely": ["KjZ"],
  "uniqueness": ["Kja"],
  "unison": ["Kjb"],
  "unit": ["Jix"],
  "unite": ["Jiw"],
  "United Arab Emirates": ["HFF","HAa"],
  "United Kingdom": ["HFG","GEs","G3K","CvQ","FWi","CvN","EPg","CvO"],
  "United States": ["HFH","GEt","G3L","CvU","CvR","EPk","CvT","DwN"],
  "unity": ["Jiy"],
  "universal": ["Jiz"],
  "universally": ["Kjc"],
  "universe": ["G3M","CvV","CvW","CvX"],
  "university": ["G3N","CvY","FWj","Cva","CvZ"],
  "university lecturer": ["DP1","EPi","EPh","DP0"],
  "unjust": ["Kjd"],
  "unknown": ["Kje"],
  "unlawful": ["Kjf"],
  "unleaded": ["Ji0"],
  "unleash": ["Kjg"],
  "unless": ["HAb"],
  "unlike": ["Kji"],
  "unlikely": ["Kjh"],
  "unlimited": ["Kjj"],
  "unload": ["Cvb"],
  "unlock": ["Kjk"],
  "unlock the door": ["Hkj"],
  "unlucky": ["Kjl"],
  "unmarked": ["Kjm"],
  "unmarried": ["Kjn"],
  "unmistakable": ["Kjo"],
  "unmute": ["HAc"],
  "unnamed": ["Kjp"],
  "unnatural": ["Kjq"],
  "unnecessarily": ["Kjr"],
  "unnecessary": ["Kjs"],
  "unnoticed": ["Kjt"],
  "Uno": ["Hkk"],
  "unofficial": ["Kju"],
  "unpack": ["Kjv"],
  "unpack a bag": ["Hkl"],
  "unpaid": ["Kjw"],
  "unparalleled": ["Ji1"],
  "unpleasant": ["Kjx"],
  "unpopular": ["Kjy"],
  "unprecedented": ["Ji2"],
  "unpredictable": ["Ji3"],
  "unpublished": ["Kjz"],
  "unravel": ["Ji4"],
  "unreal": ["Kj1"],
  "unrealistic": ["Kj0"],
  "unreasonable": ["Kj2"],
  "unrelated": ["Kj3"],
  "unreliable": ["Kj4"],
  "unresolved": ["Kj5"],
  "unrest": ["Ji5"],
  "unrestricted": ["Kj6"],
  "unsafe": ["Kj7"],
  "unsatisfactory": ["Kj8"],
  "unseen": ["Kj9"],
  "unsettle": ["Ji6"],
  "unspecified": ["KkA"],
  "unstable": ["KkB"],
  "unsubstantiated": ["Ji7"],
  "unsuccessful": ["KkD"],
  "unsuccessfully": ["KkC"],
  "unsuitable": ["KkE"],
  "unsure": ["KkF"],
  "untamed": ["Ji8"],
  "untapped": ["Ji9"],
  "unthinkable": ["KkG"],
  "untidy": ["G3O","Cvc"],
  "untie your laces": ["Hkm"],
  "until": ["KkH"],
  "unto": ["KkI"],
  "untouched": ["KkJ"],
  "untreated": ["KkK"],
  "untrue": ["KkL"],
  "unused": ["KkM"],
  "unusual": ["G3P","Dvj"],
  "unusually": ["KkN"],
  "unveil": ["KkO"],
  "unwanted": ["KkP"],
  "unwelcome": ["KkQ"],
  "unwilling": ["KkR"],
  "up": ["G3S","Dvl","FWk","Dvk"],
  "up to now": ["JjN"],
  "upbeat": ["KkS"],
  "upbringing": ["JjA"],
  "upcoming": ["JjB"],
  "update": ["JjD"],
  "updated": ["JjC"],
  "upgrade": ["JjE"],
  "upheaval": ["JjF"],
  "uphill": ["KkT"],
  "uphold": ["JjG"],
  "upland": ["KkU"],
  "uplift": ["KkV"],
  "upload": ["G3Q","Cve","Cvd"],
  "upon": ["KkW"],
  "upper": ["JjI"],
  "upper class": ["Hkn"],
  "uppermost": ["JjH"],
  "upright": ["JjJ"],
  "uprise": ["KkX"],
  "uproar": ["JjK"],
  "uproot": ["JjL"],
  "upset": ["G3T","Cvf","FWl","EPj"],
  "upside": ["KkY"],
  "upside down": ["GHF","Cvg","Cvh","EiI","DP2"],
  "upstairs": ["G3U","Cvi","FWm"],
  "upstream": ["KkZ"],
  "upsurge": ["JjM"],
  "uptake": ["Kka"],
  "upturn": ["Kkb"],
  "upward": ["Kkc"],
  "upwards": ["JjO"],
  "uranium": ["Kkd"],
  "uranus": ["G3V","Cvj"],
  "urban": ["Hkp"],
  "urban sprawl": ["JjP"],
  "urbanization": ["Hko"],
  "urchin": ["Kke"],
  "urge": ["JjS"],
  "urge on": ["JjR"],
  "urgency": ["Kkf"],
  "urgent": ["JjQ"],
  "urgently": ["Kkg"],
  "urine": ["Kkh"],
  "Ursa Major": ["Hkq"],
  "Uruguay": ["HFK"],
  "Uruguayan": ["HFJ","KqJ"],
  "us": ["HAe"],
  "USA": ["GEu","GEv","G3W","AEp","EPk","AEV","DwN","C4p","AEX","AEY","AEZ"],
  "usa dollar": ["Cvk","Cvl"],
  "USA flag": ["GHG","DP3"],
  "usable": ["Kki"],
  "usage": ["Kkj"],
  "usb stick": ["GHH","DP4","Cvm","D7U","Cvn"],
  "use": ["G3Z","Dnm","FWn","Dnh","Dni","Ec1","Dnl","Ebq","Ebp","EaG","EaD","Dnj","EaF"],
  "use a computer": ["G3X","Dnh","EPl","Ec1"],
  "use a hairdryer": ["EaD"],
  "use a key": ["DP6"],
  "use a knife": ["Hkr"],
  "use a laptop": ["EPm"],
  "use a microwave": ["DP7"],
  "use a mirror": ["DP8"],
  "use a pen": ["GHI","DP9"],
  "use a phone": ["GHJ","Dni","DQA","Ebq"],
  "use a ruler": ["DQB"],
  "use a spoon": ["DQC"],
  "use a tablet": ["Ebp","Dnj"],
  "use a tissue": ["DQD"],
  "use a wheelchair": ["EaF","Dnk"],
  "use both hands": ["Hks"],
  "use carefully": ["Hkt"],
  "use chopsticks": ["Dnl","DQE","EaG"],
  "use scissors": ["DQF"],
  "use the computer": ["GHK","E4m"],
  "use the Internet": ["GHL","Dnn"],
  "use the toilet": ["Hkw"],
  "use up": ["Hkx"],
  "use used": ["GHM","Dnh","ETT","EVx","Dni","Dnj","Dnm"],
  "use your phone": ["Hky"],
  "used": ["EVx","ETT"],
  "used chopsticks": ["EVx"],
  "used his phone": ["ETT"],
  "used to": ["JjT"],
  "useful": ["G3Y","Dvm"],
  "usefully": ["Kkk"],
  "usefulness": ["Kkl"],
  "useless": ["E4l"],
  "user": ["Hkv"],
  "username": ["Hku","HAd"],
  "usher": ["JjV"],
  "usher in": ["JjU"],
  "using": ["Ebp","Ec1","Ebq","Dnm","Dnh","Dni","Dnj","Dnl"],
  "using a computer": ["GHN","Dnh","Ec1"],
  "using a phone": ["Dni","Ebq"],
  "using a tablet": ["Ebp","Dnj"],
  "using a wheelchair": ["Dnk"],
  "using chopsticks": ["Dnl"],
  "using the Internet": ["Dnn"],
  "usual": ["Kkm"],
  "usually": ["JjW"],
  "utensil": ["JjX"],
  "utilitarian": ["JjY"],
  "utility": ["Kkn","JjZ"],
  "utilization": ["Kko"],
  "utilize": ["Jja"],
  "utmost": ["Jjb"],
  "utter": ["Jjd"],
  "utterance": ["Kkp"],
  "utterly": ["Jjc"],
  "uv index": ["Hkz"],
  "Uzbek": ["HFM","KqK","HAg"],
  "Uzbekistan": ["HFL","HAf"],
  "V": ["DaR","HFP","HFN"],
  "v": ["G30","GHq","FW7","DaS"],
  "vacancy": ["Jje"],
  "vacant": ["Jjf"],
  "vacate": ["Jjg"],
  "vacation": ["G3a","Cvo","FWo"],
  "vaccination": ["Kkq"],
  "vaccine": ["Hk0"],
  "vacuum": ["G3c","Cvq","FWq"],
  "vacuum cleaner": ["G3b","DQG","FWp","Cvp","D7V"],
  "vacuum of space": ["Hk1"],
  "vacuum the carpet": ["GHO"],
  "vagrant": ["Jjh"],
  "vague": ["Jji"],
  "vaguely": ["Kkr"],
  "vain": ["Jjj"],
  "valentine": ["Jjk"],
  "valid": ["Jjn"],
  "validate": ["Jjl"],
  "validation": ["Kks"],
  "validity": ["Jjm"],
  "valley": ["Hk2","G3d","DYx","FWr","Cvr","Cvt","Cvs"],
  "valuable": ["GHP","DYy","Cvu"],
  "valuation": ["Kkt"],
  "value": ["Jjo"],
  "values": ["Hk3"],
  "valve": ["GHQ","DYz","Cvw","Cvv"],
  "vampire": ["G3e","Cvy","FWs","Cvx","Cvz","EPo"],
  "van": ["G3g","Cv3","FWt","DQH","Cv0","D7W"],
  "Van Gogh": ["Kku"],
  "Vancouver": ["HAh"],
  "vandalism": ["GHR","Cv1","Cv2"],
  "vanilla": ["G3f","Dvn"],
  "vanish": ["Jjp"],
  "vanity": ["Jjq"],
  "vantage": ["Kkv"],
  "vapor": ["Jjs"],
  "vaporize": ["Jjr"],
  "variability": ["Kkw"],
  "variable": ["Jjt"],
  "variance": ["Kkx"],
  "variant": ["Jju"],
  "variation": ["Kky"],
  "varied": ["Jjv"],
  "variety": ["E4o"],
  "various": ["E4p"],
  "variously": ["Kkz"],
  "varnish": ["Jjw"],
  "vary": ["Jjx"],
  "vascular": ["Jjy"],
  "vase": ["G3h","DQI","FWu","Cv8","Cv6","Cv7","Cv5","Cv4","D7X"],
  "vast": ["GHS","CwA"],
  "vastly": ["Kk0"],
  "Vatican": ["HAi"],
  "Vatican City": ["CwB"],
  "vault": ["Jjz"],
  "vector": ["Kk1"],
  "veer": ["Kk2"],
  "veg out": ["Jj3"],
  "vegetable": ["G3i","CwF","FWv","CwC"],
  "vegetable garden": ["GHT","CwD","CwE"],
  "vegetables": ["G3j","DQJ","FWw","EPp","CwK","CwH","CwG","CwI","CwJ"],
  "vegetarian": ["Jj0"],
  "vegetation": ["Jj1"],
  "vegetative": ["Jj2"],
  "vehement": ["Jj4"],
  "vehicle": ["GHU","E4q"],
  "veil": ["Jj5"],
  "vein": ["Jj6"],
  "veins": ["GHV","CwL"],
  "velocity": ["CwM"],
  "velvet": ["Kk3"],
  "vending machine": ["E4r"],
  "vendor": ["GHW","CwN","CwO"],
  "Venezuela": ["G3k","CwR","CwP","EPq"],
  "Venezuelan": ["HFO","KrM"],
  "vengeance": ["Kk4"],
  "Venice": ["Kk5"],
  "venom": ["Jj8"],
  "venomous": ["Jj7"],
  "vent": ["JkA"],
  "ventilation": ["Jj9"],
  "ventricle": ["Kk6"],
  "ventricular": ["Kk7"],
  "venture": ["JkB"],
  "venturesome": ["JkC"],
  "venue": ["Kk8"],
  "venus": ["G3l","CwS","FWx"],
  "verb": ["Kk9"],
  "verbal": ["JkE"],
  "verbalize": ["JkD"],
  "verbiage": ["JkF"],
  "verdict": ["JkG"],
  "verge": ["JkH"],
  "verifiable": ["JkI"],
  "verification": ["KlA"],
  "verify": ["JkJ"],
  "vermillion": ["DQK"],
  "vernacular": ["KlB"],
  "versa": ["KlC"],
  "versatile": ["JkK"],
  "verse": ["JkL"],
  "version": ["JkM"],
  "versus": ["JkN"],
  "vertebrate": ["Hk4"],
  "vertex": ["KlD"],
  "vertical": ["GHX","CwT"],
  "vertically": ["KlE"],
  "very": ["KlF"],
  "very hungry": ["Hk5"],
  "vesicle": ["KlG"],
  "vessel": ["CwU"],
  "vest": ["G3m","CwY","FWy","CwZ","DQL","CwX","D7Y"],
  "vestige": ["JkO"],
  "vet": ["G3o","DQM","FWz","DQN","Cwc","EPr","EPs","D7Z","Cwa"],
  "veteran": ["Hk6"],
  "veterinarian": ["G3n","Cwb"],
  "veterinary": ["KlH"],
  "veto": ["JkP"],
  "via": ["JkR"],
  "viability": ["KlI"],
  "viable": ["JkQ"],
  "vibe": ["KlJ"],
  "vibrant": ["JkS"],
  "vibrate": ["JkT"],
  "vibration": ["JkU"],
  "vicar": ["KlK"],
  "vice": ["JkV"],
  "vicinity": ["JkW"],
  "vicious": ["JkY"],
  "vicious circle": ["JkX"],
  "victim": ["JkZ"],
  "victimization": ["KlL"],
  "victor": ["Jka"],
  "Victoria Falls": ["Hk7"],
  "victory": ["KlM"],
  "video": ["G3p","Cwd"],
  "video call": ["HAj"],
  "video game": ["GHZ","GHY","E4s"],
  "video games": ["GHa","E4t"],
  "videotape": ["KlN"],
  "vie": ["Jkb"],
  "Vienna": ["HAk"],
  "Vietnam": ["G3q","Cwj","FW0","Cwe","EPt","Cwh","Cwg"],
  "Vietnam flag": ["GHc","DQO"],
  "Vietnamese": ["GHb","KsF","KrN"],
  "view": ["G3r","Cwk"],
  "viewer": ["Jkc"],
  "viewpoint": ["KlO"],
  "vigil": ["Jke"],
  "vigilance": ["Jkd"],
  "vigor": ["Jkg"],
  "vigorous": ["Jkf"],
  "vigorously": ["KlP"],
  "Viking": ["KrO"],
  "Vikings": ["KsG"],
  "villa": ["KlR"],
  "village": ["G3s","Cwm","FW1","Cwn","Cwl"],
  "villager": ["KlQ"],
  "villain": ["GHd","Cwo"],
  "vine": ["Jkh"],
  "vinegar": ["GHe","Cwp"],
  "vineyard": ["KlS"],
  "vintage": ["KlT"],
  "vinyl": ["KlU"],
  "violate": ["Jki"],
  "violation": ["KlV"],
  "violence": ["Jkj"],
  "violent": ["Jkk"],
  "violently": ["KlW"],
  "violet": ["G3t","DQP"],
  "violin": ["G3u","DQQ","FW2","Cww","D7a","Cwt","Cwr","Cwq","Cws"],
  "violinist": ["GHf","Cwv"],
  "viral": ["Jkl"],
  "virgin": ["KlY"],
  "Virginia": ["KlX"],
  "Virgo": ["Hk8"],
  "virtual": ["Jkm"],
  "virtually": ["KlZ"],
  "virtue": ["Jkn"],
  "virtuous": ["Jko"],
  "virus": ["E4u"],
  "visa": ["Hk9"],
  "viscous": ["Jkp"],
  "visibility": ["Kla"],
  "visible": ["Jkq"],
  "visibly": ["Klb"],
  "vision": ["Jkr"],
  "visionary": ["Klc"],
  "visit": ["G3w","Dno","FW4","Ec2"],
  "visit a friend": ["HlA"],
  "visit a museum": ["GHg"],
  "visit family": ["GHi"],
  "visit friends": ["HlB"],
  "visit grandma": ["GHj"],
  "visit grandparents": ["G3v","Dno","FW3","Ec2"],
  "visit London": ["HlC"],
  "visit my grandma": ["GHl","E4v"],
  "visit the doctor": ["HlD"],
  "visit the zoo": ["HlE"],
  "visit visited": ["GHn","Dno","EWD","EUV"],
  "visited": ["GHh","EUV","EWD"],
  "visited France": ["EWD"],
  "visited her grandparents": ["EUV"],
  "visiting": ["GHk","Dno","Ec2"],
  "visiting grandparents": ["Dno","Ec2"],
  "visitor": ["GHm","E4w"],
  "visual": ["Jkt"],
  "visualize": ["Jks"],
  "visually": ["Kld"],
  "vital": ["Jku"],
  "vitality": ["Kle"],
  "vitamin": ["Klf"],
  "vivacious": ["Jkv"],
  "vivid": ["Jkw"],
  "vividly": ["Klg"],
  "vivify": ["Jkx"],
  "vocabulary": ["HlF"],
  "vocal": ["Jkz"],
  "vocalization": ["Klh"],
  "vocalize": ["Jky"],
  "vocation": ["Jk0"],
  "vocational": ["Kli"],
  "vodka": ["Klj"],
  "vogue": ["Jk1"],
  "voice": ["E4x"],
  "voice message": ["HAl"],
  "void": ["Klk"],
  "volatile": ["Jk2"],
  "volatility": ["Kll"],
  "volcanic": ["Klm"],
  "volcano": ["G3x","DQT","FW5","Cw2","Cwx","Cwz","Cw0","D7b","DQR","Cw1","Cwy","DQS"],
  "Volga": ["Kln"],
  "Volga River": ["Klo"],
  "volley": ["Klp"],
  "volleyball": ["G3y","DQU","FW6","Cw3","Cw7","Cw6","D7c","Cw5","Cw4"],
  "voltage": ["HlG"],
  "volume": ["HlH"],
  "voluntarily": ["Klq"],
  "voluntary": ["Jk3"],
  "volunteer": ["G3z","Dvo"],
  "vomit": ["Jk4"],
  "voracious": ["Jk5"],
  "vortex": ["Klr"],
  "vote": ["HlI"],
  "vote down": ["Jk6"],
  "voter": ["HlJ"],
  "voting": ["Dvp"],
  "voucher": ["GHo","Cw8"],
  "vow": ["Jk7"],
  "vowel": ["Kls"],
  "voyage": ["GHp","Dvq"],
  "Vulcan": ["HlK"],
  "vulgar": ["Jk8"],
  "vulnerability": ["Klt"],
  "vulnerable": ["Jk9"],
  "vulture": ["G31","CxC","Cw9"],
  "W": ["DaT","G5r","GJv","HFT"],
  "w": ["FYE","DaU","HFQ"],
  "wade": ["JlB"],
  "wade in": ["JlA"],
  "waffle": ["EhD"],
  "waffles": ["G32","DQV","CxD","D7d","CxE","CxF"],
  "wag": ["Klu"],
  "wage": ["HlL"],
  "waggle": ["JlC"],
  "wagon": ["G33","CxI","CxG"],
  "wail": ["JlD"],
  "waist": ["GHr"],
  "wait": ["G35","Dns","EaH","Edm","Dnr","Dnp","CxJ","CxL","CxQ","CxK"],
  "wait a minute": ["HlM","HAm"],
  "wait at the lights": ["Dnp"],
  "wait for": ["GHv","Dnq"],
  "wait for a bus": ["GHu","Dnq","Edm","EaH"],
  "wait for a train": ["Dnr"],
  "wait for the bus": ["HlN"],
  "wait here": ["HlO"],
  "wait in line": ["GHy","CxP"],
  "wait on": ["JlE"],
  "wait out": ["JlF"],
  "wait outside": ["HlP"],
  "wait up": ["JlG"],
  "wait waited": ["Dns","EWS","EVC","Dnp","Dnq","Dnr"],
  "wait your turn": ["HlQ"],
  "waited": ["GHs","EWS","EVC"],
  "waited for a bus": ["EVC"],
  "waiter": ["G34","DQX","FW8","EPv","DQW","CxN","EPu","CxO","CxM","D7e"],
  "waiters": ["GHt"],
  "waiting": ["GHx","Dns","Edm","Dnr","Dnp"],
  "waiting at the lights": ["GHw","Dnp"],
  "waiting for": ["Dnq"],
  "waiting for a bus": ["Dnq","Edm"],
  "waiting for a train": ["Dnr"],
  "waiting room": ["E4y"],
  "waitress": ["G36","CxT","FW9","CxS","CxR"],
  "waive": ["Klv"],
  "waiver": ["Klw"],
  "wake": ["JlH"],
  "wake early": ["HlR"],
  "wake late": ["HlS"],
  "wake me": ["HlT"],
  "wake the baby": ["HlU"],
  "wake up": ["G37","Dnt","Dnu","Ec3","CxV","CxU","EPx","EPw"],
  "wake up early": ["HlV"],
  "wake up woke up": ["GHz","Dnt","Dnu"],
  "waking up": ["GH0","Dnu","Dnt","Ec3"],
  "Wales": ["HFR","EPy"],
  "walk": ["G4A","Dnx","FXB","Dny","Dnv","EP0","CxX","Ec4","CxW","Dnw","EaK","Cxc"],
  "walk a dog": ["G38","Dnv"],
  "walk across": ["HlW"],
  "walk along": ["HlX"],
  "walk away from": ["JlI"],
  "walk away with": ["JlJ"],
  "walk back": ["JlK"],
  "walk downstairs": ["HlY"],
  "walk home": ["HlZ"],
  "walk in the countryside": ["EPz"],
  "walk in the park": ["GH4","Dnw"],
  "walk into": ["JlL"],
  "walk out": ["JlM"],
  "walk slowly": ["ERV"],
  "walk the": ["Ec4"],
  "walk the dog": ["G4B","Cxf","FXC","Cxd","Ec4","EaK","Cxe","Cxg"],
  "walk through": ["JlN"],
  "walk to class": ["Dny"],
  "walk to school": ["G4C","Dvr"],
  "walk up to": ["JlO"],
  "walk upstairs": ["Hla"],
  "walk walked": ["GH5","ETU","Dnx","Dnv","Dny","Dnw"],
  "walked": ["GH1","ETU"],
  "walker": ["Klx"],
  "walking": ["G39","Dnx","FXA","Dnv","Ec4","Dnw","Dny","Cxa","CxY","CxZ"],
  "walking a dog": ["GH2","Dnv"],
  "walking in the park": ["GH3","Dnw"],
  "walking stick": ["D7f","DQY"],
  "walking to class": ["Dny"],
  "wall": ["G4E","DQa","FXE","Cxh","Cxo","D7h","Cxi"],
  "wall off": ["JlP"],
  "wallet": ["G4D","DQZ","FXD","Cxj","D7g","Cxl","Cxn","Cxk","Cxm"],
  "wallow in": ["JlQ"],
  "wallpaper": ["Kly"],
  "walnut": ["GH6","D7i"],
  "walnuts": ["GH7","Cxs","Cxq"],
  "walrus": ["G4F","Cxt","Cxv","Cxu"],
  "waltz": ["Cxw"],
  "wan": ["JlU"],
  "wand": ["GH8","Cxx"],
  "wander": ["JlR"],
  "wane": ["JlS"],
  "waning moon": ["Hlb"],
  "wanna": ["JlT"],
  "want": ["GH9","E4z"],
  "want in": ["JlV"],
  "want out": ["JlW"],
  "war": ["G4I","Dvs"],
  "ward": ["Kl0"],
  "warden": ["Klz"],
  "wardrobe": ["G4G","Cx0","FXF","Cxz","Cxy"],
  "ware": ["JlX"],
  "warehouse": ["Hlc"],
  "warfare": ["Kl1"],
  "warhead": ["Kl2"],
  "warlord": ["Kl3"],
  "warm": ["G4H","Cx1","FXG","Cx2","EP2"],
  "warm front": ["Hld"],
  "warm regards": ["Hle"],
  "warm to": ["JlY"],
  "warm up": ["Hlf"],
  "warmer": ["GIA","DQb"],
  "warmly": ["Kl4"],
  "warmth": ["Kl5"],
  "warn": ["Jla"],
  "warn off": ["JlZ"],
  "warning": ["GIB"],
  "warp": ["Jlb"],
  "warrant": ["Jlc"],
  "warranty": ["Kl6"],
  "warrior": ["Jld"],
  "Warsaw": ["HAn"],
  "wartime": ["Kl7"],
  "wary": ["Jle"],
  "was": ["EUW"],
  "was sad": ["EUW"],
  "wash": ["G4O","Dn2","FXL","Dnz","Dn4","Dn7","Dn0","Ebt","Cx8","Ebr","Dn1","Dn6","Ebs","Cx3","EaL","Dn5","EaN","EaM","Dn3"],
  "wash away": ["Hlg"],
  "wash dishes": ["G4K","Dnz","FXI","Dn0"],
  "wash face": ["G4L","Dvt","FXJ","Ebr"],
  "wash hands": ["GID","Ebs"],
  "wash his face": ["Dn1"],
  "wash my face": ["G4N","E40"],
  "wash my hands": ["GII","E41"],
  "wash off": ["Hlh"],
  "wash the car": ["G4P","CyB"],
  "wash the clothes": ["Hli"],
  "wash the dishes": ["G4Q","CyC","FXM","Dn3","EaL","Ebt","CyD"],
  "wash the dog": ["Hlj"],
  "wash the floor": ["Hlk"],
  "wash up": ["G4R","Dvu"],
  "wash washed": ["GIK","Dnz","Dn2","EVO","EVN","EWE","ETV","Dn0","Dn1"],
  "wash your car": ["GIL","Dn4"],
  "wash your face": ["G4S","Dn5","FXN","EaM","EP4"],
  "wash your hair": ["GIM","Dn6","EaN"],
  "wash your hands": ["G4T","Dn7","FXO"],
  "washbasin": ["G4J","Cx4","FXH"],
  "washed": ["GIC","EWE","EVO","EVN","ETV"],
  "washed her hair": ["EWE"],
  "washed his car": ["EVN"],
  "washed his hands": ["ETV"],
  "washed the dishes": ["EVO"],
  "washing": ["GIF","Dn2","Dn4","Dn0","Dn7","Ebt","Ebs","Ebr","Dnz","Dn1","Dn3","Dn5","Dn6"],
  "washing dishes": ["GIE","Dn0","Dnz"],
  "washing his face": ["Dn1"],
  "washing line": ["HAo"],
  "washing machine": ["G4M","DQc","FXK","Cx6","D7j","Cx7"],
  "washing the dishes": ["GIG","Dn3","Ebt"],
  "washing your car": ["GIH","Dn4"],
  "washing your face": ["Dn5"],
  "washing your hair": ["Dn6"],
  "washing your hands": ["Dn7"],
  "Washington": ["Kl8","EP3"],
  "washroom": ["GIJ","CyA","Cx9"],
  "wasp": ["GIN","CyF","CyH","CyE"],
  "waste": ["G4V","CyI","FXP","CyM","CyJ"],
  "waste basket": ["G4U","CyK","CyL"],
  "waste one's breath": ["Jlf"],
  "wastebasket": ["GIO","E42"],
  "watch": ["G4Z","DQe","Dn9","Dn8","DQd","EaO","D7k","D7l","CyP","CyN","CyU","Edn","DoA","CyO"],
  "watch a film": ["GIP","E43"],
  "watch a movie": ["GIQ","E44"],
  "watch a video": ["Hll"],
  "watch carefully": ["Hlm"],
  "watch cartoons": ["GIR"],
  "watch films": ["GIV"],
  "watch me": ["Hln"],
  "watch movies": ["G4Y","Dvv","FXS"],
  "watch out": ["Hlo"],
  "watch out for": ["Jlg"],
  "watch over": ["Jlh"],
  "watch strap": ["CyV","CyW"],
  "watch the news": ["Hlp"],
  "watch TV": ["G4a","GIX","CyX","Dn9","FXU","EaO","DoA","Edn","CyX","CyY"],
  "watch watched": ["GIY","EVh","DoA","Dn8","Dn9","EVD"],
  "watchdog": ["Kl9"],
  "watched": ["GIS","EVh","EVD"],
  "watched TV": ["GIT","EVh","EVD"],
  "watcher": ["KmA"],
  "watches": ["GIU","CyQ"],
  "watching": ["G4W","Dn9","FXQ","Dn8","DoA","Edn"],
  "watching movies": ["GIW"],
  "watching TV": ["G4X","CyT","Dn9","FXR","DoA","Edn","CyT","CyS"],
  "water": ["G4f","DQh","Cya","D7o","CyZ","DoB","CzA","EaP"],
  "water balloon": ["Cyb"],
  "water bottle": ["G4b","Cyc","FXV","Cye","Cyd"],
  "water bucket": ["Cyf"],
  "water cycle": ["DY0"],
  "water dispenser": ["GIZ","DQf","D7m"],
  "water down": ["Jlj"],
  "water lily": ["GIc","Cyu"],
  "water park": ["G4e","Cy3","FXY","DY1","Cy8","Cy5"],
  "water plants": ["GIf","EaP"],
  "water polo": ["Hlq"],
  "water shortage": ["GIg","DY2","CzB"],
  "water ski": ["GIh","Dvw"],
  "water skiing": ["G4g","CzF","CzH","CzE"],
  "water slide": ["GIi","CzJ","CzK"],
  "water the flowers": ["E45"],
  "water the lawn": ["GIj","CzL","CzM"],
  "water the plants": ["G4h","E46"],
  "water vegetables": ["DoB"],
  "water watered": ["DoB"],
  "watercolor": ["KmB"],
  "watercourse": ["Jli"],
  "waterfall": ["G4c","Cyj","FXW","Cyk","Cym","Cyl","Cyi"],
  "waterfalls": ["Cyn"],
  "waterfront": ["KmC"],
  "watering": ["GIb","DoB","Cyt"],
  "watering can": ["GIa","Cyp","Cys","Cyr"],
  "watering vegetables": ["DoB"],
  "watermelon": ["G4d","DQg","FXX","Cyy","Cyx","D7n","Cy1","Cy0","Cyz","Cyw"],
  "watermelons": ["GId","Cy2"],
  "waterpark": ["GIe","Cy6","Cy9","Cy7"],
  "waterproof": ["KmD"],
  "watershed": ["KmE"],
  "waterway": ["KmF"],
  "waterwheel": ["Dvx"],
  "watery": ["KmG"],
  "watt": ["Hlr"],
  "wave": ["G4i","G4j","CzQ","FXZ","DoE","DoD","CzO","Ec5","CzP","EaQ","CzN","DoC"],
  "wave goodbye": ["Hls"],
  "wave her hand": ["DoD"],
  "wave off": ["Jlk"],
  "wave to a friend": ["EaQ"],
  "wave waved": ["ETW","DoC","DoD","DoE"],
  "wave your hand": ["Hlu"],
  "waved": ["ETW"],
  "wavelength": ["Hlt"],
  "waver": ["Jll"],
  "waves": ["G4k","CzR"],
  "waving": ["GIk","DoE","Ec5","DoC","DoD"],
  "waving her hand": ["DoD"],
  "wavy": ["GIl","Dvy"],
  "wavy hair": ["G4l","CzS","FXa","CzT"],
  "wax": ["G4m","CzU","FXb"],
  "waxing moon": ["Hlv"],
  "way": ["GIm","E47"],
  "we": ["GI9","E5D"],
  "we are friends": ["Hl2"],
  "we are going": ["Hl3"],
  "we are hungry": ["Hl4"],
  "we are late": ["Hl5"],
  "we are ready": ["Hl6"],
  "weak": ["G4n","CzV","FXc","EP7","CzW"],
  "weak sunshine": ["Hlw"],
  "weaken": ["KmH"],
  "weaker": ["GIn","DQi"],
  "weakly": ["KmI"],
  "weakness": ["KmJ"],
  "wealth": ["Hlx"],
  "wealthy": ["Jlm"],
  "weapon": ["Hly"],
  "weapons": ["Hlz"],
  "wear": ["G4o","DoF","FXd","DoJ","EaS","DoI","DoG","EaR","DoH"],
  "wear a black dress": ["Ef4"],
  "wear a blue hat": ["Ef5"],
  "wear a brown belt": ["Ef6"],
  "wear a brown coat": ["Ef7"],
  "wear a coat": ["GIo","DoF"],
  "wear a costume": ["EP8"],
  "wear a dress": ["Hl0"],
  "wear a green scarf": ["Ef8"],
  "wear a hat": ["Hl1"],
  "wear a mask": ["GIp","DoG","DoH","EaR"],
  "wear a pink shirt": ["EgA"],
  "wear a raincoat": ["GIq","DoI","EaS"],
  "wear a red jacket": ["EgB"],
  "wear a yellow skirt": ["EgC"],
  "wear a yellow tie": ["EgD"],
  "wear an orange shirt": ["Ef9"],
  "wear black gloves": ["EgE"],
  "wear blue coats": ["EgF"],
  "wear blue pants": ["EgG"],
  "wear brown pants": ["EgH"],
  "wear costumes": ["GIr"],
  "wear down": ["Jln"],
  "wear glasses": ["GIs","DoJ"],
  "wear green shorts": ["EgI"],
  "wear off": ["Jlo"],
  "wear on": ["Jlp"],
  "wear orange hats": ["EgJ"],
  "wear out": ["Hl7"],
  "wear purple socks": ["EgK"],
  "wear red glasses": ["EgL"],
  "wear red shoes": ["EgM"],
  "wear shoes": ["Hl8"],
  "wear trousers": ["Hl9"],
  "wear uniform": ["HmA"],
  "wear wore": ["GIw","DoI","DoJ","DoF","EUb","DoG"],
  "wear worn": ["EWU","EWF"],
  "wear yellow shorts": ["EgN"],
  "wearily": ["KmK"],
  "wearing": ["GIv","DoF","DoI","DoJ","DoG","DoH"],
  "wearing a coat": ["DoF"],
  "wearing a mask": ["DoG","DoH"],
  "wearing a raincoat": ["GIt","DoI"],
  "wearing glasses": ["GIu","DoJ"],
  "weary": ["Jlq"],
  "weather": ["G4p","CzX","FXe","DY3","CzY"],
  "weather forecast": ["HmB"],
  "weather the storm": ["Jls"],
  "weather vane": ["CzZ"],
  "weather warning": ["HmC"],
  "weathering": ["Jlr"],
  "weave": ["Jlt"],
  "web": ["G4r","Cza","Czg"],
  "web designer": ["GIx","Czd"],
  "web developer": ["DQj"],
  "web page": ["HmD"],
  "webbed feet": ["E48"],
  "webcam": ["G4q","Czc","Czb"],
  "website": ["GIy","E49"],
  "wed": ["KmL"],
  "wedding": ["G4s","Czm","FXf","Czh","Czl","Czi","Czj","Czk"],
  "wedge": ["Jlu"],
  "wedge shaped": ["Jlv"],
  "Wednesday": ["G4t","DQn","FXg","DQl","DQm"],
  "wee": ["KmN"],
  "weed": ["GIz","Czn","Czo"],
  "weed out": ["Jlw"],
  "weeds": ["GI0","Czs","Czr","Czp"],
  "week": ["GI1","E5B"],
  "weekday": ["HAp"],
  "weekend": ["E5A"],
  "weekly": ["KmM"],
  "weep": ["GI2","Czt"],
  "weigh": ["GI3","Czu"],
  "weigh in": ["Jlx"],
  "weigh the fruit": ["HmE"],
  "weigh up": ["Jly"],
  "weight": ["G4u","Dvz"],
  "weight lifting": ["GI4","Czv","Czw"],
  "weight scale": ["Czy","Czx"],
  "weightless": ["HmG"],
  "weightlessness": ["HmF"],
  "weightlifting": ["GI5","DQo"],
  "weights": ["GI6","DQp"],
  "weird": ["GI7","E5C"],
  "weird out": ["Jlz"],
  "welcome": ["G4v","DY4"],
  "weld": ["KmO"],
  "welfare": ["HmH"],
  "well": ["G4w","Cz0","ERE","DY6","Czz"],
  "well adjusted": ["Jl0"],
  "well bred": ["Jl1"],
  "well brought up": ["Jl2"],
  "well built": ["DY5"],
  "well done": ["HmI","HAq"],
  "well dressed": ["Jl3"],
  "well heeled": ["Jl4"],
  "well played": ["HmL"],
  "wellies": ["HmJ"],
  "wellington boots": ["HmK"],
  "Welsh": ["HFS","KsH"],
  "Welshman": ["KrP"],
  "went": ["G4x","EVE"],
  "went to school": ["GI8","EVE"],
  "were": ["EVF"],
  "were happy": ["EVF"],
  "werewolf": ["G4y","Cz3","Cz4","Cz2","Cz1"],
  "west": ["HmM"],
  "West Africa": ["KmQ"],
  "West African": ["KmP"],
  "western": ["GJA","Cz6","Cz7"],
  "westerner": ["KrQ"],
  "westward": ["KmR"],
  "wet": ["G4z","DQs","FXh","DQr","DQq","Cz8","EQD","EiJ","C0E"],
  "wet dog": ["EiJ"],
  "wetland": ["GJB","C0C","C0A","C0D","C0B"],
  "wetsuit": ["GJC"],
  "wetter": ["DQt"],
  "whack": ["KmS"],
  "whale": ["G40","DQu","FXi","D7q","C0I","C0L","C0F","C0H","C0K","C0G","C0J"],
  "wharf": ["HmN"],
  "what": ["G41","Ddt","FXj","Dds","Ddr"],
  "what a pity": ["HmO"],
  "what a shame": ["HmP"],
  "what color": ["Ddq"],
  "what color is the bike": ["GJD","EQE","Ddq"],
  "what colour": ["Ddq"],
  "what colour is the bike": ["EQE","Ddq"],
  "what date": ["HmQ"],
  "what day": ["HmR"],
  "what do you like to drink": ["EQF"],
  "what do you like to eat": ["EQG"],
  "what do you mean": ["HmT"],
  "what do you want": ["HmU"],
  "what does that mean": ["HmS"],
  "what for": ["Jl5"],
  "what happened": ["HmV"],
  "what if": ["Jl6"],
  "what is it": ["HmW"],
  "what is the matter": ["HmX"],
  "what is the time": ["GJE","Ddr"],
  "what is the weather like": ["EQH"],
  "what is up": ["HmY"],
  "what is wrong": ["HmZ"],
  "what is your favorite country": ["EQI"],
  "what is your favourite country": ["EQI"],
  "what is your phone number": ["GJF","Dds"],
  "what phone do you have": ["GJG","Ddt"],
  "what sport do you like": ["EQL"],
  "what time": ["GJJ","Ddv"],
  "what time do you go to bed": ["EQM"],
  "what time do you wake up": ["GJI","Ddv"],
  "what's the matter": ["Hma"],
  "what's the matter with": ["Jl8"],
  "what's the weather like": ["Ddu"],
  "what's up": ["Hmb"],
  "what's wrong": ["Hmc"],
  "whatever": ["HAr"],
  "whats the weather like": ["GJH"],
  "whatsoever": ["Jl7"],
  "wheat": ["G42","C0M","FXk","C0O","C0P","C0Q"],
  "wheel": ["G43","C0g","FXl","C0T","C0R","C0U","C0V","C0S"],
  "wheelbarrow": ["GJK","DQv","C0Y","C0a","C0Z"],
  "wheelchair": ["GJL","DQw","C0e","D7s","C0b","C0d"],
  "wheelchair basketball": ["Hmd"],
  "when": ["G44","Ddw","FXm"],
  "when do we start": ["Hme"],
  "when do you brush your teeth": ["EQN"],
  "when do you go to bed": ["GJM"],
  "when do you study": ["EQO"],
  "when do you take a shower": ["EQP"],
  "when do you wake up": ["EQQ"],
  "when I was young": ["Hmg"],
  "when is Christmas": ["EQR"],
  "when is it": ["Hmf"],
  "when is lunch": ["EQS"],
  "when is the meeting": ["EQT"],
  "when is your exam": ["EQU"],
  "when it comes to": ["Jl9"],
  "when you arrive": ["Hmh"],
  "whenever": ["KmT"],
  "where": ["G45","Ddx","FXn","Ddz","Ddy","Dd3"],
  "where are you": ["Hmi"],
  "where are you from": ["GJO","GJN","Ddx","EQV"],
  "where are you going": ["GJP","Ddy"],
  "where do you live": ["GJQ","EQY","Ddz"],
  "where does she come from": ["EQX"],
  "where from": ["Hmj"],
  "where is he from": ["EQZ"],
  "where is it": ["Hmk"],
  "where is Italy": ["EQa"],
  "where is she from": ["Dd0"],
  "where is the bus stop": ["GJR","Dd1"],
  "where is the hospital": ["EQc"],
  "where is the remote": ["GJS","Dd2"],
  "where is the WC": ["Dd3"],
  "where now": ["Hml"],
  "where to go": ["Hmm"],
  "whereabouts": ["JmA"],
  "whereas": ["JmB"],
  "whereby": ["JmC"],
  "wherein": ["KmU"],
  "wherever": ["KmV"],
  "whether": ["JmD"],
  "which": ["GJT","Dd4"],
  "which donut would you like": ["EQe"],
  "which ice cream would you like": ["EQf"],
  "which team do you like": ["GJU","Dd4"],
  "whichever": ["HAs"],
  "while": ["KmW"],
  "while away": ["JmE"],
  "whilst": ["KmX"],
  "whim": ["JmF"],
  "whine": ["KmY"],
  "whip": ["C0h"],
  "whirl": ["KmZ"],
  "whisk": ["G47","Dv0"],
  "whiskers": ["G46","C0j","C0i"],
  "whisky": ["Kma"],
  "whisper": ["G48","C0l","FXo","DoK","C0k"],
  "whisper a secret": ["Hmn"],
  "whisper whispered": ["ETX","DoK"],
  "whispered": ["ETX"],
  "whispering": ["DoK"],
  "whistle": ["G49","DQx","FXp","D7t","C0m","C0o","C0n"],
  "whit": ["Kmb"],
  "white": ["G5B","DQz","FXr"],
  "white dwarf": ["Hmo"],
  "whiteboard": ["G5A","C0s","FXq","C0p","DQy","C0t","C0q","C0r","D7u"],
  "who": ["G5C","Dd6","FXs","Dd5"],
  "who are you": ["Hmp"],
  "who do you love": ["Dd5"],
  "who is it": ["Hmq"],
  "who is playing the violin": ["EQi"],
  "who is she": ["GJV","Dd6"],
  "who is that": ["Hmr"],
  "who is the manager": ["EQj"],
  "who is the oldest": ["EQk"],
  "who is the president": ["EQl"],
  "who is your favorite singer": ["EQm"],
  "who is your favourite singer": ["EQm"],
  "who is your friend": ["EQn"],
  "who knows": ["Hms"],
  "who wants": ["Hmt"],
  "whoever": ["HAt"],
  "whole": ["JmG"],
  "wholesale": ["Kmc"],
  "wholesaler": ["Kmd"],
  "wholesome": ["JmH"],
  "wholly": ["Kme"],
  "whom": ["E5E"],
  "whoop": ["Kmf"],
  "whore": ["Kmg"],
  "whose": ["E5F"],
  "why": ["GJW","E5G"],
  "why are you sad": ["Hmu"],
  "why is it": ["Hmv"],
  "why not": ["Hmw"],
  "wi fi": ["HAu"],
  "wick": ["JmJ"],
  "wicked": ["JmI"],
  "wicket": ["Kmh"],
  "wide": ["G5D","Dv1","FXt"],
  "wide awake": ["Hmx"],
  "widely": ["Kmi"],
  "widen": ["Kmj"],
  "wider": ["GJX","DQ0"],
  "widespread": ["JmK"],
  "widow": ["JmL"],
  "width": ["Kmk"],
  "wield": ["JmM"],
  "wife": ["G5E","DZj","C0x","C0w","C0u","C0v","EQo","EQp"],
  "wifi": ["G5F","C01","C0y","C00","C0z"],
  "wig": ["G5G","C03","FXu","C02"],
  "wiggle out": ["JmN"],
  "wild": ["G5J","C1C","C04","C05"],
  "wild animals": ["G5H","C09","C07","C08","C06"],
  "wilderness": ["JmO"],
  "wildfire": ["GJY"],
  "wildlife": ["G5I","C1B","FXv","C1A"],
  "wildly": ["Kml"],
  "will": ["Kmp"],
  "will be fine": ["Hmy"],
  "will go": ["Hmz"],
  "will help": ["Hm0"],
  "will you come": ["Hm1"],
  "willful": ["JmP"],
  "William the Conqueror": ["Kmm"],
  "willingly": ["Kmn"],
  "willingness": ["Kmo"],
  "willow": ["JmQ"],
  "Wimbledon": ["Hm2"],
  "win": ["G5U","DoM","FX3","DoL","C1D","C2F","C1E"],
  "win a prize": ["GJZ"],
  "win the cup": ["DoM"],
  "win win situation": ["JmV"],
  "win win won": ["DoM"],
  "win won": ["GJg","EWT","EUa","DoL"],
  "wince": ["Kmq"],
  "wind": ["G5L","DQ5","FXx","C1G","C1e","D7y","C1F"],
  "wind chill": ["Hm3"],
  "wind down": ["JmR"],
  "wind energy": ["Hm4"],
  "wind farm": ["GJa","DY7","C1H","C1I"],
  "wind turbine": ["Hm6"],
  "wind up": ["JmT"],
  "wind vane": ["DY8"],
  "winding": ["JmS"],
  "windmill": ["GJb","DQ1","C1J","C1L","C1M"],
  "window": ["G5K","DQ4","FXw","C1W","D7x","C1N","C1P","C1Q","C1O"],
  "window blind": ["C1R"],
  "window blinds": ["C1U","C1V"],
  "window cleaner": ["GJc","DQ3","EQr","EQq","DQ2"],
  "windows": ["GJd","C1X","C1d"],
  "windstorm": ["Hm5"],
  "windsurf": ["G5N","C1g","C1k","C1f"],
  "windsurfing": ["G5M","C1h","C1j","C1i"],
  "windy": ["G5O","DQ7","FXy","EQs","C1o","C1l","C1p","C1n","C1m","DQ6"],
  "wine": ["G5P","C1q","FXz","C1s","D70","C1v","C1u","C1r","C1t"],
  "wine glass": ["DQ8"],
  "wing": ["G5Q","C10","FX0","C1x","C1z","C1w","C1y"],
  "wings": ["G5R","DQ9","FX1","D71","C16","C11","C13","C14","C15"],
  "wink": ["G5S","C17","DY9","C2A","C2B","C19"],
  "winner": ["G5T","DZA","FX2","C2D"],
  "winnie the pooh": ["C2E"],
  "winning": ["GJe","DoL","DoM"],
  "winning the cup": ["DoM"],
  "winter": ["G5V","GJf","Dv2","FX4","C2J","C2H","C2G","C2I"],
  "Winter Olympics": ["Hm7"],
  "wintry": ["JmU"],
  "wipe": ["G5W","DoN","Ec6"],
  "wipe off": ["JmW"],
  "wipe out": ["JmX"],
  "wipe the table": ["GJh","DoN","Ec6"],
  "wipe wiped": ["EUX"],
  "wipe wipes": ["DoN"],
  "wiped": ["EUX"],
  "wiped the table": ["EUX"],
  "wiping": ["Ec6","DoN"],
  "wiping the table": ["DoN","Ec6"],
  "wire": ["G5X","C2K","C2M","C2L"],
  "wire stripper": ["C2N"],
  "wireless": ["Kmr"],
  "wisdom": ["Kms"],
  "wise": ["G5Y","Dv3"],
  "wise up": ["JmY"],
  "wisely": ["Kmt"],
  "wish": ["E5H"],
  "wispy": ["JmZ"],
  "wit": ["Jme"],
  "witch": ["G5Z","C2R","FX5","C2Q","C2P","EQu","C2O"],
  "witches": ["EQt"],
  "with": ["G5a","Dv4"],
  "with a pen": ["Hm8"],
  "with care": ["Hm9"],
  "with friends": ["HnA"],
  "with love": ["HnB"],
  "with my family": ["HnC"],
  "withdraw": ["GJi","DoO","Ec7"],
  "withdraw money": ["DoO","Ec7"],
  "withdraw withdrew": ["EUY","DoO"],
  "withdrawal": ["Kmu"],
  "withdrawing": ["Ec7","DoO"],
  "withdrawing money": ["DoO","Ec7"],
  "withdrew": ["EUY"],
  "withdrew money": ["EUY"],
  "wither": ["DZB"],
  "withhold": ["Jma"],
  "within": ["Jmb"],
  "without": ["Kmv"],
  "without question": ["Jmc"],
  "withstand": ["Jmd"],
  "witness": ["E5I"],
  "witty": ["Kmw"],
  "wizard": ["G5b","DZC","C2W","EQv","C2T","C2V","EQw","C2U"],
  "wobble": ["Kmx"],
  "woe": ["Kmy"],
  "woke up": ["GJj","EUZ"],
  "wolf": ["G5c","DRA","FX6","C2b","C2Y","C2Z","C2X","EQx","D72","C2a"],
  "wolly jumper": ["DZD"],
  "wolves": ["GJk","C2f","C2e","C2d"],
  "woman": ["G5d","C2m","FX7","C2h","C2g","C2k","C2i","C2l","C2j"],
  "womb": ["Kmz"],
  "women": ["G5e","C2q","FX8","C2o","C2p","C2n"],
  "won": ["GJl","EWT","EUa"],
  "won a prize": ["EUa"],
  "won the cup": ["EWT"],
  "won't eat": ["HnE"],
  "won't fit": ["HnF"],
  "won't share": ["HnG"],
  "won't stop": ["HnH"],
  "won't work": ["HnI"],
  "wonder": ["Jmf"],
  "wonderful": ["G5f","Dv5"],
  "wonderfully": ["Km0"],
  "Wonders of the World": ["HnD"],
  "wont": ["Km1"],
  "woo": ["Km4"],
  "wood": ["G5h","C2s","FX9","C2t","C21","C2u","C2r"],
  "wood screw": ["GJm","C22","C23","C24"],
  "wooded": ["Jmg"],
  "wooden": ["G5g","C2v","C2y","C2w"],
  "wooden paddle": ["C2x"],
  "woodland": ["Km2"],
  "woodlouse": ["C20"],
  "woods": ["G5i","Dv6"],
  "wool": ["G5j","C27","FYA","C26","C25"],
  "woolen": ["Km3"],
  "word": ["Km5"],
  "word up": ["Jmh"],
  "words": ["G5k","C28"],
  "wordsheet": ["DZE"],
  "wore": ["GJn","EUb"],
  "wore a coat": ["EUb"],
  "work": ["HnQ","G5m","DoQ","DoT","DoP","EaV","C3A","EaU","C3B","EQ2","C3C","EQy","EaT","DoR","C29"],
  "work ": ["EQz"],
  "work alone": ["HnJ"],
  "work around": ["Jmi"],
  "work at home": ["HnK"],
  "work for": ["Jmj"],
  "work happily": ["ERW"],
  "work hard": ["GJq","ERX"],
  "work in a clothes store": ["EaT","DoR"],
  "work in a shop": ["HnM"],
  "work in a team": ["HnN"],
  "work in an office": ["EaU"],
  "work off": ["Jmk"],
  "work on": ["HnP"],
  "work on a computer": ["EaV"],
  "work out": ["G5l","DoS","EQ1"],
  "work out worked out": ["DoS"],
  "work quietly": ["ERY"],
  "work together": ["HnS"],
  "work up": ["Jmm"],
  "work worked": ["GJt","DoT","DoP","DoQ","DoR"],
  "workbook": ["HnL"],
  "worked": ["GJo"],
  "worker": ["GJp","E5J"],
  "workforce": ["Km6"],
  "working": ["GJs","DoT","DoP","DoQ","DoR"],
  "working class": ["HnO"],
  "working in a clothes store": ["DoR"],
  "working out": ["GJr","DoS"],
  "workload": ["Km7"],
  "workman": ["Km8"],
  "workout": ["Jml"],
  "workplace": ["Km9"],
  "workshop": ["HnR"],
  "workstation": ["KnA"],
  "world": ["G5n","C3D","FYB","DZF"],
  "World Cup": ["HnT"],
  "world famous": ["Jmn"],
  "world heritage site": ["E5K"],
  "World Series": ["HnU"],
  "World War": ["HnV"],
  "worldwide": ["E5L"],
  "worm": ["G5o","C3E","FYC","C3G","C3F"],
  "wormhole": ["HnW"],
  "worn": ["EWU","EWF"],
  "worn a costume": ["EWU"],
  "worn glasses": ["EWF"],
  "worn out": ["Ehr"],
  "worried": ["G5p","C3J","FYD","C3I","C3H"],
  "worry": ["G5q","C3L","C3K"],
  "worry about": ["Jmo"],
  "worse": ["GJu","DRB","ERZ"],
  "worsen": ["Jmp"],
  "worship": ["Jmq"],
  "worth": ["HAv"],
  "worthless": ["KnB"],
  "worthwhile": ["Jmr"],
  "worthwhile to": ["Jms"],
  "worthy": ["HAw"],
  "would": ["KnC"],
  "would like": ["HnX"],
  "would like to": ["Jmt"],
  "would rather": ["Jmu"],
  "would you like some fruit": ["EQ3"],
  "would you mind": ["HnY"],
  "wound": ["Jmv"],
  "wow": ["KnD"],
  "wrap": ["G5s","DRC"],
  "wrap up": ["Jmw"],
  "wrappers": ["DZG"],
  "wrath": ["KnE"],
  "wreath": ["G5t","DZH","FYF","EiK","C3N","EQ4","C3M","C3P"],
  "wreck": ["Jmx"],
  "wreckage": ["KnF"],
  "wrench": ["G5u","C3T","C3Q"],
  "wrench set": ["C3V"],
  "wrestle": ["Jmy"],
  "wrestling": ["G5v","C3Y","DRD","C3W","D73"],
  "wretch": ["Jmz"],
  "wriggle": ["KnG"],
  "wring": ["KnH"],
  "wrinkle": ["Jm0"],
  "wrist": ["G5w","DRE","D74"],
  "writ": ["KnI"],
  "write": ["G5y","DoW","FYG","DoU","Ec8","DoV","C3Z","C3b","EaY","C3a","DoX","EaX"],
  "write a letter": ["HnZ"],
  "write a story": ["Hna"],
  "write a word": ["Hnb"],
  "write an email": ["G5x","Dv7"],
  "write back": ["Jm1"],
  "write books": ["EQ5"],
  "write computer software": ["EaX"],
  "write different languages": ["EQ6"],
  "write down": ["Hnc"],
  "write neatly": ["Hnd"],
  "write on the board": ["GJw","DoV","EaY"],
  "write software": ["DoX"],
  "write stories": ["GJx"],
  "write wrote": ["G50","EUc","DoU","DoV","DoW"],
  "write your name": ["Hne"],
  "writer": ["G5z","Dv8","FYH"],
  "writing": ["G51","DoU","FYI","DoW","Ec8","C3c","C3e","DoV","C3d","DoX"],
  "writing on the board": ["GJy","DoV"],
  "writing software": ["DoX"],
  "wrong": ["GJz","EQ7"],
  "wrongdoing": ["KnJ"],
  "wrongly": ["KnK"],
  "wrote": ["G52","EUc"],
  "wrought": ["KnL"],
  "wry": ["KnM"],
  "wushu": ["Hnf"],
  "X": ["DaV","G53","GJ0","FYJ","HFV"],
  "x": ["DaW","HFU"],
  "X ray": ["Jm2","G54","DRF","FYK","C3f","C3g","D75"],
  "xi": ["KnN"],
  "xylophone": ["G55","C3i","FYL","C3h"],
  "Y": ["DaZ","FYY","HFX"],
  "y": ["G6M","DaY","HFW"],
  "yacht": ["G56","C3m","FYM","C3k","C3l","C3j"],
  "yak": ["G57","C3r","FYN","C3n","C3p","C3q","C3o"],
  "yam": ["G58","C3s","FYO","C3t"],
  "Yangtze": ["KnO"],
  "Yangtze River": ["KnP"],
  "yank": ["KnQ"],
  "Yank": ["KrU","KrR"],
  "Yankee": ["KrT","KrS"],
  "yard": ["G59","C3u","FYP","C3w","C3v"],
  "yarn": ["G6A","C3z","FYQ","C3y","C3x"],
  "yawn": ["G6B","DoZ","FYR","Ebv","C30","C33","C31","DoY","C32"],
  "yawn yawned": ["GJ2","EUd","DoY","DoZ"],
  "yawned": ["EUd"],
  "yawning": ["GJ1","DoZ","DoY","Ebv"],
  "yeah": ["KnR"],
  "year": ["GJ3","E5M"],
  "yearly": ["KnS"],
  "yearn": ["KnT"],
  "yeast": ["Jm3"],
  "yell": ["G6D","C34"],
  "yellow": ["G6C","GJ4","DRG"],
  "yellow emperor": ["Hng"],
  "yellow shorts": ["GJ5","DRH","EgN"],
  "yellow skirt": ["DRI","EgC"],
  "yellow tie": ["DRJ","EgD"],
  "Yellowstone": ["Hnh"],
  "yelp": ["Jm4"],
  "yen": ["KnU"],
  "yep": ["KnV"],
  "yes": ["G6E","Dv9","FYS"],
  "yes please": ["Hni"],
  "yesterday": ["E5N"],
  "yet": ["Jm5"],
  "yield": ["Jm6"],
  "yield to": ["Jm7"],
  "yin and yang": ["C35"],
  "yo yo": ["G6K","E5P","FYX","DwC"],
  "yoga": ["G6F","C4A","FYT","C37","C39","C36","C38"],
  "yoghurt": ["G6G","DwA","FYU"],
  "yogurt": ["G6H","DRK","FYV","C4B"],
  "Yokai": ["Hnj"],
  "yoke": ["Jm8"],
  "yolk": ["Jm9"],
  "yorkshire pudding": ["C4C"],
  "Yosemite": ["Hnk"],
  "you": ["E5O"],
  "you are kind": ["Hnl"],
  "you are late": ["Hnm"],
  "you are my friend": ["Hnn"],
  "you are right": ["Hno"],
  "you are welcome": ["Hnp"],
  "you bet": ["JnA"],
  "you know": ["HAx"],
  "you must listen": ["Hnq"],
  "you should rest": ["Hns"],
  "you too": ["Hnt"],
  "you're": ["HAy"],
  "you're welcome": ["Hnr"],
  "young": ["G6J","C4D","FYW"],
  "younger": ["G6I","DRL"],
  "youngster": ["KnW"],
  "your": ["HAz"],
  "yourself": ["KnX"],
  "youth": ["JnB"],
  "youthful": ["KnY"],
  "youtube": ["GJ6","DwB"],
  "yoyo": ["G6L","DwD"],
  "Z": ["DaX","HFd","HFY"],
  "z": ["G6W","Daa","FYg"],
  "Zambia": ["HFa","HA0"],
  "Zambian": ["HFZ","KrV"],
  "zeal": ["KnZ"],
  "zealous": ["JnC"],
  "zebra": ["G6O","DRM","FYZ","C4J","D76","C4G","C4E","C4F"],
  "zebra crossing": ["G6N","C4H","C4I"],
  "zebras": ["GJ7","C4L","C4K"],
  "zero": ["G6P","Dc9","FYa","Dc8"],
  "zero gravity": ["Hnu"],
  "zero in on": ["JnD"],
  "zest": ["JnE"],
  "Zeus": ["Hnv"],
  "zigzag": ["G6Q","DwE"],
  "Zimbabwe": ["HFc","HA1"],
  "Zimbabwean": ["HFb","KrW"],
  "zinc": ["Hnw"],
  "zip": ["G6S","DRN","FYc","C4N","D77","C4Q"],
  "zip up": ["JnF"],
  "zip up your coat": ["Hnx"],
  "zipper": ["G6R","C4O","FYb","C4P"],
  "zodiac": ["Hny"],
  "zombie": ["G6T","C4R","FYd","C4T","C4S","EQ8"],
  "zone": ["JnG"],
  "zoo": ["G6V","DRP","FYf","D78"],
  "zookeeper": ["G6U","DwF","FYe"],
  "zoology": ["JnH"],
  "zoom": ["JnK"],
  "zoom call": ["GJ8","DRO"],
  "zoom in": ["JnI"],
  "zoom out": ["JnJ"],
  "zucchini": ["G6X","C4U","FYh","C4V","C4Y","C4X","C4W"],
  "Zulu": ["KrX"],
  "Zurich": ["HA2"],
  "zygote": ["Kna"]
}